import * as i0 from '@angular/core';
import { Injectable, Component, ElementRef, Input, NgZone, ViewChild, NgModule, Directive, Host, HostListener, ChangeDetectionStrategy, ViewContainerRef, ComponentFactoryResolver, Pipe, InjectionToken, EventEmitter, Inject, HostBinding, Output, forwardRef, ContentChildren, ChangeDetectorRef, ApplicationRef, Injector, TemplateRef, ViewEncapsulation, ViewChildren, ContentChild, IterableDiffers, EmbeddedViewRef, Optional, RendererFactory2, Renderer2 } from '@angular/core';
import { Subscription, fromEvent, noop, Subject, merge, timer, BehaviorSubject, of, forkJoin, combineLatest, ReplaySubject } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { auditTime, takeUntil, tap, switchMapTo, filter, switchMap, take, startWith, map, debounceTime, finalize, takeWhile } from 'rxjs/operators';
import { coerceBooleanProperty as coerceBooleanProperty$1, coerceElement, coerceCssPixelValue, coerceArray, coerceNumberProperty } from '@angular/cdk/coercion';
import { NG_VALUE_ACCESSOR, FormsModule, NG_VALIDATORS, NgControl, NgForm, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/cdk/observers';
import { ContentObserver, ObserversModule } from '@angular/cdk/observers';
import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import isEqual from 'lodash-es/isEqual';
import sortedUniq from 'lodash-es/sortedUniq';
import { CssVarsModule } from 'ngx-css-variables';
import tinycolor from 'tinycolor2';
import { DataSource as DataSource$1 } from '@angular/cdk/collections';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as i1$1 from '@angular/router';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/observers';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from 'ngx-css-variables';
import * as ɵngcc5 from '@angular/cdk/scrolling';
import * as ɵngcc6 from '@angular/router';
import * as ɵngcc7 from '@angular/cdk/drag-drop';
import * as ɵngcc8 from '@angular/common/http';

function AnchorLinksComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function AnchorLinksComponent_a_6_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const link_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.navigateToAnchor(link_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r1 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("anchorId", link_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(link_r1.label);
} }
const _c0 = ["layer"];
const _c1 = ["*"];
const _c2 = ["pmccRichrowDetail", ""];
const _c3 = ["control"];
function BtnMenuComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-services-menu-inline", 6);
    ɵngcc0.ɵɵlistener("modelChange", function BtnMenuComponent_ng_template_6_Template_pmcc_services_menu_inline_modelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.modelChange.emit($event); })("hide", function BtnMenuComponent_ng_template_6_Template_pmcc_services_menu_inline_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.hide(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("model", ctx_r1.model)("items", ctx_r1.options)("alignRight", ctx_r1.subMenuOnLeft)("controlElement", _r0)("width", ctx_r1.serviceMenuWidth)("height", ctx_r1.serviceMenuHeight);
} }
const _c4 = function (a0) { return { "disabled": a0 }; };
const _c5 = function () { return { elementAnchor: "southeast", layerAnchor: "northeast" }; };
const _c6 = function () { return { elementAnchor: "southwest", layerAnchor: "northwest" }; };
const _c7 = ["ulElement"];
function ServicesMenuInlineComponent_ul_0_li_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 12);
    ɵngcc0.ɵɵelement(2, "div", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", item_r4.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", item_r4.description);
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 14);
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", item_r4.icon);
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, ServicesMenuInlineComponent_ul_0_li_2_div_5_span_1_Template, 1, 1, "span", 16);
    ɵngcc0.ɵɵelement(2, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("title", item_r4.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r4.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", item_r4.label);
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_6_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", item_r4.icon);
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 24);
    ɵngcc0.ɵɵelementEnd();
} }
function ServicesMenuInlineComponent_ul_0_li_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵtemplate(2, ServicesMenuInlineComponent_ul_0_li_2_div_6_span_2_Template, 1, 1, "span", 16);
    ɵngcc0.ɵɵelement(3, "span", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ServicesMenuInlineComponent_ul_0_li_2_div_6_div_4_Template, 2, 0, "div", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("title", item_r4.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("with-icon", item_r4.subMenu == null ? null : item_r4.subMenu.options);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r4.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", item_r4.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r4.subMenu == null ? null : item_r4.subMenu.options);
} }
function ServicesMenuInlineComponent_ul_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 5, 6);
    ɵngcc0.ɵɵlistener("click", function ServicesMenuInlineComponent_ul_0_li_2_Template_li_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const item_r4 = restoredCtx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.select($event, item_r4); })("mouseenter", function ServicesMenuInlineComponent_ul_0_li_2_Template_li_mouseenter_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const item_r4 = restoredCtx.$implicit; const _r6 = ɵngcc0.ɵɵreference(1); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.onMouseenter(item_r4, _r6); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, ServicesMenuInlineComponent_ul_0_li_2_ng_container_3_Template, 3, 2, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(4, ServicesMenuInlineComponent_ul_0_li_2_div_4_Template, 1, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(5, ServicesMenuInlineComponent_ul_0_li_2_div_5_Template, 3, 3, "div", 10);
    ɵngcc0.ɵɵtemplate(6, ServicesMenuInlineComponent_ul_0_li_2_div_6_Template, 5, 6, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r3.getClassNames(item_r4, i_r5));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitch", item_r4.type)("pmccTooltip", item_r4.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "category-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "divider");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "delete");
} }
function ServicesMenuInlineComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 2, 3);
    ɵngcc0.ɵɵlistener("scroll", function ServicesMenuInlineComponent_ul_0_Template_ul_scroll_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.removeSubMenu(); });
    ɵngcc0.ɵɵtemplate(2, ServicesMenuInlineComponent_ul_0_li_2_Template, 7, 6, "li", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0.width, "px")("height", ctx_r0.height, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
const _c8 = function (a0) { return { "top": a0 }; };
function ServicesMenuInlineComponent_pmcc_services_menu_inline_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-services-menu-inline", 25);
    ɵngcc0.ɵɵlistener("modelChange", function ServicesMenuInlineComponent_pmcc_services_menu_inline_1_Template_pmcc_services_menu_inline_modelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.modelChange.emit($event); })("hide", function ServicesMenuInlineComponent_pmcc_services_menu_inline_1_Template_pmcc_services_menu_inline_hide_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.hide.emit($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.alignRight ? "pmcc-sub-menu-right" : "pmcc-sub-menu-left")("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c8, ctx_r1.subMenuTop))("model", ctx_r1.model)("items", ctx_r1.subMenu.options)("width", ctx_r1.subMenu == null ? null : ctx_r1.subMenu.width)("height", ctx_r1.subMenu == null ? null : ctx_r1.subMenu.height)("alignRight", ctx_r1.alignRight)("controlElement", ctx_r1.controlElement);
} }
function BtnSplitComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-services-menu-inline", 5);
    ɵngcc0.ɵɵlistener("modelChange", function BtnSplitComponent_ng_template_5_Template_pmcc_services_menu_inline_modelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.modelChange.emit($event); })("hide", function BtnSplitComponent_ng_template_5_Template_pmcc_services_menu_inline_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.hide(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("model", ctx_r1.model)("items", ctx_r1.options)("alignRight", ctx_r1.subMenuOnLeft)("controlElement", _r0)("width", ctx_r1.serviceMenuWidth)("height", ctx_r1.serviceMenuHeight);
} }
function DropdownComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabIndex", -1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.model == null ? null : ctx_r3.model.label);
} }
const _c9 = function (a1) { return ["icon", a1]; };
function DropdownComponent_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 7);
    ɵngcc0.ɵɵelement(1, "input", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c9, (ctx_r5.model == null ? null : ctx_r5.model.icon) || ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ctx_r5.width, "px");
    ɵngcc0.ɵɵclassProp("with-icon", ctx_r5.model == null ? null : ctx_r5.model.icon);
    ɵngcc0.ɵɵproperty("value", ctx_r5.model == null ? null : ctx_r5.model.label)("tabIndex", -1);
} }
function DropdownComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_ng_container_2_ng_container_1_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, DropdownComponent_ng_container_2_ng_template_2_Template, 2, 9, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.textDropdown)("ngIfElse", _r4);
} }
function DropdownComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-services-menu-inline", 9);
    ɵngcc0.ɵɵlistener("modelChange", function DropdownComponent_ng_template_4_Template_pmcc_services_menu_inline_modelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onChange($event); })("hide", function DropdownComponent_ng_template_4_Template_pmcc_services_menu_inline_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.hide(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("model", ctx_r2.model)("items", ctx_r2.options)("controlElement", ctx_r2.elRef.nativeElement)("width", ctx_r2.serviceMenuWidth)("height", ctx_r2.serviceMenuHeight)("alignRight", ctx_r2.alignRight);
} }
const _c10 = function (a0) { return { "max-width": a0 }; };
function SelectTriggerComponent_pmcc_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r0.icon);
} }
const _c11 = function (a0, a1, a2, a3, a4, a5) { return { disabled: a0, "not-in-calendar": a1, today: a2, selected: a3, highlight: a4, blank: a5 }; };
function CalendarComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵlistener("click", function CalendarComponent_span_25_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const day_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectDay(day_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(4, _c11, !!day_r2.isDisabled, !day_r2.isInMonth, !!day_r2.isToday, !!day_r2.isSelected, !!day_r2.isInRange, !day_r2.date))("pmccTooltip", (day_r2 == null ? null : day_r2.maxDateTooltip) ? day_r2.maxDateTooltip : day_r2.minDateTooltip);
    ɵngcc0.ɵɵattribute("data-pm-id", !!day_r2.isSelected ? "selected-date" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (day_r2 == null ? null : day_r2.date == null ? null : day_r2.date.getDate()) || "", " ");
} }
function CalendarComponent_span_48_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵlistener("click", function CalendarComponent_span_48_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const day_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.selectDay(day_r5); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(3, _c11, !!day_r5.isDisabled, !day_r5.isInMonth, !!day_r5.isToday, !!day_r5.isSelected, !!day_r5.isInRange, !day_r5.date))("pmccTooltip", (day_r5 == null ? null : day_r5.maxDateTooltip) ? day_r5.maxDateTooltip : day_r5.minDateTooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (day_r5 == null ? null : day_r5.date == null ? null : day_r5.date.getDate()) || "", " ");
} }
const _c14 = function (a1) { return { "pmcc-character-counter": true, "pmcc-character-count-zero": a1 }; };
function CheckboxComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
const _c15 = function (a0, a1, a2) { return { "pmcc-cb-checked": a0, "pmcc-cb-some": a1, "pmcc-cb-none": a2 }; };
const _c16 = ["content"];
const _c17 = [[["pmcc-collapsible-panel-header"]], [["", 8, "pmcc-toolbar"]], [["pmcc-collapsible-panel-content"]], [["footer"]]];
const _c18 = ["pmcc-collapsible-panel-header", ".pmcc-toolbar", "pmcc-collapsible-panel-content", "footer"];
function CollapsiblePanelHeaderComponent_pmcc_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("expanded", ctx_r0.panel.expanded);
    ɵngcc0.ɵɵproperty("color", ctx_r0.panel.type !== "light" && ctx_r0.panel.type !== "white" ? "white" : undefined);
} }
function CollapsiblePanelHeaderComponent_pmcc_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("expanded", ctx_r1.panel.expanded);
    ɵngcc0.ɵɵproperty("color", ctx_r1.panel.type !== "light" && ctx_r1.panel.type !== "white" ? "white" : undefined);
} }
const _c19 = [[["pmcc-collapsible-panel-title"]], "*"];
const _c20 = ["pmcc-collapsible-panel-title", "*"];
function ColumnSelectorComponent_ng_template_4_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "pmcc-checkbox", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function ColumnSelectorComponent_ng_template_4_li_7_Template_pmcc_checkbox_ngModelChange_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const column_r3 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.setSelected(column_r3, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.isSelected(column_r3))("label", column_r3)("disabled", ctx_r2.isRequired(column_r3))("title", ctx_r2.isRequired(column_r3) ? "This column cannot be removed." : "");
} }
function ColumnSelectorComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "pmcc-checkbox", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function ColumnSelectorComponent_ng_template_4_Template_pmcc_checkbox_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.setAllSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "strong");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul", 9);
    ɵngcc0.ɵɵtemplate(7, ColumnSelectorComponent_ng_template_4_li_7_Template, 2, 4, "li", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "hr");
    ɵngcc0.ɵɵelementStart(9, "div", 11);
    ɵngcc0.ɵɵelementStart(10, "div", 12);
    ɵngcc0.ɵɵelementStart(11, "button", 13);
    ɵngcc0.ɵɵlistener("click", function ColumnSelectorComponent_ng_template_4_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.closeMenu(); });
    ɵngcc0.ɵɵtext(12, " Cancel ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 14);
    ɵngcc0.ɵɵelementStart(14, "button", 15);
    ɵngcc0.ɵɵlistener("click", function ColumnSelectorComponent_ng_template_4_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.applyAndClose(); });
    ɵngcc0.ɵɵtext(15, " Done ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("right-align", ctx_r1.alignRight);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.allColumnSelected);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r1.visibleColumnsCount, " of ", ctx_r1.columns.length, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.columns);
} }
const _c21 = function (a0, a1) { return { elementAnchor: a0, layerAnchor: a1, detectEdges: false }; };
const _c22 = ["searchInput"];
function CurrencyPickerDropdownComponent_ng_template_8_pmcc_currency_dropdown_option_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-currency-dropdown-option", 9);
    ɵngcc0.ɵɵlistener("click", function CurrencyPickerDropdownComponent_ng_template_8_pmcc_currency_dropdown_option_1_Template_pmcc_currency_dropdown_option_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const currency_r3 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onCurrencySelected(currency_r3); });
    ɵngcc0.ɵɵelementStart(1, "span", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 10);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const currency_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("selected", (ctx_r2.selectedCurrency == null ? null : ctx_r2.selectedCurrency.xrateCode) === currency_r3.xrateCode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(currency_r3.sign);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("data-pm-id", currency_r3.xrateCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", currency_r3.xrateCode, " ");
} }
function CurrencyPickerDropdownComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 7);
    ɵngcc0.ɵɵtemplate(1, CurrencyPickerDropdownComponent_ng_template_8_pmcc_currency_dropdown_option_1_Template, 5, 5, "pmcc-currency-dropdown-option", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("min-width", (ctx_r1.elRef.nativeElement == null ? null : ctx_r1.elRef.nativeElement.offsetWidth) + 1, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.visibleCurrencies);
} }
const _c23 = ["valueInput"];
const _c24 = ["pmccHeaderRow", ""];
const _c25 = ["pmccRow", ""];
function PaginationComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r1.datasource.totalRecords, " Record");
} }
function PaginationComponent_div_0_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.datasource.totalRecords, " Records");
} }
function PaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "strong", 6);
    ɵngcc0.ɵɵtemplate(7, PaginationComponent_div_0_ng_template_7_Template, 1, 1, "ng-template", 7);
    ɵngcc0.ɵɵtemplate(8, PaginationComponent_div_0_ng_template_8_Template, 1, 1, "ng-template", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelementStart(10, "span");
    ɵngcc0.ɵɵtext(11, " Show ");
    ɵngcc0.ɵɵelementStart(12, "span");
    ɵngcc0.ɵɵelementStart(13, "pmcc-dropdown", 10);
    ɵngcc0.ɵɵlistener("change", function PaginationComponent_div_0_Template_pmcc_dropdown_change_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onRowsPerPageChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, " per page ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span");
    ɵngcc0.ɵɵtext(16, " Page ");
    ɵngcc0.ɵɵelementStart(17, "span", 11);
    ɵngcc0.ɵɵelementStart(18, "input", 12);
    ɵngcc0.ɵɵlistener("input", function PaginationComponent_div_0_Template_input_input_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onInputChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, " of ");
    ɵngcc0.ɵɵelementStart(20, "span", 11);
    ɵngcc0.ɵɵelement(21, "input", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "button", 14);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.changePageToPrev(); });
    ɵngcc0.ɵɵelement(23, "pmcc-icon", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "button", 16);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_24_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.changePageToNext(); });
    ɵngcc0.ɵɵelement(25, "pmcc-icon", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(26, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.styleClass);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngPlural", ctx_r0.datasource.totalRecords || 0);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("model", ctx_r0.model)("width", 60)("options", ctx_r0.pageSizeOptions);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵpropertyInterpolate("max", ctx_r0.getNoOfPages());
    ɵngcc0.ɵɵproperty("value", ctx_r0.datasource.pageNumber)("disabled", ctx_r0.getNoOfPages() === 1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r0.getNoOfPages());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isPrevBtnDisabled());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isNextBtnDisabled());
} }
const _c26 = [[["", 8, "pmcc-pagination-left"]], [["", 8, "pmcc-pagination-right"]]];
const _c27 = [".pmcc-pagination-left", ".pmcc-pagination-right"];
const _c28 = ["noDataRowTemplate"];
const _c29 = ["defaultNoDataRow"];
function DataTableComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "table", 6);
    ɵngcc0.ɵɵelement(2, "thead");
    ɵngcc0.ɵɵelement(3, "tbody");
    ɵngcc0.ɵɵelement(4, "tfoot");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DataTableComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 7);
    ɵngcc0.ɵɵelementStart(1, "td", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r5 = ctx.message;
    const colspan_r6 = ctx.colspan;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("colSpan", colspan_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r5);
} }
function DataTableComponent_pmcc_pagination_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "pmcc-pagination", 9, 10);
    ɵngcc0.ɵɵpipe(2, "apply");
    ɵngcc0.ɵɵprojection(3, 0, ["ngProjectAs", ".pmcc-pagination-left", 5, ["", 8, "pmcc-pagination-left"]]);
    ɵngcc0.ɵɵprojection(4, 1, ["ngProjectAs", ".pmcc-pagination-right", 5, ["", 8, "pmcc-pagination-right"]]);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(1);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("pageSizeOptions", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r3.pagination == null ? null : ctx_r3.pagination.pageSizeOptions, ctx_r3._mapOptions) || _r7.pageSizeOptions);
} }
const _c30 = ["pmccSortHeader", ""];
function InputComponent_pmcc_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-icon", 1);
    ɵngcc0.ɵɵlistener("click", function InputComponent_pmcc_icon_3_Template_pmcc_icon_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.clearInputValue($event); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c31 = [[["pmcc-addon", 3, "align", "after"]], [["input"], ["textarea"], ["label"]], [["pmcc-addon", "align", "after"]]];
const _c32 = ["pmcc-addon:not([align='after'])", "input, textarea, label", "pmcc-addon[align='after']"];
function PopoverComponent_ng_template_0_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵlistener("click", function PopoverComponent_ng_template_0_span_3_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.triggerClose(); });
    ɵngcc0.ɵɵelementEnd();
} }
function PopoverComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵlistener("mouseenter", function PopoverComponent_ng_template_0_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onMouseEnter(); })("mouseleave", function PopoverComponent_ng_template_0_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onMouseLeave(); });
    ɵngcc0.ɵɵelementStart(1, "p", 1);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, PopoverComponent_ng_template_0_span_3_Template, 1, 0, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("pmcc-close-icon-hidden", ctx_r0.hideCloseIcon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideCloseIcon);
} }
const _c33 = ["input"];
const _c34 = function (a0) { return { "cursor-default": a0 }; };
function DatePickerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-date-picker-field", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("date", ctx_r0.date)("disabled", ctx_r0.disabled);
} }
function DatePickerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-date-picker-field", 5);
    ɵngcc0.ɵɵlistener("focus", function DatePickerComponent_ng_template_1_Template_pmcc_date_picker_field_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onFieldFocus(); })("keydown", function DatePickerComponent_ng_template_1_Template_pmcc_date_picker_field_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onKeyDown($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("pmccPopoverTrigger", _r2)("date", ctx_r1.date)("required", ctx_r1.required)("minDate", ctx_r1.minDate)("maxDate", ctx_r1.maxDate);
} }
const _c35 = function (a0) { return { selected: a0 }; };
function DayofweekComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c35, day_r1.selected));
    ɵngcc0.ɵɵattribute("data-pm-id", day_r1.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", day_r1.label, " ");
} }
function DayparterComponent_tr_24_td_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 16);
    ɵngcc0.ɵɵlistener("mousedown", function DayparterComponent_tr_24_td_6_Template_td_mousedown_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const hour_r5 = restoredCtx.$implicit; const day_r3 = ɵngcc0.ɵɵnextContext().index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clickSelectHour(day_r3, hour_r5); })("mouseenter", function DayparterComponent_tr_24_td_6_Template_td_mouseenter_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const hour_r5 = restoredCtx.$implicit; const day_r3 = ɵngcc0.ɵɵnextContext().index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.extendSelectHour(day_r3, hour_r5); });
    ɵngcc0.ɵɵtext(1, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hour_r5 = ctx.$implicit;
    const day_r3 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("pmcc-dayparter-cell-selected", ctx_r4.isHourSelected(day_r3, hour_r5));
} }
function DayparterComponent_tr_24_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 14);
    ɵngcc0.ɵɵlistener("mousedown", function DayparterComponent_tr_24_Template_td_mousedown_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const day_r3 = restoredCtx.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.clickSelectAllHoursInDay(day_r3); })("mouseenter", function DayparterComponent_tr_24_Template_td_mouseenter_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const day_r3 = restoredCtx.index; const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.extendSelectAllHoursInDay(day_r3); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td", 4);
    ɵngcc0.ɵɵtext(5, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DayparterComponent_tr_24_td_6_Template, 2, 2, "td", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dayLabel_r2 = ctx.$implicit;
    const day_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(dayLabel_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("pmcc-dayparter-cell-selected", ctx_r0.isSelectedThisDayAllHours(day_r3));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.hours);
} }
function DayparterComponent_td_36_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 17);
    ɵngcc0.ɵɵlistener("mousedown", function DayparterComponent_td_36_Template_td_mousedown_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const hour_r15 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.clickSelectHourInAllDays(hour_r15); })("mouseenter", function DayparterComponent_td_36_Template_td_mouseenter_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const hour_r15 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.extendSelectHourInAllDays(hour_r15); });
    ɵngcc0.ɵɵtext(1, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hour_r15 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("pmcc-dayparter-cell-selected", ctx_r1.isSelectedThisHourAllDays(hour_r15));
} }
function DialogComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-dialog-inline", 1);
    ɵngcc0.ɵɵlistener("showDialogChange", function DialogComponent_ng_template_0_Template_pmcc_dialog_inline_showDialogChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.cancelHandler(); });
    ɵngcc0.ɵɵprojection(1, 0, ["ngProjectAs", "div.pmcc-dialog-title", 5, ["div", 8, "pmcc-dialog-title"]]);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("showDialog", ctx_r0.showDialog)("size", ctx_r0.size)("headerClass", ctx_r0.headerClass)("type", ctx_r0.type)("title", ctx_r0.title)("hideCloseIcon", ctx_r0.hideCloseIcon);
} }
const _c36 = [[["div", 8, "pmcc-dialog-title"]], "*"];
const _c37 = ["div.pmcc-dialog-title", "*"];
function DialogInlineComponent_ng_template_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", ctx_r5.title)("textContent", ctx_r5.title);
} }
function DialogInlineComponent_ng_template_0_pmcc_icon_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-icon", 9);
    ɵngcc0.ɵɵlistener("click", function DialogInlineComponent_ng_template_0_pmcc_icon_6_Template_pmcc_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.cancelHandler(); });
    ɵngcc0.ɵɵelementEnd();
} }
function DialogInlineComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", null, 5);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DialogInlineComponent_ng_template_0_div_5_Template, 1, 2, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DialogInlineComponent_ng_template_0_pmcc_icon_6_Template, 1, 0, "pmcc-icon", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(7, 1);
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.headerClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", _r4.children.length === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.hideCloseIcon);
} }
function DialogInlineComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DialogInlineComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, DialogInlineComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.getSize());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function DialogInlineComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DialogInlineComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, DialogInlineComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
const _c38 = ["fileInput"];
const _c39 = ["displayFileNames"];
function FileComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
function FormControlComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("pmcc-position-overlay", ctx_r0.overlayError);
    ɵngcc0.ɵɵproperty("textContent", ctx_r0.errorMessage);
} }
const _c40 = function (a0) { return { flexGrow: a0 }; };
const _c41 = function (a0, a1) { return { "--barColor": a0, "--tooltipBackgroundColor": a1 }; };
const _c42 = function (a0) { return { dark: a0 }; };
function MiniReportGaugeComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelement(4, "pmcc-tooltip", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "tooltip-" + item_r1.tooltipPosition)("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c40, item_r1.fillPercentage))("css-vars", ɵngcc0.ɵɵpureFunction2(8, _c41, item_r1.color, ctx_r0.lightenColor(item_r1.color)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", item_r1.tooltipPosition === "bottom" ? "southcentral" : "northcentral");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c42, ctx_r0.isDarkColor(ctx_r0.lightenColor(item_r1.color))))("content", item_r1.tooltipLabel);
} }
function GlobalHeaderComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵlistener("mouseover", function GlobalHeaderComponent_span_6_Template_span_mouseover_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.showSecondaryMenu(item_r5); })("click", function GlobalHeaderComponent_span_6_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.showSecondaryMenu(item_r5); });
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("selected", item_r5.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("data-pm-id", item_r5.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r5.label);
} }
function GlobalHeaderComponent_div_7_span_1_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵtext(1, " Learn more ");
    ɵngcc0.ɵɵelement(2, "pmcc-icon", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r12.currentNav.description.learnMoreUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function GlobalHeaderComponent_div_7_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, GlobalHeaderComponent_div_7_span_1_a_5_Template, 3, 1, "a", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.currentNav.description.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.currentNav.description.summary);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.currentNav.description.learnMoreUrl);
} }
function GlobalHeaderComponent_div_7_span_2_span_1_ul_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelementStart(2, "a", 23);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("data-pm-id", item_r16.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", item_r16.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", item_r16.openInNewTab ? "_blank" : "_self")("rel", item_r16.openInNewTab ? "opener" : "noopener");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r16.label);
} }
function GlobalHeaderComponent_div_7_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, GlobalHeaderComponent_div_7_span_2_span_1_ul_3_Template, 4, 5, "ul", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(group_r14.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r14.items);
} }
function GlobalHeaderComponent_div_7_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtemplate(1, GlobalHeaderComponent_div_7_span_2_span_1_Template, 4, 2, "span", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.currentNav.groups);
} }
function GlobalHeaderComponent_div_7_pmcc_ad_tag_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-ad-tag", 24);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("adSlot", ctx_r11.currentNav.adSlot);
} }
function GlobalHeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, GlobalHeaderComponent_div_7_span_1_Template, 6, 3, "span", 14);
    ɵngcc0.ɵɵtemplate(2, GlobalHeaderComponent_div_7_span_2_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵtemplate(3, GlobalHeaderComponent_div_7_pmcc_ad_tag_3_Template, 1, 1, "pmcc-ad-tag", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("show", ctx_r1.displaySecondaryNavMenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.currentNav && ctx_r1.currentNav.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.currentNav);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.currentNav.adSlot);
} }
function GlobalHeaderComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵelementStart(1, "a", 19);
    ɵngcc0.ɵɵtext(2, "Help");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r2.help.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("data-pm-id", ctx_r2.help.label);
} }
function GlobalHeaderComponent_div_10_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 29);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r17.alertsCount);
} }
function GlobalHeaderComponent_div_10_li_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, "You have no recent alerts");
    ɵngcc0.ɵɵelementEnd();
} }
function GlobalHeaderComponent_div_10_li_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 38);
} }
function GlobalHeaderComponent_div_10_li_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 39);
    ɵngcc0.ɵɵelementStart(1, "a", 40);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r20.alertsModel.viewAllUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("data-pm-id", "alerts-" + item_r23.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r23.label);
} }
function GlobalHeaderComponent_div_10_li_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 38);
} }
function GlobalHeaderComponent_div_10_li_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 41);
    ɵngcc0.ɵɵtext(2, " Create An Alert ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r22.alertsModel.createUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function GlobalHeaderComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 27);
    ɵngcc0.ɵɵlistener("click", function GlobalHeaderComponent_div_10_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.showAlertsMenu(); })("mouseover", function GlobalHeaderComponent_div_10_Template_div_mouseover_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.showAlertsMenu(); });
    ɵngcc0.ɵɵelement(2, "pmcc-icon", 28);
    ɵngcc0.ɵɵelementStart(3, "span", 29);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 30);
    ɵngcc0.ɵɵelementStart(6, "span", 17);
    ɵngcc0.ɵɵelementStart(7, "h2");
    ɵngcc0.ɵɵtext(8, " Alerts ");
    ɵngcc0.ɵɵtemplate(9, GlobalHeaderComponent_div_10_span_9_Template, 2, 1, "span", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "span", 21);
    ɵngcc0.ɵɵelementStart(11, "ul", 32);
    ɵngcc0.ɵɵelementStart(12, "li", 33);
    ɵngcc0.ɵɵtext(13, "Recent Alerts");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, GlobalHeaderComponent_div_10_li_14_Template, 2, 0, "li", 34);
    ɵngcc0.ɵɵtemplate(15, GlobalHeaderComponent_div_10_li_15_Template, 1, 0, "li", 35);
    ɵngcc0.ɵɵtemplate(16, GlobalHeaderComponent_div_10_li_16_Template, 3, 3, "li", 36);
    ɵngcc0.ɵɵtemplate(17, GlobalHeaderComponent_div_10_li_17_Template, 1, 0, "li", 35);
    ɵngcc0.ɵɵelementStart(18, "li");
    ɵngcc0.ɵɵelementStart(19, "a", 37);
    ɵngcc0.ɵɵtext(20, " View All Alerts ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, GlobalHeaderComponent_div_10_li_21_Template, 3, 1, "li", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("show-badge", ctx_r3.alertsCount > 0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.alertsCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("show", ctx_r3.displayAlertsMenu);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.alertsCount > 0);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.alertsCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.alertsCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.alertsModel.alerts);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.alertsCount > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r3.alertsModel.viewAllUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.alertsModel.createUrl);
} }
function GlobalHeaderComponent_div_11_h2_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 55);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r27.userInfo.username);
} }
function GlobalHeaderComponent_div_11_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 56);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2, "ID:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r28.userInfo.accountId, " ");
} }
function GlobalHeaderComponent_div_11_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 56);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2, "Timezone:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r29.userInfo.timezone, " ");
} }
function GlobalHeaderComponent_div_11_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 56);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2, "Currency:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r30.userInfo.currency, " ");
} }
function GlobalHeaderComponent_div_11_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 56);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const meta_r36 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", meta_r36.label, ":");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", meta_r36.value, " ");
} }
function GlobalHeaderComponent_div_11_pmcc_ad_tag_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-ad-tag", 57);
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("adSlot", ctx_r32.userInfo.adSlot);
} }
function GlobalHeaderComponent_div_11_li_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r33.help.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r33.help.label);
} }
function GlobalHeaderComponent_div_11_li_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 38);
} }
function GlobalHeaderComponent_div_11_ng_container_22_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 58);
    ɵngcc0.ɵɵlistener("click", function GlobalHeaderComponent_div_11_ng_container_22_li_4_Template_a_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r41); const item_r39 = restoredCtx.$implicit; return item_r39.click && item_r39.click($event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r39 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", item_r39.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("data-pm-id", "gh-" + item_r39.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r39.label, " ");
} }
function GlobalHeaderComponent_div_11_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 33);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, GlobalHeaderComponent_div_11_ng_container_22_li_4_Template, 3, 3, "li", 22);
    ɵngcc0.ɵɵelement(5, "li", 38);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r37 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(group_r37.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r37.items);
} }
function GlobalHeaderComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelementStart(1, "span", 43);
    ɵngcc0.ɵɵlistener("click", function GlobalHeaderComponent_div_11_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(); ctx_r42.miniMode = true; return ctx_r42.showUserMenu(); })("mouseover", function GlobalHeaderComponent_div_11_Template_span_mouseover_1_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r44 = ɵngcc0.ɵɵnextContext(); ctx_r44.miniMode = true; return ctx_r44.showUserMenu(); });
    ɵngcc0.ɵɵelement(2, "pmcc-icon", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 45);
    ɵngcc0.ɵɵlistener("mouseover", function GlobalHeaderComponent_div_11_Template_span_mouseover_3_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r45 = ɵngcc0.ɵɵnextContext(); ctx_r45.miniMode = false; return ctx_r45.showUserMenu(); })("click", function GlobalHeaderComponent_div_11_Template_span_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r46 = ɵngcc0.ɵɵnextContext(); ctx_r46.miniMode = false; return ctx_r46.showUserMenu(); });
    ɵngcc0.ɵɵelementStart(4, "div", 46);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 47);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 48);
    ɵngcc0.ɵɵelementStart(9, "span", 49);
    ɵngcc0.ɵɵtemplate(10, GlobalHeaderComponent_div_11_h2_10_Template, 2, 1, "h2", 50);
    ɵngcc0.ɵɵelementStart(11, "p");
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, GlobalHeaderComponent_div_11_div_13_Template, 4, 1, "div", 51);
    ɵngcc0.ɵɵtemplate(14, GlobalHeaderComponent_div_11_div_14_Template, 4, 1, "div", 51);
    ɵngcc0.ɵɵtemplate(15, GlobalHeaderComponent_div_11_div_15_Template, 4, 1, "div", 51);
    ɵngcc0.ɵɵtemplate(16, GlobalHeaderComponent_div_11_div_16_Template, 4, 2, "div", 52);
    ɵngcc0.ɵɵtemplate(17, GlobalHeaderComponent_div_11_pmcc_ad_tag_17_Template, 1, 1, "pmcc-ad-tag", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "span", 21);
    ɵngcc0.ɵɵelementStart(19, "ul");
    ɵngcc0.ɵɵtemplate(20, GlobalHeaderComponent_div_11_li_20_Template, 3, 2, "li", 34);
    ɵngcc0.ɵɵtemplate(21, GlobalHeaderComponent_div_11_li_21_Template, 1, 0, "li", 35);
    ɵngcc0.ɵɵtemplate(22, GlobalHeaderComponent_div_11_ng_container_22_Template, 6, 2, "ng-container", 22);
    ɵngcc0.ɵɵelementStart(23, "li", 54);
    ɵngcc0.ɵɵlistener("click", function GlobalHeaderComponent_div_11_Template_li_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.onLogoutClickHandler(); });
    ɵngcc0.ɵɵtext(24, " Log Out ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.userInfo.username);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.userInfo.company);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("show", ctx_r4.displayUserMenu);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.userInfo.username);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.userInfo.company, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.userInfo.accountId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.userInfo.timezone);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.userInfo.currency);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.userInfo.metaData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.displayUserMenu);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.miniMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.miniMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.userInfoMenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r4.logoutHidden);
} }
function HierarchicalSelectorComponent_div_7_pmcc_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 17);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("pmccTooltip", ctx_r8.checkboxFilterTooltipText);
} }
function HierarchicalSelectorComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "pmcc-checkbox", 15);
    ɵngcc0.ɵɵlistener("change", function HierarchicalSelectorComponent_div_7_Template_pmcc_checkbox_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onCheckboxStateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, HierarchicalSelectorComponent_div_7_pmcc_icon_2_Template, 1, 1, "pmcc-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.checkboxFilterDisabled)("label", ctx_r0.checkboxFilterLabel)("checked", ctx_r0.isCheckboxFilterChecked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.checkboxFilterTooltipText);
} }
function HierarchicalSelectorComponent_pmcc_checkbox_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-checkbox", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HierarchicalSelectorComponent_pmcc_checkbox_9_Template_pmcc_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onAllChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabled || ctx_r1.disableSelectAll)("label", ctx_r1.headerText || "Add / Remove All")("ngModel", ctx_r1.selectBarSelected);
} }
function HierarchicalSelectorComponent_div_11_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 21);
} }
function HierarchicalSelectorComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, HierarchicalSelectorComponent_div_11_i_1_Template, 1, 0, "i", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showLoading);
} }
function HierarchicalSelectorComponent_div_13_pmcc_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-checkbox", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function HierarchicalSelectorComponent_div_13_pmcc_checkbox_1_Template_pmcc_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const item_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onItemChanged($event, item_r14); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", item_r14.disabled)("ngModel", item_r14.selected || ctx_r15.falseValue);
} }
function HierarchicalSelectorComponent_div_13_span_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 32);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r14.countLabel);
} }
function HierarchicalSelectorComponent_div_13_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 29);
    ɵngcc0.ɵɵtemplate(1, HierarchicalSelectorComponent_div_13_span_5_span_1_Template, 2, 1, "span", 30);
    ɵngcc0.ɵɵelement(2, "span", 31);
    ɵngcc0.ɵɵelement(3, "span", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r14.countLabel);
} }
const _c43 = function (a0) { return { "focused": a0 }; };
function HierarchicalSelectorComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, HierarchicalSelectorComponent_div_13_pmcc_checkbox_1_Template, 1, 2, "pmcc-checkbox", 23);
    ɵngcc0.ɵɵelementStart(2, "span", 24);
    ɵngcc0.ɵɵlistener("click", function HierarchicalSelectorComponent_div_13_Template_span_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const item_r14 = restoredCtx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onItemClick(item_r14); });
    ɵngcc0.ɵɵelementStart(3, "span", 25);
    ɵngcc0.ɵɵelement(4, "span", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, HierarchicalSelectorComponent_div_13_span_5_Template, 4, 1, "span", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c43, ctx_r3.focusedItem && item_r14.label === ctx_r3.focusedItem.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.hideBodyCheckbox);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("title", item_r14.label)("textContent", item_r14.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r14.hasChildren);
} }
function HierarchicalSelectorComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelement(1, "span", 34);
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchicalSelectorComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵelement(1, "span", 36);
    ɵngcc0.ɵɵelement(2, "div", 37);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("textContent", ctx_r5.noMatchMessage);
} }
function HierarchicalSelectorComponent_div_16_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span", 40);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, " added");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r26.addedCount);
} }
function HierarchicalSelectorComponent_div_16_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, " / ");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchicalSelectorComponent_div_16_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, HierarchicalSelectorComponent_div_16_span_3_span_1_Template, 2, 0, "span", 39);
    ɵngcc0.ɵɵelementStart(2, "span", 41);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, " removed");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.addedCount > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r27.removedCount);
} }
function HierarchicalSelectorComponent_div_16_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "0 items changed");
    ɵngcc0.ɵɵelementEnd();
} }
function HierarchicalSelectorComponent_div_16_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r29.blockedCount, " blocked");
} }
function HierarchicalSelectorComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 38);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, HierarchicalSelectorComponent_div_16_span_2_Template, 4, 1, "span", 39);
    ɵngcc0.ɵɵtemplate(3, HierarchicalSelectorComponent_div_16_span_3_Template, 5, 2, "span", 39);
    ɵngcc0.ɵɵtemplate(4, HierarchicalSelectorComponent_div_16_span_4_Template, 2, 0, "span", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, HierarchicalSelectorComponent_div_16_div_5_Template, 2, 1, "div", 39);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.addedCount > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.removedCount > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.addedCount === 0 && ctx_r6.removedCount === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.blockedCount !== null);
} }
function HierarchicalSelectorComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelementStart(1, "button", 43);
    ɵngcc0.ɵɵlistener("click", function HierarchicalSelectorComponent_div_17_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.cancel(); });
    ɵngcc0.ɵɵtext(2, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 44);
    ɵngcc0.ɵɵlistener("click", function HierarchicalSelectorComponent_div_17_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.save(); });
    ɵngcc0.ɵɵtext(4, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r7.addedCount === 0 && ctx_r7.removedCount == 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r7.addedCount === 0 && ctx_r7.removedCount === 0);
} }
const _c44 = function (a0, a1) { return { "no-footer": a0, "disabled": a1 }; };
function MessageBoxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 2);
    ɵngcc0.ɵɵlistener("click", function MessageBoxComponent_div_0_Template_span_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.closeMessage(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.messageClass);
} }
function MessageBoxTogglerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "button", 2);
    ɵngcc0.ɵɵlistener("click", function MessageBoxTogglerComponent_div_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.handleCollapserClick(); });
    ɵngcc0.ɵɵelement(2, "pmcc-icon", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 2);
    ɵngcc0.ɵɵlistener("click", function MessageBoxTogglerComponent_div_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.handleExpanderClick(); });
    ɵngcc0.ɵɵelement(4, "pmcc-icon", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.state === 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.state === 3 || ctx_r0.numberOfItems != null && ctx_r0.numberOfItems < 4 && ctx_r0.state === 2);
} }
const _c45 = ["list"];
function AvailableSectionListComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.noMatchesMessage, " ");
} }
function AvailableSectionListComponent_li_3_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function AvailableSectionListComponent_li_3_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const availableItem_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.selectItem(availableItem_r4); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const availableItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", availableItem_r4[ctx_r5.labelProp]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", availableItem_r4[ctx_r5.labelProp], " ");
} }
function AvailableSectionListComponent_li_3_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function AvailableSectionListComponent_li_3_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const availableItem_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectItem(availableItem_r4); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const availableItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", availableItem_r4[ctx_r6.labelProp], " ");
} }
function AvailableSectionListComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵtemplate(1, AvailableSectionListComponent_li_3_a_1_Template, 2, 2, "a", 6);
    ɵngcc0.ɵɵtemplate(2, AvailableSectionListComponent_li_3_a_2_Template, 2, 1, "a", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const availableItem_r4 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r2.textWrap)("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c35, ctx_r2.isSelected(availableItem_r4)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "nowrap");
} }
function AvailableSectionListComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.matchesExceedsLimitMessageInterpolated, " ");
} }
const _c46 = function (a0, a1, a2) { return { "pmcc-ms-text-wrap-nowrap": a0, "pmcc-ms-text-wrap-wrap": a1, "pmcc-ms-text-wrap-word-break": a2 }; };
function AvailableSectionTemplateComponent_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 0);
    ɵngcc0.ɵɵelementStart(1, "li", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.noMatchesMessage, " ");
} }
function AvailableSectionTemplateComponent_ul_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 0);
    ɵngcc0.ɵɵelementStart(1, "li", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.matchesExceedsLimitMessageInterpolated, " ");
} }
const _c47 = function (a0, a1, a2) { return { selectItem: a0, isSelected: a1, viewableItems: a2 }; };
const _c48 = function (a0) { return { unremovable: a0 }; };
function SelectedSectionListComponent_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function SelectedSectionListComponent_li_2_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const selectedItem_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectItem(selectedItem_r2, $event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", selectedItem_r2[ctx_r3.labelProp]);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c48, selectedItem_r2.unremovable));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", selectedItem_r2[ctx_r3.labelProp], " ");
} }
function SelectedSectionListComponent_li_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function SelectedSectionListComponent_li_2_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const selectedItem_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectItem(selectedItem_r2, $event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c48, selectedItem_r2.unremovable));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", selectedItem_r2[ctx_r4.labelProp], " ");
} }
function SelectedSectionListComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtemplate(1, SelectedSectionListComponent_li_2_a_1_Template, 2, 5, "a", 4);
    ɵngcc0.ɵɵtemplate(2, SelectedSectionListComponent_li_2_a_2_Template, 2, 4, "a", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r1.textWrap);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "nowrap");
} }
const _c49 = function (a0, a1, a2, a3) { return { "pmcc-ms-selected-search-disabled": a0, "pmcc-ms-text-wrap-nowrap": a1, "pmcc-ms-text-wrap-wrap": a2, "pmcc-ms-text-wrap-word-break": a3 }; };
const _c50 = function (a0, a1) { return { selectItem: a0, viewableItems: a1 }; };
const _c51 = ["search"];
function MultiselectComponent_ng_template_3_pmcc_spinner_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-spinner");
} }
function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_list_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-available-section-list", 21);
    ɵngcc0.ɵɵlistener("itemSelected", function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_list_8_Template_pmcc_multiselect_available_section_list_itemSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.selectItem($event); })("pmccScrollEnd", function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_list_8_Template_pmcc_multiselect_available_section_list_pmccScrollEnd_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.loadAvailableItems(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("textWrap", ctx_r5.textWrap)("viewableAvailableItems", ctx_r5.viewableAvailableItems)("availableItemsSearchEmpty", false)("noMatchesMessage", ctx_r5.noMatchesMessage)("isSelected", ctx_r5.isSelected)("labelProp", ctx_r5.labelProp)("matchesExceedsLimitMessageInterpolated", ctx_r5.matchesExceedsLimitMessageInterpolated)("showNoMatches", ctx_r5.showNoMatches)("showMatchesExceedsLimit", ctx_r5.showMatchesExceedsLimit);
} }
function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-available-section-template", 22);
    ɵngcc0.ɵɵlistener("itemSelected", function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_template_9_Template_pmcc_multiselect_available_section_template_itemSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.selectItem($event); })("pmccScrollEnd", function MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_template_9_Template_pmcc_multiselect_available_section_template_pmccScrollEnd_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.loadAvailableItems(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("viewableItems", ctx_r6.viewableAvailableItems)("template", ctx_r6.availableItemsTemplate)("selectedItemsSoftStore", ctx_r6.selectedItemsSoftStore)("isSelected", ctx_r6.isSelected)("showNoMatches", ctx_r6.showNoMatches)("showMatchesExceedsLimit", ctx_r6.showMatchesExceedsLimit)("noMatchesMessage", ctx_r6.noMatchesMessage)("matchesExceedsLimitMessageInterpolated", ctx_r6.matchesExceedsLimitMessageInterpolated);
} }
function MultiselectComponent_ng_template_3_pmcc_multiselect_search_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-search", 11);
    ɵngcc0.ɵɵlistener("changed", function MultiselectComponent_ng_template_3_pmcc_multiselect_search_12_Template_pmcc_multiselect_search_changed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.searchSelectedItems($event); })("searchCleared", function MultiselectComponent_ng_template_3_pmcc_multiselect_search_12_Template_pmcc_multiselect_search_searchCleared_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.clearSelectedItemsSearch(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("query", ctx_r7.selectedItemsSearchQuery);
} }
function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_list_13_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-selected-section-list", 23);
    ɵngcc0.ɵɵlistener("itemSelected", function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_list_13_Template_pmcc_multiselect_selected_section_list_itemSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.selectItem($event); })("pmccScrollEnd", function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_list_13_Template_pmcc_multiselect_selected_section_list_pmccScrollEnd_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.loadSelectedItems(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("selectedItemsSearchEnabled", ctx_r8.selectedItemsSearchEnabled)("textWrap", ctx_r8.textWrap)("labelProp", ctx_r8.labelProp)("viewableSelectedItems", ctx_r8.viewableSelectedItems);
} }
function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-selected-section-template", 24);
    ɵngcc0.ɵɵlistener("itemSelected", function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_template_14_Template_pmcc_multiselect_selected_section_template_itemSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.selectItem($event); })("pmccScrollEnd", function MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_template_14_Template_pmcc_multiselect_selected_section_template_pmccScrollEnd_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.loadSelectedItems(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("viewableItems", ctx_r9.viewableSelectedItems)("template", ctx_r9.selectedItemsTemplate);
} }
const _c52 = function (a0, a1, a2) { return { sm: a0, md: a1, lg: a2 }; };
const _c53 = function (a0, a1, a2, a3, a4, a5) { return { sm: a0, md: a1, lg: a2, active: a3, "pmcc-ms-align-right": a4, "layer-push": a5 }; };
function MultiselectComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵlistener("keydown", function MultiselectComponent_ng_template_3_Template_div_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(1); return _r0.triggerKeyHandler($event); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, MultiselectComponent_ng_template_3_pmcc_spinner_3_Template, 1, 0, "pmcc-spinner", 8);
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "pmcc-multiselect-available-section-header", 10);
    ɵngcc0.ɵɵlistener("selectedAll", function MultiselectComponent_ng_template_3_Template_pmcc_multiselect_available_section_header_selectedAll_5_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.selectAll(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "pmcc-multiselect-search", 11, 12);
    ɵngcc0.ɵɵlistener("changed", function MultiselectComponent_ng_template_3_Template_pmcc_multiselect_search_changed_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.searchAvailableItems($event); })("searchCleared", function MultiselectComponent_ng_template_3_Template_pmcc_multiselect_search_searchCleared_6_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.clearAvailableItemsSearch(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_list_8_Template, 1, 9, "pmcc-multiselect-available-section-list", 13);
    ɵngcc0.ɵɵtemplate(9, MultiselectComponent_ng_template_3_pmcc_multiselect_available_section_template_9_Template, 1, 8, "pmcc-multiselect-available-section-template", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 15);
    ɵngcc0.ɵɵelementStart(11, "pmcc-multiselect-selected-section-header", 16);
    ɵngcc0.ɵɵlistener("deselectedAll", function MultiselectComponent_ng_template_3_Template_pmcc_multiselect_selected_section_header_deselectedAll_11_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.deselectAll(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, MultiselectComponent_ng_template_3_pmcc_multiselect_search_12_Template, 1, 1, "pmcc-multiselect-search", 17);
    ɵngcc0.ɵɵtemplate(13, MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_list_13_Template, 1, 4, "pmcc-multiselect-selected-section-list", 18);
    ɵngcc0.ɵɵtemplate(14, MultiselectComponent_ng_template_3_pmcc_multiselect_selected_section_template_14_Template, 1, 2, "pmcc-multiselect-selected-section-template", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "pmcc-multiselect-button-bar", 20);
    ɵngcc0.ɵɵlistener("layerClosed", function MultiselectComponent_ng_template_3_Template_pmcc_multiselect_button_bar_layerClosed_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(1); return _r0.closeLayer($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(22, _c52, ctx_r2.size === "sm", ctx_r2.size === "md", ctx_r2.size === "lg"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("display", _r0.isOpen ? "block" : "none");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(26, _c53, ctx_r2.size === "sm", ctx_r2.size === "md", ctx_r2.size === "lg", _r0.isOpen, ctx_r2.alignRight, ctx_r2.layerPositioningPush));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.loading);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("selectedItemsLimit", ctx_r2.selectedItemsLimit)("warnMaxLimit", ctx_r2.warnMaxLimit)("selectionLimitMessage", ctx_r2.selectionLimitMessage)("instructions", ctx_r2.instructions)("isSelectAllDisabled", ctx_r2.isSelectAllDisabled)("isLimitReached", ctx_r2.isLimitReached)("selectAllTooltip", ctx_r2.selectAllTooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("query", ctx_r2.availableItemsSearchQuery);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.availableItemsTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.availableItemsTemplate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("showClearAll", ctx_r2.showClearAll)("instructions", ctx_r2.instructions)("isDeselectAllDisabled", ctx_r2.isDeselectAllDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.selectedItemsSearchEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.selectedItemsTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.selectedItemsTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isDoneDisabled", ctx_r2.isDoneDisabled);
} }
const _c54 = ["el"];
function MultiselectHierarchicalComponent_pmcc_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r1.labels.fieldIcon);
} }
function MultiselectHierarchicalComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 7);
    ɵngcc0.ɵɵlistener("focus", function MultiselectHierarchicalComponent_input_3_Template_input_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onFocus(); })("blur", function MultiselectHierarchicalComponent_input_3_Template_input_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.hide($event); });
    ɵngcc0.ɵɵpipe(1, "apply");
    ɵngcc0.ɵɵpipe(2, "apply");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r2.width, "px");
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabled)("value", ɵngcc0.ɵɵpipeBind3(1, 5, ctx_r2.selectedItems, ctx_r2.label, ctx_r2.labels))("title", ɵngcc0.ɵɵpipeBind3(2, 9, ctx_r2.selectedItems, ctx_r2.label, ctx_r2.labels));
} }
function MultiselectHierarchicalComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-multiselect-hierarchical-list", 8, 9);
    ɵngcc0.ɵɵlistener("selectedItemsChange", function MultiselectHierarchicalComponent_ng_template_5_Template_pmcc_multiselect_hierarchical_list_selectedItemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectedItemsChange($event); })("cancelCallback", function MultiselectHierarchicalComponent_ng_template_5_Template_pmcc_multiselect_hierarchical_list_cancelCallback_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.hide(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("textWrap", ctx_r3.textWrap)("availableItems", ctx_r3.availableItems)("selectedItems", ctx_r3.selectedItems)("alignRight", ctx_r3.alignRight)("triggerWidth", ctx_r3.width)("showItemId", ctx_r3.showItemId)("labels", ctx_r3.labels)("showAvailableItemCount", ctx_r3.showAvailableItemCount)("enableSelectAll", ctx_r3.enableSelectAll)("implicitParentSelection", ctx_r3.implicitParentSelection)("maxLimitOne", ctx_r3.maxLimitOne);
} }
const _c55 = function (a0, a1) { return { "disabled": a0, "with-icon": a1 }; };
function MultiselectHierarchicalListComponent_div_6_pmcc_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-checkbox", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function MultiselectHierarchicalListComponent_div_6_pmcc_checkbox_1_Template_pmcc_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.selectAll($event); });
    ɵngcc0.ɵɵpipe(1, "apply");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ɵngcc0.ɵɵpipeBind4(1, 1, ctx_r3.selectedItems, ctx_r3.isAllSelected, ctx_r3.flatItemList, ctx_r3.requiredData));
} }
function MultiselectHierarchicalListComponent_div_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" Select All (", ctx_r4.flatItemList.length, ") ");
} }
function MultiselectHierarchicalListComponent_div_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r5.selectedItems.length, " ", ctx_r5.selectedItems.length > 1 ? ctx_r5.labels.objectPlural : ctx_r5.labels.objectSingular, " Selected ");
} }
const _c56 = function (a0) { return { "hide-result-bar": a0 }; };
function MultiselectHierarchicalListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, MultiselectHierarchicalListComponent_div_6_pmcc_checkbox_1_Template, 2, 6, "pmcc-checkbox", 14);
    ɵngcc0.ɵɵtemplate(2, MultiselectHierarchicalListComponent_div_6_ng_template_2_Template, 1, 1, "ng-template", 15);
    ɵngcc0.ɵɵtemplate(3, MultiselectHierarchicalListComponent_div_6_ng_template_3_Template, 1, 2, "ng-template", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c56, !ctx_r0.enableSelectAll));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.onlySelected && ctx_r0.enableSelectAll && !ctx_r0.searchText.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.onlySelected && ctx_r0.showAvailableItemCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.onlySelected);
} }
function MultiselectHierarchicalListComponent_ul_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "pmcc-multiselect-hierarchical-item", 20);
    ɵngcc0.ɵɵlistener("toggle", function MultiselectHierarchicalListComponent_ul_7_ng_container_2_Template_pmcc_multiselect_hierarchical_item_toggle_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const group_r9 = restoredCtx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.toggle(group_r9); })("selectedItemsChange", function MultiselectHierarchicalListComponent_ul_7_ng_container_2_Template_pmcc_multiselect_hierarchical_item_selectedItemsChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onSelectedItemsChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("group", group_r9)("maxLimitExceeded", ctx_r8.maxLimitExceeded)("maxLimitOne", ctx_r8.maxLimitOne)("notToBeDisabled", ctx_r8.nonDisabledItemList)("requiredData", ctx_r8.requiredData)("expanded", ctx_r8.isExpanded(group_r9))("level", group_r9 ? ctx_r8.relations[group_r9.id].parents.length : 0)("showItemId", ctx_r8.showItemId)("selectedGroups", ctx_r8.selectedGroups);
} }
function MultiselectHierarchicalListComponent_ul_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 17);
    ɵngcc0.ɵɵelementStart(1, "cdk-virtual-scroll-viewport", 18);
    ɵngcc0.ɵɵtemplate(2, MultiselectHierarchicalListComponent_ul_7_ng_container_2_Template, 2, 9, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("itemSize", 35);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx_r1.ds)("cdkVirtualForTrackBy", ctx_r1.trackByFn)("cdkVirtualForTemplateCacheSize", 0);
} }
function MultiselectHierarchicalListComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "span", 22);
    ɵngcc0.ɵɵelement(2, "div", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("textContent", "0 " + ctx_r2.labels.objectPlural + " Found");
} }
const _c57 = function (a0) { return { "show-search-border": a0 }; };
const _c58 = function (a0, a1, a2, a3, a4, a5) { return [a0, a1, a2, a3, a4, a5]; };
function MultiselectHierarchicalItemComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 5);
    ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalItemComponent_i_4_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.doToggle($event); });
    ɵngcc0.ɵɵpipe(1, "apply");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c4, ɵngcc0.ɵɵpipeBindV(1, 1, ɵngcc0.ɵɵpureFunction6(8, _c58, ctx_r0.requiredData, ctx_r0.isDisabled, ctx_r0.group.id, ctx_r0.maxLimitOne, ctx_r0.maxLimitExceeded, ctx_r0.notToBeDisabled))));
} }
const _c59 = function (a0, a1) { return { "pmcc-ico-caret-right": a0, "pmcc-ico-caret-down": a1 }; };
function MultiselectHierarchicalItemComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 6);
    ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalItemComponent_i_5_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.doToggle($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c59, !ctx_r1.expanded, ctx_r1.expanded));
} }
const _c60 = function (a0, a1) { return { "has-children": a0, "disabled": a1 }; };
function MultiselectInlineComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " Maximum number of items selected! ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MultiselectInlineComponent_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" Select up to ", ctx_r11.maxSelectedItems, " items. ");
} }
function MultiselectInlineComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtemplate(3, MultiselectInlineComponent_div_1_ng_container_3_Template, 2, 0, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(4, MultiselectInlineComponent_div_1_ng_template_4_Template, 1, 1, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r10 = ɵngcc0.ɵɵreference(5);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("blink", ctx_r0.limitReached);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.limitReached)("ngIfElse", _r10);
} }
function MultiselectInlineComponent_table_5_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 17);
    ɵngcc0.ɵɵlistener("click", function MultiselectInlineComponent_table_5_tr_2_Template_tr_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r15); const item_r13 = restoredCtx.$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.selectItem(item_r13); });
    ɵngcc0.ɵɵelementStart(1, "td", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r12.textWrap)("title", item_r13.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13.name, " ");
} }
function MultiselectInlineComponent_table_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 15);
    ɵngcc0.ɵɵelementStart(1, "tbody");
    ɵngcc0.ɵɵtemplate(2, MultiselectInlineComponent_table_5_tr_2_Template, 3, 3, "tr", 16);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r1.ds == null ? null : ctx_r1.ds.filteredAvailableObservable));
} }
function MultiselectInlineComponent_ng_template_6_Template(rf, ctx) { }
function MultiselectInlineComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
} }
function MultiselectInlineComponent_table_14_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 17);
    ɵngcc0.ɵɵlistener("click", function MultiselectInlineComponent_table_14_tr_2_Template_tr_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const item_r17 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.deselectItem(item_r17); });
    ɵngcc0.ɵɵelementStart(1, "td", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵelement(4, "span", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r16.textWrap)("title", item_r17.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r17.name);
} }
function MultiselectInlineComponent_table_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table");
    ɵngcc0.ɵɵelementStart(1, "tbody");
    ɵngcc0.ɵɵtemplate(2, MultiselectInlineComponent_table_14_tr_2_Template, 5, 3, "tr", 16);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r5.ds == null ? null : ctx_r5.ds.filteredSelectedObservable));
} }
function MultiselectInlineComponent_ng_template_15_Template(rf, ctx) { }
function MultiselectInlineComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", ctx_r8.elRef.nativeElement.offsetHeight, "px")("width", ctx_r8.elRef.nativeElement.offsetWidth, "px");
} }
const _c61 = function (a0, a1, a2) { return { availableItems: a0, selectItem: a1, filter: a2 }; };
const _c62 = function (a0, a1, a2) { return { selectedItems: a0, deselectItem: a1, filter: a2 }; };
function MultiselectToolbarComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function MultiselectToolbarComponent_span_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onSelect(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r0.canSelect);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.buttonLabel, " ");
} }
function AvailableSectionHeaderComponent_div_1_pmcc_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 6);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("pmccTooltip", ctx_r3.selectAllTooltip);
} }
function AvailableSectionHeaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵlistener("click", function AvailableSectionHeaderComponent_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.selectAll(); });
    ɵngcc0.ɵɵtext(2, " Select All ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, AvailableSectionHeaderComponent_div_1_pmcc_icon_3_Template, 1, 1, "pmcc-icon", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isSelectAllDisabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectAllTooltip);
} }
const _c63 = function (a0) { return { "pmcc-flash": a0 }; };
function AvailableSectionHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c63, ctx_r1.warnMaxLimit));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.isLimitReached);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Select up to ", ctx_r1.selectedItemsLimit, " items ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.isLimitReached);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.selectionLimitMessage, " ");
} }
function AvailableSectionHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function SearchComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵlistener("click", function SearchComponent_span_5_Template_span_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.clearSearch($event); });
    ɵngcc0.ɵɵelementEnd();
} }
function SelectedSectionHeaderComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function SelectedSectionHeaderComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.deselectAll(); });
    ɵngcc0.ɵɵtext(1, " Clear All ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isDeselectAllDisabled);
} }
function SelectedSectionHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "strong");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r1.instructions, ":");
} }
const _c64 = function (a0, a1) { return { selected: a0, disabled: a1 }; };
function MultistepComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function MultistepComponent_div_4_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const step_r3 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.goToStep(step_r3); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c64, step_r3.selected, !step_r3.enabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r3.label, " ");
} }
function MultistepComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function MultistepComponent_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.goToStep(ctx_r6.prevStep); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", !ctx_r1.prevStep.enabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.prevStep.previousButtonLabel, " ");
} }
function MultistepComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function MultistepComponent_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.goToStep(ctx_r8.nextStep); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.nextStep.enabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.nextStep.nextButtonLabel, " ");
} }
function NotificationComponent_ng_template_0_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 4);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r3.notification.text, ɵngcc0.ɵɵsanitizeHtml);
} }
function NotificationComponent_ng_template_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.notification.subtext, ɵngcc0.ɵɵsanitizeHtml);
} }
function NotificationComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NotificationComponent_ng_template_0_label_0_Template, 1, 1, "label", 3);
    ɵngcc0.ɵɵtemplate(1, NotificationComponent_ng_template_0_span_1_Template, 1, 1, "span", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.subtext);
} }
function NotificationComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.notification.template);
} }
function NotificationComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵlistener("click", function NotificationComponent_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.dismiss(); });
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationListComponent_pmcc_notification_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-notification", 1);
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("notification", item_r1);
} }
function PageTitleComponent_span_3_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r1.helpLink, ɵngcc0.ɵɵsanitizeUrl);
} }
function PageTitleComponent_span_3_pmcc_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 7);
} }
function PageTitleComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtemplate(1, PageTitleComponent_span_3_a_1_Template, 2, 1, "a", 4);
    ɵngcc0.ɵɵtemplate(2, PageTitleComponent_span_3_pmcc_icon_2_Template, 1, 0, "pmcc-icon", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("pmccTooltip", ctx_r0.helpTooltip || "Help");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.helpLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.helpLink);
} }
const _c67 = ".pmcc-panel{font-size:13px;position:relative;display:block}.pmcc-panel .pmcc-group>*{margin-top:5px;margin-bottom:5px}.pmcc-panel .pmcc-toolbar{position:relative;display:block;background-color:#d5d6d7;padding:5px 10px}.pmcc-panel .pmcc-toolbar.pmcc-pagination{background-color:#fefefe!important}.pmcc-panel .pmcc-panel-header,.pmcc-panel .pmcc-sub-header,.pmcc-panel footer,.pmcc-panel header{position:relative;padding-left:10px;padding-right:10px;background:#6b747a;display:block}.pmcc-panel .pmcc-panel-header .pmcc-title,.pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel footer .pmcc-title,.pmcc-panel header .pmcc-title{letter-spacing:.3px;color:#fff;font:normal 16px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif}.pmcc-panel.pmcc-panel-white .pmcc-panel-header,.pmcc-panel.pmcc-panel-white .pmcc-sub-header,.pmcc-panel.pmcc-panel-white footer,.pmcc-panel.pmcc-panel-white header{background:#fff}.pmcc-panel.pmcc-panel-white .pmcc-panel-header .pmcc-title,.pmcc-panel.pmcc-panel-white .pmcc-sub-header .pmcc-title,.pmcc-panel.pmcc-panel-white footer .pmcc-title,.pmcc-panel.pmcc-panel-white header .pmcc-title{color:#222121;font-size:18px;font-weight:bolder;font-family:Helvetica,Arial,Calibri,sans-serif}.pmcc-panel .pmcc-sub-header{letter-spacing:.3px;background-color:#eaeaea;color:#222121;font:normal 14px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;padding-top:10px;padding-bottom:10px;border-radius:3px}.pmcc-panel .pmcc-content,.pmcc-panel .pmcc-sub-content{background:#fff;display:block;padding:10px;overflow:auto;font-size:13px;color:#222121}.pmcc-panel .pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel footer{background-color:#f5f5f5;color:#6b747a;font:normal 12px Arial,Helvetica,Calibri,sans-serif}.pmcc-panel .pmcc-content:first-child:last-child,.pmcc-panel .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-content.hidden{height:0}.pmcc-panel+.pmcc-panel,.pmcc-panel+.pmcc-panel-light{margin-top:20px}.pmcc-panel>*{border-left:1px solid #c3c3c3;border-right:1px solid #c3c3c3;border-bottom:1px solid #c3c3c3}.pmcc-panel>:first-child{border-top:1px solid #c3c3c3;border-top-left-radius:3px;border-top-right-radius:3px}.pmcc-panel>:not([style*=\"display:none\"]):last-child{border-bottom:1px solid #c3c3c3;border-bottom-left-radius:3px;border-bottom-right-radius:3px;box-shadow:0 2px 3px #0202021f}.pmcc-panel.pmcc-filter .pmcc-content,.pmcc-panel.pmcc-filter .pmcc-sub-content{background:#f5f5f5;border:none;box-shadow:none;padding:20px 15px;color:#656d6f}.pmcc-panel-light{background:#fff;position:relative;margin-top:0;display:block;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-shadow:#00000003 0 0 1px;border:1px solid #b8b6b7;padding:20px;border-radius:5px}.pmcc-panel-light+.pmcc-panel,.pmcc-panel-light+.pmcc-panel-light{margin-top:20px}.pmcc-panel-light>.pmcc-content,.pmcc-panel .pmcc-panel-light>.pmcc-sub-content{background:#fff;padding:10px 0;overflow:auto}.pmcc-panel-light>.pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-panel-light>.pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel-light .pmcc-content:first-child:last-child,.pmcc-panel-light .pmcc-panel .pmcc-sub-content:first-child:last-child,.pmcc-panel .pmcc-panel-light .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel-light .pmcc-content.hidden,.pmcc-panel-light .pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-panel-light .hidden.pmcc-sub-content{height:0}.pmcc-panel-light .pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel-light footer .pmcc-title,.pmcc-panel-light header .pmcc-title,.pmcc-panel .pmcc-panel-light .pmcc-sub-header .pmcc-title{font:normal 16px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;margin:0;padding:0 0 10px}.pmcc-panel-light>*+*{border-top:1px solid #c7c7c7}.pmcc-horizontal-panel-divider{display:block;text-align:center;overflow:hidden;white-space:nowrap}.pmcc-horizontal-panel-divider>span{position:relative;display:inline-block;margin:6px 0}.pmcc-horizontal-panel-divider>span:after,.pmcc-horizontal-panel-divider>span:before{content:\"\";position:absolute;top:50%;width:9999px;height:1px;background:#d4d4d4}.pmcc-horizontal-panel-divider>span:before{right:100%;margin-right:15px}.pmcc-horizontal-panel-divider>span:after{left:100%;margin-left:15px}";
const _c68 = ["track"];
const _c69 = ["leftHandle"];
const _c70 = ["rightHandle"];
function RangeTicksComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 1);
} }
const _c71 = ["scrollableTableHeader"];
const _c72 = ["scrollableTable"];
const _c73 = [[["thead"]], [["tbody"]], [["tfoot"]]];
const _c74 = ["thead", "tbody", "tfoot"];
function SingleselectComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-singleselect-list", 5);
    ɵngcc0.ɵɵlistener("searchChange", function SingleselectComponent_ng_template_4_Template_pmcc_singleselect_list_searchChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.searchChange($event); })("selectedItemChange", function SingleselectComponent_ng_template_4_Template_pmcc_singleselect_list_selectedItemChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectedItemChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("size", ctx_r0.size)("availableItemsTemplate", ctx_r0.availableItemsTemplate)("textWrap", ctx_r0.textWrap)("selectedItemTemplate", ctx_r0.selectedItemsTemplate)("availableItems", ctx_r0.filteredAvailableItems)("selectedItem", ctx_r0.selectedItem)("searchText", ctx_r0.searchText)("showLoading", ctx_r0.showLoading)("settings", ctx_r0.mergedSettings)("instructions", ctx_r0.instructions)("noMatchesFoundMessage", ctx_r0.noMatchesFoundMessage)("maxNumRecordsExceeded", ctx_r0.maxNumRecordsReturned < ctx_r0.availableItems.length)("matchesExceedsLimitMessage", ctx_r0.matchesExceedsLimitMessage)("alignRight", ctx_r0.align === "right")("triggerWidth", ctx_r0.controlElementWidth);
} }
const _c75 = ["searchInputEl"];
function SingleselectListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 16);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("textContent", ctx_r0.instructions);
} }
function SingleselectListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "button", 18);
    ɵngcc0.ɵɵlistener("click", function SingleselectListComponent_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.exclude(); });
    ɵngcc0.ɵɵtext(2, "Clear");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SingleselectListComponent_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵlistener("click", function SingleselectListComponent_ng_template_10_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.exclude(ctx_r14.selectedItem); });
    ɵngcc0.ɵɵelement(1, "a", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r13.textWrap)("title", ctx_r13.selectedItem.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", ctx_r13.selectedItem.name);
} }
function SingleselectListComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SingleselectListComponent_ng_template_10_div_0_Template, 2, 3, "div", 19);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.selectedItem);
} }
function SingleselectListComponent_ng_template_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 25);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function SingleselectListComponent_ng_template_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵlistener("click", function SingleselectListComponent_ng_template_12_div_2_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const item_r18 = restoredCtx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.include(item_r18); });
    ɵngcc0.ɵɵelement(1, "a", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r17.textWrap)("title", item_r18.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("textContent", item_r18.name);
} }
function SingleselectListComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 22);
    ɵngcc0.ɵɵtemplate(1, SingleselectListComponent_ng_template_12_ng_container_1_Template, 1, 1, "ng-container", 23);
    ɵngcc0.ɵɵtemplate(2, SingleselectListComponent_ng_template_12_div_2_Template, 2, 3, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("itemSize", 31);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showSelectedWithAvailable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx_r6.viewableAvailableItems)("cdkVirtualForTrackBy", ctx_r6.trackByFn);
} }
const _c76 = function (a0, a1, a2, a3, a4) { return { exclude: a0, selectedItem: a1, selectedItems: a2, selectedItemChange: a3, textWrap: a4 }; };
function SingleselectListComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.showDefaultSelectedItems ? _r3 : ctx_r7.selectedItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction5(2, _c76, ctx_r7.exclude, ctx_r7.selectedItem, ctx_r7.selectedItems, ctx_r7.selectedItemChange, ctx_r7.textWrap));
} }
function SingleselectListComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 28);
    ɵngcc0.ɵɵelement(2, "div", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("textContent", ctx_r8.noMatchesFoundMessage);
} }
function SingleselectListComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function SingleselectListComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 31);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("textContent", ctx_r10.matchesExceedsLimitMessage);
} }
const _c77 = function (a0, a1, a2, a3, a4, a5) { return { include: a0, viewableAvailableItems: a1, selectedItem: a2, selectedItems: a3, selectedItemChange: a4, textWrap: a5 }; };
function SortableListComponent_pmcc_sortable_item_1_pmcc_sortable_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-sortable-item", 4);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1);
} }
function SortableListComponent_pmcc_sortable_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "pmcc-sortable-item", 2);
    ɵngcc0.ɵɵtemplate(1, SortableListComponent_pmcc_sortable_item_1_pmcc_sortable_item_1_Template, 1, 1, "pmcc-sortable-item", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1);
} }
function SwitchComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.leftLabel, " ");
} }
function SwitchComponent_div_3_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.labelFalse);
} }
function SwitchComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, SwitchComponent_div_3_label_2_Template, 2, 1, "label", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.labelFalse);
} }
function SwitchComponent_div_4_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.labelTrue);
} }
function SwitchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, SwitchComponent_div_4_label_1_Template, 2, 1, "label", 9);
    ɵngcc0.ɵɵelement(2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.labelTrue);
} }
function SwitchComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.rightLabel, " ");
} }
const _c78 = function (a0, a1) { return { disabled: a0, "pmcc-new-switch": a1 }; };
function TabComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", ctx_r0.maxHeight == null ? "auto" : ctx_r0.maxHeight);
} }
function TableActionsComponent_pmcc_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-checkbox", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function TableActionsComponent_pmcc_checkbox_1_Template_pmcc_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onCheckboxClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.checkboxValue || 0)("disabled", ctx_r0.disableCheckbox || ctx_r0.disabled);
} }
function TableActionsComponent_pmcc_icon_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-icon", 6);
    ɵngcc0.ɵɵlistener("click", function TableActionsComponent_pmcc_icon_4_Template_pmcc_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onMenuClick(); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c79 = function (a0, a1) { return { "disabled": a0, "pmcc-trend-negative": a1 }; };
function TableActionsComponent_ng_template_5_ul_1_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 14);
    ɵngcc0.ɵɵlistener("click", function TableActionsComponent_ng_template_5_ul_1_li_4_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const selector_r11 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.onMenuItemClick(selector_r11); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selector_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c79, ctx_r10.isActionDisabled(selector_r11), selector_r11.isNegative))("pmccTooltip", selector_r11.tooltip)("innerHTML", selector_r11.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function TableActionsComponent_ng_template_5_ul_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 9);
    ɵngcc0.ɵɵelementStart(1, "li", 10);
    ɵngcc0.ɵɵlistener("click", function TableActionsComponent_ng_template_5_ul_1_Template_li_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onMenuItemClick($event); });
    ɵngcc0.ɵɵelementStart(2, "span", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TableActionsComponent_ng_template_5_ul_1_li_4_Template, 1, 6, "li", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.selectorsTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.selectors);
} }
function TableActionsComponent_ng_template_5_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 15);
    ɵngcc0.ɵɵlistener("click", function TableActionsComponent_ng_template_5_li_6_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r18); const action_r16 = restoredCtx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onMenuItemClick(action_r16); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r16 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c79, ctx_r9.isActionDisabled(action_r16), action_r16.isNegative))("pmccTooltip", action_r16.tooltip)("innerHTML", action_r16.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function TableActionsComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, TableActionsComponent_ng_template_5_ul_1_Template, 5, 2, "ul", 8);
    ɵngcc0.ɵɵelementStart(2, "ul", 9);
    ɵngcc0.ɵɵelementStart(3, "li", 10);
    ɵngcc0.ɵɵlistener("click", function TableActionsComponent_ng_template_5_Template_li_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onMenuItemClick($event); });
    ɵngcc0.ɵɵelementStart(4, "span", 11);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, TableActionsComponent_ng_template_5_li_6_Template, 1, 6, "li", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r3.selectors && ctx_r3.selectors.length);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.menuTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.actions);
} }
const _c80 = function (a0, a1) { return { "has-both": a0, "pmcc-ta-disabled": a1 }; };
const _c81 = function (a0, a1, a2, a3, a5) { return { isExpanded: a0, rowTemplate: a1, numColumns: a2, item: a3, level: 0, toggle: a5 }; };
function TableTreeComponent_tbody_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵelementContainer(1, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction5(2, _c81, ctx_r0.isExpanded, _r1, ctx_r0.numColumns, item_r3, ctx_r0.onToggle));
} }
const _c82 = function (a0, a1, a2, a3, a4) { return { isExpanded: a0, numColumns: a1, item: a2, level: a3, toggle: a4 }; };
function TableTreeComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 5);
    ɵngcc0.ɵɵelementContainer(1, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "tr", 6);
    ɵngcc0.ɵɵlistener("toggle", function TableTreeComponent_ng_template_5_Template_tr_toggle_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const toggle_r8 = restoredCtx.toggle; return toggle_r8($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.item;
    const isExpanded_r5 = ctx.isExpanded;
    const numColumns_r6 = ctx.numColumns;
    const level_r7 = ctx.level;
    const toggle_r8 = ctx.toggle;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngClass", isExpanded_r5[item_r4.id] && (item_r4 == null ? null : item_r4.items == null ? null : item_r4.items.length) && "expanded");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.rowTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction5(8, _c82, isExpanded_r5, numColumns_r6, item_r4, level_r7, toggle_r8));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r4)("isExpanded", isExpanded_r5)("numColumns", numColumns_r6)("rowTemplate", _r1)("level", level_r7);
} }
const _c83 = ["pmccTableTreeNester", ""];
const _c84 = function (a0, a1, a2, a3, a4, a5) { return { rowTemplate: a0, numColumns: a1, isExpanded: a2, item: a3, level: a4, toggle: a5 }; };
function TableTreeNesterComponent_ng_container_0_tbody_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵelementContainer(1, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rowTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction6(2, _c84, ctx_r1.rowTemplate, ctx_r1.numColumns, ctx_r1.isExpanded, item_r2, ctx_r1.level + 1, ctx_r1.onToggle));
} }
const _c85 = function (a0) { return { show: a0 }; };
function TableTreeNesterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "td", 1);
    ɵngcc0.ɵɵelementStart(2, "table", 2);
    ɵngcc0.ɵɵelement(3, "thead");
    ɵngcc0.ɵɵtemplate(4, TableTreeNesterComponent_ng_container_0_tbody_4_Template, 2, 9, "tbody", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c85, ctx_r0.isExpanded[ctx_r0.item.id]));
    ɵngcc0.ɵɵattribute("colspan", ctx_r0.numColumns);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.item.items);
} }
function TableTreeTogglerComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const i_r5 = ctx.$implicit;
    const last_r6 = ctx.last;
    ɵngcc0.ɵɵstyleProp("visibility", i_r5 == 0 ? "hidden" : null);
    ɵngcc0.ɵɵclassProp("link", !last_r6)("link-leaf", last_r6);
} }
function TableTreeTogglerComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} }
function TableTreeTogglerComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 10);
} }
function TableTreeTogglerComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r4.count);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r4.count), " ");
} }
function TableTreeMultiselectComponent_th_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const columnHeader_r2 = ctx.$implicit;
    const index_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ttms-title-col", index_r3 == ctx_r0.tableAttrs.collapsecol);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", columnHeader_r2.label, " ");
} }
function TableTreeMultiselectComponent_tr_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "pmcc-table-tree-multiselect-row", 6);
    ɵngcc0.ɵɵlistener("rowSelected", function TableTreeMultiselectComponent_tr_7_Template_pmcc_table_tree_multiselect_row_rowSelected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.updateRowSelection($event); })("rowExpanded", function TableTreeMultiselectComponent_tr_7_Template_pmcc_table_tree_multiselect_row_rowExpanded_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onRowExpand($event); })("rowCollapsed", function TableTreeMultiselectComponent_tr_7_Template_pmcc_table_tree_multiselect_row_rowCollapsed_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onRowCollapse($event); })("rowDeselected", function TableTreeMultiselectComponent_tr_7_Template_pmcc_table_tree_multiselect_row_rowDeselected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.updateRowDeselection($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("colspan", ctx_r1.tableAttrs.colspan);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("row", row_r4)("tableAttrs", ctx_r1.tableAttrs)("level", 0)("selectionDisabled", ctx_r1.selectionDisabled)("selectedRows", ctx_r1.selectedRows);
} }
function TableTreeMultiselectRowComponent_td_8_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} }
function TableTreeMultiselectRowComponent_td_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableTreeMultiselectRowComponent_td_8_ng_container_2_span_1_Template, 1, 0, "span", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.bypasses);
} }
function TableTreeMultiselectRowComponent_td_8_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} }
function TableTreeMultiselectRowComponent_td_8_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵlistener("click", function TableTreeMultiselectRowComponent_td_8_span_4_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.toggleExpand(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c59, !ctx_r6.expanded, ctx_r6.expanded));
} }
function TableTreeMultiselectRowComponent_td_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 5);
    ɵngcc0.ɵɵelementStart(1, "span", 6);
    ɵngcc0.ɵɵtemplate(2, TableTreeMultiselectRowComponent_td_8_ng_container_2_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(3, TableTreeMultiselectRowComponent_td_8_span_3_Template, 1, 0, "span", 8);
    ɵngcc0.ɵɵtemplate(4, TableTreeMultiselectRowComponent_td_8_span_4_Template, 1, 4, "span", 9);
    ɵngcc0.ɵɵelementStart(5, "span", 10);
    ɵngcc0.ɵɵlistener("click", function TableTreeMultiselectRowComponent_td_8_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.toggleSelect(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const columnValue_r2 = ctx.$implicit;
    const index_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ttms-title-col", index_r3 == ctx_r0.tableAttrs.collapsecol);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", index_r3 == ctx_r0.tableAttrs.collapsecol);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", index_r3 == ctx_r0.tableAttrs.collapsecol);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", index_r3 === ctx_r0.tableAttrs.collapsecol && ctx_r0.row.isParent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", columnValue_r2, ɵngcc0.ɵɵsanitizeHtml);
} }
function TableTreeMultiselectRowComponent_tr_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 15);
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "pmcc-table-tree-multiselect-row", 16);
    ɵngcc0.ɵɵlistener("rowSelected", function TableTreeMultiselectRowComponent_tr_9_Template_pmcc_table_tree_multiselect_row_rowSelected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onRowSelect($event); })("rowDeselected", function TableTreeMultiselectRowComponent_tr_9_Template_pmcc_table_tree_multiselect_row_rowDeselected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onRowDeselect($event); })("rowExpanded", function TableTreeMultiselectRowComponent_tr_9_Template_pmcc_table_tree_multiselect_row_rowExpanded_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onRowExpand($event); })("rowCollapsed", function TableTreeMultiselectRowComponent_tr_9_Template_pmcc_table_tree_multiselect_row_rowCollapsed_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onRowCollapse($event); })("updateSelectionToParent", function TableTreeMultiselectRowComponent_tr_9_Template_pmcc_table_tree_multiselect_row_updateSelectionToParent_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.updateSelectionFromChildren($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r13 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("colspan", ctx_r1.tableAttrs.colspan);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("row", row_r13)("tableAttrs", ctx_r1.tableAttrs)("level", ctx_r1.level + 1)("selectedRows", ctx_r1.selectedRows);
} }
const _c86 = ".pmcc-ttms[_ngcontent-%COMP%]{border-spacing:0;border:0;overflow:auto;table-layout:fixed;border-collapse:collapse;border-right:1px solid #ebebeb}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%], tr[_ngcontent-%COMP%]{padding:0;border:0;margin:0;vertical-align:middle}tr.row-selected[_ngcontent-%COMP%]   td.ttms-col[_ngcontent-%COMP%], tr.row-selected[_ngcontent-%COMP%]   td.ttms-col[_ngcontent-%COMP%]:hover{background:#e2f4fe}tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:hover{background:#fff}.ttms-col[_ngcontent-%COMP%]{border-left:1px solid #ebebeb;width:15%;padding:0 5px}table[_ngcontent-%COMP%]{border-bottom:1px solid #ebebeb;width:100%;border-spacing:0;table-layout:fixed;border-collapse:collapse}table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border-bottom:0 solid #ebebeb}.ttms-select-col[_ngcontent-%COMP%]{width:30px;min-width:30px;max-width:30px}.ttms-select-col[_ngcontent-%COMP%]   .ttms-caret-align[_ngcontent-%COMP%]{margin-bottom:2px}.ttms-title-col[_ngcontent-%COMP%]{width:auto;text-overflow:ellipsis;overflow:hidden;position:relative}.ttms-title-col[_ngcontent-%COMP%]   span.label.cell[_ngcontent-%COMP%]:hover{color:#0196d8;cursor:pointer}.tree-node[_ngcontent-%COMP%]{display:flex;align-items:stretch}.tree-node[_ngcontent-%COMP%]   span.fas[_ngcontent-%COMP%]{margin-left:4px;align-self:center}.tree-node[_ngcontent-%COMP%]   span.leg[_ngcontent-%COMP%]{position:relative;display:inline-block;width:25px;align-self:stretch}.tree-node[_ngcontent-%COMP%]   span.leg[_ngcontent-%COMP%]:after, .tree-node[_ngcontent-%COMP%]   span.leg[_ngcontent-%COMP%]:before{content:\"\";position:absolute;display:inline-block}.tree-node[_ngcontent-%COMP%]   span.leg.bypass[_ngcontent-%COMP%]:after{right:0;top:0;width:50%;height:100%;border-left:1px dotted #999}.tree-node[_ngcontent-%COMP%]   span.leg.mid[_ngcontent-%COMP%]:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node[_ngcontent-%COMP%]   span.leg.mid[_ngcontent-%COMP%]:after{right:0;bottom:0;width:50%;height:50%;border-left:1px dotted #999}.tree-node[_ngcontent-%COMP%]   span.leg.last[_ngcontent-%COMP%]:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node[_ngcontent-%COMP%]   span.leg.last.blank[_ngcontent-%COMP%]:after, .tree-node[_ngcontent-%COMP%]   span.leg.last.blank[_ngcontent-%COMP%]:before{border:0}.tree-node[_ngcontent-%COMP%]   span.leg.label[_ngcontent-%COMP%]{flex:1;padding:8px}";
const _c87 = function (a0, a1, a2) { return { "pmcc-tab-selected": a0, "pmcc-tab-hidden": a1, "pmcc-disabled": a2 }; };
const _c88 = function (a0) { return { "pmcc-required": a0 }; };
function TabsetComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵlistener("click", function TabsetComponent_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const tab_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectTab(tab_r1); });
    ɵngcc0.ɵɵelementStart(1, "span", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(5, _c87, tab_r1.selected, tab_r1.appearsInOverflowMenu, tab_r1.disabled))("pmccTooltip", tab_r1.tooltip);
    ɵngcc0.ɵɵattribute("data-pm-id", "tab-selector-" + tab_r1.sequence);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c88, tab_r1.required));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r1.label, " ");
} }
const _c89 = ["pmccTabsVertical", ""];
const _c90 = function (a0, a1, a2) { return { "pmcc-tab-selected": a0, "pmcc-error": a1, "pmcc-disabled": a2 }; };
const _c91 = function (a0, a1) { return { "pmcc-tab-marker-on": a0, "pmcc-tab-marker": a1 }; };
function TabsVerticalComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵlistener("click", function TabsVerticalComponent_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const tab_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectTab(tab_r1); });
    ɵngcc0.ɵɵelementStart(1, "span", 2);
    ɵngcc0.ɵɵelementStart(2, "span", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(9, _c90, ctx_r0.isSelectedTab(tab_r1), tab_r1.error, tab_r1.disabled))("pmccTooltip", tab_r1.tooltip);
    ɵngcc0.ɵɵattribute("data-pm-id", ctx_r0.getUniqueId(tab_r1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c88, tab_r1.required));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r1.label, "\u00A0 ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.markerStyle);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(15, _c91, tab_r1.checked || tab_r1.error, !tab_r1.checked && !tab_r1.error));
} }
function TimeOptionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function TimeOptionsComponent_div_0_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const option_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onSelect(option_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "pmccTime");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, option_r1), "\n");
} }
function MonthPickerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-date-picker-field", 12);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disabled)("monthPickerFlag", true)("width", 115)("date", ctx_r0.month);
} }
function MonthPickerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pmcc-date-picker-field", 13);
    ɵngcc0.ɵɵlistener("focus", function MonthPickerComponent_ng_template_1_Template_pmcc_date_picker_field_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onFieldFocus(); })("keydown", function MonthPickerComponent_ng_template_1_Template_pmcc_date_picker_field_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onKeyDown($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("pmccPopoverTrigger", _r2)("required", ctx_r1.required)("minDate", ctx_r1.minMonth)("maxDate", ctx_r1.maxMonth)("monthPickerFlag", true)("width", 115)("date", ctx_r1.month);
} }
function MonthPickerComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵlistener("click", function MonthPickerComponent_div_13_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const month_r7 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectMonth(month_r7); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c64, month_r7.isSelected, month_r7.isDisabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(2, 2, month_r7.label, 0, 3), " ");
} }
function SelectOptionComponent_pmcc_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-icon", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r0.icon);
} }
const _c92 = function (a0, a1, a2) { return { "disabled": a0, "selected": a1, "highlight": a2 }; };
function SelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0.menuWidth, "px")("height", ctx_r0.menuHeight, "px");
} }
function AdblockerNotificationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "pmcc-message-box", 2);
    ɵngcc0.ɵɵlistener("closed", function AdblockerNotificationComponent_div_0_Template_pmcc_message_box_closed_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.hideNotification(); });
    ɵngcc0.ɵɵelement(2, "span", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("type", ctx_r0.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.notificationMsg, ɵngcc0.ɵɵsanitizeHtml);
} }
function SelectBoxComponent_pmcc_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-radio-button", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("checked", ctx_r0.selected)("disabled", ctx_r0.disabled);
} }
function SelectBoxComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-checkbox", 4);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("checked", ctx_r2.selected)("disabled", ctx_r2.disabled);
} }
const _c99 = function (a0, a1) { return { "selected": a0, "disabled": a1 }; };
const _c100 = ["stickyFooter"];
function TableBulkActionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 2);
    ɵngcc0.ɵɵelement(4, "pmcc-button-actions", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.selectedItemsModel == null ? null : ctx_r0.selectedItemsModel.length, " Selected");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("actions", ctx_r0.actions)("model", ctx_r0.selectedItemsModel)("noBulkActionTooltip", ctx_r0.noBulkActionTooltip)("buttonMenuLabel", ctx_r0.buttonMenuLabel)("isBulkAction", true)("serviceMenuWidth", ctx_r0.serviceMenuWidth)("serviceMenuHeight", ctx_r0.serviceMenuHeight);
} }
function TableRowActionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "pmcc-button-actions", 4);
    ɵngcc0.ɵɵlistener("actionClick", function TableRowActionComponent_div_1_Template_pmcc_button_actions_actionClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.hideMenu(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("actions", ctx_r0.actions)("model", ctx_r0.model)("buttonMenuLabel", ctx_r0.buttonMenuLabel)("serviceMenuWidth", ctx_r0.serviceMenuWidth)("serviceMenuHeight", ctx_r0.serviceMenuHeight);
} }
function ButtonActionsComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function ButtonActionsComponent_button_1_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const primaryAction_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onPrimaryActionClick(primaryAction_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const primaryAction_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("pmccVariant", (primaryAction_r2 == null ? null : primaryAction_r2.isNegative) ? "action-red" : "secondary")("disabled", ctx_r0.isActionDisabled(primaryAction_r2))("pmccTooltip", primaryAction_r2 == null ? null : primaryAction_r2.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(primaryAction_r2.label);
} }
function ButtonActionsComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r5.isBulkAction ? "pmcc-tba-divider" : "pmcc-tra-divider");
} }
function ButtonActionsComponent_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.buttonMenuLabel, " ");
} }
function ButtonActionsComponent_ng_container_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r8.actions == null ? null : ctx_r8.actions.length) && (ctx_r8.primaryActions == null ? null : ctx_r8.primaryActions.length) ? "More Action" : "Actions", " ");
} }
function ButtonActionsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ButtonActionsComponent_ng_container_2_div_1_Template, 1, 1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "pmcc-btn-menu", 5);
    ɵngcc0.ɵɵtemplate(3, ButtonActionsComponent_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(4, ButtonActionsComponent_ng_container_2_ng_template_4_Template, 1, 1, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(5);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.primaryActions == null ? null : ctx_r1.primaryActions.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r1.buttonOption)("disabled", !ctx_r1.actions.length)("pmccTooltip", !ctx_r1.actions.length ? ctx_r1.noBulkActionTooltip : "")("scrollStrategy", "close")("serviceMenuWidth", ctx_r1.serviceMenuWidth)("serviceMenuHeight", ctx_r1.serviceMenuHeight);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.buttonMenuLabel)("ngIfElse", _r7);
} }
function DrawerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵprojection(4, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("margin-right", ctx_r0.offsetRight, "px")("margin-top", ctx_r0.offsetTop, "px")("height", ctx_r0.height);
} }
const _c101 = [[["", 8, "header"]], [["", 8, "content"]]];
const _c102 = [".header", ".content"];
function SideNavigationComponent_ng_container_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
} }
function SideNavigationComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function SideNavigationComponent_ng_container_3_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function SideNavigationComponent_ng_container_3_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const item_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onItemSelect(item_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r2.path)("routerLinkActive", "highlight");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
} }
function SideNavigationComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 4);
    ɵngcc0.ɵɵtemplate(2, SideNavigationComponent_ng_container_3_span_2_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵtemplate(3, SideNavigationComponent_ng_container_3_div_3_Template, 1, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(4, SideNavigationComponent_ng_container_3_a_4_Template, 2, 3, "a", 7);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", item_r2.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "heading");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "divider");
} }
class PmccService {
    constructor() { }
}
PmccService.ɵfac = function PmccService_Factory(t) { return new (t || PmccService)(); };
PmccService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PmccService_Factory() { return new PmccService(); }, token: PmccService, providedIn: "root" });
PmccService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PmccService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AnchorLinksComponent {
    constructor(element) {
        this.element = element;
        this.offset = { x: 0, y: 120 };
        this.scrollOffset = 15;
        this.scrollSource = window;
        this.scrollSubscription = Subscription.EMPTY;
    }
    ngOnChanges() {
        this.scrollSubscription.unsubscribe();
        if (this.scrollElementSelector) {
            this.scrollableContainer = document.querySelector(this.scrollElementSelector);
            this.scrollSource = this.scrollableContainer;
        }
        else {
            this.scrollableContainer = document.documentElement;
            this.scrollSource = window;
        }
        this.scrollSubscription = fromEvent(this.scrollSource, 'scroll').subscribe(() => {
            const activeAnchor = this.findActiveAnchor();
            /* istanbul ignore next */
            if (activeAnchor) {
                this.activateAnchor(this.element.nativeElement, activeAnchor);
            }
        });
    }
    ngOnDestroy() {
        this.scrollableContainer.style.paddingBottom = null;
        this.scrollSubscription.unsubscribe();
    }
    getAbsolutePosition(scrollableContainer, element, offset) {
        const container = scrollableContainer;
        let x = container.scrollLeft - offset.x;
        let y = container.scrollTop - offset.y;
        while (element) {
            if (element.tagName === 'BODY') {
                const xScroll = element.scrollLeft || document.documentElement.scrollLeft;
                const yScroll = element.scrollTop || document.documentElement.scrollTop;
                x += element.offsetLeft - xScroll + element.clientLeft;
                y += element.offsetTop - yScroll + element.scrollTop;
            }
            else {
                x += element.offsetLeft - element.scrollLeft + element.clientLeft;
                y += element.offsetTop - element.scrollTop + element.clientTop;
            }
            element = element.offsetParent;
        }
        if (this.scrollElementSelector) {
            x -= container.scrollLeft;
            y -= container.scrollTop;
        }
        return { x, y };
    }
    scrollTo(scrollableContainer, endPoint) {
        const container = scrollableContainer;
        const startPoint = {
            x: container.scrollLeft,
            y: container.scrollTop
        };
        const numSteps = 30;
        const dX = (endPoint.x - startPoint.x) / numSteps;
        const dY = (endPoint.y - startPoint.y) / numSteps;
        const startBottomBuffer = +container.style.paddingBottom.split('px')[0];
        let endBottomBuffer;
        if (this.scrollElementSelector) {
            endBottomBuffer = +(container.offsetHeight -
                container.scrollHeight +
                endPoint.y);
        }
        else {
            endBottomBuffer = +(window.innerHeight -
                container.offsetHeight +
                endPoint.y);
        }
        const dBottomBuffer = (endBottomBuffer) > 0 ? endBottomBuffer / numSteps : 0;
        const steps = new Array(numSteps + 1)
            .fill(null)
            .map((_, i) => ({
            x: startPoint.x + dX * i,
            y: startPoint.y + dY * i,
            bottomBuffer: startBottomBuffer + dBottomBuffer * i
        }));
        this.animateScrollTo(container, steps);
    }
    animateScrollTo(scrollableContainer, steps) {
        const container = scrollableContainer;
        const step = steps[0];
        if (step) {
            container.scrollTop = step.y;
            container.style.paddingBottom = `${step.bottomBuffer}px`;
        }
        if (steps.length > 0) {
            window.requestAnimationFrame(() => {
                return this.animateScrollTo(container, steps.slice(1));
            });
        }
    }
    findActiveAnchor() {
        const element = this.element.nativeElement;
        const globalHeaderOffset = 50;
        const anchors = Array.from(element.querySelectorAll('a'));
        return anchors
            .filter((anchor) => {
            const sectionId = anchor.getAttribute('anchorId');
            const section = document.getElementById(sectionId);
            const rect = section.getBoundingClientRect();
            return rect.top <= this.offset.y + globalHeaderOffset;
        })
            .pop();
    }
    activateAnchor(element, activeAnchor) {
        element.querySelectorAll('a').forEach((anchor) => {
            anchor.classList.remove('active');
        });
        activeAnchor.classList.add('active');
    }
    navigateToAnchor(link) {
        const container = this.scrollableContainer;
        const anchor = document.getElementById(link.id);
        const scroll = () => {
            if (this.scrollElementSelector && document.documentElement.scrollTop > 0) {
                document.documentElement.scrollTop = 0;
            }
            const scrollPosition = this.getAbsolutePosition(container, anchor, this.offset);
            this.scrollTo(container, scrollPosition);
        };
        if (container.scrollTop <= 1) {
            // tslint:disable
            container.scrollTop = 50;
            setTimeout(scroll, 250);
        }
        else {
            scroll();
        }
    }
    trackByFn(index, item) {
        return item.id;
    }
}
AnchorLinksComponent.ɵfac = function AnchorLinksComponent_Factory(t) { return new (t || AnchorLinksComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AnchorLinksComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AnchorLinksComponent, selectors: [["pmcc-anchor-links"]], inputs: { offset: "offset", scrollOffset: "scrollOffset", links: "links", positionY: "positionY", scrollElementSelector: "scrollElementSelector" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 5, consts: [[1, "pmcc-r-1", "pmcc-mar-sm", "pmcc-top-bottom"], [3, "scrollSource", "positionY", "scrollOffset"], [1, "pmcc-c-1", "pmcc-anchor-links"], [1, "pmcc-flex"], [1, "pmcc-left"], [1, "pmcc-toc"], ["href", "javascript:void(0)", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["href", "javascript:void(0)", 3, "click"]], template: function AnchorLinksComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "pmcc-fixed-layer", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, AnchorLinksComponent_a_6_Template, 2, 2, "a", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("scrollSource", ctx.scrollSource)("positionY", ctx.positionY)("scrollOffset", ctx.scrollOffset);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.links)("ngForTrackBy", ctx.trackByFn);
    } }, directives: function () { return [FixedLayerComponent, ɵngcc1.NgForOf]; }, styles: ["a[_ngcontent-%COMP%]{font:normal 13px Arial,Helvetica,Calibri,sans-serif}a[_ngcontent-%COMP%] + a[_ngcontent-%COMP%]:before{content:\"\\7c \";color:#c9c9c9;margin:0 5px;display:inline-block}a.active[_ngcontent-%COMP%]{text-decoration:none;color:#222121;cursor:default}"] });
AnchorLinksComponent.ctorParameters = () => [
    { type: ElementRef }
];
AnchorLinksComponent.propDecorators = {
    links: [{ type: Input }],
    positionY: [{ type: Input }],
    offset: [{ type: Input }],
    scrollElementSelector: [{ type: Input }],
    scrollOffset: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnchorLinksComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-anchor-links',
                template: "<div class=\"pmcc-r-1 pmcc-mar-sm pmcc-top-bottom\">\n  <pmcc-fixed-layer\n    [scrollSource]=\"scrollSource\"\n    [positionY]=\"positionY\"\n    [scrollOffset]=\"scrollOffset\"\n  >\n    <div\n      class=\"pmcc-c-1 pmcc-anchor-links\"\n    >\n      <div class=\"pmcc-flex\">\n        <div class=\"pmcc-left\">\n          <div class=\"pmcc-toc\">\n            <a\n              *ngFor=\"let link of links; trackBy: trackByFn\"\n              href=\"javascript:void(0)\"\n              [attr.anchorId]=\"link.id\"\n              (click)=\"navigateToAnchor(link)\"\n            >{{ link.label }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </pmcc-fixed-layer>\n</div>\n",
                styles: ["a{font:normal 13px Arial,Helvetica,Calibri,sans-serif}a+a:before{content:\"\\7c \";color:#c9c9c9;margin:0 5px;display:inline-block}a.active{text-decoration:none;color:#222121;cursor:default}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { offset: [{
            type: Input
        }], scrollOffset: [{
            type: Input
        }], links: [{
            type: Input
        }], positionY: [{
            type: Input
        }], scrollElementSelector: [{
            type: Input
        }] }); })();

class FixedLayerComponent {
    constructor(element, ngZone) {
        this.element = element;
        this.ngZone = ngZone;
        this.scrollOffset = 15;
        this.positionY = 0;
        this.scrollSubscription = Subscription.EMPTY;
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            const AUDIT_TIME = 5;
            this.scrollSubscription = fromEvent(this.scrollSource, 'scroll')
                .pipe(auditTime(AUDIT_TIME))
                .subscribe(() => this.setVisibility());
        });
    }
    ngOnDestroy() {
        this.scrollSubscription.unsubscribe();
    }
    setVisibility() {
        const element = this.element.nativeElement;
        const layer = this.layer.nativeElement;
        if (element.getBoundingClientRect().top <= this.scrollOffset) {
            element.style.height = `${element.offsetHeight}px`;
            layer.classList.add('active');
            layer.style.top = `${this.positionY}px`;
        }
        else {
            element.style.height = 'auto';
            layer.classList.remove('active');
        }
    }
}
FixedLayerComponent.ɵfac = function FixedLayerComponent_Factory(t) { return new (t || FixedLayerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
FixedLayerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FixedLayerComponent, selectors: [["pmcc-fixed-layer"]], viewQuery: function FixedLayerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layer = _t.first);
    } }, inputs: { scrollOffset: "scrollOffset", positionY: "positionY", scrollSource: "scrollSource" }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "pmcc-fixed-layer"], ["layer", ""]], template: function FixedLayerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:block}.pmcc-fixed-layer.active[_ngcontent-%COMP%]{position:fixed;top:0;left:0;display:block;width:100%;z-index:29000;background-color:#fff;border-bottom:1px solid #b8b7b7;padding:20px 25px;box-shadow:0 2px 1px 1px #0000001a}"] });
FixedLayerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
FixedLayerComponent.propDecorators = {
    scrollOffset: [{ type: Input }],
    positionY: [{ type: Input }],
    scrollSource: [{ type: Input }],
    layer: [{ type: ViewChild, args: ['layer', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FixedLayerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-fixed-layer',
                template: `
    <div #layer class="pmcc-fixed-layer">
      <ng-content></ng-content>
    </div>
  `,
                styles: [":host{display:block}.pmcc-fixed-layer.active{position:fixed;top:0;left:0;display:block;width:100%;z-index:29000;background-color:#fff;border-bottom:1px solid #b8b7b7;padding:20px 25px;box-shadow:0 2px 1px 1px #0000001a}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { scrollOffset: [{
            type: Input
        }], positionY: [{
            type: Input
        }], scrollSource: [{
            type: Input
        }], layer: [{
            type: ViewChild,
            args: ['layer', { static: true }]
        }] }); })();

class AnchorLinksModule {
}
AnchorLinksModule.ɵfac = function AnchorLinksModule_Factory(t) { return new (t || AnchorLinksModule)(); };
AnchorLinksModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AnchorLinksModule });
AnchorLinksModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnchorLinksModule, [{
        type: NgModule,
        args: [{
                declarations: [AnchorLinksComponent, FixedLayerComponent],
                imports: [CommonModule],
                exports: [AnchorLinksComponent, FixedLayerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AnchorLinksModule, { declarations: function () { return [AnchorLinksComponent, FixedLayerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AnchorLinksComponent, FixedLayerComponent]; } }); })();

class TableRichrowDirective {
    constructor() {
        this._openMultiple = false;
        // @todo close all
    }
    get openMultiple() {
        return this._openMultiple;
    }
    set openMultiple(value) {
        this._openMultiple = coerceBooleanProperty$1(value);
    }
    rowOpened(row) {
        if (!this.openMultiple) {
            if (this.openRow) {
                this.openRow.close();
            }
            this.openRow = row;
        }
    }
    rowClosed(row) {
        this.openRow = undefined;
    }
}
TableRichrowDirective.ɵfac = function TableRichrowDirective_Factory(t) { return new (t || TableRichrowDirective)(); };
TableRichrowDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TableRichrowDirective, selectors: [["table", "pmccTableRichrow", ""], ["pmcc-scrollable-table", "pmccTableRichrow", ""]], inputs: { openMultiple: ["pmccTableRichrowOpenMultiple", "openMultiple"] } });
TableRichrowDirective.propDecorators = {
    openMultiple: [{ type: Input, args: ['pmccTableRichrowOpenMultiple',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableRichrowDirective, [{
        type: Directive,
        args: [{
                selector: 'table[pmccTableRichrow], pmcc-scrollable-table[pmccTableRichrow]'
            }]
    }], function () { return []; }, { openMultiple: [{
            type: Input,
            args: ['pmccTableRichrowOpenMultiple']
        }] }); })();

var State;
(function (State) {
    State[State["Closed"] = 0] = "Closed";
    State[State["Opening"] = 1] = "Opening";
    State[State["Open"] = 2] = "Open";
})(State || (State = {}));
class RichrowDirective {
    constructor(tableRichrow) {
        this.tableRichrow = tableRichrow;
        this.state = State.Closed;
    }
    get isOpen() {
        return this.state === State.Open;
    }
    get closed() {
        return this.state === State.Closed;
    }
    get opening() {
        return this.state === State.Opening;
    }
    open() {
        this.state = State.Open;
        this.tableRichrow.rowOpened(this);
    }
    close() {
        this.state = State.Closed;
        this.tableRichrow.rowClosed(this);
    }
    toggle() {
        if (this.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
}
RichrowDirective.ɵfac = function RichrowDirective_Factory(t) { return new (t || RichrowDirective)(ɵngcc0.ɵɵdirectiveInject(TableRichrowDirective, 1)); };
RichrowDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RichrowDirective, selectors: [["", "pmccRichrow", ""]], exportAs: ["pmccRichrow"] });
RichrowDirective.ctorParameters = () => [
    { type: TableRichrowDirective, decorators: [{ type: Host }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichrowDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccRichrow]',
                exportAs: 'pmccRichrow'
            }]
    }], function () { return [{ type: TableRichrowDirective, decorators: [{
                type: Host
            }] }]; }, null); })();

class RichrowDetailComponent {
    constructor(parentRichrow) {
        this.parentRichrow = parentRichrow;
    }
    get open() {
        return this.parentRichrow.isOpen;
    }
    get opening() {
        return this.parentRichrow.opening;
    }
    get closed() {
        return this.parentRichrow.closed;
    }
}
RichrowDetailComponent.ɵfac = function RichrowDetailComponent_Factory(t) { return new (t || RichrowDetailComponent)(ɵngcc0.ɵɵdirectiveInject(RichrowDirective)); };
RichrowDetailComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RichrowDetailComponent, selectors: [["tr", "pmccRichrowDetail", ""]], attrs: _c2, ngContentSelectors: _c1, decls: 3, vars: 6, consts: [["colspan", "9999"], ["pmccRichrowDetailHeightAnimator", "", 1, "pmcc-richrow-detail"]], template: function RichrowDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "td", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("pmcc-richrow-detail--open", ctx.open)("pmcc-richrow-detail--opening", ctx.opening)("pmcc-richrow-detail--closed", ctx.closed);
    } }, directives: function () { return [RichrowDetailHeightAnimatorDirective]; }, styles: ["[_nghost-%COMP%]{height:0}td[_ngcontent-%COMP%]{padding-top:0;padding-bottom:0}.pmcc-richrow-detail[_ngcontent-%COMP%]{transition:height .3s;overflow:hidden}"] });
RichrowDetailComponent.ctorParameters = () => [
    { type: RichrowDirective }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichrowDetailComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'tr[pmccRichrowDetail]',
                template: "<td colspan=\"9999\">\n  <div\n    pmccRichrowDetailHeightAnimator\n    class=\"pmcc-richrow-detail\"\n    [class.pmcc-richrow-detail--open]=\"open\"\n    [class.pmcc-richrow-detail--opening]=\"opening\"\n    [class.pmcc-richrow-detail--closed]=\"closed\"\n  >\n    <ng-content></ng-content>\n  </div>\n</td>\n",
                styles: [":host{height:0}td{padding-top:0;padding-bottom:0}.pmcc-richrow-detail{transition:height .3s;overflow:hidden}"]
            }]
    }], function () { return [{ type: RichrowDirective }]; }, null); })();

class RichrowToggleDirective {
    constructor(parentRichRow) {
        this.parentRichRow = parentRichRow;
        this.rowToggles = new Set();
    }
    get isOpen() {
        return this.parentRichRow.isOpen;
    }
    get closed() {
        return this.parentRichRow.closed;
    }
    ngOnDestroy() {
        this.rowToggles.clear();
    }
    toggle() {
        this.parentRichRow.toggle();
    }
    registerRowToggle(toggle) {
        this.rowToggles.add(toggle);
    }
    deregisterRowToggle(toggle) {
        this.rowToggles.delete(toggle);
    }
    onClick() {
        // todo is clickable
        // If there are any row toggles, we should not toggle the row on click.
        if (!this.rowToggles.size) {
            this.toggle();
        }
    }
}
RichrowToggleDirective.ɵfac = function RichrowToggleDirective_Factory(t) { return new (t || RichrowToggleDirective)(ɵngcc0.ɵɵdirectiveInject(RichrowDirective, 1)); };
RichrowToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RichrowToggleDirective, selectors: [["tr", "pmccRichrowToggle", ""]], hostVars: 6, hostBindings: function RichrowToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function RichrowToggleDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-richrow-toggle", true)("pmcc-richrow-toggle--open", ctx.isOpen)("pmcc-richrow-toggle--closed", ctx.closed);
    } } });
RichrowToggleDirective.ctorParameters = () => [
    { type: RichrowDirective, decorators: [{ type: Host }] }
];
RichrowToggleDirective.propDecorators = {
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichrowToggleDirective, [{
        type: Directive,
        args: [{
                selector: 'tr[pmccRichrowToggle]',
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-richrow-toggle]': 'true',
                    '[class.pmcc-richrow-toggle--open]': 'isOpen',
                    '[class.pmcc-richrow-toggle--closed]': 'closed'
                }
            }]
    }], function () { return [{ type: RichrowDirective, decorators: [{
                type: Host
            }] }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class IconComponent {
    constructor(elRef) {
        this._name = '';
        /**
         * Icon size.
         */
        this.size = '1x';
        this._element = elRef.nativeElement;
    }
    /**
     * Name of the icon to be displayed.
     */
    get name() {
        return this._name;
    }
    set name(name) {
        this._element.classList.remove(`pmcc-ico-${this._name}`);
        this._name = name;
        this._element.classList.add(`pmcc-ico-${name}`);
    }
}
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["pmcc-icon"]], hostAttrs: ["role", "img", "aria-hidden", "true"], hostVars: 28, hostBindings: function IconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-ico", true)("pmcc-ico-2x", ctx.size === "2x")("pmcc-ico-3x", ctx.size === "3x")("pmcc-ico-4x", ctx.size === "4x")("pmcc-ico-5x", ctx.size === "5x")("pmcc-ico-6x", ctx.size === "6x")("pmcc-ico-black", ctx.color === "black")("pmcc-ico-blue-md", ctx.color === "blue-md")("pmcc-ico-gray-lt", ctx.color === "gray-lt")("pmcc-ico-green", ctx.color === "green")("pmcc-ico-orange", ctx.color === "orange")("pmcc-ico-red", ctx.color === "red")("pmcc-ico-gold", ctx.color === "gold")("pmcc-ico-white", ctx.color === "white");
    } }, inputs: { size: "size", name: "name", color: "color" }, exportAs: ["pmccIcon"], ngContentSelectors: _c1, decls: 1, vars: 0, template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%] {\n        display: inline-block;\n      }"], changeDetection: 0 });
IconComponent.ctorParameters = () => [
    { type: ElementRef }
];
IconComponent.propDecorators = {
    name: [{ type: Input }],
    size: [{ type: Input }],
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-icon',
                exportAs: 'pmccIcon',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    role: 'img',
                    'aria-hidden': 'true',
                    '[class.pmcc-ico]': 'true',
                    '[class.pmcc-ico-2x]': 'size === "2x"',
                    '[class.pmcc-ico-3x]': 'size === "3x"',
                    '[class.pmcc-ico-4x]': 'size === "4x"',
                    '[class.pmcc-ico-5x]': 'size === "5x"',
                    '[class.pmcc-ico-6x]': 'size === "6x"',
                    '[class.pmcc-ico-black]': 'color === "black"',
                    '[class.pmcc-ico-blue-md]': 'color === "blue-md"',
                    '[class.pmcc-ico-gray-lt]': 'color === "gray-lt"',
                    '[class.pmcc-ico-green]': 'color === "green"',
                    '[class.pmcc-ico-orange]': 'color === "orange"',
                    '[class.pmcc-ico-red]': 'color === "red"',
                    '[class.pmcc-ico-gold]': 'color === "gold"',
                    '[class.pmcc-ico-white]': 'color === "white"'
                },
                styles: [`
      :host {
        display: inline-block;
      }
    `]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { size: [{
            type: Input
        }], name: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

class RowToggleDirective {
    constructor(richrowToggle, elementRef, viewContainerRef, componentFactoryResolver) {
        this.richrowToggle = richrowToggle;
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.hasArrow = false;
        this.arrowDetails = {
            onOpen: 'chevron-up',
            onClose: 'chevron-down',
            position: 'right',
            size: '1x',
        };
    }
    ngOnInit() {
        this.richrowToggle.registerRowToggle(this);
        if (this.hasArrow) {
            this.appendCaretIcon();
        }
    }
    ngOnDestroy() {
        this.richrowToggle.deregisterRowToggle(this);
    }
    onClick() {
        if (this.hasArrow) {
            this.toggleIcon();
        }
        this.richrowToggle.toggle();
    }
    toggleIcon() {
        this.iconComponentInstance.name = (this.richrowToggle.isOpen)
            ? this.arrowDetails.onClose : this.arrowDetails.onOpen;
    }
    appendCaretIcon() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(IconComponent);
        const iconComponentRef = this.viewContainerRef.createComponent(componentFactory);
        this.iconComponentInstance = iconComponentRef.instance;
        this.iconComponentInstance.name = this.arrowDetails.onClose;
        this.iconComponentInstance.size = this.arrowDetails.size;
        const iconDiv = document.createElement('div');
        iconDiv.insertAdjacentElement('afterbegin', iconComponentRef.location.nativeElement);
        const cellContentDiv = document.createElement('div');
        while (this.elementRef.nativeElement.firstChild.childNodes.length > 0) {
            cellContentDiv.appendChild(this.elementRef.nativeElement.firstChild.childNodes[0]);
        }
        const parentDiv = document.createElement('div');
        if (this.arrowDetails.position === 'left') {
            parentDiv.appendChild(iconDiv);
            parentDiv.appendChild(cellContentDiv);
        }
        else {
            parentDiv.appendChild(cellContentDiv);
            parentDiv.appendChild(iconDiv);
        }
        this.elementRef.nativeElement.firstChild.insertAdjacentElement('afterbegin', parentDiv);
        this.richrowToggle.registerRowToggle(iconComponentRef.instance);
        this.setCellStyle(iconDiv, parentDiv);
    }
    setCellStyle(iconDiv, parentDiv) {
        parentDiv.style.display = 'inline-flex';
        iconDiv.style.position = 'relative';
        iconDiv.firstElementChild.classList.add('pmcc-row-toggle-icon');
    }
}
RowToggleDirective.ɵfac = function RowToggleDirective_Factory(t) { return new (t || RowToggleDirective)(ɵngcc0.ɵɵdirectiveInject(RichrowToggleDirective), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
RowToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RowToggleDirective, selectors: [["", "pmccRowToggle", ""]], hostBindings: function RowToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function RowToggleDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { hasArrow: "hasArrow", arrowDetails: "arrowDetails" }, exportAs: ["pmccRowToggle"] });
RowToggleDirective.ctorParameters = () => [
    { type: RichrowToggleDirective },
    { type: ElementRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
RowToggleDirective.propDecorators = {
    hasArrow: [{ type: Input }],
    arrowDetails: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccRowToggle]',
                exportAs: 'pmccRowToggle'
            }]
    }], function () { return [{ type: RichrowToggleDirective }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { hasArrow: [{
            type: Input
        }], arrowDetails: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class HeightAnimator {
    constructor(element) {
        this.element = coerceElement(element);
    }
    setHeight(height) {
        this.element.style.height =
            height == null ? null : coerceCssPixelValue(height);
    }
}
/**
 * Handles transition to/from height: auto.
 */
class HeightAutoAnimator extends HeightAnimator {
    expand() {
        const styleHeight = this.element.style.height;
        // have the element transition to the height of its inner content
        this.setHeight(this.element.scrollHeight);
        if (!!styleHeight) {
            // when the next css transition finishes (which should be the one we just triggered)
            const listener = () => {
                // remove "height" from the element's inline styles, so it can return to its initial value
                this.setHeight(null);
                // remove this event listener so it only gets triggered once
                this.element.removeEventListener('transitionend', listener);
            };
            this.element.addEventListener('transitionend', listener);
        }
    }
    collapse() {
        // temporarily disable all css transitions
        const elementTransition = this.element.style.transition;
        this.element.style.transition = '';
        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(() => {
            this.setHeight(this.element.scrollHeight);
            this.element.style.transition = elementTransition;
            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(() => this.setHeight(0));
        });
    }
}
class NoopHeightAnimator extends HeightAnimator {
    expand() {
        this.setHeight(null);
    }
    collapse() {
        this.setHeight(0);
    }
}

class RichrowDetailHeightAnimatorDirective {
    constructor(elRef, parentRichrow) {
        this.elRef = elRef;
        this.parentRichrow = parentRichrow;
    }
    ngOnInit() {
        this.isOpen = this.parentRichrow.isOpen;
        this.elRef.nativeElement.style.height = this.isOpen ? null : '0';
    }
    ngDoCheck() {
        if (this.isOpen !== this.parentRichrow.isOpen) {
            this.isOpen = this.parentRichrow.isOpen;
            this.animate();
        }
    }
    animate() {
        const animator = this.hasTransition()
            ? new HeightAutoAnimator(this.elRef)
            : new NoopHeightAnimator(this.elRef);
        if (this.isOpen) {
            animator.expand();
        }
        else {
            animator.collapse();
        }
    }
    hasTransition() {
        const transition = window
            .getComputedStyle(this.elRef.nativeElement, null)
            .getPropertyValue('transition');
        return transition !== 'all 0s ease 0s';
    }
}
RichrowDetailHeightAnimatorDirective.ɵfac = function RichrowDetailHeightAnimatorDirective_Factory(t) { return new (t || RichrowDetailHeightAnimatorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(RichrowDirective)); };
RichrowDetailHeightAnimatorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RichrowDetailHeightAnimatorDirective, selectors: [["", "pmccRichrowDetailHeightAnimator", ""]] });
RichrowDetailHeightAnimatorDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: RichrowDirective }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichrowDetailHeightAnimatorDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccRichrowDetailHeightAnimator]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: RichrowDirective }]; }, null); })();

class TableRichrowModule {
}
TableRichrowModule.ɵfac = function TableRichrowModule_Factory(t) { return new (t || TableRichrowModule)(); };
TableRichrowModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableRichrowModule });
TableRichrowModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableRichrowModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TableRichrowDirective,
                    RichrowDirective,
                    RichrowDetailComponent,
                    RichrowToggleDirective,
                    RowToggleDirective,
                    RichrowDetailHeightAnimatorDirective
                ],
                imports: [CommonModule],
                exports: [
                    TableRichrowDirective,
                    RichrowDirective,
                    RichrowDetailComponent,
                    RichrowToggleDirective,
                    RowToggleDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableRichrowModule, { declarations: function () { return [TableRichrowDirective, RichrowDirective, RichrowDetailComponent, RichrowToggleDirective, RowToggleDirective, RichrowDetailHeightAnimatorDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TableRichrowDirective, RichrowDirective, RichrowDetailComponent, RichrowToggleDirective, RowToggleDirective]; } }); })();

/**
 * Use "value | apply : Func" to avoid multiple calls of Func during do check
 * Result will be changed on ngChanges
 * The context of function is enclosed (this in undefined).
 * Use this.Func = this.Func.bind(this).(for example in constructor)
 * It also provides additional arguments if required
 */
class ApplyPipe {
    transform(value, func, ...args) {
        return func(value, ...args);
    }
}
ApplyPipe.ɵfac = function ApplyPipe_Factory(t) { return new (t || ApplyPipe)(); };
ApplyPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "apply", type: ApplyPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApplyPipe, [{
        type: Pipe,
        args: [{ name: 'apply' }]
    }], null, null); })();

const BTN_GROUP = new InjectionToken('BtnGroup');

/**
 * Demo example
 * <example-url>/demo/#/pmcc/btn-group</example-url>
 */
class BtnGroupItemComponent {
    constructor(btnGroup) {
        this.btnGroup = btnGroup;
        this._groupChangesSubscription = Subscription.EMPTY;
        this._selected = false;
        this._disabled = false;
        this._required = false;
        /**
         * Emitted when the item has been selected.
         */
        // tslint:disable-next-line:no-output-on-prefix
        this.onSelected = new EventEmitter();
    }
    /**
     * Group item value.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.btnGroup) {
                this._selected = this.btnGroup.value === value;
            }
        }
    }
    /**
     * Whether the item is selected.
     */
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = coerceBooleanProperty$1(value);
    }
    /**
     * Whether the item is disabled.
     */
    get disabled() {
        return this._disabled || (!!this.btnGroup && this.btnGroup.disabled);
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    /**
     * Whether the item is required.
     */
    get required() {
        return this._required || (!!this.btnGroup && this.btnGroup.required);
    }
    set required(required) {
        this._required = required;
    }
    ngOnInit() {
        if (this.btnGroup) {
            this.selected = this.btnGroup.value === this._value;
            this._groupChangesSubscription = this.btnGroup.valueChange.subscribe(value => (this.selected = this._value === value));
        }
    }
    ngOnDestroy() {
        this._groupChangesSubscription.unsubscribe();
    }
    click(event) {
        if (!this.disabled) {
            if (this.btnGroup) {
                this.btnGroup.onChange(this._value);
            }
            this.onSelected.emit(this._value);
        }
        event.stopPropagation();
    }
}
BtnGroupItemComponent.ɵfac = function BtnGroupItemComponent_Factory(t) { return new (t || BtnGroupItemComponent)(ɵngcc0.ɵɵdirectiveInject(BTN_GROUP)); };
BtnGroupItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BtnGroupItemComponent, selectors: [["pmcc-btn-group-item"]], hostVars: 6, hostBindings: function BtnGroupItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function BtnGroupItemComponent_click_HostBindingHandler($event) { return ctx.click($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-btn-group-item", true)("selected", ctx.selected)("disabled", ctx.disabled);
    } }, inputs: { value: "value", selected: "selected", disabled: "disabled", required: "required" }, outputs: { onSelected: "onSelected" }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function BtnGroupItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{font-size:12px;line-height:15px;min-height:23px;padding:3px 8px}.pmcc-btn-md   [_nghost-%COMP%]{font-size:12px;line-height:15px;min-height:27px;padding:5px 10px}.pmcc-btn-lg   [_nghost-%COMP%]{font-size:13px;line-height:16px;min-height:37px;padding:9.5px 15px}[_nghost-%COMP%]{border:1px solid #c7c7c7;position:relative;cursor:pointer;float:left;color:#0085cc;box-sizing:border-box;background-color:#fff}[_nghost-%COMP%]:last-child{border-top-right-radius:3px;border-bottom-right-radius:3px}[_nghost-%COMP%]:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}[_nghost-%COMP%]:hover:not(.disabled):not(.selected), [_nghost-%COMP%]:hover:not(.selected):not(.disabled){background-color:#ececec;border-color:#a6a9ab;box-shadow:none}.disabled[_nghost-%COMP%]{color:#bfbfbf;cursor:not-allowed;border-color:#eaeaea}.selected[_nghost-%COMP%]{color:#fff;background-color:#0196d8;border-color:#0196d8;box-shadow:none}[_nghost-%COMP%]     pmcc-icon.only-icon{font-size:15px;width:15px;height:15px;display:block}.pmcc-btn-lg   [_nghost-%COMP%]     pmcc-icon.only-icon{font-size:16px;width:16px;height:16px;display:block}.pmcc-light   [_nghost-%COMP%]{font-size:12px;padding:14px 0;border:none;border-radius:0;margin-left:16px;background-color:unset}.pmcc-light   [_nghost-%COMP%]:first-child{margin-left:0}.pmcc-light   .disabled[_nghost-%COMP%]{color:#bfbfbf}.pmcc-light   .selected[_nghost-%COMP%]{color:#0085cc;background-color:unset;box-shadow:inset 0 -10px 0 -8px #0085cc}.pmcc-light   .selected.pmcc-stripe-purple[_nghost-%COMP%]{box-shadow:inset 0 -10px 0 -8px #a563a9}.pmcc-light   .selected.pmcc-stripe-green[_nghost-%COMP%]{box-shadow:inset 0 -10px 0 -8px #06a998}.pmcc-light   [_nghost-%COMP%]:hover:not(.disabled):not(.selected), .pmcc-light   [_nghost-%COMP%]:hover:not(.selected):not(.disabled){background-color:unset;border-color:unset}"] });
BtnGroupItemComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BTN_GROUP,] }] }
];
BtnGroupItemComponent.propDecorators = {
    value: [{ type: Input }],
    selected: [{ type: Input }, { type: HostBinding, args: ['class.selected',] }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    required: [{ type: Input }],
    onSelected: [{ type: Output }],
    click: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnGroupItemComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-btn-group-item',
                template: "<ng-content></ng-content>\n",
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-btn-group-item]': 'true'
                },
                styles: [":host{font-size:12px;line-height:15px;min-height:23px;padding:3px 8px}.pmcc-btn-md :host{font-size:12px;line-height:15px;min-height:27px;padding:5px 10px}.pmcc-btn-lg :host{font-size:13px;line-height:16px;min-height:37px;padding:9.5px 15px}:host{border:1px solid #c7c7c7;position:relative;cursor:pointer;float:left;color:#0085cc;box-sizing:border-box;background-color:#fff}:host:last-child{border-top-right-radius:3px;border-bottom-right-radius:3px}:host:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}:host:hover:not(.disabled):not(.selected),:host:hover:not(.selected):not(.disabled){background-color:#ececec;border-color:#a6a9ab;box-shadow:none}:host.disabled{color:#bfbfbf;cursor:not-allowed;border-color:#eaeaea}:host.selected{color:#fff;background-color:#0196d8;border-color:#0196d8;box-shadow:none}:host ::ng-deep pmcc-icon.only-icon{font-size:15px;width:15px;height:15px;display:block}.pmcc-btn-lg :host ::ng-deep pmcc-icon.only-icon{font-size:16px;width:16px;height:16px;display:block}.pmcc-light :host{font-size:12px;padding:14px 0;border:none;border-radius:0;margin-left:16px;background-color:unset}.pmcc-light :host:first-child{margin-left:0}.pmcc-light :host.disabled{color:#bfbfbf}.pmcc-light :host.selected{color:#0085cc;background-color:unset;box-shadow:inset 0 -10px 0 -8px #0085cc}.pmcc-light :host.selected.pmcc-stripe-purple{box-shadow:inset 0 -10px 0 -8px #a563a9}.pmcc-light :host.selected.pmcc-stripe-green{box-shadow:inset 0 -10px 0 -8px #06a998}.pmcc-light :host:hover:not(.disabled):not(.selected),.pmcc-light :host:hover:not(.selected):not(.disabled){background-color:unset;border-color:unset}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BTN_GROUP]
            }] }]; }, { onSelected: [{
            type: Output
        }], value: [{
            type: Input
        }], selected: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.selected']
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], required: [{
            type: Input
        }], click: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/btn-group</example-url>
 */
class BtnGroupComponent {
    constructor() {
        this._lightTheme = false;
        this._value = null;
        this._disabled = false;
        this._required = false;
        /**
         * Group size.
         * Defaults to 'md'
         */
        this.size = 'md';
        /**
         * To facilitate the two-way binding for the `value` input.
         */
        this.valueChange = new EventEmitter();
        /**
         * Emitted when group value changes.
         */
        this.selectionChange = new EventEmitter();
        this.onModelChange = noop;
        this.onTouched = noop;
    }
    /**
     * Whether the group and its items should be rendered with light theme.
     */
    get lightTheme() {
        return this._lightTheme;
    }
    set lightTheme(value) {
        this._lightTheme = coerceBooleanProperty$1(value);
    }
    /**
     * Group value.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            this.updateSelectedButtons();
        }
    }
    /**
     * Whether the group is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    /**
     * Whether the group is required.
     */
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = coerceBooleanProperty$1(required);
    }
    /**
     * Called by BtnGroupItem when its value changes.
     */
    onChange(value) {
        this.onTouched();
        const valueChanged = this._value !== value;
        this.value = value;
        this.onModelChange(this._value);
        if (valueChanged) {
            this.valueChange.emit(this._value);
            this.selectionChange.emit(this._value);
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    updateSelectedButtons() {
        if (this.buttons) {
            this.buttons.forEach(btn => (btn.selected = this.value === btn.value));
        }
    }
}
BtnGroupComponent.ɵfac = function BtnGroupComponent_Factory(t) { return new (t || BtnGroupComponent)(); };
BtnGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BtnGroupComponent, selectors: [["pmcc-btn-group"]], contentQueries: function BtnGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BtnGroupItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttons = _t);
    } }, hostVars: 8, hostBindings: function BtnGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-light", ctx.lightTheme)("pmcc-btn-sm", ctx.size === "sm")("pmcc-btn-md", ctx.size === "md")("pmcc-btn-lg", ctx.size === "lg");
    } }, inputs: { size: "size", lightTheme: "lightTheme", value: "value", disabled: "disabled", required: "required" }, outputs: { valueChange: "valueChange", selectionChange: "selectionChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => BtnGroupComponent)
            },
            {
                provide: BTN_GROUP,
                useExisting: forwardRef(() => BtnGroupComponent)
            },
        ])], ngContentSelectors: _c1, decls: 1, vars: 0, template: function BtnGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:inline-block;position:relative}[_nghost-%COMP%]     pmcc-btn-group-item+pmcc-btn-group-item{margin-left:-1px}"] });
BtnGroupComponent.propDecorators = {
    size: [{ type: Input }],
    lightTheme: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    valueChange: [{ type: Output }],
    selectionChange: [{ type: Output }],
    buttons: [{ type: ContentChildren, args: [BtnGroupItemComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnGroupComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-btn-group',
                template: "<ng-content></ng-content>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => BtnGroupComponent)
                    },
                    {
                        provide: BTN_GROUP,
                        useExisting: forwardRef(() => BtnGroupComponent)
                    },
                ],
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-light]': 'lightTheme',
                    '[class.pmcc-btn-sm]': 'size === "sm"',
                    '[class.pmcc-btn-md]': 'size === "md"',
                    '[class.pmcc-btn-lg]': 'size === "lg"'
                },
                styles: [":host{display:inline-block;position:relative}:host ::ng-deep pmcc-btn-group-item+pmcc-btn-group-item{margin-left:-1px}"]
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], selectionChange: [{
            type: Output
        }], lightTheme: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], buttons: [{
            type: ContentChildren,
            args: [BtnGroupItemComponent]
        }] }); })();

class BtnGroupModule {
}
BtnGroupModule.ɵfac = function BtnGroupModule_Factory(t) { return new (t || BtnGroupModule)(); };
BtnGroupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BtnGroupModule });
BtnGroupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [BtnGroupComponent, BtnGroupItemComponent],
                imports: [CommonModule],
                exports: [BtnGroupComponent, BtnGroupItemComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BtnGroupModule, { declarations: function () { return [BtnGroupComponent, BtnGroupItemComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BtnGroupComponent, BtnGroupItemComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/btn-menu</example-url>
 */
class BtnMenuComponent {
    constructor() {
        this.active = false;
        this.pmccSize = 'sm';
        this.pmccVariant = 'primary';
        this.cssClass = 'pmcc-btn-sm pmcc-primary';
        this.options = [];
        this.disabled = false;
        this.subMenuOnLeft = false;
        this.scrollStrategy = 'reposition';
        this.modelChange = new EventEmitter();
    }
    onFocus(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.active = !this.active;
    }
    hide() {
        if (this.active) {
            this.active = false;
            this.buttonRef.nativeElement.blur();
        }
    }
}
BtnMenuComponent.ɵfac = function BtnMenuComponent_Factory(t) { return new (t || BtnMenuComponent)(); };
BtnMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BtnMenuComponent, selectors: [["pmcc-btn-menu"]], viewQuery: function BtnMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonRef = _t.first);
    } }, hostVars: 2, hostBindings: function BtnMenuComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.active);
    } }, inputs: { pmccSize: "pmccSize", pmccVariant: "pmccVariant", cssClass: "cssClass", options: "options", disabled: "disabled", subMenuOnLeft: "subMenuOnLeft", scrollStrategy: "scrollStrategy", model: "model", serviceMenuWidth: "serviceMenuWidth", serviceMenuHeight: "serviceMenuHeight" }, outputs: { modelChange: "modelChange" }, ngContentSelectors: _c1, decls: 7, vars: 13, consts: [[1, "pmcc-btn-menu", 3, "ngClass"], [1, "button-wrapper", "pmcc-flex", "pmcc-align-items-center"], ["pmccButton", "", 3, "pmccSize", "pmccVariant", "disabled", "ngClass", "mousedown", "focus", "blur"], ["control", ""], ["name", "caret-down", "size", "1x"], ["pmccOverlay", "", "pmccOverlayCloseOutsideOn", "mousedown", 3, "pmccPositionAdjacent", "layerAdjacentOptions", "pmccOverlayOpen", "pmccOverlayScrollStrategy", "close"], [3, "model", "items", "alignRight", "controlElement", "width", "height", "modelChange", "hide"]], template: function BtnMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵlistener("mousedown", function BtnMenuComponent_Template_button_mousedown_2_listener($event) { return ctx.onFocus($event); })("focus", function BtnMenuComponent_Template_button_focus_2_listener($event) { return ctx.onFocus($event); })("blur", function BtnMenuComponent_Template_button_blur_2_listener() { return ctx.hide(); });
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelement(5, "pmcc-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, BtnMenuComponent_ng_template_6_Template, 1, 6, "ng-template", 5);
        ɵngcc0.ɵɵlistener("close", function BtnMenuComponent_Template_ng_template_close_6_listener() { return ctx.hide(); });
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c4, ctx.disabled));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccSize", ctx.pmccSize)("pmccVariant", ctx.pmccVariant)("disabled", ctx.disabled)("ngClass", ctx.cssClass);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("pmccPositionAdjacent", _r0)("layerAdjacentOptions", ctx.subMenuOnLeft ? ɵngcc0.ɵɵpureFunction0(11, _c5) : ɵngcc0.ɵɵpureFunction0(12, _c6))("pmccOverlayOpen", ctx.active)("pmccOverlayScrollStrategy", ctx.scrollStrategy);
    } }, directives: function () { return [ɵngcc1.NgClass, ButtonDirective, IconComponent, OverlayDirective, AdjacentPositionDirective, ServicesMenuInlineComponent]; }, styles: [".pmcc-btn-menu[_ngcontent-%COMP%]{position:relative}.pmcc-btn-menu[_ngcontent-%COMP%], .pmcc-btn-menu[_ngcontent-%COMP%]   span.button-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block}.pmcc-btn-menu[_ngcontent-%COMP%]   span.button-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}.pmcc-btn-menu.disabled[_ngcontent-%COMP%]{pointer-events:none;box-shadow:none;cursor:not-allowed;opacity:.5}.pmcc-btn-menu.disabled[_ngcontent-%COMP%]   .pmcc-dropdown-caret[_ngcontent-%COMP%], .pmcc-btn-menu.disabled[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:not-allowed}.pmcc-btn-menu[_ngcontent-%COMP%]   .pmcc-btn-md[_ngcontent-%COMP%], .pmcc-btn-menu[_ngcontent-%COMP%]   .pmcc-btn-sm[_ngcontent-%COMP%]{padding-right:5px}.pmcc-btn-menu[_ngcontent-%COMP%]   .pmcc-btn-lg[_ngcontent-%COMP%]{padding-right:12px}"] });
BtnMenuComponent.propDecorators = {
    active: [{ type: HostBinding, args: ['class.active',] }],
    pmccSize: [{ type: Input }],
    pmccVariant: [{ type: Input }],
    cssClass: [{ type: Input }],
    options: [{ type: Input }],
    model: [{ type: Input }],
    disabled: [{ type: Input }],
    serviceMenuWidth: [{ type: Input }],
    serviceMenuHeight: [{ type: Input }],
    subMenuOnLeft: [{ type: Input }],
    scrollStrategy: [{ type: Input }],
    modelChange: [{ type: Output }],
    buttonRef: [{ type: ViewChild, args: ['control', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnMenuComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-btn-menu',
                template: "<!-- TODO: [ngClass]=\"cssClass\" attrbute is replaced with pmccSize and pmccVariant and can be removed in next major version release -->\n<span class=\"pmcc-btn-menu\"\n      [ngClass]=\"{'disabled':disabled}\">\n  <span class=\"button-wrapper pmcc-flex pmcc-align-items-center\">\n    <button\n      #control\n      pmccButton\n      [pmccSize]=\"pmccSize\"\n      [pmccVariant]=\"pmccVariant\"\n      [disabled]=\"disabled\"\n      [ngClass]=\"cssClass\"\n      (mousedown)=\"onFocus($event)\"\n      (focus)=\"onFocus($event)\"\n      (blur)=\"hide()\"\n    >\n      <ng-content></ng-content>\n      <pmcc-icon name=\"caret-down\" size=\"1x\"></pmcc-icon>\n    </button>\n  </span>\n</span>\n\n<ng-template\n  pmccOverlay\n  [pmccPositionAdjacent]=\"control\"\n  [layerAdjacentOptions]=\"\n    subMenuOnLeft\n      ? {\n          elementAnchor: 'southeast',\n          layerAnchor: 'northeast'\n        }\n      : {\n          elementAnchor: 'southwest',\n          layerAnchor: 'northwest'\n        }\n  \"\n  [pmccOverlayOpen]=\"active\"\n  pmccOverlayCloseOutsideOn=\"mousedown\"\n  [pmccOverlayScrollStrategy]=\"scrollStrategy\"\n  (close)=\"hide()\"\n>\n  <pmcc-services-menu-inline\n    [model]=\"model\"\n    [items]=\"options\"\n    [alignRight]=\"subMenuOnLeft\"\n    [controlElement]=\"control\"\n    [width]=\"serviceMenuWidth\"\n    [height]=\"serviceMenuHeight\"\n    (modelChange)=\"modelChange.emit($event)\"\n    (hide)=\"hide()\"\n  ></pmcc-services-menu-inline>\n</ng-template>\n",
                styles: [".pmcc-btn-menu{position:relative}.pmcc-btn-menu,.pmcc-btn-menu span.button-wrapper span{display:inline-block}.pmcc-btn-menu span.button-wrapper button:focus{outline:none}.pmcc-btn-menu.disabled{pointer-events:none;box-shadow:none;cursor:not-allowed;opacity:.5}.pmcc-btn-menu.disabled .pmcc-dropdown-caret,.pmcc-btn-menu.disabled input{cursor:not-allowed}.pmcc-btn-menu .pmcc-btn-md,.pmcc-btn-menu .pmcc-btn-sm{padding-right:5px}.pmcc-btn-menu .pmcc-btn-lg{padding-right:12px}"]
            }]
    }], function () { return []; }, { active: [{
            type: HostBinding,
            args: ['class.active']
        }], pmccSize: [{
            type: Input
        }], pmccVariant: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], options: [{
            type: Input
        }], disabled: [{
            type: Input
        }], subMenuOnLeft: [{
            type: Input
        }], scrollStrategy: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], model: [{
            type: Input
        }], serviceMenuWidth: [{
            type: Input
        }], serviceMenuHeight: [{
            type: Input
        }], buttonRef: [{
            type: ViewChild,
            args: ['control', { static: true }]
        }] }); })();

/**
 * Directive applied to pmcc-ico component to add effects to it.
 */
class IconEffectDirective {
    constructor(elRef) {
        this._element = elRef.nativeElement;
    }
    /**
     * Icon effect.
     */
    get effect() {
        return this._effect;
    }
    set effect(effect) {
        this.updateClassName('_effect', effect);
    }
    /**
     * Effect speed.
     */
    get speed() {
        return this._speed;
    }
    set speed(speed) {
        this.updateClassName('_speed', speed);
    }
    updateClassName(prop, newVal) {
        this._element.classList.remove(`pmcc-effect-${this[prop]}`);
        this[prop] = newVal;
        this._element.classList.add(`pmcc-effect-${newVal}`);
    }
}
IconEffectDirective.ɵfac = function IconEffectDirective_Factory(t) { return new (t || IconEffectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IconEffectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IconEffectDirective, selectors: [["pmcc-icon", "effect", ""]], inputs: { effect: "effect", speed: "speed" }, exportAs: ["pmccIconEffect"] });
IconEffectDirective.ctorParameters = () => [
    { type: ElementRef }
];
IconEffectDirective.propDecorators = {
    effect: [{ type: Input }],
    speed: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconEffectDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'pmcc-icon[effect]',
                exportAs: 'pmccIconEffect'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { effect: [{
            type: Input
        }], speed: [{
            type: Input
        }] }); })();

class IconModule {
}
IconModule.ɵfac = function IconModule_Factory(t) { return new (t || IconModule)(); };
IconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconModule });
IconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconModule, [{
        type: NgModule,
        args: [{
                declarations: [IconComponent, IconEffectDirective],
                imports: [CommonModule],
                exports: [IconComponent, IconEffectDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconModule, { declarations: function () { return [IconComponent, IconEffectDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconComponent, IconEffectDirective]; } }); })();

let PMCC_SERVICE_MENU_ID = 0;
/**
 * Demo example
 * <example-url>/demo/#/pmcc/service-menu</example-url>
 */
class ServicesMenuInlineComponent {
    constructor(changeDetector, ngZone, _document) {
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        this._document = _document;
        this.items = [];
        this.alignRight = false;
        this.modelChange = new EventEmitter();
        this.hide = new EventEmitter();
        this._highlightedIndex = -1;
        this._selectedIndex = -1;
        this.subMenuTop = '0px';
        this._defaultKeyHandler = this._defaultKeyHandler.bind(this);
        this.id = ++PMCC_SERVICE_MENU_ID;
    }
    ngOnChanges() {
        if (this.controlElement) {
            this.ngZone.runOutsideAngular(() => {
                this.controlElement.addEventListener('keydown', this._defaultKeyHandler);
            });
        }
        if (this.model && this.items.length) {
            this._selectedIndex = this.items.findIndex(item => item.value === this.model.value);
            this._highlightedIndex = this._selectedIndex;
        }
        this.removeSubMenu();
    }
    getClassNames(item, index) {
        const classNames = [];
        if (item.disable === true) {
            classNames.push('disable');
            return classNames;
        }
        if (index === this._highlightedIndex) {
            classNames.push('highlight');
        }
        if (index === this._selectedIndex) {
            classNames.push('selected');
        }
        if (item.type === 'category-label') {
            classNames.push('pmcc-category-label');
        }
        if (item.type === 'divider') {
            classNames.push('divider');
        }
        return classNames;
    }
    select(event, item) {
        var _a;
        event.stopPropagation();
        if (item.disable === true
            || item.type === 'divider'
            || item.type === 'category-label'
            || event.button !== 0
            || ((_a = item.subMenu) === null || _a === void 0 ? void 0 : _a.options)) {
            event.preventDefault();
            return;
        }
        this._selectValue(item);
    }
    onMouseenter(item, element) {
        if (!item.disable) {
            this.subMenu = item.subMenu;
            this.subMenuTop = (element.offsetTop - this.ulElement.nativeElement.scrollTop) + 'px';
        }
    }
    removeSubMenu() {
        if (this.subMenu) {
            this.subMenu = null;
        }
    }
    ngOnDestroy() {
        PMCC_SERVICE_MENU_ID--;
        if (this.controlElement) {
            this.ngZone.runOutsideAngular(() => {
                this.controlElement.removeEventListener('keydown', this._defaultKeyHandler);
            });
        }
    }
    _next() {
        if (this.id === PMCC_SERVICE_MENU_ID) {
            let i = this._highlightedIndex + 1;
            while (i < this.items.length && this._isSkippableItem(i)) {
                i++;
            }
            if (i < this.items.length) {
                this._highlightedIndex = i;
            }
            this.changeDetector.markForCheck();
        }
    }
    _previous() {
        if (this.id === PMCC_SERVICE_MENU_ID) {
            let i = this._highlightedIndex - 1;
            while (i >= 0 && this._isSkippableItem(i)) {
                i--;
            }
            if (i >= 0) {
                this._highlightedIndex = i;
            }
            this.changeDetector.markForCheck();
        }
    }
    _nextSubMenu() {
        var _a;
        if (this._highlightedIndex !== -1) {
            const item = this.items[this._highlightedIndex];
            if (((_a = item.subMenu) === null || _a === void 0 ? void 0 : _a.options) && this.id === PMCC_SERVICE_MENU_ID && !item.disable) {
                let liElement = this._document.querySelectorAll('li.highlight');
                liElement = liElement[liElement.length - 1];
                this.onMouseenter(item, liElement);
                this.changeDetector.markForCheck();
            }
        }
    }
    _previousSubMenu() {
        if (this.id === PMCC_SERVICE_MENU_ID - 1) {
            this.removeSubMenu();
        }
    }
    _selectByHighLightedIndex() {
        var _a;
        const item = this.items[this._highlightedIndex];
        if ((_a = item.subMenu) === null || _a === void 0 ? void 0 : _a.options) {
            this._nextSubMenu();
        }
        else {
            this._selectValue(item);
        }
    }
    _isSkippableItem(i) {
        return this.items[i].disable || this.items[i].type === 'divider' || this.items[i].type === 'category-label';
    }
    _selectValue(item) {
        if (item.action) {
            item.action(item);
        }
        this.model = item;
        this.modelChange.emit(item);
        this.hide.emit();
    }
    _defaultKeyHandler(event) {
        switch (event.key) {
            case 'ArrowUp':
                this._previous();
                break;
            case 'ArrowDown':
                this._next();
                break;
            case 'ArrowLeft':
                this._previousSubMenu();
                break;
            case 'ArrowRight':
                this._nextSubMenu();
                break;
            case 'Enter':
                this._selectByHighLightedIndex();
                break;
            case 'Escape':
                event.stopImmediatePropagation();
                this.ngZone.run(() => this.hide.emit());
                break;
            case 'Tab':
                this.hide.emit();
                break;
        }
    }
    preventDefault(event) {
        switch (event.key) {
            case 'ArrowUp':
            case 'ArrowDown':
                event.stopPropagation();
                event.preventDefault();
                break;
        }
    }
}
ServicesMenuInlineComponent.ɵfac = function ServicesMenuInlineComponent_Factory(t) { return new (t || ServicesMenuInlineComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
ServicesMenuInlineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ServicesMenuInlineComponent, selectors: [["pmcc-services-menu-inline"]], viewQuery: function ServicesMenuInlineComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ulElement = _t.first);
    } }, hostBindings: function ServicesMenuInlineComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function ServicesMenuInlineComponent_keydown_HostBindingHandler($event) { return ctx.preventDefault($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { items: "items", alignRight: "alignRight", model: "model", width: "width", height: "height", controlElement: "controlElement" }, outputs: { modelChange: "modelChange", hide: "hide" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "pmcc-menu", "data-pm-id", "pop-over", 3, "width", "height", "scroll", 4, "ngIf"], [3, "ngClass", "ngStyle", "model", "items", "width", "height", "alignRight", "controlElement", "modelChange", "hide", 4, "ngIf"], ["data-pm-id", "pop-over", 1, "pmcc-menu", 3, "scroll"], ["ulElement", ""], ["class", "pmcc-menu-item-outer", "data-pm-id", "inline-menu-item", 3, "ngClass", "click", "mouseenter", 4, "ngFor", "ngForOf"], ["data-pm-id", "inline-menu-item", 1, "pmcc-menu-item-outer", 3, "ngClass", "click", "mouseenter"], ["liElement", ""], [1, "pmcc-menu-item", 3, "ngSwitch", "pmccTooltip"], [4, "ngSwitchCase"], ["class", "divider", 4, "ngSwitchCase"], ["class", "pmcc-truncate pmcc-menu-item-delete", 3, "title", 4, "ngSwitchCase"], ["class", "pmcc-flex", 3, "title", 4, "ngSwitchDefault"], [1, "pmcc-label", 3, "textContent"], [1, "pmcc-description", 3, "textContent"], [1, "divider"], [1, "pmcc-truncate", "pmcc-menu-item-delete", 3, "title"], ["class", "pmcc-menu-item-icon", 3, "ngClass", 4, "ngIf"], [3, "textContent"], [1, "pmcc-menu-item-icon", 3, "ngClass"], [1, "pmcc-flex", 3, "title"], [1, "pmcc-left", "pmcc-menu-item-label"], [1, "pmcc-truncate", 3, "textContent"], ["class", "pmcc-right", 4, "ngIf"], [1, "pmcc-right"], ["name", "caret-right", "size", "2x", 1, "pmcc-menu-item-caret"], [3, "ngClass", "ngStyle", "model", "items", "width", "height", "alignRight", "controlElement", "modelChange", "hide"]], template: function ServicesMenuInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ServicesMenuInlineComponent_ul_0_Template, 3, 5, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, ServicesMenuInlineComponent_pmcc_services_menu_inline_1_Template, 1, 10, "pmcc-services-menu-inline", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.items.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.subMenu == null ? null : ctx.subMenu.options == null ? null : ctx.subMenu.options.length);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgSwitch, TooltipDirective, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, IconComponent, ServicesMenuInlineComponent, ɵngcc1.NgStyle]; }, encapsulation: 2, changeDetection: 0 });
ServicesMenuInlineComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
ServicesMenuInlineComponent.propDecorators = {
    items: [{ type: Input }],
    model: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    alignRight: [{ type: Input }],
    controlElement: [{ type: Input }],
    modelChange: [{ type: Output }],
    hide: [{ type: Output }],
    ulElement: [{ type: ViewChild, args: ['ulElement', { static: false },] }],
    preventDefault: [{ type: HostListener, args: ['window:keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServicesMenuInlineComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-services-menu-inline',
                template: "<ul\n  #ulElement\n  *ngIf=\"items.length\"\n  class=\"pmcc-menu\"\n  [style.width.px]=\"width\"\n  [style.height.px]=\"height\"\n  data-pm-id=\"pop-over\"\n  (scroll)=\"removeSubMenu()\"\n>\n  <li\n    #liElement\n    class=\"pmcc-menu-item-outer\"\n    (click)=\"select($event, item)\"\n    (mouseenter)=\"onMouseenter(item, liElement)\"\n    [ngClass]=\"getClassNames(item, i)\"\n    *ngFor=\"let item of items; let i = index\"\n    data-pm-id=\"inline-menu-item\"\n  >\n    <div class=\"pmcc-menu-item\" [ngSwitch]=\"item.type\" [pmccTooltip]=\"item.tooltip\">\n      <ng-container *ngSwitchCase=\"'category-label'\">\n        <div class=\"pmcc-label\" [textContent]=\"item.label\"></div>\n        <div class=\"pmcc-description\" [textContent]=\"item.description\"></div>\n      </ng-container>\n\n      <div class=\"divider\" *ngSwitchCase=\"'divider'\"></div>\n\n      <div class=\"pmcc-truncate pmcc-menu-item-delete\" *ngSwitchCase=\"'delete'\" [title]=\"item.label\">\n        <span *ngIf=\"item.icon\" class=\"pmcc-menu-item-icon\" [ngClass]=\"item.icon\"></span>\n        <span [textContent]=\"item.label\"></span>\n      </div>\n\n      <div class=\"pmcc-flex\" *ngSwitchDefault [title]=\"item.label\">\n        <div class=\"pmcc-left pmcc-menu-item-label\" [class.with-icon]=\"item.subMenu?.options\">\n          <span *ngIf=\"item.icon\" class=\"pmcc-menu-item-icon\" [ngClass]=\"item.icon\"></span>\n          <span class=\"pmcc-truncate\" [textContent]=\"item.label\"></span>\n        </div>\n\n        <div class=\"pmcc-right\" *ngIf=\"item.subMenu?.options\">\n          <pmcc-icon\n            name=\"caret-right\"\n            size=\"2x\"\n            class=\"pmcc-menu-item-caret\"\n          ></pmcc-icon>\n        </div>\n      </div>\n\n    </div>\n  </li>\n</ul>\n\n<pmcc-services-menu-inline\n  [ngClass]=\"alignRight ? 'pmcc-sub-menu-right' : 'pmcc-sub-menu-left'\"\n  [ngStyle]=\"{ 'top': subMenuTop }\"\n  *ngIf=\"subMenu?.options?.length\"\n  [model]=\"model\"\n  [items]=\"subMenu.options\"\n  [width]=\"subMenu?.width\"\n  [height]=\"subMenu?.height\"\n  [alignRight]=\"alignRight\"\n  [controlElement]=\"controlElement\"\n  (modelChange)=\"modelChange.emit($event)\"\n  (hide)=\"hide.emit($event)\"\n></pmcc-services-menu-inline>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { items: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], hide: [{
            type: Output
        }], model: [{
            type: Input
        }], preventDefault: [{
            type: HostListener,
            args: ['window:keydown', ['$event']]
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], controlElement: [{
            type: Input
        }], ulElement: [{
            type: ViewChild,
            args: ['ulElement', { static: false }]
        }] }); })();

const h = ['west', 'central', 'east'];
const v = ['north', 'south'];
function getAnchor(elementRect, layerRect, offset = 0) {
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const elCenter = elementRect.left + elementRect.width / 2;
    const below = elementRect.bottom + layerRect.height < viewportHeight;
    const right = elCenter + offset + layerRect.width < viewportWidth;
    const central = elCenter - layerRect.width / 2 > 0 &&
        elCenter + layerRect.width / 2 < viewportWidth;
    const y = below ? 'south' : 'north';
    let x;
    if (central) {
        x = 'central';
    }
    else if (right) {
        x = 'west';
    }
    else {
        x = 'east';
    }
    return `${y}${x}`;
}
function shiftAnchor(currentAnchor, direction) {
    const parts = getAnchors(currentAnchor);
    const positionYIndx = v.indexOf(parts.y);
    const positionXIndx = h.indexOf(parts.x);
    let xShift = 0;
    let yShift = 0;
    if (direction === 'left') {
        xShift = -1;
    }
    else if (direction === 'right') {
        xShift = 1;
    }
    else if (direction === 'up') {
        yShift = -1;
    }
    else if (direction === 'down') {
        yShift = 1;
    }
    const y = v[positionYIndx + yShift];
    const x = h[positionXIndx + xShift];
    if (!y || !x) {
        return currentAnchor;
    }
    return `${y}${x}`;
}
function updatePosition(edges, anchor, isLayer) {
    if (edges) {
        let direction;
        if (edges.isBelow) {
            direction = 'up';
        }
        else if (edges.isAbove) {
            direction = 'down';
        }
        else if (edges.isRight) {
            direction = 'left';
        }
        else if (edges.isLeft) {
            direction = 'right';
        }
        if (isLayer) {
            direction = mirrorDirection(direction);
        }
        return shiftAnchor(anchor, direction);
    }
    return anchor;
}
function mirrorDirection(direction) {
    if (direction === 'left') {
        return 'right';
    }
    else if (direction === 'right') {
        return 'left';
    }
    else if (direction === 'up') {
        return 'down';
    }
    else if (direction === 'down') {
        return 'up';
    }
    return direction;
}
function getAnchors(anchor) {
    const match = anchor.match(/^(north|south)(east|west|central)$/);
    const y = (match && match[1]) || 'north';
    const x = (match && match[2]) || 'west';
    return {
        x,
        y
    };
}
function isNorth(anchor) {
    return (anchor === 'northwest' ||
        anchor === 'northcentral' ||
        anchor === 'northeast');
}
function isCentral(anchor) {
    return anchor === 'southcentral' || anchor === 'northcentral';
}
function isEast(anchor) {
    return anchor === 'southeast' || anchor === 'northeast';
}

const defaultAdjacentOptions = {
    detectEdges: true,
    elementAnchor: 'southwest',
    layerAnchor: 'northwest'
};
const maxAttempts = 4;
function setTransform$1(el, x, y) {
    el.style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px)`;
}
/**
 * Demo example
 * <example-url>/demo/#/pmcc/layout-service</example-url>
 */
class LayoutService {
    pointLayerAtElement(layer, element, overridePosition, withArrow = false) {
        const elementRect = element.getBoundingClientRect();
        const layerRect = layer.getBoundingClientRect();
        const ARROW_OFFSET = 30;
        const ARROW_SIZE = 10;
        const pointer = withArrow ? ARROW_SIZE : 0;
        const offset = withArrow ? ARROW_OFFSET : 0;
        const anchor = overridePosition || getAnchor(elementRect, layerRect, offset);
        const parts = getAnchors(anchor);
        const top = parts.y === 'north'
            ? elementRect.top - layerRect.height - pointer
            : elementRect.bottom + pointer;
        let left;
        switch (parts.x) {
            case 'east':
                left =
                    elementRect.right -
                        layerRect.width +
                        (offset ? -elementRect.width / 2 + offset : 0);
                break;
            case 'west':
                left = elementRect.left + (offset ? elementRect.width / 2 - offset : 0);
                break;
            case 'central':
            default:
                left = elementRect.left + elementRect.width / 2 - layerRect.width / 2;
        }
        return {
            anchor,
            top,
            left
        };
    }
    placeLayerNearElement(layer, element, overridePosition, zIndexBase = 0, withArrow = false) {
        const { left, top, anchor } = this.pointLayerAtElement(layer, element, overridePosition, withArrow);
        const anchorRegEx = /(north|south)(east|west|central)/g;
        layer.className = layer.className.replace(anchorRegEx, '');
        setTransform$1(layer, left, top);
        layer.classList.add(anchor);
    }
    placeLayerAdjacentToElement(layer, element, options) {
        const mergedOptions = options
            ? Object.assign({}, defaultAdjacentOptions, options)
            : defaultAdjacentOptions;
        const { x, y } = this._getLayerCoordinates(mergedOptions, element, layer);
        setTransform$1(layer, x, y);
    }
    detectEdges(coordinates, elementLayout) {
        return {
            isBelow: coordinates.y + (elementLayout ? elementLayout.height || 0 : 0) >
                window.innerHeight,
            isAbove: coordinates.y < 0,
            isRight: coordinates.x + (elementLayout ? elementLayout.width || 0 : 0) >
                window.innerWidth,
            isLeft: coordinates.x < 0
        };
    }
    _getLayerCoordinates(settings, element, layer) {
        const coordinates = {
            x: 0,
            y: 0
        };
        const elementAnchorCoordinates = this._getElementAnchorCoordinates(settings.elementAnchor, element);
        const layerRect = layer.getBoundingClientRect();
        let attempts = 0;
        let currentLayerAnchor = settings.layerAnchor;
        let layerAnchor = settings.layerAnchor;
        do {
            attempts++;
            layerAnchor = currentLayerAnchor;
            let height = layerRect.height;
            if (element.getBoundingClientRect().bottom <= window.innerHeight) {
                // Bottom is within viewport
                height += element.getBoundingClientRect().height;
            }
            coordinates.y =
                elementAnchorCoordinates.y -
                    (isNorth(layerAnchor) ? 0 : height);
            coordinates.x = elementAnchorCoordinates.x;
            if (isEast(layerAnchor)) {
                coordinates.x -= layerRect.width;
            }
            else if (isCentral(layerAnchor)) {
                coordinates.x -= layerRect.width / 2;
            }
            currentLayerAnchor = updatePosition(settings.detectEdges ? this.detectEdges(coordinates, layerRect) : null, layerAnchor, true);
        } while (currentLayerAnchor !== layerAnchor && attempts <= maxAttempts);
        return {
            x: coordinates.x,
            y: coordinates.y
        };
    }
    _getElementAnchorCoordinates(anchor, element) {
        const coordinates = {
            x: 0,
            y: 0
        };
        const elementRect = element.getBoundingClientRect();
        const elCenter = elementRect.left + elementRect.width / 2;
        let attempts = 0;
        let currentAnchor = anchor;
        do {
            attempts++;
            anchor = currentAnchor;
            coordinates.y = isNorth(anchor) ? elementRect.top : elementRect.bottom;
            if (isCentral(anchor)) {
                coordinates.x = elCenter;
            }
            else if (isEast(anchor)) {
                coordinates.x = elementRect.right;
            }
            else {
                coordinates.x = elementRect.left;
            }
            currentAnchor = updatePosition(this.detectEdges(coordinates), anchor, false);
        } while (currentAnchor !== anchor && attempts <= maxAttempts);
        return coordinates;
    }
}
LayoutService.ɵfac = function LayoutService_Factory(t) { return new (t || LayoutService)(); };
LayoutService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LayoutService_Factory() { return new LayoutService(); }, token: LayoutService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

/**
 * A service that creates the DOM element inside which
 * the overlay will be rendered
 */
/** @dynamic */
class OverlayContainer {
    constructor(document) {
        this.document = document;
    }
    ngOnDestroy() {
        // if the element is created and attached to the DOM
        if (this.containerElement && this.containerElement.parentNode) {
            this.containerElement.parentNode.removeChild(this.containerElement);
        }
    }
    getContainerElement() {
        // create the container element if it doesn't exists yet
        if (!this.containerElement) {
            this.createContainer();
        }
        return this.containerElement;
    }
    createContainer() {
        const container = this.document.createElement('div');
        container.classList.add('pmcc-overlay-container');
        this.document.body.appendChild(container);
        this.containerElement = container;
    }
}
OverlayContainer.ɵfac = function OverlayContainer_Factory(t) { return new (t || OverlayContainer)(ɵngcc0.ɵɵinject(DOCUMENT)); };
OverlayContainer.ɵprov = i0.ɵɵdefineInjectable({ factory: function OverlayContainer_Factory() { return new OverlayContainer(i0.ɵɵinject(i1.DOCUMENT)); }, token: OverlayContainer, providedIn: "root" });
OverlayContainer.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayContainer, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class PositionStrategy {
    constructor(ngZone) {
        this.ngZone = ngZone;
    }
    attach(overlayRef) {
        this.overlayRef = overlayRef;
        if (this.apply) {
            this.apply = this.apply.bind(this);
            this.ngZone.runOutsideAngular(() => {
                window.addEventListener('resize', this.apply);
            });
        }
    }
    detach() {
        this.overlayRef = undefined;
        if (this.apply) {
            this.ngZone.runOutsideAngular(() => {
                window.removeEventListener('resize', this.apply);
            });
        }
    }
}

/**
 * Abstract position strategy which applies itself
 * when the overlay content changes.
 */
class ContentAwarePositionStrategy extends PositionStrategy {
    constructor(contentObserver, ngZone) {
        super(ngZone);
        this.contentObserver = contentObserver;
        this.contentChangeSubscription = Subscription.EMPTY;
    }
    attach(overlayRef) {
        super.attach(overlayRef);
        this.ngZone.runOutsideAngular(() => {
            this.contentChangeSubscription = this.contentObserver
                .observe(overlayRef.overlayElement)
                .subscribe(() => this.apply());
        });
    }
    detach() {
        super.detach();
        this.contentChangeSubscription.unsubscribe();
    }
}

class AdjacentToPositionStrategy extends ContentAwarePositionStrategy {
    constructor(connectedTo, layerAdjacentOptions, layoutService, contentObserver, ngZone) {
        super(contentObserver, ngZone);
        this.connectedTo = connectedTo;
        this.layerAdjacentOptions = layerAdjacentOptions;
        this.layoutService = layoutService;
    }
    apply() {
        if (this.overlayRef) {
            this.layoutService.placeLayerAdjacentToElement(this.overlayRef.overlayElement, this.connectedTo, this.layerAdjacentOptions);
        }
    }
}

function applyThunk(val) {
    // @ts-ignore
    return typeof val === 'function' ? val() : val;
}

/* tslint:disable:unified-signatures */
const emptyArray = [];
/**
 * Translates an element by given coordinates.
 * Rounds the values to prevent subpixel rendering.
 */
function setTransform(el, { x, y }) {
    el.style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px)`;
}
/**
 * Finds a max element in an array by a given selector.
 */
function maxBy(arr, selector) {
    let max = arr[0];
    for (let i = 0; i < arr.length; i++) {
        if (selector(arr[i]) > selector(max)) {
            max = arr[i];
        }
    }
    return max;
}
/**
 * Measures that determine how well an overlay will fit in given position.
 */
class OverlayFit {
    constructor(point, preferredPosition, overlayRect, viewportRect) {
        this.point = point;
        this.preferredPosition = preferredPosition;
        this.overlayRect = overlayRect;
        this.visibleWidth =
            Math.min(viewportRect.right, point.x + overlayRect.width) -
                Math.max(viewportRect.left, point.x);
        this.visibleHeight =
            Math.min(viewportRect.bottom, point.y + overlayRect.height) -
                Math.max(viewportRect.top, point.y);
    }
    get visibleArea() {
        return this.visibleWidth * this.visibleHeight;
    }
    get fitsInViewport() {
        return this.fitsInViewportHorizontally && this.fitsInViewportVertically;
    }
    get fitsInViewportHorizontally() {
        return this.visibleWidth === this.overlayRect.width;
    }
    get fitsInViewportVertically() {
        return this.visibleHeight === this.overlayRect.height;
    }
}
/**
 * Css class name that will be applied to the overlay element
 * if its dimensions are adjusted by the ConnectedPositionStrategy;
 */
const dimensionsAdjustedCssClass = 'pmcc-overlay-dimensions-adjusted';
/**
 * Return ViewportMargin from ViewportMarginLike parameter.
 * If number is passed, it is assumed that it represents margins
 * from all the edges.
 * If the partial margin object is passed, all missing margins will
 * be defaulted to 0.
 */
function normalizeViewportMargin(margin) {
    if (typeof margin === 'number') {
        return {
            top: margin,
            bottom: margin,
            left: margin,
            right: margin
        };
    }
    return {
        top: margin.top || 0,
        bottom: margin.bottom || 0,
        left: margin.left || 0,
        right: margin.right || 0
    };
}
/**
 * Overlay position strategy that position overlay relative to
 * an origin element. Connection point is defined as a point on the
 * overlay element that is connected to a point on the origin element.
 */
class ConnectedPositionStrategy extends ContentAwarePositionStrategy {
    constructor(connectedTo, contentObserver, ngZone) {
        super(contentObserver, ngZone);
        this.connectedTo = connectedTo;
        /**
         * Default X axis offset. Applied when defined and preferred position
         * has no offsetX of its own.
         */
        this._defaultOffsetX = 0;
        /**
         * Default Y axis offset. Applied when defined and preferred position
         * has no offsetY of its own.
         */
        this._defaultOffsetY = 0;
        /**
         * List of preferred position.
         * From most to least desirable.
         */
        this._preferredPositions = [];
        /**
         * Whether the overlay element's dimensions
         * can be adjusted to fit it in the viewport.
         */
        this._hasFlexibleDimensions = false;
        /**
         * Minimum distance from the edges of the viewport the overlay
         * must be positioned.
         * Can be a function.
         */
        this._viewportMargin = normalizeViewportMargin(0);
        /**
         * Css classes applied to the panel element.
         */
        this._appliedPanelClassNames = [];
        /**
         * Css classes applied to the origin element.
         */
        this._appliedOriginClassNames = [];
    }
    /**
     * Adds preferred positions for the overlay.
     */
    withPositions(position) {
        this._preferredPositions = position;
        return this;
    }
    /**
     * Add default offset for the overlay on the X axis.
     */
    withDefaultOffsetX(offsetX) {
        this._defaultOffsetX = offsetX;
        return this;
    }
    /**
     * Add default offset for the overlay on the Y axis.
     */
    withDefaultOffsetY(offsetY) {
        this._defaultOffsetY = offsetY;
        return this;
    }
    /**
     * Sets whether the overlay element's dimensions
     * can be adjusted to fit it in the viewport.
     */
    withFlexibleDimensions(hasFlexibleDimensions = true) {
        this._hasFlexibleDimensions = hasFlexibleDimensions;
        return this;
    }
    withViewportMargin(margin = 0) {
        this._viewportMargin =
            typeof margin === 'function'
                ? () => normalizeViewportMargin(margin())
                : normalizeViewportMargin(margin);
        return this;
    }
    /**
     * Positions the overlay element in the best position
     * that is selected as follows:
     *   1. If a position fits in the viewport entirely,
     *   use the position immediately.
     *
     *   2. If the overlay has flexible dimensions and its dimensions can
     *   be adjusted to fit, use the position that has the biggest visible area.
     *
     *   3. If all positions didn't fit,
     *   use a fallback with the biggest visible area.
     */
    apply() {
        if (this.overlayRef) {
            if (!this._preferredPositions.length) {
                // no positions have been provided, nothing else to do here
                return;
            }
            const viewportRect = this._getViewportRect();
            const overlayElement = this.overlayRef.overlayElement;
            // Clear overlay dimensions adjustments so that
            // getBoundingClientRect returns unconstrained rect.
            this._clearDimensionsAdjustments();
            const anchorRect = this.connectedTo.getBoundingClientRect();
            const overlayRect = overlayElement.getBoundingClientRect();
            // Fallback in case when no positions fit in the viewport.
            let fallback;
            // Positions where the overlay would fit with adjusted dimensions.
            const fits = [];
            // Iterate over the preferred positions to find the one
            // that fits the best.
            for (let i = 0; i < this._preferredPositions.length; i++) {
                const preferredPosition = this._preferredPositions[i];
                const point = this.getTranslationPoint(anchorRect, overlayRect, preferredPosition);
                const fit = new OverlayFit(point, preferredPosition, overlayRect, viewportRect);
                if (fit.fitsInViewport) {
                    // If the overlay fits in the viewport entirely,
                    // apply the position immediately and return.
                    this._applyPosition(fit.point, fit.preferredPosition);
                    return;
                }
                if (this._canFitWithDimensionsAdjust(fit, anchorRect)) {
                    // If the overlay's dimensions can be adjusted to fit it
                    // it the viewport, save this position for later.
                    fits.push(fit);
                }
                // Store the position with max visible area as a fallback if
                // no other positions fit.
                if (!fallback || fallback.visibleArea < fit.visibleArea) {
                    fallback = fit;
                }
            }
            const bestFit = maxBy(fits, fit => fit.visibleArea);
            if (bestFit) {
                // If we have a position that would fit the overlay with
                // adjusted dimensions, apply the adjustments and the position
                // to the overlay and return.
                const adjust = this._getDimensionsAdjust(bestFit, anchorRect);
                this._applyPosition(bestFit.point, bestFit.preferredPosition, adjust);
                return;
            }
            // Apply the fallback if all other positions have been discarded.
            this._applyPosition(fallback.point, fallback.preferredPosition);
        }
    }
    /**
     * Position the overlay with given coordinates and connection point.
     */
    _applyPosition(position, connection, dimensionsAdjust) {
        setTransform(this.overlayRef.overlayElement, position);
        this._applyPanelClassNames(connection.panelClassName);
        this._applyOriginClassNames(connection.originClassName);
        if (dimensionsAdjust) {
            this._adjustOverlayDimensions(dimensionsAdjust);
        }
    }
    /**
     * Apply CSS class names to the overlay element
     */
    _applyPanelClassNames(classNames) {
        this._appliedPanelClassNames = this._applyClassNames(classNames, this._appliedPanelClassNames, this.overlayRef.overlayElement);
    }
    /**
     * Apply CSS class names to the origin element
     */
    _applyOriginClassNames(classNames) {
        this._appliedOriginClassNames = this._applyClassNames(classNames, this._appliedOriginClassNames, this.overlayRef.anchorElement);
    }
    /**
     * Apply CSS class names to an element and clear previously applied ones.
     */
    _applyClassNames(className, prevClassNames, el) {
        const classNames = coerceArray(className || emptyArray);
        const appliedClassNames = [];
        // clear previous class names
        prevClassNames.forEach(cls => el.classList.remove(cls));
        classNames.forEach(cls => {
            if (cls !== '') {
                el.classList.add(cls);
                appliedClassNames.push(cls);
            }
        });
        return appliedClassNames;
    }
    /**
     * Returns adjustments for the overlays dimensions.
     */
    _getDimensionsAdjust(fit, anchorRect) {
        let adjust;
        const { point } = fit;
        if (!fit.fitsInViewportVertically) {
            adjust = adjust || {};
            adjust.maxHeight = fit.visibleHeight;
            if (point.y < anchorRect.top) {
                // If the overlay is above the anchor and we constrained overlay's height,
                // we need to push it down to compensate for the adjustment.
                point.y += fit.overlayRect.height - fit.visibleHeight;
            }
        }
        if (!fit.fitsInViewportHorizontally) {
            adjust = adjust || {};
            adjust.maxWidth = fit.visibleWidth;
            if (point.x < anchorRect.left) {
                // If the overlay is on the left side of  the anchor
                // and we constrained overlay's width,
                // we need to push it right to compensate for the adjustment.
                point.x += fit.overlayRect.width - fit.visibleWidth;
            }
        }
        return adjust;
    }
    _adjustOverlayDimensions(dimensionsAdjust) {
        const overlayElement = this.overlayRef.overlayElement;
        if (dimensionsAdjust.maxHeight) {
            overlayElement.style.maxHeight = `${dimensionsAdjust.maxHeight}px`;
        }
        if (dimensionsAdjust.maxWidth) {
            overlayElement.style.maxWidth = `${dimensionsAdjust.maxWidth}px`;
        }
        overlayElement.classList.add(dimensionsAdjustedCssClass);
    }
    _clearDimensionsAdjustments() {
        const overlayElement = this.overlayRef.overlayElement;
        overlayElement.style.maxHeight = null;
        overlayElement.style.maxWidth = null;
        overlayElement.classList.remove(dimensionsAdjustedCssClass);
    }
    _canFitWithDimensionsAdjust(fit, anchorRect) {
        if (!this._hasFlexibleDimensions) {
            return false;
        }
        const anchorInViewportHorizontally = anchorRect.left >= 0 && anchorRect.right <= window.innerWidth;
        const anchorInViewportVertically = anchorRect.top >= 0 && anchorRect.bottom <= window.innerHeight;
        const canFitHorizontally = fit.fitsInViewportHorizontally || anchorInViewportHorizontally;
        const canFitVertically = fit.fitsInViewportVertically || anchorInViewportVertically;
        return canFitHorizontally && canFitVertically;
    }
    /**
     * Calculates `translate` coordinates with the given connection points,
     * dimensions and offsets.
     */
    getTranslationPoint(anchorRect, overlayRect, connection) {
        const { originPos, overlayPos, offsetX = this._defaultOffsetX, offsetY = this._defaultOffsetY } = connection;
        let x = offsetX;
        let y = offsetY;
        if (originPos.originX === 'start') {
            x += anchorRect.left;
        }
        else if (originPos.originX === 'end') {
            x += anchorRect.right;
        }
        else {
            x += anchorRect.left + anchorRect.width / 2;
        }
        if (originPos.originY === 'top') {
            y += anchorRect.top;
        }
        else if (originPos.originY === 'bottom') {
            y += anchorRect.bottom;
        }
        else {
            y += anchorRect.top + anchorRect.height / 2;
        }
        if (overlayPos.overlayX === 'end') {
            x -= overlayRect.width;
        }
        else if (overlayPos.overlayX === 'center') {
            x -= overlayRect.width / 2;
        }
        if (overlayPos.overlayY === 'bottom') {
            y -= overlayRect.height;
        }
        else if (overlayPos.overlayY === 'center') {
            y -= overlayRect.height / 2;
        }
        return { x, y };
    }
    /**
     * Returns narrowed viewport rect with viewport margins applied.
     */
    _getViewportRect() {
        const margin = applyThunk(this._viewportMargin);
        return {
            top: margin.top,
            bottom: window.innerHeight - margin.bottom,
            left: margin.left,
            right: window.innerWidth - margin.right,
            width: window.innerWidth - (margin.left + margin.right),
            height: window.innerHeight - (margin.top + margin.bottom)
        };
    }
}

const overlayClassName = 'pmcc-global-overlay';
class GlobalPositionStrategy extends PositionStrategy {
    constructor() {
        super(...arguments);
        this.offsetTop = '';
        this.offsetBottom = '';
        this.offsetLeft = '';
        this.offsetRight = '';
        this.justifyContent = '';
        this.alignItems = '';
    }
    top(offsetTop = '') {
        this.offsetBottom = '';
        this.offsetTop = offsetTop;
        this.alignItems = 'flex-start';
        return this;
    }
    bottom(offsetBottom = '') {
        this.offsetTop = '';
        this.offsetBottom = offsetBottom;
        this.alignItems = 'flex-end';
        return this;
    }
    left(offsetLeft = '') {
        this.offsetRight = '';
        this.offsetLeft = offsetLeft;
        this.justifyContent = 'flex-start';
        return this;
    }
    right(offsetRight = '') {
        this.offsetLeft = '';
        this.offsetRight = offsetRight;
        this.justifyContent = 'flex-end';
        return this;
    }
    centerVertically(offsetTop = '') {
        this.top(offsetTop);
        this.alignItems = 'center';
        return this;
    }
    centerHorizontally(offsetLeft = '') {
        this.left(offsetLeft);
        this.justifyContent = 'center';
        return this;
    }
    attach(overlayRef) {
        super.attach(overlayRef);
        if (this.overlayRef && this.overlayRef.hostElement) {
            this.overlayRef.hostElement.classList.add(overlayClassName);
        }
    }
    detach() {
        if (this.overlayRef && this.overlayRef.hostElement) {
            this.overlayRef.hostElement.classList.remove(overlayClassName);
        }
        super.detach();
    }
    apply() {
        if (!this.overlayRef || !this.overlayRef.attached) {
            return;
        }
        if (!this.overlayRef.overlayElement || !this.overlayRef.hostElement) {
            return;
        }
        const overlayElStyles = this.overlayRef.overlayElement.style;
        const hostElStyles = this.overlayRef.hostElement.style;
        overlayElStyles.marginTop = this.offsetTop;
        overlayElStyles.marginBottom = this.offsetBottom;
        overlayElStyles.marginLeft = this.offsetLeft;
        overlayElStyles.marginRight = this.offsetRight;
        hostElStyles.justifyContent = this.justifyContent;
        hostElStyles.alignItems = this.alignItems;
    }
}

class NearPositionStrategy extends ContentAwarePositionStrategy {
    constructor(connectedTo, positionOverride, layoutService, contentObserver, ngZone, withArrow = false) {
        super(contentObserver, ngZone);
        this.connectedTo = connectedTo;
        this.positionOverride = positionOverride;
        this.layoutService = layoutService;
        this.withArrow = withArrow;
    }
    apply() {
        if (this.overlayRef) {
            this.layoutService.placeLayerNearElement(this.overlayRef.overlayElement, this.connectedTo, this.positionOverride, 0, this.withArrow);
        }
    }
}

class PositionStrategyBuilderService {
    constructor(layoutService, ngZone, contentObserver) {
        this.layoutService = layoutService;
        this.ngZone = ngZone;
        this.contentObserver = contentObserver;
    }
    near(element, positionOverride, withArrow = false) {
        return new NearPositionStrategy(element, positionOverride, this.layoutService, this.contentObserver, this.ngZone, withArrow);
    }
    adjacent(element, layerAdjacentOptions) {
        return new AdjacentToPositionStrategy(element, layerAdjacentOptions, this.layoutService, this.contentObserver, this.ngZone);
    }
    global() {
        return new GlobalPositionStrategy(this.ngZone);
    }
    connectedTo(connectedTo) {
        return new ConnectedPositionStrategy(connectedTo, this.contentObserver, this.ngZone);
    }
}
PositionStrategyBuilderService.ɵfac = function PositionStrategyBuilderService_Factory(t) { return new (t || PositionStrategyBuilderService)(ɵngcc0.ɵɵinject(LayoutService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ɵngcc2.ContentObserver)); };
PositionStrategyBuilderService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PositionStrategyBuilderService_Factory() { return new PositionStrategyBuilderService(i0.ɵɵinject(LayoutService), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i2.ContentObserver)); }, token: PositionStrategyBuilderService, providedIn: "root" });
PositionStrategyBuilderService.ctorParameters = () => [
    { type: LayoutService },
    { type: NgZone },
    { type: ContentObserver }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PositionStrategyBuilderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LayoutService }, { type: ɵngcc0.NgZone }, { type: ɵngcc2.ContentObserver }]; }, null); })();

const POSITION = new InjectionToken('OverlayPosition');
class NearPositionDirective {
    constructor(position) {
        this.position = position;
        this.withArrow = false;
    }
    build() {
        return this.position.near(coerceElement(this.anchorElement), this.positionOverride, this.withArrow);
    }
}
NearPositionDirective.ɵfac = function NearPositionDirective_Factory(t) { return new (t || NearPositionDirective)(ɵngcc0.ɵɵdirectiveInject(PositionStrategyBuilderService)); };
NearPositionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NearPositionDirective, selectors: [["", "pmccOverlay", "", "pmccPositionNear", ""]], inputs: { withArrow: "withArrow", anchorElement: ["pmccPositionNear", "anchorElement"], positionOverride: "positionOverride" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: POSITION,
                useExisting: forwardRef(() => NearPositionDirective)
            }
        ])] });
NearPositionDirective.ctorParameters = () => [
    { type: PositionStrategyBuilderService }
];
NearPositionDirective.propDecorators = {
    anchorElement: [{ type: Input, args: ['pmccPositionNear',] }],
    positionOverride: [{ type: Input }],
    withArrow: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NearPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccOverlay][pmccPositionNear]',
                providers: [
                    {
                        provide: POSITION,
                        useExisting: forwardRef(() => NearPositionDirective)
                    }
                ]
            }]
    }], function () { return [{ type: PositionStrategyBuilderService }]; }, { withArrow: [{
            type: Input
        }], anchorElement: [{
            type: Input,
            args: ['pmccPositionNear']
        }], positionOverride: [{
            type: Input
        }] }); })();
class AdjacentPositionDirective {
    constructor(position) {
        this.position = position;
    }
    build() {
        return this.position.adjacent(coerceElement(this.anchorElement), this.layerAdjacentOptions);
    }
}
AdjacentPositionDirective.ɵfac = function AdjacentPositionDirective_Factory(t) { return new (t || AdjacentPositionDirective)(ɵngcc0.ɵɵdirectiveInject(PositionStrategyBuilderService)); };
AdjacentPositionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AdjacentPositionDirective, selectors: [["", "pmccOverlay", "", "pmccPositionAdjacent", ""]], inputs: { anchorElement: ["pmccPositionAdjacent", "anchorElement"], layerAdjacentOptions: "layerAdjacentOptions" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: POSITION,
                useExisting: forwardRef(() => AdjacentPositionDirective)
            }
        ])] });
AdjacentPositionDirective.ctorParameters = () => [
    { type: PositionStrategyBuilderService }
];
AdjacentPositionDirective.propDecorators = {
    anchorElement: [{ type: Input, args: ['pmccPositionAdjacent',] }],
    layerAdjacentOptions: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdjacentPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccOverlay][pmccPositionAdjacent]',
                providers: [
                    {
                        provide: POSITION,
                        useExisting: forwardRef(() => AdjacentPositionDirective)
                    }
                ]
            }]
    }], function () { return [{ type: PositionStrategyBuilderService }]; }, { anchorElement: [{
            type: Input,
            args: ['pmccPositionAdjacent']
        }], layerAdjacentOptions: [{
            type: Input
        }] }); })();
class ScreenCenterPositionDirective {
    constructor(position) {
        this.position = position;
    }
    build() {
        return this.position
            .global()
            .centerHorizontally()
            .centerVertically();
    }
}
ScreenCenterPositionDirective.ɵfac = function ScreenCenterPositionDirective_Factory(t) { return new (t || ScreenCenterPositionDirective)(ɵngcc0.ɵɵdirectiveInject(PositionStrategyBuilderService)); };
ScreenCenterPositionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScreenCenterPositionDirective, selectors: [["", "pmccOverlay", "", "pmccPositionScreenCenter", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: POSITION,
                useExisting: forwardRef(() => ScreenCenterPositionDirective)
            }
        ])] });
ScreenCenterPositionDirective.ctorParameters = () => [
    { type: PositionStrategyBuilderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScreenCenterPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccOverlay][pmccPositionScreenCenter]',
                providers: [
                    {
                        provide: POSITION,
                        useExisting: forwardRef(() => ScreenCenterPositionDirective)
                    }
                ]
            }]
    }], function () { return [{ type: PositionStrategyBuilderService }]; }, null); })();
class ScreenRightPositionDirective {
    constructor(position) {
        this.position = position;
    }
    build() {
        return this.position
            .global()
            .right();
    }
}
ScreenRightPositionDirective.ɵfac = function ScreenRightPositionDirective_Factory(t) { return new (t || ScreenRightPositionDirective)(ɵngcc0.ɵɵdirectiveInject(PositionStrategyBuilderService)); };
ScreenRightPositionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScreenRightPositionDirective, selectors: [["", "pmccOverlay", "", "pmccPositionScreenRight", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: POSITION,
                useExisting: forwardRef(() => ScreenRightPositionDirective)
            }
        ])] });
ScreenRightPositionDirective.ctorParameters = () => [
    { type: PositionStrategyBuilderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScreenRightPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccOverlay][pmccPositionScreenRight]',
                providers: [
                    {
                        provide: POSITION,
                        useExisting: forwardRef(() => ScreenRightPositionDirective)
                    }
                ]
            }]
    }], function () { return [{ type: PositionStrategyBuilderService }]; }, null); })();
class ScreenLeftPositionDirective {
    constructor(position) {
        this.position = position;
    }
    build() {
        return this.position
            .global()
            .left();
    }
}
ScreenLeftPositionDirective.ɵfac = function ScreenLeftPositionDirective_Factory(t) { return new (t || ScreenLeftPositionDirective)(ɵngcc0.ɵɵdirectiveInject(PositionStrategyBuilderService)); };
ScreenLeftPositionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScreenLeftPositionDirective, selectors: [["", "pmccOverlay", "", "pmccPositionScreenLeft", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: POSITION,
                useExisting: forwardRef(() => ScreenLeftPositionDirective)
            }
        ])] });
ScreenLeftPositionDirective.ctorParameters = () => [
    { type: PositionStrategyBuilderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScreenLeftPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccOverlay][pmccPositionScreenLeft]',
                providers: [
                    {
                        provide: POSITION,
                        useExisting: forwardRef(() => ScreenLeftPositionDirective)
                    }
                ]
            }]
    }], function () { return [{ type: PositionStrategyBuilderService }]; }, null); })();

/**
 * Backdrop
 */
var BackDrop;
(function (BackDrop) {
    BackDrop[BackDrop["NONE"] = 0] = "NONE";
    BackDrop[BackDrop["TRANSPARENT"] = 1] = "TRANSPARENT";
    BackDrop[BackDrop["DARK"] = 2] = "DARK";
})(BackDrop || (BackDrop = {}));
/**
 * Reference to an overlay created with OverlayService.
 */
class OverlayRef {
    constructor(portalOutlet, host, pane, positionStrategy, scrollStrategy, ngZone, document, config) {
        this.portalOutlet = portalOutlet;
        this.host = host;
        this.pane = pane;
        this.positionStrategy = positionStrategy;
        this.scrollStrategy = scrollStrategy;
        this.ngZone = ngZone;
        this.document = document;
        this.config = config;
        this.attachments = new Subject();
        this._detachments = new Subject();
        this.close = new EventEmitter();
    }
    get overlayElement() {
        return this.pane;
    }
    get hostElement() {
        return this.host;
    }
    get detachments() {
        return this._detachments.asObservable();
    }
    get attached() {
        return this.portalOutlet.hasAttached();
    }
    /**
     * Attaches content in the given portal to
     * the overlay
     */
    attach(portal) {
        const attachResult = this.portalOutlet.attach(portal);
        if (this.host && !this.host.parentElement && this.previousHostParent) {
            this.previousHostParent.appendChild(this.host);
        }
        this.positionStrategy.attach(this);
        this.scrollStrategy.attach(this);
        if (this.config.backdrop !== BackDrop.NONE) {
            this.attachBackdrop(this.config);
        }
        this.scrollStrategy.enable();
        this.updatePosition();
        this.attachments.next();
        return attachResult;
    }
    /**
     * Detaches an overlay from a portal
     */
    detach() {
        if (this.portalOutlet.hasAttached()) {
            this.portalOutlet.detach();
            this.detachBackdrop();
            this.positionStrategy.detach();
            this.scrollStrategy.detach();
            this._detachments.next();
            this.detachContentWhenStable();
        }
    }
    /**
     * Cleans the overlay from DOM
     */
    dispose() {
        this.attachments.complete();
        this.detachBackdrop();
        if (this.host && this.host.parentNode) {
            this.host.parentNode.removeChild(this.host);
            this.host = null;
        }
        this.previousHostParent = null;
        this.pane = null;
        this.detach();
        this._detachments.complete();
    }
    get anchorElement() {
        return this.positionStrategy.connectedTo;
    }
    updatePosition() {
        this.positionStrategy.apply();
    }
    attachBackdrop(config) {
        this.backdropElement = this.document.createElement('div');
        this.backdropElement.classList.add('pmcc-overlay-backdrop');
        this.backdropElement.classList.add('back-drop');
        if (config.backdrop === BackDrop.TRANSPARENT) {
            this.backdropElement.classList.add('pmcc-transparent');
        }
        /* istanbul ignore next */
        if (config.closeOnClickOutside || config.closeOnClickOutside === undefined) {
            this.backdropElement.addEventListener('click', () => {
                this.close.emit();
            });
        }
        // Insert the backdrop before the pane in the DOM order,
        // in order to handle stacked overlays properly.
        if (this.host && this.host.parentElement) {
            this.host.parentElement.insertBefore(this.backdropElement, this.host);
        }
    }
    detachBackdrop() {
        if (!this.backdropElement) {
            return;
        }
        if (this.backdropElement.parentElement) {
            this.backdropElement.parentElement.removeChild(this.backdropElement);
        }
    }
    detachContentWhenStable() {
        this.ngZone.runOutsideAngular(() => {
            const subscription = this.ngZone.onStable
                .asObservable()
                .pipe(takeUntil(merge(this.attachments, this._detachments)))
                .subscribe(() => {
                if (!this.pane || !this.host || this.pane.children.length === 0) {
                    if (this.host && this.host.parentElement) {
                        this.previousHostParent = this.host.parentElement;
                        this.previousHostParent.removeChild(this.host);
                    }
                    subscription.unsubscribe();
                }
            });
        });
    }
}

/**
 * An for attaching portals to DOM elements outside of the Angular
 * application context.
 */
class DomPortalOutlet {
    constructor(outletElement, _componentFactoryResolver, _appRef, _injector) {
        this.outletElement = outletElement;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
        this._injector = _injector;
        this.attachedPortal = null;
        this.disposeFn = null;
        this.isDisposed = false;
    }
    hasAttached() {
        return !!this.attachedPortal;
    }
    attach(portal) {
        if (!portal) {
            throw new Error('DomPortalOutlet: no portal supplied');
        }
        if (this.hasAttached()) {
            throw new Error('DomPortalOutlet: portal already attached');
        }
        if (this.isDisposed) {
            throw new Error('DomPortalOutlet: portal outlet already disposed');
        }
        this.attachedPortal = portal;
        if ('component' in portal) {
            return this.attachComponentPortal(portal);
        }
        return this.attachTemplatePortal(portal);
    }
    attachTemplatePortal(portal) {
        const viewContainer = portal.viewContainerRef;
        const viewRef = viewContainer.createEmbeddedView(portal.templateRef);
        viewRef.detectChanges();
        viewRef.rootNodes.forEach(rootNode => this.outletElement.appendChild(rootNode));
        this.setDisposeFn(() => {
            const index = viewContainer.indexOf(viewRef);
            if (index !== -1) {
                viewContainer.remove(index);
            }
        });
        return viewRef;
    }
    attachComponentPortal(portal) {
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        let componentRef;
        if (portal.viewContainerRef) {
            componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.injector);
            this.setDisposeFn(() => componentRef.destroy());
        }
        else {
            componentRef = componentFactory.create(portal.injector || this._injector);
            this._appRef.attachView(componentRef.hostView);
            this.setDisposeFn(() => {
                this._appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            });
        }
        this.outletElement.appendChild(this._getComponentRootNode(componentRef));
        return componentRef;
    }
    detach() {
        this.attachedPortal = null;
        this.invokeDisposeFn();
    }
    dispose() {
        if (this.hasAttached()) {
            this.detach();
        }
        this.invokeDisposeFn();
        this.isDisposed = true;
    }
    setDisposeFn(fn) {
        this.disposeFn = fn;
    }
    invokeDisposeFn() {
        if (this.disposeFn) {
            this.disposeFn();
            this.disposeFn = null;
        }
    }
    _getComponentRootNode(componentRef) {
        return componentRef.hostView
            .rootNodes[0];
    }
}

class ScrollStrategy {
    constructor(ngZone, dispatcher) {
        this.ngZone = ngZone;
        this.dispatcher = dispatcher;
        this.scrollSubscription = Subscription.EMPTY;
        this.onParentScroll = this.onParentScroll.bind(this);
    }
    attach(overlayRef) {
        this.overlayRef = overlayRef;
    }
    detach() {
        this.disable();
        this.overlayRef = undefined;
    }
    enable() {
        this.dispatcher.register(this.overlayRef);
        this.scrollSubscription = this.dispatcher.scrolled.subscribe(this.onParentScroll);
        this.updatePosition();
    }
    disable() {
        this.dispatcher.deregister(this.overlayRef);
        this.scrollSubscription.unsubscribe();
    }
    updatePosition() {
        this.overlayRef.updatePosition();
    }
}

class CloseScrollStrategy extends ScrollStrategy {
    onParentScroll() {
        this.ngZone.run(() => this.overlayRef.detach());
    }
}

class RepositionScrollStrategy extends ScrollStrategy {
    onParentScroll() {
        this.ngZone.runOutsideAngular(() => {
            this.updatePosition();
        });
    }
}

function isScrollable(element) {
    return ((element && element.scrollHeight > element.clientHeight) ||
        element.scrollWidth > element.clientWidth);
}
/**
 * Finds scrollable parent of an element at the current moment.
 */
function findScrollableParents(element) {
    const scrollableParents = [];
    const findScrollableParentInner = (el) => {
        if (el) {
            if (isScrollable(el)) {
                scrollableParents.push(el);
            }
            return findScrollableParentInner(el.parentElement);
        }
    };
    findScrollableParentInner(element);
    return scrollableParents;
}
class ScrollDispatcher {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.overlays = new Map();
        this._scrolled = new Subject();
        this.listenersCountByElement = new Map();
        this.onScroll = this.onScroll.bind(this);
        this.ngZone.runOutsideAngular(() => window.addEventListener('scroll', this.onScroll));
    }
    get scrolled() {
        return this._scrolled.asObservable();
    }
    ngOnDestroy() {
        this.listenersCountByElement.clear();
        this._scrolled.complete();
        this.ngZone.runOutsideAngular(() => window.removeEventListener('scroll', this.onScroll));
    }
    register(overlayRef) {
        const scrollableParents = findScrollableParents(overlayRef.anchorElement);
        this.overlays.set(overlayRef, scrollableParents);
        this.ngZone.runOutsideAngular(() => scrollableParents.forEach(el => this.addScrollListener(el)));
    }
    deregister(overlayRef) {
        if (this.overlays.has(overlayRef)) {
            const parents = this.overlays.get(overlayRef);
            this.ngZone.runOutsideAngular(() => parents.forEach(el => this.removeScrollListener(el)));
            this.overlays.delete(overlayRef);
        }
    }
    addScrollListener(el) {
        el.addEventListener('scroll', this.onScroll);
        const count = this.listenersCountByElement.has(el)
            ? this.listenersCountByElement.get(el)
            : 0;
        this.listenersCountByElement.set(el, count + 1);
    }
    removeScrollListener(el) {
        const count = this.listenersCountByElement.get(el);
        if (count > 0) {
            this.listenersCountByElement.set(el, count - 1);
            if (count === 1) {
                el.removeEventListener('scroll', this.onScroll);
            }
        }
    }
    onScroll() {
        this._scrolled.next();
    }
}
ScrollDispatcher.ɵfac = function ScrollDispatcher_Factory(t) { return new (t || ScrollDispatcher)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
ScrollDispatcher.ɵprov = i0.ɵɵdefineInjectable({ factory: function ScrollDispatcher_Factory() { return new ScrollDispatcher(i0.ɵɵinject(i0.NgZone)); }, token: ScrollDispatcher, providedIn: "root" });
ScrollDispatcher.ctorParameters = () => [
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollDispatcher, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();

class ScrollStrategies {
    constructor(ngZone, scrollDispatcher) {
        this.ngZone = ngZone;
        this.scrollDispatcher = scrollDispatcher;
    }
    close() {
        return new CloseScrollStrategy(this.ngZone, this.scrollDispatcher);
    }
    reposition() {
        return new RepositionScrollStrategy(this.ngZone, this.scrollDispatcher);
    }
    fromString(strategyName) {
        if (strategyName === 'reposition') {
            return this.reposition();
        }
        return this.close();
    }
}
ScrollStrategies.ɵfac = function ScrollStrategies_Factory(t) { return new (t || ScrollStrategies)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ScrollDispatcher)); };
ScrollStrategies.ɵprov = i0.ɵɵdefineInjectable({ factory: function ScrollStrategies_Factory() { return new ScrollStrategies(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(ScrollDispatcher)); }, token: ScrollStrategies, providedIn: "root" });
ScrollStrategies.ctorParameters = () => [
    { type: NgZone },
    { type: ScrollDispatcher }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollStrategies, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ScrollDispatcher }]; }, null); })();

// next unique id for overlay
let nextUniqueId = 0;
function normalizeConfig(configOrBackdrop) {
    if (configOrBackdrop == null || typeof configOrBackdrop === 'number') {
        return { backdrop: configOrBackdrop };
    }
    return configOrBackdrop;
}
/**
 * Service for creating overlays.
 */
/** @dynamic */
class OverlayService {
    constructor(scrollStrategies, positionStrategyBuilder, _componentFactoryResolver, document, overlayContainer, ngZone, _appRef, _injector) {
        this.scrollStrategies = scrollStrategies;
        this.positionStrategyBuilder = positionStrategyBuilder;
        this._componentFactoryResolver = _componentFactoryResolver;
        this.document = document;
        this.overlayContainer = overlayContainer;
        this.ngZone = ngZone;
        this._appRef = _appRef;
        this._injector = _injector;
    }
    create(positionStrategy, scrollStrategy, configOrBackdrop) {
        const config = normalizeConfig(configOrBackdrop);
        const host = this.createHostElement();
        const pane = this.createPaneElement(host, config);
        const portalOutlet = new DomPortalOutlet(pane, this._componentFactoryResolver, this._appRef, this._injector);
        return new OverlayRef(portalOutlet, host, pane, positionStrategy, scrollStrategy, this.ngZone, this.document, config);
    }
    position() {
        return this.positionStrategyBuilder;
    }
    createHostElement() {
        const host = this.document.createElement('div');
        this.overlayContainer.getContainerElement().appendChild(host);
        return host;
    }
    createPaneElement(host, config) {
        const pane = this.document.createElement('div');
        pane.id = `pmcc-overlay-${nextUniqueId++}`;
        pane.classList.add('pmcc-overlay-pane');
        if (config.panelClassName) {
            pane.classList.add(...coerceArray(config.panelClassName));
        }
        host.appendChild(pane);
        return pane;
    }
}
OverlayService.ɵfac = function OverlayService_Factory(t) { return new (t || OverlayService)(ɵngcc0.ɵɵinject(ScrollStrategies), ɵngcc0.ɵɵinject(PositionStrategyBuilderService), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(OverlayContainer), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
OverlayService.ɵprov = i0.ɵɵdefineInjectable({ factory: function OverlayService_Factory() { return new OverlayService(i0.ɵɵinject(ScrollStrategies), i0.ɵɵinject(PositionStrategyBuilderService), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(OverlayContainer), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.INJECTOR)); }, token: OverlayService, providedIn: "root" });
OverlayService.ctorParameters = () => [
    { type: ScrollStrategies },
    { type: PositionStrategyBuilderService },
    { type: ComponentFactoryResolver },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: OverlayContainer },
    { type: NgZone },
    { type: ApplicationRef },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ScrollStrategies }, { type: PositionStrategyBuilderService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: OverlayContainer }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();

/** @dynamic */
class OverlayDirective {
    constructor(templateRef, viewContainerRef, position, overlayService, ngZone, document) {
        this.position = position;
        this.overlayService = overlayService;
        this.ngZone = ngZone;
        this.document = document;
        this.closeOnClickOutside = true;
        this.closeOnClickBackdrop = false;
        this.backdrop = BackDrop.NONE;
        this.closeOutsideOn = 'click';
        this.pmccOverlayOpen = false;
        this.pmccOverlayScrollStrategy = 'reposition';
        this.pmccOverlayOpenChange = new EventEmitter();
        this.open = new EventEmitter();
        this.close = new EventEmitter();
        this.portal = {
            templateRef,
            viewContainerRef
        };
    }
    set pmccOverlayCloseOnClickOutside(value) {
        this.closeOnClickOutside = coerceBooleanProperty$1(value);
    }
    set pmccOverlayCloseOnClickBackdrop(value) {
        this.closeOnClickBackdrop = coerceBooleanProperty$1(value);
    }
    set pmccOverlayBackdrop(value) {
        this.backdrop = value;
    }
    set pmccOverlayCloseOutsideOn(eventName) {
        this.closeOutsideOn = eventName;
    }
    ngOnChanges(changes) {
        if ('pmccOverlayOpen' in changes) {
            this.updateVisibility();
        }
    }
    ngOnDestroy() {
        this.hide();
        this.disposeOverlay();
    }
    show() {
        const overlayRef = this.createOverlay();
        if (!overlayRef.attached) {
            overlayRef.attach(this.portal);
            this.setOpenAndEmit(true);
            this.attachClickOutsideListener();
            this.attachClickBackdropListener();
        }
    }
    hide() {
        this.detachBackdropClickListener();
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.disposeOverlay();
            this.setOpenAndEmit(false);
        }
        this.detachClickOutsideListener();
    }
    onOutsideClick(event) {
        if (!this.overlayRef || !this.pmccOverlayOpen) {
            return;
        }
        const clickTarget = event.target;
        const { anchorElement, overlayElement } = this.overlayRef;
        if (!overlayElement.contains(clickTarget)) {
            if (!anchorElement ||
                (clickTarget !== anchorElement && !anchorElement.contains(clickTarget))) {
                this.ngZone.run(() => this.hide());
            }
        }
    }
    updateVisibility() {
        if (this.pmccOverlayOpen) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    createOverlay() {
        if (!this.overlayRef) {
            this.overlayRef = this.overlayService.create(this.createPositionStrategy(), this.createScrollStrategy(), this.backdrop);
            if (this.pmccOverlayScrollStrategy === 'close') {
                this.overlayRef.detachments.subscribe(() => {
                    this.hide();
                });
            }
        }
        return this.overlayRef;
    }
    createPositionStrategy() {
        return this.position.build();
    }
    createScrollStrategy() {
        return this.overlayService.scrollStrategies.fromString(this.pmccOverlayScrollStrategy);
    }
    disposeOverlay() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = undefined;
        }
    }
    setOpenAndEmit(open) {
        this.pmccOverlayOpen = open;
        this.pmccOverlayOpenChange.emit(this.pmccOverlayOpen);
        if (open) {
            this.open.emit();
        }
        else {
            this.close.emit();
        }
    }
    attachClickOutsideListener() {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                if (this.closeOnClickOutside) {
                    this.documentClickListener = e => this.onOutsideClick(e);
                    this.document.addEventListener(this.closeOutsideOn, this.documentClickListener, true // use capture event
                    );
                }
            });
        });
    }
    attachClickBackdropListener() {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                if (this.closeOnClickBackdrop) {
                    this.backdropClickListener = e => this.onOutsideClick(e);
                    this.document.querySelector('.pmcc-overlay-backdrop')
                        .addEventListener(this.closeOutsideOn, this.backdropClickListener, true // use capture event
                    );
                }
            });
        });
    }
    detachClickOutsideListener() {
        if (this.documentClickListener) {
            this.document.removeEventListener(this.closeOutsideOn, this.documentClickListener);
        }
    }
    detachBackdropClickListener() {
        var _a;
        if (this.backdropClickListener) {
            (_a = this.document.querySelector('.pmcc-overlay-backdrop')) === null || _a === void 0 ? void 0 : _a.removeEventListener(this.closeOutsideOn, this.backdropClickListener);
        }
    }
}
OverlayDirective.ɵfac = function OverlayDirective_Factory(t) { return new (t || OverlayDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(POSITION, 1), ɵngcc0.ɵɵdirectiveInject(OverlayService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
OverlayDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OverlayDirective, selectors: [["", "pmccOverlay", ""]], inputs: { pmccOverlayOpen: "pmccOverlayOpen", pmccOverlayScrollStrategy: "pmccOverlayScrollStrategy", pmccOverlayCloseOnClickOutside: "pmccOverlayCloseOnClickOutside", pmccOverlayCloseOnClickBackdrop: "pmccOverlayCloseOnClickBackdrop", pmccOverlayBackdrop: "pmccOverlayBackdrop", pmccOverlayCloseOutsideOn: "pmccOverlayCloseOutsideOn" }, outputs: { pmccOverlayOpenChange: "pmccOverlayOpenChange", open: "open", close: "close" }, exportAs: ["pmccOverlay"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
OverlayDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [POSITION,] }] },
    { type: OverlayService },
    { type: NgZone },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
OverlayDirective.propDecorators = {
    pmccOverlayOpen: [{ type: Input }],
    pmccOverlayScrollStrategy: [{ type: Input }],
    pmccOverlayCloseOnClickOutside: [{ type: Input }],
    pmccOverlayCloseOnClickBackdrop: [{ type: Input }],
    pmccOverlayBackdrop: [{ type: Input }],
    pmccOverlayCloseOutsideOn: [{ type: Input }],
    pmccOverlayOpenChange: [{ type: Output }],
    open: [{ type: Output }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayDirective, [{
        type: Directive,
        args: [{ selector: '[pmccOverlay]', exportAs: 'pmccOverlay' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [POSITION]
            }] }, { type: OverlayService }, { type: ɵngcc0.NgZone }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { pmccOverlayOpen: [{
            type: Input
        }], pmccOverlayScrollStrategy: [{
            type: Input
        }], pmccOverlayOpenChange: [{
            type: Output
        }], open: [{
            type: Output
        }], close: [{
            type: Output
        }], pmccOverlayCloseOnClickOutside: [{
            type: Input
        }], pmccOverlayCloseOnClickBackdrop: [{
            type: Input
        }], pmccOverlayBackdrop: [{
            type: Input
        }], pmccOverlayCloseOutsideOn: [{
            type: Input
        }] }); })();

class LayoutModule {
}
LayoutModule.ɵfac = function LayoutModule_Factory(t) { return new (t || LayoutModule)(); };
LayoutModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [LayoutService, OverlayService, OverlayContainer], imports: [[CommonModule, ObserversModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ObserversModule],
                providers: [LayoutService, OverlayService, OverlayContainer],
                declarations: [
                    OverlayDirective,
                    NearPositionDirective,
                    AdjacentPositionDirective,
                    ScreenCenterPositionDirective,
                    ScreenRightPositionDirective,
                    ScreenLeftPositionDirective,
                ],
                exports: [
                    OverlayDirective,
                    NearPositionDirective,
                    AdjacentPositionDirective,
                    ScreenCenterPositionDirective,
                    ScreenRightPositionDirective,
                    ScreenLeftPositionDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutModule, { declarations: function () { return [OverlayDirective, NearPositionDirective, AdjacentPositionDirective, ScreenCenterPositionDirective, ScreenRightPositionDirective, ScreenLeftPositionDirective]; }, imports: function () { return [CommonModule, ObserversModule]; }, exports: function () { return [OverlayDirective, NearPositionDirective, AdjacentPositionDirective, ScreenCenterPositionDirective, ScreenRightPositionDirective, ScreenLeftPositionDirective]; } }); })();

const ARROW_OFFSET_Y = 10;
const ARROW_OFFSET_X = 25;
const compassPositions = [
    {
        originPos: { originX: 'center', originY: 'bottom' },
        overlayPos: { overlayX: 'center', overlayY: 'top' },
        offsetY: ARROW_OFFSET_Y,
        panelClassName: 'southcentral'
    },
    {
        originPos: { originX: 'start', originY: 'bottom' },
        overlayPos: { overlayX: 'start', overlayY: 'top' },
        offsetY: ARROW_OFFSET_Y,
        offsetX: -ARROW_OFFSET_X,
        panelClassName: 'southwest'
    },
    {
        originPos: { originX: 'end', originY: 'bottom' },
        overlayPos: { overlayX: 'end', overlayY: 'top' },
        offsetY: ARROW_OFFSET_Y,
        offsetX: ARROW_OFFSET_X,
        panelClassName: 'southeast'
    },
    {
        originPos: { originX: 'center', originY: 'top' },
        overlayPos: { overlayX: 'center', overlayY: 'bottom' },
        offsetY: -ARROW_OFFSET_Y,
        panelClassName: 'northcentral'
    },
    {
        originPos: { originX: 'start', originY: 'top' },
        overlayPos: { overlayX: 'start', overlayY: 'bottom' },
        offsetY: -ARROW_OFFSET_Y,
        offsetX: -ARROW_OFFSET_X,
        panelClassName: 'northwest'
    },
    {
        originPos: { originX: 'end', originY: 'top' },
        overlayPos: { overlayX: 'end', overlayY: 'bottom' },
        offsetY: -ARROW_OFFSET_Y,
        offsetX: ARROW_OFFSET_X,
        panelClassName: 'northeast'
    }
];

/**
 * Demo example
 * <example-url>/demo/#/pmcc/markdown-service</example-url>
 */
class MarkdownService {
    constructor() {
        this.formulaDictionary = [
            {
                key: '\\*',
                value: '<pmcc-md-multiply />',
            },
            {
                key: '([^<])\\/([^>]\)',
                value: '$1<pmcc-md-divide />$2',
            },
            {
                key: '\\+',
                value: '<pmcc-md-add />',
            },
            {
                key: '\\s-\\s',
                value: '<pmcc-md-subtract />',
            },
            {
                key: '=',
                value: '<pmcc-md-equals />',
            },
            // Pairs
            {
                key: '\\$\\$(.*?)\\$\\$',
                value: '<pmcc-md-formula>$1</pmcc-md-formula>',
            },
            {
                key: '\\((.*?)\\)',
                value: '<pmcc-md-group>$1</pmcc-md-group>',
            },
        ];
    }
    parseMarkdown(content) {
        return this._translateIntoHTML(this._parseParagraphs(this._parseFormulas(this._maskFormulas(content))));
    }
    _maskFormulas(content) {
        const matches = content.match(/\${2}(.*?)\${2}/gim);
        if (matches && matches.length) {
            return Array.from(matches).reduce((acc, text, i) => {
                const token = 'pmcc[' + (new Date()).getTime() + '-' + i + ']';
                acc.content = acc.content.replace(text, token);
                acc.formulaQueue.push({ token, text });
                return acc;
            }, { content, formulaQueue: [] });
        }
        return { content, formulaQueue: [] };
    }
    _parseFormulas({ content, formulaQueue }) {
        if (formulaQueue.length) {
            return formulaQueue.reduceRight((newContent, currentFormulaQueue) => {
                return newContent.replace(currentFormulaQueue.token, this._parseFormula(currentFormulaQueue.text));
            }, content);
        }
        return content;
    }
    _parseFormula(content) {
        return this.formulaDictionary.reduceRight((newContent, formula) => {
            return newContent.replace(new RegExp(formula.key, 'gim'), formula.value);
        }, content);
    }
    _parseParagraphs(content) {
        return content.replace(new RegExp('\\n(.*?)\\n\\n', 'gim'), '<pmcc-md-paragraph>$1</pmcc-md-paragraph>');
    }
    _translateIntoHTML(content) {
        const rules = {
            '<pmcc-md-multiply />': '<span class="pmcc-md pmcc-md-multiply"></span>',
            '<pmcc-md-add />': '<span class="pmcc-md pmcc-md-add"></span>',
            '<pmcc-md-equals />': '<span class="pmcc-md pmcc-md-equals"></span>',
            '<pmcc-md-divide />': '<span class="pmcc-md pmcc-md-divide"></span>',
            '<pmcc-md-subtract />': '<span class="pmcc-md pmcc-md-subtract"></span>',
            '<pmcc-md-group>': '<span class="pmcc-md-group">',
            '<pmcc-md-formula>': '<span class="pmcc-md-formula">',
            '<pmcc-md-paragraph>': '<span class="pmcc-md-paragraph">',
            '</pmcc-md-group>': '</span>',
            '</pmcc-md-formula>': '</span>',
            '</pmcc-md-paragraph>': '</span>',
        };
        return Object.keys(rules).reduce((newContent, tag) => {
            return newContent.replace(new RegExp(tag, 'gim'), rules[tag]);
        }, content);
    }
}
MarkdownService.ɵfac = function MarkdownService_Factory(t) { return new (t || MarkdownService)(); };
MarkdownService.ɵprov = i0.ɵɵdefineInjectable({ factory: function MarkdownService_Factory() { return new MarkdownService(); }, token: MarkdownService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkdownService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PopupDirective {
    constructor(_el, _overlayService) {
        this._el = _el;
        this._overlayService = _overlayService;
    }
    createOverlay(positionStrategy, scrollStrategy) {
        if (this.overlayRef) {
            return this.overlayRef;
        }
        if (!positionStrategy) {
            throw new Error('PositionStrategy is not defined');
        }
        if (!scrollStrategy) {
            throw new Error('ScrollStrategy is not defined');
        }
        this.overlayRef = this._overlayService.create(positionStrategy, scrollStrategy, this.overlayConfig());
        return this.overlayRef;
    }
    ngOnDestroy() {
        this.hide();
        this.disposeOverlay();
    }
    disposeOverlay() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = undefined;
        }
    }
    overlayConfig() {
        return { backdrop: BackDrop.NONE };
    }
}
PopupDirective.ɵfac = function PopupDirective_Factory(t) { return new (t || PopupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(OverlayService)); };
PopupDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PopupDirective });
PopupDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: OverlayService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopupDirective, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: OverlayService }]; }, null); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/tooltip</example-url>
 */
class TooltipComponent {
    constructor(elRef) {
        this.elRef = elRef;
    }
    get dataPmId() {
        return this.elRef.nativeElement.getAttribute('data-pm-id');
    }
}
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["pmcc-tooltip"]], hostVars: 4, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-tooltip-layer", true)("arrow-box", true);
    } }, inputs: { content: "content" }, decls: 1, vars: 2, consts: [[3, "innerHTML"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "p", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHTML", ctx.content, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵattribute("data-pm-id", (ctx.dataPmId || "tooltip") + "-content");
    } }, encapsulation: 2 });
TooltipComponent.ctorParameters = () => [
    { type: ElementRef }
];
TooltipComponent.propDecorators = {
    content: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-tooltip',
                template: "<p\n  [innerHTML]=\"content\"\n  [attr.data-pm-id]=\"(dataPmId || 'tooltip') + '-content'\"\n></p>\n",
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-tooltip-layer]': 'true',
                    '[class.arrow-box]': 'true'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { content: [{
            type: Input
        }] }); })();

const tooltipRevealDelay = 400;
function isTextOverflown(el) {
    const elementContainer = el.parentElement;
    const textElement = el.children[0];
    return (!!elementContainer &&
        !!textElement &&
        el.clientWidth < textElement.offsetWidth);
}
/**
 * Demo example
 * <example-url>/demo/#/pmcc/tooltip</example-url>
 */
class TooltipDirective extends PopupDirective {
    constructor(el, overlayService, viewContainerRef, _markdownService) {
        super(el, overlayService);
        this._markdownService = _markdownService;
        this.mouseEventsSubscription = Subscription.EMPTY;
        /**
         * Tooltip displayed strategy.
         * When set to 'when-needed', the tooltip will be displayed when
         * the target element's text is overflown.
         * When set to 'always', the tooltip will be shown regardless of any overflows.
         */
        this.pmccTooltipDisplay = 'always';
        this.portal = {
            component: TooltipComponent,
            viewContainerRef: viewContainerRef
        };
        this.positionStrategy = overlayService
            .position()
            .connectedTo(this._el.nativeElement)
            .withPositions(compassPositions);
        this.scrollStrategy = overlayService.scrollStrategies.reposition();
    }
    ngAfterViewInit() {
        // hide the popover on mouseleave
        const mouseleave$ = fromEvent(this._el.nativeElement, 'mouseleave').pipe(tap(() => this.hide()));
        // when mouse enters the trigger:
        //   1. wait tooltipRevealDelay
        //   2. show the tooltip
        //   3. cancel if mouseleave emits before tooltipRevealDelay passes
        const mouseenter$ = fromEvent(this._el.nativeElement, 'mouseenter').pipe(switchMapTo(timer(tooltipRevealDelay).pipe(takeUntil(mouseleave$))), tap(() => this.show()));
        this.mouseEventsSubscription = merge(mouseleave$, mouseenter$).subscribe();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.mouseEventsSubscription.unsubscribe();
    }
    /**
     * Shows the tooltip.
     * Note that the tooltip won't be shown if the message is empty.
     */
    show() {
        const display = this.pmccTooltipDisplay;
        const shouldShow = display === 'always' || isTextOverflown(this._el.nativeElement);
        if (this.message && shouldShow) {
            this._show();
        }
    }
    /**
     * Hides the tooltip.
     */
    hide() {
        if (this.overlayRef) {
            this.overlayRef.detach();
        }
    }
    _show() {
        const { instance, changeDetectorRef, location } = this.createOverlay(this.positionStrategy, this.scrollStrategy).attach(this.portal);
        const dataPmId = this._el.nativeElement.getAttribute('data-pm-id');
        location.nativeElement.setAttribute('data-pm-id', dataPmId ? `${dataPmId}-tooltip` : 'tooltip');
        instance.content = this._markdownService.parseMarkdown(`${this.message}`);
        changeDetectorRef.detectChanges();
        this.overlayRef.updatePosition();
    }
}
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(OverlayService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(MarkdownService)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "pmccTooltip", ""]], inputs: { pmccTooltipDisplay: "pmccTooltipDisplay", message: ["pmccTooltip", "message"] }, exportAs: ["pmccTooltip"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TooltipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: OverlayService },
    { type: ViewContainerRef },
    { type: MarkdownService }
];
TooltipDirective.propDecorators = {
    message: [{ type: Input, args: ['pmccTooltip',] }],
    pmccTooltipDisplay: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccTooltip]',
                exportAs: 'pmccTooltip'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: OverlayService }, { type: ɵngcc0.ViewContainerRef }, { type: MarkdownService }]; }, { pmccTooltipDisplay: [{
            type: Input
        }], message: [{
            type: Input,
            args: ['pmccTooltip']
        }] }); })();

class TooltipModule {
}
TooltipModule.ɵfac = function TooltipModule_Factory(t) { return new (t || TooltipModule)(); };
TooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [TooltipDirective, TooltipComponent],
                imports: [CommonModule],
                exports: [TooltipDirective, TooltipComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipModule, { declarations: function () { return [TooltipDirective, TooltipComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TooltipDirective, TooltipComponent]; } }); })();

class ServicesMenuModule {
}
ServicesMenuModule.ɵfac = function ServicesMenuModule_Factory(t) { return new (t || ServicesMenuModule)(); };
ServicesMenuModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ServicesMenuModule });
ServicesMenuModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LayoutModule,
            TooltipModule,
            IconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServicesMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [ServicesMenuInlineComponent],
                imports: [
                    CommonModule,
                    LayoutModule,
                    TooltipModule,
                    IconModule,
                ],
                exports: [ServicesMenuInlineComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ServicesMenuModule, { declarations: function () { return [ServicesMenuInlineComponent]; }, imports: function () { return [CommonModule, LayoutModule, TooltipModule, IconModule]; }, exports: function () { return [ServicesMenuInlineComponent]; } }); })();

var ButtonState;
(function (ButtonState) {
    ButtonState[ButtonState["Normal"] = 0] = "Normal";
    ButtonState[ButtonState["Active"] = 1] = "Active";
    ButtonState[ButtonState["Disabled"] = 2] = "Disabled";
})(ButtonState || (ButtonState = {}));
class ButtonDirective {
    constructor() {
        this.pmccSize = 'sm';
        this.pmccVariant = 'primary';
        this.type = 'button';
    }
    ngOnChanges(changes) {
        if ('disabled' in changes || 'active' in changes) {
            this.updateButtonState();
        }
    }
    updateButtonState() {
        const disabled = coerceBooleanProperty$1(this.disabled);
        const active = coerceBooleanProperty$1(this.active);
        if (disabled) {
            this.state = ButtonState.Disabled;
        }
        else if (active) {
            this.state = ButtonState.Active;
        }
        else {
            this.state = ButtonState.Normal;
        }
    }
}
ButtonDirective.ɵfac = function ButtonDirective_Factory(t) { return new (t || ButtonDirective)(); };
ButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ButtonDirective, selectors: [["button", "pmccButton", ""]], hostVars: 20, hostBindings: function ButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.state === 2);
        ɵngcc0.ɵɵattribute("type", ctx.type);
        ɵngcc0.ɵɵclassProp("pmcc-btn-sm", ctx.pmccSize === "sm")("pmcc-btn-md", ctx.pmccSize === "md")("pmcc-btn-lg", ctx.pmccSize === "lg")("pmcc-primary", ctx.pmccVariant === "primary")("pmcc-secondary", ctx.pmccVariant === "secondary")("pmcc-action-green", ctx.pmccVariant === "action-green")("pmcc-action-red", ctx.pmccVariant === "action-red")("active", ctx.state === 1)("disabled", ctx.state === 2);
    } }, inputs: { pmccSize: "pmccSize", pmccVariant: "pmccVariant", type: "type", disabled: "disabled", active: "active" }, exportAs: ["pmccButton"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ButtonDirective.propDecorators = {
    pmccSize: [{ type: Input }],
    pmccVariant: [{ type: Input }],
    disabled: [{ type: Input }],
    active: [{ type: Input }],
    type: [{ type: Input }, { type: HostBinding, args: ['attr.type',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'button[pmccButton]',
                exportAs: 'pmccButton',
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-btn-sm]': 'pmccSize === "sm"',
                    '[class.pmcc-btn-md]': 'pmccSize === "md"',
                    '[class.pmcc-btn-lg]': 'pmccSize === "lg"',
                    '[class.pmcc-primary]': 'pmccVariant === "primary"',
                    '[class.pmcc-secondary]': 'pmccVariant === "secondary"',
                    '[class.pmcc-action-green]': 'pmccVariant === "action-green"',
                    '[class.pmcc-action-red]': 'pmccVariant === "action-red"',
                    '[class.active]': `state === 1`,
                    '[class.disabled]': `state === 2`,
                    '[disabled]': `state === 2`
                }
            }]
    }], function () { return []; }, { pmccSize: [{
            type: Input
        }], pmccVariant: [{
            type: Input
        }], type: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.type']
        }], disabled: [{
            type: Input
        }], active: [{
            type: Input
        }] }); })();

class ButtonModule {
}
ButtonModule.ɵfac = function ButtonModule_Factory(t) { return new (t || ButtonModule)(); };
ButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [ButtonDirective],
                imports: [CommonModule],
                exports: [ButtonDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: function () { return [ButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ButtonDirective]; } }); })();

class BtnMenuModule {
}
BtnMenuModule.ɵfac = function BtnMenuModule_Factory(t) { return new (t || BtnMenuModule)(); };
BtnMenuModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BtnMenuModule });
BtnMenuModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LayoutModule,
            ServicesMenuModule,
            IconModule,
            ButtonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [BtnMenuComponent],
                imports: [
                    CommonModule,
                    LayoutModule,
                    ServicesMenuModule,
                    IconModule,
                    ButtonModule
                ],
                exports: [BtnMenuComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BtnMenuModule, { declarations: function () { return [BtnMenuComponent]; }, imports: function () { return [CommonModule, LayoutModule, ServicesMenuModule, IconModule, ButtonModule]; }, exports: function () { return [BtnMenuComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/btn-split</example-url>
 */
class BtnSplitComponent extends BtnMenuComponent {
}
BtnSplitComponent.ɵfac = /*@__PURE__*/ function () { let ɵBtnSplitComponent_BaseFactory; return function BtnSplitComponent_Factory(t) { return (ɵBtnSplitComponent_BaseFactory || (ɵBtnSplitComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BtnSplitComponent)))(t || BtnSplitComponent); }; }();
BtnSplitComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BtnSplitComponent, selectors: [["pmcc-btn-split"]], inputs: { action: "action" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 6, vars: 13, consts: [["pmccButton", "", 1, "pmcc-btn-split-primary-action", 3, "pmccSize", "pmccVariant", "ngClass", "disabled", "click"], ["pmccButton", "", 1, "pmcc-btn-split-menu-trigger", 3, "pmccSize", "pmccVariant", "ngClass", "disabled", "mousedown", "focus", "blur"], ["control", ""], ["name", "caret-down", "data-pm-id", "btn-split-icon"], ["pmccOverlay", "", "pmccOverlayCloseOutsideOn", "mousedown", 3, "pmccPositionAdjacent", "layerAdjacentOptions", "pmccOverlayOpen", "pmccOverlayScrollStrategy", "pmccOverlayOpenChange"], ["data-pm-id", "btn-split-panel", 1, "btn-split-menu", 3, "model", "items", "alignRight", "controlElement", "width", "height", "modelChange", "hide"]], template: function BtnSplitComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BtnSplitComponent_Template_button_click_0_listener() { return ctx.action ? ctx.action() : null; });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "button", 1, 2);
        ɵngcc0.ɵɵlistener("mousedown", function BtnSplitComponent_Template_button_mousedown_2_listener($event) { return ctx.onFocus($event); })("focus", function BtnSplitComponent_Template_button_focus_2_listener($event) { return ctx.onFocus($event); })("blur", function BtnSplitComponent_Template_button_blur_2_listener() { return ctx.hide(); });
        ɵngcc0.ɵɵelement(4, "pmcc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BtnSplitComponent_ng_template_5_Template, 1, 6, "ng-template", 4);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function BtnSplitComponent_Template_ng_template_pmccOverlayOpenChange_5_listener($event) { return ctx.active = $event; });
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("pmccSize", ctx.pmccSize)("pmccVariant", ctx.pmccVariant)("ngClass", ctx.cssClass)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccSize", ctx.pmccSize)("pmccVariant", ctx.pmccVariant)("ngClass", ctx.cssClass)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("pmccPositionAdjacent", _r0)("layerAdjacentOptions", ɵngcc0.ɵɵpureFunction0(12, _c5))("pmccOverlayOpen", ctx.active)("pmccOverlayScrollStrategy", ctx.scrollStrategy);
    } }, directives: [ButtonDirective, ɵngcc1.NgClass, IconComponent, OverlayDirective, AdjacentPositionDirective, ServicesMenuInlineComponent], styles: ["[_nghost-%COMP%]   button[_ngcontent-%COMP%]{font-size:12px;line-height:15px;min-height:23px;padding:3px 8px}[_nghost-%COMP%]   button.pmcc-btn-md[_ngcontent-%COMP%]{font-size:12px;line-height:15px;min-height:27px;padding:5px 10px}[_nghost-%COMP%]   button.pmcc-btn-lg[_ngcontent-%COMP%]{font-size:13px;line-height:16px;min-height:37px;padding:9.5px 15px}[_nghost-%COMP%]{display:inline-block;white-space:nowrap}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:0}[_nghost-%COMP%]   .pmcc-btn-split-primary-action[_ngcontent-%COMP%]{border-bottom-right-radius:0;border-top-right-radius:0;border-right:none;margin-right:0}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-top-left-radius:0;margin-left:0}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger[_ngcontent-%COMP%]:hover{box-shadow:none}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger[_ngcontent-%COMP%]   pmcc-icon[_ngcontent-%COMP%], [_nghost-%COMP%]   .pmcc-btn-split-menu-trigger[_ngcontent-%COMP%]   pmcc-icon[_ngcontent-%COMP%]:before{width:auto;height:12px;font-size:11px}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger.pmcc-btn-lg[_ngcontent-%COMP%]   pmcc-icon[_ngcontent-%COMP%]:before{font-size:12px}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger.pmcc-primary[_ngcontent-%COMP%]{border-left-color:#fff}[_nghost-%COMP%]   .pmcc-btn-split-menu-trigger.pmcc-secondary[_ngcontent-%COMP%]{border-left-color:#efefef}"] });
BtnSplitComponent.propDecorators = {
    action: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnSplitComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-btn-split',
                template: "<!-- TODO: [ngClass]=\"cssClass\" attrbute is replaced with pmccSize and pmccVariant and can be removed in next major version release -->\n<button\n  pmccButton\n  [pmccSize]=\"pmccSize\"\n  [pmccVariant]=\"pmccVariant\"\n  [ngClass]=\"cssClass\"\n  class=\"pmcc-btn-split-primary-action\"\n  (click)=\"action ? action() : null\"\n  [disabled]=\"disabled\"\n>\n  <ng-content></ng-content>\n</button>\n\n<button\n  #control\n  pmccButton\n  [pmccSize]=\"pmccSize\"\n  [pmccVariant]=\"pmccVariant\"\n  [ngClass]=\"cssClass\"\n  class=\"pmcc-btn-split-menu-trigger\"\n  [disabled]=\"disabled\"\n  (mousedown)=\"onFocus($event)\"\n  (focus)=\"onFocus($event)\"\n  (blur)=\"hide()\"\n>\n  <pmcc-icon name=\"caret-down\" data-pm-id=\"btn-split-icon\"></pmcc-icon>\n</button>\n\n<ng-template\n  pmccOverlay\n  [pmccPositionAdjacent]=\"control\"\n  [layerAdjacentOptions]=\"{\n    elementAnchor: 'southeast',\n    layerAnchor: 'northeast'\n  }\"\n  [(pmccOverlayOpen)]=\"active\"\n  pmccOverlayCloseOutsideOn=\"mousedown\"\n  [pmccOverlayScrollStrategy]=\"scrollStrategy\"\n>\n  <pmcc-services-menu-inline\n    class=\"btn-split-menu\"\n    [model]=\"model\"\n    [items]=\"options\"\n    [alignRight]=\"subMenuOnLeft\"\n    [controlElement]=\"control\"\n    [width]=\"serviceMenuWidth\"\n    [height]=\"serviceMenuHeight\"\n    (modelChange)=\"modelChange.emit($event)\"\n    (hide)=\"hide()\"\n    data-pm-id=\"btn-split-panel\"\n  ></pmcc-services-menu-inline>\n</ng-template>\n",
                styles: [":host button{font-size:12px;line-height:15px;min-height:23px;padding:3px 8px}:host button.pmcc-btn-md{font-size:12px;line-height:15px;min-height:27px;padding:5px 10px}:host button.pmcc-btn-lg{font-size:13px;line-height:16px;min-height:37px;padding:9.5px 15px}:host{display:inline-block;white-space:nowrap}:host button:focus{outline:none}:host button+button{margin-left:0}:host .pmcc-btn-split-primary-action{border-bottom-right-radius:0;border-top-right-radius:0;border-right:none;margin-right:0}:host .pmcc-btn-split-menu-trigger{border-bottom-left-radius:0;border-top-left-radius:0;margin-left:0}:host .pmcc-btn-split-menu-trigger:hover{box-shadow:none}:host .pmcc-btn-split-menu-trigger pmcc-icon,:host .pmcc-btn-split-menu-trigger pmcc-icon:before{width:auto;height:12px;font-size:11px}:host .pmcc-btn-split-menu-trigger.pmcc-btn-lg pmcc-icon:before{font-size:12px}:host .pmcc-btn-split-menu-trigger.pmcc-primary{border-left-color:#fff}:host .pmcc-btn-split-menu-trigger.pmcc-secondary{border-left-color:#efefef}"]
            }]
    }], null, { action: [{
            type: Input
        }] }); })();

class BtnSplitModule {
}
BtnSplitModule.ɵfac = function BtnSplitModule_Factory(t) { return new (t || BtnSplitModule)(); };
BtnSplitModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BtnSplitModule });
BtnSplitModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LayoutModule,
            ServicesMenuModule,
            BtnMenuModule,
            IconModule,
            ButtonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BtnSplitModule, [{
        type: NgModule,
        args: [{
                declarations: [BtnSplitComponent],
                imports: [
                    CommonModule,
                    LayoutModule,
                    ServicesMenuModule,
                    BtnMenuModule,
                    IconModule,
                    ButtonModule
                ],
                exports: [BtnSplitComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BtnSplitModule, { declarations: function () { return [BtnSplitComponent]; }, imports: function () { return [CommonModule, LayoutModule, ServicesMenuModule, BtnMenuModule, IconModule, ButtonModule]; }, exports: function () { return [BtnSplitComponent]; } }); })();

var DropdownState;
(function (DropdownState) {
    DropdownState[DropdownState["Closed"] = 0] = "Closed";
    DropdownState[DropdownState["Focused"] = 1] = "Focused";
    DropdownState[DropdownState["Open"] = 2] = "Open";
})(DropdownState || (DropdownState = {}));
/**
 * Demo example
 * <example-url>/demo/#/pmcc/dropdown</example-url>
 */
class DropdownComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.state = DropdownState.Closed;
        this._disabled = false;
        this._textDropdown = false;
        this.backdrop = BackDrop.TRANSPARENT;
        this.width = 120;
        this.alignRight = false;
        this.maxWidth = 120;
        this.modelChange = new EventEmitter();
        this.sameModelSelect = new EventEmitter();
        this.change = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    get textDropdown() {
        return this._textDropdown;
    }
    set textDropdown(textDropdown) {
        this._textDropdown = coerceBooleanProperty$1(textDropdown);
    }
    get title() {
        return this.model ? this.model.label : '';
    }
    get active() {
        return this.state === DropdownState.Open;
    }
    get tabIndex() {
        return this._disabled ? '' : '0';
    }
    onFocus() {
        if (!this._disabled) {
            if (this.state === DropdownState.Closed) {
                this.state = DropdownState.Open;
            }
        }
    }
    onMouseDown() {
        if (this._disabled) {
            return;
        }
        if (this.state === DropdownState.Open) {
            this.state = DropdownState.Focused;
        }
        else {
            this.state = DropdownState.Open;
        }
    }
    onChange(option) {
        if (this.model !== option) {
            this.model = option;
            this.modelChange.emit(option);
            this.change.emit(option);
            this.onModelChange(option);
        }
        else {
            this.sameModelSelect.emit(option);
        }
        this.onTouched();
    }
    hide() {
        if (this.state === DropdownState.Open) {
            this.state = DropdownState.Closed;
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(obj) {
        this.model = obj;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["pmcc-dropdown"]], hostVars: 8, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function DropdownComponent_focus_HostBindingHandler() { return ctx.onFocus(); })("mousedown", function DropdownComponent_mousedown_HostBindingHandler() { return ctx.onMouseDown(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("title", ctx.title);
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabIndex);
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled)("pmcc-dropdown-text-dropdown", ctx.textDropdown)("active", ctx.active);
    } }, inputs: { width: "width", alignRight: "alignRight", maxWidth: "maxWidth", disabled: "disabled", textDropdown: "textDropdown", model: "model", options: "options", serviceMenuWidth: "serviceMenuWidth", serviceMenuHeight: "serviceMenuHeight", triggerTemplate: "triggerTemplate" }, outputs: { modelChange: "modelChange", sameModelSelect: "sameModelSelect", change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DropdownComponent)
            },
        ])], decls: 5, vars: 11, consts: [[1, "pmcc-dropdown-label-wrapper", 3, "ngStyle"], ["trigger", ""], [4, "ngIf", "ngIfElse"], ["name", "caret-down"], ["pmccOverlay", "", "pmccOverlayCloseOutsideOn", "mousedown", 3, "pmccPositionAdjacent", "pmccOverlayOpen", "pmccOverlayBackdrop", "layerAdjacentOptions", "close"], ["defaultDropdown", ""], [1, "pmcc-truncate", 3, "tabIndex"], [3, "ngClass"], ["type", "text", "readonly", "", "disabled", "", 3, "value", "tabIndex"], ["data-pm-id", "dropdown-item-panel", 3, "model", "items", "controlElement", "width", "height", "alignRight", "modelChange", "hide"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, DropdownComponent_ng_container_2_Template, 4, 2, "ng-container", 2);
        ɵngcc0.ɵɵelement(3, "pmcc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DropdownComponent_ng_template_4_Template, 1, 6, "ng-template", 4);
        ɵngcc0.ɵɵlistener("close", function DropdownComponent_Template_ng_template_close_4_listener() { return ctx.hide(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c10, ctx.textDropdown && !ctx.triggerTemplate ? ctx.maxWidth + "px" : "unset"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(!!ctx.triggerTemplate && ctx.textDropdown))("ngIfElse", ctx.triggerTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccPositionAdjacent", ctx.elRef)("pmccOverlayOpen", ctx.active)("pmccOverlayBackdrop", ctx.backdrop)("layerAdjacentOptions", ctx.alignRight ? ɵngcc0.ɵɵpureFunction0(9, _c5) : ɵngcc0.ɵɵpureFunction0(10, _c6));
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf, IconComponent, OverlayDirective, AdjacentPositionDirective, ɵngcc1.NgClass, ServicesMenuInlineComponent], styles: ["[_nghost-%COMP%]{display:inline-block;position:relative;font:normal 13px Arial,Helvetica,Calibri,sans-serif;border-radius:3px;border:1px solid #c9c9c9;background:#fff}.disabled[_nghost-%COMP%]{border:1px solid #c9c9c9;box-shadow:none;cursor:not-allowed;opacity:.5}.disabled[_nghost-%COMP%] > *[_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]:hover:not(.disabled):not(.pmcc-dropdown-text-dropdown){background:linear-gradient(180deg,#f5f5f5 0,#f0f0f0)}.pmcc-dropdown-text-dropdown[_nghost-%COMP%]{border:none;background:inherit}.pmcc-dropdown-text-dropdown[_nghost-%COMP%]   .pmcc-dropdown-label-wrapper[_ngcontent-%COMP%]{font:normal 13px Arial,Helvetica,Calibri,sans-serif;display:flex;align-items:center;position:relative;border:0;cursor:pointer;color:initial;text-overflow:ellipsis;min-width:25px}.pmcc-dropdown-text-dropdown[_nghost-%COMP%]   span[_ngcontent-%COMP%]{width:auto;font-weight:700}.pmcc-dropdown-text-dropdown[_nghost-%COMP%]   pmcc-icon[_ngcontent-%COMP%]{position:relative;right:unset;top:unset;height:auto;color:inherit;cursor:pointer;text-align:center;margin-left:3px}[_nghost-%COMP%]     input{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 20px 5px 5px;position:relative;border:0;cursor:pointer;width:120px;color:initial;background-color:initial;text-shadow:0 0 0 #212121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}[_nghost-%COMP%]     input.with-icon{padding-left:21px}[_nghost-%COMP%]     .icon{position:absolute;top:4px}[_nghost-%COMP%]     pmcc-icon{position:absolute;right:3px;top:6px;height:10px;color:#787878;cursor:pointer;text-align:center}[_nghost-%COMP%]     span[class*=\" pmcc-ico-\"], [_nghost-%COMP%]     span[class^=pmcc-ico-]{padding-left:5px;margin-right:5px}"] });
DropdownComponent.ctorParameters = () => [
    { type: ElementRef }
];
DropdownComponent.propDecorators = {
    model: [{ type: Input }],
    options: [{ type: Input }],
    width: [{ type: Input }],
    serviceMenuWidth: [{ type: Input }],
    serviceMenuHeight: [{ type: Input }],
    alignRight: [{ type: Input }],
    triggerTemplate: [{ type: Input }],
    maxWidth: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    textDropdown: [{ type: Input }, { type: HostBinding, args: ['class.pmcc-dropdown-text-dropdown',] }],
    modelChange: [{ type: Output }],
    sameModelSelect: [{ type: Output }],
    change: [{ type: Output }],
    title: [{ type: HostBinding, args: ['title',] }],
    active: [{ type: HostBinding, args: ['class.active',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onMouseDown: [{ type: HostListener, args: ['mousedown',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-dropdown',
                template: "<div\n  #trigger\n  class=\"pmcc-dropdown-label-wrapper\"\n  [ngStyle]=\"{ 'max-width': (textDropdown && !triggerTemplate) ? (maxWidth+'px'): 'unset' }\"\n>\n  <ng-container\n    *ngIf=\"!(!!triggerTemplate && textDropdown); else triggerTemplate\"\n  >\n    <ng-container *ngIf=\"textDropdown; else defaultDropdown\">\n      <span class=\"pmcc-truncate\" [tabIndex]=\"-1\">{{ model?.label }}</span>\n    </ng-container>\n    <ng-template #defaultDropdown>\n      <span [ngClass]=\"['icon', model?.icon || '']\"></span>\n      <input\n        type=\"text\"\n        [class.with-icon]=\"model?.icon\"\n        [value]=\"model?.label\"\n        [tabIndex]=\"-1\"\n        readonly\n        disabled\n        [style.width.px]=\"width\"\n      />\n    </ng-template>\n  </ng-container>\n  <pmcc-icon name=\"caret-down\"></pmcc-icon>\n</div>\n\n<!--\nTODO:\n  Replace the content above this comment with following in next major version\n  Note: This has corresponding changes in styles as well\n\n<pmcc-select-trigger\n  [icon]=\"model?.icon?.substr(9)\"\n  [label]=\"model?.label\"\n  [width]=\"width\"\n  [disabled]=\"disabled\"\n></pmcc-select-trigger>\n-->\n\n<ng-template\n  pmccOverlay\n  [pmccPositionAdjacent]=\"elRef\"\n  [pmccOverlayOpen]=\"active\"\n  [pmccOverlayBackdrop]=\"backdrop\"\n  [layerAdjacentOptions]=\"\n    alignRight\n      ? {\n          elementAnchor: 'southeast',\n          layerAnchor: 'northeast'\n        }\n      : {\n          elementAnchor: 'southwest',\n          layerAnchor: 'northwest'\n        }\n  \"\n  pmccOverlayCloseOutsideOn=\"mousedown\"\n  (close)=\"hide()\"\n>\n  <pmcc-services-menu-inline\n    [model]=\"model\"\n    [items]=\"options\"\n    [controlElement]=\"elRef.nativeElement\"\n    [width]=\"serviceMenuWidth\"\n    [height]=\"serviceMenuHeight\"\n    [alignRight]=\"alignRight\"\n    (modelChange)=\"onChange($event)\"\n    (hide)=\"hide()\"\n    data-pm-id=\"dropdown-item-panel\"\n  ></pmcc-services-menu-inline>\n</ng-template>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DropdownComponent)
                    },
                ],
                styles: [":host{display:inline-block;position:relative;font:normal 13px Arial,Helvetica,Calibri,sans-serif;border-radius:3px;border:1px solid #c9c9c9;background:#fff}:host.disabled{border:1px solid #c9c9c9;box-shadow:none;cursor:not-allowed;opacity:.5}:host.disabled>*{cursor:not-allowed}:host:hover:not(.disabled):not(.pmcc-dropdown-text-dropdown){background:linear-gradient(180deg,#f5f5f5 0,#f0f0f0)}:host.pmcc-dropdown-text-dropdown{border:none;background:inherit}:host.pmcc-dropdown-text-dropdown .pmcc-dropdown-label-wrapper{font:normal 13px Arial,Helvetica,Calibri,sans-serif;display:flex;align-items:center;position:relative;border:0;cursor:pointer;color:initial;text-overflow:ellipsis;min-width:25px}:host.pmcc-dropdown-text-dropdown span{width:auto;font-weight:700}:host.pmcc-dropdown-text-dropdown pmcc-icon{position:relative;right:unset;top:unset;height:auto;color:inherit;cursor:pointer;text-align:center;margin-left:3px}:host ::ng-deep input{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 20px 5px 5px;position:relative;border:0;cursor:pointer;width:120px;color:initial;background-color:initial;text-shadow:0 0 0 #212121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}:host ::ng-deep input.with-icon{padding-left:21px}:host ::ng-deep .icon{position:absolute;top:4px}:host ::ng-deep pmcc-icon{position:absolute;right:3px;top:6px;height:10px;color:#787878;cursor:pointer;text-align:center}:host ::ng-deep span[class*=\" pmcc-ico-\"],:host ::ng-deep span[class^=pmcc-ico-]{padding-left:5px;margin-right:5px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { width: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], sameModelSelect: [{
            type: Output
        }], change: [{
            type: Output
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], textDropdown: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.pmcc-dropdown-text-dropdown']
        }], title: [{
            type: HostBinding,
            args: ['title']
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown']
        }], model: [{
            type: Input
        }], options: [{
            type: Input
        }], serviceMenuWidth: [{
            type: Input
        }], serviceMenuHeight: [{
            type: Input
        }], triggerTemplate: [{
            type: Input
        }] }); })();

class SelectTriggerComponent {
    constructor() {
        this.width = 120;
    }
    get label() {
        if (this._label) {
            return this._label;
        }
        return '';
    }
    set label(label) {
        this._label = label;
    }
}
SelectTriggerComponent.ɵfac = function SelectTriggerComponent_Factory(t) { return new (t || SelectTriggerComponent)(); };
SelectTriggerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectTriggerComponent, selectors: [["pmcc-select-trigger"]], hostVars: 2, hostBindings: function SelectTriggerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
    } }, inputs: { width: "width", label: "label", icon: "icon", disabled: "disabled" }, decls: 3, vars: 7, consts: [["class", "icon", 3, "name", 4, "ngIf"], ["type", "text", "readonly", "", "disabled", "", 3, "value", "tabIndex"], ["name", "caret-down", 1, "caret-down"], [1, "icon", 3, "name"]], template: function SelectTriggerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SelectTriggerComponent_pmcc_icon_0_Template, 1, 1, "pmcc-icon", 0);
        ɵngcc0.ɵɵelement(1, "input", 1);
        ɵngcc0.ɵɵelement(2, "pmcc-icon", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵclassProp("with-icon", ctx.icon);
        ɵngcc0.ɵɵproperty("value", ctx.label)("tabIndex", -1);
    } }, directives: [ɵngcc1.NgIf, IconComponent], styles: ["[_nghost-%COMP%]{display:inline-block;position:relative;font:normal 13px Arial,Helvetica,Calibri,sans-serif;border-radius:3px;border:1px solid #c9c9c9;background:#fff}.disabled[_nghost-%COMP%]{border:1px solid #c9c9c9;box-shadow:none;cursor:not-allowed;opacity:.5}.disabled[_nghost-%COMP%] > *[_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]:hover:not(.disabled){background:linear-gradient(180deg,#f5f5f5 0,#f0f0f0)}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 20px 5px 5px;position:relative;border:0;cursor:default;width:120px;color:initial;background-color:initial;text-shadow:0 0 0 #222121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}[_nghost-%COMP%]   input.with-icon[_ngcontent-%COMP%]{padding-left:23px}[_nghost-%COMP%]   pmcc-icon[_ngcontent-%COMP%]{position:absolute;top:6px;text-align:center}[_nghost-%COMP%]   pmcc-icon.icon[_ngcontent-%COMP%]{left:5px}[_nghost-%COMP%]   pmcc-icon.caret-down[_ngcontent-%COMP%]{right:3px;color:#787878}"] });
SelectTriggerComponent.propDecorators = {
    icon: [{ type: Input }],
    width: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectTriggerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select-trigger',
                template: "<pmcc-icon *ngIf=\"icon\" class=\"icon\" [name]=\"icon\"></pmcc-icon>\n<!--\nTODO: Replace <input> with <label> in next breaking change.\n<input> tag has following issue:\n1. click on element\n2. navigate via up/down arrow keys\n3. press Enter\n4. now withoutclicking anywhere else, try to click on the element again\nThe menu does not open\n-->\n<input\n  type=\"text\"\n  [class.with-icon]=\"icon\"\n  [value]=\"label\"\n  [tabIndex]=\"-1\"\n  readonly\n  disabled\n  [style.width.px]=\"width\"\n/>\n<pmcc-icon class=\"caret-down\" name=\"caret-down\"></pmcc-icon>\n",
                styles: [":host{display:inline-block;position:relative;font:normal 13px Arial,Helvetica,Calibri,sans-serif;border-radius:3px;border:1px solid #c9c9c9;background:#fff}:host.disabled{border:1px solid #c9c9c9;box-shadow:none;cursor:not-allowed;opacity:.5}:host.disabled>*{cursor:not-allowed}:host:hover:not(.disabled){background:linear-gradient(180deg,#f5f5f5 0,#f0f0f0)}:host input{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 20px 5px 5px;position:relative;border:0;cursor:default;width:120px;color:initial;background-color:initial;text-shadow:0 0 0 #222121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}:host input.with-icon{padding-left:23px}:host pmcc-icon{position:absolute;top:6px;text-align:center}:host pmcc-icon.icon{left:5px}:host pmcc-icon.caret-down{right:3px;color:#787878}"]
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], label: [{
            type: Input
        }], icon: [{
            type: Input
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }] }); })();

class SelectTriggerModule {
}
SelectTriggerModule.ɵfac = function SelectTriggerModule_Factory(t) { return new (t || SelectTriggerModule)(); };
SelectTriggerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SelectTriggerModule });
SelectTriggerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectTriggerModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectTriggerComponent],
                imports: [CommonModule, IconModule],
                exports: [SelectTriggerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectTriggerModule, { declarations: function () { return [SelectTriggerComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [SelectTriggerComponent]; } }); })();

class DropdownModule {
}
DropdownModule.ɵfac = function DropdownModule_Factory(t) { return new (t || DropdownModule)(); };
DropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DropdownModule });
DropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LayoutModule,
            ServicesMenuModule,
            IconModule,
            SelectTriggerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [DropdownComponent],
                imports: [
                    CommonModule,
                    LayoutModule,
                    ServicesMenuModule,
                    IconModule,
                    SelectTriggerModule
                ],
                exports: [DropdownComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DropdownModule, { declarations: function () { return [DropdownComponent]; }, imports: function () { return [CommonModule, LayoutModule, ServicesMenuModule, IconModule, SelectTriggerModule]; }, exports: function () { return [DropdownComponent]; } }); })();

const isDateInRange = (date, min, max) => {
    if (min != null && max != null) {
        return date >= min && date <= max;
    }
    if (min != null) {
        return date >= min;
    }
    if (max != null) {
        return date <= max;
    }
    return true;
};
const ɵ0$6 = isDateInRange;
const isDateObject = (date) => date && date.getTime && !isNaN(date.getTime());
const ɵ1$3 = isDateObject;
const isValidDate = (date, min, max) => isDateObject(date) && isDateInRange(date, min, max);
const ɵ2$1 = isValidDate;

function stripLocalTime(date) {
    return date ? new Date(date).setHours(0, 0, 0, 0) : 0;
}

const isSameDay = (date1, date2) => (date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear());
const ɵ0$5 = isSameDay;

const CENTURY_FACTOR = 400;
const YEAR_FACTOR = 4;
const CENTURY = 100;
const isLeapYear = (year) => (year % CENTURY_FACTOR === 0 || (year % YEAR_FACTOR === 0 && year % CENTURY !== 0));
const ɵ0$4 = isLeapYear;

const daysOfMonth = (month, year) => {
    let days;
    if (month === 1) {
        days = year && isLeapYear(year) ? 29 : 28; // tslint:disable-line
    }
    else {
        days = 31 - ((month % 7) % 2); // tslint:disable-line
    }
    return days;
};
const ɵ0$3 = daysOfMonth;

const months = [
    {
        label: 'January',
        value: 0
    },
    {
        label: 'February',
        value: 1
    },
    {
        label: 'March',
        value: 2
    },
    {
        label: 'April',
        value: 3
    },
    {
        label: 'May',
        value: 4
    },
    {
        label: 'June',
        value: 5
    },
    {
        label: 'July',
        value: 6
    },
    {
        label: 'August',
        value: 7
    },
    {
        label: 'September',
        value: 8
    },
    {
        label: 'October',
        value: 9
    },
    {
        label: 'November',
        value: 10
    },
    {
        label: 'December',
        value: 11
    }
];

const NO_OF_GRIDS = 42;
function hasChangesFor(changes, keys) {
    return keys.some(key => {
        for (const changeKey in changes) {
            if (changes.hasOwnProperty(changeKey) &&
                changeKey === key &&
                !changes[changeKey].firstChange) {
                return true;
            }
        }
        return false;
    });
}
/**
 * Demo example
 * <example-url>/demo/#/pmcc/calendar</example-url>
 */
class CalendarComponent {
    constructor() {
        this.today = new Date();
        this.nextMonth = {};
        this.nextYear = {};
        this.yearDropdownHeight = 240;
        this.availableYears = [];
        /**
         * The date to show initially. Fallbacks to Today.
         */
        this.openAt = 'StartDate';
        this.maxDateTooltip = '';
        this.minDateTooltip = '';
        this.calendarChanged = new EventEmitter();
        this.selectedDateChanged = new EventEmitter();
        this.monthNames = months;
    }
    ngOnInit() {
        this.resetMonthGrids();
        this.goToCurrentMonth();
    }
    ngOnChanges(changes) {
        if (hasChangesFor(changes, ['startDate'])) {
            this.updateCalendarOnBoundaryDateChange(changes.startDate.previousValue, changes.startDate.currentValue);
        }
        if (hasChangesFor(changes, ['endDate'])) {
            this.updateCalendarOnBoundaryDateChange(changes.endDate.previousValue, changes.endDate.currentValue);
        }
        if (hasChangesFor(changes, ['minDate', 'maxDate', 'availableYears'])) {
            if (this.minDate > this.maxDate) {
                throw new Error('minDate cannot be greater than maxDate');
            }
            this.goToCurrentMonth();
        }
    }
    updateCalendarOnBoundaryDateChange(previousValue, currentValue) {
        const dateChanged = previousValue !== currentValue ||
            (previousValue &&
                currentValue &&
                stripLocalTime(previousValue) !== stripLocalTime(currentValue));
        if (dateChanged) {
            this.renderCalendar();
        }
    }
    isDisabled(date) {
        return !isValidDate(date, this.minDate, this.maxDate);
    }
    setCurrentMonth(date) {
        this.currentMonth = this.monthFromIndex(date.getMonth(), date.getFullYear());
        this.currentYear = {
            label: date.getFullYear(),
        };
    }
    isInSelectedRange(date) {
        const start = stripLocalTime(this.startDate);
        const end = stripLocalTime(this.endDate);
        const currentTime = stripLocalTime(date);
        return start && end && currentTime > start && currentTime < end;
    }
    isSelected(date) {
        const start = stripLocalTime(this.startDate);
        const end = stripLocalTime(this.endDate);
        const currentTime = stripLocalTime(date);
        return currentTime === start || currentTime === end;
    }
    getStartingDayOfWeek(month, year) {
        const date = new Date(year.label, month.value, 1);
        const SUNDAY_INDEX = 6;
        const dayOfWeek = date.getDay();
        return (dayOfWeek === 0) ? SUNDAY_INDEX : (dayOfWeek - 1);
    }
    createDayObj(year, month, date) {
        const day = new Date(year.label, month.value, date);
        return {
            date: day,
            isToday: isSameDay(day, this.today),
            isInMonth: true,
            isSelected: this.isSelected(day),
            isInRange: this.isInSelectedRange(day),
            isDisabled: this.isDisabled(day),
            maxDateTooltip: this.applyDisableTooltipFutureDate(day),
            minDateTooltip: this.applyDisableTooltipPastDate(day)
        };
    }
    applyDisableTooltipFutureDate(date) {
        if (this.maxDate && this.isDisabled(date) && date > this.maxDate) {
            return this.maxDateTooltip;
        }
        else {
            return '';
        }
    }
    applyDisableTooltipPastDate(date) {
        if (this.minDate && this.isDisabled(date) && date < this.minDate) {
            return this.minDateTooltip;
        }
        else {
            return '';
        }
    }
    rotateMonth(val, by) {
        const TOTAL_MONTHS = 12;
        const monthIndex = (val.month.value + TOTAL_MONTHS + by) % TOTAL_MONTHS;
        const yearIndex = monthIndex === (val.month.value + by) ? val.year.label : val.year.label + by;
        const year = { label: yearIndex };
        const month = this.monthFromIndex(monthIndex, yearIndex);
        return { month, year };
    }
    resetMonthGrids() {
        this.currentMonthGrid = new Array(NO_OF_GRIDS).fill({});
        this.nextMonthGrid = new Array(NO_OF_GRIDS).fill({});
    }
    fillMonthGrid(grid, month, year) {
        const start = this.getStartingDayOfWeek(month, year);
        const stop = start + month.days;
        return grid.map((value, i) => {
            if (i >= start && i < stop) {
                return this.createDayObj(year, month, i - start + 1);
            }
            return value;
        });
    }
    fillPreMonthDays(grid, month, year) {
        const startOfMonth = this.getStartingDayOfWeek(month, year);
        const endOfPrevMonth = startOfMonth - 1;
        const prev = this.rotateMonth({ month, year }, -1);
        return grid.map((value, i) => {
            if (i <= endOfPrevMonth) {
                return Object.assign(Object.assign({}, this.createDayObj(prev.year, prev.month, i - endOfPrevMonth + prev.month.days)), { isInMonth: false });
            }
            return value;
        });
    }
    fillPostMonthDays(grid, month, year) {
        const startOfMonth = this.getStartingDayOfWeek(month, year);
        const startOfNextMonth = startOfMonth + month.days;
        const next = this.rotateMonth({ month, year }, 1);
        return grid.map((value, i) => {
            if (i >= startOfNextMonth) {
                return Object.assign(Object.assign({}, this.createDayObj(next.year, next.month, i - startOfNextMonth + 1)), { isInMonth: false });
            }
            return value;
        });
    }
    setNextMonth() {
        if (!this.currentMonth || !this.currentYear) {
            return;
        }
        const next = this.rotateMonth({ month: this.currentMonth, year: this.currentYear }, 1);
        this.nextMonth = next.month;
        this.nextYear = next.year;
    }
    isInCurrentCalendar(date) {
        const first = new Date(this.currentYear.label, this.currentMonth.value, 1);
        const last = new Date(this.nextYear.label, this.nextMonth.value, this.nextMonth.days);
        return date >= first && date <= last;
    }
    fillAvailableYears() {
        const diff = this.currentYear.label - this.today.getFullYear();
        const defaultNumberOfYears = 5;
        let numberOfPrecedingYears = Math.max(defaultNumberOfYears, -diff);
        let numberOfFollowingYears = Math.max(defaultNumberOfYears, diff);
        if (this.minDate && this.today.getFullYear() - numberOfPrecedingYears < this.minDate.getFullYear()) {
            numberOfPrecedingYears = this.today.getFullYear() - this.minDate.getFullYear();
        }
        if (this.maxDate && this.today.getFullYear() + numberOfFollowingYears > this.maxDate.getFullYear()) {
            numberOfFollowingYears = this.maxDate.getFullYear() - this.today.getFullYear();
        }
        this.availableYears = new Array(1 + numberOfPrecedingYears + numberOfFollowingYears)
            .fill(this.today.getFullYear() - numberOfPrecedingYears)
            .map((year, index) => {
            const value = `${year + index}`;
            return { value, label: value };
        });
        this.setYearDropdownHeight();
    }
    setYearDropdownHeight() {
        const NO_OF_YEARS_TO_FIT_HEIGHT = 7;
        if (this.availableYears.length < NO_OF_YEARS_TO_FIT_HEIGHT) {
            this.yearDropdownHeight = null;
        }
        else {
            const DEFAULT_DROPDOWN_HEIGHT = 240;
            this.yearDropdownHeight = DEFAULT_DROPDOWN_HEIGHT;
        }
    }
    renderCalendar() {
        this.setNextMonth();
        this.fillAvailableYears();
        this.resetMonthGrids();
        this.fillCurrentMonthGrid();
        this.fillNextMonthGrid();
    }
    fillCurrentMonthGrid() {
        this.currentMonthGrid = this.fillMonthGrid(this.currentMonthGrid, this.currentMonth, this.currentYear);
        this.currentMonthGrid = this.fillPreMonthDays(this.currentMonthGrid, this.currentMonth, this.currentYear);
    }
    fillNextMonthGrid() {
        this.nextMonthGrid = this.fillMonthGrid(this.nextMonthGrid, this.nextMonth, this.nextYear);
        this.nextMonthGrid = this.fillPostMonthDays(this.nextMonthGrid, this.nextMonth, this.nextYear);
    }
    get isPrevMonthDisabled() {
        return !isValidDate(new Date(this.currentYear.label, this.currentMonth.value), this.minDate, this.maxDate);
    }
    get isNextMonthDisabled() {
        return !isValidDate(new Date(this.nextYear.label, this.nextMonth.value), this.minDate, this.maxDate);
    }
    goToMonth(deviation) {
        const to = this.rotateMonth({ month: this.currentMonth, year: this.currentYear }, deviation);
        this.currentMonth = to.month;
        this.currentYear = to.year;
        this.renderCalendar();
        this.calendarChanged.emit();
    }
    goToPrevMonth() {
        this.goToMonth(-1);
    }
    goToNextMonth() {
        this.goToMonth(1);
    }
    goToCurrentMonth() {
        this.setCurrentMonth(this.getOpenAtDate());
        this.renderCalendar();
    }
    selectDay(day) {
        if (!day.isDisabled) {
            this.selectedDateChanged.emit(day.date);
        }
        else {
            // TODO: Check if this is needed
            this.calendarChanged.emit();
        }
    }
    updateMonth(option) {
        this.currentMonth = this.monthFromIndex(+option.value, this.currentYear.label);
        this.renderCalendar();
    }
    updateYear(option) {
        this.currentYear = { label: +option.value };
        // If there is switch between leap nad non-leap year,
        // days count of days in month should change
        this.currentMonth = this.monthFromIndex(this.currentMonth.value, this.currentYear.label);
        this.renderCalendar();
    }
    getOpenAtDate() {
        let date;
        switch (this.openAt) {
            case 'StartDate':
                date = this.startDate;
                break;
            case 'EndDate':
                date = this.endDate;
                break;
            case 'Today':
            default:
                date = this.today;
        }
        /**
         * If no `startDate`
         * 1. `minDate` is greater than today then
         *    calendar should open at `minDate` instead of `Today`
         * 2. Both `minDate` and `maxDate` are less than today then
         *    calendar will open at `maxDate`
         */
        if (!this.startDate) {
            if (this.minDate > this.today) {
                date = this.minDate;
            }
            else if (this.minDate < this.today && this.maxDate < this.today) {
                date = this.maxDate;
            }
        }
        return date || this.today;
    }
    monthFromIndex(monthIndex, year) {
        return Object.assign(Object.assign({}, this.monthNames[monthIndex]), { days: daysOfMonth(monthIndex, year) });
    }
}
CalendarComponent.ɵfac = function CalendarComponent_Factory(t) { return new (t || CalendarComponent)(); };
CalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CalendarComponent, selectors: [["pmcc-calendar"]], inputs: { availableYears: "availableYears", openAt: "openAt", maxDateTooltip: "maxDateTooltip", minDateTooltip: "minDateTooltip", startDate: "startDate", endDate: "endDate", minDate: "minDate", maxDate: "maxDate" }, outputs: { calendarChanged: "calendarChanged", selectedDateChanged: "selectedDateChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 49, vars: 13, consts: [[1, "pmcc-calendar", "pmcc-prevent-selection"], ["data-pm-id", "calendar-prev-month", 1, "pmcc-calendar-month"], [1, "pmcc-calendar-controls"], [1, "pmcc-calendar-caption"], ["data-pm-id", "prev-month", 1, "pmcc-calendar-prev-month", "pmcc-icon", "pmcc-ico-chevron-left", "pmcc-clickable", 3, "click"], [1, "pmcc-calendar-select-month"], ["width", "100", "serviceMenuWidth", "126", "serviceMenuHeight", "240", "data-pm-id", "pmcc-calendar-month-select", 3, "model", "options", "change"], [1, "pmcc-calendar-select-year"], ["width", "55", "data-pm-id", "pmcc-calendar-year-select", 3, "model", "options", "serviceMenuHeight", "change"], [1, "pmcc-calendar-dow", "pmcc-clearfix"], [1, "weekend"], [1, "pmcc-calendar-dates", "pmcc-clearfix"], [3, "ngClass", "pmccTooltip", "click", 4, "ngFor", "ngForOf"], ["data-pm-id", "calendar-next-month", 1, "pmcc-calendar-month"], [1, "pmcc-calendar-month-2-caption"], ["data-pm-id", "next-month", 1, "pmcc-calendar-next-month", "pmcc-icon", "pmcc-ico-chevron-right", "pmcc-clickable", 3, "click"], [3, "ngClass", "pmccTooltip", "click"]], template: function CalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_div_click_4_listener() { return ctx.goToPrevMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "pmcc-dropdown", 6);
        ɵngcc0.ɵɵlistener("change", function CalendarComponent_Template_pmcc_dropdown_change_6_listener($event) { return ctx.updateMonth($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "pmcc-dropdown", 8);
        ɵngcc0.ɵɵlistener("change", function CalendarComponent_Template_pmcc_dropdown_change_8_listener($event) { return ctx.updateYear($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵelementStart(10, "span");
        ɵngcc0.ɵɵtext(11, "M");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13, "T");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span");
        ɵngcc0.ɵɵtext(15, "W");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "span");
        ɵngcc0.ɵɵtext(17, "T");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "span");
        ɵngcc0.ɵɵtext(19, "F");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "span", 10);
        ɵngcc0.ɵɵtext(21, "S");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "span", 10);
        ɵngcc0.ɵɵtext(23, "S");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 11);
        ɵngcc0.ɵɵtemplate(25, CalendarComponent_span_25_Template, 2, 11, "span", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 13);
        ɵngcc0.ɵɵelementStart(27, "div", 2);
        ɵngcc0.ɵɵelementStart(28, "div", 3);
        ɵngcc0.ɵɵelementStart(29, "div", 14);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 15);
        ɵngcc0.ɵɵlistener("click", function CalendarComponent_Template_div_click_31_listener() { return ctx.goToNextMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 9);
        ɵngcc0.ɵɵelementStart(33, "span");
        ɵngcc0.ɵɵtext(34, "M");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "span");
        ɵngcc0.ɵɵtext(36, "T");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "span");
        ɵngcc0.ɵɵtext(38, "W");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "span");
        ɵngcc0.ɵɵtext(40, "T");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "span");
        ɵngcc0.ɵɵtext(42, "F");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "span", 10);
        ɵngcc0.ɵɵtext(44, "S");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "span", 10);
        ɵngcc0.ɵɵtext(46, "S");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "div", 11);
        ɵngcc0.ɵɵtemplate(48, CalendarComponent_span_48_Template, 2, 10, "span", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isPrevMonthDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("model", ctx.currentMonth)("options", ctx.monthNames);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("model", ctx.currentYear)("options", ctx.availableYears)("serviceMenuHeight", ctx.yearDropdownHeight);
        ɵngcc0.ɵɵadvance(17);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.currentMonthGrid);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.nextMonth == null ? null : ctx.nextMonth.label, " ", ctx.nextYear == null ? null : ctx.nextYear.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isNextMonthDisabled);
        ɵngcc0.ɵɵadvance(17);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.nextMonthGrid);
    } }, directives: [DropdownComponent, ɵngcc1.NgForOf, ɵngcc1.NgClass, TooltipDirective], styles: [".pmcc-calendar[_ngcontent-%COMP%]{width:434px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]{float:left;width:212px;margin-right:10px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]:last-child{margin:0}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]{position:relative;height:27px;line-height:27px;font-size:14px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]{text-align:center;height:27px;line-height:27px;font-weight:700}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{float:left}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.pmcc-calendar-next-month[_ngcontent-%COMP%], .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.pmcc-calendar-prev-month[_ngcontent-%COMP%]{width:30px;height:27px;line-height:27px;cursor:pointer}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.pmcc-calendar-select-month[_ngcontent-%COMP%], .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.pmcc-calendar-select-year[_ngcontent-%COMP%]{height:27px;line-height:27px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.pmcc-calendar-select-month[_ngcontent-%COMP%]{margin-right:5px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   div.disabled[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   .pmcc-calendar-month-2-caption[_ngcontent-%COMP%]{float:none}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-controls[_ngcontent-%COMP%]   .pmcc-calendar-caption[_ngcontent-%COMP%]   .pmcc-calendar-next-month[_ngcontent-%COMP%]{position:absolute;top:0;right:0}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dow[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:30px;height:30px;text-align:center;line-height:30px;float:left;font-weight:700;color:#7b7b7b}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dow[_ngcontent-%COMP%]   .weekend[_ngcontent-%COMP%]{color:#c9c9c9}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]{border:1px solid #c9c9c9}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#000;width:30px;height:30px;text-align:center;line-height:30px;float:left;font-weight:700;text-decoration:none;border-bottom:1px solid #c9c9c9;border-right:1px solid #c9c9c9}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(7n){border-right:none;margin-right:-3px}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(n+36){border-bottom:none}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:not(.blank):not(.disabled){cursor:pointer}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.disabled[_ngcontent-%COMP%], .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.not-in-calendar[_ngcontent-%COMP%]{opacity:.5;font-weight:400}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.blank[_ngcontent-%COMP%]{pointer-events:none}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.today[_ngcontent-%COMP%]{color:#0085cc}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.selected[_ngcontent-%COMP%]{background-color:#0085cc;color:#fff}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.selected[_ngcontent-%COMP%]:focus, .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.selected[_ngcontent-%COMP%]:hover{background-color:#0085cc;color:#fff;opacity:.75}.pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span.highlight[_ngcontent-%COMP%], .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:focus, .pmcc-calendar[_ngcontent-%COMP%]   .pmcc-calendar-month[_ngcontent-%COMP%]   .pmcc-calendar-dates[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:hover{background-color:#e2f4fe}"] });
CalendarComponent.propDecorators = {
    startDate: [{ type: Input }],
    endDate: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    availableYears: [{ type: Input }],
    openAt: [{ type: Input }],
    maxDateTooltip: [{ type: Input }],
    minDateTooltip: [{ type: Input }],
    calendarChanged: [{ type: Output }],
    selectedDateChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CalendarComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-calendar',
                template: "<div class=\"pmcc-calendar pmcc-prevent-selection\">\n  <div class=\"pmcc-calendar-month\" data-pm-id=\"calendar-prev-month\">\n    <div class=\"pmcc-calendar-controls\">\n      <div class=\"pmcc-calendar-caption\">\n        <div\n          class=\"pmcc-calendar-prev-month pmcc-icon pmcc-ico-chevron-left pmcc-clickable\"\n          [class.disabled]=\"isPrevMonthDisabled\"\n          (click)=\"goToPrevMonth()\"\n          data-pm-id=\"prev-month\"\n        ></div>\n        <div class=\"pmcc-calendar-select-month\">\n          <pmcc-dropdown\n            [model]=\"currentMonth\"\n            [options]=\"monthNames\"\n            (change)=\"updateMonth($event)\"\n            width=\"100\"\n            serviceMenuWidth=\"126\"\n            serviceMenuHeight=\"240\"\n            data-pm-id=\"pmcc-calendar-month-select\"\n          ></pmcc-dropdown>\n        </div>\n        <div class=\"pmcc-calendar-select-year\">\n          <pmcc-dropdown\n            [model]=\"currentYear\"\n            [options]=\"availableYears\"\n            (change)=\"updateYear($event)\"\n            width=\"55\"\n            [serviceMenuHeight]=\"yearDropdownHeight\"\n            data-pm-id=\"pmcc-calendar-year-select\"\n          ></pmcc-dropdown>\n        </div>\n      </div>\n    </div>\n    <div class=\"pmcc-calendar-dow pmcc-clearfix\">\n      <span>M</span>\n      <span>T</span>\n      <span>W</span>\n      <span>T</span>\n      <span>F</span>\n      <span class=\"weekend\">S</span>\n      <span class=\"weekend\">S</span>\n    </div>\n    <div class=\"pmcc-calendar-dates pmcc-clearfix\">\n      <span\n        *ngFor=\"let day of currentMonthGrid\"\n        (click)=\"selectDay(day)\"\n        [ngClass]=\"{\n          disabled: !!day.isDisabled,\n          'not-in-calendar': !day.isInMonth,\n          today: !!day.isToday,\n          selected: !!day.isSelected,\n          highlight: !!day.isInRange,\n          blank: !day.date\n        }\"\n        [attr.data-pm-id]=\"!!day.isSelected ? 'selected-date' : null\"\n        [pmccTooltip]=\"day?.maxDateTooltip ? day.maxDateTooltip: day.minDateTooltip\"\n      >\n          {{ day?.date?.getDate() || '' }}\n      </span>\n    </div>\n  </div>\n  <div class=\"pmcc-calendar-month\" data-pm-id=\"calendar-next-month\">\n    <div class=\"pmcc-calendar-controls\">\n      <div class=\"pmcc-calendar-caption\">\n        <div class=\"pmcc-calendar-month-2-caption\">\n          {{ nextMonth?.label }} {{ nextYear?.label }}\n        </div>\n        <div\n          class=\"pmcc-calendar-next-month pmcc-icon pmcc-ico-chevron-right pmcc-clickable\"\n          [class.disabled]=\"isNextMonthDisabled\"\n          (click)=\"goToNextMonth()\"\n          data-pm-id=\"next-month\"\n        ></div>\n      </div>\n    </div>\n    <div class=\"pmcc-calendar-dow pmcc-clearfix\">\n      <span>M</span>\n      <span>T</span>\n      <span>W</span>\n      <span>T</span>\n      <span>F</span>\n      <span class=\"weekend\">S</span>\n      <span class=\"weekend\">S</span>\n    </div>\n    <div class=\"pmcc-calendar-dates pmcc-clearfix\">\n      <span\n        *ngFor=\"let day of nextMonthGrid\"\n        (click)=\"selectDay(day)\"\n        [ngClass]=\"{\n          disabled: !!day.isDisabled,\n          'not-in-calendar': !day.isInMonth,\n          today: !!day.isToday,\n          selected: !!day.isSelected,\n          highlight: !!day.isInRange,\n          blank: !day.date\n        }\"\n        [pmccTooltip]=\"day?.maxDateTooltip ? day.maxDateTooltip: day.minDateTooltip\"\n        >\n          {{ day?.date?.getDate() || '' }}\n      </span>\n    </div>\n  </div>\n</div>\n",
                styles: [".pmcc-calendar{width:434px}.pmcc-calendar .pmcc-calendar-month{float:left;width:212px;margin-right:10px}.pmcc-calendar .pmcc-calendar-month:last-child{margin:0}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls{position:relative;height:27px;line-height:27px;font-size:14px}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption{text-align:center;height:27px;line-height:27px;font-weight:700}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div{float:left}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.pmcc-calendar-next-month,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.pmcc-calendar-prev-month{width:30px;height:27px;line-height:27px;cursor:pointer}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.pmcc-calendar-select-month,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.pmcc-calendar-select-year{height:27px;line-height:27px}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.pmcc-calendar-select-month{margin-right:5px}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption div.disabled{opacity:.5;pointer-events:none}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption .pmcc-calendar-month-2-caption{float:none}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-controls .pmcc-calendar-caption .pmcc-calendar-next-month{position:absolute;top:0;right:0}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dow span{width:30px;height:30px;text-align:center;line-height:30px;float:left;font-weight:700;color:#7b7b7b}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dow .weekend{color:#c9c9c9}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates{border:1px solid #c9c9c9}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span{color:#000;width:30px;height:30px;text-align:center;line-height:30px;float:left;font-weight:700;text-decoration:none;border-bottom:1px solid #c9c9c9;border-right:1px solid #c9c9c9}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span:nth-child(7n){border-right:none;margin-right:-3px}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span:nth-child(n+36){border-bottom:none}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span:not(.blank):not(.disabled){cursor:pointer}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.disabled,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.not-in-calendar{opacity:.5;font-weight:400}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.blank{pointer-events:none}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.today{color:#0085cc}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.selected{background-color:#0085cc;color:#fff}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.selected:focus,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.selected:hover{background-color:#0085cc;color:#fff;opacity:.75}.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span.highlight,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span:focus,.pmcc-calendar .pmcc-calendar-month .pmcc-calendar-dates span:hover{background-color:#e2f4fe}"]
            }]
    }], function () { return []; }, { availableYears: [{
            type: Input
        }], openAt: [{
            type: Input
        }], maxDateTooltip: [{
            type: Input
        }], minDateTooltip: [{
            type: Input
        }], calendarChanged: [{
            type: Output
        }], selectedDateChanged: [{
            type: Output
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }] }); })();

class CalendarModule {
}
CalendarModule.ɵfac = function CalendarModule_Factory(t) { return new (t || CalendarModule)(); };
CalendarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CalendarModule });
CalendarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, DropdownModule, TooltipModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [CalendarComponent],
                imports: [CommonModule, DropdownModule, TooltipModule],
                exports: [CalendarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CalendarModule, { declarations: function () { return [CalendarComponent]; }, imports: function () { return [CommonModule, DropdownModule, TooltipModule]; }, exports: function () { return [CalendarComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/character-counter</example-url>
 */
class CharacterCounterComponent {
    get counter() {
        return this.maxLength - (this.model || '').length;
    }
}
CharacterCounterComponent.ɵfac = function CharacterCounterComponent_Factory(t) { return new (t || CharacterCounterComponent)(); };
CharacterCounterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CharacterCounterComponent, selectors: [["pmcc-character-counter"]], inputs: { model: "model", maxLength: "maxLength" }, decls: 2, vars: 4, consts: function () { let i18n_12; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_3679576604017790943$$FESM2015_PUBMATIC_PMCC_JS_13 = goog.getMsg(" {$interpolation} characters left\n", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_12 = MSG_EXTERNAL_3679576604017790943$$FESM2015_PUBMATIC_PMCC_JS_13;
    }
    else {
        i18n_12 = $localize `:␟f38dd6a145ea9a8d3858ef945dea9968a8583649␟3679576604017790943: ${"\uFFFD0\uFFFD"}:INTERPOLATION: characters left
`;
    } return [[3, "ngClass"], i18n_12]; }, template: function CharacterCounterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵi18n(1, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c14, !ctx.counter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵi18nExp(ctx.counter);
        ɵngcc0.ɵɵi18nApply(1);
    } }, directives: [ɵngcc1.NgClass], styles: [".pmcc-character-counter[_ngcontent-%COMP%]{text-align:right;color:#7b7b7b;padding:5px 0}.pmcc-character-counter.pmcc-character-count-zero[_ngcontent-%COMP%]{color:#f47d30}"], changeDetection: 0 });
CharacterCounterComponent.propDecorators = {
    model: [{ type: Input }],
    maxLength: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CharacterCounterComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-character-counter',
                template: "<div\n  i18n\n  [ngClass]=\"{\n    'pmcc-character-counter': true,\n    'pmcc-character-count-zero': !counter\n  }\"\n>\n  {{ counter }} characters left\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".pmcc-character-counter{text-align:right;color:#7b7b7b;padding:5px 0}.pmcc-character-counter.pmcc-character-count-zero{color:#f47d30}"]
            }]
    }], null, { model: [{
            type: Input
        }], maxLength: [{
            type: Input
        }] }); })();

class CharacterCounterModule {
}
CharacterCounterModule.ɵfac = function CharacterCounterModule_Factory(t) { return new (t || CharacterCounterModule)(); };
CharacterCounterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CharacterCounterModule });
CharacterCounterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CharacterCounterModule, [{
        type: NgModule,
        args: [{
                declarations: [CharacterCounterComponent],
                imports: [CommonModule],
                exports: [CharacterCounterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CharacterCounterModule, { declarations: function () { return [CharacterCounterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CharacterCounterComponent]; } }); })();

var CheckboxState;
(function (CheckboxState) {
    CheckboxState[CheckboxState["UNCHECKED"] = 0] = "UNCHECKED";
    CheckboxState[CheckboxState["CHECKED"] = 1] = "CHECKED";
    CheckboxState[CheckboxState["PARTIAL"] = 2] = "PARTIAL";
})(CheckboxState || (CheckboxState = {}));
/**
 * Demo example
 * <example-url>/demo/#/pmcc/checkbox</example-url>
 */
class CheckboxComponent {
    constructor() {
        this._value = 0;
        this._disabled = false;
        this._required = false;
        this.falseValue = CheckboxState.UNCHECKED;
        this.trueValue = CheckboxState.CHECKED;
        this.someValue = CheckboxState.PARTIAL;
        /**
         * Emitted when checkbox's value changes.
         */
        this.change = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = noop;
        /* istanbul ignore next */
        this.onTouched = noop;
    }
    /**
     * Whether the checkbox is checked.
     */
    get checked() {
        return this._value === this.trueValue;
    }
    set checked(value) {
        const checked = coerceBooleanProperty$1(value);
        this._value = checked ? this.trueValue : this.falseValue;
    }
    /**
     * Whether the checkbox is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    /**
     * Whether the checkbox is required.
     */
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = coerceBooleanProperty$1(required);
    }
    /**
     * Current value.
     */
    get value() {
        return this._value;
    }
    /**
     * Whether the checkbox is indeterminate.
     */
    get indeterminate() {
        return this._value === this.someValue;
    }
    set indeterminate(value) {
        const indeterminate = coerceBooleanProperty$1(value);
        this._value = indeterminate ? this.someValue : this.falseValue;
    }
    onBlur() {
        this.onTouched();
    }
    onInputChange(event) {
        // Stop propagation for the change event of the input element.
        // Otherwise it bubbles up and the callback gets called with an event object
        event.stopPropagation();
        switch (this._value) {
            case this.falseValue:
                this._value = this.trueValue;
                break;
            case this.trueValue:
            case this.someValue:
                this._value = this.falseValue;
                break;
            default:
                throw new Error(`Value ${this._value} doesn't match any of ${this.falseValue}/${this.someValue}/${this.trueValue}`);
        }
        this.change.emit({
            checked: this.checked,
            source: this
        });
        this.onModelChange(this._value);
        setTimeout(() => { CheckboxComponent.checkboxObserver.next(); });
    }
    onInputClick(event) {
        // Prevent host's (click) event from triggering twice
        event.stopPropagation();
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(value) {
        if (value !== this._value && value != null) {
            this._value = value;
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["pmcc-checkbox"]], hostVars: 2, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function CheckboxComponent_blur_HostBindingHandler() { return ctx.onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-disabled", ctx.disabled);
    } }, inputs: { falseValue: "falseValue", trueValue: "trueValue", someValue: "someValue", checked: "checked", disabled: "disabled", required: "required", indeterminate: "indeterminate", id: "id", name: "name", label: "label" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => CheckboxComponent)
            },
        ])], decls: 4, vars: 12, consts: [[1, "pmcc-cb-flag", 3, "ngClass"], [4, "ngIf"], ["type", "checkbox", 1, "pmcc-visually-hidden", 3, "id", "checked", "indeterminate", "disabled", "required", "change", "click"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label");
        ɵngcc0.ɵɵelement(1, "i", 0);
        ɵngcc0.ɵɵtemplate(2, CheckboxComponent_span_2_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵelementStart(3, "input", 2);
        ɵngcc0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_3_listener($event) { return ctx.onInputChange($event); })("click", function CheckboxComponent_Template_input_click_3_listener($event) { return ctx.onInputClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(8, _c15, ctx.value === ctx.trueValue, ctx.value === ctx.someValue, ctx.value === ctx.falseValue));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("checked", ctx.checked)("indeterminate", ctx.indeterminate)("disabled", ctx.disabled)("required", ctx.required);
        ɵngcc0.ɵɵattribute("name", ctx.name);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{display:inline-block}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{cursor:pointer}.pmcc-disabled[_nghost-%COMP%]{opacity:.5}.pmcc-disabled[_nghost-%COMP%]   *[_ngcontent-%COMP%]{cursor:not-allowed}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;margin:0 5px}[_nghost-%COMP%]   label[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .pmcc-cb-flag[_ngcontent-%COMP%]{position:relative;display:inline-block;height:14px;width:14px;border:1px solid #c9c9c9;border-radius:2px;background:#fff;box-sizing:initial;vertical-align:middle}[_nghost-%COMP%]   .pmcc-cb-flag[_ngcontent-%COMP%]:after{content:\"\";display:inline-block;position:absolute}[_nghost-%COMP%]   .pmcc-cb-flag.pmcc-cb-checked[_ngcontent-%COMP%]:after{left:4px;top:1px;transform:rotate(45deg);height:7px;width:3px;border-bottom:2.8px solid #0196d8;border-right:2.8px solid #0196d8}[_nghost-%COMP%]   .pmcc-cb-flag.pmcc-cb-some[_ngcontent-%COMP%]:after{left:2px;top:6px;width:10px;border-bottom:2px solid #0196d8}"] });
CheckboxComponent.checkboxObserver = new Subject();
CheckboxComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    label: [{ type: Input }],
    falseValue: [{ type: Input }],
    trueValue: [{ type: Input }],
    someValue: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.pmcc-disabled',] }],
    required: [{ type: Input }],
    indeterminate: [{ type: Input }],
    change: [{ type: Output }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-checkbox',
                template: "<label>\n  <i\n    class=\"pmcc-cb-flag\"\n    [ngClass]=\"{\n      'pmcc-cb-checked': value === trueValue,\n      'pmcc-cb-some': value === someValue,\n      'pmcc-cb-none': value === falseValue\n    }\"\n  ></i>\n  <span *ngIf=\"label\">{{ label }}</span>\n  <input\n    [id]=\"id\"\n    type=\"checkbox\"\n    class=\"pmcc-visually-hidden\"\n    [checked]=\"checked\"\n    [indeterminate]=\"indeterminate\"\n    [disabled]=\"disabled\"\n    [required]=\"required\"\n    [attr.name]=\"name\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n</label>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => CheckboxComponent)
                    },
                ],
                styles: [":host{display:inline-block}:host *{cursor:pointer}:host.pmcc-disabled{opacity:.5}:host.pmcc-disabled *{cursor:not-allowed}:host span{display:inline-block;vertical-align:middle;margin:0 5px}:host label{position:relative}:host .pmcc-cb-flag{position:relative;display:inline-block;height:14px;width:14px;border:1px solid #c9c9c9;border-radius:2px;background:#fff;box-sizing:initial;vertical-align:middle}:host .pmcc-cb-flag:after{content:\"\";display:inline-block;position:absolute}:host .pmcc-cb-flag.pmcc-cb-checked:after{left:4px;top:1px;transform:rotate(45deg);height:7px;width:3px;border-bottom:2.8px solid #0196d8;border-right:2.8px solid #0196d8}:host .pmcc-cb-flag.pmcc-cb-some:after{left:2px;top:6px;width:10px;border-bottom:2px solid #0196d8}"]
            }]
    }], function () { return []; }, { falseValue: [{
            type: Input
        }], trueValue: [{
            type: Input
        }], someValue: [{
            type: Input
        }], change: [{
            type: Output
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.pmcc-disabled']
        }], required: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

class CheckboxModule {
}
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckboxComponent],
                imports: [CommonModule],
                exports: [CheckboxComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CheckboxComponent]; } }); })();

class CollapsiblePanelContentComponent {
    constructor() {
        this.className = true;
    }
}
CollapsiblePanelContentComponent.ɵfac = function CollapsiblePanelContentComponent_Factory(t) { return new (t || CollapsiblePanelContentComponent)(); };
CollapsiblePanelContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapsiblePanelContentComponent, selectors: [["pmcc-collapsible-panel-content"]], hostVars: 2, hostBindings: function CollapsiblePanelContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-content", ctx.className);
    } }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function CollapsiblePanelContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
CollapsiblePanelContentComponent.propDecorators = {
    className: [{ type: HostBinding, args: ['class.pmcc-content',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapsiblePanelContentComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-collapsible-panel-content',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return []; }, { className: [{
            type: HostBinding,
            args: ['class.pmcc-content']
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/collapsible-panel</example-url>
 */
class CollapsiblePanelComponent {
    constructor(cd) {
        this.cd = cd;
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        this.expandedChange = new EventEmitter();
        this._expanded = true;
    }
    set content(value) {
        this._contentEl = value.nativeElement;
    }
    get expanded() {
        return this._expanded;
    }
    set expanded(value) {
        this.setExpanded(coerceBooleanProperty$1(value));
    }
    ngOnInit() {
        this._contentEl.style.height = this._expanded ? null : '0';
    }
    open() {
        this.setExpanded(true);
    }
    close() {
        this.setExpanded(false);
    }
    toggle() {
        this.setExpanded(!this._expanded);
    }
    setExpanded(expanded) {
        if (expanded !== this._expanded) {
            this._expanded = expanded;
            if (this._expanded) {
                this.expand();
                this.opened.emit();
            }
            else {
                this.collapse();
                this.closed.emit();
            }
            this.expandedChange.emit(expanded);
            this.cd.markForCheck();
        }
    }
    expand() {
        const styleHeight = this._contentEl.style.height;
        // have the element transition to the height of its inner content
        this._contentEl.style.height = `${this._contentEl.scrollHeight}px`;
        if (!!styleHeight) {
            // when the next css transition finishes (which should be the one we just triggered)
            const listener = () => {
                // remove "height" from the element's inline styles, so it can return to its initial value
                this._contentEl.style.height = null;
                // remove this event listener so it only gets triggered once
                this._contentEl.removeEventListener('transitionend', listener);
            };
            this._contentEl.addEventListener('transitionend', listener);
        }
    }
    collapse() {
        /**
         * With Angular 9, how @ViewChild() works is changed
         * and the _contentEl is set later in the lifecycle
         * So, initially when expanded is set to false via @Input()
         * this private collapse() method gets called and as
         * _contentEl is not yet initialised it fails with an
         * error `trying to access style of undefined`
         * As in ngOnInit lifecycle hook we are setting the height again
         * we do not need to worry about this.
         *
         * Also, tried covering this in test case (only the else part)
         * But in jasmine we are getting the required _contentEl
         */
        // istanbul ignore next
        if (this._contentEl) {
            // temporarily disable all css transitions
            const elementTransition = this._contentEl.style.transition;
            this._contentEl.style.transition = '';
            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the element's height to its current pixel height, so we
            // aren't transitioning out of 'auto'
            requestAnimationFrame(() => {
                this._contentEl.style.height = `${this._contentEl.scrollHeight}px`;
                this._contentEl.style.transition = elementTransition;
                // on the next frame (as soon as the previous style change has taken effect),
                // have the element transition to height: 0
                requestAnimationFrame(() => (this._contentEl.style.height = `0px`));
            });
        }
    }
}
CollapsiblePanelComponent.ɵfac = function CollapsiblePanelComponent_Factory(t) { return new (t || CollapsiblePanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CollapsiblePanelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapsiblePanelComponent, selectors: [["pmcc-collapsible-panel"]], viewQuery: function CollapsiblePanelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c16, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, hostVars: 6, hostBindings: function CollapsiblePanelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-panel", ctx.type == null || ctx.type === "white")("pmcc-panel-light", ctx.type === "light")("pmcc-panel-white", ctx.type === "white");
    } }, inputs: { expanded: "expanded", type: "type" }, outputs: { opened: "opened", closed: "closed", expandedChange: "expandedChange" }, ngContentSelectors: _c18, decls: 6, vars: 0, consts: [[1, "content-wrapper"], ["content", ""]], template: function CollapsiblePanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0, 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵprojection(4, 2);
        ɵngcc0.ɵɵprojection(5, 3);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [_c67, "pmcc-collapsible-panel{display:block;border-radius:3px}pmcc-collapsible-panel .pmcc-content{display:block}pmcc-collapsible-panel .content-wrapper{overflow:hidden;transition:height .5s ease-out;height:auto}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"]),pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"]){overflow:hidden;border:none;box-shadow:none}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"])>.pmcc-content,pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>.pmcc-content{border-radius:0}pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>*{border-left:1px solid #c3c3c3;border-right:1px solid #c3c3c3;border-bottom:1px solid #c3c3c3}pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>:not([style*=\"display:none\"]):last-child{border-bottom-left-radius:3px;border-bottom-right-radius:3px}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"])>*{border-top:1px solid #c3c3c3}"], encapsulation: 2, changeDetection: 0 });
CollapsiblePanelComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CollapsiblePanelComponent.propDecorators = {
    opened: [{ type: Output }],
    closed: [{ type: Output }],
    expandedChange: [{ type: Output }],
    content: [{ type: ViewChild, args: ['content', { static: true },] }],
    type: [{ type: Input }],
    expanded: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapsiblePanelComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-collapsible-panel',
                template: "<ng-content select=\"pmcc-collapsible-panel-header\"></ng-content>\n<div #content class=\"content-wrapper\">\n  <ng-content select=\".pmcc-toolbar\"></ng-content>\n  <ng-content select=\"pmcc-collapsible-panel-content\"></ng-content>\n  <ng-content select=\"footer\"></ng-content>\n</div>\n",
                // tslint:disable-next-line: no-host-metadata-property
                host: {
                    '[class.pmcc-panel]': 'type == null || type === "white"',
                    '[class.pmcc-panel-light]': 'type === "light"',
                    '[class.pmcc-panel-white]': 'type === "white"'
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".pmcc-panel{font-size:13px;position:relative;display:block}.pmcc-panel .pmcc-group>*{margin-top:5px;margin-bottom:5px}.pmcc-panel .pmcc-toolbar{position:relative;display:block;background-color:#d5d6d7;padding:5px 10px}.pmcc-panel .pmcc-toolbar.pmcc-pagination{background-color:#fefefe!important}.pmcc-panel .pmcc-panel-header,.pmcc-panel .pmcc-sub-header,.pmcc-panel footer,.pmcc-panel header{position:relative;padding-left:10px;padding-right:10px;background:#6b747a;display:block}.pmcc-panel .pmcc-panel-header .pmcc-title,.pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel footer .pmcc-title,.pmcc-panel header .pmcc-title{letter-spacing:.3px;color:#fff;font:normal 16px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif}.pmcc-panel.pmcc-panel-white .pmcc-panel-header,.pmcc-panel.pmcc-panel-white .pmcc-sub-header,.pmcc-panel.pmcc-panel-white footer,.pmcc-panel.pmcc-panel-white header{background:#fff}.pmcc-panel.pmcc-panel-white .pmcc-panel-header .pmcc-title,.pmcc-panel.pmcc-panel-white .pmcc-sub-header .pmcc-title,.pmcc-panel.pmcc-panel-white footer .pmcc-title,.pmcc-panel.pmcc-panel-white header .pmcc-title{color:#222121;font-size:18px;font-weight:bolder;font-family:Helvetica,Arial,Calibri,sans-serif}.pmcc-panel .pmcc-sub-header{letter-spacing:.3px;background-color:#eaeaea;color:#222121;font:normal 14px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;padding-top:10px;padding-bottom:10px;border-radius:3px}.pmcc-panel .pmcc-content,.pmcc-panel .pmcc-sub-content{background:#fff;display:block;padding:10px;overflow:auto;font-size:13px;color:#222121}.pmcc-panel .pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel footer{background-color:#f5f5f5;color:#6b747a;font:normal 12px Arial,Helvetica,Calibri,sans-serif}.pmcc-panel .pmcc-content:first-child:last-child,.pmcc-panel .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-content.hidden{height:0}.pmcc-panel+.pmcc-panel,.pmcc-panel+.pmcc-panel-light{margin-top:20px}.pmcc-panel>*{border-left:1px solid #c3c3c3;border-right:1px solid #c3c3c3;border-bottom:1px solid #c3c3c3}.pmcc-panel>:first-child{border-top:1px solid #c3c3c3;border-top-left-radius:3px;border-top-right-radius:3px}.pmcc-panel>:not([style*=\"display:none\"]):last-child{border-bottom:1px solid #c3c3c3;border-bottom-left-radius:3px;border-bottom-right-radius:3px;box-shadow:0 2px 3px #0202021f}.pmcc-panel.pmcc-filter .pmcc-content,.pmcc-panel.pmcc-filter .pmcc-sub-content{background:#f5f5f5;border:none;box-shadow:none;padding:20px 15px;color:#656d6f}.pmcc-panel-light{background:#fff;position:relative;margin-top:0;display:block;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-shadow:#00000003 0 0 1px;border:1px solid #b8b6b7;padding:20px;border-radius:5px}.pmcc-panel-light+.pmcc-panel,.pmcc-panel-light+.pmcc-panel-light{margin-top:20px}.pmcc-panel-light>.pmcc-content,.pmcc-panel .pmcc-panel-light>.pmcc-sub-content{background:#fff;padding:10px 0;overflow:auto}.pmcc-panel-light>.pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-panel-light>.pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel-light .pmcc-content:first-child:last-child,.pmcc-panel-light .pmcc-panel .pmcc-sub-content:first-child:last-child,.pmcc-panel .pmcc-panel-light .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel-light .pmcc-content.hidden,.pmcc-panel-light .pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-panel-light .hidden.pmcc-sub-content{height:0}.pmcc-panel-light .pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel-light footer .pmcc-title,.pmcc-panel-light header .pmcc-title,.pmcc-panel .pmcc-panel-light .pmcc-sub-header .pmcc-title{font:normal 16px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;margin:0;padding:0 0 10px}.pmcc-panel-light>*+*{border-top:1px solid #c7c7c7}.pmcc-horizontal-panel-divider{display:block;text-align:center;overflow:hidden;white-space:nowrap}.pmcc-horizontal-panel-divider>span{position:relative;display:inline-block;margin:6px 0}.pmcc-horizontal-panel-divider>span:after,.pmcc-horizontal-panel-divider>span:before{content:\"\";position:absolute;top:50%;width:9999px;height:1px;background:#d4d4d4}.pmcc-horizontal-panel-divider>span:before{right:100%;margin-right:15px}.pmcc-horizontal-panel-divider>span:after{left:100%;margin-left:15px}", "pmcc-collapsible-panel{display:block;border-radius:3px}pmcc-collapsible-panel .pmcc-content{display:block}pmcc-collapsible-panel .content-wrapper{overflow:hidden;transition:height .5s ease-out;height:auto}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"]),pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"]){overflow:hidden;border:none;box-shadow:none}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"])>.pmcc-content,pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>.pmcc-content{border-radius:0}pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>*{border-left:1px solid #c3c3c3;border-right:1px solid #c3c3c3;border-bottom:1px solid #c3c3c3}pmcc-collapsible-panel.pmcc-panel>.content-wrapper:not([style*=\"display:none\"])>:not([style*=\"display:none\"]):last-child{border-bottom-left-radius:3px;border-bottom-right-radius:3px}pmcc-collapsible-panel.pmcc-panel-light>.content-wrapper:not([style*=\"display:none\"])>*{border-top:1px solid #c3c3c3}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], expandedChange: [{
            type: Output
        }], content: [{
            type: ViewChild,
            args: ['content', { static: true }]
        }], expanded: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class CollapsiblePanelHeaderComponent {
    constructor(panel, cd) {
        this.panel = panel;
        this.cd = cd;
        this.className = true;
        this.flexClassName = true;
        this.arrowPosition = 'left';
    }
    onClick() {
        this.panel.toggle();
        this.cd.markForCheck();
    }
}
CollapsiblePanelHeaderComponent.ɵfac = function CollapsiblePanelHeaderComponent_Factory(t) { return new (t || CollapsiblePanelHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(CollapsiblePanelComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CollapsiblePanelHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapsiblePanelHeaderComponent, selectors: [["pmcc-collapsible-panel-header"]], hostVars: 4, hostBindings: function CollapsiblePanelHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CollapsiblePanelHeaderComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-panel-header", ctx.className)("pmcc-flex", ctx.flexClassName);
    } }, inputs: { arrowPosition: "arrowPosition" }, ngContentSelectors: _c20, decls: 8, vars: 2, consts: [[1, "pmcc-left"], ["name", "chevron-down", 3, "color", "expanded", 4, "ngIf"], [1, "pmcc-group"], [1, "pmcc-right"], ["name", "chevron-down", "class", "right", 3, "color", "expanded", 4, "ngIf"], ["name", "chevron-down", 3, "color"], ["name", "chevron-down", 1, "right", 3, "color"]], template: function CollapsiblePanelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c19);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CollapsiblePanelHeaderComponent_pmcc_icon_1_Template, 1, 3, "pmcc-icon", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, CollapsiblePanelHeaderComponent_pmcc_icon_6_Template, 1, 3, "pmcc-icon", 4);
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrowPosition === "left");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrowPosition === "right");
    } }, directives: [ɵngcc1.NgIf, IconComponent], styles: ["pmcc-collapsible-panel.pmcc-panel   [_nghost-%COMP%]{cursor:pointer;display:flex}pmcc-icon[_ngcontent-%COMP%]{transition:transform .5s ease-out}.expanded[_ngcontent-%COMP%]{transform:rotate(-180deg)}.expanded.right[_ngcontent-%COMP%]{transform:rotate(180deg)}pmcc-collapsible-panel.pmcc-panel-light   [_nghost-%COMP%]   .pmcc-group[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{padding:0 0 10px}pmcc-collapsible-panel.pmcc-panel-light   [_nghost-%COMP%]   pmcc-icon[_ngcontent-%COMP%]{margin-bottom:10px}"] });
CollapsiblePanelHeaderComponent.ctorParameters = () => [
    { type: CollapsiblePanelComponent },
    { type: ChangeDetectorRef }
];
CollapsiblePanelHeaderComponent.propDecorators = {
    className: [{ type: HostBinding, args: ['class.pmcc-panel-header',] }],
    flexClassName: [{ type: HostBinding, args: ['class.pmcc-flex',] }],
    arrowPosition: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapsiblePanelHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-collapsible-panel-header',
                template: "<div class=\"pmcc-left\">\n  <pmcc-icon\n    *ngIf=\"arrowPosition === 'left'\"\n    name=\"chevron-down\"\n    [color]=\"(panel.type !== 'light' && panel.type !== 'white') ? 'white' : undefined\"\n    [class.expanded]=\"panel.expanded\"\n  ></pmcc-icon>\n  <div class=\"pmcc-group\">\n    <span>\n      <ng-content select=\"pmcc-collapsible-panel-title\"></ng-content>\n    </span>\n  </div>\n</div>\n<div class=\"pmcc-right\">\n  <pmcc-icon\n    *ngIf=\"arrowPosition === 'right'\"\n    name=\"chevron-down\"\n    class=\"right\"\n    [color]=\"(panel.type !== 'light' && panel.type !== 'white') ? 'white' : undefined\"\n    [class.expanded]=\"panel.expanded\"\n  ></pmcc-icon>\n  <ng-content></ng-content>\n</div>\n",
                styles: ["pmcc-collapsible-panel.pmcc-panel :host{cursor:pointer;display:flex}pmcc-icon{transition:transform .5s ease-out}.expanded{transform:rotate(-180deg)}.expanded.right{transform:rotate(180deg)}pmcc-collapsible-panel.pmcc-panel-light :host .pmcc-group>span{padding:0 0 10px}pmcc-collapsible-panel.pmcc-panel-light :host pmcc-icon{margin-bottom:10px}"]
            }]
    }], function () { return [{ type: CollapsiblePanelComponent }, { type: ɵngcc0.ChangeDetectorRef }]; }, { className: [{
            type: HostBinding,
            args: ['class.pmcc-panel-header']
        }], flexClassName: [{
            type: HostBinding,
            args: ['class.pmcc-flex']
        }], arrowPosition: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class CollapsiblePanelTitleComponent {
    constructor() {
        this.className = true;
    }
}
CollapsiblePanelTitleComponent.ɵfac = function CollapsiblePanelTitleComponent_Factory(t) { return new (t || CollapsiblePanelTitleComponent)(); };
CollapsiblePanelTitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapsiblePanelTitleComponent, selectors: [["pmcc-collapsible-panel-title"]], hostVars: 2, hostBindings: function CollapsiblePanelTitleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-title", ctx.className);
    } }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function CollapsiblePanelTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
CollapsiblePanelTitleComponent.propDecorators = {
    className: [{ type: HostBinding, args: ['class.pmcc-title',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapsiblePanelTitleComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-collapsible-panel-title',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return []; }, { className: [{
            type: HostBinding,
            args: ['class.pmcc-title']
        }] }); })();

class CollapsiblePanelModule {
}
CollapsiblePanelModule.ɵfac = function CollapsiblePanelModule_Factory(t) { return new (t || CollapsiblePanelModule)(); };
CollapsiblePanelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CollapsiblePanelModule });
CollapsiblePanelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapsiblePanelModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CollapsiblePanelComponent,
                    CollapsiblePanelHeaderComponent,
                    CollapsiblePanelContentComponent,
                    CollapsiblePanelTitleComponent
                ],
                imports: [CommonModule, IconModule],
                exports: [
                    CollapsiblePanelComponent,
                    CollapsiblePanelHeaderComponent,
                    CollapsiblePanelContentComponent,
                    CollapsiblePanelTitleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CollapsiblePanelModule, { declarations: function () { return [CollapsiblePanelComponent, CollapsiblePanelHeaderComponent, CollapsiblePanelContentComponent, CollapsiblePanelTitleComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [CollapsiblePanelComponent, CollapsiblePanelHeaderComponent, CollapsiblePanelContentComponent, CollapsiblePanelTitleComponent]; } }); })();

class EscapableDirective {
    constructor() {
        this.stopEscapePropagation = true;
    }
    onEscape(event) {
        if (this.isEscapable) {
            if (this.stopEscapePropagation) {
                event.stopImmediatePropagation();
            }
            this._onEscape(event);
        }
    }
}
EscapableDirective.ɵfac = function EscapableDirective_Factory(t) { return new (t || EscapableDirective)(); };
EscapableDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EscapableDirective, hostBindings: function EscapableDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.escape", function EscapableDirective_keydown_escape_HostBindingHandler($event) { return ctx.onEscape($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } } });
EscapableDirective.propDecorators = {
    onEscape: [{ type: HostListener, args: ['document:keydown.escape', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EscapableDirective, [{
        type: Directive
    }], function () { return []; }, { onEscape: [{
            type: HostListener,
            args: ['document:keydown.escape', ['$event']]
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/column-selector</example-url>
 * @deprecated Use MultiSelectHierarchical instead
 */
class ColumnSelectorComponent extends EscapableDirective {
    constructor() {
        super(...arguments);
        this._requiredColumns = new Set();
        /**
         * Whether the overlay menu is open.
         */
        this.menuOpen = false;
        /**
         * Array of all available columns.
         */
        this.columns = [];
        /**
         * To facilitate the two-way binding for the `selectedColumns` input.
         */
        this.selectedColumnsChange = new EventEmitter();
    }
    /**
     * Array of currently selected columns.
     */
    set selectedColumns(value) {
        this._selectedColumns = value;
        this._localSelectedColumns = new Set(value);
    }
    /**
     * Array of columns that should always be selected.
     */
    set requiredColumns(value) {
        this._requiredColumns = new Set(value);
    }
    /**
     * Set when the component is used at the right side of UI.
     */
    get alignRight() {
        return this._alignRight;
    }
    set alignRight(value) {
        this._alignRight = coerceBooleanProperty$1(value);
    }
    /**
     * Number of currently selected columns.
     */
    get visibleColumnsCount() {
        return this._localSelectedColumns ? this._localSelectedColumns.size : 0;
    }
    /**
     * Whether all the columns are selected or partially selected.
     */
    get allColumnSelected() {
        if (this.visibleColumnsCount === this.columns.length) {
            return 1;
        }
        return this.visibleColumnsCount > this._requiredColumns.size ? 2 : 0;
    }
    /**
     * Position override for trigger element.
     */
    get elementPositionOverride() {
        return this._alignRight ? 'southeast' : 'southwest';
    }
    /**
     * Position override for menu element.
     */
    get layerPositionOverride() {
        return this._alignRight ? 'northeast' : 'northwest';
    }
    get isEscapable() {
        return this.menuOpen;
    }
    /**
     * Whether the column is required and cannot be unselected.
     */
    isRequired(column) {
        return this._requiredColumns.has(column);
    }
    /**
     * Whether the column is currently selected.
     */
    isSelected(column) {
        // required columns are always selected
        return this._localSelectedColumns.has(column) || this.isRequired(column)
            ? 1
            : 0;
    }
    /**
     * Select/unselect a column.
     *
     * Required columns cannot be unselected.
     */
    setSelected(column, selected) {
        if (selected) {
            this._localSelectedColumns.add(column);
        }
        else if (!this.isRequired(column)) {
            this._localSelectedColumns.delete(column);
        }
    }
    /**
     * Select/unselect all the columns.
     */
    setAllSelected(selected) {
        this.columns.forEach(column => this.setSelected(column, selected));
    }
    /**
     * Open/close the selector's menu.
     */
    toggleMenu() {
        this.menuOpen = !this.menuOpen;
        if (this.menuOpen) {
            // when menu opens, restore pristine state without any local changes
            this._localSelectedColumns = new Set(this._selectedColumns);
        }
    }
    /**
     * Close the menu without applying any changes.
     */
    closeMenu() {
        this.menuOpen = false;
    }
    /**
     * Close the menu and apply changes.
     */
    applyAndClose() {
        this._selectedColumns = Array.from(this._localSelectedColumns);
        this.selectedColumnsChange.emit(this._selectedColumns);
        this.closeMenu();
    }
    _onEscape(event) {
        this.closeMenu();
    }
}
ColumnSelectorComponent.ɵfac = /*@__PURE__*/ function () { let ɵColumnSelectorComponent_BaseFactory; return function ColumnSelectorComponent_Factory(t) { return (ɵColumnSelectorComponent_BaseFactory || (ɵColumnSelectorComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ColumnSelectorComponent)))(t || ColumnSelectorComponent); }; }();
ColumnSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ColumnSelectorComponent, selectors: [["pmcc-column-selector"]], inputs: { columns: "columns", selectedColumns: "selectedColumns", requiredColumns: "requiredColumns", alignRight: "alignRight" }, outputs: { selectedColumnsChange: "selectedColumnsChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 8, consts: [["pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", 1, "pmcc-column-selector-button", "pmcc-flex", "pmcc-align-items-center", 3, "click"], ["trigger", ""], [1, "pmcc-ico-columns", "pmcc-ico-2x"], [1, "pmcc-ico-caret-down"], ["pmccOverlay", "", 3, "pmccOverlayOpen", "pmccPositionAdjacent", "layerAdjacentOptions", "pmccOverlayOpenChange"], ["data-pm-id", "cs-popover", 1, "pmcc-column-selector-menu"], [1, "pmcc-cs-select-all-row", "pmcc-flex"], ["label", "Select All Columns", "data-pm-id", "select-all-columns", 3, "ngModel", "ngModelChange"], ["data-pm-id", "selections", 1, "pmcc-right"], ["data-pm-id", "columns-list", 1, "pmcc-column-names"], [4, "ngFor", "ngForOf"], [1, "pmcc-flex", "pmcc-column-selector-button-bar"], [1, "pmcc-left"], ["pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", "data-pm-id", "cancel-btn", 3, "click"], [1, "pmcc-right"], ["pmccButton", "", "pmccSize", "md", "data-pm-id", "done-btn", 3, "click"], ["data-pm-id", "select-column", 3, "ngModel", "label", "disabled", "title", "ngModelChange"]], template: function ColumnSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function ColumnSelectorComponent_Template_button_click_0_listener() { return ctx.toggleMenu(); });
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, ColumnSelectorComponent_ng_template_4_Template, 16, 6, "ng-template", 4);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function ColumnSelectorComponent_Template_ng_template_pmccOverlayOpenChange_4_listener($event) { return ctx.menuOpen = $event; });
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵclassProp("open", ctx.menuOpen);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.menuOpen)("pmccPositionAdjacent", _r0)("layerAdjacentOptions", ɵngcc0.ɵɵpureFunction2(5, _c21, ctx.elementPositionOverride, ctx.layerPositionOverride));
    } }, directives: [ButtonDirective, OverlayDirective, AdjacentPositionDirective, CheckboxComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]{display:inline-block}.pmcc-column-selector-button[_ngcontent-%COMP%]{outline:none;color:#222121}.pmcc-column-selector-button[_ngcontent-%COMP%]   .pmcc-ico-caret-down[_ngcontent-%COMP%]{left:4px}.pmcc-column-selector-button.open[_ngcontent-%COMP%]{border-radius:3px 3px 0 0;border-color:#c9c9c9 #c9c9c9 #0000}.pmcc-column-selector-menu[_ngcontent-%COMP%]{display:inline-block;border:1px solid #c9c9c9;border-radius:0 3px 3px 3px;padding:0;margin:-1px 0 0;background:#fff;min-width:230px}.pmcc-column-selector-menu[_ngcontent-%COMP%]:after{content:\"\";border-top:1px solid #fff;width:48px;top:-1px;position:absolute;z-index:1}.pmcc-column-selector-menu.right-align[_ngcontent-%COMP%]{border-radius:3px 0 3px 3px}.pmcc-column-selector-menu.right-align[_ngcontent-%COMP%]:after{right:1px}.pmcc-column-selector-menu[_ngcontent-%COMP%]   .pmcc-cs-select-all-row[_ngcontent-%COMP%]{margin:0 10px;padding:15px 10px 15px 0;border-bottom:1px solid #eaeaea}.pmcc-column-selector-menu[_ngcontent-%COMP%]   .pmcc-column-names[_ngcontent-%COMP%]{list-style:none;padding:0;margin:0 10px;min-height:144px;max-height:226px;overflow-y:auto}.pmcc-column-selector-menu[_ngcontent-%COMP%]   .pmcc-column-names[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 0}.pmcc-column-selector-menu[_ngcontent-%COMP%]   .pmcc-column-names[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]{border-top:1px solid #eaeaea}.pmcc-column-selector-menu[_ngcontent-%COMP%]   .pmcc-column-selector-button-bar[_ngcontent-%COMP%]{margin:10px}"] });
ColumnSelectorComponent.propDecorators = {
    columns: [{ type: Input }],
    selectedColumns: [{ type: Input }],
    requiredColumns: [{ type: Input }],
    alignRight: [{ type: Input }],
    selectedColumnsChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-column-selector',
                template: "<button\n  #trigger\n  pmccButton\n  pmccVariant=\"secondary\"\n  pmccSize=\"md\"\n  class=\"pmcc-column-selector-button pmcc-flex pmcc-align-items-center\"\n  [class.open]=\"menuOpen\"\n  (click)=\"toggleMenu()\"\n>\n  <span class=\"pmcc-ico-columns pmcc-ico-2x\"></span>\n  <span class=\"pmcc-ico-caret-down\"></span>\n</button>\n\n<ng-template\n  pmccOverlay\n  [(pmccOverlayOpen)]=\"menuOpen\"\n  [pmccPositionAdjacent]=\"trigger\"\n  [layerAdjacentOptions]=\"{\n    elementAnchor: elementPositionOverride,\n    layerAnchor: layerPositionOverride,\n    detectEdges: false\n  }\"\n>\n  <div\n    class=\"pmcc-column-selector-menu\"\n    [class.right-align]=\"alignRight\"\n    data-pm-id=\"cs-popover\"\n  >\n    <div class=\"pmcc-cs-select-all-row pmcc-flex\">\n      <pmcc-checkbox\n        [ngModel]=\"allColumnSelected\"\n        (ngModelChange)=\"setAllSelected($event)\"\n        label=\"Select All Columns\"\n        data-pm-id=\"select-all-columns\"\n      ></pmcc-checkbox>\n      <div class=\"pmcc-right\" data-pm-id=\"selections\">\n        <strong>{{ visibleColumnsCount }} of {{ columns.length }}</strong>\n      </div>\n    </div>\n\n    <ul class=\"pmcc-column-names\" data-pm-id=\"columns-list\">\n      <li *ngFor=\"let column of columns\">\n        <pmcc-checkbox\n          [ngModel]=\"isSelected(column)\"\n          (ngModelChange)=\"setSelected(column, $event)\"\n          [label]=\"column\"\n          [disabled]=\"isRequired(column)\"\n          [title]=\"isRequired(column) ? 'This column cannot be removed.' : ''\"\n          data-pm-id=\"select-column\"\n        ></pmcc-checkbox>\n      </li>\n    </ul>\n\n    <hr />\n\n    <div class=\"pmcc-flex pmcc-column-selector-button-bar\">\n      <div class=\"pmcc-left\">\n        <button\n          pmccButton\n          pmccVariant=\"secondary\"\n          pmccSize=\"md\"\n          (click)=\"closeMenu()\"\n          data-pm-id=\"cancel-btn\"\n        >\n          Cancel\n        </button>\n      </div>\n      <div class=\"pmcc-right\">\n        <button\n          pmccButton\n          pmccSize=\"md\"\n          (click)=\"applyAndClose()\"\n          data-pm-id=\"done-btn\"\n        >\n          Done\n        </button>\n      </div>\n    </div>\n  </div>\n</ng-template>\n",
                styles: [":host{display:inline-block}.pmcc-column-selector-button{outline:none;color:#222121}.pmcc-column-selector-button .pmcc-ico-caret-down{left:4px}.pmcc-column-selector-button.open{border-radius:3px 3px 0 0;border-color:#c9c9c9 #c9c9c9 #0000}.pmcc-column-selector-menu{display:inline-block;border:1px solid #c9c9c9;border-radius:0 3px 3px 3px;padding:0;margin:-1px 0 0;background:#fff;min-width:230px}.pmcc-column-selector-menu:after{content:\"\";border-top:1px solid #fff;width:48px;top:-1px;position:absolute;z-index:1}.pmcc-column-selector-menu.right-align{border-radius:3px 0 3px 3px}.pmcc-column-selector-menu.right-align:after{right:1px}.pmcc-column-selector-menu .pmcc-cs-select-all-row{margin:0 10px;padding:15px 10px 15px 0;border-bottom:1px solid #eaeaea}.pmcc-column-selector-menu .pmcc-column-names{list-style:none;padding:0;margin:0 10px;min-height:144px;max-height:226px;overflow-y:auto}.pmcc-column-selector-menu .pmcc-column-names li{padding:10px 0}.pmcc-column-selector-menu .pmcc-column-names li+li{border-top:1px solid #eaeaea}.pmcc-column-selector-menu .pmcc-column-selector-button-bar{margin:10px}"]
            }]
    }], null, { columns: [{
            type: Input
        }], selectedColumnsChange: [{
            type: Output
        }], selectedColumns: [{
            type: Input
        }], requiredColumns: [{
            type: Input
        }], alignRight: [{
            type: Input
        }] }); })();

/* tslint:disable:deprecation */
class ColumnSelectorModule {
}
ColumnSelectorModule.ɵfac = function ColumnSelectorModule_Factory(t) { return new (t || ColumnSelectorModule)(); };
ColumnSelectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ColumnSelectorModule });
ColumnSelectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, LayoutModule, CheckboxModule, FormsModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnSelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [ColumnSelectorComponent],
                imports: [CommonModule, LayoutModule, CheckboxModule, FormsModule, ButtonModule],
                exports: [ColumnSelectorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ColumnSelectorModule, { declarations: function () { return [ColumnSelectorComponent]; }, imports: function () { return [CommonModule, LayoutModule, CheckboxModule, FormsModule, ButtonModule]; }, exports: function () { return [ColumnSelectorComponent]; } }); })();

class CurrencyDropdownOptionDirective {
    constructor(elRef, cd) {
        this.elRef = elRef;
        this.cd = cd;
        this.highlighted = false;
        this.role = 'listitem';
    }
    /**
     * Implemented as port of Highlightable.
     * Marks the option as highlighted.
     */
    setActiveStyles() {
        this.setHighlighted(true);
        this.scrollIntoView();
    }
    /**
     * Implemented as port of Highlightable.
     * Removes highlight from the option.
     */
    setInactiveStyles() {
        this.setHighlighted(false);
    }
    /**
     * Scrolls into the option's view
     */
    scrollIntoView() {
        this.elRef.nativeElement.scrollIntoView({ block: 'nearest' });
    }
    setHighlighted(highlighted) {
        this.highlighted = highlighted;
        this.cd.detectChanges();
    }
}
CurrencyDropdownOptionDirective.ɵfac = function CurrencyDropdownOptionDirective_Factory(t) { return new (t || CurrencyDropdownOptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CurrencyDropdownOptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CurrencyDropdownOptionDirective, selectors: [["pmcc-currency-dropdown-option"]], hostVars: 3, hostBindings: function CurrencyDropdownOptionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassProp("highlighted", ctx.highlighted);
    } } });
CurrencyDropdownOptionDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
CurrencyDropdownOptionDirective.propDecorators = {
    highlighted: [{ type: HostBinding, args: ['class.highlighted',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyDropdownOptionDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'pmcc-currency-dropdown-option'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { highlighted: [{
            type: HostBinding,
            args: ['class.highlighted']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/currency-picker-dropdown</example-url>
 */
class CurrencyPickerDropdownComponent extends EscapableDirective {
    constructor(elRef, cd) {
        super();
        this.elRef = elRef;
        this.cd = cd;
        this._filter = '';
        this._visibleCurrencies = [];
        /**
         * Emitted when an option is selected by the user.
         */
        this.change = new EventEmitter();
        /**
         * Makes the trigger tabbable.
         */
        this.tabIndex = 0;
        this.isOpen = false;
    }
    /**
     * Whether the dropdown is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = disabled;
        if (disabled) {
            this.isOpen = false;
            this.cd.markForCheck();
        }
    }
    get visibleCurrencies() {
        return this._visibleCurrencies;
    }
    get filter() {
        return this._filter;
    }
    get isEscapable() {
        return this.isOpen;
    }
    ngOnInit() {
        this.updateVisibleCurrencies();
    }
    ngOnChanges(changes) {
        if ('currencies' in changes) {
            // reapply the filter if currencies change.
            this.updateVisibleCurrencies();
        }
    }
    ngAfterViewInit() {
        this.keyManager = new ActiveDescendantKeyManager(this.options).withVerticalOrientation();
    }
    onClick() {
        if (!this._disabled) {
            // don't open the dropdown if disabled.
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this._filter = '';
                this.updateVisibleCurrencies();
            }
        }
    }
    onCurrencySelected(currency) {
        this.change.emit(currency);
        this.isOpen = false;
    }
    onFilter(query) {
        this._filter = query;
        this.updateVisibleCurrencies();
    }
    onDropdownOpen() {
        this.focusSearchInput();
        setTimeout(() => this.focusFirstOption());
    }
    onKeyDown(event) {
        if (!this._disabled) {
            // don't handle keyboard events if disabled
            if (this.isOpen) {
                this.handleOpenKeydown(event);
            }
            else {
                this.handleClosedKeydown(event);
            }
        }
    }
    _onEscape(event) {
        this.isOpen = false;
    }
    handleOpenKeydown(event) {
        if (event.key === 'Enter' && this.keyManager.activeItemIndex != null) {
            // select currently highlighted option when Enter is pressed
            this.onCurrencySelected(this._visibleCurrencies[this.keyManager.activeItemIndex]);
        }
        else {
            this.keyManager.onKeydown(event);
        }
    }
    handleClosedKeydown(event) {
        if (event.key === 'Enter') {
            // open the dropdown when Enter is pressed on the trigger.
            this.isOpen = true;
        }
    }
    focusSearchInput() {
        setTimeout(() => this.searchInputRef.nativeElement.focus());
    }
    focusFirstOption() {
        if (this.keyManager) {
            this.keyManager.setFirstItemActive();
        }
    }
    updateVisibleCurrencies() {
        const lowerCaseFilter = this._filter.toLowerCase();
        this._visibleCurrencies = this.currencies;
        if (this._filter) {
            this._visibleCurrencies = this.currencies.filter(c => c.xrateCode.toLowerCase().includes(lowerCaseFilter) ||
                c.sign.includes(lowerCaseFilter));
        }
        this.focusFirstOption();
    }
}
CurrencyPickerDropdownComponent.ɵfac = function CurrencyPickerDropdownComponent_Factory(t) { return new (t || CurrencyPickerDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CurrencyPickerDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CurrencyPickerDropdownComponent, selectors: [["pmcc-currency-picker-dropdown"]], viewQuery: function CurrencyPickerDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c22, 7);
        ɵngcc0.ɵɵviewQuery(CurrencyDropdownOptionDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInputRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, hostVars: 3, hostBindings: function CurrencyPickerDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CurrencyPickerDropdownComponent_click_HostBindingHandler() { return ctx.onClick(); })("keydown", function CurrencyPickerDropdownComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", ctx.tabIndex);
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
    } }, inputs: { disabled: "disabled", selectedCurrency: "selectedCurrency", currencies: "currencies" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 9, consts: [[1, "pmcc-flex", "pmcc-align-items-center"], [1, "pmcc-currency-symbol"], ["data-pm-id", "selected-currency-code", 1, "pmcc-currency-short-name"], ["name", "caret-down", "data-pm-id", "currency-picker-caret-icon", 1, "caret"], ["type", "text", 1, "pmcc-currency-picker-search", 3, "value", "input", "change"], ["searchInput", ""], ["pmccOverlay", "", 3, "pmccOverlayOpen", "pmccPositionAdjacent", "pmccOverlayOpenChange", "open"], ["data-pm-id", "currency-picker-menu-container", 1, "pmcc-currency-picker-menu"], [3, "selected", "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "pmcc-currency-short-name"]], template: function CurrencyPickerDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "pmcc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("input", function CurrencyPickerDropdownComponent_Template_input_input_6_listener($event) { return ctx.onFilter($event.target.value); })("change", function CurrencyPickerDropdownComponent_Template_input_change_6_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, CurrencyPickerDropdownComponent_ng_template_8_Template, 2, 3, "ng-template", 6);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function CurrencyPickerDropdownComponent_Template_ng_template_pmccOverlayOpenChange_8_listener($event) { return ctx.isOpen = $event; })("open", function CurrencyPickerDropdownComponent_Template_ng_template_open_8_listener() { return ctx.onDropdownOpen(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("display", ctx.isOpen ? "none" : undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.selectedCurrency == null ? null : ctx.selectedCurrency.sign);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedCurrency == null ? null : ctx.selectedCurrency.xrateCode, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("display", ctx.isOpen ? undefined : "none");
        ɵngcc0.ɵɵproperty("value", ctx.filter);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.isOpen)("pmccPositionAdjacent", ctx.elRef);
    } }, directives: [IconComponent, OverlayDirective, AdjacentPositionDirective, ɵngcc1.NgForOf, CurrencyDropdownOptionDirective], styles: ["pmcc-currency-picker-dropdown{display:flex;border-radius:3px 0 0 3px;border:1px solid #ccc;border-right-width:0;position:relative;overflow:visible;padding:0 5px 0 10px;cursor:default}pmcc-currency-picker-dropdown .caret{display:inline-block;margin-left:10px;font-size:13px}pmcc-currency-picker-dropdown .pmcc-currency-picker-search{border:0;outline:none;font:normal 13px Arial,Helvetica,Calibri,sans-serif;width:83px;margin:3px 0}pmcc-currency-picker-dropdown.disabled{border-color:#d4d4d4;background:#e9e9e9;color:#999;cursor:not-allowed;outline:none}.pmcc-currency-short-name,.pmcc-currency-symbol{display:inline-block;width:30px;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.pmcc-currency-symbol{font-weight:700}.pmcc-currency-picker-menu{display:block;max-height:150px;margin:0;padding:0;background:#fff;list-style:none;overflow:auto;border:1px solid #ccc}.pmcc-currency-picker-menu pmcc-currency-dropdown-option{padding:2px 10px;display:flex;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.pmcc-currency-picker-menu pmcc-currency-dropdown-option.highlighted,.pmcc-currency-picker-menu pmcc-currency-dropdown-option:hover{background:#eaeaea;cursor:pointer}.pmcc-currency-picker-menu pmcc-currency-dropdown-option.selected{background:#e8f7ff;cursor:pointer}"], encapsulation: 2, changeDetection: 0 });
CurrencyPickerDropdownComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
CurrencyPickerDropdownComponent.propDecorators = {
    selectedCurrency: [{ type: Input }],
    currencies: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    change: [{ type: Output }],
    searchInputRef: [{ type: ViewChild, args: ['searchInput', { static: true },] }],
    options: [{ type: ViewChildren, args: [CurrencyDropdownOptionDirective,] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabIndex',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyPickerDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-currency-picker-dropdown',
                template: "<div\n  [style.display]=\"isOpen ? 'none' : undefined\"\n  class=\"pmcc-flex pmcc-align-items-center\"\n>\n  <span class=\"pmcc-currency-symbol\">{{ selectedCurrency?.sign }}</span>\n  <span class=\"pmcc-currency-short-name\" data-pm-id=\"selected-currency-code\">\n    {{ selectedCurrency?.xrateCode }}\n  </span>\n  <pmcc-icon\n    name=\"caret-down\"\n    class=\"caret\"\n    data-pm-id=\"currency-picker-caret-icon\"\n  ></pmcc-icon>\n</div>\n\n<input\n  [style.display]=\"isOpen ? undefined : 'none'\"\n  #searchInput\n  type=\"text\"\n  class=\"pmcc-currency-picker-search\"\n  [value]=\"filter\"\n  (input)=\"onFilter($event.target.value)\"\n  (change)=\"$event.stopPropagation()\"\n/>\n\n<ng-template\n  pmccOverlay\n  [(pmccOverlayOpen)]=\"isOpen\"\n  [pmccPositionAdjacent]=\"elRef\"\n  (open)=\"onDropdownOpen()\"\n>\n  <ul\n    class=\"pmcc-currency-picker-menu\"\n    data-pm-id=\"currency-picker-menu-container\"\n    [style.min-width.px]=\"elRef.nativeElement?.offsetWidth + 1\"\n  >\n    <pmcc-currency-dropdown-option\n      *ngFor=\"let currency of visibleCurrencies\"\n      [class.selected]=\"selectedCurrency?.xrateCode === currency.xrateCode\"\n      (click)=\"onCurrencySelected(currency)\"\n    >\n      <span class=\"pmcc-currency-symbol\">{{ currency.sign }}</span>\n      <span class=\"pmcc-currency-short-name\" [attr.data-pm-id]=\"currency.xrateCode\">\n        {{ currency.xrateCode }}\n      </span>\n    </pmcc-currency-dropdown-option>\n  </ul>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["pmcc-currency-picker-dropdown{display:flex;border-radius:3px 0 0 3px;border:1px solid #ccc;border-right-width:0;position:relative;overflow:visible;padding:0 5px 0 10px;cursor:default}pmcc-currency-picker-dropdown .caret{display:inline-block;margin-left:10px;font-size:13px}pmcc-currency-picker-dropdown .pmcc-currency-picker-search{border:0;outline:none;font:normal 13px Arial,Helvetica,Calibri,sans-serif;width:83px;margin:3px 0}pmcc-currency-picker-dropdown.disabled{border-color:#d4d4d4;background:#e9e9e9;color:#999;cursor:not-allowed;outline:none}.pmcc-currency-short-name,.pmcc-currency-symbol{display:inline-block;width:30px;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.pmcc-currency-symbol{font-weight:700}.pmcc-currency-picker-menu{display:block;max-height:150px;margin:0;padding:0;background:#fff;list-style:none;overflow:auto;border:1px solid #ccc}.pmcc-currency-picker-menu pmcc-currency-dropdown-option{padding:2px 10px;display:flex;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.pmcc-currency-picker-menu pmcc-currency-dropdown-option.highlighted,.pmcc-currency-picker-menu pmcc-currency-dropdown-option:hover{background:#eaeaea;cursor:pointer}.pmcc-currency-picker-menu pmcc-currency-dropdown-option.selected{background:#e8f7ff;cursor:pointer}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { change: [{
            type: Output
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], selectedCurrency: [{
            type: Input
        }], currencies: [{
            type: Input
        }], searchInputRef: [{
            type: ViewChild,
            args: ['searchInput', { static: true }]
        }], options: [{
            type: ViewChildren,
            args: [CurrencyDropdownOptionDirective]
        }] }); })();

const currencies = [
    {
        id: 1,
        name: 'US dollar',
        sign: '$',
        xrateCode: 'USD'
    },
    {
        id: 2,
        name: 'Euro',
        sign: '€',
        xrateCode: 'EUR'
    },
    {
        id: 3,
        name: 'British Pound',
        sign: '£',
        xrateCode: 'GBP'
    },
    {
        id: 4,
        name: 'Canadian dollar',
        sign: 'C$',
        xrateCode: 'CAD'
    },
    {
        id: 5,
        name: 'Australian dollar',
        sign: 'A$',
        xrateCode: 'AUD'
    },
    {
        id: 6,
        name: 'Swedish Krona',
        sign: 'Kr',
        xrateCode: 'SEK'
    },
    {
        id: 7,
        name: 'Swiss Franc',
        sign: 'Fr',
        xrateCode: 'CHF'
    },
    {
        id: 8,
        name: 'Czech Koruna',
        sign: 'Kč',
        xrateCode: 'CZK'
    },
    {
        id: 9,
        name: 'Danish Krone',
        sign: 'kr.',
        xrateCode: 'DKK'
    },
    {
        id: 11,
        name: 'New Zealand Dollar',
        sign: 'NZ$',
        xrateCode: 'NZD'
    },
    {
        id: 12,
        name: 'Japanese Yen',
        sign: '¥',
        xrateCode: 'JPY'
    },
    {
        id: 14,
        name: 'Thai Baht',
        sign: '฿',
        xrateCode: 'THB'
    },
    {
        id: 15,
        name: 'Singapore Dollar',
        sign: 'SG$',
        xrateCode: 'SGD'
    },
    {
        id: 25,
        name: 'Polish Zloty',
        sign: 'zł',
        xrateCode: 'PLN'
    },
    {
        id: 31,
        name: 'Indian Rupee',
        sign: '₹',
        xrateCode: 'INR'
    }
];

/**
 * Demo example
 * <example-url>/demo/#/pmcc/currency-picker</example-url>
 */
class CurrencyPickerComponent {
    constructor(cd) {
        this.cd = cd;
        this._disabled = false;
        this._error = false;
        this.inputValue = '';
        /**
         * Available currencies list.
         */
        this.currencies = currencies;
        /**
         * Value input width in pixels.
         */
        this.width = 80;
        /**
         * Emitted when value changes.
         */
        this.valueChange = new EventEmitter();
        /**
         * Emitted when currency changes.
         */
        this.currencyChange = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
    }
    /**
     * Updates input value.
     * Ignores the update if value cannot be converted to a number.
     * TODO: Remove/Rename this input in next BREAKING CHANGE
     * as it masks the native meaning of `value` property for any component
     * if need to be persisted it should reflect the value of complete currency comp
     * which includes symbol and value
     */
    set value(val) {
        this.inputValue = `${coerceNumberProperty(val, this.inputValue)}`;
    }
    /**
     * Whether the dropdown is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    /**
     * Whether the input has error.
     */
    get error() {
        return this._error;
    }
    set error(error) {
        this._error = coerceBooleanProperty$1(error);
    }
    onValueChange(event) {
        const val = this.inputEl.nativeElement.value;
        const nextVal = coerceNumberProperty(val, null);
        this.valueChange.emit(nextVal);
        this.onModelChange({
            currency: this.currency,
            value: nextVal,
        });
        this.onTouched();
    }
    onCurrencySelected(currency) {
        this.currency = currency;
        this.currencyChange.emit(currency);
        this.onModelChange({
            currency: this.currency,
            value: coerceNumberProperty(this.inputEl.nativeElement.value, null),
        });
        this.onTouched();
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(val) {
        const { currency = null, value = null } = val || {};
        this.currency = currency;
        this.value = value;
        this.cd.markForCheck();
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cd.markForCheck();
    }
    validate(c) {
        const err = [];
        if (!this.inputEl.nativeElement.checkValidity()) {
            err.push({ currencyValue: 'Please provide a valid numeric value not less than 0' });
        }
        // TODO add validation for currency selection
        return err.length ? err.reduce((res, e) => Object.assign(res, e), {}) : null;
    }
}
CurrencyPickerComponent.ɵfac = function CurrencyPickerComponent_Factory(t) { return new (t || CurrencyPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CurrencyPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CurrencyPickerComponent, selectors: [["pmcc-currency-picker"]], viewQuery: function CurrencyPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c23, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
    } }, hostVars: 2, hostBindings: function CurrencyPickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("error", ctx.error);
    } }, inputs: { currencies: "currencies", width: "width", value: "value", disabled: "disabled", error: "error", currency: "currency" }, outputs: { valueChange: "valueChange", currencyChange: "currencyChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => CurrencyPickerComponent)
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => CurrencyPickerComponent),
                multi: true
            }
        ])], decls: 3, vars: 6, consts: [["data-pm-id", "currency-picker-dropdown", 3, "selectedCurrency", "currencies", "disabled", "change"], ["type", "number", "min", "0.00", "step", "0.01", "placeholder", "0.00", "data-pm-id", "currency-value", 1, "pmcc-currency-picker-field", 3, "value", "input"], ["valueInput", ""]], template: function CurrencyPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pmcc-currency-picker-dropdown", 0);
        ɵngcc0.ɵɵlistener("change", function CurrencyPickerComponent_Template_pmcc_currency_picker_dropdown_change_0_listener($event) { return ctx.onCurrencySelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("input", function CurrencyPickerComponent_Template_input_input_1_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("selectedCurrency", ctx.currency)("currencies", ctx.currencies)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵproperty("value", ctx.inputValue);
    } }, directives: [CurrencyPickerDropdownComponent], styles: ["[_nghost-%COMP%]{display:inline-flex}[_nghost-%COMP%]   .pmcc-currency-picker-field[_ngcontent-%COMP%]{border-radius:0 3px 3px 0;border:1px solid #ccc;padding:4px 2px 4px 10px;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.error[_nghost-%COMP%]   .pmcc-currency-picker-field[_ngcontent-%COMP%]{border:1px solid #c00}"], changeDetection: 0 });
CurrencyPickerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CurrencyPickerComponent.propDecorators = {
    inputEl: [{ type: ViewChild, args: ['valueInput', { static: true },] }],
    value: [{ type: Input }],
    currency: [{ type: Input }],
    currencies: [{ type: Input }],
    disabled: [{ type: Input }],
    error: [{ type: Input }, { type: HostBinding, args: ['class.error',] }],
    width: [{ type: Input }],
    valueChange: [{ type: Output }],
    currencyChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyPickerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-currency-picker',
                template: "<pmcc-currency-picker-dropdown\n  [selectedCurrency]=\"currency\"\n  [currencies]=\"currencies\"\n  [disabled]=\"disabled\"\n  (change)=\"onCurrencySelected($event)\"\n  data-pm-id=\"currency-picker-dropdown\"\n></pmcc-currency-picker-dropdown>\n<input\n  #valueInput\n  type=\"number\"\n  class=\"pmcc-currency-picker-field\"\n  min=\"0.00\"\n  step=\"0.01\"\n  placeholder=\"0.00\"\n  [value]=\"inputValue\"\n  (input)=\"onValueChange($event)\"\n  [style.width.px]=\"width\"\n  data-pm-id=\"currency-value\"\n/>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => CurrencyPickerComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => CurrencyPickerComponent),
                        multi: true
                    }
                ],
                styles: [":host{display:inline-flex}:host .pmcc-currency-picker-field{border-radius:0 3px 3px 0;border:1px solid #ccc;padding:4px 2px 4px 10px;font:normal 13px Arial,Helvetica,Calibri,sans-serif}:host.error .pmcc-currency-picker-field{border:1px solid #c00}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { currencies: [{
            type: Input
        }], width: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], currencyChange: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], error: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.error']
        }], currency: [{
            type: Input
        }], inputEl: [{
            type: ViewChild,
            args: ['valueInput', { static: true }]
        }] }); })();

class CurrencyPickerModule {
}
CurrencyPickerModule.ɵfac = function CurrencyPickerModule_Factory(t) { return new (t || CurrencyPickerModule)(); };
CurrencyPickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CurrencyPickerModule });
CurrencyPickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, LayoutModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyPickerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CurrencyPickerComponent,
                    CurrencyPickerDropdownComponent,
                    CurrencyDropdownOptionDirective
                ],
                imports: [CommonModule, LayoutModule, IconModule],
                exports: [CurrencyPickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CurrencyPickerModule, { declarations: function () { return [CurrencyPickerComponent, CurrencyPickerDropdownComponent, CurrencyDropdownOptionDirective]; }, imports: function () { return [CommonModule, LayoutModule, IconModule]; }, exports: function () { return [CurrencyPickerComponent]; } }); })();

/**
 * Clamps `val` between `min` and `max
 */
function clamp(val, min, max) {
    return Math.max(Math.min(val, max), min);
}

function rotate(val, min, max) {
    if (val < min) {
        return val + 1 + max;
    }
    else if (val > max) {
        return (val - 1) % max;
    }
    return val;
}

/**
 * Used to inject `window` into components.
 * Similar to built-in `DOCUMENT` injection token
 */
const WINDOW = new InjectionToken('window', {
    providedIn: 'root',
    factory: () => window
});

/**
 * Used to inject user language.
 */
const LOCALE = new InjectionToken('locale');
const localeProvider = {
    provide: LOCALE,
    deps: [WINDOW],
    useFactory: localeFactory
};
function localeFactory(window) {
    return window.navigator.language.toLowerCase();
}

class UtilsModule {
}
UtilsModule.ɵfac = function UtilsModule_Factory(t) { return new (t || UtilsModule)(); };
UtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UtilsModule });
UtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtilsModule, [{
        type: NgModule,
        args: [{
                declarations: [ApplyPipe],
                imports: [
                    CommonModule,
                ],
                exports: [ApplyPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UtilsModule, { declarations: function () { return [ApplyPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ApplyPipe]; } }); })();

class CellDefDirective {
    constructor(template) {
        this.template = template;
    }
}
CellDefDirective.ɵfac = function CellDefDirective_Factory(t) { return new (t || CellDefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CellDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CellDefDirective, selectors: [["", "pmccCellDef", ""]] });
CellDefDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CellDefDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccCellDef]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class HeaderCellDefDirective {
    constructor(template) {
        this.template = template;
    }
}
HeaderCellDefDirective.ɵfac = function HeaderCellDefDirective_Factory(t) { return new (t || HeaderCellDefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
HeaderCellDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeaderCellDefDirective, selectors: [["", "pmccHeaderCellDef", ""]] });
HeaderCellDefDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderCellDefDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccHeaderCellDef]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class ColumnDefDirective {
}
ColumnDefDirective.ɵfac = function ColumnDefDirective_Factory(t) { return new (t || ColumnDefDirective)(); };
ColumnDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ColumnDefDirective, selectors: [["", "pmccColumnDef", ""]], contentQueries: function ColumnDefDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CellDefDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, HeaderCellDefDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cell = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerCell = _t.first);
    } }, inputs: { name: ["pmccColumnDef", "name"] } });
ColumnDefDirective.propDecorators = {
    name: [{ type: Input, args: ['pmccColumnDef',] }],
    cell: [{ type: ContentChild, args: [CellDefDirective, { static: true },] }],
    headerCell: [{ type: ContentChild, args: [HeaderCellDefDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnDefDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccColumnDef]'
            }]
    }], null, { name: [{
            type: Input,
            args: ['pmccColumnDef']
        }], cell: [{
            type: ContentChild,
            args: [CellDefDirective, { static: true }]
        }], headerCell: [{
            type: ContentChild,
            args: [HeaderCellDefDirective, { static: true }]
        }] }); })();

class BaseRowDefDirective {
    constructor(template, differs) {
        this.template = template;
        this.differs = differs;
    }
    ngOnChanges(changes) {
        if (!this.columnsDiffer) {
            const columns = (changes['columns'] && changes['columns'].currentValue) || [];
            this.columnsDiffer = this.differs.find(columns).create();
            this.columnsDiffer.diff(columns);
        }
    }
    getColumnsDiff() {
        return this.columnsDiffer.diff(this.columns);
    }
    extractCellTemplate(column) {
        // tslint:disable-next-line:no-use-before-declare
        if (this instanceof HeaderRowDefDirective) {
            return column.headerCell.template;
        }
        else {
            return column.cell.template;
        }
    }
}
BaseRowDefDirective.ɵfac = function BaseRowDefDirective_Factory(t) { return new (t || BaseRowDefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers)); };
BaseRowDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BaseRowDefDirective, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
BaseRowDefDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: IterableDiffers }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseRowDefDirective, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.IterableDiffers }]; }, null); })();
class HeaderRowDefDirective extends BaseRowDefDirective {
    constructor(template, _differs) {
        super(template, _differs);
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
    }
}
HeaderRowDefDirective.ɵfac = function HeaderRowDefDirective_Factory(t) { return new (t || HeaderRowDefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers)); };
HeaderRowDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeaderRowDefDirective, selectors: [["", "pmccHeaderRowDef", ""]], inputs: { columns: ["pmccHeaderRowDef", "columns"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
HeaderRowDefDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: IterableDiffers }
];
HeaderRowDefDirective.propDecorators = {
    columns: [{ type: Input, args: ['pmccHeaderRowDef',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderRowDefDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccHeaderRowDef]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.IterableDiffers }]; }, { columns: [{
            type: Input,
            args: ['pmccHeaderRowDef']
        }] }); })();
class RowDefDirective extends BaseRowDefDirective {
    constructor(template, _differs) {
        super(template, _differs);
    }
}
RowDefDirective.ɵfac = function RowDefDirective_Factory(t) { return new (t || RowDefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers)); };
RowDefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RowDefDirective, selectors: [["", "pmccRowDef", ""]], inputs: { columns: ["pmccRowDefColumns", "columns"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
RowDefDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: IterableDiffers }
];
RowDefDirective.propDecorators = {
    columns: [{ type: Input, args: ['pmccRowDefColumns',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowDefDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccRowDef]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.IterableDiffers }]; }, { columns: [{
            type: Input,
            args: ['pmccRowDefColumns']
        }] }); })();
class CellOutletDirective {
    constructor(_viewContainer) {
        this._viewContainer = _viewContainer;
        CellOutletDirective.mostRecentCellOutlet = this;
    }
    ngOnDestroy() {
        if (CellOutletDirective.mostRecentCellOutlet === this) {
            CellOutletDirective.mostRecentCellOutlet = null;
        }
    }
}
CellOutletDirective.ɵfac = function CellOutletDirective_Factory(t) { return new (t || CellOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CellOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CellOutletDirective, selectors: [["", "pmccCellOutlet", ""]] });
CellOutletDirective.mostRecentCellOutlet = null;
CellOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CellOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccCellOutlet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
class HeaderRowComponent {
}
HeaderRowComponent.ɵfac = function HeaderRowComponent_Factory(t) { return new (t || HeaderRowComponent)(); };
HeaderRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderRowComponent, selectors: [["", "pmccHeaderRow", ""]], attrs: _c24, decls: 1, vars: 0, consts: [["pmccCellOutlet", ""]], template: function HeaderRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, directives: [CellOutletDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderRowComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[pmccHeaderRow]',
                template: '<ng-container pmccCellOutlet></ng-container>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null); })();
class RowComponent {
}
RowComponent.ɵfac = function RowComponent_Factory(t) { return new (t || RowComponent)(); };
RowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RowComponent, selectors: [["", "pmccRow", ""]], attrs: _c25, decls: 1, vars: 0, consts: [["pmccCellOutlet", ""]], template: function RowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, directives: [CellOutletDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[pmccRow]',
                template: '<ng-container pmccCellOutlet></ng-container>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null); })();

function getPageSize(option) {
    return typeof option === 'number' ? option : (+option.value || 0);
}
class DataSource {
    constructor(requestData, sort, paginator, defaultPageSize) {
        this.requestData = requestData;
        this._dataQuery = new BehaviorSubject(null);
        this.renderData = new BehaviorSubject([]);
        this.internalPageChanges = new Subject();
        this.changesSubscription = Subscription.EMPTY;
        this._sort = sort;
        this._paginator = paginator;
        this.initializePaginator(paginator, defaultPageSize);
        this._updateChangeSubscription();
        if (!sort && !paginator) {
            this.dataQuery = {};
        }
        if (requestData) {
            this.dataQueryChangesSubscription = this._dataQuery
                .pipe(filter(Boolean), switchMap(dataQuery => this.requestData(dataQuery)))
                .subscribe(data => {
                this.updatePaginator(data.totalLength);
                this.renderData.next(data.items);
            });
        }
    }
    get dataQuery() {
        return this._dataQuery.value;
    }
    set dataQuery(value) {
        if (!this.dataQuery ||
            this.dataQuery.sortActive !== value.sortActive ||
            this.dataQuery.sortDirection !== value.sortDirection ||
            this.dataQuery.pageNumber !== value.pageNumber ||
            this.dataQuery.pageSize !== value.pageSize) {
            this._dataQuery.next(value);
        }
    }
    get sort() {
        return this._sort;
    }
    set sort(value) {
        this._sort = value;
        this._updateChangeSubscription();
    }
    get paginator() {
        return this._paginator;
    }
    set paginator(paginator) {
        this._paginator = paginator;
        this.initializePaginator(paginator);
        this._updateChangeSubscription();
    }
    initializePaginator(paginator, defaultPageSize) {
        if (paginator) {
            paginator.datasource = {
                pageNumber: 1,
                totalRecords: null,
                pageSize: getPageSize(defaultPageSize || paginator.pageSizeOptions[0])
            };
        }
    }
    _updateChangeSubscription() {
        const sortChange = this._sort ? merge(this._sort.sortChange) : of(null);
        const pageChange = this._paginator ? merge(this._paginator.pageChange, this.internalPageChanges) : of(null);
        this.changesSubscription.unsubscribe();
        this.changesSubscription = merge(forkJoin([
            this._sort ? this._sort.initialized.pipe(take(1)) : of(null),
            this._paginator ? this._paginator.initialized.pipe(take(1)) : of(null)
        ]), combineLatest([
            sortChange.pipe(startWith(null)),
            pageChange.pipe(startWith(null))
        ]))
            .pipe(map(([sortEvent, pageEvent]) => {
            if (pageEvent) {
                this._paginator.datasource = Object.assign(Object.assign({}, this._paginator.datasource), { pageNumber: pageEvent.pageNumber, pageSize: pageEvent.pageSize });
            }
            return this.orderData(this.pageData(this.dataQuery));
        }))
            .subscribe(dataQuery => this.dataQuery = dataQuery);
    }
    orderData(dataQuery) {
        const sort = this._sort;
        if (sort) {
            return Object.assign(Object.assign({}, dataQuery), { sortActive: sort.sortActive, sortDirection: sort.sortDirection });
        }
        return dataQuery;
    }
    pageData(dataQuery) {
        const paginator = this.paginator;
        if (paginator) {
            return Object.assign(Object.assign({}, dataQuery), { pageNumber: paginator.datasource.pageNumber, pageSize: paginator.datasource.pageSize });
        }
        return dataQuery;
    }
    derivePageNumber(totalRecords) {
        const lastPageIndex = Math.ceil(totalRecords / this.paginator.datasource.pageSize) || 0;
        const newPageIndex = Math.min(this.paginator.datasource.pageNumber, lastPageIndex);
        return newPageIndex || 1;
    }
    updatePaginator(totalRecords, pageNumber) {
        return Promise.resolve().then(() => {
            const paginator = this.paginator;
            if (!paginator) {
                return;
            }
            paginator.datasource.totalRecords = totalRecords;
            if (pageNumber) {
                paginator.datasource.pageNumber = pageNumber;
            }
            else {
                const newPageIndex = this.derivePageNumber(totalRecords);
                if (newPageIndex !== +paginator.datasource.pageNumber) {
                    paginator.datasource.pageNumber = newPageIndex;
                    this.internalPageChanges.next();
                }
            }
        });
    }
    connect() {
        return this.renderData;
    }
}

function PaginationOption(pageSize) {
    return { label: `${pageSize}`, value: `${pageSize}` };
}
// tslint:disable-next-line:no-magic-numbers
const defaultPageSizeOptions = [10, 25, 50, 100].map(PaginationOption);
/**
 * Demo example
 * <example-url>/demo/#/pmcc/pagination</example-url>
 */
class PaginationComponent {
    constructor(cd) {
        this.cd = cd;
        this.pageSizeOptions = defaultPageSizeOptions.slice();
        this.pageChange = new EventEmitter();
        this.timer = null;
        this.initialized = new Subject();
    }
    get datasource() {
        return this._datasource;
    }
    set datasource(value) {
        this._datasource = value;
        if (this._datasource) {
            this.model = {
                label: this._datasource.pageSize,
                value: this._datasource.pageSize
            };
        }
        this.initialized.next(this._datasource);
        this.cd.markForCheck();
        this.cd.detectChanges();
    }
    /**
     * @desc method to call when next button is clicked
     */
    changePageToNext() {
        const nextPageNum = Number(this.datasource.pageNumber) + 1;
        this.datasource.pageNumber = nextPageNum;
        this.onPageChangeHandler({
            pageNumber: this._datasource.pageNumber,
            pageSize: this._datasource.pageSize
        });
    }
    /**
     * @desc method to call when prev button is clicked
     */
    changePageToPrev() {
        const prevPageNum = Number(this.datasource.pageNumber) - 1;
        this.datasource.pageNumber = prevPageNum;
        this.onPageChangeHandler({
            pageNumber: this._datasource.pageNumber,
            pageSize: this._datasource.pageSize
        });
    }
    /**
     * @desc method will be called when we change rows per page to be displayed
     */
    onRowsPerPageChange(changedRowsNo) {
        this.model = changedRowsNo;
        this.datasource.pageSize = +changedRowsNo.value;
        this.datasource.pageNumber = 1;
        this.onPageChangeHandler({
            pageNumber: 1,
            pageSize: +changedRowsNo.value
        });
    }
    /**
     * @desc method will be called when we change rows per page to be displayed
     */
    onPageChangeHandler(obj) {
        this.pageChange.emit(obj);
    }
    /**
     * @desc method to check next button state
     */
    isNextBtnDisabled() {
        return Number(this._datasource.pageNumber) === this.getNoOfPages();
    }
    /**
     * @desc method to check next button state
     */
    isPrevBtnDisabled() {
        return Number(this._datasource.pageNumber) === 1;
    }
    /**
     * @desc method will be called when we change rows per page to be displayed
     * @param event this will be passed from template to get the value
     */
    onInputChange(event) {
        let inputValue = Number(event.target.value);
        const DEBOUNCE_TIME = 600;
        this.debounce(() => {
            // For empty textbox
            if (!event.target.value) {
                return;
            }
            // For -ve values in textbox
            if (inputValue < 1) {
                event.target.value = 1;
                if (this._datasource.pageNumber === 1) {
                    return;
                }
                inputValue = 1;
            }
            // for value > lastPageNo
            const lastPageNo = this.getNoOfPages();
            if (inputValue > lastPageNo) {
                event.target.value = 1;
                inputValue = 1;
            }
            // for floating point numbers
            if (!Number.isInteger(inputValue)) {
                event.target.value = 1;
                inputValue = 1;
            }
            this.datasource.pageNumber = inputValue;
            const newDataSource = {
                pageNumber: inputValue,
                pageSize: this._datasource.pageSize
            };
            this.onPageChangeHandler(newDataSource);
        }, DEBOUNCE_TIME);
    }
    /**
     * @desc method will be called when we change rows per page to be displayed
     * @param func function to be called in debounce
     * @param duration time in ms
     */
    debounce(func, duration = 400) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            func();
        }, duration);
    }
    /**
     * @desc method to get the no of pages
     */
    getNoOfPages() {
        const noOfPages = Math.ceil(this._datasource.totalRecords / this._datasource.pageSize);
        return noOfPages === 0 ? 1 : noOfPages;
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PaginationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["pmcc-pagination"]], inputs: { pageSizeOptions: "pageSizeOptions", datasource: "datasource", styleClass: "styleClass" }, outputs: { pageChange: "pageChange" }, ngContentSelectors: _c27, decls: 1, vars: 1, consts: [["class", "pagination-container", 3, "ngClass", 4, "ngIf"], [1, "pagination-container", 3, "ngClass"], [1, "pmcc-container-fluid"], [1, "pmcc-row", "pmcc-justify-content-end", "pmcc-align-items-center"], [1, "pmcc-col-sm-3", "pmcc-col-md-4", "pagination-group"], [1, "records-count"], ["data-pm-id", "records-count", 3, "ngPlural"], ["ngPluralCase", "one"], ["ngPluralCase", "other"], [1, "pmcc-col-sm-9", "pagination-group", "pmcc-col-md-8", "pagination-controls"], ["data-pm-id", "pagination-dropdown", 3, "model", "width", "options", "change"], [1, "pmcc-input", "pmcc-xs"], ["min", "1", "size", "4", "type", "number", "data-pm-id", "page-number", 1, "pagination-current-page", 3, "value", "max", "disabled", "input"], ["size", "4", "readonly", "", "data-pm-id", "page-count", 1, "pagination-page-count", 3, "value"], ["pmccButton", "", "pmccVariant", "secondary", "data-pm-id", "previous", 1, "pagination-previous-page", 3, "disabled", "click"], ["name", "chevron-left"], ["pmccButton", "", "pmccVariant", "secondary", "data-pm-id", "next", 1, "pagination-next-page", 3, "disabled", "click"], ["name", "chevron-right"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c26);
        ɵngcc0.ɵɵtemplate(0, PaginationComponent_div_0_Template, 27, 11, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.datasource);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgPlural, ɵngcc1.NgPluralCase, DropdownComponent, ButtonDirective, IconComponent], styles: [".pagination-container[_ngcontent-%COMP%]{color:#222121;display:block;height:auto;background-color:#e6e6e6;border:1px solid #c3c3c3}.pagination-container[_ngcontent-%COMP%]   .pmcc-page-size[_ngcontent-%COMP%] > pmcc-dropdown[_ngcontent-%COMP%]{display:flex}.pagination-container[_ngcontent-%COMP%]   .pagination-controls[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-end}.pagination-container[_ngcontent-%COMP%]   .pagination-group[_ngcontent-%COMP%]{display:flex;margin-top:0;margin-bottom:0;padding-top:10px;padding-bottom:10px;height:100%}.pagination-container[_ngcontent-%COMP%]   .pagination-current-page[_ngcontent-%COMP%]{width:50px;padding:0 8px;height:27px;line-height:27px;border-radius:3px;-moz-appearance:textfield;border:1px solid #6b747a40}.pagination-container[_ngcontent-%COMP%]   .pagination-current-page[_ngcontent-%COMP%]::-webkit-inner-spin-button, .pagination-container[_ngcontent-%COMP%]   .pagination-current-page[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.pagination-container[_ngcontent-%COMP%]   .pagination-page-count[_ngcontent-%COMP%]{border:0;background:#0000;cursor:default;height:25px}.pagination-container[_ngcontent-%COMP%]     .pagination-group>*{display:inline-block;height:100%}.pagination-container[_ngcontent-%COMP%]     .pagination-group>:not(:last-child){padding-right:10px}.pagination-container[_ngcontent-%COMP%]     .pagination-group>*+*{border-left:1px solid #c9c9c9;padding-left:10px}.pagination-container[_ngcontent-%COMP%]   .records-count[_ngcontent-%COMP%]{height:auto;display:flex;align-items:center}button.pagination-next-page[_ngcontent-%COMP%], button.pagination-previous-page[_ngcontent-%COMP%]{height:27px;margin-right:4px;border-radius:4px;cursor:pointer;color:#0196d8}button.pagination-next-page.disabled[_ngcontent-%COMP%], button.pagination-previous-page.disabled[_ngcontent-%COMP%]{opacity:.7;cursor:not-allowed;border-color:#eaeaea;color:#22212166}button.pagination-next-page[_ngcontent-%COMP%] > span[class^=pmcc-ico-][_ngcontent-%COMP%], button.pagination-next-page[_ngcontent-%COMP%] > span[class^=pmcc-ico-][_ngcontent-%COMP%]:before, button.pagination-previous-page[_ngcontent-%COMP%] > span[class^=pmcc-ico-][_ngcontent-%COMP%], button.pagination-previous-page[_ngcontent-%COMP%] > span[class^=pmcc-ico-][_ngcontent-%COMP%]:before{height:12px}"] });
PaginationComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
PaginationComponent.propDecorators = {
    pageSizeOptions: [{ type: Input }],
    styleClass: [{ type: Input }],
    pageChange: [{ type: Output }],
    datasource: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-pagination',
                template: "<div\n  class=\"pagination-container\"\n  [ngClass]=\"styleClass\"\n  *ngIf=\"datasource\"\n>\n  <div class=\"pmcc-container-fluid\">\n    <div class=\"pmcc-row pmcc-justify-content-end pmcc-align-items-center\">\n      <!---Show record-->\n      <div class=\"pmcc-col-sm-3 pmcc-col-md-4 pagination-group\">\n        <ng-content select=\".pmcc-pagination-left\"></ng-content>\n        <div class=\"records-count\">\n          <strong  [ngPlural]=\"datasource.totalRecords || 0\" data-pm-id=\"records-count\">\n            <ng-template ngPluralCase=\"one\">{{ datasource.totalRecords }} Record</ng-template>\n            <ng-template ngPluralCase=\"other\">{{ datasource.totalRecords }} Records</ng-template>\n          </strong>\n        </div>\n      </div>\n      <div class=\"pmcc-col-sm-9 pagination-group pmcc-col-md-8 pagination-controls\">\n        <span>\n          Show\n          <span>\n            <pmcc-dropdown\n              [model]=\"model\"\n              [width]=\"60\"\n              [options]=\"pageSizeOptions\"\n              (change)=\"onRowsPerPageChange($event)\"\n              data-pm-id=\"pagination-dropdown\"\n            ></pmcc-dropdown>\n          </span>\n          per page\n        </span>\n        <span>\n          Page\n          <span class=\"pmcc-input pmcc-xs\">\n            <input\n              class=\"pagination-current-page\"\n              [value]=\"datasource.pageNumber\"\n              min=\"1\"\n              max=\"{{ getNoOfPages() }}\"\n              size=\"4\"\n              type=\"number\"\n              (input)=\"onInputChange($event)\"\n              [disabled]=\"getNoOfPages() === 1\"\n              data-pm-id=\"page-number\"\n            /></span>\n          of\n          <span class=\"pmcc-input pmcc-xs\">\n            <input\n              class=\"pagination-page-count\"\n              size=\"4\"\n              value=\"{{ getNoOfPages() }}\"\n              readonly\n              data-pm-id=\"page-count\"\n            /></span>\n\n            <button\n              pmccButton\n              pmccVariant=\"secondary\"\n              class=\"pagination-previous-page\"\n              [disabled]=\"isPrevBtnDisabled()\"\n              (click)=\"changePageToPrev()\"\n              data-pm-id=\"previous\"\n            >\n            <pmcc-icon name=\"chevron-left\"></pmcc-icon>\n          </button>\n          <button\n            pmccButton\n            pmccVariant=\"secondary\"\n            class=\"pagination-next-page\"\n            [disabled]=\"isNextBtnDisabled()\"\n            (click)=\"changePageToNext()\"\n            data-pm-id=\"next\"\n          >\n            <pmcc-icon name=\"chevron-right\"></pmcc-icon>\n          </button>\n        </span>\n        <ng-content select=\".pmcc-pagination-right\"></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".pagination-container{color:#222121;display:block;height:auto;background-color:#e6e6e6;border:1px solid #c3c3c3}.pagination-container .pmcc-page-size>pmcc-dropdown{display:flex}.pagination-container .pagination-controls{display:flex;align-items:center;justify-content:flex-end}.pagination-container .pagination-group{display:flex;margin-top:0;margin-bottom:0;padding-top:10px;padding-bottom:10px;height:100%}.pagination-container .pagination-current-page{width:50px;padding:0 8px;height:27px;line-height:27px;border-radius:3px;-moz-appearance:textfield;border:1px solid #6b747a40}.pagination-container .pagination-current-page::-webkit-inner-spin-button,.pagination-container .pagination-current-page::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.pagination-container .pagination-page-count{border:0;background:#0000;cursor:default;height:25px}.pagination-container ::ng-deep .pagination-group>*{display:inline-block;height:100%}.pagination-container ::ng-deep .pagination-group>:not(:last-child){padding-right:10px}.pagination-container ::ng-deep .pagination-group>*+*{border-left:1px solid #c9c9c9;padding-left:10px}.pagination-container .records-count{height:auto;display:flex;align-items:center}button.pagination-next-page,button.pagination-previous-page{height:27px;margin-right:4px;border-radius:4px;cursor:pointer;color:#0196d8}button.pagination-next-page.disabled,button.pagination-previous-page.disabled{opacity:.7;cursor:not-allowed;border-color:#eaeaea;color:#22212166}button.pagination-next-page>span[class^=pmcc-ico-],button.pagination-next-page>span[class^=pmcc-ico-]:before,button.pagination-previous-page>span[class^=pmcc-ico-],button.pagination-previous-page>span[class^=pmcc-ico-]:before{height:12px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { pageSizeOptions: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], datasource: [{
            type: Input
        }], styleClass: [{
            type: Input
        }] }); })();

class SortDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._stateChanges = new Subject();
        this.sortables = new Map();
        this.initialized = new BehaviorSubject(null);
        this.sortStart = 'asc';
        this.sortDirection = '';
        this.sortChange = new EventEmitter();
    }
    register(sortable) {
        if (!sortable.id) {
            throw new Error('SortHeaderMissingIdError');
        }
        if (this.sortables.has(sortable.id)) {
            throw new Error('SortDuplicateSortableIdError');
        }
        this.sortables.set(sortable.id, sortable);
    }
    deregister(sortable) {
        this.sortables.delete(sortable.id);
    }
    sort(sortable) {
        if (this.sortActive !== sortable.id) {
            this.sortActive = sortable.id;
            this.sortDirection = sortable.start ? sortable.start : this.sortStart;
        }
        else {
            this.sortDirection = this.getNextSortDirection(sortable);
        }
        this.sortChange.emit({
            active: this.sortActive,
            direction: this.sortDirection,
        });
    }
    getNextSortDirection(sortable) {
        if (!sortable) {
            return '';
        }
        const sortDirectionCycle = getSortDirectionCycle(sortable.start || this.sortStart);
        let nextDirectionIndex = sortDirectionCycle.indexOf(this.sortDirection) + 1;
        if (nextDirectionIndex >= sortDirectionCycle.length) {
            nextDirectionIndex = 0;
        }
        return sortDirectionCycle[nextDirectionIndex];
    }
    ngOnInit() {
        this.initialized.next({
            active: this.sortActive,
            direction: this.sortDirection,
        });
    }
    ngOnChanges() {
        this._stateChanges.next();
    }
    ngOnDestroy() {
        this._stateChanges.complete();
    }
}
SortDirective.ɵfac = function SortDirective_Factory(t) { return new (t || SortDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SortDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SortDirective, selectors: [["", "pmccSort", ""]], inputs: { sortStart: "sortStart", sortDirection: "sortDirection", sortActive: "sortActive" }, outputs: { sortChange: "sortChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SortDirective.ctorParameters = () => [
    { type: ElementRef }
];
SortDirective.propDecorators = {
    sortActive: [{ type: Input }],
    sortStart: [{ type: Input }],
    sortDirection: [{ type: Input }],
    sortChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccSort]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { sortStart: [{
            type: Input
        }], sortDirection: [{
            type: Input
        }], sortChange: [{
            type: Output
        }], sortActive: [{
            type: Input
        }] }); })();
function getSortDirectionCycle(start) {
    if (start === 'desc') {
        return ['asc', 'desc'];
    }
    return ['desc', 'asc'];
}

class StreamingDataSource extends DataSource {
    constructor(streamer, paramsChangeCallback, dataRequest, 
    /* istanbul ignore next */
    options = {}) {
        super(null, options.sort, options.paginator, options.defaultPageSize);
        this.streamer = streamer;
        this.paramsChangeCallback = paramsChangeCallback;
        this.dataRequest = dataRequest;
        this.currentQuery = this._dataQuery.value;
        this.dataQueryChangesSubscription = this._dataQuery
            .subscribe(dataQuery => {
            /* istanbul ignore next */
            if (this.paramsChangeCallback) {
                this.paramsChangeCallback(dataQuery);
            }
            this.dataRequest.emit(dataQuery);
        });
        this.streamer
            .pipe(filter(Boolean))
            .subscribe((data) => {
            this.updatePaginator(data.metaData.totalRecords, data.metaData.pageNumber);
            this.renderData.next(data.items);
        });
    }
    get dataQuery() {
        return this._dataQuery.value;
    }
    set dataQuery(value) {
        /* istanbul ignore next */
        if (!this.currentQuery ||
            this.currentQuery.sortActive !== value.sortActive ||
            this.currentQuery.sortDirection !== value.sortDirection ||
            this.currentQuery.pageNumber !== value.pageNumber ||
            this.currentQuery.pageSize !== value.pageSize) {
            this._dataQuery.next(Object.assign({}, value));
            this.currentQuery = Object.assign({}, value);
        }
    }
    /**
     * pageNumber is NOT optional in this overridden method
     */
    updatePaginator(totalRecords, pageNumber) {
        return super.updatePaginator(totalRecords, pageNumber).then(() => {
            this.currentQuery.pageNumber = pageNumber;
        });
    }
}

class DataRowOutletDirective {
    constructor(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
}
DataRowOutletDirective.ɵfac = function DataRowOutletDirective_Factory(t) { return new (t || DataRowOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DataRowOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DataRowOutletDirective, selectors: [["", "pmccRowOutlet", ""]] });
DataRowOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataRowOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccRowOutlet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ElementRef }]; }, null); })();
class FooterRowOutletDirective {
    constructor(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
}
FooterRowOutletDirective.ɵfac = function FooterRowOutletDirective_Factory(t) { return new (t || FooterRowOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FooterRowOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FooterRowOutletDirective, selectors: [["", "pmccFooterRowOutlet", ""]] });
FooterRowOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterRowOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccFooterRowOutlet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ElementRef }]; }, null); })();
class HeaderRowOutletDirective {
    constructor(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
}
HeaderRowOutletDirective.ɵfac = function HeaderRowOutletDirective_Factory(t) { return new (t || HeaderRowOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HeaderRowOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeaderRowOutletDirective, selectors: [["", "pmccHeaderRowOutlet", ""]] });
HeaderRowOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderRowOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccHeaderRowOutlet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ElementRef }]; }, null); })();
class RowViewRef extends EmbeddedViewRef {
}
class DataTableComponent {
    constructor(differs, changeDetectorRef, elementRef, _document, sort) {
        this.differs = differs;
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this._document = _document;
        this.sort = sort;
        this._onDestroy = new Subject();
        this._columnDefsByName = new Map();
        this._customColumnDefs = new Set();
        this._customRowDefs = new Set();
        this._customHeaderRowDefs = new Set();
        this._headerRowDefChanged = true;
        this.noDataMessage = 'No records';
        this.dataRequest = new EventEmitter();
        this._mapOptions = (options) => options && options.map(PaginationOption);
    }
    ngOnInit() {
        this._wrapIntoTemplate();
        this._dataDiffer = this.differs
            .find([])
            .create((_i, dataRow) => dataRow);
    }
    ngAfterViewInit() {
        this._data = [];
        const defaultPageSize = this.enablePagination && this.pagination && this.pagination.defaultPageSize;
        this.dataSource = this.dataStream ? new StreamingDataSource(this.dataStream, this.paramsChange, this.dataRequest, {
            sort: this.sort,
            paginator: this.enablePagination && this.paginationComponent,
            defaultPageSize: defaultPageSize
        }) : new DataSource(this.requestData, this.sort, this.enablePagination && this.paginationComponent, defaultPageSize);
    }
    ngAfterContentChecked() {
        this._cacheRowDefs();
        this._cacheColumnDefs();
        if (!this._headerRowDefs.length && !this._rowDefs.length) {
            throw new Error('TableMissingRowDefsError');
        }
        this._renderUpdatedColumns();
        if (this._headerRowDefChanged) {
            this._forceRenderHeaderRows();
            this._headerRowDefChanged = false;
        }
        if (this.dataSource &&
            this._rowDefs.length > 0 &&
            !this._renderChangeSubscription) {
            this._observeRenderChanges();
        }
    }
    ngOnDestroy() {
        this._rowOutlet.viewContainer.clear();
        this._headerRowOutlet.viewContainer.clear();
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    renderRows() {
        this._renderRows = this._getAllRenderRows();
        this._renderNoDataRow();
        const changes = this._dataDiffer.diff(this._renderRows);
        if (!changes) {
            return;
        }
        const viewContainer = this._rowOutlet.viewContainer;
        changes.forEachOperation((record, prevIndex, currentIndex) => {
            if (record.previousIndex == null) {
                this._insertRow(record.item, currentIndex);
            }
            else {
                viewContainer.remove(prevIndex);
            }
        });
        this._updateRowIndexContext();
    }
    _renderNoDataRow() {
        this._footerRowOutlet.viewContainer.clear();
        if (!this._renderRows.length) {
            const context = {
                colspan: this._columnDefsByName.size,
                message: this.noDataMessage
            };
            this._footerRowOutlet.viewContainer.createEmbeddedView(this.noDataRowTemplate || this.defaultNoDataRowTemplate, context, 0);
            this.changeDetectorRef.markForCheck();
        }
    }
    _getAllRenderRows() {
        const renderRows = [];
        for (let i = 0; i < this._data.length; i++) {
            const data = this._data[i];
            const renderRowsForData = this._getRenderRowsForData(data, i);
            for (let j = 0; j < renderRowsForData.length; j++) {
                const renderRow = renderRowsForData[j];
                renderRows.push(renderRow);
            }
        }
        return renderRows;
    }
    _getRenderRowsForData(data, dataIndex) {
        return this._rowDefs.map(rowDef => ({
            data,
            rowDef,
            dataIndex
        }));
    }
    _cacheColumnDefs() {
        this._columnDefsByName.clear();
        const columnDefs = mergeQueryListAndSet(this._contentColumnDefs, this._customColumnDefs);
        columnDefs.forEach(columnDef => {
            if (this._columnDefsByName.has(columnDef.name)) {
                throw new Error('TableDuplicateColumnNameError');
            }
            this._columnDefsByName.set(columnDef.name, columnDef);
        });
    }
    _cacheRowDefs() {
        this._headerRowDefs = mergeQueryListAndSet(this._contentHeaderRowDefs, this._customHeaderRowDefs);
        this._rowDefs = mergeQueryListAndSet(this._contentRowDefs, this._customRowDefs);
        const defaultRowDefs = this._rowDefs;
        if (defaultRowDefs.length > 1) {
            throw new Error('TableMultipleDefaultRowDefsError');
        }
        this._defaultRowDef = defaultRowDefs[0];
    }
    _renderUpdatedColumns() {
        const columnsDiffReducer = (acc, def) => acc || !!def.getColumnsDiff();
        if (this._rowDefs.reduce(columnsDiffReducer, false)) {
            this._forceRenderDataRows();
        }
        if (this._headerRowDefs.reduce(columnsDiffReducer, false)) {
            this._forceRenderHeaderRows();
        }
    }
    _observeRenderChanges() {
        const dataStream = this.dataSource.connect();
        this._renderChangeSubscription = dataStream
            .pipe(takeUntil(this._onDestroy))
            .subscribe(data => {
            this._data = data || [];
            this.renderRows();
        });
    }
    _forceRenderHeaderRows() {
        if (this._headerRowOutlet.viewContainer.length > 0) {
            this._headerRowOutlet.viewContainer.clear();
        }
        this._headerRowDefs.forEach((def, i) => this._renderRow(this._headerRowOutlet, def, i));
    }
    _insertRow(renderRow, renderIndex) {
        const rowDef = renderRow.rowDef;
        const context = { $implicit: renderRow.data };
        this._renderRow(this._rowOutlet, rowDef, renderIndex, context);
    }
    _renderRow(outlet, rowDef, index, context = {}) {
        outlet.viewContainer.createEmbeddedView(rowDef.template, context, index);
        for (const cellTemplate of this._getCellTemplates(rowDef)) {
            CellOutletDirective.mostRecentCellOutlet._viewContainer.createEmbeddedView(cellTemplate, context);
        }
        this.changeDetectorRef.markForCheck();
    }
    _updateRowIndexContext() {
        const viewContainer = this._rowOutlet.viewContainer;
        for (let renderIndex = 0, count = viewContainer.length; renderIndex < count; renderIndex++) {
            const viewRef = viewContainer.get(renderIndex);
            const context = viewRef.context;
            context.count = count;
            context.first = renderIndex === 0;
            context.last = renderIndex === count - 1;
            context.even = renderIndex % 2 === 0;
            context.odd = !context.even;
            context.index = this._renderRows[renderIndex].dataIndex;
        }
    }
    _getCellTemplates(rowDef) {
        if (!rowDef || !rowDef.columns) {
            return [];
        }
        return Array.from(rowDef.columns, columnId => {
            const column = this._columnDefsByName.get(columnId);
            return rowDef.extractCellTemplate(column);
        });
    }
    _wrapIntoTemplate() {
        const template = this.tableTemplate ||
            this.defaultTemplate.createEmbeddedView({ sort: this.sort }).rootNodes[0];
        const sections = [
            { tag: 'thead', outlet: this._headerRowOutlet },
            { tag: 'tbody', outlet: this._rowOutlet },
            { tag: 'tfoot', outlet: this._footerRowOutlet }
        ];
        for (const section of sections) {
            const element = template.querySelector(section.tag);
            element.appendChild(section.outlet.elementRef.nativeElement);
        }
        this.elementRef.nativeElement.append(template);
    }
    _forceRenderDataRows() {
        this._dataDiffer.diff([]);
        this._rowOutlet.viewContainer.clear();
        this.renderRows();
    }
}
DataTableComponent.ɵfac = function DataTableComponent_Factory(t) { return new (t || DataTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(SortDirective, 8)); };
DataTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataTableComponent, selectors: [["pmcc-data-table"]], contentQueries: function DataTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c28, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DataRowOutletDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, HeaderRowOutletDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ColumnDefDirective, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, RowDefDirective, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, HeaderRowDefDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.noDataRowTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._rowOutletInsertionPoint = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._headerRowOutletInsertionPoint = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contentColumnDefs = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contentRowDefs = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contentHeaderRowDefs = _t);
    } }, viewQuery: function DataTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PaginationComponent, 5);
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
        ɵngcc0.ɵɵviewQuery(DataRowOutletDirective, 7);
        ɵngcc0.ɵɵviewQuery(HeaderRowOutletDirective, 7);
        ɵngcc0.ɵɵviewQuery(FooterRowOutletDirective, 7);
        ɵngcc0.ɵɵviewQuery(_c29, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.paginationComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._rowOutlet = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._headerRowOutlet = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._footerRowOutlet = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultNoDataRowTemplate = _t.first);
    } }, inputs: { noDataMessage: "noDataMessage", dataSource: "dataSource", tableTemplate: "tableTemplate", requestData: "requestData", enablePagination: "enablePagination", pagination: "pagination", paramsChange: "paramsChange", dataStream: "dataStream" }, outputs: { dataRequest: "dataRequest" }, ngContentSelectors: _c27, decls: 7, vars: 1, consts: [["pmccHeaderRowOutlet", ""], ["pmccRowOutlet", ""], ["pmccFooterRowOutlet", ""], ["defaultNoDataRow", ""], ["data-pm-id", "dt-pagination", 3, "pageSizeOptions", 4, "ngIf"], [1, "pmcc-table-wrapper"], ["data-pm-id", "dt-table", 1, "pmcc-table", "pmcc-table-sortable"], [1, "no-data-row"], [3, "colSpan"], ["data-pm-id", "dt-pagination", 3, "pageSizeOptions"], ["paginationComponent", ""]], template: function DataTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c26);
        ɵngcc0.ɵɵelementContainer(0, 0);
        ɵngcc0.ɵɵelementContainer(1, 1);
        ɵngcc0.ɵɵelementContainer(2, 2);
        ɵngcc0.ɵɵtemplate(3, DataTableComponent_ng_template_3_Template, 5, 0, "ng-template");
        ɵngcc0.ɵɵtemplate(4, DataTableComponent_ng_template_4_Template, 3, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, DataTableComponent_pmcc_pagination_6_Template, 5, 4, "pmcc-pagination", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enablePagination);
    } }, directives: [HeaderRowOutletDirective, DataRowOutletDirective, FooterRowOutletDirective, ɵngcc1.NgIf, PaginationComponent], pipes: [ApplyPipe], encapsulation: 2, changeDetection: 0 });
DataTableComponent.ctorParameters = () => [
    { type: IterableDiffers },
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: SortDirective, decorators: [{ type: Optional }] }
];
DataTableComponent.propDecorators = {
    tableTemplate: [{ type: Input }],
    requestData: [{ type: Input }],
    enablePagination: [{ type: Input }],
    pagination: [{ type: Input }],
    paramsChange: [{ type: Input }],
    dataStream: [{ type: Input }],
    noDataMessage: [{ type: Input }],
    dataRequest: [{ type: Output }],
    dataSource: [{ type: Input }],
    paginationComponent: [{ type: ViewChild, args: [PaginationComponent,] }],
    defaultTemplate: [{ type: ViewChild, args: [TemplateRef, { static: true },] }],
    _rowOutlet: [{ type: ViewChild, args: [DataRowOutletDirective, { static: true },] }],
    _headerRowOutlet: [{ type: ViewChild, args: [HeaderRowOutletDirective, { static: true },] }],
    _footerRowOutlet: [{ type: ViewChild, args: [FooterRowOutletDirective, { static: true },] }],
    defaultNoDataRowTemplate: [{ type: ViewChild, args: ['defaultNoDataRow', { static: true },] }],
    noDataRowTemplate: [{ type: ContentChild, args: ['noDataRowTemplate', { static: true },] }],
    _rowOutletInsertionPoint: [{ type: ContentChild, args: [DataRowOutletDirective, { static: true },] }],
    _headerRowOutletInsertionPoint: [{ type: ContentChild, args: [HeaderRowOutletDirective, { static: true },] }],
    _contentColumnDefs: [{ type: ContentChildren, args: [ColumnDefDirective,] }],
    _contentRowDefs: [{ type: ContentChildren, args: [RowDefDirective,] }],
    _contentHeaderRowDefs: [{ type: ContentChildren, args: [HeaderRowDefDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataTableComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-data-table',
                template: "<ng-container pmccHeaderRowOutlet></ng-container>\n<ng-container pmccRowOutlet></ng-container>\n<ng-container pmccFooterRowOutlet></ng-container>\n\n<ng-template let-sort=\"sort\">\n  <div class=\"pmcc-table-wrapper\">\n    <table\n      class=\"pmcc-table pmcc-table-sortable\"\n      data-pm-id=\"dt-table\"\n    >\n      <thead></thead>\n      <tbody></tbody>\n      <tfoot></tfoot>\n    </table>\n  </div>\n</ng-template>\n\n<ng-template #defaultNoDataRow let-message=\"message\" let-colspan=\"colspan\">\n  <tr class=\"no-data-row\">\n    <td [colSpan]=\"colspan\">{{message}}</td>\n  </tr>\n</ng-template>\n\n<pmcc-pagination\n  *ngIf=\"enablePagination\"\n  #paginationComponent\n  [pageSizeOptions]=\"\n    (pagination?.pageSizeOptions | apply: _mapOptions) ||\n    paginationComponent.pageSizeOptions\n  \"\n  data-pm-id=\"dt-pagination\"\n>\n  <ng-content select=\".pmcc-pagination-left\" ngProjectAs=\".pmcc-pagination-left\"></ng-content>\n  <ng-content select=\".pmcc-pagination-right\" ngProjectAs=\".pmcc-pagination-right\"></ng-content>\n</pmcc-pagination>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.IterableDiffers }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: SortDirective, decorators: [{
                type: Optional
            }] }]; }, { noDataMessage: [{
            type: Input
        }], dataRequest: [{
            type: Output
        }], dataSource: [{
            type: Input
        }], tableTemplate: [{
            type: Input
        }], requestData: [{
            type: Input
        }], enablePagination: [{
            type: Input
        }], pagination: [{
            type: Input
        }], paramsChange: [{
            type: Input
        }], dataStream: [{
            type: Input
        }], paginationComponent: [{
            type: ViewChild,
            args: [PaginationComponent]
        }], defaultTemplate: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }], _rowOutlet: [{
            type: ViewChild,
            args: [DataRowOutletDirective, { static: true }]
        }], _headerRowOutlet: [{
            type: ViewChild,
            args: [HeaderRowOutletDirective, { static: true }]
        }], _footerRowOutlet: [{
            type: ViewChild,
            args: [FooterRowOutletDirective, { static: true }]
        }], defaultNoDataRowTemplate: [{
            type: ViewChild,
            args: ['defaultNoDataRow', { static: true }]
        }], noDataRowTemplate: [{
            type: ContentChild,
            args: ['noDataRowTemplate', { static: true }]
        }], _rowOutletInsertionPoint: [{
            type: ContentChild,
            args: [DataRowOutletDirective, { static: true }]
        }], _headerRowOutletInsertionPoint: [{
            type: ContentChild,
            args: [HeaderRowOutletDirective, { static: true }]
        }], _contentColumnDefs: [{
            type: ContentChildren,
            args: [ColumnDefDirective]
        }], _contentRowDefs: [{
            type: ContentChildren,
            args: [RowDefDirective]
        }], _contentHeaderRowDefs: [{
            type: ContentChildren,
            args: [HeaderRowDefDirective]
        }] }); })();
function mergeQueryListAndSet(queryList, set) {
    return queryList.toArray().concat(Array.from(set));
}

class SortHeaderComponent {
    constructor(changeDetectorRef, sort) {
        this.sort = sort;
        this.sortLabel = true;
        this.cursor = 'pointer';
        if (!sort) {
            throw new Error('SortHeaderNotContainedWithinSortError');
        }
        this.rerenderSubscription = merge(sort.sortChange, sort._stateChanges)
            .subscribe(() => changeDetectorRef.markForCheck());
    }
    get sortNone() {
        return this.sort.sortDirection === '' || this.sort.sortActive !== this.id;
    }
    get sortAscending() {
        return this.sort.sortDirection === 'asc' && this.sort.sortActive === this.id;
    }
    get sortDescending() {
        return this.sort.sortDirection === 'desc' && this.sort.sortActive === this.id;
    }
    onClick() {
        this.sort.sort(this);
    }
    ngOnInit() {
        this.sort.register(this);
    }
    ngOnDestroy() {
        this.sort.deregister(this);
        this.rerenderSubscription.unsubscribe();
    }
}
SortHeaderComponent.ɵfac = function SortHeaderComponent_Factory(t) { return new (t || SortHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(SortDirective, 8)); };
SortHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SortHeaderComponent, selectors: [["", "pmccSortHeader", ""]], hostVars: 10, hostBindings: function SortHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SortHeaderComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("cursor", ctx.cursor);
        ɵngcc0.ɵɵclassProp("sort-label", ctx.sortLabel)("sort-none", ctx.sortNone)("sort-ascending", ctx.sortAscending)("sort-descending", ctx.sortDescending);
    } }, inputs: { id: ["pmccSortHeader", "id"], start: "start" }, attrs: _c30, ngContentSelectors: _c1, decls: 2, vars: 0, consts: [["data-pm-id", "sort", 1, "sort-label"]], template: function SortHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
SortHeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: SortDirective, decorators: [{ type: Optional }] }
];
SortHeaderComponent.propDecorators = {
    id: [{ type: Input, args: ['pmccSortHeader',] }],
    start: [{ type: Input }],
    sortNone: [{ type: HostBinding, args: ['class.sort-none',] }],
    sortAscending: [{ type: HostBinding, args: ['class.sort-ascending',] }],
    sortDescending: [{ type: HostBinding, args: ['class.sort-descending',] }],
    sortLabel: [{ type: HostBinding, args: ['class.sort-label',] }],
    cursor: [{ type: HostBinding, args: ['style.cursor',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortHeaderComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[pmccSortHeader]',
                template: `
    <div class="sort-label" data-pm-id="sort">
      <ng-content></ng-content>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: SortDirective, decorators: [{
                type: Optional
            }] }]; }, { sortLabel: [{
            type: HostBinding,
            args: ['class.sort-label']
        }], cursor: [{
            type: HostBinding,
            args: ['style.cursor']
        }], sortNone: [{
            type: HostBinding,
            args: ['class.sort-none']
        }], sortAscending: [{
            type: HostBinding,
            args: ['class.sort-ascending']
        }], sortDescending: [{
            type: HostBinding,
            args: ['class.sort-descending']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], id: [{
            type: Input,
            args: ['pmccSortHeader']
        }], start: [{
            type: Input
        }] }); })();

class PaginationModule {
}
PaginationModule.ɵfac = function PaginationModule_Factory(t) { return new (t || PaginationModule)(); };
PaginationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PaginationModule });
PaginationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            DropdownModule,
            ButtonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationModule, [{
        type: NgModule,
        args: [{
                declarations: [PaginationComponent],
                imports: [
                    CommonModule,
                    DropdownModule,
                    ButtonModule,
                    IconModule
                ],
                exports: [
                    PaginationComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PaginationModule, { declarations: function () { return [PaginationComponent]; }, imports: function () { return [CommonModule, DropdownModule, ButtonModule, IconModule]; }, exports: function () { return [PaginationComponent]; } }); })();

class DataTableModule {
}
DataTableModule.ɵfac = function DataTableModule_Factory(t) { return new (t || DataTableModule)(); };
DataTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataTableModule });
DataTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PaginationModule,
            UtilsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DataTableComponent,
                    CellDefDirective,
                    HeaderCellDefDirective,
                    ColumnDefDirective,
                    HeaderRowDefDirective,
                    RowDefDirective,
                    CellOutletDirective,
                    HeaderRowComponent,
                    RowComponent,
                    DataRowOutletDirective,
                    FooterRowOutletDirective,
                    HeaderRowOutletDirective,
                    SortDirective,
                    SortHeaderComponent,
                ],
                imports: [
                    CommonModule,
                    PaginationModule,
                    UtilsModule
                ],
                exports: [
                    DataTableComponent,
                    CellDefDirective,
                    HeaderCellDefDirective,
                    ColumnDefDirective,
                    HeaderRowDefDirective,
                    RowDefDirective,
                    CellOutletDirective,
                    HeaderRowComponent,
                    RowComponent,
                    DataRowOutletDirective,
                    HeaderRowOutletDirective,
                    SortDirective,
                    SortHeaderComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataTableModule, { declarations: function () { return [DataTableComponent, CellDefDirective, HeaderCellDefDirective, ColumnDefDirective, HeaderRowDefDirective, RowDefDirective, CellOutletDirective, HeaderRowComponent, RowComponent, DataRowOutletDirective, FooterRowOutletDirective, HeaderRowOutletDirective, SortDirective, SortHeaderComponent]; }, imports: function () { return [CommonModule, PaginationModule, UtilsModule]; }, exports: function () { return [DataTableComponent, CellDefDirective, HeaderCellDefDirective, ColumnDefDirective, HeaderRowDefDirective, RowDefDirective, CellOutletDirective, HeaderRowComponent, RowComponent, DataRowOutletDirective, HeaderRowOutletDirective, SortDirective, SortHeaderComponent]; } }); })();

function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}

/**
 * Demo example
 * <example-url>/demo/#/pmcc/input</example-url>
 * A directive that adds addons for pmcc-input.
 * Usage:
 *   <pmcc-input>
 *     <pmcc-addon>$</pmcc-addon>
 *     <pmcc-addon align="after">.00</pmcc-addon>
 *   </pmcc-input>
 */
class AddonDirective {
    constructor() {
        this.align = 'before';
    }
    /**
     * Sets 'pmcc-input-addon-after' when align="after"
     */
    get isAfter() {
        return this.align === 'after';
    }
}
AddonDirective.ɵfac = function AddonDirective_Factory(t) { return new (t || AddonDirective)(); };
AddonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AddonDirective, selectors: [["pmcc-addon"]], hostVars: 2, hostBindings: function AddonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("addon-after", ctx.isAfter);
    } }, inputs: { align: "align" } });
AddonDirective.propDecorators = {
    align: [{ type: Input }],
    isAfter: [{ type: HostBinding, args: ['class.addon-after',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddonDirective, [{
        type: Directive,
        args: [{
                // it doesn't have a template so it makes sense
                // to use Directive.
                // tslint:disable-next-line:directive-selector
                selector: 'pmcc-addon'
            }]
    }], function () { return []; }, { align: [{
            type: Input
        }], isAfter: [{
            type: HostBinding,
            args: ['class.addon-after']
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/input</example-url>
 */
class InputComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this._fullWidth = false;
        this._pmccClear = false;
        this._allowedToShowClearButton = false;
        this.addonsChangesSubscription = Subscription.EMPTY;
        /**
         * Sets 'pmcc-addon-before' when there is
         * `<pmcc-addon align="before"></pmcc-addon>`.
         */
        this.addonBefore = false;
        /**
         * Sets 'pmcc-addon-after' when there is
         * `<pmcc-addon align="after"></pmcc-addon>`.
         */
        this.addonAfter = false;
        this.clear = new EventEmitter();
    }
    /**
     * Sets 'pmcc-fullwidth' when the 'fullWidth' input is truthy
     */
    get fullWidth() {
        return this._fullWidth;
    }
    set fullWidth(value) {
        this._fullWidth = coerceBooleanProperty(value);
    }
    /**
     * When truthy, the clear button is shown unless
     * the input is disabled or has empty value
     */
    set pmccClear(value) {
        this._pmccClear = coerceBooleanProperty(value);
    }
    get shouldAddClearInputClass() {
        return this._pmccClear;
    }
    get shouldShowClearButton() {
        return this._pmccClear && this._allowedToShowClearButton;
    }
    ngAfterContentInit() {
        this.updateAddonClassNames(this.addons.toArray());
        this.addonsChangesSubscription = this.addons.changes.subscribe(addons => this.updateAddonClassNames(addons.toArray()));
    }
    ngOnDestroy() {
        this.addonsChangesSubscription.unsubscribe();
    }
    showClearButton(show) {
        this._allowedToShowClearButton = show;
    }
    clearInputValue(event) {
        event.stopPropagation();
        const inputEl = this.elRef.nativeElement.querySelector('input, textarea');
        if (inputEl) {
            inputEl.value = '';
            inputEl.dispatchEvent(new Event('input'));
            this.clear.emit();
        }
    }
    /**
     * Update host class names in response to addons changes.
     */
    updateAddonClassNames(addons) {
        this.addonBefore =
            addons.findIndex(({ align }) => align === 'before') !== -1;
        this.addonAfter = addons.findIndex(({ align }) => align === 'after') !== -1;
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["pmcc-input"]], contentQueries: function InputComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AddonDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.addons = _t);
    } }, hostVars: 10, hostBindings: function InputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("with-addon-before", ctx.addonBefore)("with-addon-after", ctx.addonAfter)("pmcc-fullwidth", ctx.fullWidth)("pmcc-clear-input", ctx.shouldAddClearInputClass)("pmcc-has-clear", ctx.shouldShowClearButton);
    } }, inputs: { fullWidth: "fullWidth", pmccClear: "pmccClear" }, outputs: { clear: "clear" }, ngContentSelectors: _c32, decls: 4, vars: 1, consts: [["name", "close", 3, "click", 4, "ngIf"], ["name", "close", 3, "click"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c31);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵprojection(1, 1);
        ɵngcc0.ɵɵprojection(2, 2);
        ɵngcc0.ɵɵtemplate(3, InputComponent_pmcc_icon_3_Template, 1, 0, "pmcc-icon", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldShowClearButton);
    } }, directives: [ɵngcc1.NgIf, IconComponent], encapsulation: 2 });
InputComponent.ctorParameters = () => [
    { type: ElementRef }
];
InputComponent.propDecorators = {
    addonBefore: [{ type: HostBinding, args: ['class.with-addon-before',] }],
    addonAfter: [{ type: HostBinding, args: ['class.with-addon-after',] }],
    addons: [{ type: ContentChildren, args: [AddonDirective,] }],
    fullWidth: [{ type: Input }, { type: HostBinding, args: ['class.pmcc-fullwidth',] }],
    pmccClear: [{ type: Input }],
    shouldAddClearInputClass: [{ type: HostBinding, args: ['class.pmcc-clear-input',] }],
    shouldShowClearButton: [{ type: HostBinding, args: ['class.pmcc-has-clear',] }],
    clear: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-input',
                template: "<ng-content select=\"pmcc-addon:not([align='after'])\"></ng-content>\n\n<ng-content select=\"input, textarea, label\"></ng-content>\n\n<ng-content select=\"pmcc-addon[align='after']\"></ng-content>\n<pmcc-icon\n  name=\"close\"\n  *ngIf=\"shouldShowClearButton\"\n  (click)=\"clearInputValue($event)\"\n></pmcc-icon>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { addonBefore: [{
            type: HostBinding,
            args: ['class.with-addon-before']
        }], addonAfter: [{
            type: HostBinding,
            args: ['class.with-addon-after']
        }], clear: [{
            type: Output
        }], fullWidth: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.pmcc-fullwidth']
        }], pmccClear: [{
            type: Input
        }], shouldAddClearInputClass: [{
            type: HostBinding,
            args: ['class.pmcc-clear-input']
        }], shouldShowClearButton: [{
            type: HostBinding,
            args: ['class.pmcc-has-clear']
        }], addons: [{
            type: ContentChildren,
            args: [AddonDirective]
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/input</example-url>
 * Shows an inline help bubble.
 * Usage:
 *   <pmcc-inline-help>
 *     Some helper info
 *   </pmcc-inline-help>
 *
 * For single for inline help use singleRow input:
 *   <pmcc-inline-help singleRow>
 *     Some helper info
 *   </pmcc-inline-help>
 */
class InlineHelpDirective {
    constructor() {
        this._singleRow = false;
    }
    /**
     * Sets 'single-row' when the 'singleRow' input is truthy
     */
    get singleRow() {
        return this._singleRow;
    }
    set singleRow(value) {
        this._singleRow = coerceBooleanProperty(value);
    }
}
InlineHelpDirective.ɵfac = function InlineHelpDirective_Factory(t) { return new (t || InlineHelpDirective)(); };
InlineHelpDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InlineHelpDirective, selectors: [["pmcc-inline-help"]], hostVars: 2, hostBindings: function InlineHelpDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("single-row", ctx.singleRow);
    } }, inputs: { singleRow: "singleRow" } });
InlineHelpDirective.propDecorators = {
    singleRow: [{ type: Input }, { type: HostBinding, args: ['class.single-row',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InlineHelpDirective, [{
        type: Directive,
        args: [{
                // it doesn't have a template so it makes sense
                // to use Directive.
                // tslint:disable-next-line
                selector: 'pmcc-inline-help'
            }]
    }], function () { return []; }, { singleRow: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.single-row']
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/input</example-url>
 */
class InputDirective {
    constructor(elRef, parent, control) {
        this.elRef = elRef;
        this.parent = parent;
        this.control = control;
        this.controlSubscription = Subscription.EMPTY;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        /**
         * The next line is temporary fix for UD-2535
         * Remove this temporary fix after resolving UD-2652
         */
        this._val = this.elRef.nativeElement.value;
        this.notifyParent();
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    get readonly() {
        return this._readonly;
    }
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
    }
    ngOnInit() {
        this._val = this.elRef.nativeElement.value;
        this.notifyParent();
        if (this.control) {
            this.controlSubscription = this.control.valueChanges.subscribe(() => {
                if (this._val !== this.control.value) {
                    this._val = this.control.value;
                    this.notifyParent();
                }
            });
        }
    }
    ngOnDestroy() {
        this.controlSubscription.unsubscribe();
    }
    onInput(event) {
        const value = event.target.value;
        if (value !== this._val) {
            this._val = value;
            this.notifyParent();
        }
    }
    notifyParent() {
        if (this.parent) {
            const shouldShow = !this.disabled && this.hasValue();
            this.parent.showClearButton(shouldShow);
        }
    }
    hasValue() {
        return this._val == null ? false : !!this._val || this._val !== '';
    }
}
InputDirective.ɵfac = function InputDirective_Factory(t) { return new (t || InputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(InputComponent, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 9)); };
InputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InputDirective, selectors: [["input", "pmccInput", ""], ["textarea", "pmccInput", ""]], hostVars: 5, hostBindings: function InputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function InputDirective_input_HostBindingHandler($event) { return ctx.onInput($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.disabled)("required", ctx.required);
        ɵngcc0.ɵɵattribute("readonly", ctx.readonly)("id", ctx.id)("placeholder", ctx.placeholder);
    } }, inputs: { disabled: "disabled", required: "required", readonly: "readonly", id: "id", placeholder: "placeholder" }, exportAs: ["pmccInput"] });
InputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: InputComponent, decorators: [{ type: Optional }, { type: Host }] },
    { type: NgControl, decorators: [{ type: Optional }, { type: Host }] }
];
InputDirective.propDecorators = {
    id: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    placeholder: [{ type: Input }, { type: HostBinding, args: ['attr.placeholder',] }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['disabled',] }],
    required: [{ type: Input }, { type: HostBinding, args: ['required',] }],
    readonly: [{ type: Input }, { type: HostBinding, args: ['attr.readonly',] }],
    onInput: [{ type: HostListener, args: ['input', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[pmccInput], textarea[pmccInput]',
                exportAs: 'pmccInput'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: InputComponent, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }, { type: ɵngcc3.NgControl, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, { disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['disabled']
        }], required: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['required']
        }], readonly: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.readonly']
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], placeholder: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.placeholder']
        }] }); })();

class InputModule {
}
InputModule.ɵfac = function InputModule_Factory(t) { return new (t || InputModule)(); };
InputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InputModule });
InputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    InputComponent,
                    InputDirective,
                    AddonDirective,
                    InlineHelpDirective
                ],
                imports: [CommonModule, IconModule],
                exports: [InputComponent, InputDirective, AddonDirective, InlineHelpDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputModule, { declarations: function () { return [InputComponent, InputDirective, AddonDirective, InlineHelpDirective]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [InputComponent, InputDirective, AddonDirective, InlineHelpDirective]; } }); })();

/**
 * Service that ensures that there is only one open
 * popover at a time.
 */
class PopoverRegistry {
    popoverOpened(trigger) {
        if (this.openedPopoverTrigger) {
            this.openedPopoverTrigger.close();
        }
        this.openedPopoverTrigger = trigger;
    }
    popoverClosed(trigger) {
        if (this.openedPopoverTrigger === trigger) {
            this.openedPopoverTrigger = undefined;
        }
    }
}
PopoverRegistry.ɵfac = function PopoverRegistry_Factory(t) { return new (t || PopoverRegistry)(); };
PopoverRegistry.ɵprov = i0.ɵɵdefineInjectable({ factory: function PopoverRegistry_Factory() { return new PopoverRegistry(); }, token: PopoverRegistry, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const defaultTriggerEvent = 'click';
/**
 * Demo example
 * <example-url>/demo/#/pmcc/popover</example-url>
 */
class PopoverComponent {
    constructor() {
        this._hideCloseIcon = false;
        /**
         * Whether the component is currently hovered.
         * Used with pmccBindOn="hover" so that the popover
         * stays open when its trigger itself is not hovered.
         */
        this.hovering = false;
        /**
         * Event that opens the popover.
         */
        this.pmccBindOn = defaultTriggerEvent;
        this.close = new EventEmitter();
    }
    /**
     * Whether the close icon is hidden.
     * False by default.
     * When the close icon is shown, the popover has extra
     * padding on the right.
     */
    get hideCloseIcon() {
        return this._hideCloseIcon;
    }
    set hideCloseIcon(value) {
        this._hideCloseIcon = coerceBooleanProperty(value);
    }
    ngOnDestroy() {
        this.triggerClose();
    }
    onMouseEnter() {
        if (this.pmccBindOn === 'hover') {
            this.hovering = true;
        }
    }
    onMouseLeave() {
        if (this.pmccBindOn === 'hover') {
            this.hovering = false;
            this.triggerClose();
        }
    }
    triggerClose() {
        this.close.emit();
    }
}
PopoverComponent.ɵfac = function PopoverComponent_Factory(t) { return new (t || PopoverComponent)(); };
PopoverComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopoverComponent, selectors: [["pmcc-popover"]], viewQuery: function PopoverComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { pmccBindOn: "pmccBindOn", hideCloseIcon: "hideCloseIcon", positionOverride: "positionOverride" }, outputs: { close: "close" }, ngContentSelectors: _c1, decls: 1, vars: 0, consts: [["data-pm-id", "popover-container", 1, "pmcc-popover", 3, "mouseenter", "mouseleave"], ["data-pm-id", "popover-description"], ["class", "pmcc-popover-close-icon", "data-pm-id", "popover-close", 3, "click", 4, "ngIf"], ["data-pm-id", "popover-close", 1, "pmcc-popover-close-icon", 3, "click"]], template: function PopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, PopoverComponent_ng_template_0_Template, 4, 3, "ng-template");
    } }, directives: [ɵngcc1.NgIf], styles: ["pmcc-popover{display:none}.pmcc-popover{width:auto;max-width:500px;line-height:18px;position:relative;background:#fff;border:1px solid #b7b7b7;border-radius:5px;box-shadow:0 2px 8px #0000001f}.pmcc-popover pmcc-toolbar{display:block;text-align:right;margin-top:10px}.pmcc-popover:after,.pmcc-popover:before{border:solid #0000;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.pmcc-popover>p{max-width:620px;max-height:500px;color:#464646;font:normal 12px Arial,Helvetica,Calibri,sans-serif;padding:20px 30px 15px 15px;margin:0;position:relative;overflow:auto}.pmcc-popover .pmcc-popover-close-icon{position:absolute;top:5px;right:8px}.pmcc-popover .pmcc-popover-close-icon:before{position:relative;font-family:pmcc-ico;content:\"e\";font-size:12px;color:#b3c0cd}.pmcc-popover .pmcc-popover-close-icon:hover{cursor:pointer}.pmcc-popover .pmcc-popover-close-icon:hover:before{color:#0085cc}.pmcc-popover.pmcc-close-icon-hidden>p{padding:15px}.pmcc-popover.pmcc-no-pad>p{padding:0!important}.pmcc-overlay-pane.northcentral .pmcc-popover:after,.pmcc-overlay-pane.northcentral .pmcc-popover:before,.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.northwest .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:before{top:100%;left:50%}.pmcc-overlay-pane.northcentral .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:after{border-top-color:#fff;border-width:10px;margin-left:-10px}.pmcc-overlay-pane.northcentral .pmcc-popover:before,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.northwest .pmcc-popover:before{border-top-color:#b7b7b7;border-width:11px;margin-left:-11px}.pmcc-overlay-pane.southcentral .pmcc-popover:after,.pmcc-overlay-pane.southcentral .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:before{bottom:100%;left:50%}.pmcc-overlay-pane.southcentral .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:after{border-bottom-color:#fff;border-width:10px;margin-left:-10px}.pmcc-overlay-pane.southcentral .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:before{border-bottom-color:#b7b7b7;border-width:11px;margin-left:-11px}.pmcc-overlay-pane.northwest .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:before{left:30px;right:auto}.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:before{left:auto;right:20px}.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:after{right:21px}"], encapsulation: 2 });
PopoverComponent.propDecorators = {
    templateRef: [{ type: ViewChild, args: [TemplateRef,] }],
    positionOverride: [{ type: Input }],
    pmccBindOn: [{ type: Input }],
    hideCloseIcon: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-popover',
                template: "<ng-template>\n  <div\n    class=\"pmcc-popover\"\n    [class.pmcc-close-icon-hidden]=\"hideCloseIcon\"\n    (mouseenter)=\"onMouseEnter()\"\n    (mouseleave)=\"onMouseLeave()\"\n    data-pm-id=\"popover-container\"\n  >\n    <p data-pm-id=\"popover-description\">\n      <ng-content></ng-content>\n    </p>\n    <span\n      *ngIf=\"!hideCloseIcon\"\n      class=\"pmcc-popover-close-icon\"\n      (click)=\"triggerClose()\"\n      data-pm-id=\"popover-close\"\n    ></span>\n  </div>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["pmcc-popover{display:none}.pmcc-popover{width:auto;max-width:500px;line-height:18px;position:relative;background:#fff;border:1px solid #b7b7b7;border-radius:5px;box-shadow:0 2px 8px #0000001f}.pmcc-popover pmcc-toolbar{display:block;text-align:right;margin-top:10px}.pmcc-popover:after,.pmcc-popover:before{border:solid #0000;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.pmcc-popover>p{max-width:620px;max-height:500px;color:#464646;font:normal 12px Arial,Helvetica,Calibri,sans-serif;padding:20px 30px 15px 15px;margin:0;position:relative;overflow:auto}.pmcc-popover .pmcc-popover-close-icon{position:absolute;top:5px;right:8px}.pmcc-popover .pmcc-popover-close-icon:before{position:relative;font-family:pmcc-ico;content:\"e\";font-size:12px;color:#b3c0cd}.pmcc-popover .pmcc-popover-close-icon:hover{cursor:pointer}.pmcc-popover .pmcc-popover-close-icon:hover:before{color:#0085cc}.pmcc-popover.pmcc-close-icon-hidden>p{padding:15px}.pmcc-popover.pmcc-no-pad>p{padding:0!important}.pmcc-overlay-pane.northcentral .pmcc-popover:after,.pmcc-overlay-pane.northcentral .pmcc-popover:before,.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.northwest .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:before{top:100%;left:50%}.pmcc-overlay-pane.northcentral .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:after{border-top-color:#fff;border-width:10px;margin-left:-10px}.pmcc-overlay-pane.northcentral .pmcc-popover:before,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.northwest .pmcc-popover:before{border-top-color:#b7b7b7;border-width:11px;margin-left:-11px}.pmcc-overlay-pane.southcentral .pmcc-popover:after,.pmcc-overlay-pane.southcentral .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:before{bottom:100%;left:50%}.pmcc-overlay-pane.southcentral .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:after{border-bottom-color:#fff;border-width:10px;margin-left:-10px}.pmcc-overlay-pane.southcentral .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:before{border-bottom-color:#b7b7b7;border-width:11px;margin-left:-11px}.pmcc-overlay-pane.northwest .pmcc-popover:after,.pmcc-overlay-pane.northwest .pmcc-popover:before,.pmcc-overlay-pane.southwest .pmcc-popover:after,.pmcc-overlay-pane.southwest .pmcc-popover:before{left:30px;right:auto}.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.northeast .pmcc-popover:before,.pmcc-overlay-pane.southeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:before{left:auto;right:20px}.pmcc-overlay-pane.northeast .pmcc-popover:after,.pmcc-overlay-pane.southeast .pmcc-popover:after{right:21px}"]
            }]
    }], function () { return []; }, { pmccBindOn: [{
            type: Input
        }], close: [{
            type: Output
        }], hideCloseIcon: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: [TemplateRef]
        }], positionOverride: [{
            type: Input
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/popover</example-url>
 * Directive that shows a popover using a component reference
 * that is supplied to it as as input.
 * Usage:
 * ```
 *   <button [pmccPopoverTrigger]="popover">Open the popover</button>
 *   <pmcc-popover #popover [hideCloseIcon]="hideCloseButton">
 *     Popover content
 *   </pmcc-popover>
 * ```
 */
class PopoverTriggerDirective {
    constructor(element, viewContainerRef, overlayService, registry) {
        this.element = element;
        this.viewContainerRef = viewContainerRef;
        this.overlayService = overlayService;
        this.registry = registry;
        this._isOpen = false;
        this.closeTimerId = null;
        this.closeSubscription = Subscription.EMPTY;
        this.closeOnClickOutside = true;
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
    }
    get isOpen() {
        return this._isOpen;
    }
    get bindOn() {
        return this.pmccBindOn || this.popover.pmccBindOn || defaultTriggerEvent;
    }
    get pmccPopoverDisabled() {
        return this._pmccPopoverDisabled;
    }
    set pmccPopoverDisabled(disabled) {
        this._pmccPopoverDisabled = coerceBooleanProperty$1(disabled);
        if (this._isOpen && disabled) {
            // to avoid ExpresionChanged error
            Promise.resolve().then(() => this.close());
        }
    }
    ngAfterViewInit() {
        if (!this.popover) {
            throw new Error(`pmccPopoverTrigger: you need to pass a PopoverComponent instance.
      Example:
        <button [pmccPopoverTrigger]="popover"></button>
        <pmcc-popover #popover></pmcc-popover>
      `);
        }
        this.popover.close.subscribe(() => {
            // close the popover if it was requested from the component itself
            this.close();
        });
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
        this.closeSubscription.unsubscribe();
    }
    open() {
        if (!this._isOpen && !this._pmccPopoverDisabled) {
            const overlay = this.createOverlay();
            overlay.attach(this.portal);
            this.closeSubscription = overlay.close.subscribe(() => this.close());
            this._isOpen = true;
            this.popover.pmccBindOn = this.bindOn;
            // register the popover.
            this.registry.popoverOpened(this);
            this.opened.emit();
        }
    }
    close() {
        if (this._isOpen && this.overlayRef) {
            this.overlayRef.detach();
            this._isOpen = false;
            this.registry.popoverClosed(this);
            this.closed.emit();
        }
    }
    onClick() {
        if (this.bindOn === 'click') {
            // toggle popover on click
            if (this._isOpen) {
                this.close();
            }
            else {
                this.open();
            }
        }
    }
    onMouseEnter() {
        if (this.bindOn === 'hover') {
            this.open();
            clearTimeout(this.closeTimerId);
        }
    }
    onMouseLeave() {
        const WAIT_TIME_TO_CLOSE = 200;
        // When the mouse leave the trigger
        if (this.bindOn === 'hover') {
            clearTimeout(this.closeTimerId);
            // the user maybe reaching for the popover component.
            // So we wait a bit before closing
            this.closeTimerId = setTimeout(() => {
                // don't close if the mouse is indeed hovering the popover component
                if (!this.popover.hovering) {
                    this.close();
                }
            }, WAIT_TIME_TO_CLOSE);
        }
    }
    onWindowResize() {
        if (this._isOpen) {
            // close the popover when window is resized
            this.close();
        }
    }
    createOverlay() {
        this.portal = {
            templateRef: this.popover.templateRef,
            viewContainerRef: this.viewContainerRef
        };
        const { scrollStrategies } = this.overlayService;
        const element = this.element.nativeElement;
        const { positionOverride } = this.popover;
        const scrollStrategy = this.pmccScrollStrategyOverride
            ? scrollStrategies.fromString(this.pmccScrollStrategyOverride)
            : scrollStrategies.reposition();
        const positions = positionOverride == null
            ? compassPositions
            : [compassPositions.find(p => p.panelClassName === positionOverride)];
        const positionStrategy = this.overlayService
            .position()
            .connectedTo(element)
            .withPositions(positions);
        this.overlayRef = this.overlayService.create(positionStrategy, scrollStrategy, {
            backdrop: this.bindOn === 'click'
                ? BackDrop.TRANSPARENT
                : BackDrop.NONE,
            closeOnClickOutside: this.closeOnClickOutside,
        });
        this.overlayRef.detachments.subscribe(() => this.close());
        return this.overlayRef;
    }
}
PopoverTriggerDirective.ɵfac = function PopoverTriggerDirective_Factory(t) { return new (t || PopoverTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(OverlayService), ɵngcc0.ɵɵdirectiveInject(PopoverRegistry)); };
PopoverTriggerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PopoverTriggerDirective, selectors: [["", "pmccPopoverTrigger", ""]], hostBindings: function PopoverTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PopoverTriggerDirective_click_HostBindingHandler() { return ctx.onClick(); })("mouseenter", function PopoverTriggerDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function PopoverTriggerDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); })("resize", function PopoverTriggerDirective_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { closeOnClickOutside: "closeOnClickOutside", pmccPopoverDisabled: "pmccPopoverDisabled", popover: ["pmccPopoverTrigger", "popover"], pmccBindOn: "pmccBindOn", pmccScrollStrategyOverride: "pmccScrollStrategyOverride" }, outputs: { opened: "opened", closed: "closed" }, exportAs: ["pmccPopoverTrigger"] });
PopoverTriggerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ViewContainerRef },
    { type: OverlayService },
    { type: PopoverRegistry }
];
PopoverTriggerDirective.propDecorators = {
    popover: [{ type: Input, args: ['pmccPopoverTrigger',] }],
    pmccBindOn: [{ type: Input }],
    pmccScrollStrategyOverride: [{ type: Input }],
    closeOnClickOutside: [{ type: Input }],
    opened: [{ type: Output }],
    closed: [{ type: Output }],
    pmccPopoverDisabled: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onMouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
    onMouseLeave: [{ type: HostListener, args: ['mouseleave',] }],
    onWindowResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccPopoverTrigger]',
                exportAs: 'pmccPopoverTrigger'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: OverlayService }, { type: PopoverRegistry }]; }, { closeOnClickOutside: [{
            type: Input
        }], opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], pmccPopoverDisabled: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize']
        }], popover: [{
            type: Input,
            args: ['pmccPopoverTrigger']
        }], pmccBindOn: [{
            type: Input
        }], pmccScrollStrategyOverride: [{
            type: Input
        }] }); })();

/**
 *
 * Demo example
 * <example-url>/demo/#/pmcc/popover</example-url>
 * Closes popover when clicked. Usage:
 * ```
 *   <pmcc-popover>
 *     <button pmccPopoverDismiss>Dismiss</button>
 *   </pmcc-popover>
 * ```
 */
class PopoverDismissDirective {
    constructor(popover) {
        this.popover = popover;
    }
    onClick() {
        if (this.popover) {
            this.popover.triggerClose();
        }
    }
}
PopoverDismissDirective.ɵfac = function PopoverDismissDirective_Factory(t) { return new (t || PopoverDismissDirective)(ɵngcc0.ɵɵdirectiveInject(PopoverComponent, 9)); };
PopoverDismissDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PopoverDismissDirective, selectors: [["", "pmccPopoverDismiss", ""]], hostBindings: function PopoverDismissDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PopoverDismissDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, exportAs: ["pmccPopoverDismiss"] });
PopoverDismissDirective.ctorParameters = () => [
    { type: PopoverComponent, decorators: [{ type: Optional }, { type: Host }] }
];
PopoverDismissDirective.propDecorators = {
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverDismissDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccPopoverDismiss]',
                exportAs: 'pmccPopoverDismiss'
            }]
    }], function () { return [{ type: PopoverComponent, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class PopoverModule {
}
PopoverModule.ɵfac = function PopoverModule_Factory(t) { return new (t || PopoverModule)(); };
PopoverModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PopoverModule });
PopoverModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LayoutModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PopoverComponent,
                    PopoverTriggerDirective,
                    PopoverDismissDirective,
                ],
                imports: [
                    CommonModule,
                    LayoutModule,
                ],
                exports: [PopoverComponent, PopoverTriggerDirective, PopoverDismissDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PopoverModule, { declarations: function () { return [PopoverComponent, PopoverTriggerDirective, PopoverDismissDirective]; }, imports: function () { return [CommonModule, LayoutModule]; }, exports: function () { return [PopoverComponent, PopoverTriggerDirective, PopoverDismissDirective]; } }); })();

/**
 * This is used to solve circular dependency issue.
 * DatePicker uses DatePickerField as a @ViewChild() and
 * DatePickerField injects DatePicker to communicate with it.
 */
const PARENT_DATE_PICKER = new InjectionToken('DatePicker');

const MONTHS_IN_YEAR = 12;
function dateToLocaleString(date, locale) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return locale === 'en-us'
        ? `${month}/${day}/${year}`
        : `${day}/${month}/${year}`;
}
function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
// TODO: This can be removed. input is readonly
function parseStringToDate(displayString, locale) {
    const dateRegEx = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/g;
    let parts;
    let date;
    if (dateRegEx.test(displayString)) {
        parts = displayString.split('/');
        const year = +parts[2];
        const month = parts[locale === 'en-us' ? 0 : 1] - 1;
        const day = +parts[locale === 'en-us' ? 1 : 0];
        if (month < MONTHS_IN_YEAR) {
            if (day <= daysInMonth(year, month)) {
                date = new Date(year, month, day);
            }
        }
    }
    return date;
}
/**
 * Demo example
 * <example-url>/demo/#/pmcc/date-picker</example-url>
 */
class DatePickerFieldComponent {
    constructor(window, 
    // TODO: parentDatePicker can be removed
    parentDatePicker) {
        this.parentDatePicker = parentDatePicker;
        this.disabledColor = 'gray-lt';
        this.enabledColor = 'blue-md';
        this._displayString = '';
        this.isFocused = false;
        this.disabled = false;
        this.monthPickerFlag = false;
        this.width = 100;
        // Wanted these outputs to resemble the native ones,
        // but `focus` and `blur` are already taken by the methods.
        // Thus the renaming.
        // tslint:disable-next-line:no-output-on-prefix no-output-rename
        this.focus$ = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix no-output-rename
        this.blur$ = new EventEmitter();
        /**
         * Whether input's value is an invalid date.
         */
        this.invalidDate = false;
        this.locale = window.navigator.language.toLowerCase();
    }
    set date(date) {
        if (date) {
            const startOfDay = new Date(date);
            startOfDay.setHours(0, 0, 0, 0);
            this._date = startOfDay;
            this._displayString = this.monthPickerFlag
                ? this.monthToString(this._date)
                : dateToLocaleString(this._date, this.locale);
            this.invalidDate = !isValidDate(startOfDay, this.minDate, this.maxDate);
        }
        else {
            this._date = undefined;
            this._displayString = '';
        }
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    /**
     * String representation of the date displayed in the input.
     */
    get displayString() {
        return this._displayString;
    }
    /**
     * Whether the input should be in error state.
     * Error state should not be shown when focused.
     */
    get hasError() {
        return this.invalidDate && !this.isFocused;
    }
    /**
     * Focus the native input element
     */
    focus() {
        this.inputEl.nativeElement.focus();
    }
    /**
     * Blur the native input element
     */
    blur() {
        this.inputEl.nativeElement.blur();
    }
    onInput(event) {
        this._displayString = event.target.value;
    }
    onFocus() {
        this.isFocused = true;
        this.focus$.emit();
    }
    // TODO: This can be removed
    onBlur() {
        this.isFocused = false;
        const date = this.monthPickerFlag
            ? this._date
            : parseStringToDate(this.displayString, this.locale);
        this.invalidDate = !this.isValidInputValue(date);
        // if the new date is valid and is different,
        // we need to notify the date picker component about the change
        if (!this.invalidDate && this.shouldTriggerChange(date)) {
            if (this.parentDatePicker) {
                this.parentDatePicker.onDateChange(date);
            }
        }
        this.blur$.emit();
    }
    openPopover(e) {
        // prevent events from reaching the popover
        // otherwise it will close shortly after it is opened
        e.stopPropagation();
        this.onFocus();
    }
    onEnter() {
        // blur the input when enter is pressed
        // to apply any changes and close the popover
        this.inputEl.nativeElement.blur();
    }
    monthToString(date) {
        const month = months[date.getMonth()].label;
        const year = date.getFullYear();
        return `${month} ${year}`;
    }
    isValidInputValue(date) {
        const validDate = isValidDate(date, this.minDate, this.maxDate);
        if (this.required) {
            return this.displayString.length > 0 && validDate;
        }
        return this.displayString === '' || validDate;
    }
    // TODO: This can be removed
    shouldTriggerChange(date) {
        if (!this._date && !date) {
            return false;
        }
        return !this._date || !date || this._date.getTime() !== date.getTime();
    }
}
DatePickerFieldComponent.ɵfac = function DatePickerFieldComponent_Factory(t) { return new (t || DatePickerFieldComponent)(ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(PARENT_DATE_PICKER, 8)); };
DatePickerFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatePickerFieldComponent, selectors: [["pmcc-date-picker-field"]], viewQuery: function DatePickerFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c33, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
    } }, inputs: { disabled: "disabled", monthPickerFlag: "monthPickerFlag", width: "width", date: "date", required: "required", minDate: "minDate", maxDate: "maxDate" }, outputs: { focus$: "focus", blur$: "blur" }, decls: 5, vars: 11, consts: [[3, "click"], ["type", "text", "readonly", "", 3, "disabled", "value", "required", "input", "focus", "blur", "keyup.enter"], ["input", ""], ["align", "after", 3, "ngClass"], ["name", "calendar", 3, "color"]], template: function DatePickerFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pmcc-input", 0);
        ɵngcc0.ɵɵlistener("click", function DatePickerFieldComponent_Template_pmcc_input_click_0_listener($event) { return ctx.openPopover($event); });
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("input", function DatePickerFieldComponent_Template_input_input_1_listener($event) { return ctx.onInput($event); })("focus", function DatePickerFieldComponent_Template_input_focus_1_listener() { return ctx.onFocus(); })("blur", function DatePickerFieldComponent_Template_input_blur_1_listener() { return ctx.onBlur(); })("keyup.enter", function DatePickerFieldComponent_Template_input_keyup_enter_1_listener() { return ctx.onEnter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "pmcc-addon", 3);
        ɵngcc0.ɵɵelement(4, "pmcc-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-error", ctx.hasError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("value", ctx.displayString)("required", ctx.required);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c34, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.disabled ? ctx.disabledColor : ctx.enabledColor);
    } }, directives: [InputComponent, AddonDirective, ɵngcc1.NgClass, IconComponent], styles: ["[_nghost-%COMP%]{display:inline-block}pmcc-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{outline:0!important;border-color:#c9c9c9}pmcc-input[_ngcontent-%COMP%]   pmcc-addon[_ngcontent-%COMP%]{cursor:pointer;background:#fff;color:#0499d3;font-size:17px;padding-top:3px;padding-left:4px;padding-right:4px;border-radius:0 3px 3px 0;margin-right:-4px;z-index:1}pmcc-input[_ngcontent-%COMP%]   pmcc-addon[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:before, pmcc-input[_ngcontent-%COMP%]   pmcc-addon[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{width:auto}pmcc-input[_ngcontent-%COMP%]:hover   pmcc-addon[_ngcontent-%COMP%]{background-color:#f8f7f7}pmcc-input[_ngcontent-%COMP%]:focus{border-color:#0085cc;outline:0!important;border-right:1px solid #0085cc}pmcc-input.pmcc-error[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:1px solid #d7494e}pmcc-input.pmcc-error[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline-color:#d7494e}.cursor-default[_ngcontent-%COMP%]{cursor:default!important}"] });
DatePickerFieldComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [PARENT_DATE_PICKER,] }] }
];
DatePickerFieldComponent.propDecorators = {
    inputEl: [{ type: ViewChild, args: ['input', { static: true },] }],
    disabled: [{ type: Input }],
    monthPickerFlag: [{ type: Input }],
    width: [{ type: Input }],
    date: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    required: [{ type: Input }],
    focus$: [{ type: Output, args: ['focus',] }],
    blur$: [{ type: Output, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerFieldComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-date-picker-field',
                template: "<pmcc-input [class.pmcc-error]=\"hasError\" (click)=\"openPopover($event)\">\n  <input\n    #input\n    type=\"text\"\n    [disabled]=\"disabled\"\n    (input)=\"onInput($event)\"\n    [value]=\"displayString\"\n    [required]=\"required\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    (keyup.enter)=\"onEnter()\"\n    readonly\n    [style.width.px]=\"width\"\n    />\n  <pmcc-addon align=\"after\" [ngClass]=\"{'cursor-default': disabled}\">\n    <pmcc-icon name=\"calendar\" [color]=\"disabled ? disabledColor : enabledColor\"></pmcc-icon>\n  </pmcc-addon>\n</pmcc-input>\n",
                styles: [":host{display:inline-block}pmcc-input input{outline:0!important;border-color:#c9c9c9}pmcc-input pmcc-addon{cursor:pointer;background:#fff;color:#0499d3;font-size:17px;padding-top:3px;padding-left:4px;padding-right:4px;border-radius:0 3px 3px 0;margin-right:-4px;z-index:1}pmcc-input pmcc-addon :before,pmcc-input pmcc-addon>*{width:auto}pmcc-input:hover pmcc-addon{background-color:#f8f7f7}pmcc-input:focus{border-color:#0085cc;outline:0!important;border-right:1px solid #0085cc}pmcc-input.pmcc-error input{border:1px solid #d7494e}pmcc-input.pmcc-error input:focus{outline-color:#d7494e}.cursor-default{cursor:default!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [PARENT_DATE_PICKER]
            }] }]; }, { disabled: [{
            type: Input
        }], monthPickerFlag: [{
            type: Input
        }], width: [{
            type: Input
        }], focus$: [{
            type: Output,
            args: ['focus']
        }], blur$: [{
            type: Output,
            args: ['blur']
        }], date: [{
            type: Input
        }], required: [{
            type: Input
        }], inputEl: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }] }); })();

const DATE_RANGE_PICKER = new InjectionToken('DATE_RANGE_PICKER');

/**
 * Demo example
 * <example-url>/demo/#/pmcc/date-picker</example-url>
 */
class DatePickerComponent {
    constructor(parentDateRangePicker) {
        this.parentDateRangePicker = parentDateRangePicker;
        this.disabled = false;
        this.readOnly = false;
        this.openAt = 'StartDate';
        this.minDateTooltip = '';
        this.maxDateTooltip = '';
        /**
         * Emitted when the date changes
         */
        this.dateChange = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
    }
    get date() {
        return this._date;
    }
    set date(value) {
        this._date = value;
        if (this.parentDateRangePicker) {
            this.parentDateRangePicker.onDateChanged(this);
        }
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    focus() {
        this.datePickerField.focus();
    }
    blur() {
        this.datePickerField.blur();
    }
    onDateChange(date) {
        this._date = date;
        this.popoverTrigger.close();
        this.dateChange.emit(date);
        this.onModelChange(date);
        this.onTouched();
        if (this.parentDateRangePicker) {
            this.parentDateRangePicker.onDateChangeWithUserInput(this);
        }
    }
    onFieldFocus() {
        if (!this.popoverTrigger.isOpen && !this.readOnly && !this.disabled) {
            this.calendarComponent.goToCurrentMonth();
            // open the popover when the date picker field is focused
            this.popoverTrigger.open();
        }
    }
    onKeyDown(event) {
        if (event.key === 'Tab' && this.popoverTrigger.isOpen) {
            // close the popover when the date picker field is blurred
            this.popoverTrigger.close();
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(date) {
        if (date !== this._date) {
            this._date = date;
            if (this.parentDateRangePicker) {
                this.parentDateRangePicker.onDateChanged(this);
            }
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DatePickerComponent.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(DATE_RANGE_PICKER, 8)); };
DatePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["pmcc-date-picker"]], viewQuery: function DatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DatePickerFieldComponent, 5);
        ɵngcc0.ɵɵviewQuery(PopoverTriggerDirective, 5);
        ɵngcc0.ɵɵviewQuery(CalendarComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickerField = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popoverTrigger = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.calendarComponent = _t.first);
    } }, inputs: { disabled: "disabled", readOnly: "readOnly", openAt: "openAt", minDateTooltip: "minDateTooltip", maxDateTooltip: "maxDateTooltip", date: "date", required: "required", minDate: "minDate", maxDate: "maxDate", startDate: "startDate", endDate: "endDate", positionOverride: "positionOverride" }, outputs: { dateChange: "dateChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DatePickerComponent)
            }
        ], [
            {
                provide: PARENT_DATE_PICKER,
                useExisting: forwardRef(() => DatePickerComponent)
            },
        ])], decls: 5, vars: 10, consts: [[3, "ngIf"], ["hideCloseIcon", "", 3, "positionOverride"], ["popover", ""], ["data-pm-id", "date-picker-calendar", 3, "startDate", "endDate", "minDate", "maxDate", "openAt", "minDateTooltip", "maxDateTooltip", "selectedDateChanged"], [3, "date", "disabled"], [3, "pmccPopoverTrigger", "date", "required", "minDate", "maxDate", "focus", "keydown"]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DatePickerComponent_ng_template_0_Template, 1, 2, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, DatePickerComponent_ng_template_1_Template, 1, 5, "ng-template", 0);
        ɵngcc0.ɵɵelementStart(2, "pmcc-popover", 1, 2);
        ɵngcc0.ɵɵelementStart(4, "pmcc-calendar", 3);
        ɵngcc0.ɵɵlistener("selectedDateChanged", function DatePickerComponent_Template_pmcc_calendar_selectedDateChanged_4_listener($event) { return ctx.onDateChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly || ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.readOnly && !ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("positionOverride", ctx.positionOverride);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("startDate", ctx.startDate || ctx.date)("endDate", ctx.endDate || ctx.date)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("openAt", ctx.openAt)("minDateTooltip", ctx.minDateTooltip)("maxDateTooltip", ctx.maxDateTooltip);
    } }, directives: [ɵngcc1.NgIf, PopoverComponent, CalendarComponent, DatePickerFieldComponent, PopoverTriggerDirective], encapsulation: 2 });
DatePickerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DATE_RANGE_PICKER,] }] }
];
DatePickerComponent.propDecorators = {
    disabled: [{ type: Input }],
    readOnly: [{ type: Input }],
    datePickerField: [{ type: ViewChild, args: [DatePickerFieldComponent,] }],
    popoverTrigger: [{ type: ViewChild, args: [PopoverTriggerDirective,] }],
    calendarComponent: [{ type: ViewChild, args: [CalendarComponent, { static: true },] }],
    date: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    startDate: [{ type: Input }],
    endDate: [{ type: Input }],
    positionOverride: [{ type: Input }],
    required: [{ type: Input }],
    openAt: [{ type: Input }],
    minDateTooltip: [{ type: Input }],
    maxDateTooltip: [{ type: Input }],
    dateChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-date-picker',
                template: "<ng-template [ngIf]=\"readOnly || disabled\">\n  <pmcc-date-picker-field\n    [date]=\"date\"\n    [disabled]=\"disabled\"\n  ></pmcc-date-picker-field>\n</ng-template>\n<ng-template [ngIf]=\"!readOnly && !disabled\">\n  <pmcc-date-picker-field\n    [pmccPopoverTrigger]=\"popover\"\n    [date]=\"date\"\n    [required]=\"required\"\n    [minDate]=\"minDate\"\n    [maxDate]=\"maxDate\"\n    (focus)=\"onFieldFocus()\"\n    (keydown)=\"onKeyDown($event)\"\n  ></pmcc-date-picker-field>\n</ng-template>\n<pmcc-popover #popover hideCloseIcon [positionOverride]=\"positionOverride\">\n  <pmcc-calendar\n    [startDate]=\"startDate || date\"\n    [endDate]=\"endDate || date\"\n    [minDate]=\"minDate\"\n    [maxDate]=\"maxDate\"\n    [openAt]=\"openAt\"\n    [minDateTooltip]=\"minDateTooltip\"\n    [maxDateTooltip]=\"maxDateTooltip\"\n    (selectedDateChanged)=\"onDateChange($event)\"\n    data-pm-id=\"date-picker-calendar\"\n  ></pmcc-calendar>\n</pmcc-popover>\n",
                viewProviders: [
                    {
                        provide: PARENT_DATE_PICKER,
                        useExisting: forwardRef(() => DatePickerComponent)
                    },
                ],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DatePickerComponent)
                    }
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DATE_RANGE_PICKER]
            }] }]; }, { disabled: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], openAt: [{
            type: Input
        }], minDateTooltip: [{
            type: Input
        }], maxDateTooltip: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], date: [{
            type: Input
        }], required: [{
            type: Input
        }], datePickerField: [{
            type: ViewChild,
            args: [DatePickerFieldComponent]
        }], popoverTrigger: [{
            type: ViewChild,
            args: [PopoverTriggerDirective]
        }], calendarComponent: [{
            type: ViewChild,
            args: [CalendarComponent, { static: true }]
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], positionOverride: [{
            type: Input
        }] }); })();

class DatePickerModule {
}
DatePickerModule.ɵfac = function DatePickerModule_Factory(t) { return new (t || DatePickerModule)(); };
DatePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DatePickerModule });
DatePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            InputModule,
            PopoverModule,
            CalendarModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [DatePickerComponent, DatePickerFieldComponent],
                imports: [
                    CommonModule,
                    InputModule,
                    PopoverModule,
                    CalendarModule,
                    IconModule
                ],
                exports: [DatePickerComponent, DatePickerFieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DatePickerModule, { declarations: function () { return [DatePickerComponent, DatePickerFieldComponent]; }, imports: function () { return [CommonModule, InputModule, PopoverModule, CalendarModule, IconModule]; }, exports: function () { return [DatePickerComponent, DatePickerFieldComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/date-range-picker</example-url>
 */
class DateRangePickerComponent {
    constructor() {
        this.startDateChange = new EventEmitter();
        this.endDateChange = new EventEmitter();
    }
    /**
     * Reference to the start date picker
     */
    get startPicker() {
        return this.datePickers.first;
    }
    /**
     * Reference to the end date picker
     */
    get endPicker() {
        return this.datePickers.last;
    }
    ngAfterContentInit() {
        const count = this.datePickers.length;
        if (count !== 2) {
            throw new Error(`Date Range Picker: Expected to have two child Date-Pickers, got ${count}`);
        }
        this.setStartAndEndDateForPickers();
        this.startPicker.openAt = 'StartDate';
        this.endPicker.openAt = 'EndDate';
    }
    onDateChanged(picker) {
        if (this.datePickers) {
            if (picker === this.startPicker) {
                this.onStartDateChange(picker.date);
            }
            else {
                this.onEndDateChange(picker.date);
            }
        }
    }
    onDateChangeWithUserInput(picker) {
        this.onDateChanged(picker);
        if (picker === this.startPicker) {
            this.endPicker.focus();
        }
        else {
            picker.blur();
        }
    }
    onStartDateChange(date) {
        this.setStartDateAndEmitChange(date);
        if (!!date && date > this.endDate) {
            this.setEndDateAndEmitChange(date);
        }
        this.setStartAndEndDateForPickers();
    }
    onEndDateChange(date) {
        this.setEndDateAndEmitChange(date);
        if (!!date && date < this.startDate) {
            this.setStartDateAndEmitChange(date);
        }
        this.setStartAndEndDateForPickers();
    }
    setStartDateAndEmitChange(date) {
        this.startDate = date;
        this.startDateChange.emit(date);
    }
    setEndDateAndEmitChange(date) {
        this.endDate = date;
        this.endDateChange.emit(date);
    }
    setStartAndEndDateForPickers() {
        this.startPicker.startDate = this.startDate;
        this.startPicker.endDate =
            this.startDate == null ? undefined : this.endDate;
        this.endPicker.startDate =
            this.endDate == null ? undefined : this.startDate;
        this.endPicker.endDate = this.endDate;
    }
}
DateRangePickerComponent.ɵfac = function DateRangePickerComponent_Factory(t) { return new (t || DateRangePickerComponent)(); };
DateRangePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateRangePickerComponent, selectors: [["pmcc-date-range-picker"]], contentQueries: function DateRangePickerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DatePickerComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickers = _t);
    } }, inputs: { startDate: "startDate", endDate: "endDate" }, outputs: { startDateChange: "startDateChange", endDateChange: "endDateChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: DATE_RANGE_PICKER,
                useExisting: forwardRef(() => DateRangePickerComponent)
            }
        ])], ngContentSelectors: _c1, decls: 1, vars: 0, template: function DateRangePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
DateRangePickerComponent.propDecorators = {
    datePickers: [{ type: ContentChildren, args: [DatePickerComponent, { descendants: true },] }],
    startDate: [{ type: Input }],
    endDate: [{ type: Input }],
    startDateChange: [{ type: Output }],
    endDateChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateRangePickerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-date-range-picker',
                template: "<ng-content></ng-content>\n",
                providers: [
                    {
                        provide: DATE_RANGE_PICKER,
                        useExisting: forwardRef(() => DateRangePickerComponent)
                    }
                ]
            }]
    }], function () { return []; }, { startDateChange: [{
            type: Output
        }], endDateChange: [{
            type: Output
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], datePickers: [{
            type: ContentChildren,
            args: [DatePickerComponent, { descendants: true }]
        }] }); })();

class DateRangePickerModule {
}
DateRangePickerModule.ɵfac = function DateRangePickerModule_Factory(t) { return new (t || DateRangePickerModule)(); };
DateRangePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DateRangePickerModule });
DateRangePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateRangePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [DateRangePickerComponent],
                imports: [CommonModule],
                exports: [DateRangePickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DateRangePickerModule, { declarations: function () { return [DateRangePickerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DateRangePickerComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/dayofweek</example-url>
 */
class DayofweekComponent {
}
DayofweekComponent.ɵfac = function DayofweekComponent_Factory(t) { return new (t || DayofweekComponent)(); };
DayofweekComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DayofweekComponent, selectors: [["pmcc-dayofweek"]], inputs: { model: "model" }, decls: 2, vars: 1, consts: [[1, "pmcc-dayofweek"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"]], template: function DayofweekComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, DayofweekComponent_li_1_Template, 2, 5, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".pmcc-dayofweek[_ngcontent-%COMP%]{display:flex;list-style:none;padding:0;margin:0}.pmcc-dayofweek[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;background:#f5f5f5;color:#c9c9c9;border-radius:3px;height:20px;width:20px;font:normal 13px/16px Helvetica,Arial,Calibri,sans-serif}.pmcc-dayofweek[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]{margin-left:5px}.pmcc-dayofweek[_ngcontent-%COMP%]   li.selected[_ngcontent-%COMP%]{background:#e2f4fe;color:#222121}"] });
DayofweekComponent.propDecorators = {
    model: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DayofweekComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-dayofweek',
                template: "<ul class=\"pmcc-dayofweek\">\n  <li\n    *ngFor=\"let day of model\"\n    [ngClass]=\"{ selected: day.selected }\"\n    [attr.data-pm-id]=\"day.label\"\n  >\n    {{ day.label }}\n  </li>\n</ul>\n",
                styles: [".pmcc-dayofweek{display:flex;list-style:none;padding:0;margin:0}.pmcc-dayofweek li{display:flex;justify-content:center;align-items:center;background:#f5f5f5;color:#c9c9c9;border-radius:3px;height:20px;width:20px;font:normal 13px/16px Helvetica,Arial,Calibri,sans-serif}.pmcc-dayofweek li+li{margin-left:5px}.pmcc-dayofweek li.selected{background:#e2f4fe;color:#222121}"]
            }]
    }], null, { model: [{
            type: Input
        }] }); })();

class DayofweekModule {
}
DayofweekModule.ɵfac = function DayofweekModule_Factory(t) { return new (t || DayofweekModule)(); };
DayofweekModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DayofweekModule });
DayofweekModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DayofweekModule, [{
        type: NgModule,
        args: [{
                declarations: [DayofweekComponent],
                imports: [CommonModule],
                exports: [DayofweekComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DayofweekModule, { declarations: function () { return [DayofweekComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DayofweekComponent]; } }); })();

const TOTAL_HOURS_IN_DAY = 24;
/**
 * Demo example
 * <example-url>/demo/#/pmcc/dayparter</example-url>
 */
class DayparterComponent {
    constructor() {
        this.selectedTimes = [];
        this.change = new EventEmitter();
        this.hours = new Array(TOTAL_HOURS_IN_DAY).fill(null).map((_, hour) => hour);
        this.days = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ];
        this.isDragging = false;
        this.draggingIntentIsToSelect = false;
    }
    onMouseUp() {
        this.cancelDragging();
    }
    isHourSelected(day, hour) {
        return this.selectedTimes[day].includes(hour);
    }
    isSelectedThisDayAllHours(day) {
        return isEqual(this.selectedTimes[day], this.hours);
    }
    isSelectedThisHourAllDays(hour) {
        return this.selectedTimes.every(day => day.includes(hour));
    }
    isSelectedAllHoursInAllDays() {
        return this.selectedTimes.every(day => isEqual(day, this.hours));
    }
    toggleAllHoursInAllDays() {
        const isSelected = !this.isSelectedAllHoursInAllDays();
        const result = this.days.map(() => (isSelected ? this.hours : []));
        this.onChange(result);
    }
    clickSelectAllHoursInDay(selectedDay) {
        this.isDragging = true;
        this.draggingIntentIsToSelect = !this.isSelectedThisDayAllHours(selectedDay);
        this.selectAllHoursInDay(selectedDay);
    }
    extendSelectAllHoursInDay(selectedDay) {
        if (!this.isDragging) {
            return;
        }
        this.selectAllHoursInDay(selectedDay);
    }
    clickSelectHourInAllDays(selectedHour) {
        this.isDragging = true;
        this.draggingIntentIsToSelect = !this.isSelectedThisHourAllDays(selectedHour);
        this.selectHourInAllDays(selectedHour);
    }
    extendSelectHourInAllDays(selectedHour) {
        if (!this.isDragging) {
            return;
        }
        this.selectHourInAllDays(selectedHour);
    }
    clickSelectHour(selectedDay, selectedHour) {
        this.isDragging = true;
        this.draggingIntentIsToSelect = !this.isHourSelected(selectedDay, selectedHour);
        this.selectHour(selectedDay, selectedHour);
    }
    extendSelectHour(selectedDay, selectedHour) {
        if (!this.isDragging) {
            return;
        }
        this.selectHour(selectedDay, selectedHour);
    }
    insertHourIntoHours(hour, hours) {
        return sortedUniq(hours.concat(hour).sort((a, b) => a - b));
    }
    removeHourFromHours(hour, hours) {
        return hours.filter(h => h !== hour);
    }
    onChange(result) {
        this.change.emit(result);
    }
    cancelDragging() {
        this.isDragging = false;
    }
    selectAllHoursInDay(selectedDay) {
        const result = this.days.map((dayName, day) => {
            if (day !== selectedDay) {
                return this.selectedTimes[day];
            }
            return this.draggingIntentIsToSelect ? this.hours : [];
        });
        this.onChange(result);
    }
    selectHourInAllDays(selectedHour) {
        const result = this.days.map((day, dayIndex) => {
            const hours = this.selectedTimes[dayIndex];
            return this.draggingIntentIsToSelect
                ? this.insertHourIntoHours(selectedHour, hours)
                : this.removeHourFromHours(selectedHour, hours);
        });
        this.onChange(result);
    }
    selectHour(selectedDay, selectedHour) {
        const result = this.days.map((day, dayIndex) => {
            if (dayIndex !== selectedDay) {
                return this.selectedTimes[dayIndex];
            }
            const hours = this.selectedTimes[dayIndex];
            return this.draggingIntentIsToSelect
                ? this.insertHourIntoHours(selectedHour, hours)
                : this.removeHourFromHours(selectedHour, hours);
        });
        this.onChange(result);
    }
}
DayparterComponent.ɵfac = function DayparterComponent_Factory(t) { return new (t || DayparterComponent)(); };
DayparterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DayparterComponent, selectors: [["pmcc-dayparter"]], hostBindings: function DayparterComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseup", function DayparterComponent_mouseup_HostBindingHandler() { return ctx.onMouseUp(); });
    } }, inputs: { selectedTimes: "selectedTimes" }, outputs: { change: "change" }, decls: 42, vars: 4, consts: [["cellpadding", "0", "cellspacing", "0", 1, "pmcc-dayparting-grid"], ["colspan", "", 1, "pmcc-dayparter-label"], ["colspan", "3", 1, "pmcc-dayparter-label"], [4, "ngFor", "ngForOf"], [1, "pmcc-spacer"], [1, "pmcc-spacer", "pmcc-bt"], ["colspan", "24", 1, "pmcc-spacer", "pmcc-bt"], [1, "pmcc-dayparter-label"], [1, "pmcc-dayparter-cell-active", "pmcc-br", "pmcc-bb", "pmcc-bl", 3, "click"], ["class", "pmcc-bb pmcc-dayparter-cell-active", 3, "pmcc-dayparter-cell-selected", "mousedown", "mouseenter", 4, "ngFor", "ngForOf"], [1, "pmcc-dayparter-legend"], ["colspan", "3"], ["colspan", "24"], [1, "pmcc-dayparter-legend-box"], [1, "pmcc-dayparter-cell-active", "pmcc-bl", "pmcc-br", 3, "mousedown", "mouseenter"], ["class", "pmcc-dayparter-cell-active", 3, "pmcc-dayparter-cell-selected", "mousedown", "mouseenter", 4, "ngFor", "ngForOf"], [1, "pmcc-dayparter-cell-active", 3, "mousedown", "mouseenter"], [1, "pmcc-bb", "pmcc-dayparter-cell-active", 3, "mousedown", "mouseenter"]], template: function DayparterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "table", 0);
        ɵngcc0.ɵɵelementStart(1, "tr");
        ɵngcc0.ɵɵelementStart(2, "th", 1);
        ɵngcc0.ɵɵtext(3, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "th", 1);
        ɵngcc0.ɵɵtext(5, "All Day");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "th", 1);
        ɵngcc0.ɵɵtext(7, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "th", 2);
        ɵngcc0.ɵɵtext(9, "12 am");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "th", 2);
        ɵngcc0.ɵɵtext(11, "3 am");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "th", 2);
        ɵngcc0.ɵɵtext(13, "6 am");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "th", 2);
        ɵngcc0.ɵɵtext(15, "9 am");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "th", 2);
        ɵngcc0.ɵɵtext(17, "12 pm");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "th", 2);
        ɵngcc0.ɵɵtext(19, "3 pm");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "th", 2);
        ɵngcc0.ɵɵtext(21, "6 pm");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "th", 2);
        ɵngcc0.ɵɵtext(23, "9 pm");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(24, DayparterComponent_tr_24_Template, 7, 4, "tr", 3);
        ɵngcc0.ɵɵelementStart(25, "tr");
        ɵngcc0.ɵɵelement(26, "td", 4);
        ɵngcc0.ɵɵelement(27, "td", 5);
        ɵngcc0.ɵɵelement(28, "td", 4);
        ɵngcc0.ɵɵelement(29, "td", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "tr");
        ɵngcc0.ɵɵelementStart(31, "td", 7);
        ɵngcc0.ɵɵtext(32, "Every Day");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "td", 8);
        ɵngcc0.ɵɵlistener("click", function DayparterComponent_Template_td_click_33_listener() { return ctx.toggleAllHoursInAllDays(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "td", 4);
        ɵngcc0.ɵɵtext(35, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, DayparterComponent_td_36_Template, 2, 2, "td", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "tr", 10);
        ɵngcc0.ɵɵelement(38, "td", 11);
        ɵngcc0.ɵɵelementStart(39, "td", 12);
        ɵngcc0.ɵɵelement(40, "span", 13);
        ɵngcc0.ɵɵtext(41, " Scheduled hours are shaded blue ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(24);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.days);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵclassProp("pmcc-dayparter-cell-selected", ctx.isSelectedAllHoursInAllDays());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hours);
    } }, directives: [ɵngcc1.NgForOf], styles: [".pmcc-dayparting-grid[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pmcc-dayparting-grid[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-dayparter-label[_ngcontent-%COMP%], .pmcc-dayparting-grid[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#8b8b8b;font-size:11px;font-weight:400;padding:5px}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none;padding:10px;border-left:1px solid #f5f5f5;border-top:1px solid #dfdfdf}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(3n+1){border-left:1px solid #dfdfdf}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-dayparter-cell-active[_ngcontent-%COMP%]{cursor:pointer}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-dayparter-cell-active[_ngcontent-%COMP%]:hover{background-color:#e2f4fe}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-bl[_ngcontent-%COMP%]{border-left:1px solid #dfdfdf!important}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-br[_ngcontent-%COMP%]{border-right:1px solid #dfdfdf!important}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-bb[_ngcontent-%COMP%]{border-bottom:1px solid #dfdfdf!important}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-bt[_ngcontent-%COMP%]{border-top:1px solid #dfdfdf!important}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child{border-right:1px solid #dfdfdf}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-dayparter-cell-selected[_ngcontent-%COMP%]{background-color:#0499d3}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-spacer[_ngcontent-%COMP%]{border:none}.pmcc-dayparting-grid[_ngcontent-%COMP%]   td.pmcc-dayparter-label[_ngcontent-%COMP%]{border:none;text-align:right}.pmcc-dayparting-grid[_ngcontent-%COMP%]   tr.pmcc-dayparter-legend[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{text-align:center;border:0;padding-top:20px}.pmcc-dayparting-grid[_ngcontent-%COMP%]   tr.pmcc-dayparter-legend[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .pmcc-dayparter-legend-box[_ngcontent-%COMP%]{background-color:#0499d3;display:inline-block;width:10px;height:10px;margin-right:5px}"], changeDetection: 0 });
DayparterComponent.propDecorators = {
    selectedTimes: [{ type: Input }],
    change: [{ type: Output }],
    onMouseUp: [{ type: HostListener, args: ['mouseup',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DayparterComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-dayparter',
                template: "<table class=\"pmcc-dayparting-grid\" cellpadding=\"0\" cellspacing=\"0\">\n  <tr>\n    <th class=\"pmcc-dayparter-label\" colspan=\"\">&nbsp;</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"\">All Day</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"\">&nbsp;</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">12 am</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">3 am</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">6 am</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">9 am</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">12 pm</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">3 pm</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">6 pm</th>\n    <th class=\"pmcc-dayparter-label\" colspan=\"3\">9 pm</th>\n  </tr>\n\n  <tr *ngFor=\"let dayLabel of days; let day = index\">\n    <td class=\"pmcc-dayparter-label\">{{ dayLabel }}</td>\n    <td\n      class=\"pmcc-dayparter-cell-active pmcc-bl pmcc-br\"\n      [class.pmcc-dayparter-cell-selected]=\"isSelectedThisDayAllHours(day)\"\n      (mousedown)=\"clickSelectAllHoursInDay(day)\"\n      (mouseenter)=\"extendSelectAllHoursInDay(day)\"\n    ></td>\n    <td class=\"pmcc-spacer\">&nbsp;</td>\n    <td\n      *ngFor=\"let hour of hours\"\n      class=\"pmcc-dayparter-cell-active\"\n      [class.pmcc-dayparter-cell-selected]=\"isHourSelected(day, hour)\"\n      (mousedown)=\"clickSelectHour(day, hour)\"\n      (mouseenter)=\"extendSelectHour(day, hour)\"\n    >\n      &nbsp;\n    </td>\n  </tr>\n\n  <tr>\n    <td class=\"pmcc-spacer\"></td>\n    <td class=\"pmcc-spacer pmcc-bt\"></td>\n    <td class=\"pmcc-spacer\"></td>\n    <td class=\"pmcc-spacer pmcc-bt\" colspan=\"24\"></td>\n  </tr>\n\n  <tr>\n    <td class=\"pmcc-dayparter-label\">Every Day</td>\n    <td\n      class=\"pmcc-dayparter-cell-active pmcc-br pmcc-bb pmcc-bl\"\n      [class.pmcc-dayparter-cell-selected]=\"isSelectedAllHoursInAllDays()\"\n      (click)=\"toggleAllHoursInAllDays()\"\n    ></td>\n    <td class=\"pmcc-spacer\">&nbsp;</td>\n    <td\n      *ngFor=\"let hour of hours\"\n      class=\"pmcc-bb pmcc-dayparter-cell-active\"\n      [class.pmcc-dayparter-cell-selected]=\"isSelectedThisHourAllDays(hour)\"\n      (mousedown)=\"clickSelectHourInAllDays(hour)\"\n      (mouseenter)=\"extendSelectHourInAllDays(hour)\"\n    >\n      &nbsp;\n    </td>\n  </tr>\n\n  <tr class=\"pmcc-dayparter-legend\">\n    <td colspan=\"3\"></td>\n    <td colspan=\"24\">\n      <span class=\"pmcc-dayparter-legend-box\"></span>\n      Scheduled hours are shaded blue\n    </td>\n  </tr>\n</table>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".pmcc-dayparting-grid td,.pmcc-dayparting-grid th{-webkit-user-select:none;user-select:none}.pmcc-dayparting-grid td.pmcc-dayparter-label,.pmcc-dayparting-grid th{text-align:left;color:#8b8b8b;font-size:11px;font-weight:400;padding:5px}.pmcc-dayparting-grid td{-webkit-user-select:none;user-select:none;padding:10px;border-left:1px solid #f5f5f5;border-top:1px solid #dfdfdf}.pmcc-dayparting-grid td:nth-child(3n+1){border-left:1px solid #dfdfdf}.pmcc-dayparting-grid td.pmcc-dayparter-cell-active{cursor:pointer}.pmcc-dayparting-grid td.pmcc-dayparter-cell-active:hover{background-color:#e2f4fe}.pmcc-dayparting-grid td.pmcc-bl{border-left:1px solid #dfdfdf!important}.pmcc-dayparting-grid td.pmcc-br{border-right:1px solid #dfdfdf!important}.pmcc-dayparting-grid td.pmcc-bb{border-bottom:1px solid #dfdfdf!important}.pmcc-dayparting-grid td.pmcc-bt{border-top:1px solid #dfdfdf!important}.pmcc-dayparting-grid td:last-child{border-right:1px solid #dfdfdf}.pmcc-dayparting-grid td.pmcc-dayparter-cell-selected{background-color:#0499d3}.pmcc-dayparting-grid td.pmcc-spacer{border:none}.pmcc-dayparting-grid td.pmcc-dayparter-label{border:none;text-align:right}.pmcc-dayparting-grid tr.pmcc-dayparter-legend td{text-align:center;border:0;padding-top:20px}.pmcc-dayparting-grid tr.pmcc-dayparter-legend td .pmcc-dayparter-legend-box{background-color:#0499d3;display:inline-block;width:10px;height:10px;margin-right:5px}"]
            }]
    }], function () { return []; }, { selectedTimes: [{
            type: Input
        }], change: [{
            type: Output
        }], onMouseUp: [{
            type: HostListener,
            args: ['mouseup']
        }] }); })();

class DayparterModule {
}
DayparterModule.ɵfac = function DayparterModule_Factory(t) { return new (t || DayparterModule)(); };
DayparterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DayparterModule });
DayparterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DayparterModule, [{
        type: NgModule,
        args: [{
                declarations: [DayparterComponent],
                imports: [CommonModule],
                exports: [DayparterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DayparterModule, { declarations: function () { return [DayparterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DayparterComponent]; } }); })();

/**
 * Custom injector for overlay components created using ComponentPortal.
 */
class PortalInjector {
    constructor(parentInjector, tokens) {
        this.parentInjector = parentInjector;
        this.tokens = tokens;
    }
    get(token, notFoundValue) {
        const value = this.tokens.get(token);
        return value !== undefined
            ? value
            : this.parentInjector.get(token, notFoundValue);
    }
}

class DialogRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
        this._afterClosed = new Subject();
        overlayRef.detachments.subscribe(() => {
            this._afterClosed.next(this._result);
            this._afterClosed.complete();
            this.overlayRef.dispose();
        });
    }
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    close(dialogResult) {
        this._result = dialogResult;
        this.overlayRef.detach();
    }
    _setInstance(instance) {
        this.componentInstance = instance;
    }
}

/**
 * Token for injecting dialog data for dialogs opened using
 * DialogService.
 */
const DIALOG_DATA = new InjectionToken('DIALOG_DATA');

/** @dynamic */
class DialogBodyStyleService {
    constructor(rendererFactory, document) {
        this.rendererFactory = rendererFactory;
        this.document = document;
        this.savedOverflow = '';
        this.savedZIndex = '';
        this.savedPaddingRight = '';
        this.overflowSet = false;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    get header() {
        return document.querySelector('pmcc-global-header');
    }
    addBodyOverflowHidden() {
        if (!this.overflowSet) {
            this.savedPaddingRight = this.body.style.paddingRight;
            this.savedOverflow = this.body.style.overflow;
            this.setStyle('padding-right', `${this.scrollBarWidth}px`);
            this.setStyle('overflow', 'hidden');
            this.overflowSet = true;
            // TODO: Check if this has any other alternative
            // one can be to have two styles in global header itself -
            // one for blackout-mask-present and one for other cases
            if (this.header) {
                this.savedZIndex = this.header.style.zIndex;
                this.header.style.zIndex = '900';
            }
        }
    }
    removeBodyOverflowHidden() {
        if (this.overflowSet) {
            this.setStyle('padding-right', this.savedPaddingRight);
            this.setStyle('overflow', this.savedOverflow);
            this.overflowSet = false;
            if (this.header) {
                this.header.style.zIndex = this.savedZIndex;
            }
        }
    }
    get body() {
        return this.document.body;
    }
    get scrollBarWidth() {
        return window.innerWidth - this.document.documentElement.clientWidth;
    }
    setStyle(style, value) {
        this.renderer.setStyle(this.body, style, value);
    }
}
DialogBodyStyleService.ɵfac = function DialogBodyStyleService_Factory(t) { return new (t || DialogBodyStyleService)(ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(DOCUMENT)); };
DialogBodyStyleService.ɵprov = i0.ɵɵdefineInjectable({ factory: function DialogBodyStyleService_Factory() { return new DialogBodyStyleService(i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i1.DOCUMENT)); }, token: DialogBodyStyleService, providedIn: "root" });
DialogBodyStyleService.ctorParameters = () => [
    { type: RendererFactory2 },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogBodyStyleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.RendererFactory2 }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class DialogService {
    constructor(appRef, injector, overlayService, dialogBodyStyleService) {
        this.appRef = appRef;
        this.injector = injector;
        this.overlayService = overlayService;
        this.dialogBodyStyleService = dialogBodyStyleService;
        this.openDialogs = new Set();
        this.openInlineDialogs = new Set();
    }
    ngOnDestroy() {
        this.openDialogs.forEach(dialogRef => dialogRef.close());
        this.openDialogs.clear();
        this.openInlineDialogs.clear();
    }
    open(component, config) {
        const overlayRef = this.overlayService.create(this.getPositionStrategy(config), this.overlayService.scrollStrategies.reposition(), config);
        const tokens = new WeakMap();
        if (config && config.data) {
            tokens.set(DIALOG_DATA, config.data);
        }
        const dialogRef = this.createDialogRef(overlayRef);
        dialogRef.afterClosed().subscribe(() => this.removeDialog(dialogRef));
        tokens.set(DialogRef, dialogRef);
        const viewContainerRef = config && config.viewContainerRef;
        const userInjector = viewContainerRef && viewContainerRef.injector;
        const injector = new PortalInjector(userInjector || this.injector, tokens);
        const componentRef = overlayRef.attach({
            component,
            injector,
            viewContainerRef,
        });
        componentRef.changeDetectorRef.detectChanges();
        dialogRef._setInstance(componentRef.instance);
        overlayRef.updatePosition();
        this.addBodyOverflowHidden();
        return dialogRef;
    }
    registerInlineDialog(dialog) {
        this.openInlineDialogs.add(dialog);
        this.addBodyOverflowHidden();
    }
    deregisterInlineDialog(dialog) {
        this.openInlineDialogs.delete(dialog);
        this.removeBodyOverflowHidden();
    }
    getPositionStrategy(config) {
        let offsetTop = '';
        let offsetLeft = '';
        if (config && config.positionOffset) {
            offsetTop = config.positionOffset.top;
            offsetLeft = config.positionOffset.left;
        }
        return this.overlayService
            .position()
            .global()
            .centerVertically(offsetTop)
            .centerHorizontally(offsetLeft);
    }
    addBodyOverflowHidden() {
        this.dialogBodyStyleService.addBodyOverflowHidden();
    }
    removeBodyOverflowHidden() {
        if (!this.openDialogs.size && !this.openInlineDialogs.size) {
            this.dialogBodyStyleService.removeBodyOverflowHidden();
        }
    }
    createDialogRef(overlayRef) {
        const dialogRef = new DialogRef(overlayRef);
        this.openDialogs.add(dialogRef);
        return dialogRef;
    }
    removeDialog(dialogRef) {
        this.openDialogs.delete(dialogRef);
        this.removeBodyOverflowHidden();
    }
}
DialogService.ɵfac = function DialogService_Factory(t) { return new (t || DialogService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(OverlayService), ɵngcc0.ɵɵinject(DialogBodyStyleService)); };
DialogService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DialogService, factory: DialogService.ɵfac });
DialogService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: Injector },
    { type: OverlayService },
    { type: DialogBodyStyleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }, { type: OverlayService }, { type: DialogBodyStyleService }]; }, null); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/dialog</example-url>
 */
class DialogComponent {
    constructor(dialogService) {
        this.dialogService = dialogService;
        this.type = 'modal';
        this.size = 'small';
        this.showDialog = false;
        this.hideCloseIcon = false;
        this.headerClass = '';
        this.title = '';
        this.showDialogChange = new EventEmitter();
        this.closeCallback = new EventEmitter();
    }
    ngOnInit() {
        this.updateDialogRegistration();
    }
    ngOnChanges(changes) {
        if ('showDialog' in changes) {
            this.updateDialogRegistration();
        }
    }
    ngOnDestroy() {
        this.updateDialogRegistration();
    }
    cancelHandler() {
        this.showDialog = false;
        this.showDialogChange.emit(false);
        this.updateDialogRegistration();
        this.closeCallback.emit();
    }
    backdrop() {
        return this.type === 'modal' ? BackDrop.DARK : BackDrop.NONE;
    }
    updateDialogRegistration() {
        if (this.showDialog) {
            this.dialogService.registerInlineDialog(this);
        }
        else {
            this.dialogService.deregisterInlineDialog(this);
        }
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(DialogService)); };
DialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["pmcc-dialog"]], inputs: { type: "type", size: "size", showDialog: "showDialog", hideCloseIcon: "hideCloseIcon", headerClass: "headerClass", title: "title" }, outputs: { showDialogChange: "showDialogChange", closeCallback: "closeCallback" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c37, decls: 1, vars: 3, consts: [["pmccOverlay", "", "pmccPositionScreenCenter", "", 3, "pmccOverlayOpen", "pmccOverlayCloseOnClickOutside", "pmccOverlayBackdrop", "pmccOverlayOpenChange"], [3, "showDialog", "size", "headerClass", "type", "title", "hideCloseIcon", "showDialogChange"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵtemplate(0, DialogComponent_ng_template_0_Template, 3, 6, "ng-template", 0);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function DialogComponent_Template_ng_template_pmccOverlayOpenChange_0_listener($event) { return ctx.showDialog = $event; });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.showDialog)("pmccOverlayCloseOnClickOutside", false)("pmccOverlayBackdrop", ctx.backdrop());
    } }, directives: function () { return [OverlayDirective, ScreenCenterPositionDirective, DialogInlineComponent]; }, encapsulation: 2 });
DialogComponent.ctorParameters = () => [
    { type: DialogService }
];
DialogComponent.propDecorators = {
    type: [{ type: Input }],
    size: [{ type: Input }],
    showDialog: [{ type: Input }],
    hideCloseIcon: [{ type: Input }],
    headerClass: [{ type: Input }],
    title: [{ type: Input }],
    showDialogChange: [{ type: Output }],
    closeCallback: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-dialog',
                template: "<!-- todo fix click outside behaviour with nested overlays. Disabled for now -->\n<ng-template\n  pmccOverlay\n  [(pmccOverlayOpen)]=\"showDialog\"\n  [pmccOverlayCloseOnClickOutside]=\"false\"\n  pmccPositionScreenCenter\n  [pmccOverlayBackdrop]=\"backdrop()\"\n>\n  <pmcc-dialog-inline\n    [showDialog]=\"showDialog\"\n    [size]=\"size\"\n    [headerClass]=\"headerClass\"\n    [type]=\"type\"\n    [title]=\"title\"\n    [hideCloseIcon]=\"hideCloseIcon\"\n    (showDialogChange)=\"cancelHandler()\">\n    <ng-content select=\"div.pmcc-dialog-title\" ngProjectAs=\"div.pmcc-dialog-title\"></ng-content>\n    <ng-content></ng-content>\n  </pmcc-dialog-inline>\n</ng-template>\n"
            }]
    }], function () { return [{ type: DialogService }]; }, { type: [{
            type: Input
        }], size: [{
            type: Input
        }], showDialog: [{
            type: Input
        }], hideCloseIcon: [{
            type: Input
        }], headerClass: [{
            type: Input
        }], title: [{
            type: Input
        }], showDialogChange: [{
            type: Output
        }], closeCallback: [{
            type: Output
        }] }); })();

class DialogCloseDirective {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.ariaLabel = 'Close dialog';
    }
    onClick() {
        if (this.dialogRef) {
            this.dialogRef.close(this.result);
        }
    }
}
DialogCloseDirective.ɵfac = function DialogCloseDirective_Factory(t) { return new (t || DialogCloseDirective)(ɵngcc0.ɵɵdirectiveInject(DialogRef, 8)); };
DialogCloseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DialogCloseDirective, selectors: [["", "pmccDialogClose", ""]], hostBindings: function DialogCloseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DialogCloseDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { ariaLabel: ["aria-label", "ariaLabel"], result: ["pmccDialogClose", "result"] }, exportAs: ["pmccDialogClose"] });
DialogCloseDirective.ctorParameters = () => [
    { type: DialogRef, decorators: [{ type: Optional }] }
];
DialogCloseDirective.propDecorators = {
    result: [{ type: Input, args: ['pmccDialogClose',] }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogCloseDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccDialogClose]',
                exportAs: 'pmccDialogClose'
            }]
    }], function () { return [{ type: DialogRef, decorators: [{
                type: Optional
            }] }]; }, { ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], result: [{
            type: Input,
            args: ['pmccDialogClose']
        }] }); })();

class DialogInlineComponent extends EscapableDirective {
    constructor(_dialogRef) {
        super();
        this._dialogRef = _dialogRef;
        this.type = 'modal';
        this.size = 'small';
        this.showDialog = false;
        this.headerClass = '';
        this.title = '';
        this.hideCloseIcon = false;
        this.showDialogChange = new EventEmitter();
    }
    get isEscapable() {
        return this.showDialog;
    }
    /**
     * get the class name based on size
     */
    getSize() {
        return this.size;
    }
    /**
     * Cancel icon handler
     */
    cancelHandler() {
        this.showDialog = false;
        this.showDialogChange.emit(false);
        if (this._dialogRef) {
            this._dialogRef.close();
        }
    }
    _onEscape(event) {
        this.cancelHandler();
    }
}
DialogInlineComponent.ɵfac = function DialogInlineComponent_Factory(t) { return new (t || DialogInlineComponent)(ɵngcc0.ɵɵdirectiveInject(DialogRef, 8)); };
DialogInlineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogInlineComponent, selectors: [["pmcc-dialog-inline"]], inputs: { type: "type", size: "size", showDialog: "showDialog", headerClass: "headerClass", title: "title", hideCloseIcon: "hideCloseIcon" }, outputs: { showDialogChange: "showDialogChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c37, decls: 4, vars: 2, consts: [["dialogBody", ""], ["class", "pmcc-modal-dialog", 3, "ngClass", 4, "ngIf"], ["class", "pmcc-non-modal-dialog", 4, "ngIf"], [1, "pmcc-dialog-header", 3, "ngClass"], ["data-pm-id", "dialog-title", 1, "pmcc-dialog-title-container"], ["content", ""], ["class", "title pmcc-truncate", 3, "title", "textContent", 4, "ngIf"], ["class", "pmcc-cancel", "name", "close", "size", "2x", "color", "white", "data-pm-id", "dialog-close-icon", 3, "click", 4, "ngIf"], [1, "title", "pmcc-truncate", 3, "title", "textContent"], ["name", "close", "size", "2x", "color", "white", "data-pm-id", "dialog-close-icon", 1, "pmcc-cancel", 3, "click"], [1, "pmcc-modal-dialog", 3, "ngClass"], [4, "ngTemplateOutlet"], [1, "pmcc-non-modal-dialog"]], template: function DialogInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵtemplate(0, DialogInlineComponent_ng_template_0_Template, 8, 3, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, DialogInlineComponent_div_2_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DialogInlineComponent_div_3_Template, 2, 1, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDialog && ctx.type === "modal");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDialog && ctx.type === "non-modal");
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, IconComponent, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]     .pmcc-modal-dialog{display:inline-block;text-align:left;vertical-align:middle}[_nghost-%COMP%]     .pmcc-modal-dialog, [_nghost-%COMP%]     .pmcc-non-modal-dialog{color:#222121;box-shadow:0 2px 8px #0000001f;border:1px solid #c9c9c9;border-radius:3px;font:normal 12px Arial,Helvetica,Calibri,sans-serif;width:480px}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-content, [_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-footer, [_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-content, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-footer, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header{padding:10px 20px}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-footer, [_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-footer, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header{display:flex;flex-flow:row;background-color:#f5f5f5;align-items:baseline;justify-content:space-between}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-footer.warning, [_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header.warning, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-footer.warning, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header.warning{background-color:#c5242a;color:#fff}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-footer, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-footer{border-top:1px solid #c9c9c9;border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:#f9f9f9}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-content, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-content{background-color:#fff;overflow:auto;max-height:480px}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header{background:#6b747a;border-top-left-radius:2px;border-top-right-radius:2px}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container{display:flex;flex-flow:row;justify-content:flex-start;align-items:baseline;width:90%!important}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .pmcc-dialog-title, [_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .title, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .pmcc-dialog-title, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .title{font:normal 16px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;color:#fff}[_nghost-%COMP%]     .pmcc-modal-dialog .pmcc-dialog-header .pmcc-cancel, [_nghost-%COMP%]     .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-cancel{cursor:pointer}[_nghost-%COMP%]     .pmcc-modal-dialog.small, [_nghost-%COMP%]     .pmcc-non-modal-dialog.small{width:320px;left:calc(50% - 160px)}[_nghost-%COMP%]     .pmcc-modal-dialog.medium, [_nghost-%COMP%]     .pmcc-non-modal-dialog.medium{width:480px;left:calc(50% - 240px)}[_nghost-%COMP%]     .pmcc-modal-dialog.large, [_nghost-%COMP%]     .pmcc-non-modal-dialog.large{width:640px;left:calc(50% - 320px)}[_nghost-%COMP%]     .pmcc-modal-dialog.x-large, [_nghost-%COMP%]     .pmcc-non-modal-dialog.x-large{width:800px;left:calc(50% - 400px)}[_nghost-%COMP%]     .pmcc-modal-dialog.x-large .pmcc-dialog-content, [_nghost-%COMP%]     .pmcc-non-modal-dialog.x-large .pmcc-dialog-content{max-height:86vh}[_nghost-%COMP%]     .pmcc-modal-dialog.xx-large, [_nghost-%COMP%]     .pmcc-non-modal-dialog.xx-large{width:900px;left:calc(50% - 450px)}[_nghost-%COMP%]     .pmcc-modal-dialog.xx-large .pmcc-dialog-content, [_nghost-%COMP%]     .pmcc-non-modal-dialog.xx-large .pmcc-dialog-content{max-height:86vh}"] });
DialogInlineComponent.ctorParameters = () => [
    { type: DialogRef, decorators: [{ type: Optional }] }
];
DialogInlineComponent.propDecorators = {
    type: [{ type: Input }],
    size: [{ type: Input }],
    showDialog: [{ type: Input }],
    headerClass: [{ type: Input }],
    title: [{ type: Input }],
    hideCloseIcon: [{ type: Input }],
    showDialogChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogInlineComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-dialog-inline',
                template: "<!-- Common dialog body-->\n<ng-template #dialogBody>\n  <div class=\"pmcc-dialog-header\" [ngClass]=\"headerClass\">\n    <div class=\"pmcc-dialog-title-container\" data-pm-id=\"dialog-title\">\n      <div #content>\n        <ng-content select=\"div.pmcc-dialog-title\"></ng-content>\n      </div>\n      <div\n        *ngIf=\"content.children.length === 0\"\n        class=\"title pmcc-truncate\"\n        [title]=\"title\"\n        [textContent]=\"title\"\n        i18n\n      ></div>\n    </div>\n    <pmcc-icon\n      *ngIf=\"!hideCloseIcon\"\n      class=\"pmcc-cancel\"\n      name=\"close\"\n      size=\"2x\"\n      color=\"white\"\n      (click)=\"cancelHandler()\"\n      data-pm-id=\"dialog-close-icon\"\n    ></pmcc-icon>\n  </div>\n\n  <ng-content></ng-content>\n</ng-template>\n\n<!--  Modal Dialog  -->\n<div\n  *ngIf=\"showDialog && type === 'modal'\"\n  class=\"pmcc-modal-dialog\"\n  [ngClass]=\"getSize()\"\n>\n  <ng-container *ngTemplateOutlet=\"dialogBody\"></ng-container>\n</div>\n\n<!--  Non-Modal Dialog  -->\n<div *ngIf=\"showDialog && type === 'non-modal'\" class=\"pmcc-non-modal-dialog\">\n  <ng-container *ngTemplateOutlet=\"dialogBody\"></ng-container>\n</div>\n",
                styles: [":host ::ng-deep .pmcc-modal-dialog{display:inline-block;text-align:left;vertical-align:middle}:host ::ng-deep .pmcc-modal-dialog,:host ::ng-deep .pmcc-non-modal-dialog{color:#222121;box-shadow:0 2px 8px #0000001f;border:1px solid #c9c9c9;border-radius:3px;font:normal 12px Arial,Helvetica,Calibri,sans-serif;width:480px}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-content,:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-footer,:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-content,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-footer,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header{padding:10px 20px}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-footer,:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-footer,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header{display:flex;flex-flow:row;background-color:#f5f5f5;align-items:baseline;justify-content:space-between}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-footer.warning,:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header.warning,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-footer.warning,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header.warning{background-color:#c5242a;color:#fff}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-footer,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-footer{border-top:1px solid #c9c9c9;border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:#f9f9f9}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-content,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-content{background-color:#fff;overflow:auto;max-height:480px}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header{background:#6b747a;border-top-left-radius:2px;border-top-right-radius:2px}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container{display:flex;flex-flow:row;justify-content:flex-start;align-items:baseline;width:90%!important}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .pmcc-dialog-title,:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .title,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .pmcc-dialog-title,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-dialog-title-container .title{font:normal 16px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;color:#fff}:host ::ng-deep .pmcc-modal-dialog .pmcc-dialog-header .pmcc-cancel,:host ::ng-deep .pmcc-non-modal-dialog .pmcc-dialog-header .pmcc-cancel{cursor:pointer}:host ::ng-deep .pmcc-modal-dialog.small,:host ::ng-deep .pmcc-non-modal-dialog.small{width:320px;left:calc(50% - 160px)}:host ::ng-deep .pmcc-modal-dialog.medium,:host ::ng-deep .pmcc-non-modal-dialog.medium{width:480px;left:calc(50% - 240px)}:host ::ng-deep .pmcc-modal-dialog.large,:host ::ng-deep .pmcc-non-modal-dialog.large{width:640px;left:calc(50% - 320px)}:host ::ng-deep .pmcc-modal-dialog.x-large,:host ::ng-deep .pmcc-non-modal-dialog.x-large{width:800px;left:calc(50% - 400px)}:host ::ng-deep .pmcc-modal-dialog.x-large .pmcc-dialog-content,:host ::ng-deep .pmcc-non-modal-dialog.x-large .pmcc-dialog-content{max-height:86vh}:host ::ng-deep .pmcc-modal-dialog.xx-large,:host ::ng-deep .pmcc-non-modal-dialog.xx-large{width:900px;left:calc(50% - 450px)}:host ::ng-deep .pmcc-modal-dialog.xx-large .pmcc-dialog-content,:host ::ng-deep .pmcc-non-modal-dialog.xx-large .pmcc-dialog-content{max-height:86vh}"]
            }]
    }], function () { return [{ type: DialogRef, decorators: [{
                type: Optional
            }] }]; }, { type: [{
            type: Input
        }], size: [{
            type: Input
        }], showDialog: [{
            type: Input
        }], headerClass: [{
            type: Input
        }], title: [{
            type: Input
        }], hideCloseIcon: [{
            type: Input
        }], showDialogChange: [{
            type: Output
        }] }); })();

class DialogModule {
}
DialogModule.ɵfac = function DialogModule_Factory(t) { return new (t || DialogModule)(); };
DialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [DialogService], imports: [[CommonModule, LayoutModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                declarations: [DialogComponent, DialogInlineComponent, DialogCloseDirective],
                imports: [CommonModule, LayoutModule, IconModule],
                exports: [DialogComponent, DialogInlineComponent, DialogCloseDirective],
                providers: [DialogService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent, DialogInlineComponent, DialogCloseDirective]; }, imports: function () { return [CommonModule, LayoutModule, IconModule]; }, exports: function () { return [DialogComponent, DialogInlineComponent, DialogCloseDirective]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/event-service</example-url>
 */
class EventService {
    constructor() {
        this._observable = new EventEmitter();
    }
    get observable() {
        return this._observable.asObservable();
    }
    subscribe(generatorOrNext) {
        return this.observable.subscribe(generatorOrNext);
    }
    emit(type, data) {
        this._observable.emit({
            type: type,
            data: data,
        });
    }
    filter(predicate, thisArg) {
        return this._observable.pipe(filter(predicate, thisArg));
    }
}
EventService.ɵfac = function EventService_Factory(t) { return new (t || EventService)(); };
EventService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EventService, factory: EventService.ɵfac, providedIn: 'root' });
EventService.decorators = [ { type: Injectable }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }, {
        type: Injectable
    }], function () { return []; }, null); })();

class EventModule {
}
EventModule.ɵfac = function EventModule_Factory(t) { return new (t || EventModule)(); };
EventModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EventModule });
EventModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [EventService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                providers: [EventService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EventModule, { imports: function () { return [CommonModule]; } }); })();

let nextId$1 = 0;
const maxShownFiles = 10;
class FileComponent {
    constructor() {
        this._required = false;
        this._disabled = false;
        this._multiple = false;
        this._fileNames = null;
        this._filesTooltipContent = '';
        this.hasDisallowedFileTypes = false;
        this.id = `pmcc-file-${nextId$1++}`;
        this.name = '';
        /**
         * Comma-separated list of content types.
         */
        this.accept = '';
        /**
         * Text that is displayed on the left of the component.
         */
        this.label = '';
        this.placeholder = 'No file chosen';
        /**
         * Event emitted when files change.
         */
        this.change = new EventEmitter();
        this.clear = new EventEmitter();
        this.onTouched = () => {
        };
        this.onModelChange = () => { };
    }
    /**
     * Whether multiple items can be selected from a list.
     */
    get multiple() {
        return this._multiple;
    }
    set multiple(value) {
        this._multiple = coerceBooleanProperty$1(value);
    }
    /**
     * Whether the file is required.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty$1(value);
    }
    /**
     * Whether the file is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty$1(value);
    }
    get files() {
        return this.inputEl.nativeElement.files;
    }
    get fileNames() {
        return this._fileNames;
    }
    get filesTooltipContent() {
        return this._filesTooltipContent;
    }
    onBlur() {
        this.onTouched();
    }
    onFilesSelected(event) {
        // prevent the `change` event from bubbling
        // and triggering (change) Output twice
        event.stopPropagation();
        const { files } = this;
        const filesArray = Array.from(files);
        this._fileNames = filesArray.map(f => f.name).join(', ');
        this.displayFileNames.showClearButton(true);
        this.updateTooltipContent(filesArray);
        this.onModelChange(files);
        this.onTouched();
        this.change.emit(files);
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     * it only supports resetting value using writeValue
     */
    writeValue(value) {
        if (!value || (value && Array.isArray(value) && !value.length)) {
            this._fileNames = null;
            this.inputEl.nativeElement.value = null;
            this._filesTooltipContent = '';
            this.displayFileNames.showClearButton(false);
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
    /**
     * Implemented as part of Validator.
     * Emits `hasDisallowedFileTypes` error.
     */
    validate(control) {
        let validFileTypes = [];
        if (this.accept && control.value) {
            validFileTypes = this.accept.split(',').map(fileType => fileType.trim());
            const fileNames = Array.from(control.value).map((file) => file.name);
            this.hasDisallowedFileTypes = fileNames.some(fileName => validFileTypes.every(extension => !fileName.includes(extension)));
        }
        return !this.hasDisallowedFileTypes
            ? null
            : {
                hasDisallowedFileTypes: {
                    validFileTypes
                }
            };
    }
    updateTooltipContent(filesArray) {
        if (filesArray.length < 2) {
            this._filesTooltipContent = `${filesArray.map(f => f.name)}`;
        }
        else {
            const files = filesArray
                .slice(0, maxShownFiles)
                .map(file => `<li>${file.name}</li>`)
                .join('');
            const moreFilesNotice = filesArray.length > maxShownFiles
                ? `<div class="pmcc-more">and ${filesArray.length -
                    maxShownFiles} more…</div>`
                : '';
            this._filesTooltipContent = `
        <ul class="pmcc-list pmcc-file-list">
          ${files}${moreFilesNotice}
        </ul>
      `;
        }
    }
    clearFileInputValue() {
        this._fileNames = null;
        this.inputEl.nativeElement.value = null;
        this._filesTooltipContent = '';
        const { files } = this;
        this.onModelChange(files);
        this.onTouched();
        this.displayFileNames.showClearButton(false);
        this.change.emit(files);
        this.clear.emit();
    }
}
FileComponent.ɵfac = function FileComponent_Factory(t) { return new (t || FileComponent)(); };
FileComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FileComponent, selectors: [["pmcc-file"]], viewQuery: function FileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c38, 7);
        ɵngcc0.ɵɵviewQuery(_c39, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.displayFileNames = _t.first);
    } }, hostBindings: function FileComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function FileComponent_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { id: "id", name: "name", accept: "accept", label: "label", placeholder: "placeholder", multiple: "multiple", required: "required", disabled: "disabled" }, outputs: { change: "change", clear: "clear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => FileComponent)
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => FileComponent),
                multi: true
            },
        ])], decls: 8, vars: 12, consts: [["type", "file", 1, "pmcc-visually-hidden", 3, "id", "name", "multiple", "accept", "required", "disabled", "change"], ["fileInput", ""], ["class", "pmcc-file-label", 4, "ngIf"], ["pmccClear", "", 3, "clear"], ["displayFileNames", ""], ["pmccInput", "", "type", "text", "readonly", "", "data-pm-id", "file-input", 3, "value", "pmccTooltip", "placeholder", "disabled"], ["type", "button", "pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", "data-pm-id", "file-button", 3, "disabled", "click"], [1, "pmcc-file-label"]], template: function FileComponent_Template(rf, ctx) { if (rf & 1) {
        const _r3 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("change", function FileComponent_Template_input_change_0_listener($event) { return ctx.onFilesSelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, FileComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "pmcc-input", 3, 4);
        ɵngcc0.ɵɵlistener("clear", function FileComponent_Template_pmcc_input_clear_3_listener() { return ctx.clearFileInputValue(); });
        ɵngcc0.ɵɵelement(5, "input", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 6);
        ɵngcc0.ɵɵlistener("click", function FileComponent_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r3); const _r0 = ɵngcc0.ɵɵreference(1); return _r0.click(); });
        ɵngcc0.ɵɵtext(7, " Select File\n");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("name", ctx.name)("multiple", ctx.multiple)("accept", ctx.accept)("required", ctx.required)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("value", ctx.fileNames)("pmccTooltip", ctx.filesTooltipContent)("placeholder", ctx.placeholder)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
    } }, directives: [ɵngcc1.NgIf, InputComponent, InputDirective, TooltipDirective, ButtonDirective], styles: ["[_nghost-%COMP%]{position:relative}.pmcc-form-control-invalid   [_nghost-%COMP%]   input[_ngcontent-%COMP%]{border:1px solid #c5242a}button[_ngcontent-%COMP%]{display:inline-block;vertical-align:bottom}pmcc-input[_ngcontent-%COMP%]{margin-right:5px}input[type=text][_ngcontent-%COMP%]{text-overflow:ellipsis}.pmcc-file-label[_ngcontent-%COMP%]{font-weight:600}.pmcc-file-label[_ngcontent-%COMP%] + pmcc-input[_ngcontent-%COMP%]{margin-left:10px}  .pmcc-file-list{margin:0}  .pmcc-file-list .pmcc-more{font-weight:700;margin-top:4px}"] });
FileComponent.propDecorators = {
    inputEl: [{ type: ViewChild, args: ['fileInput', { static: true },] }],
    displayFileNames: [{ type: ViewChild, args: ['displayFileNames', { static: true },] }],
    id: [{ type: Input }],
    name: [{ type: Input }],
    accept: [{ type: Input }],
    label: [{ type: Input }],
    placeholder: [{ type: Input }],
    multiple: [{ type: Input }],
    required: [{ type: Input }],
    disabled: [{ type: Input }],
    change: [{ type: Output }],
    clear: [{ type: Output }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-file',
                template: "<input\n  #fileInput\n  type=\"file\"\n  class=\"pmcc-visually-hidden\"\n  [id]=\"id\"\n  [name]=\"name\"\n  [multiple]=\"multiple\"\n  [accept]=\"accept\"\n  [required]=\"required\"\n  [disabled]=\"disabled\"\n  (change)=\"onFilesSelected($event)\"\n/>\n<span *ngIf=\"label\" class=\"pmcc-file-label\">{{ label }}</span>\n<pmcc-input\n  pmccClear\n  #displayFileNames\n  (clear)=\"clearFileInputValue()\">\n  <input\n    pmccInput\n    type=\"text\"\n    [value]=\"fileNames\"\n    [pmccTooltip]=\"filesTooltipContent\"\n    [placeholder]=\"placeholder\"\n    readonly\n    [disabled]=\"disabled\"\n    data-pm-id=\"file-input\"\n  />\n</pmcc-input>\n<button\n  type=\"button\"\n  pmccButton\n  pmccVariant=\"secondary\"\n  pmccSize=\"md\"\n  [disabled]=\"disabled\"\n  (click)=\"fileInput.click()\"\n  data-pm-id=\"file-button\"\n>\n  Select File\n</button>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => FileComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => FileComponent),
                        multi: true
                    },
                ],
                styles: [":host{position:relative}.pmcc-form-control-invalid :host input{border:1px solid #c5242a}button{display:inline-block;vertical-align:bottom}pmcc-input{margin-right:5px}input[type=text]{text-overflow:ellipsis}.pmcc-file-label{font-weight:600}.pmcc-file-label+pmcc-input{margin-left:10px}::ng-deep .pmcc-file-list{margin:0}::ng-deep .pmcc-file-list .pmcc-more{font-weight:700;margin-top:4px}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], accept: [{
            type: Input
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], change: [{
            type: Output
        }], clear: [{
            type: Output
        }], multiple: [{
            type: Input
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], inputEl: [{
            type: ViewChild,
            args: ['fileInput', { static: true }]
        }], displayFileNames: [{
            type: ViewChild,
            args: ['displayFileNames', { static: true }]
        }] }); })();

class FileModule {
}
FileModule.ɵfac = function FileModule_Factory(t) { return new (t || FileModule)(); };
FileModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FileModule });
FileModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, InputModule, TooltipModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileModule, [{
        type: NgModule,
        args: [{
                declarations: [FileComponent],
                imports: [CommonModule, InputModule, TooltipModule, ButtonModule],
                exports: [FileComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileModule, { declarations: function () { return [FileComponent]; }, imports: function () { return [CommonModule, InputModule, TooltipModule, ButtonModule]; }, exports: function () { return [FileComponent]; } }); })();

/** Provider that defines how formGroup controls behave with regards to displaying error messages. */
class ErrorStateMatcher {
    isErrorState(control, form) {
        return !!(control && control.invalid && (control.touched || (form && form.submitted)));
    }
}
ErrorStateMatcher.ɵfac = function ErrorStateMatcher_Factory(t) { return new (t || ErrorStateMatcher)(); };
ErrorStateMatcher.ɵprov = i0.ɵɵdefineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorStateMatcher, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/** Error state matcher that matches when a control is invalid and dirty. */
class DirtyErrorStateMatcher {
    isErrorState(control, form) {
        return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
    }
}
DirtyErrorStateMatcher.ɵfac = function DirtyErrorStateMatcher_Factory(t) { return new (t || DirtyErrorStateMatcher)(); };
DirtyErrorStateMatcher.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DirtyErrorStateMatcher, factory: DirtyErrorStateMatcher.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirtyErrorStateMatcher, [{
        type: Injectable
    }], null, null); })();
/** Updates controls error only when submitted */
class SubmitErrorStateMatcher {
    isErrorState(control, form) {
        return !!(control && control.invalid && form && form.submitted);
    }
}
SubmitErrorStateMatcher.ɵfac = function SubmitErrorStateMatcher_Factory(t) { return new (t || SubmitErrorStateMatcher)(); };
SubmitErrorStateMatcher.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SubmitErrorStateMatcher, factory: SubmitErrorStateMatcher.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SubmitErrorStateMatcher, [{
        type: Injectable
    }], null, null); })();

const validationMessages = {
    validation: {
        required: 'Field is required',
        email: 'Invalid email format',
        equal: 'Password fields do not match',
        alphabetic: 'Only alphabetic characters allowed',
        hasDisallowedFileTypes: 'Upload field requires valid extension',
        wrongImageSize: 'Wrong image size',
    },
    correctFormErrors: 'Please correct the form errors',
};

class FormControlComponent {
    constructor(_defaultErrorStateMatcher, _parentForm, _parentFormGroup) {
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.validatorErrors = validationMessages.validation;
        this.meta = {};
        this.overlayError = false;
    }
    get matcher() {
        return this.errorStateMatcher || this._defaultErrorStateMatcher;
    }
    get parent() {
        return this._parentFormGroup || this._parentForm;
    }
    get invalid() {
        return this.matcher.isErrorState(this.control, this.parent);
    }
    get controlName() {
        return this.meta.controlName || this.ngControl.name || null;
    }
    ngDoCheck() {
        // We need to re-evaluate this on every change detection cycle, because there are some
        // error triggers that we can't subscribe to (e.g. parent form submissions). This means
        // that whatever logic is in here has to be super lean or we risk destroying the performance.
        this.errorMessage = this._getValidationMessage();
    }
    _getValidationMessage() {
        if (!this.control) {
            return;
        }
        if (this.invalid) {
            const errors = Object.keys(this.control.errors);
            const key = errors.filter(_ => _ in this.validatorErrors).shift();
            if (!key) {
                return `"${errors[0]}" validation error occurred.`;
            }
            const validationError = this.validatorErrors[key];
            if (validationError instanceof Function) {
                return validationError(this.controlName ? Object.assign(Object.assign(Object.assign({}, this.control.errors[key]), this.meta), { controlName: this.controlName }) : this.control.errors[key]);
            }
            else if (typeof validationError === 'string') {
                return validationError;
            }
            else {
                return `"${key}" wrong type of validation error.`;
            }
        }
        return null;
    }
    get control() {
        return this.ngControl ? this.ngControl.control : null;
    }
}
FormControlComponent.ɵfac = function FormControlComponent_Factory(t) { return new (t || FormControlComponent)(ɵngcc0.ɵɵdirectiveInject(ErrorStateMatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgForm, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8)); };
FormControlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormControlComponent, selectors: [["pmcc-form-control"]], contentQueries: function FormControlComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgControl, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngControl = _t.first);
    } }, hostVars: 2, hostBindings: function FormControlComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-form-control-invalid", ctx.invalid);
    } }, inputs: { validatorErrors: "validatorErrors", meta: "meta", overlayError: "overlayError", errorStateMatcher: "errorStateMatcher" }, ngContentSelectors: _c1, decls: 2, vars: 1, consts: [["class", "pmcc-inline-error", 3, "pmcc-position-overlay", "textContent", 4, "ngIf"], [1, "pmcc-inline-error", 3, "textContent"]], template: function FormControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, FormControlComponent_div_1_Template, 1, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
FormControlComponent.ctorParameters = () => [
    { type: ErrorStateMatcher },
    { type: NgForm, decorators: [{ type: Optional }] },
    { type: FormGroupDirective, decorators: [{ type: Optional }] }
];
FormControlComponent.propDecorators = {
    validatorErrors: [{ type: Input }],
    meta: [{ type: Input }],
    errorStateMatcher: [{ type: Input }],
    overlayError: [{ type: Input }],
    ngControl: [{ type: ContentChild, args: [NgControl,] }],
    invalid: [{ type: HostBinding, args: ['class.pmcc-form-control-invalid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormControlComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-form-control',
                template: "<ng-content></ng-content>\n<div *ngIf=\"errorMessage\"\n     class=\"pmcc-inline-error\"\n     [class.pmcc-position-overlay]=\"overlayError\"\n     [textContent]=\"errorMessage\"\n     i18n>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ErrorStateMatcher }, { type: ɵngcc3.NgForm, decorators: [{
                type: Optional
            }] }, { type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }]; }, { validatorErrors: [{
            type: Input
        }], meta: [{
            type: Input
        }], overlayError: [{
            type: Input
        }], invalid: [{
            type: HostBinding,
            args: ['class.pmcc-form-control-invalid']
        }], errorStateMatcher: [{
            type: Input
        }], ngControl: [{
            type: ContentChild,
            args: [NgControl]
        }] }); })();

class ScrollToErrorDirective {
    constructor(_parentForm, _parentFormGroup) {
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.submitSubscription = Subscription.EMPTY;
        this.formControls = [];
    }
    ngOnInit() {
        const form = this._parentFormGroup || this._parentForm;
        this.submitSubscription = form.ngSubmit.subscribe(() => this.scrollToInvalidControl());
    }
    ngOnDestroy() {
        this.submitSubscription.unsubscribe();
        this.formControls.length = 0;
    }
    registerControl(control) {
        /* istanbul ignore next */
        if (this.formControls.indexOf(control) === -1) {
            this.addControl(control);
        }
    }
    unregisterControl(control) {
        this.formControls = this.formControls.filter(c => c !== control);
    }
    scrollToInvalidControl() {
        const invalidControl = this.formControls.find(({ nativeElement }) => nativeElement.classList.contains('ng-invalid'));
        if (invalidControl) {
            invalidControl.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }
    addControl(control) {
        this.formControls.push(control);
        // Sort the controls by their position in the document.
        // That way we can just use `Array.find` to get the first (UI-wise) invalid
        // form control.
        this.formControls.sort((a, b) => {
            const mask = a.nativeElement.compareDocumentPosition(b.nativeElement);
            /* istanbul ignore next */
            // tslint:disable-next-line:no-bitwise
            return mask & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
    }
}
ScrollToErrorDirective.ɵfac = function ScrollToErrorDirective_Factory(t) { return new (t || ScrollToErrorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgForm, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 9)); };
ScrollToErrorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScrollToErrorDirective, selectors: [["form", "pmccScrollToError", ""]] });
ScrollToErrorDirective.ctorParameters = () => [
    { type: NgForm, decorators: [{ type: Host }, { type: Optional }] },
    { type: FormGroupDirective, decorators: [{ type: Host }, { type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollToErrorDirective, [{
        type: Directive,
        args: [{ selector: 'form[pmccScrollToError]' }]
    }], function () { return [{ type: ɵngcc3.NgForm, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }]; }, null); })();
/**
 * Since we can't reliably distinguish invalid formControls from invalid
 * formGroups/formGroupNames (they all add .ng-invalid classes to their hosts),
 * we use this directive, that is automatically applied to formControls only
 * (note the selector), so that scrollToError looks for an invalid control
 * amongst those that have the directive applied.
 */
class FormControlNativeElementDirective {
    constructor(elRef, scrollToErrorDirective) {
        this.scrollToErrorDirective = scrollToErrorDirective;
        this.nativeElement = elRef.nativeElement;
        if (this.scrollToErrorDirective) {
            this.scrollToErrorDirective.registerControl(this);
        }
    }
    ngOnDestroy() {
        if (this.scrollToErrorDirective) {
            this.scrollToErrorDirective.unregisterControl(this);
        }
    }
}
FormControlNativeElementDirective.ɵfac = function FormControlNativeElementDirective_Factory(t) { return new (t || FormControlNativeElementDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ScrollToErrorDirective, 8)); };
FormControlNativeElementDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormControlNativeElementDirective, selectors: [["", "ngModel", ""], ["", "formControl", ""], ["", "formControlName", ""], ["", "ngDefaultControl", ""]] });
FormControlNativeElementDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ScrollToErrorDirective, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormControlNativeElementDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[ngModel],[formControl],[formControlName],[ngDefaultControl]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ScrollToErrorDirective, decorators: [{
                type: Optional
            }] }]; }, null); })();

// @dynamic
class CommonValidators {
    static checkImageSize(requiredWidth, requiredHeight) {
        return (control) => {
            const reader = new FileReader();
            const image = new Image();
            const subject = new ReplaySubject(1);
            image.onload = function () {
                if (image.width !== requiredWidth || image.height !== requiredHeight) {
                    subject.next({ actualWidth: image.width, actualHeight: image.height });
                }
                else {
                    subject.next(null);
                }
                subject.complete();
            };
            reader.onload = function (e) {
                image.src = e.target.result;
            };
            if (control.value && control.value.length) {
                reader.readAsDataURL(control.value[0]);
            }
            else {
                subject.next(null);
                subject.complete();
            }
            return subject.pipe(map(result => {
                if (result) {
                    const { actualWidth, actualHeight } = result;
                    return {
                        wrongImageSize: {
                            actualWidth,
                            actualHeight,
                            requiredWidth,
                            requiredHeight,
                        },
                    };
                }
                return null;
            }));
        };
    }
    static email() {
        return (control) => {
            return (!CommonValidators.validators.email(control) || !control.value) ? null :
                { email: { actualValue: control.value, pattern: CommonValidators.regex.email } };
        };
    }
    static match(pattern) {
        return (control) => {
            const value = control.value ? String(control.value) : '';
            return value.match(pattern) ? null :
                { match: { actualValue: value, pattern: pattern } };
        };
    }
    static equal(otherControl) {
        return (control) => {
            const subscription = otherControl.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
                subscription.unsubscribe();
            });
            if (otherControl.value !== control.value) {
                return {
                    equal: true,
                };
            }
            return null;
        };
    }
    static alphabetic() {
        return (control) => {
            return !CommonValidators.validators.alphabetic(control) ? null :
                { alphabetic: { actualValue: control.value, pattern: CommonValidators.regex.alphabetic } };
        };
    }
}
CommonValidators.regex = {
    email: /.+@.+\.+.{2,6}$/,
    alphabetic: /^[a-zA-Z ]*$/,
};
CommonValidators.validators = {
    email: CommonValidators.match(CommonValidators.regex.email),
    alphabetic: CommonValidators.match(CommonValidators.regex.alphabetic),
};

class FormControlModule {
}
FormControlModule.ɵfac = function FormControlModule_Factory(t) { return new (t || FormControlModule)(); };
FormControlModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormControlModule });
FormControlModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, ReactiveFormsModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormControlModule, [{
        type: NgModule,
        args: [{
                declarations: [FormControlComponent, ScrollToErrorDirective, FormControlNativeElementDirective],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, IconModule],
                exports: [FormControlComponent, ScrollToErrorDirective, FormControlNativeElementDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormControlModule, { declarations: function () { return [FormControlComponent, ScrollToErrorDirective, FormControlNativeElementDirective]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, IconModule]; }, exports: function () { return [FormControlComponent, ScrollToErrorDirective, FormControlNativeElementDirective]; } }); })();

class GaugeComponent {
    constructor() {
        this.percent = -1;
        this.width = 0;
        this.height = 0;
        this.valueNotAvailableMessage = 'Not Available';
    }
    get label() {
        if (this.percent > -1) {
            return `${this.percent}%`;
        }
        else {
            return this.valueNotAvailableMessage;
        }
    }
    get gaugeEmptyHeight() {
        return this.height - clamp(this.percent, 0, 100) / 100 * this.height;
    }
}
GaugeComponent.ɵfac = function GaugeComponent_Factory(t) { return new (t || GaugeComponent)(); };
GaugeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GaugeComponent, selectors: [["pmcc-gauge"]], inputs: { percent: "percent", width: "width", height: "height", valueNotAvailableMessage: "valueNotAvailableMessage" }, decls: 7, vars: 9, consts: [[1, "pmcc-gauge-container"], [1, "pmcc-gauge"], [1, "pmcc-gauge-background"], [1, "pmcc-icon", "pmcc-ico-missing-content"], [1, "pmcc-fill-percentage", "pmcc-large"]], template: function GaugeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵelement(4, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("value-not-available", ctx.percent === -1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px")("height", ctx.height, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx.gaugeEmptyHeight, "px");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
    } }, styles: ["[_nghost-%COMP%]{display:inline-block}.pmcc-gauge-container[_ngcontent-%COMP%]   .pmcc-fill-percentage[_ngcontent-%COMP%]{font:normal 13px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;text-align:center}.pmcc-gauge-container[_ngcontent-%COMP%]   .pmcc-fill-percentage.pmcc-large[_ngcontent-%COMP%]{font-size:20px}.pmcc-gauge-container[_ngcontent-%COMP%]   .pmcc-gauge[_ngcontent-%COMP%]{margin:10px auto;background-color:#0184cc;border-radius:5px}.pmcc-gauge-container[_ngcontent-%COMP%]   .pmcc-gauge[_ngcontent-%COMP%]   .pmcc-gauge-background[_ngcontent-%COMP%]{background-color:#eae8e9;border-radius:4px 4px 0 0}.pmcc-gauge-container[_ngcontent-%COMP%]   .pmcc-icon[_ngcontent-%COMP%]{visibility:hidden}.pmcc-gauge-container.value-not-available[_ngcontent-%COMP%]   .pmcc-icon[_ngcontent-%COMP%]{visibility:visible;color:#bfbfbf;font-size:22px;left:-4px}.pmcc-gauge-container.value-not-available[_ngcontent-%COMP%]   .pmcc-icon[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:before{width:22px;height:22px}.pmcc-gauge-container.value-not-available[_ngcontent-%COMP%]   .pmcc-gauge-background[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#fff;border:1px solid #eae8e9}.pmcc-gauge-container.value-not-available[_ngcontent-%COMP%]   .pmcc-fill-percentage[_ngcontent-%COMP%]{color:#bfbfbf}.pmcc-gauge-container.value-not-available[_ngcontent-%COMP%]   .pmcc-fill-percentage.pmcc-large[_ngcontent-%COMP%]{font-size:13px}"] });
GaugeComponent.propDecorators = {
    percent: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    valueNotAvailableMessage: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaugeComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-gauge',
                template: "<div\n  class=\"pmcc-gauge-container\"\n  [class.value-not-available]=\"percent === -1\"\n>\n  <div\n    class=\"pmcc-gauge\"\n    [style.width.px]=\"width\"\n    [style.height.px]=\"height\"\n  >\n    <div\n      class=\"pmcc-gauge-background\"\n      [style.height.px]=\"gaugeEmptyHeight\"\n    >\n      <div>\n        <span class=\"pmcc-icon pmcc-ico-missing-content\"></span>\n      </div>\n    </div>\n  </div>\n  <div class=\"pmcc-fill-percentage pmcc-large\">\n    {{ label }}\n  </div>\n</div>\n",
                styles: [":host{display:inline-block}.pmcc-gauge-container .pmcc-fill-percentage{font:normal 13px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;text-align:center}.pmcc-gauge-container .pmcc-fill-percentage.pmcc-large{font-size:20px}.pmcc-gauge-container .pmcc-gauge{margin:10px auto;background-color:#0184cc;border-radius:5px}.pmcc-gauge-container .pmcc-gauge .pmcc-gauge-background{background-color:#eae8e9;border-radius:4px 4px 0 0}.pmcc-gauge-container .pmcc-icon{visibility:hidden}.pmcc-gauge-container.value-not-available .pmcc-icon{visibility:visible;color:#bfbfbf;font-size:22px;left:-4px}.pmcc-gauge-container.value-not-available .pmcc-icon :before{width:22px;height:22px}.pmcc-gauge-container.value-not-available .pmcc-gauge-background{display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#fff;border:1px solid #eae8e9}.pmcc-gauge-container.value-not-available .pmcc-fill-percentage{color:#bfbfbf}.pmcc-gauge-container.value-not-available .pmcc-fill-percentage.pmcc-large{font-size:13px}"]
            }]
    }], function () { return []; }, { percent: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], valueNotAvailableMessage: [{
            type: Input
        }] }); })();

class GaugeHealthComponent {
    constructor() {
        this.health = 0 /* Health0 */;
    }
}
GaugeHealthComponent.ɵfac = function GaugeHealthComponent_Factory(t) { return new (t || GaugeHealthComponent)(); };
GaugeHealthComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GaugeHealthComponent, selectors: [["pmcc-gauge-health"]], inputs: { health: "health" }, decls: 8, vars: 1, consts: [[1, "pmcc-gauge-health-container"], [1, "pmcc-gauge-health-status", 3, "ngClass"], [1, "pmcc-gauge-health-no-data"], [1, "pmcc-gauge-health-bars"], [1, "pmcc-gauge-health-bar"]], template: function GaugeHealthComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "\u2014");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", "pmcc-health-" + ctx.health);
    } }, directives: [ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{line-height:31px}.pmcc-gauge-health-bars[_ngcontent-%COMP%]{margin:0 4px}.pmcc-gauge-health-status.pmcc-health-0[_ngcontent-%COMP%]{color:#b3c0cd}.pmcc-gauge-health-status.pmcc-health-0[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]{display:none}.pmcc-gauge-health-status.pmcc-health-0[_ngcontent-%COMP%]   .pmcc-gauge-health-no-data[_ngcontent-%COMP%]{display:inline-block;width:28px;font-size:16px;color:#999;text-align:center}.pmcc-gauge-health-status.pmcc-health-1[_ngcontent-%COMP%]   .pmcc-gauge-health-icon[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-1[_ngcontent-%COMP%]   .pmcc-gauge-health-no-data[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-2[_ngcontent-%COMP%]   .pmcc-gauge-health-icon[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-2[_ngcontent-%COMP%]   .pmcc-gauge-health-no-data[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-icon[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-no-data[_ngcontent-%COMP%]{display:none}.pmcc-gauge-health-status.pmcc-health-1[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-2[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%], .pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]{height:20px;width:4px;background-color:#d5d5d5;border-radius:4px;margin:0 4px 0 0;display:inline-block}.pmcc-gauge-health-status.pmcc-health-1[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:first-of-type{background-color:#c5242a}.pmcc-gauge-health-status.pmcc-health-2[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:first-of-type, .pmcc-gauge-health-status.pmcc-health-2[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:nth-of-type(2){background-color:#e5b700}.pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:first-of-type, .pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:nth-of-type(2), .pmcc-gauge-health-status.pmcc-health-3[_ngcontent-%COMP%]   .pmcc-gauge-health-bar[_ngcontent-%COMP%]:nth-of-type(3){background-color:#1c7b1c}"] });
GaugeHealthComponent.propDecorators = {
    health: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaugeHealthComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-gauge-health',
                template: "<div class=\"pmcc-gauge-health-container\">\n  <div\n    class=\"pmcc-gauge-health-status\"\n    [ngClass]=\"'pmcc-health-' + health\"\n  >\n    <div class=\"pmcc-gauge-health-no-data\">&mdash;</div>\n    <div class=\"pmcc-gauge-health-bars\">\n      <div class=\"pmcc-gauge-health-bar\"></div>\n      <div class=\"pmcc-gauge-health-bar\"></div>\n      <div class=\"pmcc-gauge-health-bar\"></div>\n    </div>\n  </div>\n</div>\n",
                styles: [":host{line-height:31px}.pmcc-gauge-health-bars{margin:0 4px}.pmcc-gauge-health-status.pmcc-health-0{color:#b3c0cd}.pmcc-gauge-health-status.pmcc-health-0 .pmcc-gauge-health-bar{display:none}.pmcc-gauge-health-status.pmcc-health-0 .pmcc-gauge-health-no-data{display:inline-block;width:28px;font-size:16px;color:#999;text-align:center}.pmcc-gauge-health-status.pmcc-health-1 .pmcc-gauge-health-icon,.pmcc-gauge-health-status.pmcc-health-1 .pmcc-gauge-health-no-data,.pmcc-gauge-health-status.pmcc-health-2 .pmcc-gauge-health-icon,.pmcc-gauge-health-status.pmcc-health-2 .pmcc-gauge-health-no-data,.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-icon,.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-no-data{display:none}.pmcc-gauge-health-status.pmcc-health-1 .pmcc-gauge-health-bar,.pmcc-gauge-health-status.pmcc-health-2 .pmcc-gauge-health-bar,.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-bar{height:20px;width:4px;background-color:#d5d5d5;border-radius:4px;margin:0 4px 0 0;display:inline-block}.pmcc-gauge-health-status.pmcc-health-1 .pmcc-gauge-health-bar:first-of-type{background-color:#c5242a}.pmcc-gauge-health-status.pmcc-health-2 .pmcc-gauge-health-bar:first-of-type,.pmcc-gauge-health-status.pmcc-health-2 .pmcc-gauge-health-bar:nth-of-type(2){background-color:#e5b700}.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-bar:first-of-type,.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-bar:nth-of-type(2),.pmcc-gauge-health-status.pmcc-health-3 .pmcc-gauge-health-bar:nth-of-type(3){background-color:#1c7b1c}"]
            }]
    }], function () { return []; }, { health: [{
            type: Input
        }] }); })();

class MiniReportGaugeComponent {
    constructor() {
        this._lightenRatio = 40;
        this._lightenColors = {};
    }
    lightenColor(color) {
        if (!this._lightenColors[color]) {
            this._lightenColors[color] = tinycolor(color).lighten(this._lightenRatio).toString();
        }
        return this._lightenColors[color];
    }
    isDarkColor(color) {
        return tinycolor(color).isDark();
    }
}
MiniReportGaugeComponent.ɵfac = function MiniReportGaugeComponent_Factory(t) { return new (t || MiniReportGaugeComponent)(); };
MiniReportGaugeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MiniReportGaugeComponent, selectors: [["pmcc-mini-report-gauge"]], inputs: { bars: "bars" }, decls: 2, vars: 1, consts: [[1, "pmcc-mini-report-gauge"], ["class", "bar-wrapper", 3, "ngClass", "ngStyle", "css-vars", 4, "ngFor", "ngForOf"], [1, "bar-wrapper", 3, "ngClass", "ngStyle", "css-vars"], [1, "top-bar"], [1, "middle-bar"], [1, "pmcc-tooltip-pane", 3, "ngClass"], [1, "pmcc-tooltip-layer", 3, "ngClass", "content"], [1, "bottom-bar"]], template: function MiniReportGaugeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MiniReportGaugeComponent_div_1_Template, 6, 13, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.bars);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc4.CssVarsDirective, TooltipComponent], styles: [".pmcc-mini-report-gauge[_ngcontent-%COMP%]{display:flex;padding:48px 23px 48px 0}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]{position:relative}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-top[_ngcontent-%COMP%]   .top-bar[_ngcontent-%COMP%]{border-right-width:1px}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-top[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]{top:-65px}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-top[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]   .pmcc-tooltip-layer.arrow-box[_ngcontent-%COMP%]:before{border-top-color:var(--barColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-top[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]   .pmcc-tooltip-layer.arrow-box[_ngcontent-%COMP%]:after{border-top-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-bottom[_ngcontent-%COMP%]   .bottom-bar[_ngcontent-%COMP%]{border-right-width:1px}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-bottom[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]{top:45px}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-bottom[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]   .pmcc-tooltip-layer.arrow-box[_ngcontent-%COMP%]:before{border-bottom-color:var(--barColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper.tooltip-bottom[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]   .pmcc-tooltip-layer.arrow-box[_ngcontent-%COMP%]:after{border-bottom-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .bottom-bar[_ngcontent-%COMP%], .pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%], .pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .top-bar[_ngcontent-%COMP%]{height:15px;border:0 solid var(--barColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]{display:flex;justify-content:center;height:25px;border-left:1px solid #fff;background-color:var(--barColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]{position:relative;right:-50%;margin-left:-1px}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]     .pmcc-tooltip-layer.arrow-box{border-color:var(--barColor);background-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge[_ngcontent-%COMP%]   .bar-wrapper[_ngcontent-%COMP%]   .middle-bar[_ngcontent-%COMP%]   .pmcc-tooltip-pane[_ngcontent-%COMP%]     .pmcc-tooltip-layer.arrow-box.dark p{color:#fff}"] });
MiniReportGaugeComponent.propDecorators = {
    bars: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MiniReportGaugeComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-mini-report-gauge',
                template: "<div class=\"pmcc-mini-report-gauge\">\n  <div\n    class=\"bar-wrapper\"\n    *ngFor=\"let item of bars;\"\n    [ngClass]=\"'tooltip-' + item.tooltipPosition\"\n    [ngStyle]=\"{flexGrow: item.fillPercentage}\"\n    [css-vars]=\"{'--barColor': item.color, '--tooltipBackgroundColor': lightenColor(item.color)}\"\n  >\n    <div class=\"top-bar\"></div>\n\n    <div class=\"middle-bar\">\n      <div\n        class=\"pmcc-tooltip-pane\"\n        [ngClass]=\"item.tooltipPosition === 'bottom' ? 'southcentral' : 'northcentral'\"\n      >\n        <pmcc-tooltip\n          class=\"pmcc-tooltip-layer\"\n          [ngClass]=\"{dark: isDarkColor(lightenColor(item.color))}\"\n          [content]=\"item.tooltipLabel\"\n        ></pmcc-tooltip>\n      </div>\n    </div>\n\n    <div class=\"bottom-bar\"></div>\n  </div>\n</div>\n",
                styles: [".pmcc-mini-report-gauge{display:flex;padding:48px 23px 48px 0}.pmcc-mini-report-gauge .bar-wrapper{position:relative}.pmcc-mini-report-gauge .bar-wrapper.tooltip-top .top-bar{border-right-width:1px}.pmcc-mini-report-gauge .bar-wrapper.tooltip-top .middle-bar .pmcc-tooltip-pane{top:-65px}.pmcc-mini-report-gauge .bar-wrapper.tooltip-top .middle-bar .pmcc-tooltip-pane .pmcc-tooltip-layer.arrow-box:before{border-top-color:var(--barColor)}.pmcc-mini-report-gauge .bar-wrapper.tooltip-top .middle-bar .pmcc-tooltip-pane .pmcc-tooltip-layer.arrow-box:after{border-top-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge .bar-wrapper.tooltip-bottom .bottom-bar{border-right-width:1px}.pmcc-mini-report-gauge .bar-wrapper.tooltip-bottom .middle-bar .pmcc-tooltip-pane{top:45px}.pmcc-mini-report-gauge .bar-wrapper.tooltip-bottom .middle-bar .pmcc-tooltip-pane .pmcc-tooltip-layer.arrow-box:before{border-bottom-color:var(--barColor)}.pmcc-mini-report-gauge .bar-wrapper.tooltip-bottom .middle-bar .pmcc-tooltip-pane .pmcc-tooltip-layer.arrow-box:after{border-bottom-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge .bar-wrapper .bottom-bar,.pmcc-mini-report-gauge .bar-wrapper .middle-bar,.pmcc-mini-report-gauge .bar-wrapper .top-bar{height:15px;border:0 solid var(--barColor)}.pmcc-mini-report-gauge .bar-wrapper .middle-bar{display:flex;justify-content:center;height:25px;border-left:1px solid #fff;background-color:var(--barColor)}.pmcc-mini-report-gauge .bar-wrapper .middle-bar .pmcc-tooltip-pane{position:relative;right:-50%;margin-left:-1px}.pmcc-mini-report-gauge .bar-wrapper .middle-bar .pmcc-tooltip-pane ::ng-deep .pmcc-tooltip-layer.arrow-box{border-color:var(--barColor);background-color:var(--tooltipBackgroundColor)}.pmcc-mini-report-gauge .bar-wrapper .middle-bar .pmcc-tooltip-pane ::ng-deep .pmcc-tooltip-layer.arrow-box.dark p{color:#fff}"]
            }]
    }], function () { return []; }, { bars: [{
            type: Input
        }] }); })();

class GaugeModule {
}
GaugeModule.ɵfac = function GaugeModule_Factory(t) { return new (t || GaugeModule)(); };
GaugeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GaugeModule });
GaugeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TooltipModule, CssVarsModule.forChild()]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaugeModule, [{
        type: NgModule,
        args: [{
                declarations: [GaugeComponent, GaugeHealthComponent, MiniReportGaugeComponent],
                imports: [CommonModule, TooltipModule, CssVarsModule.forChild()],
                exports: [GaugeComponent, GaugeHealthComponent, MiniReportGaugeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GaugeModule, { declarations: function () { return [GaugeComponent, GaugeHealthComponent, MiniReportGaugeComponent]; }, imports: function () { return [CommonModule, TooltipModule, ɵngcc4.CssVarsModule]; }, exports: function () { return [GaugeComponent, GaugeHealthComponent, MiniReportGaugeComponent]; } }); })();

/**
 * Demo page to show in CompoDoc documentation
 * <example-url>/demo/#/pmcc/header</example-url>
 * Example usage to show in Info tab of CompoDoc:
 * ```typescript
  <pmcc-global-header
    [menus]="menus"
    [activeMenu]="activeMenu"
    [alerts]="alertsModel"
    [help]="help"
    [userInfo]="userInfo"
    [userInfoMenu]="userInfoMenu"
    [logoutHidden]="logoutHidden"
    (logoutCallback)="onLogout($event)">
  </pmcc-global-header>
 ```
 */
class GlobalHeaderComponent {
    constructor() {
        this.homeUrl = 'https://www.pubmatic.com';
        this.menus = [];
        this.logoutCallback = new EventEmitter();
    }
    // sortAlphabets(item1:string, item2:string) {
    //   return item1 > item2 ? 1 : item1===item2 ? 0 : -1;
    // }
    /**
     * @ignore
     */
    ngOnInit() {
        // this.menus.sort((menu1, menu2) => this.sortAlphabets(menu1.id, menu2.id));
        this.hideAllSecondaryMenus();
        this.miniMode = false;
        // mark Active Menu
        this.menus.map(m => (m.isActive = m.id === this.activeMenu));
    }
    /**
     * @ignore
     */
    get alertsCount() {
        return this.alertsModel.alertsCount;
    }
    hideAllSecondaryMenus() {
        this.displayAlertsMenu = false;
        this.displaySecondaryNavMenu = false;
        this.displayUserMenu = false;
        this.currentNav = null;
    }
    showSecondaryMenu(menuItem) {
        this.hideAllSecondaryMenus();
        this.displaySecondaryNavMenu = true;
        this.currentNav = menuItem;
    }
    showAlertsMenu() {
        this.hideAllSecondaryMenus();
        this.displayAlertsMenu = true;
    }
    showUserMenu() {
        this.hideAllSecondaryMenus();
        this.displayUserMenu = true;
    }
    onLogoutClickHandler() {
        this.logoutCallback.emit({ userInfo: this.userInfo });
    }
}
GlobalHeaderComponent.ɵfac = function GlobalHeaderComponent_Factory(t) { return new (t || GlobalHeaderComponent)(); };
GlobalHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GlobalHeaderComponent, selectors: [["pmcc-global-header"]], inputs: { homeUrl: "homeUrl", menus: "menus", activeMenu: "activeMenu", alertsModel: ["alerts", "alertsModel"], help: "help", userInfo: "userInfo", userInfoMenu: "userInfoMenu", logoutHidden: "logoutHidden" }, outputs: { logoutCallback: "logoutCallback" }, decls: 12, vars: 7, consts: [[1, "wrapper"], ["data-pm-id", "gh-logo", 1, "hidden-below-sm", 3, "href"], [1, "pmcc-nav-item", "logo", "pmcc-d-sm-none", "pmcc-d-md-inline-block"], ["data-pm-id", "gh-logo-responsive", 3, "href"], [1, "pmcc-nav-item", "logo", "clipped", "pmcc-d-md-none", "pmcc-d-sm-inline-block"], [1, "nav-items-wrapper"], ["class", "pmcc-nav-item", 3, "selected", "mouseover", "click", 4, "ngFor", "ngForOf"], ["class", "panel-full-width nav-items-container", "data-pm-id", "secondary-nav-menu", 3, "show", 4, "ngIf"], [1, "pmcc-nav-item", "force-right"], ["class", "pmcc-nav-item tight hidden-below-lg", 4, "ngIf"], ["class", "alert-items-wrapper", 4, "ngIf"], ["class", "user-menu-wrapper", 4, "ngIf"], [1, "pmcc-nav-item", 3, "mouseover", "click"], ["data-pm-id", "secondary-nav-menu", 1, "panel-full-width", "nav-items-container"], ["class", "panel-left", 4, "ngIf"], ["class", "panel-center", 4, "ngIf"], ["class", "panel-right", 3, "adSlot", 4, "ngIf"], [1, "panel-left"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], ["name", "chevron-right", "size", "1x"], [1, "panel-center"], [4, "ngFor", "ngForOf"], [3, "target", "rel", "href"], [1, "panel-right", 3, "adSlot"], [1, "pmcc-nav-item", "tight", "hidden-below-lg"], [1, "alert-items-wrapper"], ["id", "alertsBtn", "data-pm-id", "gh-alerts-icon", 1, "pmcc-nav-item", "icon", "tight", 3, "click", "mouseover"], ["name", "alert"], [1, "badge"], ["data-pm-id", "alerts", 1, "panel-dyna-width", "alert-items-container"], ["class", "badge", 4, "ngIf"], [1, "alerts"], [1, "title"], [4, "ngIf"], ["class", "divider", 4, "ngIf"], ["class", "wrap", 4, "ngFor", "ngForOf"], ["data-pm-id", "gh-view-all-alerts", 3, "href"], [1, "divider"], [1, "wrap"], [3, "href"], ["data-pm-id", "gh-create-alert", 3, "href"], [1, "user-menu-wrapper"], ["data-pm-id", "gh-overflow-menu", 1, "pmcc-nav-item", "icon", "tight", "pmcc-d-lg-none", "last", 3, "click", "mouseover"], ["name", "hamburger"], ["data-pm-id", "gh-user-info", 1, "pmcc-nav-item", "tight", "stacked", "hidden-below-lg", "last", 3, "mouseover", "click"], [1, "logged-user-heading", "pmcc-gh-truncate"], [1, "small", "pmcc-gh-truncate"], [1, "panel-dyna-width", "user-menu-container"], [1, "panel-left", "user-menu-left-container"], ["class", "logged-user-heading", 4, "ngIf"], ["class", "user-menu-item", 4, "ngIf"], ["class", "user-menu-item", 4, "ngFor", "ngForOf"], [3, "adSlot", 4, "ngIf"], ["data-pm-id", "gh-log-out", 3, "hidden", "click"], [1, "logged-user-heading"], [1, "user-menu-item"], [3, "adSlot"], [3, "href", "click"]], template: function GlobalHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵelement(4, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, GlobalHeaderComponent_span_6_Template, 3, 4, "span", 6);
        ɵngcc0.ɵɵtemplate(7, GlobalHeaderComponent_div_7_Template, 4, 5, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "span", 8);
        ɵngcc0.ɵɵtemplate(9, GlobalHeaderComponent_span_9_Template, 3, 2, "span", 9);
        ɵngcc0.ɵɵtemplate(10, GlobalHeaderComponent_div_10_Template, 22, 12, "div", 10);
        ɵngcc0.ɵɵtemplate(11, GlobalHeaderComponent_div_11_Template, 25, 15, "div", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.homeUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.homeUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menus);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentNav);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.alertsModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.userInfo);
    } }, directives: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, IconComponent, AdTagComponent]; }, styles: ["[_nghost-%COMP%]{display:block;color:#fff;position:fixed;top:0;z-index:30000;width:100%;max-width:1366px}[_nghost-%COMP%]   .wrapper[_ngcontent-%COMP%]{position:relative;background:#1d2b41;display:flex;width:100%;align-items:center;min-height:56px}[_nghost-%COMP%]   div.alert-items-container[_ngcontent-%COMP%], [_nghost-%COMP%]   div.nav-items-container[_ngcontent-%COMP%], [_nghost-%COMP%]   div.user-menu-container[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   .nav-items-wrapper[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-self:stretch;align-items:center}[_nghost-%COMP%]   .nav-items-wrapper[_ngcontent-%COMP%]:hover > div.nav-items-container[_ngcontent-%COMP%]{display:flex;left:0}[_nghost-%COMP%]   .alert-items-wrapper[_ngcontent-%COMP%]{display:flex;align-self:stretch;align-items:center}[_nghost-%COMP%]   .alert-items-wrapper[_ngcontent-%COMP%]:hover > div.alert-items-container[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]   .user-menu-wrapper[_ngcontent-%COMP%]{display:flex;align-self:stretch;align-items:center}[_nghost-%COMP%]   .user-menu-wrapper[_ngcontent-%COMP%]:hover > div.user-menu-container[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]   .user-menu-wrapper[_ngcontent-%COMP%]   .user-menu-container[_ngcontent-%COMP%]   .user-menu-left-container.panel-left[_ngcontent-%COMP%]{padding:24px}[_nghost-%COMP%]   .user-menu-wrapper[_ngcontent-%COMP%]   .user-menu-container[_ngcontent-%COMP%]   .user-menu-left-container.panel-left[_ngcontent-%COMP%]   .user-menu-item[_ngcontent-%COMP%]{margin-bottom:5px}[_nghost-%COMP%]   .logged-user-heading[_ngcontent-%COMP%]{word-break:break-word}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]{font-family:MuliBold,Arial Regular,Arial,sans-serif;letter-spacing:.1px;font-size:15px;white-space:nowrap;align-content:center;position:relative;display:inline-block;cursor:pointer;margin-top:6px;margin-bottom:6px;padding-bottom:6px;color:#a4b1b6;transition:all 0s ease-in}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], [_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:visited{color:inherit!important;text-decoration:none!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]:first-child{margin-left:24px}[_nghost-%COMP%]   .pmcc-nav-item.last[_ngcontent-%COMP%]{margin-right:24px}[_nghost-%COMP%]   .pmcc-nav-item.logo[_ngcontent-%COMP%]{align-content:center;display:inline-block;width:107px;height:16px;background-image:url(https://cdn.pubmatic.com/common/pmcc/latest/img/pubmatic-logo-sm.png);background-repeat:no-repeat;background-size:107px 16px;margin-right:32px}[_nghost-%COMP%]   .pmcc-nav-item.logo.clipped[_ngcontent-%COMP%]{width:32px}[_nghost-%COMP%]   .pmcc-nav-item.selected[_ngcontent-%COMP%]{color:#fff;border-bottom:3px solid #00ccf1}[_nghost-%COMP%]   .pmcc-nav-item.selected[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%]{top:-11140px;min-width:100px;z-index:30001;background:#ccc;color:#666;padding:10px;display:flex}[_nghost-%COMP%]   .pmcc-nav-item.force-right[_ngcontent-%COMP%]{margin-left:auto!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]:hover{color:#fff}[_nghost-%COMP%]   .pmcc-nav-item.previewing[_ngcontent-%COMP%]{position:relative;color:#fff}[_nghost-%COMP%]   .pmcc-nav-item.previewing2[_ngcontent-%COMP%]{color:#fff;position:relative}[_nghost-%COMP%]   .pmcc-nav-item.previewing2[_ngcontent-%COMP%]:after{position:absolute;content:\"-\"}[_nghost-%COMP%]   .pmcc-nav-item.icon[_ngcontent-%COMP%]{font-size:1.4em}[_nghost-%COMP%]   .pmcc-nav-item.stacked[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]{font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item[_ngcontent-%COMP%]{margin-left:32px}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item.tight[_ngcontent-%COMP%]{margin-left:24px}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]   span.badge[_ngcontent-%COMP%]{position:absolute;display:none;left:10px;top:10px;z-index:1;padding:2px 4px;border-radius:12px;background:#0499d3;color:#fff;font-size:11px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]   .pmcc-gh-truncate[_ngcontent-%COMP%]{max-width:250px;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[_nghost-%COMP%]   .pmcc-nav-item.show-badge[_ngcontent-%COMP%]{margin-right:16px}[_nghost-%COMP%]   .pmcc-nav-item.show-badge[_ngcontent-%COMP%]   span.badge[_ngcontent-%COMP%]{display:inline-block}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]{position:absolute;background:#fff;color:#999;height:0;min-height:0;overflow:hidden;display:flex;width:100%;transition:all 0s ease-in}[_nghost-%COMP%]   .panel-dyna-width.show[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width.show[_ngcontent-%COMP%]{height:auto;min-height:250px!important;top:100%;box-shadow:0 0 10px 15px #0003}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%]{background:#f9f9f9;flex-basis:20%;min-width:200px;padding:24px 42px;font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin-top:0;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;font-size:18px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]{flex-basis:60%;display:flex;padding:24px 48px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:10%}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin:0;padding:0 5px;color:#999;white-space:nowrap;font-size:13px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;padding:0;margin:0}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;color:#1b2431;white-space:nowrap;font-size:15px;letter-spacing:.2px;line-height:32px;padding:0 5px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.wrap[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.wrap[_ngcontent-%COMP%]{white-space:normal!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover, [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#f0f0f0;cursor:pointer}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:visited, [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:visited{display:block;color:inherit;text-decoration:inherit}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]{flex-basis:20%;border-left:1px solid #d8d8d8;padding-left:24px;margin:24px 64px 24px 24px;font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin-top:0;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;font-size:18px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]:before, [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]:before{content:\"NEW\";font-size:11px;margin-right:10px;padding:3px 8px;background:green;color:#fff}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]{background:#fff;color:#999;height:0;min-height:0;overflow:hidden;display:flex;position:absolute;width:480px;right:0;transition:all 0s ease-in}[_nghost-%COMP%]   .panel-dyna-width.show[_ngcontent-%COMP%]{height:auto;min-height:240px;box-shadow:0 0 10px 15px #0003}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   span.badge[_ngcontent-%COMP%]{padding:2px 8px;border-radius:12px;background:#0499d3;color:#fff;font-size:11px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]{padding:24px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;padding:0;margin:0;display:block;width:100%}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul.alerts[_ngcontent-%COMP%]{max-height:420px;overflow-y:auto}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{line-height:32px;padding:0 5px;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;color:#1b2431;white-space:nowrap;font-size:15px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.wrap[_ngcontent-%COMP%]{white-space:normal!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.wrap[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{white-space:normal!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]{color:#999;white-space:normal;font-size:13px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]:hover{background:inherit!important;cursor:inherit!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.divider[_ngcontent-%COMP%]{border-top:1px solid #d8d8d8;margin-top:8px;padding-bottom:8px}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.divider[_ngcontent-%COMP%]:hover{background:#0000;cursor:default}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#f0f0f0;cursor:pointer}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:visited{display:block;color:inherit;text-decoration:inherit}@media screen and (max-width:1024px){.hidden-below-lg[_ngcontent-%COMP%]{display:none!important}[_nghost-%COMP%]   .logo[_ngcontent-%COMP%]{margin-right:16px!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]:first-child{margin-left:16px}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]:last-child{margin-right:16px}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item[_ngcontent-%COMP%]{margin-left:16px!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item.force-right[_ngcontent-%COMP%]{margin-left:auto!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:5%!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:13px!important}}@media screen and (max-width:768px){[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]{font-size:13px!important}[_nghost-%COMP%]   .pmcc-nav-item.selected[_ngcontent-%COMP%]{padding-bottom:2px;border-bottom-width:2px!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item[_ngcontent-%COMP%]{margin-left:16px!important}[_nghost-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%] + .pmcc-nav-item.force-right[_ngcontent-%COMP%]{margin-left:auto!important}[_nghost-%COMP%]   .pmcc-nav-item.icon[_ngcontent-%COMP%]{font-size:1.2em!important}.logo[_ngcontent-%COMP%]{width:20px!important;margin-right:0!important}.panel-dyna-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%], .panel-full-width[_ngcontent-%COMP%]   .panel-right[_ngcontent-%COMP%]{display:none}.panel-dyna-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%], .panel-full-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%]{margin-left:16px;padding-left:16px!important;padding-right:16px!important}.panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%], .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]{padding-left:16px!important}.panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:13px!important}}@media screen and (max-width:576px){[_nghost-%COMP%]   .hidden-below-sm[_ngcontent-%COMP%]{display:none!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-left[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]{width:60%!important;padding:24px!important;flex-direction:column!important}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:0!important;margin-top:8px;border-top:1px solid #d8d8d8}[_nghost-%COMP%]   .panel-dyna-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], [_nghost-%COMP%]   .panel-full-width[_ngcontent-%COMP%]   .panel-center[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:13px!important}}"] });
GlobalHeaderComponent.ctorParameters = () => [];
GlobalHeaderComponent.propDecorators = {
    homeUrl: [{ type: Input }],
    menus: [{ type: Input }],
    activeMenu: [{ type: Input }],
    alertsModel: [{ type: Input, args: ['alerts',] }],
    help: [{ type: Input }],
    userInfo: [{ type: Input }],
    userInfoMenu: [{ type: Input }],
    logoutHidden: [{ type: Input }],
    logoutCallback: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-global-header',
                template: "<div class=\"wrapper\">\n  <!--logo-->\n  <a href=\"{{homeUrl}}\" data-pm-id=\"gh-logo\" class=\"hidden-below-sm\">\n    <span class=\"pmcc-nav-item logo pmcc-d-sm-none pmcc-d-md-inline-block\"></span>\n  </a>\n  <a href=\"{{homeUrl}}\" data-pm-id=\"gh-logo-responsive\">\n    <span class=\"pmcc-nav-item logo clipped pmcc-d-md-none pmcc-d-sm-inline-block\"></span>\n  </a>\n\n  <!--top level nav items-->\n  <div class=\"nav-items-wrapper\">\n    <span class=\"pmcc-nav-item\" *ngFor=\"let item of menus\" [class.selected]=\"item.isActive\" (mouseover)=\"showSecondaryMenu(item)\"\n          (click)=\"showSecondaryMenu(item)\">\n      <label [attr.data-pm-id]=\"item.label\">{{item.label}}</label>\n    </span>\n    <div class=\"panel-full-width nav-items-container\" [class.show]=\"displaySecondaryNavMenu\" *ngIf=\"currentNav\" data-pm-id=\"secondary-nav-menu\">\n      <span class=\"panel-left\" *ngIf=\"currentNav && currentNav.description\">\n        <h2>{{currentNav.description.title}}</h2>\n        <p>{{currentNav.description.summary}}</p>\n        <a href=\"{{currentNav.description.learnMoreUrl}}\" target=\"_blank\" *ngIf=\"currentNav.description.learnMoreUrl\">\n          Learn more\n          <pmcc-icon name=\"chevron-right\" size=\"1x\"></pmcc-icon>\n        </a>\n      </span>\n\n      <span class=\"panel-center\" *ngIf=\"currentNav\">\n        <span *ngFor=\"let group of currentNav.groups\">\n          <h2>{{group.label}}</h2>\n          <ul *ngFor=\"let item of group.items\">\n            <li [attr.data-pm-id]=\"item.label\">\n              <a [target]=\"item.openInNewTab ? '_blank' : '_self'\"\n                [rel]=\"item.openInNewTab ? 'opener' : 'noopener'\"\n                href=\"{{item.url}}\"\n              >{{item.label}}</a>\n            </li>\n          </ul>\n        </span>\n      </span>\n\n      <pmcc-ad-tag *ngIf=\"currentNav.adSlot\" class=\"panel-right\" [adSlot]=\"currentNav.adSlot\">\n      </pmcc-ad-tag>\n\n    </div>\n  </div>\n\n\n  <!--force everything after this element to the right side-->\n  <span class=\"pmcc-nav-item force-right\"></span>\n\n  <!--Help Link-->\n  <span class=\"pmcc-nav-item tight hidden-below-lg\" *ngIf=\"help\">\n    <a href=\"{{help.url}}\" target=\"_blank\" [attr.data-pm-id]=\"help.label\">Help</a>\n  </span>\n\n  <!--Alerts Menu-->\n  <div class=\"alert-items-wrapper\" *ngIf=\"alertsModel\">\n    <div id=\"alertsBtn\" class=\"pmcc-nav-item icon tight\" [class.show-badge]=\"alertsCount>0\" (click)=\"showAlertsMenu()\" (mouseover)=\"showAlertsMenu()\"\n         data-pm-id=\"gh-alerts-icon\">\n      <pmcc-icon name=\"alert\"></pmcc-icon>\n      <span class=\"badge\">{{alertsCount}}</span>\n    </div>\n    <div class=\"panel-dyna-width alert-items-container\" [class.show]=\"displayAlertsMenu\" data-pm-id=\"alerts\">\n      <span class=\"panel-left\">\n        <h2>\n          Alerts\n          <span class=\"badge\" *ngIf=\"alertsCount > 0\">{{alertsCount}}</span>\n        </h2>\n      </span>\n      <span class=\"panel-center\">\n        <ul class=\"alerts\">\n          <li class=\"title\">Recent Alerts</li>\n\n          <li *ngIf=\"!alertsCount\">You have no recent alerts</li>\n          <li class=\"divider\" *ngIf=\"!alertsCount\"></li>\n          <li class=\"wrap\" *ngFor=\"let item of alertsModel.alerts\">\n            <a href=\"{{alertsModel.viewAllUrl}}\" [attr.data-pm-id]=\"'alerts-'+item.label\">{{item.label}}</a>\n          </li>\n\n          <li class=\"divider\" *ngIf=\"alertsCount > 0\"></li>\n\n          <li>\n            <a data-pm-id=\"gh-view-all-alerts\" href=\"{{alertsModel.viewAllUrl}}\">\n              View All Alerts\n            </a>\n          </li>\n\n          <li *ngIf=\"alertsModel.createUrl\">\n            <a data-pm-id=\"gh-create-alert\" href=\"{{alertsModel.createUrl}}\">\n              Create An Alert\n            </a>\n          </li>\n        </ul>\n      </span>\n    </div>\n  </div>\n\n\n  <!-- User Menu options -->\n  <div class=\"user-menu-wrapper\" *ngIf=\"userInfo\">\n    <!--Hamburger menu to appear in large or md or sm or xs viewports-->\n    <span class=\"pmcc-nav-item icon tight pmcc-d-lg-none last\" (click)=\"miniMode=true; showUserMenu()\" (mouseover)=\"miniMode=true; showUserMenu()\"\n          data-pm-id=\"gh-overflow-menu\">\n      <pmcc-icon name=\"hamburger\"></pmcc-icon>\n    </span>\n    <span class=\"pmcc-nav-item tight stacked hidden-below-lg last\" (mouseover)=\"miniMode=false;showUserMenu()\" (click)=\"miniMode=false;showUserMenu()\"\n          data-pm-id=\"gh-user-info\">\n      <div class=\"logged-user-heading pmcc-gh-truncate\">{{userInfo.username}}</div>\n      <div class=\"small pmcc-gh-truncate\">{{userInfo.company}}</div>\n    </span>\n    <div class=\"panel-dyna-width user-menu-container\" [class.show]=\"displayUserMenu\">\n      <span class=\"panel-left user-menu-left-container\">\n        <h2 class=\"logged-user-heading\" *ngIf=\"userInfo.username\">{{userInfo.username}}</h2>\n        <p> {{userInfo.company}}</p>\n        <!-- TODO: remove this after all Apps Upgrade PMCC -->\n        <div *ngIf=\"userInfo.accountId\" class=\"user-menu-item\">\n          <strong>ID:</strong> {{userInfo.accountId}}\n        </div>\n        <div *ngIf=\"userInfo.timezone\" class=\"user-menu-item\">\n          <strong>Timezone:</strong> {{userInfo.timezone}}\n        </div>\n        <div *ngIf=\"userInfo.currency\" class=\"user-menu-item\">\n          <strong>Currency:</strong> {{userInfo.currency}}\n        </div>\n        <div *ngFor=\"let meta of userInfo.metaData\" class=\"user-menu-item\">\n          <strong>{{meta.label}}:</strong> {{meta.value}}\n        </div>\n        <pmcc-ad-tag *ngIf=\"displayUserMenu\" [adSlot]=\"userInfo.adSlot\"></pmcc-ad-tag>\n      </span>\n      <span class=\"panel-center\">\n        <ul>\n          <li *ngIf=\"miniMode\">\n            <a href=\"{{help.url}}\" target=\"_blank\">{{help.label}}</a>\n          </li>\n          <li *ngIf=\"miniMode\" class=\"divider\"></li>\n\n          <!--dynamic menus-->\n          <ng-container *ngFor=\"let group of userInfoMenu\">\n            <li class=\"title\">\n              <span>{{group.label}}</span>\n            </li>\n\n            <li *ngFor=\"let item of group.items\">\n              <a\n                [href]=\"item.url\"\n                (click)=\"item.click && item.click($event)\"\n                [attr.data-pm-id]=\"'gh-'+item.label\"\n              >\n                {{item.label}}\n              </a>\n            </li>\n            <li class=\"divider\"></li>\n          </ng-container>\n\n          <li [hidden]=\"logoutHidden\" (click)=\"onLogoutClickHandler()\" data-pm-id=\"gh-log-out\">\n            Log Out\n          </li>\n\n        </ul>\n      </span>\n    </div>\n  </div>\n\n</div>\n",
                styles: [":host{display:block;color:#fff;position:fixed;top:0;z-index:30000;width:100%;max-width:1366px}:host .wrapper{position:relative;background:#1d2b41;display:flex;width:100%;align-items:center;min-height:56px}:host div.alert-items-container,:host div.nav-items-container,:host div.user-menu-container{display:none}:host .nav-items-wrapper{display:flex;flex-wrap:wrap;align-self:stretch;align-items:center}:host .nav-items-wrapper:hover>div.nav-items-container{display:flex;left:0}:host .alert-items-wrapper{display:flex;align-self:stretch;align-items:center}:host .alert-items-wrapper:hover>div.alert-items-container{display:flex}:host .user-menu-wrapper{display:flex;align-self:stretch;align-items:center}:host .user-menu-wrapper:hover>div.user-menu-container{display:flex}:host .user-menu-wrapper .user-menu-container .user-menu-left-container.panel-left{padding:24px}:host .user-menu-wrapper .user-menu-container .user-menu-left-container.panel-left .user-menu-item{margin-bottom:5px}:host .logged-user-heading{word-break:break-word}:host .pmcc-nav-item{font-family:MuliBold,Arial Regular,Arial,sans-serif;letter-spacing:.1px;font-size:15px;white-space:nowrap;align-content:center;position:relative;display:inline-block;cursor:pointer;margin-top:6px;margin-bottom:6px;padding-bottom:6px;color:#a4b1b6;transition:all 0s ease-in}:host .pmcc-nav-item>a,:host .pmcc-nav-item>a:visited{color:inherit!important;text-decoration:none!important}:host .pmcc-nav-item:first-child{margin-left:24px}:host .pmcc-nav-item.last{margin-right:24px}:host .pmcc-nav-item.logo{align-content:center;display:inline-block;width:107px;height:16px;background-image:url(https://cdn.pubmatic.com/common/pmcc/latest/img/pubmatic-logo-sm.png);background-repeat:no-repeat;background-size:107px 16px;margin-right:32px}:host .pmcc-nav-item.logo.clipped{width:32px}:host .pmcc-nav-item.selected{color:#fff;border-bottom:3px solid #00ccf1}:host .pmcc-nav-item.selected .menu{top:-11140px;min-width:100px;z-index:30001;background:#ccc;color:#666;padding:10px;display:flex}:host .pmcc-nav-item.force-right{margin-left:auto!important}:host .pmcc-nav-item:hover{color:#fff}:host .pmcc-nav-item.previewing{position:relative;color:#fff}:host .pmcc-nav-item.previewing2{color:#fff;position:relative}:host .pmcc-nav-item.previewing2:after{position:absolute;content:\"-\"}:host .pmcc-nav-item.icon{font-size:1.4em}:host .pmcc-nav-item.stacked .small{font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}:host .pmcc-nav-item+.pmcc-nav-item{margin-left:32px}:host .pmcc-nav-item+.pmcc-nav-item.tight{margin-left:24px}:host .pmcc-nav-item span.badge{position:absolute;display:none;left:10px;top:10px;z-index:1;padding:2px 4px;border-radius:12px;background:#0499d3;color:#fff;font-size:11px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}:host .pmcc-nav-item .pmcc-gh-truncate{max-width:250px;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .pmcc-nav-item.show-badge{margin-right:16px}:host .pmcc-nav-item.show-badge span.badge{display:inline-block}:host .panel-dyna-width,:host .panel-full-width{position:absolute;background:#fff;color:#999;height:0;min-height:0;overflow:hidden;display:flex;width:100%;transition:all 0s ease-in}:host .panel-dyna-width.show,:host .panel-full-width.show{height:auto;min-height:250px!important;top:100%;box-shadow:0 0 10px 15px #0003}:host .panel-dyna-width .panel-left,:host .panel-full-width .panel-left{background:#f9f9f9;flex-basis:20%;min-width:200px;padding:24px 42px;font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}:host .panel-dyna-width .panel-left h2,:host .panel-full-width .panel-left h2{margin-top:0;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;font-size:18px}:host .panel-dyna-width .panel-center,:host .panel-full-width .panel-center{flex-basis:60%;display:flex;padding:24px 48px}:host .panel-dyna-width .panel-center span+span,:host .panel-full-width .panel-center span+span{margin-left:10%}:host .panel-dyna-width .panel-center span h2,:host .panel-full-width .panel-center span h2{margin:0;padding:0 5px;color:#999;white-space:nowrap;font-size:13px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}:host .panel-dyna-width .panel-center span ul,:host .panel-full-width .panel-center span ul{list-style:none;padding:0;margin:0}:host .panel-dyna-width .panel-center span ul li,:host .panel-full-width .panel-center span ul li{font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;color:#1b2431;white-space:nowrap;font-size:15px;letter-spacing:.2px;line-height:32px;padding:0 5px}:host .panel-dyna-width .panel-center span ul li.wrap,:host .panel-full-width .panel-center span ul li.wrap{white-space:normal!important}:host .panel-dyna-width .panel-center span ul li:hover,:host .panel-full-width .panel-center span ul li:hover{background:#f0f0f0;cursor:pointer}:host .panel-dyna-width .panel-center span ul li a,:host .panel-dyna-width .panel-center span ul li a:visited,:host .panel-full-width .panel-center span ul li a,:host .panel-full-width .panel-center span ul li a:visited{display:block;color:inherit;text-decoration:inherit}:host .panel-dyna-width .panel-right,:host .panel-full-width .panel-right{flex-basis:20%;border-left:1px solid #d8d8d8;padding-left:24px;margin:24px 64px 24px 24px;font-family:MuliRegular,Arial Regular,Arial,sans-serif;font-size:13px}:host .panel-dyna-width .panel-right h2,:host .panel-full-width .panel-right h2{margin-top:0;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;font-size:18px}:host .panel-dyna-width .panel-right h2:before,:host .panel-full-width .panel-right h2:before{content:\"NEW\";font-size:11px;margin-right:10px;padding:3px 8px;background:green;color:#fff}:host .panel-dyna-width{background:#fff;color:#999;height:0;min-height:0;overflow:hidden;display:flex;position:absolute;width:480px;right:0;transition:all 0s ease-in}:host .panel-dyna-width.show{height:auto;min-height:240px;box-shadow:0 0 10px 15px #0003}:host .panel-dyna-width span.badge{padding:2px 8px;border-radius:12px;background:#0499d3;color:#fff;font-size:11px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}:host .panel-dyna-width .panel-center{padding:24px}:host .panel-dyna-width .panel-center ul{list-style:none;padding:0;margin:0;display:block;width:100%}:host .panel-dyna-width .panel-center ul.alerts{max-height:420px;overflow-y:auto}:host .panel-dyna-width .panel-center ul li{line-height:32px;padding:0 5px;font-family:MuliSemiBold,Arial Regular,Arial,sans-serif;color:#1b2431;white-space:nowrap;font-size:15px}:host .panel-dyna-width .panel-center ul li.wrap{white-space:normal!important}:host .panel-dyna-width .panel-center ul li.wrap a{white-space:normal!important}:host .panel-dyna-width .panel-center ul li.title{color:#999;white-space:normal;font-size:13px;font-family:MuliRegular,Arial Regular,Arial,sans-serif}:host .panel-dyna-width .panel-center ul li.title:hover{background:inherit!important;cursor:inherit!important}:host .panel-dyna-width .panel-center ul li.divider{border-top:1px solid #d8d8d8;margin-top:8px;padding-bottom:8px}:host .panel-dyna-width .panel-center ul li.divider:hover{background:#0000;cursor:default}:host .panel-dyna-width .panel-center ul li:hover{background:#f0f0f0;cursor:pointer}:host .panel-dyna-width .panel-center ul li a,:host .panel-dyna-width .panel-center ul li a:visited{display:block;color:inherit;text-decoration:inherit}@media screen and (max-width:1024px){.hidden-below-lg{display:none!important}:host .logo{margin-right:16px!important}:host .pmcc-nav-item:first-child{margin-left:16px}:host .pmcc-nav-item:last-child{margin-right:16px}:host .pmcc-nav-item+.pmcc-nav-item{margin-left:16px!important}:host .pmcc-nav-item+.pmcc-nav-item.force-right{margin-left:auto!important}:host .panel-dyna-width .panel-center span+span,:host .panel-full-width .panel-center span+span{margin-left:5%!important}:host .panel-dyna-width .panel-center ul li,:host .panel-full-width .panel-center ul li{font-size:13px!important}}@media screen and (max-width:768px){:host .pmcc-nav-item{font-size:13px!important}:host .pmcc-nav-item.selected{padding-bottom:2px;border-bottom-width:2px!important}:host .pmcc-nav-item+.pmcc-nav-item{margin-left:16px!important}:host .pmcc-nav-item+.pmcc-nav-item.force-right{margin-left:auto!important}:host .pmcc-nav-item.icon{font-size:1.2em!important}.logo{width:20px!important;margin-right:0!important}.panel-dyna-width .panel-right,.panel-full-width .panel-right{display:none}.panel-dyna-width .panel-left,.panel-full-width .panel-left{margin-left:16px;padding-left:16px!important;padding-right:16px!important}.panel-dyna-width .panel-center,.panel-full-width .panel-center{padding-left:16px!important}.panel-dyna-width .panel-center ul li,.panel-full-width .panel-center ul li{font-size:13px!important}}@media screen and (max-width:576px){:host .hidden-below-sm{display:none!important}:host .panel-dyna-width .panel-left,:host .panel-full-width .panel-left{display:none}:host .panel-dyna-width .panel-center,:host .panel-full-width .panel-center{width:60%!important;padding:24px!important;flex-direction:column!important}:host .panel-dyna-width .panel-center span+span,:host .panel-full-width .panel-center span+span{margin-left:0!important;margin-top:8px;border-top:1px solid #d8d8d8}:host .panel-dyna-width .panel-center ul li,:host .panel-full-width .panel-center ul li{font-size:13px!important}}"]
            }]
    }], function () { return []; }, { homeUrl: [{
            type: Input
        }], menus: [{
            type: Input
        }], logoutCallback: [{
            type: Output
        }], activeMenu: [{
            type: Input
        }], alertsModel: [{
            type: Input,
            args: ['alerts']
        }], help: [{
            type: Input
        }], userInfo: [{
            type: Input
        }], userInfoMenu: [{
            type: Input
        }], logoutHidden: [{
            type: Input
        }] }); })();

class AdTagComponent {
    constructor(document, elementRef) {
        this.document = document;
        this.elementRef = elementRef;
        window.Phoenix = window.Phoenix || {};
        window.Phoenix.EQ = window.Phoenix.EQ || [];
    }
    ngOnChanges(changes) {
        if (changes.adSlot && changes.adSlot.currentValue) {
            this.adSlotName = changes.adSlot.currentValue.adSlotName.replace(/\s/gi, '-');
            this.injectAdServerScript();
            this.createSlot(this.adSlotName);
            this.defineSlot(this.adSlot);
            this.displaySlot(this.adSlotName);
        }
    }
    injectAdServerScript() {
        const phScriptUrl = '//ads.pubmatic.com/AdServer/js/phoenix.js';
        const tag = this.scriptTag({ src: phScriptUrl, async: true });
        const node = document.querySelector('script');
        node.parentNode.insertBefore(tag, node);
    }
    createSlot(slotName) {
        this.elementRef.nativeElement.innerHTML = '';
        const div = this.document.createElement('div');
        div.setAttribute('id', slotName);
        this.elementRef.nativeElement.appendChild(div);
    }
    defineSlot(adSlot) {
        const { adServerId, adSlotId, adSlotSizes, adSlotName } = adSlot;
        const slotSizes = Array.isArray(adSlotSizes) ? adSlotSizes : JSON.parse(adSlotSizes);
        window.Phoenix.EQ.push(function () {
            const Phoenix = window.Phoenix;
            Phoenix.enableSingleRequestCallMode();
            Phoenix.setInfo('ACCID', adServerId);
            Phoenix.defineAdSlot(adSlotId, slotSizes, adSlotName);
        });
    }
    displaySlot(slotName) {
        window.Phoenix.EQ.push(function () {
            window.Phoenix.display(slotName);
        });
    }
    scriptTag(attributes) {
        const tag = this.document.createElement('script');
        tag.type = 'text/javascript';
        Object.keys(attributes).forEach((key) => {
            tag[key] = attributes[key];
        });
        return tag;
    }
}
AdTagComponent.ɵfac = function AdTagComponent_Factory(t) { return new (t || AdTagComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AdTagComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AdTagComponent, selectors: [["pmcc-ad-tag"]], inputs: { adSlot: "adSlot" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function AdTagComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
AdTagComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef }
];
AdTagComponent.propDecorators = {
    adSlot: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdTagComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-ad-tag',
                template: ``,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef }]; }, { adSlot: [{
            type: Input
        }] }); })();

// TODO: Sync these types with the ones in Navigator in next breaking version

class GlobalHeaderModule {
}
GlobalHeaderModule.ɵfac = function GlobalHeaderModule_Factory(t) { return new (t || GlobalHeaderModule)(); };
GlobalHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GlobalHeaderModule });
GlobalHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [GlobalHeaderComponent, AdTagComponent],
                imports: [CommonModule, IconModule],
                exports: [GlobalHeaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GlobalHeaderModule, { declarations: function () { return [GlobalHeaderComponent, AdTagComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [GlobalHeaderComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/hierarchical-selector</example-url>
 */
class HierarchicalSelectorComponent {
    constructor() {
        this.showLoading = false;
        this.itemsLoadingDone = true;
        this.availableItems = [];
        this.blockedCount = null;
        this.addedCount = 0;
        this.removedCount = 0;
        this.disableSelectAll = false;
        this.searchText = '';
        this.searchPlaceholder = 'Search';
        this.checkboxFilterTooltipText = '';
        this.checkboxFilterLabel = '';
        this.checkboxFilterDisabled = false;
        this.showCheckboxFilter = false;
        this.isCheckboxFilterChecked = false;
        this.disabled = false;
        this.hideFooter = true;
        this.headerText = 'Add / Remove All';
        this.tooltipText = 'Please enter text to search';
        this.noMatchMessage = 'No matches found';
        this.hideParentCheckbox = false;
        this.hideBodyCheckbox = false;
        this.height = 350;
        this.removePartialState = false;
        this.showActions = false;
        this.debounceTime = 300;
        this.selectAllCallback = new EventEmitter();
        this.loadMoreItemsCallback = new EventEmitter(); // triggers by infinite scroll
        this.itemChangedCallback = new EventEmitter();
        this.itemSelectCallback = new EventEmitter();
        this.searchCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.saveCallback = new EventEmitter();
        this.checkboxFilterCallback = new EventEmitter();
        this._parentCheckboxDebouncer = new Subject();
        this.focusedItem = null;
        this.loadMoreInProgress = true;
        this.falseValue = 0;
        this.selectBarSelected = CheckboxState.UNCHECKED;
        this.viewableAvailableItems = [];
    }
    onItemClick(item) {
        this.focusedItem = item;
        this.itemSelectCallback.emit(item);
    }
    onAllChanged(selected) {
        this.selectAll = selected;
        this.selectAllCallback.emit({
            selected,
            searchText: this.searchText || '',
        });
    }
    onItemChanged(selected, item) {
        this.itemChangedCallback.emit(Object.assign(Object.assign({}, item), { selected }));
    }
    ngOnInit() {
        const DEBOUNCE_TIME = 300;
        this._parentCheckboxDebouncer.pipe(debounceTime(DEBOUNCE_TIME)).subscribe(() => this._updateItemsState());
    }
    ngOnChanges(changes) {
        if (changes['availableItems']) {
            if (!this.loadMoreInProgress) {
                this.focusedItem = null;
            }
            if (!this.isRemoteSearch) {
                this.viewableAvailableItems = this.applyLocalSearch(this.searchText || '');
            }
            else {
                this.viewableAvailableItems = [...this.availableItems];
            }
            this.loadMoreInProgress = false;
        }
        this._updateItemsState();
    }
    ngOnDestroy() {
        this._parentCheckboxDebouncer.unsubscribe();
    }
    onScrollEnd() {
        if (!this.disabled
            && this.availableItems.length
            && !this.itemsLoadingDone
            && !this.loadMoreInProgress) {
            this.loadMoreInProgress = true;
            this.loadMoreItemsCallback.emit();
        }
    }
    search(query) {
        this.searchText = query;
        if (this.isRemoteSearch) {
            clearTimeout(this._searchTimeout);
            this._searchTimeout = setTimeout(() => {
                this.searchCallback.emit(query);
            }, this.debounceTime);
        }
        else {
            this.viewableAvailableItems = this.applyLocalSearch(query);
            this._parentCheckboxDebouncer.next();
        }
    }
    onCheckboxStateChange(event) {
        this.isCheckboxFilterChecked = event.checked;
        this.checkboxFilterCallback.emit(event.checked);
    }
    cancel() {
        this.cancelCallback.emit();
    }
    save() {
        this.saveCallback.emit();
    }
    get isRemoteSearch() {
        return !!this.searchCallback.observers.length;
    }
    applyLocalSearch(query) {
        return this.availableItems
            .filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
    }
    getLoadedItemsState() {
        return {
            allChecked: this.viewableAvailableItems.length
                && this.viewableAvailableItems.every(item => item.selected === CheckboxState.CHECKED),
            allUnchecked: this.viewableAvailableItems.every(item => !item.selected) // this handles undefined and null cases
        };
    }
    // tslint:disable-next-line: cyclomatic-complexity
    _updateItemsState() {
        const selectAll = +this.selectAll || CheckboxState.UNCHECKED;
        const state = this.getLoadedItemsState();
        const overideState = this.removePartialState ?
            (state.allChecked ? CheckboxState.CHECKED : CheckboxState.UNCHECKED)
            : CheckboxState.PARTIAL;
        /**
         disableSelectAll = true --> input
         not-all-loaded & (input is partial) --> partial
         not-all-loaded & (input is uncheck & some selected) --> partial
         not-all-loaded & (input is uncheck & none selected) --> uncheck
         not-all-loaded & (input is uncheck & all are selected) --> partial
         not-all-loaded & (input is check & some are not selected) --> partial
         not-all-loaded & (input is check & all are selected) --> check
         not-all-loaded & (input is check & none selected) --> partial (assume that at-least to-be-loaded items are checked)
         not-all-loaded & (User clicks to check "SelectAll") --> Checked (Ignore input)
         not-all-loaded & (User clicks to uncheck "SelectAll") --> Uncheck (Ignore input)
         all loaded >> ignore input and calculate internally
         removePartialState = true --> input
         If all items checked ---> Checked
         Not all items checked ---> unchecked
         */
        if (this.disableSelectAll) {
            this.selectBarSelected = selectAll;
        }
        else if (!this.itemsLoadingDone) {
            const respectInput = (selectAll === CheckboxState.PARTIAL)
                || (selectAll === CheckboxState.CHECKED && state.allChecked)
                || (selectAll === CheckboxState.UNCHECKED && state.allUnchecked);
            this.selectBarSelected = respectInput ? selectAll : overideState;
        }
        else {
            this.selectBarSelected = state.allChecked ? CheckboxState.CHECKED
                : (state.allUnchecked ? CheckboxState.UNCHECKED : overideState);
        }
    }
}
HierarchicalSelectorComponent.ɵfac = function HierarchicalSelectorComponent_Factory(t) { return new (t || HierarchicalSelectorComponent)(); };
HierarchicalSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HierarchicalSelectorComponent, selectors: [["pmcc-hierarchical-selector"]], inputs: { showLoading: "showLoading", itemsLoadingDone: "itemsLoadingDone", availableItems: "availableItems", blockedCount: "blockedCount", addedCount: "addedCount", removedCount: "removedCount", disableSelectAll: "disableSelectAll", searchText: "searchText", searchPlaceholder: "searchPlaceholder", checkboxFilterTooltipText: "checkboxFilterTooltipText", checkboxFilterLabel: "checkboxFilterLabel", checkboxFilterDisabled: "checkboxFilterDisabled", showCheckboxFilter: "showCheckboxFilter", isCheckboxFilterChecked: "isCheckboxFilterChecked", disabled: "disabled", hideFooter: "hideFooter", headerText: "headerText", tooltipText: "tooltipText", noMatchMessage: "noMatchMessage", hideParentCheckbox: "hideParentCheckbox", hideBodyCheckbox: "hideBodyCheckbox", height: "height", removePartialState: "removePartialState", showActions: "showActions", debounceTime: "debounceTime", selectAll: "selectAll" }, outputs: { selectAllCallback: "selectAllCallback", loadMoreItemsCallback: "loadMoreItemsCallback", itemChangedCallback: "itemChangedCallback", itemSelectCallback: "itemSelectCallback", searchCallback: "searchCallback", cancelCallback: "cancelCallback", saveCallback: "saveCallback", checkboxFilterCallback: "checkboxFilterCallback" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 18, vars: 19, consts: [[1, "level-list"], [1, "pmcc-hs-filters-bar"], ["pmccClear", "", "data-pm-id", "selector-list-search-input", 1, "input"], ["pmccInput", "", "type", "text", "data-pm-id", "selector-list-search-input", 3, "placeholder", "ngModel", "pmccTooltip", "readOnly", "ngModelChange"], ["class", "pmcc-hs-checkbox-filter", 4, "ngIf"], [1, "select-bar"], ["data-pm-id", "selector-list-select-all", 3, "disabled", "label", "ngModel", "ngModelChange", 4, "ngIf"], ["class", "list-items-overlay", 4, "ngIf"], ["pmccInfiniteScroll", "", "data-pm-id", "items-list", 1, "list-items", 3, "ngClass", "pmccScrollEnd"], ["class", "item-row", "data-pm-id", "item-row", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "item-row pmcc-justify-content-sm-center loader", 4, "ngIf"], ["class", "no-match-message", 4, "ngIf"], ["class", "footer-bar pmcc-flex button-actions", "data-pm-id", "footer-bar", 4, "ngIf"], ["class", "select-bar pmcc-flex button-actions", 4, "ngIf"], [1, "pmcc-hs-checkbox-filter"], ["data-pm-id", "pmcc-hs-checkbox-filter", 3, "disabled", "label", "checked", "change"], ["name", "info", "data-pm-id", "pmcc-hs-checkbox-filter-tooltip", 3, "pmccTooltip", 4, "ngIf"], ["name", "info", "data-pm-id", "pmcc-hs-checkbox-filter-tooltip", 3, "pmccTooltip"], ["data-pm-id", "selector-list-select-all", 3, "disabled", "label", "ngModel", "ngModelChange"], [1, "list-items-overlay"], ["class", "pmcc-ico-4x pmcc-ico-processing pmcc-effect-spin", 4, "ngIf"], [1, "pmcc-ico-4x", "pmcc-ico-processing", "pmcc-effect-spin"], ["data-pm-id", "item-row", 1, "item-row", 3, "ngClass"], ["data-pm-id", "item-ckbx", 3, "disabled", "ngModel", "ngModelChange", 4, "ngIf"], [1, "item-caption", 3, "click"], ["data-pm-id", "item-name", 1, "item-label", "pmcc-truncate"], [3, "title", "textContent"], ["class", "item-has-children", 4, "ngIf"], ["data-pm-id", "item-ckbx", 3, "disabled", "ngModel", "ngModelChange"], [1, "item-has-children"], ["class", "pmcc-hs-margin-r-10", 4, "ngIf"], [1, "pmcc-ico-chevron-right", "pmcc-ico-1x"], [1, "pmcc-hs-margin-r-10"], [1, "item-row", "pmcc-justify-content-sm-center", "loader"], [1, "pmcc-ico-processing", "pmcc-ico-3x", "pmcc-effect-spin"], [1, "no-match-message"], [1, "pmcc-ico-info", "pmcc-ico-6x"], [3, "textContent"], ["data-pm-id", "footer-bar", 1, "footer-bar", "pmcc-flex", "button-actions"], [4, "ngIf"], [1, "color-green"], [1, "color-red"], [1, "select-bar", "pmcc-flex", "button-actions"], ["pmccButton", "", "data-pm-id", "pmcc-hs-cancel-button", 1, "pmcc-btn-sm", "pmcc-secondary", 3, "disabled", "click"], ["pmccButton", "", "data-pm-id", "pmcc-hs-submit-button", 1, "pmcc-btn-sm", "pmcc-primary", 3, "disabled", "click"]], template: function HierarchicalSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4, "Search");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "pmcc-input", 2);
        ɵngcc0.ɵɵelementStart(6, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HierarchicalSelectorComponent_Template_input_ngModelChange_6_listener($event) { return ctx.search($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HierarchicalSelectorComponent_div_7_Template, 3, 4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtemplate(9, HierarchicalSelectorComponent_pmcc_checkbox_9_Template, 1, 3, "pmcc-checkbox", 6);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, HierarchicalSelectorComponent_div_11_Template, 2, 1, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵlistener("pmccScrollEnd", function HierarchicalSelectorComponent_Template_div_pmccScrollEnd_12_listener() { return ctx.onScrollEnd(); });
        ɵngcc0.ɵɵtemplate(13, HierarchicalSelectorComponent_div_13_Template, 6, 7, "div", 9);
        ɵngcc0.ɵɵtemplate(14, HierarchicalSelectorComponent_div_14_Template, 2, 0, "div", 10);
        ɵngcc0.ɵɵtemplate(15, HierarchicalSelectorComponent_div_15_Template, 3, 1, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, HierarchicalSelectorComponent_div_16_Template, 6, 4, "div", 12);
        ɵngcc0.ɵɵtemplate(17, HierarchicalSelectorComponent_div_17_Template, 5, 2, "div", 13);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("placeholder", ctx.searchPlaceholder)("ngModel", ctx.searchText)("pmccTooltip", ctx.tooltipText)("readOnly", ctx.showLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCheckboxFilter);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideParentCheckbox);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.hideParentCheckbox ? ctx.headerText : "", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.disabled || ctx.showLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c44, ctx.hideFooter, ctx.disabled || ctx.showLoading));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.viewableAvailableItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadMoreInProgress);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewableAvailableItems.length === 0 && !ctx.showLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideFooter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActions);
    } }, directives: function () { return [InputComponent, InputDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, TooltipDirective, ɵngcc1.NgIf, InfiniteScrollDirective, ɵngcc1.NgClass, ɵngcc1.NgForOf, CheckboxComponent, IconComponent]; }, styles: [".level-list[_ngcontent-%COMP%]{position:relative;box-shadow:0 2px 12px #d2d2d2}.level-list[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]{background:#d5d6d7;color:#616162;font-weight:700}.level-list[_ngcontent-%COMP%]   .pmcc-hs-filters-bar[_ngcontent-%COMP%]{background:#e6e6e6;display:flex;justify-content:space-between;flex-wrap:wrap}.level-list[_ngcontent-%COMP%]   .pmcc-hs-checkbox-filter[_ngcontent-%COMP%]{display:flex;align-items:center}.level-list[_ngcontent-%COMP%]   .select-bar[_ngcontent-%COMP%]{background:#f9f9f9;font-weight:700!important}.level-list[_ngcontent-%COMP%]   .color-green[_ngcontent-%COMP%]{color:#6db33f;font-weight:700}.level-list[_ngcontent-%COMP%]   .color-red[_ngcontent-%COMP%]{color:#d7494e;font-weight:700}.level-list[_ngcontent-%COMP%]   .pmcc-hs-filters-bar[_ngcontent-%COMP%], .level-list[_ngcontent-%COMP%]   .select-bar[_ngcontent-%COMP%], .level-list[_ngcontent-%COMP%]   .title-bar[_ngcontent-%COMP%]{padding:11px;border:1px solid #cacacb}.level-list[_ngcontent-%COMP%]   .list-items-overlay[_ngcontent-%COMP%]{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;flex-direction:column;width:100%;height:100%;top:0;background-color:#8a8a8a1a;z-index:1;cursor:pointer}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]{border:1px solid #c3c3c3;position:relative;overflow:auto;background:#f9f9f9}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]{cursor:pointer;padding:11px;border-bottom:1px solid #e5e5e5}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row.focused[_ngcontent-%COMP%]{background-color:#c2e2f1}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row.loader[_ngcontent-%COMP%]{margin:0 auto;width:40px}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]:hover{background-color:#c2e2f1}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%]{position:relative;top:4px;width:70%}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]   .item-has-children[_ngcontent-%COMP%]{float:right}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]   .item-has-children[_ngcontent-%COMP%]   .pmcc-hs-margin-r-10[_ngcontent-%COMP%]{margin-right:10px}.level-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item-row[_ngcontent-%COMP%]   .item-has-children[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child{margin-left:-7px}.level-list[_ngcontent-%COMP%]   .list-items.disabled[_ngcontent-%COMP%]{overflow:hidden}.level-list[_ngcontent-%COMP%]   .list-items.no-footer[_ngcontent-%COMP%]{border-radius:0 0 5px 5px}.level-list[_ngcontent-%COMP%]   .no-match-message[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-flow:column;height:300px;color:#c4c4c4;text-align:center}.level-list[_ngcontent-%COMP%]   .no-match-message[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin:10px}.level-list[_ngcontent-%COMP%]   .footer-bar[_ngcontent-%COMP%]{min-height:33px;background:#e6e6e6;border:1px solid #c3c3c3;padding:9px;color:#696969}.level-list[_ngcontent-%COMP%]   .button-actions[_ngcontent-%COMP%]{justify-content:space-between}"] });
HierarchicalSelectorComponent.propDecorators = {
    showLoading: [{ type: Input }],
    itemsLoadingDone: [{ type: Input }],
    availableItems: [{ type: Input }],
    blockedCount: [{ type: Input }],
    addedCount: [{ type: Input }],
    removedCount: [{ type: Input }],
    selectAll: [{ type: Input }],
    disableSelectAll: [{ type: Input }],
    searchText: [{ type: Input }],
    searchPlaceholder: [{ type: Input }],
    checkboxFilterTooltipText: [{ type: Input }],
    checkboxFilterLabel: [{ type: Input }],
    checkboxFilterDisabled: [{ type: Input }],
    showCheckboxFilter: [{ type: Input }],
    isCheckboxFilterChecked: [{ type: Input }],
    disabled: [{ type: Input }],
    hideFooter: [{ type: Input }],
    headerText: [{ type: Input }],
    tooltipText: [{ type: Input }],
    noMatchMessage: [{ type: Input }],
    hideParentCheckbox: [{ type: Input }],
    hideBodyCheckbox: [{ type: Input }],
    height: [{ type: Input }],
    removePartialState: [{ type: Input }],
    showActions: [{ type: Input }],
    debounceTime: [{ type: Input }],
    selectAllCallback: [{ type: Output }],
    loadMoreItemsCallback: [{ type: Output }],
    itemChangedCallback: [{ type: Output }],
    itemSelectCallback: [{ type: Output }],
    searchCallback: [{ type: Output }],
    cancelCallback: [{ type: Output }],
    saveCallback: [{ type: Output }],
    checkboxFilterCallback: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HierarchicalSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-hierarchical-selector',
                template: "<div class=\"level-list\">\n  <!--In PMCC DEMO IT EXISTS-->\n  <!--<div *ngIf=\"headerText\"\n       class=\"title-bar\"\n       [textContent]=\"headerText\">\n  </div>-->\n  <div class=\"pmcc-hs-filters-bar\">\n    <div>\n      <span>Search</span>\n      <pmcc-input\n        pmccClear\n        class=\"input\"\n        data-pm-id=\"selector-list-search-input\"\n      >\n        <input\n          pmccInput\n          type=\"text\"\n          data-pm-id=\"selector-list-search-input\"\n          [placeholder]=\"searchPlaceholder\"\n          [ngModel]=\"searchText\"\n          (ngModelChange)=\"search($event)\"\n          [pmccTooltip]=\"tooltipText\"\n          [readOnly]=\"showLoading\"\n        />\n      </pmcc-input>\n    </div>\n    <div *ngIf=\"showCheckboxFilter\" class=\"pmcc-hs-checkbox-filter\">\n      <pmcc-checkbox\n        [disabled]=\"checkboxFilterDisabled\"\n        [label]=\"checkboxFilterLabel\"\n        (change)=\"onCheckboxStateChange($event)\"\n        [checked]=\"isCheckboxFilterChecked\"\n        data-pm-id=\"pmcc-hs-checkbox-filter\"\n      ></pmcc-checkbox>\n      <pmcc-icon\n        *ngIf=\"checkboxFilterTooltipText\"\n        name=\"info\"\n        [pmccTooltip]=\"checkboxFilterTooltipText\"\n        data-pm-id=\"pmcc-hs-checkbox-filter-tooltip\"\n      ></pmcc-icon>\n    </div>\n  </div>\n\n  <div class=\"select-bar\">\n    <pmcc-checkbox\n      *ngIf=\"!hideParentCheckbox\"\n      data-pm-id=\"selector-list-select-all\"\n      [disabled]=\"disabled || disableSelectAll\"\n      [label]=\"headerText || 'Add / Remove All'\"\n      [ngModel]=\"selectBarSelected\"\n      (ngModelChange)=\"onAllChanged($event)\"\n    >\n    </pmcc-checkbox>\n    {{hideParentCheckbox ? headerText: ''}}\n  </div>\n\n  <div\n    *ngIf=\"disabled || showLoading\"\n    class=\"list-items-overlay\"\n  >\n    <i\n      *ngIf=\"showLoading\"\n      class=\"pmcc-ico-4x pmcc-ico-processing pmcc-effect-spin\"\n    ></i>\n  </div>\n  <div\n    class=\"list-items\"\n    [style.height.px]=\"height\"\n    [ngClass]=\"{'no-footer': hideFooter,'disabled': disabled || showLoading}\"\n    pmccInfiniteScroll\n    (pmccScrollEnd)=\"onScrollEnd()\"\n    data-pm-id=\"items-list\"\n  >\n\n    <!--start list-->\n    <div\n      class=\"item-row\"\n      *ngFor=\"let item of viewableAvailableItems;\"\n      [ngClass]=\"{'focused': focusedItem && item.label === focusedItem.label}\"\n      data-pm-id=\"item-row\"\n    >\n      <pmcc-checkbox\n        *ngIf=\"!hideBodyCheckbox\"\n        [disabled]=\"item.disabled\"\n        [ngModel]=\"item.selected || falseValue\"\n        (ngModelChange)=\"onItemChanged($event, item)\"\n        data-pm-id=\"item-ckbx\"\n      >\n      </pmcc-checkbox>\n\n      <span\n        class=\"item-caption\"\n        (click)=\"onItemClick(item)\"\n      >\n        <span\n          class=\"item-label pmcc-truncate\"\n          data-pm-id=\"item-name\"\n        >\n          <span [title]=\"item.label\" [textContent]=\"item.label\"></span>\n        </span>\n        <span\n          *ngIf=\"item.hasChildren\"\n          class=\"item-has-children\"\n        >\n          <span *ngIf=\"item.countLabel\" class=\"pmcc-hs-margin-r-10\">{{ item.countLabel }}</span>\n          <span class=\"pmcc-ico-chevron-right pmcc-ico-1x\"></span>\n          <span class=\"pmcc-ico-chevron-right pmcc-ico-1x\"></span>\n        </span>\n      </span>\n    </div>\n\n    <div\n      class=\"item-row pmcc-justify-content-sm-center loader\"\n      *ngIf=\"loadMoreInProgress\"\n    >\n      <span class=\"pmcc-ico-processing pmcc-ico-3x pmcc-effect-spin\"></span>\n    </div>\n\n    <div\n      class=\"no-match-message\"\n      *ngIf=\"viewableAvailableItems.length === 0 && !showLoading\"\n    >\n      <span class=\"pmcc-ico-info pmcc-ico-6x\"></span>\n      <div [textContent]=\"noMatchMessage\"></div>\n    </div>\n    <!--end list-->\n  </div>\n  <div\n    class=\"footer-bar pmcc-flex button-actions\"\n    *ngIf=\"!hideFooter\"\n    data-pm-id=\"footer-bar\"\n  >\n    <div>\n      <span *ngIf=\"addedCount > 0\"><span class=\"color-green\">{{addedCount}}</span> added</span>\n      <span *ngIf=\"removedCount > 0\"><span *ngIf=\"addedCount > 0\"> / </span><span\n          class=\"color-red\">{{removedCount}}</span> removed</span>\n      <span *ngIf=\"addedCount === 0 && removedCount === 0\">0 items changed</span>\n    </div>\n    <div *ngIf=\"blockedCount !== null\">{{blockedCount}} blocked</div>\n  </div>\n  <div\n    *ngIf=\"showActions\"\n    class=\"select-bar pmcc-flex button-actions\"\n  >\n    <button\n      [disabled]=\"addedCount === 0 && removedCount == 0\"\n      class=\"pmcc-btn-sm pmcc-secondary\"\n      pmccButton\n      (click)=\"cancel()\"\n      data-pm-id=\"pmcc-hs-cancel-button\"\n    >Cancel</button>\n    <button\n      [disabled]=\"addedCount === 0 && removedCount === 0\"\n      class=\"pmcc-btn-sm pmcc-primary\"\n      pmccButton\n      (click)=\"save()\"\n      data-pm-id=\"pmcc-hs-submit-button\"\n    >Save</button>\n  </div>\n</div>\n",
                styles: [".level-list{position:relative;box-shadow:0 2px 12px #d2d2d2}.level-list .title-bar{background:#d5d6d7;color:#616162;font-weight:700}.level-list .pmcc-hs-filters-bar{background:#e6e6e6;display:flex;justify-content:space-between;flex-wrap:wrap}.level-list .pmcc-hs-checkbox-filter{display:flex;align-items:center}.level-list .select-bar{background:#f9f9f9;font-weight:700!important}.level-list .color-green{color:#6db33f;font-weight:700}.level-list .color-red{color:#d7494e;font-weight:700}.level-list .pmcc-hs-filters-bar,.level-list .select-bar,.level-list .title-bar{padding:11px;border:1px solid #cacacb}.level-list .list-items-overlay{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;flex-direction:column;width:100%;height:100%;top:0;background-color:#8a8a8a1a;z-index:1;cursor:pointer}.level-list .list-items{border:1px solid #c3c3c3;position:relative;overflow:auto;background:#f9f9f9}.level-list .list-items .item-row{cursor:pointer;padding:11px;border-bottom:1px solid #e5e5e5}.level-list .list-items .item-row.focused{background-color:#c2e2f1}.level-list .list-items .item-row.loader{margin:0 auto;width:40px}.level-list .list-items .item-row:hover{background-color:#c2e2f1}.level-list .list-items .item-row .item-label{position:relative;top:4px;width:70%}.level-list .list-items .item-row .item-has-children{float:right}.level-list .list-items .item-row .item-has-children .pmcc-hs-margin-r-10{margin-right:10px}.level-list .list-items .item-row .item-has-children span:last-child{margin-left:-7px}.level-list .list-items.disabled{overflow:hidden}.level-list .list-items.no-footer{border-radius:0 0 5px 5px}.level-list .no-match-message{display:flex;align-items:center;justify-content:center;flex-flow:column;height:300px;color:#c4c4c4;text-align:center}.level-list .no-match-message span{margin:10px}.level-list .footer-bar{min-height:33px;background:#e6e6e6;border:1px solid #c3c3c3;padding:9px;color:#696969}.level-list .button-actions{justify-content:space-between}"]
            }]
    }], function () { return []; }, { showLoading: [{
            type: Input
        }], itemsLoadingDone: [{
            type: Input
        }], availableItems: [{
            type: Input
        }], blockedCount: [{
            type: Input
        }], addedCount: [{
            type: Input
        }], removedCount: [{
            type: Input
        }], disableSelectAll: [{
            type: Input
        }], searchText: [{
            type: Input
        }], searchPlaceholder: [{
            type: Input
        }], checkboxFilterTooltipText: [{
            type: Input
        }], checkboxFilterLabel: [{
            type: Input
        }], checkboxFilterDisabled: [{
            type: Input
        }], showCheckboxFilter: [{
            type: Input
        }], isCheckboxFilterChecked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], hideFooter: [{
            type: Input
        }], headerText: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], noMatchMessage: [{
            type: Input
        }], hideParentCheckbox: [{
            type: Input
        }], hideBodyCheckbox: [{
            type: Input
        }], height: [{
            type: Input
        }], removePartialState: [{
            type: Input
        }], showActions: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], selectAllCallback: [{
            type: Output
        }], loadMoreItemsCallback: [{
            type: Output
        }], itemChangedCallback: [{
            type: Output
        }], itemSelectCallback: [{
            type: Output
        }], searchCallback: [{
            type: Output
        }], cancelCallback: [{
            type: Output
        }], saveCallback: [{
            type: Output
        }], checkboxFilterCallback: [{
            type: Output
        }], selectAll: [{
            type: Input
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/infinite-scroll</example-url>
 */
class InfiniteScrollDirective {
    constructor(_elementRef) {
        this.pmccScrollEnd = new EventEmitter();
        this.pmccHorizontalScrollEnd = new EventEmitter();
        this._element = null;
        this._element = _elementRef.nativeElement;
    }
    getElementProp(element) {
        return {
            scrollTop: element.scrollTop || 0,
            scrollLeft: element.scrollLeft || 0,
            scrollHeight: element.scrollHeight,
            scrollWidth: element.scrollWidth,
            offsetHeight: element.offsetHeight,
            offsetWidth: element.offsetWidth
        };
    }
    scrollEndCallbackFire($event) {
        const props = this.getElementProp(this._element);
        if (this.pmccScrollEnd.observers.length > 0
            && (Math.ceil(props.scrollTop) + props.offsetHeight >= props.scrollHeight)) {
            this.pmccScrollEnd.emit();
        }
        if (this.pmccHorizontalScrollEnd.observers.length > 0
            && (props.scrollLeft + props.offsetWidth >= props.scrollWidth)) {
            this.pmccHorizontalScrollEnd.emit();
        }
    }
}
InfiniteScrollDirective.ɵfac = function InfiniteScrollDirective_Factory(t) { return new (t || InfiniteScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
InfiniteScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InfiniteScrollDirective, selectors: [["", "pmccInfiniteScroll", ""]], hostBindings: function InfiniteScrollDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function InfiniteScrollDirective_scroll_HostBindingHandler($event) { return ctx.scrollEndCallbackFire($event); });
    } }, outputs: { pmccScrollEnd: "pmccScrollEnd", pmccHorizontalScrollEnd: "pmccHorizontalScrollEnd" }, exportAs: ["pmccInfiniteScroll"] });
InfiniteScrollDirective.ctorParameters = () => [
    { type: ElementRef }
];
InfiniteScrollDirective.propDecorators = {
    pmccScrollEnd: [{ type: Output }],
    pmccHorizontalScrollEnd: [{ type: Output }],
    scrollEndCallbackFire: [{ type: HostListener, args: ['scroll', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfiniteScrollDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccInfiniteScroll]',
                exportAs: 'pmccInfiniteScroll'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { pmccScrollEnd: [{
            type: Output
        }], pmccHorizontalScrollEnd: [{
            type: Output
        }], scrollEndCallbackFire: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

class InfiniteScrollModule {
}
InfiniteScrollModule.ɵfac = function InfiniteScrollModule_Factory(t) { return new (t || InfiniteScrollModule)(); };
InfiniteScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InfiniteScrollModule });
InfiniteScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfiniteScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [InfiniteScrollDirective],
                imports: [CommonModule],
                exports: [InfiniteScrollDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InfiniteScrollModule, { declarations: function () { return [InfiniteScrollDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [InfiniteScrollDirective]; } }); })();

class HierarchicalSelectorModule {
}
HierarchicalSelectorModule.ɵfac = function HierarchicalSelectorModule_Factory(t) { return new (t || HierarchicalSelectorModule)(); };
HierarchicalSelectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HierarchicalSelectorModule });
HierarchicalSelectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            CommonModule,
            CheckboxModule,
            TooltipModule,
            InfiniteScrollModule,
            InputModule,
            IconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HierarchicalSelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [HierarchicalSelectorComponent],
                imports: [
                    FormsModule,
                    CommonModule,
                    CheckboxModule,
                    TooltipModule,
                    InfiniteScrollModule,
                    InputModule,
                    IconModule,
                ],
                exports: [HierarchicalSelectorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HierarchicalSelectorModule, { declarations: function () { return [HierarchicalSelectorComponent]; }, imports: function () { return [FormsModule,
        CommonModule, CheckboxModule, TooltipModule, InfiniteScrollModule, InputModule, IconModule]; }, exports: function () { return [HierarchicalSelectorComponent]; } }); })();

class MarkdownModule {
}
MarkdownModule.ɵfac = function MarkdownModule_Factory(t) { return new (t || MarkdownModule)(); };
MarkdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MarkdownModule });
MarkdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        MarkdownService,
    ], imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                providers: [
                    MarkdownService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarkdownModule, { imports: function () { return [CommonModule]; } }); })();

class MessageBoxComponent {
    constructor() {
        this._type = 'inform';
        this.isMessageShowing = true;
        this.closed = new EventEmitter();
    }
    set type(val) {
        this._type = val;
        this.setMessageClass(val);
    }
    ngOnInit() {
        this.setMessageClass(this._type);
    }
    setMessageClass(type) {
        switch (type) {
            case 'inform':
                this.messageClass = 'pmcc-inform';
                break;
            case 'error':
                this.messageClass = 'pmcc-error';
                break;
            case 'success':
                this.messageClass = 'pmcc-confirm';
                break;
            case 'warning':
                this.messageClass = 'pmcc-action-required';
                break;
        }
    }
    closeMessage() {
        this.isMessageShowing = false;
        this.closed.emit({ value: false });
    }
}
MessageBoxComponent.ɵfac = function MessageBoxComponent_Factory(t) { return new (t || MessageBoxComponent)(); };
MessageBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageBoxComponent, selectors: [["pmcc-message-box"]], inputs: { type: "type" }, outputs: { closed: "closed" }, ngContentSelectors: _c1, decls: 1, vars: 1, consts: [["class", "pmcc-message-box pmcc-mar-bottom-sm", 3, "ngClass", 4, "ngIf"], [1, "pmcc-message-box", "pmcc-mar-bottom-sm", 3, "ngClass"], ["data-pm-id", "close", 1, "pmcc-close-message", 3, "click"]], template: function MessageBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, MessageBoxComponent_div_0_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMessageShowing);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], encapsulation: 2 });
MessageBoxComponent.propDecorators = {
    type: [{ type: Input }],
    closed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageBoxComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-message-box',
                template: "<div\n  class=\"pmcc-message-box pmcc-mar-bottom-sm\"\n  [ngClass]=\"messageClass\"\n  *ngIf=\"isMessageShowing\"\n>\n  <label><ng-content></ng-content></label>\n  <span\n    class=\"pmcc-close-message\"\n    (click)=\"closeMessage()\"\n    data-pm-id=\"close\"\n  ></span>\n</div>\n"
            }]
    }], function () { return []; }, { closed: [{
            type: Output
        }], type: [{
            type: Input
        }] }); })();

var MessageBoxTogglerState;
(function (MessageBoxTogglerState) {
    MessageBoxTogglerState[MessageBoxTogglerState["Hidden"] = 0] = "Hidden";
    MessageBoxTogglerState[MessageBoxTogglerState["ShowNone"] = 1] = "ShowNone";
    MessageBoxTogglerState[MessageBoxTogglerState["ShowSome"] = 2] = "ShowSome";
    MessageBoxTogglerState[MessageBoxTogglerState["ShowAll"] = 3] = "ShowAll";
})(MessageBoxTogglerState || (MessageBoxTogglerState = {}));
const stateClassNames = ['hidden', 'show-none', 'show-some', 'show-all'];
/**
 * Demo example
 * <example-url>/demo/#/pmcc/notifiers</example-url>
 */
class MessageBoxTogglerComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.state = MessageBoxTogglerState.ShowSome;
    }
    ngOnInit() {
        this.applyStyle();
    }
    ngOnChanges(changes) {
        if ('state' in changes) {
            this.applyStyle();
        }
    }
    handleCollapserClick() {
        if (this.state - 1 > MessageBoxTogglerState.Hidden) {
            this.state = this.state - 1;
        }
        this.applyStyle();
    }
    handleExpanderClick() {
        if (this.state === MessageBoxTogglerState.ShowNone) {
            this.state = MessageBoxTogglerState.ShowAll;
        }
        else if (this.state + 1 <= MessageBoxTogglerState.ShowAll) {
            this.state = this.state + 1;
        }
        this.applyStyle();
    }
    applyStyle() {
        const parentElement = this.elementRef.nativeElement.parentElement;
        if (parentElement) {
            parentElement.classList.remove(...stateClassNames);
            parentElement.classList.add(stateClassNames[this.state]);
        }
    }
}
MessageBoxTogglerComponent.ɵfac = function MessageBoxTogglerComponent_Factory(t) { return new (t || MessageBoxTogglerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MessageBoxTogglerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageBoxTogglerComponent, selectors: [["pmcc-message-box-toggler"]], inputs: { state: "state", numberOfItems: "numberOfItems" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "pmcc-msg-toggle-btns", 4, "ngIf"], [1, "pmcc-msg-toggle-btns"], ["type", "button", 3, "disabled", "click"], ["name", "chevron-up", "data-pm-id", "message-box-collapse"], ["name", "chevron-down", "data-pm-id", "message-box-expand"]], template: function MessageBoxTogglerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MessageBoxTogglerComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.numberOfItems == null || ctx.numberOfItems > 1);
    } }, directives: [ɵngcc1.NgIf, IconComponent], encapsulation: 2 });
MessageBoxTogglerComponent.ctorParameters = () => [
    { type: ElementRef }
];
MessageBoxTogglerComponent.propDecorators = {
    state: [{ type: Input }],
    numberOfItems: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageBoxTogglerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-message-box-toggler',
                template: "<div class=\"pmcc-msg-toggle-btns\" *ngIf=\"numberOfItems == null || numberOfItems > 1\">\n  <button\n    type=\"button\"\n    (click)=\"handleCollapserClick()\"\n    [disabled]=\"state === 1\"\n  >\n    <pmcc-icon name=\"chevron-up\" data-pm-id=\"message-box-collapse\"></pmcc-icon>\n  </button>\n  <button\n    type=\"button\"\n    (click)=\"handleExpanderClick()\"\n    [disabled]=\"state === 3 || numberOfItems != null && numberOfItems < 4 && state === 2\"\n  >\n    <pmcc-icon name=\"chevron-down\" data-pm-id=\"message-box-expand\"></pmcc-icon>\n  </button>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { state: [{
            type: Input
        }], numberOfItems: [{
            type: Input
        }] }); })();

/**
 * @internal
 */
const defaultMargin = 5;
/**
 * @internal
 */
class DefaultViewportMarginProvider {
    getMargin() {
        this.findHeader();
        const top = this.header ? this.header.offsetHeight : 0;
        return {
            top: top + defaultMargin,
            bottom: defaultMargin
        };
    }
    findHeader() {
        /* istanbul ignore next */
        if (!this.header) {
            this.header = document.querySelector('pmcc-global-header');
        }
    }
}
/**
 * A token that is used to provide viewport margins for
 * components that create overlays.
 * By default the margins are set in the way that an overlay
 * doesn't overlap GlobalHeaderComponent.
 */
const VIEWPORT_MARGIN = new InjectionToken('Default viewport margin', {
    providedIn: 'root',
    factory: () => {
        const marginProvider = new DefaultViewportMarginProvider();
        return () => marginProvider.getMargin();
    }
});

class SelectMsTriggerComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.pmccTrigger = true;
    }
    get tabIndex() {
        return this.isDisabled ? -1 : 0;
    }
    get isFocused() {
        return this.elRef.nativeElement === document.activeElement;
    }
    onMouseDown() {
        this.focus();
    }
    onMouseUp() {
        this.blur();
    }
    focus() {
        this.elRef.nativeElement.focus();
    }
    blur() {
        this.elRef.nativeElement.blur();
    }
}
SelectMsTriggerComponent.ɵfac = function SelectMsTriggerComponent_Factory(t) { return new (t || SelectMsTriggerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SelectMsTriggerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectMsTriggerComponent, selectors: [["pmcc-select-ms-trigger"]], hostVars: 10, hostBindings: function SelectMsTriggerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function SelectMsTriggerComponent_mousedown_HostBindingHandler() { return ctx.onMouseDown(); })("mouseup", function SelectMsTriggerComponent_mouseup_HostBindingHandler() { return ctx.onMouseUp(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", ctx.tabIndex)("title", ctx.triggerLabel);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵclassProp("pmcc-trigger", ctx.pmccTrigger)("focused", ctx.isFocused)("active", ctx.isOpen);
    } }, inputs: { isOpen: "isOpen", triggerLabel: "triggerLabel", width: "width", isDisabled: "isDisabled" }, exportAs: ["pmccSelectTrigger"], decls: 2, vars: 1, consts: [[1, "pmcc-trigger-label"]], template: function SelectMsTriggerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.triggerLabel, "\n");
    } }, encapsulation: 2, changeDetection: 0 });
SelectMsTriggerComponent.ctorParameters = () => [
    { type: ElementRef }
];
SelectMsTriggerComponent.propDecorators = {
    isOpen: [{ type: Input }, { type: HostBinding, args: ['class.active',] }],
    triggerLabel: [{ type: Input }, { type: HostBinding, args: ['attr.title',] }],
    width: [{ type: Input }, { type: HostBinding, args: ['style.width.px',] }],
    isDisabled: [{ type: Input }],
    pmccTrigger: [{ type: HostBinding, args: ['class.pmcc-trigger',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabIndex',] }],
    isFocused: [{ type: HostBinding, args: ['class.focused',] }],
    onMouseDown: [{ type: HostListener, args: ['mousedown',] }],
    onMouseUp: [{ type: HostListener, args: ['mouseup',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectMsTriggerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select-ms-trigger',
                template: "<span class=\"pmcc-trigger-label\">\n  {{ triggerLabel }}\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'pmccSelectTrigger'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { pmccTrigger: [{
            type: HostBinding,
            args: ['class.pmcc-trigger']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], isFocused: [{
            type: HostBinding,
            args: ['class.focused']
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown']
        }], onMouseUp: [{
            type: HostListener,
            args: ['mouseup']
        }], isOpen: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.active']
        }], triggerLabel: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.title']
        }], width: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['style.width.px']
        }], isDisabled: [{
            type: Input
        }] }); })();

class SelectMsControllerDirective extends EscapableDirective {
    constructor(element, overlayService, viewContainerRef, viewPortMargin) {
        super();
        this.element = element;
        this.overlayService = overlayService;
        this.viewContainerRef = viewContainerRef;
        this.viewPortMargin = viewPortMargin;
        this.open = new EventEmitter();
        this.close = new EventEmitter();
        this.scrollSubscription = Subscription.EMPTY;
        this.closeSubscription = Subscription.EMPTY;
    }
    get isEscapable() {
        return this.isOpen;
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.overlayRef.dispose();
        }
        this.scrollSubscription.unsubscribe();
        this.closeSubscription.unsubscribe();
    }
    triggerKeyHandler(event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.toggleLayer(event.key === 'ArrowUp');
        }
    }
    toggleLayer(forceClose) {
        if (this.isDisabled && !forceClose) {
            return false;
        }
        else if (forceClose === true) {
            this.isOpen = false;
        }
        else if (forceClose === false) {
            if (!this.isOpen) {
                this.isOpen = true;
            }
            else {
                return false;
            }
        }
        else {
            this.isOpen = !this.isOpen;
        }
        if (this.isOpen) {
            this.open.emit();
            if (!this.layerPositioningPush) {
                this.createOverlay().attach(this.portal);
            }
        }
        else {
            this.scrollSubscription.unsubscribe();
            this.scrollSubscription = Subscription.EMPTY;
            if (this.overlayRef) {
                this.overlayRef.detach();
            }
            if (this.trigger) {
                this.trigger.focus();
            }
        }
    }
    closeLayer(close, force) {
        if (!this.isOpen) {
            return;
        }
        this.close.emit(close);
        this.toggleLayer(force);
    }
    createOverlay() {
        this.portal = {
            templateRef: this.template,
            viewContainerRef: this.viewContainerRef,
        };
        const scrollStrategy = this.overlayService.scrollStrategies
            .reposition();
        const offsetY = -2;
        // right aligned positions that always be available.
        const preferredPositions = [
            {
                originPos: { originX: 'end', originY: 'bottom' },
                overlayPos: { overlayX: 'end', overlayY: 'top' },
                offsetY,
                panelClassName: 'pmcc-ms-align-right'
            },
            {
                originPos: { originX: 'end', originY: 'top' },
                overlayPos: { overlayX: 'end', overlayY: 'bottom' },
                offsetY: -offsetY,
                panelClassName: ['pmcc-ms-align-right', 'is-above-trigger'],
                originClassName: 'is-below-overlay'
            }
        ];
        if (this.alignRight !== true) {
            // if right alignment is not forced,
            // add left aligned position to the front
            preferredPositions.unshift({
                originPos: { originX: 'start', originY: 'bottom' },
                overlayPos: { overlayX: 'start', overlayY: 'top' },
                offsetY
            }, {
                originPos: { originX: 'start', originY: 'top' },
                overlayPos: { overlayX: 'start', overlayY: 'bottom' },
                offsetY: -offsetY,
                panelClassName: 'is-above-trigger',
                originClassName: 'is-below-overlay'
            });
        }
        const positionStrategy = this.overlayService
            .position()
            .connectedTo(this.element.nativeElement)
            .withPositions(preferredPositions)
            .withViewportMargin(this.viewPortMargin)
            .withFlexibleDimensions();
        this.overlayRef = this.overlayService.create(positionStrategy, scrollStrategy, {
            backdrop: BackDrop.TRANSPARENT,
            panelClassName: ['pmcc-multiselect-pane', this.size]
        });
        this.closeSubscription = this.overlayRef.close.subscribe(() => {
            // createOverlay() itself is only for non-push behaviour
            this.closeLayer('cancel');
        });
        return this.overlayRef;
    }
    _onEscape(event) {
        this.closeLayer('cancel');
    }
}
SelectMsControllerDirective.ɵfac = function SelectMsControllerDirective_Factory(t) { return new (t || SelectMsControllerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(OverlayService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(VIEWPORT_MARGIN)); };
SelectMsControllerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SelectMsControllerDirective, selectors: [["", "pmccSelectController", ""]], contentQueries: function SelectMsControllerDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SelectMsTriggerComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
    } }, hostVars: 6, hostBindings: function SelectMsControllerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function SelectMsControllerDirective_keydown_HostBindingHandler($event) { return ctx.triggerKeyHandler($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.isOpen)("disabled", ctx.isDisabled)("layer-push", ctx.layerPositioningPush);
    } }, inputs: { isDisabled: "isDisabled", layerPositioningPush: "layerPositioningPush", template: "template", alignRight: "alignRight", size: "size" }, outputs: { open: "open", close: "close" }, exportAs: ["pmccSelectController"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
SelectMsControllerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: OverlayService },
    { type: ViewContainerRef },
    { type: undefined, decorators: [{ type: Inject, args: [VIEWPORT_MARGIN,] }] }
];
SelectMsControllerDirective.propDecorators = {
    isDisabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    layerPositioningPush: [{ type: Input }, { type: HostBinding, args: ['class.layer-push',] }],
    template: [{ type: Input }],
    alignRight: [{ type: Input }],
    size: [{ type: Input }],
    open: [{ type: Output }],
    close: [{ type: Output }],
    isOpen: [{ type: HostBinding, args: ['class.active',] }],
    trigger: [{ type: ContentChild, args: [SelectMsTriggerComponent,] }],
    triggerKeyHandler: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectMsControllerDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccSelectController]',
                exportAs: 'pmccSelectController'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: OverlayService }, { type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [VIEWPORT_MARGIN]
            }] }]; }, { open: [{
            type: Output
        }], close: [{
            type: Output
        }], triggerKeyHandler: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], isOpen: [{
            type: HostBinding,
            args: ['class.active']
        }], isDisabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], layerPositioningPush: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.layer-push']
        }], template: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], size: [{
            type: Input
        }], trigger: [{
            type: ContentChild,
            args: [SelectMsTriggerComponent]
        }] }); })();

class AvailableSectionListComponent {
    constructor() {
        this.viewableAvailableItems = [];
        this.itemSelected = new EventEmitter();
    }
    selectItem(item) {
        this.itemSelected.emit(item);
    }
    resetScroll() {
        this.list.nativeElement.scrollTop = 0;
    }
}
AvailableSectionListComponent.ɵfac = function AvailableSectionListComponent_Factory(t) { return new (t || AvailableSectionListComponent)(); };
AvailableSectionListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AvailableSectionListComponent, selectors: [["pmcc-multiselect-available-section-list"]], viewQuery: function AvailableSectionListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c45, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, inputs: { viewableAvailableItems: "viewableAvailableItems", textWrap: "textWrap", availableItemsSearchEmpty: "availableItemsSearchEmpty", noMatchesMessage: "noMatchesMessage", labelProp: "labelProp", matchesExceedsLimitMessageInterpolated: "matchesExceedsLimitMessageInterpolated", isSelected: "isSelected", showNoMatches: "showNoMatches", showMatchesExceedsLimit: "showMatchesExceedsLimit" }, outputs: { itemSelected: "itemSelected" }, decls: 5, vars: 8, consts: [[1, "pmcc-available-list", 3, "ngClass"], ["list", ""], ["class", "messaging", 4, "ngIf"], [3, "ngSwitch", "ngClass", 4, "ngFor", "ngForOf"], [1, "messaging"], [3, "ngSwitch", "ngClass"], ["href", "javascript:void(0)", 3, "title", "click", 4, "ngSwitchCase"], ["href", "javascript:void(0)", 3, "click", 4, "ngSwitchDefault"], ["href", "javascript:void(0)", 3, "title", "click"], ["href", "javascript:void(0)", 3, "click"]], template: function AvailableSectionListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0, 1);
        ɵngcc0.ɵɵtemplate(2, AvailableSectionListComponent_li_2_Template, 2, 1, "li", 2);
        ɵngcc0.ɵɵtemplate(3, AvailableSectionListComponent_li_3_Template, 3, 5, "li", 3);
        ɵngcc0.ɵɵtemplate(4, AvailableSectionListComponent_li_4_Template, 2, 1, "li", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c46, ctx.textWrap === "nowrap", ctx.textWrap === "wrap", ctx.textWrap === "word-break"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNoMatches);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.viewableAvailableItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMatchesExceedsLimit);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault], encapsulation: 2 });
AvailableSectionListComponent.propDecorators = {
    textWrap: [{ type: Input }],
    viewableAvailableItems: [{ type: Input }],
    availableItemsSearchEmpty: [{ type: Input }],
    noMatchesMessage: [{ type: Input }],
    labelProp: [{ type: Input }],
    matchesExceedsLimitMessageInterpolated: [{ type: Input }],
    isSelected: [{ type: Input }],
    showNoMatches: [{ type: Input }],
    showMatchesExceedsLimit: [{ type: Input }],
    itemSelected: [{ type: Output }],
    list: [{ type: ViewChild, args: ['list', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AvailableSectionListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-available-section-list',
                template: "<ul\n  #list\n  class=\"pmcc-available-list\"\n  [ngClass]=\"{\n    'pmcc-ms-text-wrap-nowrap': textWrap === 'nowrap',\n    'pmcc-ms-text-wrap-wrap': textWrap === 'wrap',\n    'pmcc-ms-text-wrap-word-break': textWrap === 'word-break'\n  }\"\n>\n  <li\n    class=\"messaging\"\n    *ngIf=\"showNoMatches\"\n  >\n    {{ noMatchesMessage }}\n  </li>\n  <li\n    *ngFor=\"let availableItem of viewableAvailableItems\"\n    [ngSwitch]=\"textWrap\"\n    [ngClass]=\"{ selected: isSelected(availableItem)}\"\n  >\n    <a\n      href=\"javascript:void(0)\"\n      *ngSwitchCase=\"'nowrap'\"\n      title=\"{{ availableItem[labelProp] }}\"\n      (click)=\"selectItem(availableItem)\"\n    >\n      {{ availableItem[labelProp] }}\n    </a>\n    <a\n      href=\"javascript:void(0)\"\n      *ngSwitchDefault\n      (click)=\"selectItem(availableItem)\"\n    >\n      {{ availableItem[labelProp] }}\n    </a>\n  </li>\n  <li\n    class=\"messaging\"\n    *ngIf=\"showMatchesExceedsLimit\"\n  >\n    {{ matchesExceedsLimitMessageInterpolated }}\n  </li>\n</ul>\n"
            }]
    }], function () { return []; }, { viewableAvailableItems: [{
            type: Input
        }], itemSelected: [{
            type: Output
        }], textWrap: [{
            type: Input
        }], availableItemsSearchEmpty: [{
            type: Input
        }], noMatchesMessage: [{
            type: Input
        }], labelProp: [{
            type: Input
        }], matchesExceedsLimitMessageInterpolated: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], showNoMatches: [{
            type: Input
        }], showMatchesExceedsLimit: [{
            type: Input
        }], list: [{
            type: ViewChild,
            args: ['list', { static: true }]
        }] }); })();

class AvailableSectionTemplateComponent {
    constructor() {
        this.viewableItems = [];
        this.selectedItemsSoftStore = [];
        this.itemSelected = new EventEmitter();
        this.selectItem = (item) => {
            this.itemSelected.emit(item);
        };
    }
    resetScroll() {
        this.list.nativeElement.scrollTop = 0;
    }
}
AvailableSectionTemplateComponent.ɵfac = function AvailableSectionTemplateComponent_Factory(t) { return new (t || AvailableSectionTemplateComponent)(); };
AvailableSectionTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AvailableSectionTemplateComponent, selectors: [["pmcc-multiselect-available-section-template"]], viewQuery: function AvailableSectionTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c45, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, inputs: { viewableItems: "viewableItems", selectedItemsSoftStore: "selectedItemsSoftStore", template: "template", isSelected: "isSelected", showNoMatches: "showNoMatches", noMatchesMessage: "noMatchesMessage", searchCallbackEnabled: "searchCallbackEnabled", showMatchesExceedsLimit: "showMatchesExceedsLimit", matchesExceedsLimitMessageInterpolated: "matchesExceedsLimitMessageInterpolated" }, outputs: { itemSelected: "itemSelected" }, decls: 6, vars: 8, consts: [[1, "pmcc-available-list"], ["list", ""], ["class", "pmcc-available-list", 4, "ngIf"], [1, "pmcc-table"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "messaging"]], template: function AvailableSectionTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, AvailableSectionTemplateComponent_ul_2_Template, 3, 1, "ul", 2);
        ɵngcc0.ɵɵtemplate(3, AvailableSectionTemplateComponent_ul_3_Template, 3, 1, "ul", 2);
        ɵngcc0.ɵɵelementStart(4, "table", 3);
        ɵngcc0.ɵɵelementContainer(5, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNoMatches);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMatchesExceedsLimit);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(4, _c47, ctx.selectItem, ctx.isSelected, ctx.viewableItems));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
AvailableSectionTemplateComponent.propDecorators = {
    viewableItems: [{ type: Input }],
    template: [{ type: Input }],
    isSelected: [{ type: Input }],
    selectedItemsSoftStore: [{ type: Input }],
    showNoMatches: [{ type: Input }],
    noMatchesMessage: [{ type: Input }],
    searchCallbackEnabled: [{ type: Input }],
    showMatchesExceedsLimit: [{ type: Input }],
    matchesExceedsLimitMessageInterpolated: [{ type: Input }],
    itemSelected: [{ type: Output }],
    list: [{ type: ViewChild, args: ['list', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AvailableSectionTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-available-section-template',
                template: "<div\n  #list\n  class=\"pmcc-available-list\"\n>\n  <ul\n    class=\"pmcc-available-list\"\n    *ngIf=\"showNoMatches\"\n  >\n    <li class=\"messaging\">\n      {{ noMatchesMessage }}\n    </li>\n  </ul>\n  <ul\n    class=\"pmcc-available-list\"\n    *ngIf=\"showMatchesExceedsLimit\"\n  >\n    <li class=\"messaging\">\n      {{ matchesExceedsLimitMessageInterpolated }}\n    </li>\n  </ul>\n  <table class=\"pmcc-table\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{\n        selectItem: selectItem,\n        isSelected: isSelected,\n        viewableItems: viewableItems\n      }\"\n    ></ng-container>\n  </table>\n</div>\n"
            }]
    }], function () { return []; }, { viewableItems: [{
            type: Input
        }], selectedItemsSoftStore: [{
            type: Input
        }], itemSelected: [{
            type: Output
        }], template: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], showNoMatches: [{
            type: Input
        }], noMatchesMessage: [{
            type: Input
        }], searchCallbackEnabled: [{
            type: Input
        }], showMatchesExceedsLimit: [{
            type: Input
        }], matchesExceedsLimitMessageInterpolated: [{
            type: Input
        }], list: [{
            type: ViewChild,
            args: ['list', { static: true }]
        }] }); })();

class SelectedSectionListComponent {
    constructor() {
        this.viewableSelectedItems = [];
        this.itemSelected = new EventEmitter();
    }
    selectItem(item, event) {
        event.stopPropagation();
        if (item.unremovable) {
            return;
        }
        this.itemSelected.emit(item);
    }
    scrollToBottom() {
        this.list.nativeElement.scrollTop = this.list.nativeElement.scrollHeight;
    }
}
SelectedSectionListComponent.ɵfac = function SelectedSectionListComponent_Factory(t) { return new (t || SelectedSectionListComponent)(); };
SelectedSectionListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectedSectionListComponent, selectors: [["pmcc-multiselect-selected-section-list"]], viewQuery: function SelectedSectionListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c45, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, inputs: { viewableSelectedItems: "viewableSelectedItems", selectedItemsSearchEnabled: "selectedItemsSearchEnabled", textWrap: "textWrap", labelProp: "labelProp", selectedItem: "selectedItem" }, outputs: { itemSelected: "itemSelected" }, decls: 3, vars: 7, consts: [[1, "pmcc-selected-list", 3, "ngClass"], ["list", ""], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["href", "javascript:void(0)", 3, "ngClass", "title", "click", 4, "ngSwitchCase"], ["href", "javascript:void(0)", 3, "ngClass", "click", 4, "ngSwitchDefault"], ["href", "javascript:void(0)", 3, "ngClass", "title", "click"], ["href", "javascript:void(0)", 3, "ngClass", "click"]], template: function SelectedSectionListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0, 1);
        ɵngcc0.ɵɵtemplate(2, SelectedSectionListComponent_li_2_Template, 3, 2, "li", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(2, _c49, !ctx.selectedItemsSearchEnabled, ctx.textWrap === "nowrap", ctx.textWrap === "wrap", ctx.textWrap === "word-break"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.viewableSelectedItems);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault], encapsulation: 2 });
SelectedSectionListComponent.propDecorators = {
    selectedItemsSearchEnabled: [{ type: Input }],
    textWrap: [{ type: Input }],
    labelProp: [{ type: Input }],
    viewableSelectedItems: [{ type: Input }],
    selectedItem: [{ type: Input }],
    itemSelected: [{ type: Output }],
    list: [{ type: ViewChild, args: ['list', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedSectionListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-selected-section-list',
                template: "<ul\n  #list\n  class=\"pmcc-selected-list\"\n  [ngClass]=\"{\n    'pmcc-ms-selected-search-disabled': !selectedItemsSearchEnabled,\n    'pmcc-ms-text-wrap-nowrap': textWrap === 'nowrap',\n    'pmcc-ms-text-wrap-wrap': textWrap === 'wrap',\n    'pmcc-ms-text-wrap-word-break': textWrap === 'word-break'\n  }\"\n>\n  <li\n    *ngFor=\"let selectedItem of viewableSelectedItems\"\n    [ngSwitch]=\"textWrap\"\n  >\n    <a\n      href=\"javascript:void(0)\"\n      *ngSwitchCase=\"'nowrap'\"\n      [ngClass]=\"{ unremovable: selectedItem.unremovable }\"\n      title=\"{{ selectedItem[labelProp] }}\"\n      (click)=\"selectItem(selectedItem, $event)\"\n    >\n      {{ selectedItem[labelProp] }}\n    </a>\n    <a\n      href=\"javascript:void(0)\"\n      *ngSwitchDefault\n      [ngClass]=\"{ unremovable: selectedItem.unremovable }\"\n      (click)=\"selectItem(selectedItem, $event)\"\n    >\n      {{ selectedItem[labelProp] }}\n    </a>\n  </li>\n</ul>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { viewableSelectedItems: [{
            type: Input
        }], itemSelected: [{
            type: Output
        }], selectedItemsSearchEnabled: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], labelProp: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], list: [{
            type: ViewChild,
            args: ['list', { static: true }]
        }] }); })();

class SelectedSectionTemplateComponent {
    constructor() {
        this.viewableItems = [];
        this.itemSelected = new EventEmitter();
        this.selectItem = (item, event) => {
            event.stopPropagation();
            if (item.unremovable) {
                return;
            }
            this.itemSelected.emit(item);
        };
    }
    scrollToBottom() {
        this.list.nativeElement.scrollTop = this.list.nativeElement.scrollHeight;
    }
}
SelectedSectionTemplateComponent.ɵfac = function SelectedSectionTemplateComponent_Factory(t) { return new (t || SelectedSectionTemplateComponent)(); };
SelectedSectionTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectedSectionTemplateComponent, selectors: [["pmcc-multiselect-selected-section-template"]], viewQuery: function SelectedSectionTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c45, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, inputs: { viewableItems: "viewableItems", template: "template" }, outputs: { itemSelected: "itemSelected" }, decls: 4, vars: 5, consts: [[1, "pmcc-selected-list"], ["list", ""], [1, "pmcc-table"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function SelectedSectionTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "table", 2);
        ɵngcc0.ɵɵelementContainer(3, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c50, ctx.selectItem, ctx.viewableItems));
    } }, directives: [ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
SelectedSectionTemplateComponent.propDecorators = {
    viewableItems: [{ type: Input }],
    template: [{ type: Input }],
    itemSelected: [{ type: Output }],
    list: [{ type: ViewChild, args: ['list', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedSectionTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-selected-section-template',
                template: "<div\n  #list\n  class=\"pmcc-selected-list\"\n>\n  <table class=\"pmcc-table\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{\n        selectItem: selectItem,\n        viewableItems: viewableItems\n      }\"\n    ></ng-container>\n  </table>\n</div>\n"
            }]
    }], function () { return []; }, { viewableItems: [{
            type: Input
        }], itemSelected: [{
            type: Output
        }], template: [{
            type: Input
        }], list: [{
            type: ViewChild,
            args: ['list', { static: true }]
        }] }); })();

const maxLimitWarningTimeout = 3000;
const ɵ0$2 = found => `${found} results found. To refine results, please modify your search criteria.`;
const pmccMultiselectMessaging = {
    noResultsFound: 'Sorry, we couldn\'t find any results. Please modify your search criteria and try again.',
    resultsLimitExceeded: ɵ0$2,
};
const commaSeparate = num => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const ɵ1$2 = commaSeparate;
class MultiselectComponent {
    constructor() {
        this.size = 'sm';
        this.selectedItems = [];
        this.idProp = 'id';
        this.selectedItemsLimit = 0;
        this.maxViewableSelectedItems = 6;
        this.showClearAll = true;
        this.labelProp = 'name';
        this.matchesExceedsLimitMessage = pmccMultiselectMessaging.resultsLimitExceeded;
        this.noMatchesMessage = pmccMultiselectMessaging.noResultsFound;
        this.selectionLimitMessage = 'Maximum limit reached';
        this.textWrap = 'nowrap';
        this.minSelectedItems = 0;
        this.itemSelected = new EventEmitter();
        this.itemDeselected = new EventEmitter();
        this.selectedAll = new EventEmitter();
        this.clearedAll = new EventEmitter();
        this.multiselectDone = new EventEmitter();
        this.multiselectCanceled = new EventEmitter();
        this._availableItems = [];
        this._selectedItemsSoftStore = [];
        this.selectedItemsStore = this.selectedItems;
        this.availableItemsStore = this._availableItems;
        this.availableItemsStoreIndex = 0;
        this.selectedItemsStoreIndex = 0;
        /**
         * Available items that were shown before any search was performed.
         * We restore availableItems to it when multiselect is closed.
         */
        this.initialAvailableItems = this._availableItems;
        this.warnMaxLimitTimer = null;
        this._openSubscription = Subscription.EMPTY;
        this._searchSubscription = Subscription.EMPTY;
        this._disabled = false;
        this._itemsPageSize = 100;
        this.numRecordsFound = 0;
        this.viewableAvailableItems = this.availableItemsStore;
        this.availableItemsSearchQuery = '';
        this.selectedItemsSearchQuery = '';
        this.viewableSelectedItems = this.selectedItemsSoftStore;
        this.warnMaxLimit = false;
        this.unremovableItemsCount = 0;
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
        this.isSelected = (item) => {
            return this.findSelectedItemIndex(item[this.idProp]) > -1;
        };
    }
    set search(value) {
        this._search = value;
        if (this._search && !this.loading) {
            this._search.focusInput();
        }
    }
    get availableSection() {
        return this.availableSectionList || this.availableSectionTemplate;
    }
    get selectedSection() {
        return this.selectedSectionList || this.selectedSectionTemplate;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
        this.selectMsController.closeLayer('cancel', true);
    }
    get triggerLabel() {
        let label;
        const length = this.selectedItems.length;
        if (length === 0) {
            label = this.defaultLabel || 'Select';
        }
        else if (this.selectedLabel) {
            label = this.selectedLabel(this.selectedItems);
        }
        else {
            if (length === 1) {
                label = this.selectedItems[0][this.labelProp];
            }
            if (length === this.availableItems.length + this.unremovableItemsCount) {
                label = 'All Selected';
            }
        }
        return label || `${length} Selected`;
    }
    get showNoMatches() {
        if (this.loading) {
            return false;
        }
        const searchCallbackNoResults = (!!this.searchCallback &&
            !!this.availableItemsSearchQuery &&
            !this.numRecordsFound);
        return !this.viewableAvailableItems.length || searchCallbackNoResults;
    }
    get showMatchesExceedsLimit() {
        return !!this.searchCallback && this.maxNumRecordsExceeded;
    }
    get selectedItemsSearchEnabled() {
        return this.selectedItemsSoftStore.length >= this.maxViewableSelectedItems;
    }
    get maxNumRecordsExceeded() {
        return this.maxNumRecordsReturned < this.numRecordsFound;
    }
    get matchesExceedsLimitMessageInterpolated() {
        return this.matchesExceedsLimitMessage(commaSeparate(this.numRecordsFound));
    }
    get selectedItemsSoftStore() {
        return this._selectedItemsSoftStore;
    }
    set selectedItemsSoftStore(value) {
        this._selectedItemsSoftStore = value;
        if (this.selectedItemsSearchEnabled) {
            this.searchSelectedItems(this.selectedItemsSearchQuery);
        }
        else {
            this.resetSelectedItemsStore(value);
            this.clearSelectedItemsSearch();
        }
    }
    get availableItems() {
        return this._availableItems;
    }
    set availableItems(value) {
        this.updateAvailableItems(value);
    }
    set itemsPageSize(value) {
        this._itemsPageSize = value;
        this.resetAvailableItemsStore(this.availableItems);
    }
    get isDoneDisabled() {
        return this.selectedItemsSoftStore.length < this.minSelectedItems
            || (this.selectedItemsLimit && this.selectedItemsSoftStore.length > this.selectedItemsLimit);
    }
    get isSelectAllDisabled() {
        return (this.availableItems.length + this.unremovableItemsCount) === this.selectedItemsSoftStore.length;
    }
    get isDeselectAllDisabled() {
        return !this.selectedItemsStore.length;
    }
    get isLimitReached() {
        return this.selectedItemsLimit && this.selectedItemsSoftStore.length >= this.selectedItemsLimit;
    }
    ngOnInit() {
        this.selectedItemsSoftStore = [...this.selectedItems];
        this.unremovableItemsCount = this._selectedItemsSoftStore.reduce((count, _) => _.unremovable ? ++count : count, 0);
        if (!this.searchableKeys || !this.searchableKeys.length) {
            this.searchableKeys = [this.labelProp];
        }
    }
    selectItem(item) {
        const exists = this.isSelected(item);
        if (exists) {
            const itemIndex = this.findSelectedItemIndex(item[this.idProp]);
            this.selectedItemsSoftStore = this.selectedItemsSoftStore
                .filter((_, i) => i !== itemIndex);
            this.itemDeselected.emit(item);
            this.resetWarnMax();
        }
        else {
            const reachedLimit = this.selectedItemsLimit &&
                this.selectedItemsStore.length >= this.selectedItemsLimit;
            if (!reachedLimit) {
                this.selectedItemsSoftStore = [
                    ...this.selectedItemsSoftStore,
                    item
                ];
                this.itemSelected.emit(item);
                setTimeout(() => this.scrollSelectedList());
            }
            else {
                this.warnMaxLimit = true;
                this.warnMaxLimitTimer = setTimeout(() => {
                    this.warnMaxLimit = false;
                }, maxLimitWarningTimeout);
            }
        }
        this.checkAvailabilityItemVisibility();
    }
    findSelectedItemIndex(id) {
        return this.selectedItemsSoftStore.findIndex(item => item[this.idProp] === id);
    }
    scrollAvailableList() {
        this.availableSection.resetScroll();
    }
    scrollSelectedList() {
        this.selectedSection.scrollToBottom();
    }
    /**
     * The do-while loop below will skip counting selected items in the outer for loop.
     * So items of length _itemsPageSize plus selected items are added in viewableAvailableItems.
     */
    loadAvailableItems() {
        for (let i = 0; i < this._itemsPageSize; i++) {
            let item;
            do {
                item = this.availableItemsStore[this.availableItemsStoreIndex];
                if (item) {
                    this.viewableAvailableItems.push(item);
                    this.availableItemsStoreIndex++;
                }
            } while (item && this.isSelected(item));
        }
    }
    loadSelectedItems() {
        for (let i = 0; i < this._itemsPageSize; i++) {
            const item = this.selectedItemsStore[this.selectedItemsStoreIndex];
            if (item) {
                this.viewableSelectedItems.push(item);
                this.selectedItemsStoreIndex++;
            }
        }
    }
    resetAvailableItemsStore(value) {
        this.availableItemsStore = value;
        this.availableItemsStoreIndex = 0;
        this.viewableAvailableItems = [];
        this.loadAvailableItems();
        this.checkAvailabilityItemVisibility();
    }
    resetSelectedItemsStore(value) {
        this.selectedItemsStore = value;
        this.selectedItemsStoreIndex = 0;
        this.viewableSelectedItems = [];
        this.loadSelectedItems();
        this.checkAvailabilityItemVisibility();
    }
    checkAvailabilityItemVisibility() {
        this.allVisibleItemsSelected = this.viewableAvailableItems.every(item => {
            return this.isSelected(item);
        });
    }
    selectAll() {
        this.selectedItemsSoftStore = this.getUniqueElements(this.selectedItemsSoftStore.concat(this.viewableAvailableItems));
        this.scrollAvailableList();
        this.scrollSelectedList();
        this.checkAvailabilityItemVisibility();
        this.selectedAll.emit();
    }
    deselectAll() {
        this.selectedItemsSoftStore = this.selectedItemsSoftStore
            .filter(item => {
            if (this.selectedItemsSearchQuery) {
                return item.unremovable || !this.selectedItemsStore.includes(item);
            }
            return item.unremovable;
        });
        this.checkAvailabilityItemVisibility();
        this.resetWarnMax();
        this.clearedAll.emit();
    }
    resetWarnMax() {
        if (this.warnMaxLimit) {
            this.warnMaxLimit = false;
            clearTimeout(this.warnMaxLimitTimer);
        }
    }
    getMatchingItems(query, items) {
        const lowerCaseQuery = query.toLowerCase();
        const keys = this.searchableKeys;
        return items.filter(item => {
            return keys.some(key => String(item[key]).toLowerCase().includes(lowerCaseQuery));
        });
    }
    searchAvailableItems(query) {
        this.availableItemsSearchQuery = query;
        if (this.searchCallback) {
            this.performSearch();
            return;
        }
        if (query) {
            const data = this.getMatchingItems(query, this.availableItems);
            this.resetAvailableItemsStore(data);
        }
        else {
            this.resetAvailableItemsStore(this.availableItems);
        }
    }
    searchSelectedItems(query) {
        this.selectedItemsSearchQuery = query;
        if (query) {
            const data = this.getMatchingItems(query, this.selectedItemsSoftStore);
            this.resetSelectedItemsStore(data);
        }
        else {
            this.resetSelectedItemsStore(this.selectedItemsSoftStore);
        }
    }
    clearAvailableItemsSearch() {
        this.searchAvailableItems('');
    }
    clearSelectedItemsSearch() {
        this.searchSelectedItems('');
    }
    performSearch() {
        const params = { query: this.availableItemsSearchQuery };
        this.loading = true;
        this._searchSubscription.unsubscribe();
        this._searchSubscription = this.searchCallback(params)
            .pipe(take(1), finalize(() => this.loading = false))
            .subscribe(({ data }) => {
            this.updateAvailableItems(data.items);
            this.numRecordsFound = data.metaData.totalRecords;
        });
    }
    onOpenCallback() {
        this.loading = true;
        this._openSubscription.unsubscribe();
        this._openSubscription = this.onOpen()
            .pipe(take(1), finalize(() => {
            this.loading = false;
        }))
            .subscribe(({ data }) => {
            this.updateAvailableItems(data.items);
            this.numRecordsFound = data.metaData.totalRecords;
        });
    }
    handleOpen() {
        if (this.onOpen && !this.availableItems.length) {
            this.onOpenCallback();
        }
        this.selectedItemsSoftStore = this.selectedItems;
        this.initialAvailableItems = this._availableItems;
    }
    closeLayer(param) {
        this.onTouched();
        this._searchSubscription.unsubscribe();
        if (param === 'close') {
            this.selectedItems = this.selectedItemsSoftStore;
            this.multiselectDone.emit(this.selectedItems);
            this.onModelChange(this.selectedItems);
        }
        else {
            this.resetSelectedItemsStore(this.selectedItems);
            this.multiselectCanceled.emit(this.selectedItems);
        }
        if (this.warnMaxLimit) {
            this.warnMaxLimit = false;
            clearTimeout(this.warnMaxLimitTimer);
        }
        this.availableItemsSearchQuery = this.selectedItemsSearchQuery = '';
        this._availableItems = this.initialAvailableItems;
        this.resetAvailableItemsStore(this.initialAvailableItems);
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(obj) {
        this.selectedItems = obj == null ? [] : coerceArray(obj);
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    updateAvailableItems(value) {
        this._availableItems = value;
        this.resetAvailableItemsStore(value);
        if (!this.availableItemsSearchQuery) {
            // If available items were updated not because of searching,
            // we need to reset initialAvailableItems.
            this.initialAvailableItems = this._availableItems;
        }
    }
    getUniqueElements(mergedItems) {
        for (let i = 0; i < mergedItems.length; ++i) {
            for (let j = i + 1; j < mergedItems.length; ++j) {
                if (mergedItems[i][this.idProp] === mergedItems[j][this.idProp]) {
                    mergedItems.splice(j--, 1);
                }
            }
        }
        return mergedItems;
    }
}
MultiselectComponent.ɵfac = function MultiselectComponent_Factory(t) { return new (t || MultiselectComponent)(); };
MultiselectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectComponent, selectors: [["pmcc-multiselect"]], viewQuery: function MultiselectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c51, 5);
        ɵngcc0.ɵɵviewQuery(SelectMsControllerDirective, 7);
        ɵngcc0.ɵɵviewQuery(AvailableSectionListComponent, 5);
        ɵngcc0.ɵɵviewQuery(AvailableSectionTemplateComponent, 5);
        ɵngcc0.ɵɵviewQuery(SelectedSectionListComponent, 5);
        ɵngcc0.ɵɵviewQuery(SelectedSectionTemplateComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.search = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectMsController = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.availableSectionList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.availableSectionTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectedSectionList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectedSectionTemplate = _t.first);
    } }, inputs: { size: "size", selectedItems: "selectedItems", idProp: "idProp", selectedItemsLimit: "selectedItemsLimit", maxViewableSelectedItems: "maxViewableSelectedItems", showClearAll: "showClearAll", labelProp: "labelProp", matchesExceedsLimitMessage: "matchesExceedsLimitMessage", noMatchesMessage: "noMatchesMessage", selectionLimitMessage: "selectionLimitMessage", textWrap: "textWrap", minSelectedItems: "minSelectedItems", disabled: "disabled", availableItems: "availableItems", itemsPageSize: "itemsPageSize", searchableKeys: "searchableKeys", availableItemsTemplate: "availableItemsTemplate", selectedItemsTemplate: "selectedItemsTemplate", searchCallback: "searchCallback", maxNumRecordsReturned: "maxNumRecordsReturned", instructions: "instructions", width: "width", layerPositioningPush: "layerPositioningPush", onOpen: "onOpen", alignRight: "alignRight", defaultLabel: "defaultLabel", selectedLabel: "selectedLabel", selectAllTooltip: "selectAllTooltip" }, outputs: { itemSelected: "itemSelected", itemDeselected: "itemDeselected", selectedAll: "selectedAll", clearedAll: "clearedAll", multiselectDone: "multiselectDone", multiselectCanceled: "multiselectCanceled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => MultiselectComponent)
            }
        ])], decls: 5, vars: 15, consts: [["pmccSelectController", "", 1, "pmcc-ms-container", 3, "ngClass", "alignRight", "template", "isDisabled", "size", "layerPositioningPush", "open", "close"], ["controller", "pmccSelectController"], [3, "isOpen", "isDisabled", "width", "triggerLabel", "click"], [3, "ngIf"], ["template", ""], [1, "pmcc-ms-layer-container", 3, "ngClass"], [1, "pmcc-ms-layer", 3, "ngClass", "keydown"], [1, "pmcc-ms-items-section"], [4, "ngIf"], [1, "pmcc-available-section"], [3, "selectedItemsLimit", "warnMaxLimit", "selectionLimitMessage", "instructions", "isSelectAllDisabled", "isLimitReached", "selectAllTooltip", "selectedAll"], [3, "query", "changed", "searchCleared"], ["search", ""], ["pmccInfiniteScroll", "", 3, "textWrap", "viewableAvailableItems", "availableItemsSearchEmpty", "noMatchesMessage", "isSelected", "labelProp", "matchesExceedsLimitMessageInterpolated", "showNoMatches", "showMatchesExceedsLimit", "itemSelected", "pmccScrollEnd", 4, "ngIf"], ["pmccInfiniteScroll", "", 3, "viewableItems", "template", "selectedItemsSoftStore", "isSelected", "showNoMatches", "showMatchesExceedsLimit", "noMatchesMessage", "matchesExceedsLimitMessageInterpolated", "itemSelected", "pmccScrollEnd", 4, "ngIf"], [1, "pmcc-selected-section"], [3, "showClearAll", "instructions", "isDeselectAllDisabled", "deselectedAll"], [3, "query", "changed", "searchCleared", 4, "ngIf"], ["pmccInfiniteScroll", "", 3, "selectedItemsSearchEnabled", "textWrap", "labelProp", "viewableSelectedItems", "itemSelected", "pmccScrollEnd", 4, "ngIf"], ["pmccInfiniteScroll", "", 3, "viewableItems", "template", "itemSelected", "pmccScrollEnd", 4, "ngIf"], [3, "isDoneDisabled", "layerClosed"], ["pmccInfiniteScroll", "", 3, "textWrap", "viewableAvailableItems", "availableItemsSearchEmpty", "noMatchesMessage", "isSelected", "labelProp", "matchesExceedsLimitMessageInterpolated", "showNoMatches", "showMatchesExceedsLimit", "itemSelected", "pmccScrollEnd"], ["pmccInfiniteScroll", "", 3, "viewableItems", "template", "selectedItemsSoftStore", "isSelected", "showNoMatches", "showMatchesExceedsLimit", "noMatchesMessage", "matchesExceedsLimitMessageInterpolated", "itemSelected", "pmccScrollEnd"], ["pmccInfiniteScroll", "", 3, "selectedItemsSearchEnabled", "textWrap", "labelProp", "viewableSelectedItems", "itemSelected", "pmccScrollEnd"], ["pmccInfiniteScroll", "", 3, "viewableItems", "template", "itemSelected", "pmccScrollEnd"]], template: function MultiselectComponent_Template(rf, ctx) { if (rf & 1) {
        const _r32 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("open", function MultiselectComponent_Template_div_open_0_listener() { return ctx.handleOpen(); })("close", function MultiselectComponent_Template_div_close_0_listener($event) { return ctx.closeLayer($event); });
        ɵngcc0.ɵɵelementStart(2, "pmcc-select-ms-trigger", 2);
        ɵngcc0.ɵɵlistener("click", function MultiselectComponent_Template_pmcc_select_ms_trigger_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r32); const _r0 = ɵngcc0.ɵɵreference(1); return _r0.toggleLayer(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, MultiselectComponent_ng_template_3_Template, 16, 33, "ng-template", 3, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(11, _c52, ctx.size === "sm", ctx.size === "md", ctx.size === "lg"))("alignRight", ctx.alignRight)("template", _r1)("isDisabled", ctx.disabled)("size", ctx.size)("layerPositioningPush", ctx.layerPositioningPush);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("isOpen", _r0.isOpen)("isDisabled", ctx.disabled)("width", ctx.width)("triggerLabel", ctx.triggerLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", _r0.isOpen && ctx.layerPositioningPush);
    } }, directives: function () { return [SelectMsControllerDirective, ɵngcc1.NgClass, SelectMsTriggerComponent, ɵngcc1.NgIf, AvailableSectionHeaderComponent, SearchComponent, SelectedSectionHeaderComponent, ButtonBarComponent, SpinnerComponent, AvailableSectionListComponent, InfiniteScrollDirective, AvailableSectionTemplateComponent, SelectedSectionListComponent, SelectedSectionTemplateComponent]; }, styles: [".pmcc-form-control-invalid pmcc-multiselect .pmcc-trigger{border:1px solid #c5242a!important}pmcc-multiselect-available-section-header{display:block}pmcc-multiselect-available-section-list,pmcc-multiselect-available-section-template,pmcc-multiselect-selected-section-list,pmcc-multiselect-selected-section-template{overflow:auto}pmcc-multiselect{position:relative;display:inline-block;text-align:left;font-size:13px}pmcc-multiselect .pmcc-ms-container{position:relative;display:inline-flex;width:100%}pmcc-multiselect .pmcc-ms-container.active .pmcc-trigger{z-index:1010}pmcc-multiselect .pmcc-ms-container.active .pmcc-ms-layer{z-index:1000}pmcc-multiselect .pmcc-ms-container.active:not(.is-below-overlay) .pmcc-trigger{margin-bottom:1px;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}pmcc-multiselect .pmcc-ms-container.active.is-below-overlay .pmcc-trigger{margin-top:1px;border-top:0;border-top-left-radius:0;border-top-right-radius:0}pmcc-multiselect .pmcc-ms-container.disabled{opacity:.5}pmcc-multiselect .pmcc-ms-container.disabled .pmcc-trigger{cursor:not-allowed}pmcc-multiselect .pmcc-ms-container.disabled .pmcc-trigger.focused{outline:none!important}pmcc-multiselect .pmcc-ms-container .pmcc-trigger{-webkit-user-select:none;user-select:none;position:relative;display:flex;justify-content:space-between;width:140px;padding:5px 10px 5px 5px;overflow:hidden;outline:none;font-size:13px;font-weight:400;line-height:1.18;text-align:left;text-overflow:ellipsis;white-space:nowrap;vertical-align:initial;background:#fff;border:1px solid #c9c9c9;border-radius:3px;box-shadow:0 1px 5px rgba(0,0,0,.075);cursor:pointer;max-width:235px}pmcc-multiselect .pmcc-ms-container .pmcc-trigger.active{position:relative;z-index:29001;padding-bottom:5px;box-shadow:none}pmcc-multiselect .pmcc-ms-container .pmcc-trigger:after{z-index:0;content:\"a\";font-family:pmcc-ico;color:#787878;line-height:1}pmcc-multiselect .pmcc-ms-container .pmcc-trigger>.pmcc-trigger-label{overflow:hidden;text-overflow:ellipsis}pmcc-multiselect.pmcc-error .pmcc-trigger{border-color:#c5242a}.pmcc-overlay-pane.pmcc-ms-align-right.is-above-trigger .pmcc-ms-layer{border-radius:3px 3px 0 3px}.pmcc-overlay-pane.pmcc-ms-align-right:not(.is-above-trigger) .pmcc-ms-layer{border-radius:3px 0 3px 3px}.pmcc-overlay-pane.is-above-trigger .pmcc-ms-layer{border-radius:3px 3px 3px 0}.pmcc-overlay-pane:not(.is-above-trigger) .pmcc-ms-layer{border-radius:0 3px 3px 3px}.pmcc-ms-layer{position:relative;height:100%;z-index:980;background:#fff;background-clip:padding-box;border:1px solid #c9c9c9;box-sizing:border-box;box-shadow:0 4px 8px -3px #0000001f;border-radius:3px 3px 3px 3px;flex-direction:column;align-items:stretch;display:flex!important;font-size:13px}.pmcc-ms-layer.layer-push{position:relative;top:-2px}.pmcc-ms-layer.layer-push:not(.pmcc-ms-align-right){border-radius:0 3px 3px 3px}.pmcc-ms-layer.layer-push.pmcc-ms-align-right{border-radius:3px 3px 3px 0}.pmcc-ms-layer.layer-push.sm{height:350px}.pmcc-ms-layer.layer-push.md{height:470px}.pmcc-ms-layer.layer-push.lg{height:540px}.pmcc-ms-layer .pmcc-ms-items-section{display:flex;flex:1;min-height:0;width:100%;position:relative;margin:0}.pmcc-ms-layer .pmcc-available-section,.pmcc-ms-layer .pmcc-selected-section{display:flex;flex-direction:column;box-sizing:border-box;width:50%;padding:1em 10px 0 0}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header{position:relative;min-height:33px;margin-bottom:1em;padding-bottom:.5em;font-weight:700;border-bottom:1px solid #ccc}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header.disabled,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header.disabled{height:32px}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header.disabled *,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header.disabled *{visibility:hidden}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header .pmcc-ms-tooltip-info-icon,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header .pmcc-ms-tooltip-info-icon{opacity:.5;margin-left:7px;top:3px;cursor:pointer}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header div.pmcc-ms-section-header-message,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header div.pmcc-ms-section-header-message{position:relative;padding-top:1em;min-height:27px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search{position:relative;margin-bottom:.25em}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search:after,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search:after{content:\"\";display:table;clear:both}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search.disabled,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search.disabled{height:30px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search.disabled *,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search.disabled *{visibility:hidden}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search span.label,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search span.label{float:left;font-weight:700;line-height:29px;font-size:13px;padding:0}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search input,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search input{float:right;width:77%;border:1px solid #c9c9c9;border-radius:4px;padding:7px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search input::-ms-clear,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search input::-ms-clear{width:0;height:0}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search span.pmcc-ico-close,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search span.pmcc-ico-close{position:absolute;top:10px;right:7px;font-size:11px;color:#d8d8d8;cursor:pointer}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list{padding:0;list-style:none}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-nowrap li a{white-space:nowrap}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-wrap li a{white-space:normal}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-word-break li a{white-space:normal;word-break:break-all;text-overflow:unset}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li.messaging,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list li.messaging,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list li.messaging,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li.messaging{white-space:normal;color:#666}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a{width:100%;overflow:hidden;text-overflow:ellipsis;text-decoration:none}.pmcc-ms-layer .pmcc-available-section{border-top-left-radius:3px;padding-left:1em;border-right:1px solid #ccc}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li.selected{display:none}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li a{display:block;margin:0 0 4px;padding:8px 0;color:#0085cc;border-bottom:1px solid #e7e7e7}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li:last-child a{border-bottom:none}.pmcc-ms-layer .pmcc-selected-section{border-top-right-radius:3px;padding-left:10px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li{margin:0 13px .5em 0}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a{position:relative;display:block;vertical-align:middle;box-sizing:border-box;padding:8px 30px 7px 6px;color:#666;font-size:13px;background:#f1f1f1;border-radius:3px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a:after{content:\"\";display:table;clear:both;position:absolute;z-index:1;top:0;right:8px;display:flex;justify-content:center;align-items:center;height:100%;padding-left:8px;line-height:31px;border-left:1px solid #fff;font-family:pmcc-ico;content:\"e\";color:#ccc;font-size:9px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a.unremovable{cursor:default}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a.unremovable:after{display:none}.pmcc-ms-layer .pmcc-button-bar{padding:1em;border-top:1px solid #e4e4e4}.pmcc-ms-layer .pmcc-button-bar button{margin:0}.pmcc-overlay-pane.pmcc-multiselect-pane.sm{height:350px}.pmcc-overlay-pane.pmcc-multiselect-pane.md{height:470px}.pmcc-overlay-pane.pmcc-multiselect-pane.lg{height:540px}.pmcc-ms-layer-container{height:100%}.pmcc-ms-layer-container.sm{width:470px;max-width:470px}.pmcc-ms-layer-container.md{width:670px;max-width:670px}.pmcc-ms-layer-container.lg{width:870px;max-width:870px}.pmcc-ms-container.layer-push{flex-wrap:wrap}.pmcc-ms-container.layer-push.active.sm{width:470px}.pmcc-ms-container.layer-push.active.md{width:670px}.pmcc-ms-container.layer-push.active.lg{width:870px}.pmcc-available-list,.pmcc-selected-list{justify-content:flex-start;align-items:flex-start;padding-bottom:10px}.pmcc-available-list>.pmcc-table,.pmcc-selected-list>.pmcc-table{border:0!important;width:100%}.pmcc-available-list>.pmcc-table>tbody>tr>td,.pmcc-selected-list>.pmcc-table>tbody>tr>td{border:0!important;cursor:pointer!important;vertical-align:middle!important}.pmcc-available-list>.pmcc-table>tbody>tr>td>div,.pmcc-selected-list>.pmcc-table>tbody>tr>td>div{vertical-align:middle!important}.pmcc-available-list>.pmcc-table>tbody>tr>td.nowrap,.pmcc-selected-list>.pmcc-table>tbody>tr>td.nowrap{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:1px}.pmcc-available-list>.pmcc-table>tbody>tr>td.nowrap>div,.pmcc-selected-list>.pmcc-table>tbody>tr>td.nowrap>div{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.pmcc-available-list>.pmcc-table>tbody>tr>td.wrap,.pmcc-selected-list>.pmcc-table>tbody>tr>td.wrap{white-space:normal}.pmcc-available-list>.pmcc-table>tbody>tr>td.word-break,.pmcc-selected-list>.pmcc-table>tbody>tr>td.word-break{white-space:normal;word-break:break-all}.pmcc-available-list>.pmcc-table{border-top:1em solid #0000}.pmcc-available-list>.pmcc-table thead{background:#fff}.pmcc-available-list>.pmcc-table th{background:#fff;border-left:0!important;border-right:0!important}.pmcc-available-list>.pmcc-table tr.selected{display:none}.pmcc-selected-list>.pmcc-table{border-collapse:initial!important;border-spacing:0 .5em!important}.pmcc-selected-list>.pmcc-table thead{background:#fff}.pmcc-selected-list>.pmcc-table th{background:#fff;border-left:0!important;border-right:0!important}.pmcc-selected-list>.pmcc-table td{padding:8px 6px 7px!important;background:none!important;background:#f1f1f1!important;border-left:1px solid #f1f1f1!important;line-height:normal!important}.pmcc-selected-list>.pmcc-table td:last-child{border-left:2px solid #fff!important}.pmcc-selected-list>.pmcc-table td:first-of-type{border-top-left-radius:3px;border-bottom-left-radius:3px;color:#666}.pmcc-selected-list>.pmcc-table td:last-of-type{display:table-cell;width:37px!important;border-top-right-radius:3px;border-bottom-right-radius:3px;color:#ccc;text-align:center;vertical-align:middle}.pmcc-selected-list>.pmcc-table td:last-of-type .pmcc-ico-close{font-size:9px;font-weight:700}.pmcc-selected-list>.pmcc-table tr:first-of-type td{padding:0}.pmcc-selected-list>.pmcc-table tr:nth-child(n+2) td{margin:5px 0 0}"], encapsulation: 2 });
MultiselectComponent.propDecorators = {
    size: [{ type: Input }],
    availableItemsTemplate: [{ type: Input }],
    selectedItemsTemplate: [{ type: Input }],
    selectedItems: [{ type: Input }],
    idProp: [{ type: Input }],
    selectedItemsLimit: [{ type: Input }],
    maxViewableSelectedItems: [{ type: Input }],
    showClearAll: [{ type: Input }],
    searchableKeys: [{ type: Input }],
    labelProp: [{ type: Input }],
    searchCallback: [{ type: Input }],
    maxNumRecordsReturned: [{ type: Input }],
    matchesExceedsLimitMessage: [{ type: Input }],
    noMatchesMessage: [{ type: Input }],
    instructions: [{ type: Input }],
    selectionLimitMessage: [{ type: Input }],
    textWrap: [{ type: Input }],
    minSelectedItems: [{ type: Input }],
    width: [{ type: Input }],
    layerPositioningPush: [{ type: Input }],
    onOpen: [{ type: Input }],
    alignRight: [{ type: Input }],
    defaultLabel: [{ type: Input }],
    selectedLabel: [{ type: Input }],
    selectAllTooltip: [{ type: Input }],
    itemSelected: [{ type: Output }],
    itemDeselected: [{ type: Output }],
    selectedAll: [{ type: Output }],
    clearedAll: [{ type: Output }],
    multiselectDone: [{ type: Output }],
    multiselectCanceled: [{ type: Output }],
    selectMsController: [{ type: ViewChild, args: [SelectMsControllerDirective, { static: true },] }],
    availableSectionList: [{ type: ViewChild, args: [AvailableSectionListComponent,] }],
    availableSectionTemplate: [{ type: ViewChild, args: [AvailableSectionTemplateComponent,] }],
    selectedSectionList: [{ type: ViewChild, args: [SelectedSectionListComponent,] }],
    selectedSectionTemplate: [{ type: ViewChild, args: [SelectedSectionTemplateComponent,] }],
    search: [{ type: ViewChild, args: ['search',] }],
    disabled: [{ type: Input }],
    availableItems: [{ type: Input }],
    itemsPageSize: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect',
                template: "<div\n  class=\"pmcc-ms-container\"\n  [ngClass]=\"{\n    sm: size === 'sm',\n    md: size === 'md',\n    lg: size === 'lg'\n  }\"\n  pmccSelectController\n  #controller=\"pmccSelectController\"\n  [alignRight]=\"alignRight\"\n  [template]=\"template\"\n  [isDisabled]=\"disabled\"\n  [size]=\"size\"\n  [layerPositioningPush]=\"layerPositioningPush\"\n  (open)=\"handleOpen()\"\n  (close)=\"closeLayer($event)\"\n>\n  <pmcc-select-ms-trigger\n    [isOpen]=\"controller.isOpen\"\n    [isDisabled]=\"disabled\"\n    [width]=\"width\"\n    [triggerLabel]=\"triggerLabel\"\n    (click)=\"controller.toggleLayer()\"\n  ></pmcc-select-ms-trigger>\n\n  <ng-template #template [ngIf]=\"controller.isOpen && layerPositioningPush\">\n    <div\n      class=\"pmcc-ms-layer-container\"\n      [ngClass]=\"{\n        sm: size === 'sm',\n        md: size === 'md',\n        lg: size === 'lg'\n      }\"\n    >\n      <div\n        class=\"pmcc-ms-layer\"\n        [ngClass]=\"{\n          sm: size === 'sm',\n          md: size === 'md',\n          lg: size === 'lg',\n          active: controller.isOpen,\n          'pmcc-ms-align-right': alignRight,\n          'layer-push': layerPositioningPush\n        }\"\n        [style.display]=\"controller.isOpen ? 'block' : 'none'\"\n        (keydown)=\"controller.triggerKeyHandler($event)\"\n      >\n        <div class=\"pmcc-ms-items-section\">\n          <pmcc-spinner *ngIf=\"loading\"></pmcc-spinner>\n          <div class=\"pmcc-available-section\">\n            <pmcc-multiselect-available-section-header\n              [selectedItemsLimit]=\"selectedItemsLimit\"\n              [warnMaxLimit]=\"warnMaxLimit\"\n              [selectionLimitMessage]=\"selectionLimitMessage\"\n              [instructions]=\"instructions\"\n              [isSelectAllDisabled]=\"isSelectAllDisabled\"\n              [isLimitReached]=\"isLimitReached\"\n              [selectAllTooltip]=\"selectAllTooltip\"\n              (selectedAll)=\"selectAll()\"\n            ></pmcc-multiselect-available-section-header>\n\n            <pmcc-multiselect-search\n              #search\n              [query]=\"availableItemsSearchQuery\"\n              (changed)=\"searchAvailableItems($event)\"\n              (searchCleared)=\"clearAvailableItemsSearch()\"\n            ></pmcc-multiselect-search>\n\n            <pmcc-multiselect-available-section-list\n              *ngIf=\"!availableItemsTemplate\"\n              [textWrap]=\"textWrap\"\n              [viewableAvailableItems]=\"viewableAvailableItems\"\n              [availableItemsSearchEmpty]=\"false\"\n              [noMatchesMessage]=\"noMatchesMessage\"\n              [isSelected]=\"isSelected\"\n              [labelProp]=\"labelProp\"\n              [matchesExceedsLimitMessageInterpolated]=\"matchesExceedsLimitMessageInterpolated\"\n              [showNoMatches]=\"showNoMatches\"\n              [showMatchesExceedsLimit]=\"showMatchesExceedsLimit\"\n              (itemSelected)=\"selectItem($event)\"\n              pmccInfiniteScroll\n              (pmccScrollEnd)=\"loadAvailableItems()\"\n            ></pmcc-multiselect-available-section-list>\n\n            <pmcc-multiselect-available-section-template\n              *ngIf=\"availableItemsTemplate\"\n              [viewableItems]=\"viewableAvailableItems\"\n              [template]=\"availableItemsTemplate\"\n              [selectedItemsSoftStore]=\"selectedItemsSoftStore\"\n              [isSelected]=\"isSelected\"\n              [showNoMatches]=\"showNoMatches\"\n              [showMatchesExceedsLimit]=\"showMatchesExceedsLimit\"\n              [noMatchesMessage]=\"noMatchesMessage\"\n              [matchesExceedsLimitMessageInterpolated]=\"matchesExceedsLimitMessageInterpolated\"\n              (itemSelected)=\"selectItem($event)\"\n              pmccInfiniteScroll\n              (pmccScrollEnd)=\"loadAvailableItems()\"\n            ></pmcc-multiselect-available-section-template>\n          </div>\n          <div class=\"pmcc-selected-section\">\n            <pmcc-multiselect-selected-section-header\n              [showClearAll]=\"showClearAll\"\n              [instructions]=\"instructions\"\n              [isDeselectAllDisabled]=\"isDeselectAllDisabled\"\n              (deselectedAll)=\"deselectAll()\"\n            ></pmcc-multiselect-selected-section-header>\n\n            <pmcc-multiselect-search\n              *ngIf=\"selectedItemsSearchEnabled\"\n              [query]=\"selectedItemsSearchQuery\"\n              (changed)=\"searchSelectedItems($event)\"\n              (searchCleared)=\"clearSelectedItemsSearch()\"\n            ></pmcc-multiselect-search>\n\n            <pmcc-multiselect-selected-section-list\n              *ngIf=\"!selectedItemsTemplate\"\n              [selectedItemsSearchEnabled]=\"selectedItemsSearchEnabled\"\n              [textWrap]=\"textWrap\"\n              [labelProp]=\"labelProp\"\n              [viewableSelectedItems]=\"viewableSelectedItems\"\n              (itemSelected)=\"selectItem($event)\"\n              pmccInfiniteScroll\n              (pmccScrollEnd)=\"loadSelectedItems()\"\n            ></pmcc-multiselect-selected-section-list>\n\n            <pmcc-multiselect-selected-section-template\n              *ngIf=\"selectedItemsTemplate\"\n              [viewableItems]=\"viewableSelectedItems\"\n              [template]=\"selectedItemsTemplate\"\n              (itemSelected)=\"selectItem($event)\"\n              pmccInfiniteScroll\n              (pmccScrollEnd)=\"loadSelectedItems()\"\n            ></pmcc-multiselect-selected-section-template>\n          </div>\n        </div>\n        <pmcc-multiselect-button-bar\n          [isDoneDisabled]=\"isDoneDisabled\"\n          (layerClosed)=\"controller.closeLayer($event)\"\n        ></pmcc-multiselect-button-bar>\n      </div>\n    </div>\n  </ng-template>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => MultiselectComponent)
                    }
                ],
                styles: [".pmcc-form-control-invalid pmcc-multiselect .pmcc-trigger{border:1px solid #c5242a!important}pmcc-multiselect-available-section-header{display:block}pmcc-multiselect-available-section-list,pmcc-multiselect-available-section-template,pmcc-multiselect-selected-section-list,pmcc-multiselect-selected-section-template{overflow:auto}pmcc-multiselect{position:relative;display:inline-block;text-align:left;font-size:13px}pmcc-multiselect .pmcc-ms-container{position:relative;display:inline-flex;width:100%}pmcc-multiselect .pmcc-ms-container.active .pmcc-trigger{z-index:1010}pmcc-multiselect .pmcc-ms-container.active .pmcc-ms-layer{z-index:1000}pmcc-multiselect .pmcc-ms-container.active:not(.is-below-overlay) .pmcc-trigger{margin-bottom:1px;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}pmcc-multiselect .pmcc-ms-container.active.is-below-overlay .pmcc-trigger{margin-top:1px;border-top:0;border-top-left-radius:0;border-top-right-radius:0}pmcc-multiselect .pmcc-ms-container.disabled{opacity:.5}pmcc-multiselect .pmcc-ms-container.disabled .pmcc-trigger{cursor:not-allowed}pmcc-multiselect .pmcc-ms-container.disabled .pmcc-trigger.focused{outline:none!important}pmcc-multiselect .pmcc-ms-container .pmcc-trigger{-webkit-user-select:none;user-select:none;position:relative;display:flex;justify-content:space-between;width:140px;padding:5px 10px 5px 5px;overflow:hidden;outline:none;font-size:13px;font-weight:400;line-height:1.18;text-align:left;text-overflow:ellipsis;white-space:nowrap;vertical-align:initial;background:#fff;border:1px solid #c9c9c9;border-radius:3px;box-shadow:0 1px 5px rgba(0,0,0,.075);cursor:pointer;max-width:235px}pmcc-multiselect .pmcc-ms-container .pmcc-trigger.active{position:relative;z-index:29001;padding-bottom:5px;box-shadow:none}pmcc-multiselect .pmcc-ms-container .pmcc-trigger:after{z-index:0;content:\"a\";font-family:pmcc-ico;color:#787878;line-height:1}pmcc-multiselect .pmcc-ms-container .pmcc-trigger>.pmcc-trigger-label{overflow:hidden;text-overflow:ellipsis}pmcc-multiselect.pmcc-error .pmcc-trigger{border-color:#c5242a}.pmcc-overlay-pane.pmcc-ms-align-right.is-above-trigger .pmcc-ms-layer{border-radius:3px 3px 0 3px}.pmcc-overlay-pane.pmcc-ms-align-right:not(.is-above-trigger) .pmcc-ms-layer{border-radius:3px 0 3px 3px}.pmcc-overlay-pane.is-above-trigger .pmcc-ms-layer{border-radius:3px 3px 3px 0}.pmcc-overlay-pane:not(.is-above-trigger) .pmcc-ms-layer{border-radius:0 3px 3px 3px}.pmcc-ms-layer{position:relative;height:100%;z-index:980;background:#fff;background-clip:padding-box;border:1px solid #c9c9c9;box-sizing:border-box;box-shadow:0 4px 8px -3px #0000001f;border-radius:3px 3px 3px 3px;flex-direction:column;align-items:stretch;display:flex!important;font-size:13px}.pmcc-ms-layer.layer-push{position:relative;top:-2px}.pmcc-ms-layer.layer-push:not(.pmcc-ms-align-right){border-radius:0 3px 3px 3px}.pmcc-ms-layer.layer-push.pmcc-ms-align-right{border-radius:3px 3px 3px 0}.pmcc-ms-layer.layer-push.sm{height:350px}.pmcc-ms-layer.layer-push.md{height:470px}.pmcc-ms-layer.layer-push.lg{height:540px}.pmcc-ms-layer .pmcc-ms-items-section{display:flex;flex:1;min-height:0;width:100%;position:relative;margin:0}.pmcc-ms-layer .pmcc-available-section,.pmcc-ms-layer .pmcc-selected-section{display:flex;flex-direction:column;box-sizing:border-box;width:50%;padding:1em 10px 0 0}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header{position:relative;min-height:33px;margin-bottom:1em;padding-bottom:.5em;font-weight:700;border-bottom:1px solid #ccc}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header.disabled,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header.disabled{height:32px}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header.disabled *,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header.disabled *{visibility:hidden}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header .pmcc-ms-tooltip-info-icon,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header .pmcc-ms-tooltip-info-icon{opacity:.5;margin-left:7px;top:3px;cursor:pointer}.pmcc-ms-layer .pmcc-available-section .pmcc-ms-section-header div.pmcc-ms-section-header-message,.pmcc-ms-layer .pmcc-selected-section .pmcc-ms-section-header div.pmcc-ms-section-header-message{position:relative;padding-top:1em;min-height:27px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search{position:relative;margin-bottom:.25em}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search:after,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search:after{content:\"\";display:table;clear:both}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search.disabled,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search.disabled{height:30px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search.disabled *,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search.disabled *{visibility:hidden}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search span.label,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search span.label{float:left;font-weight:700;line-height:29px;font-size:13px;padding:0}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search input,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search input{float:right;width:77%;border:1px solid #c9c9c9;border-radius:4px;padding:7px}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search input::-ms-clear,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search input::-ms-clear{width:0;height:0}.pmcc-ms-layer .pmcc-available-section .pmcc-input-search span.pmcc-ico-close,.pmcc-ms-layer .pmcc-selected-section .pmcc-input-search span.pmcc-ico-close{position:absolute;top:10px;right:7px;font-size:11px;color:#d8d8d8;cursor:pointer}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list{padding:0;list-style:none}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-nowrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-nowrap li a{white-space:nowrap}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-wrap li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-wrap li a{white-space:normal}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list.pmcc-ms-text-wrap-word-break li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list.pmcc-ms-text-wrap-word-break li a{white-space:normal;word-break:break-all;text-overflow:unset}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li.messaging,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list li.messaging,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list li.messaging,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li.messaging{white-space:normal;color:#666}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li a,.pmcc-ms-layer .pmcc-available-section .pmcc-selected-list li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-available-list li a,.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a{width:100%;overflow:hidden;text-overflow:ellipsis;text-decoration:none}.pmcc-ms-layer .pmcc-available-section{border-top-left-radius:3px;padding-left:1em;border-right:1px solid #ccc}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li.selected{display:none}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li a{display:block;margin:0 0 4px;padding:8px 0;color:#0085cc;border-bottom:1px solid #e7e7e7}.pmcc-ms-layer .pmcc-available-section .pmcc-available-list li:last-child a{border-bottom:none}.pmcc-ms-layer .pmcc-selected-section{border-top-right-radius:3px;padding-left:10px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li{margin:0 13px .5em 0}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a{position:relative;display:block;vertical-align:middle;box-sizing:border-box;padding:8px 30px 7px 6px;color:#666;font-size:13px;background:#f1f1f1;border-radius:3px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a:after{content:\"\";display:table;clear:both;position:absolute;z-index:1;top:0;right:8px;display:flex;justify-content:center;align-items:center;height:100%;padding-left:8px;line-height:31px;border-left:1px solid #fff;font-family:pmcc-ico;content:\"e\";color:#ccc;font-size:9px}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a.unremovable{cursor:default}.pmcc-ms-layer .pmcc-selected-section .pmcc-selected-list li a.unremovable:after{display:none}.pmcc-ms-layer .pmcc-button-bar{padding:1em;border-top:1px solid #e4e4e4}.pmcc-ms-layer .pmcc-button-bar button{margin:0}.pmcc-overlay-pane.pmcc-multiselect-pane.sm{height:350px}.pmcc-overlay-pane.pmcc-multiselect-pane.md{height:470px}.pmcc-overlay-pane.pmcc-multiselect-pane.lg{height:540px}.pmcc-ms-layer-container{height:100%}.pmcc-ms-layer-container.sm{width:470px;max-width:470px}.pmcc-ms-layer-container.md{width:670px;max-width:670px}.pmcc-ms-layer-container.lg{width:870px;max-width:870px}.pmcc-ms-container.layer-push{flex-wrap:wrap}.pmcc-ms-container.layer-push.active.sm{width:470px}.pmcc-ms-container.layer-push.active.md{width:670px}.pmcc-ms-container.layer-push.active.lg{width:870px}.pmcc-available-list,.pmcc-selected-list{justify-content:flex-start;align-items:flex-start;padding-bottom:10px}.pmcc-available-list>.pmcc-table,.pmcc-selected-list>.pmcc-table{border:0!important;width:100%}.pmcc-available-list>.pmcc-table>tbody>tr>td,.pmcc-selected-list>.pmcc-table>tbody>tr>td{border:0!important;cursor:pointer!important;vertical-align:middle!important}.pmcc-available-list>.pmcc-table>tbody>tr>td>div,.pmcc-selected-list>.pmcc-table>tbody>tr>td>div{vertical-align:middle!important}.pmcc-available-list>.pmcc-table>tbody>tr>td.nowrap,.pmcc-selected-list>.pmcc-table>tbody>tr>td.nowrap{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:1px}.pmcc-available-list>.pmcc-table>tbody>tr>td.nowrap>div,.pmcc-selected-list>.pmcc-table>tbody>tr>td.nowrap>div{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.pmcc-available-list>.pmcc-table>tbody>tr>td.wrap,.pmcc-selected-list>.pmcc-table>tbody>tr>td.wrap{white-space:normal}.pmcc-available-list>.pmcc-table>tbody>tr>td.word-break,.pmcc-selected-list>.pmcc-table>tbody>tr>td.word-break{white-space:normal;word-break:break-all}.pmcc-available-list>.pmcc-table{border-top:1em solid #0000}.pmcc-available-list>.pmcc-table thead{background:#fff}.pmcc-available-list>.pmcc-table th{background:#fff;border-left:0!important;border-right:0!important}.pmcc-available-list>.pmcc-table tr.selected{display:none}.pmcc-selected-list>.pmcc-table{border-collapse:initial!important;border-spacing:0 .5em!important}.pmcc-selected-list>.pmcc-table thead{background:#fff}.pmcc-selected-list>.pmcc-table th{background:#fff;border-left:0!important;border-right:0!important}.pmcc-selected-list>.pmcc-table td{padding:8px 6px 7px!important;background:none!important;background:#f1f1f1!important;border-left:1px solid #f1f1f1!important;line-height:normal!important}.pmcc-selected-list>.pmcc-table td:last-child{border-left:2px solid #fff!important}.pmcc-selected-list>.pmcc-table td:first-of-type{border-top-left-radius:3px;border-bottom-left-radius:3px;color:#666}.pmcc-selected-list>.pmcc-table td:last-of-type{display:table-cell;width:37px!important;border-top-right-radius:3px;border-bottom-right-radius:3px;color:#ccc;text-align:center;vertical-align:middle}.pmcc-selected-list>.pmcc-table td:last-of-type .pmcc-ico-close{font-size:9px;font-weight:700}.pmcc-selected-list>.pmcc-table tr:first-of-type td{padding:0}.pmcc-selected-list>.pmcc-table tr:nth-child(n+2) td{margin:5px 0 0}"]
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], idProp: [{
            type: Input
        }], selectedItemsLimit: [{
            type: Input
        }], maxViewableSelectedItems: [{
            type: Input
        }], showClearAll: [{
            type: Input
        }], labelProp: [{
            type: Input
        }], matchesExceedsLimitMessage: [{
            type: Input
        }], noMatchesMessage: [{
            type: Input
        }], selectionLimitMessage: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], minSelectedItems: [{
            type: Input
        }], itemSelected: [{
            type: Output
        }], itemDeselected: [{
            type: Output
        }], selectedAll: [{
            type: Output
        }], clearedAll: [{
            type: Output
        }], multiselectDone: [{
            type: Output
        }], multiselectCanceled: [{
            type: Output
        }], search: [{
            type: ViewChild,
            args: ['search']
        }], disabled: [{
            type: Input
        }], availableItems: [{
            type: Input
        }], itemsPageSize: [{
            type: Input
        }], searchableKeys: [{
            type: Input
        }], availableItemsTemplate: [{
            type: Input
        }], selectedItemsTemplate: [{
            type: Input
        }], searchCallback: [{
            type: Input
        }], maxNumRecordsReturned: [{
            type: Input
        }], instructions: [{
            type: Input
        }], width: [{
            type: Input
        }], layerPositioningPush: [{
            type: Input
        }], onOpen: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], defaultLabel: [{
            type: Input
        }], selectedLabel: [{
            type: Input
        }], selectAllTooltip: [{
            type: Input
        }], selectMsController: [{
            type: ViewChild,
            args: [SelectMsControllerDirective, { static: true }]
        }], availableSectionList: [{
            type: ViewChild,
            args: [AvailableSectionListComponent]
        }], availableSectionTemplate: [{
            type: ViewChild,
            args: [AvailableSectionTemplateComponent]
        }], selectedSectionList: [{
            type: ViewChild,
            args: [SelectedSectionListComponent]
        }], selectedSectionTemplate: [{
            type: ViewChild,
            args: [SelectedSectionTemplateComponent]
        }] }); })();

function hasChildren(group) {
    return !!(group.children && group.children.length);
}
function getFlattenList(list) {
    return list.reduce((acc, item) => {
        acc.push(item);
        if (hasChildren(item)) {
            acc.push(...getFlattenList(item.children));
        }
        return acc;
    }, []);
}
function isGroupSelected(selectedGroups, groupItemList, implicitParentSelection) {
    const result = groupItemList.filter(item => selectedGroups[item.id] === CheckboxState.CHECKED);
    if (groupItemList.length && result.length && result.length === groupItemList.length) {
        return implicitParentSelection ? CheckboxState.CHECKED : CheckboxState.PARTIAL;
    }
    else if (result && result.length > 0) {
        return CheckboxState.PARTIAL;
    }
    return CheckboxState.UNCHECKED;
}
function getRelations(availableItems, relations = {}, parents = []) {
    return availableItems.reduce((acc, item) => {
        acc[item.id] = { children: [], parents };
        if (hasChildren(item)) {
            if (parents.length) {
                parents.forEach(parent => {
                    acc[parent.id].children.push(item);
                });
            }
            return getRelations(item.children, acc, [...parents, item]);
        }
        else {
            parents.forEach((parent) => {
                acc[parent.id].children = [...acc[parent.id].children, item];
            });
            return acc;
        }
    }, relations);
}
function getSelectedItems(availableItems, selectedItems, selectedGroups) {
    return availableItems.reduce((acc, item) => {
        const selectedValue = selectedGroups[item.id] || 0;
        if (selectedValue) {
            if (item.children) {
                const children = getSelectedItems(item.children, selectedItems, selectedGroups);
                acc.push(Object.assign(Object.assign({}, item), { children }));
            }
            else {
                acc.push(item);
            }
        }
        return acc;
    }, []);
}
function isFound(item, query, showItemId) {
    const findByNameCondition = item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    const findByIdCondition = item.id.toString().toLowerCase().indexOf(query.toLowerCase()) > -1;
    return findByNameCondition || (showItemId && findByIdCondition);
}
function deepSearch(list, query, showItemId) {
    return list.reduce((acc, item) => {
        let foundParent = false;
        if (isFound(item, query, showItemId)) {
            acc.push(item);
            foundParent = true;
        }
        if (hasChildren(item)) {
            const searchResults = deepSearch(item.children, query, showItemId);
            if (searchResults.length) {
                /*
                * 3. If searchtext matches a child & doesn't match its parent, only child gets shown in search results.
                * Parent isn't shown in this case.
                * */
                if (!foundParent) {
                    acc.push(...searchResults);
                }
            }
        }
        return acc;
    }, []);
}
const defaultLabels = {
    fieldNoSelectionsText: 'Select Objects',
    fieldSelectionsText: 'Multiple Selected',
    objectPlural: 'Objects',
    objectSingular: 'Object',
};

class MultiselectHierarchicalComponent extends EscapableDirective {
    constructor() {
        super(...arguments);
        this.keyMap = {
            id: 'id',
            label: 'label',
            children: 'children',
        };
        this.showItemId = false;
        this.labels = defaultLabels;
        this.data = [];
        this.selectedData = [];
        this.enableSelectAll = true;
        this.alignRight = false;
        this.width = 200;
        this.textWrap = 'nowrap';
        this.showAvailableItemCount = true;
        this.implicitParentSelection = false;
        this.maxLimitOne = false;
        this.selectedDataChange = new EventEmitter();
        this.active = false;
        this.disabled = false;
        this.availableItems = [];
        this.selectedItems = [];
    }
    get isEscapable() {
        return this.active;
    }
    selectedItemsChange(data) {
        this.selectedDataChange.emit(this.unmap(data));
        this.hide();
    }
    onFocus() {
        this.active = true;
    }
    onClick() {
        this.active = !this.active;
    }
    hide(event) {
        if (event) {
            const clickTarget = event.relatedTarget;
            if (this.active
                && clickTarget
                && !this.el.nativeElement.contains(clickTarget)) {
                this.active = false;
            }
        }
        else {
            this.active = false;
        }
    }
    ngOnChanges() {
        this.availableItems = this.remap(this.data);
        this.selectedItems = this.remap(this.selectedData);
    }
    remap(list) {
        return list.map(item => {
            const childItems = item[this.keyMap.children || 'children'];
            const children = childItems
                ? this.remap(item[this.keyMap.children || 'children'])
                : [];
            return {
                id: item[this.keyMap.id || 'id'],
                label: item[this.keyMap.label || 'label'],
                unremovable: !!item.unremovable,
                children,
            };
        });
    }
    _onEscape(event) {
        this.hide();
    }
    unmap(list) {
        return list.map(item => {
            const object = {};
            object[this.keyMap.id || 'id'] = item.id;
            object[this.keyMap.label || 'label'] = item.label;
            if (item.children) {
                object[this.keyMap.children || 'children'] = this.unmap(item.children);
            }
            return object;
        });
    }
    label(selectedItems, labels) {
        return selectedItems.length
            ? selectedItems.length === 1
                ? `1 ${labels.objectSingular}`
                : `${selectedItems.length} ${labels.objectPlural} Selected`
            : labels.fieldNoSelectionsText;
    }
}
MultiselectHierarchicalComponent.ɵfac = /*@__PURE__*/ function () { let ɵMultiselectHierarchicalComponent_BaseFactory; return function MultiselectHierarchicalComponent_Factory(t) { return (ɵMultiselectHierarchicalComponent_BaseFactory || (ɵMultiselectHierarchicalComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(MultiselectHierarchicalComponent)))(t || MultiselectHierarchicalComponent); }; }();
MultiselectHierarchicalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectHierarchicalComponent, selectors: [["pmcc-multiselect-hierarchical"]], viewQuery: function MultiselectHierarchicalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c54, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, hostVars: 4, hostBindings: function MultiselectHierarchicalComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.active)("disabled", ctx.disabled);
    } }, inputs: { keyMap: "keyMap", showItemId: "showItemId", labels: "labels", data: "data", selectedData: "selectedData", enableSelectAll: "enableSelectAll", alignRight: "alignRight", width: "width", textWrap: "textWrap", showAvailableItemCount: "showAvailableItemCount", implicitParentSelection: "implicitParentSelection", maxLimitOne: "maxLimitOne", disabled: "disabled" }, outputs: { selectedDataChange: "selectedDataChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 9, consts: [[1, "input-wrapper", "pmcc-flex", "pmcc-align-items-center", 3, "ngClass", "mousedown"], ["trigger", ""], ["size", "2x", 3, "name", 4, "ngIf"], ["type", "text", "class", "pmcc-input", "readonly", "", 3, "disabled", "value", "title", "width", "focus", "blur", 4, "ngIf"], ["name", "caret-down", 1, "caret"], ["pmccOverlay", "", 3, "pmccOverlayOpen", "pmccPositionNear", "positionOverride", "pmccOverlayOpenChange"], ["size", "2x", 3, "name"], ["type", "text", "readonly", "", 1, "pmcc-input", 3, "disabled", "value", "title", "focus", "blur"], [3, "textWrap", "availableItems", "selectedItems", "alignRight", "triggerWidth", "showItemId", "labels", "showAvailableItemCount", "enableSelectAll", "implicitParentSelection", "maxLimitOne", "selectedItemsChange", "cancelCallback"], ["el", ""]], template: function MultiselectHierarchicalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("mousedown", function MultiselectHierarchicalComponent_Template_div_mousedown_0_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵtemplate(2, MultiselectHierarchicalComponent_pmcc_icon_2_Template, 1, 1, "pmcc-icon", 2);
        ɵngcc0.ɵɵtemplate(3, MultiselectHierarchicalComponent_input_3_Template, 3, 13, "input", 3);
        ɵngcc0.ɵɵelement(4, "pmcc-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, MultiselectHierarchicalComponent_ng_template_5_Template, 2, 11, "ng-template", 5);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function MultiselectHierarchicalComponent_Template_ng_template_pmccOverlayOpenChange_5_listener($event) { return ctx.active = $event; });
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c55, ctx.disabled, !!ctx.labels.fieldIcon));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.labels.fieldIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.labels.fieldIcon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.active)("pmccPositionNear", _r0)("positionOverride", ctx.alignRight ? "southeast" : "southwest");
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, IconComponent, OverlayDirective, NearPositionDirective, MultiselectHierarchicalListComponent]; }, pipes: function () { return [ApplyPipe]; }, styles: ["[_nghost-%COMP%]{position:relative;display:inline-block;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.disabled[_nghost-%COMP%]{box-shadow:none;cursor:not-allowed;opacity:.5;pointer-events:none}.disabled[_nghost-%COMP%]   .pmcc-caret[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   input[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:baseline;justify-content:space-between;border-radius:3px;background:#fff;border:1px solid #c9c9c9;cursor:pointer}[_nghost-%COMP%]   .input-wrapper.with-icon[_ngcontent-%COMP%]{padding:5px 10px}[_nghost-%COMP%]   .input-wrapper.with-icon[_ngcontent-%COMP%] > .caret[_ngcontent-%COMP%]{margin:0 0 0 2px;text-align:right}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 10px 5px 5px;position:relative;border:0;cursor:pointer;background-color:initial;text-overflow:ellipsis;outline:none;-webkit-user-select:none;user-select:none}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%] > .caret[_ngcontent-%COMP%]:before{color:#787878}.active[_nghost-%COMP%]{z-index:29001}.active[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{border-bottom-right-radius:0;border-bottom-left-radius:0;border:1px solid #c9c9c9;border-bottom-color:#fff}"] });
MultiselectHierarchicalComponent.propDecorators = {
    keyMap: [{ type: Input }],
    showItemId: [{ type: Input }],
    labels: [{ type: Input }],
    data: [{ type: Input }],
    selectedData: [{ type: Input }],
    enableSelectAll: [{ type: Input }],
    alignRight: [{ type: Input }],
    width: [{ type: Input }],
    textWrap: [{ type: Input }],
    showAvailableItemCount: [{ type: Input }],
    implicitParentSelection: [{ type: Input }],
    maxLimitOne: [{ type: Input }],
    el: [{ type: ViewChild, args: ['el', { read: ElementRef },] }],
    selectedDataChange: [{ type: Output }],
    active: [{ type: HostBinding, args: ['class.active',] }],
    disabled: [{ type: HostBinding, args: ['class.disabled',] }, { type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectHierarchicalComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-hierarchical',
                template: "<div class=\"input-wrapper pmcc-flex pmcc-align-items-center\"\n     [ngClass]=\"{'disabled': disabled, 'with-icon': !!labels.fieldIcon}\"\n     (mousedown)=\"onClick()\"\n     #trigger>\n  <pmcc-icon *ngIf=\"labels.fieldIcon\"\n             [name]=\"labels.fieldIcon\"\n             size=\"2x\"\n  ></pmcc-icon>\n  <input *ngIf=\"!labels.fieldIcon\"\n         type=\"text\"\n         class=\"pmcc-input\"\n         [disabled]=\"disabled\"\n         (focus)=\"onFocus()\"\n         (blur)=\"hide($event)\"\n         [value]=\"selectedItems | apply: label: labels\"\n         [title]=\"selectedItems | apply: label: labels\"\n         [style.width.px]=\"width\"\n         readonly>\n  <pmcc-icon name=\"caret-down\" class=\"caret\"></pmcc-icon>\n</div>\n\n<ng-template\n  pmccOverlay\n  [(pmccOverlayOpen)]=\"active\"\n  [pmccPositionNear]=\"trigger\"\n  [positionOverride]=\"alignRight ? 'southeast': 'southwest'\"\n>\n  <pmcc-multiselect-hierarchical-list\n    #el\n    [textWrap]=\"textWrap\"\n    [availableItems]=\"availableItems\"\n    [selectedItems]=\"selectedItems\"\n    [alignRight]=\"alignRight\"\n    [triggerWidth]=\"width\"\n    [showItemId]=\"showItemId\"\n    [labels]=\"labels\"\n    [showAvailableItemCount]=\"showAvailableItemCount\"\n    [enableSelectAll]=\"enableSelectAll\"\n    [implicitParentSelection]=\"implicitParentSelection\"\n    [maxLimitOne]=\"maxLimitOne\"\n    (selectedItemsChange)=\"selectedItemsChange($event)\"\n    (cancelCallback)=\"hide()\">\n  </pmcc-multiselect-hierarchical-list>\n</ng-template>\n\n",
                styles: [":host{position:relative;display:inline-block;font:normal 13px Arial,Helvetica,Calibri,sans-serif}:host.disabled{box-shadow:none;cursor:not-allowed;opacity:.5;pointer-events:none}:host.disabled .pmcc-caret,:host.disabled input{cursor:not-allowed;pointer-events:none}:host .input-wrapper{display:flex;flex-direction:row;align-items:baseline;justify-content:space-between;border-radius:3px;background:#fff;border:1px solid #c9c9c9;cursor:pointer}:host .input-wrapper.with-icon{padding:5px 10px}:host .input-wrapper.with-icon>.caret{margin:0 0 0 2px;text-align:right}:host .input-wrapper input{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:5px 10px 5px 5px;position:relative;border:0;cursor:pointer;background-color:initial;text-overflow:ellipsis;outline:none;-webkit-user-select:none;user-select:none}:host .input-wrapper>.caret:before{color:#787878}:host.active{z-index:29001}:host.active .input-wrapper{border-bottom-right-radius:0;border-bottom-left-radius:0;border:1px solid #c9c9c9;border-bottom-color:#fff}"]
            }]
    }], null, { keyMap: [{
            type: Input
        }], showItemId: [{
            type: Input
        }], labels: [{
            type: Input
        }], data: [{
            type: Input
        }], selectedData: [{
            type: Input
        }], enableSelectAll: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], width: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], showAvailableItemCount: [{
            type: Input
        }], implicitParentSelection: [{
            type: Input
        }], maxLimitOne: [{
            type: Input
        }], selectedDataChange: [{
            type: Output
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }, {
            type: Input
        }], el: [{
            type: ViewChild,
            args: ['el', { read: ElementRef }]
        }] }); })();

class MshDataSource extends DataSource$1 {
    constructor(flatItemList, relations, initial) {
        super();
        this.flatItemList = flatItemList;
        this.relations = relations;
        this.initial = initial;
        this.dataStream = new ReplaySubject(1);
        this.subscription = new Subscription();
        this.cachedData = this.initial;
        this.dataStream.next(this.cachedData);
    }
    connect(collectionViewer) {
        this.subscription.add(collectionViewer.viewChange.subscribe(range => {
            this.range = range;
        }));
        return this.dataStream;
    }
    disconnect() {
        this.subscription.unsubscribe();
    }
    toggle(group, include) {
        const index = this.cachedData.findIndex(currentGroup => group.id === currentGroup.id);
        if (include) {
            this.cachedData.splice(index + 1, 0, ...group.children);
        }
        else {
            this.cachedData = this.cachedData
                .filter(currentGroup => !this.relations[group.id].children.find(item => item.id === currentGroup.id));
        }
        this.dataStream.next(this.cachedData);
    }
}

class MultiselectHierarchicalListComponent {
    constructor() {
        this.showAvailableItemCount = true;
        this.showItemId = false;
        this.labels = defaultLabels;
        this.availableItems = [];
        this.selectedItems = [];
        this.textWrap = 'nowrap';
        this.alignRight = false;
        this.enableSelectAll = true;
        this.implicitParentSelection = false;
        this.maxLimitOne = false;
        this.cancelCallback = new EventEmitter();
        this.selectedItemsChange = new EventEmitter();
        this.requiredData = [];
        this.searchText = '';
        this.flatItemList = [];
        this.relations = {};
        this.onlySelected = false;
        this.itemList = [];
        this.selectedGroups = {};
        this.maxLimitExceeded = false;
        this.nonDisabledItemList = [];
        this.expandedIds = new Set();
    }
    ngOnInit() {
        if (this.selectedItems.length > 0 && this.maxLimitOne) {
            this.maxLimitExceeded = true;
            if (this.selectedItems.length === 1) {
                /* tslint:disable:max-line-length */
                this.nonDisabledItemList = [this.selectedItems[0].id].concat(this.relations[this.selectedItems.slice(-1)[0].id].parents.map(item => item.id));
            }
            else {
                this.nonDisabledItemList = this.relations[this.selectedItems.slice(-1)[0].id].parents.map(item => item.id);
            }
        }
    }
    ngOnChanges() {
        this.relations = getRelations(this.availableItems);
        this.generateLists();
        this.setCheckboxes(this.selectedItems, 1);
    }
    isExpanded(group) {
        return this.expandedIds.has(group.id);
    }
    onSearch(searchText) {
        this.searchText = searchText;
        this.expandedIds.clear();
        this.generateLists();
    }
    selectAll(value) {
        if (value) {
            this.selectedItems = [
                ...this.flatItemList
            ];
            this.setCheckboxes(this.selectedItems, CheckboxState.CHECKED);
        }
        else {
            if (!this.requiredData.length) {
                /*
                * This filtering is doubtfull
                * TODO: Need to verify this filtering
                */
                this.selectedItems = this.selectedItems
                    .filter(currentItem => !this.flatItemList.find(item => item.id === currentItem.id));
                this.setCheckboxes(this.selectedItems, CheckboxState.UNCHECKED);
                /*
                * this.selectedItems = [], when no selected items
                * setCheckboxes funtion needs list to set their states
                * this.flatItemList has data for which the state needs to be set UNCHECKED
                * Therefore, pass this.flatItemList to setCheckboxes method with CheckboxState.UNCHECKED
                */
                /* istanbul ignore next */
                if (this.selectedItems.length === 0) {
                    this.setCheckboxes(this.flatItemList, CheckboxState.UNCHECKED);
                }
            }
            else {
                this.selectedItems = this.flatItemList.filter(item => this.requiredData.indexOf(String(item.id)) > -1);
                const itemsToUncheck = this.flatItemList.filter(item => this.requiredData.indexOf(String(item.id)) === -1);
                this.setCheckboxes(itemsToUncheck, CheckboxState.UNCHECKED);
            }
        }
    }
    toggleSelectedState() {
        /*
        * If user clicks "View selected", only selected items (with their existing parent-child relationship & state)
        * should be shown in viewport.
        * While in "View Selected" mode, unselecting an item should remove it from this view.
        * With this, it becomes easy for the user to view only selected items.
        * Partially selected parents shouldn't appear in the selected items model.
        */
        this.searchText = '';
        this.onlySelected = !this.onlySelected;
        this.generateLists();
    }
    cancel() {
        this.cancelCallback.emit();
    }
    done() {
        this.selectedItemsChange.emit(this.selectedItems);
    }
    /*
    * while in "View Selected" mode, if user unswitches last selected item from selection list
    * (leaving no more selected items), view mode should automatically switch to "View All"
    */
    // tslint:disable-next-line: cyclomatic-complexity
    onSelectedItemsChange({ value, group }) {
        const items = hasChildren(group) ? [group, ...this.relations[group.id].children] : [group];
        if (value) {
            if (this.maxLimitOne) {
                const parentIds = this.relations[group.id].parents.map(item => item.id);
                if ((items.length === 1 && this.selectedItems.length === 0) || (hasChildren(group) && this.selectedItems.length === 0)) {
                    this.selectedItems = [...this.selectedItems, ...items];
                    this.nonDisabledItemList = [...parentIds, items[0].id];
                }
                this.maxLimitExceeded = true;
            }
            else {
                this.selectedItems = [...this.selectedItems, ...items];
            }
        }
        else {
            this.selectedItems = this.selectedItems.filter(currentItem => !items.find(groupItem => groupItem.id === currentItem.id));
            if (this.selectedItems.length === 0) {
                this.nonDisabledItemList = [];
                this.maxLimitExceeded = false;
            }
        }
        if (!this.selectedItems.length && this.onlySelected) {
            this.onlySelected = false;
        }
        items.forEach(currentGroup => {
            this.selectedGroups[currentGroup.id] = value;
        });
        this.checkParentSelection(group);
        this.generateLists();
    }
    isAllSelected(selectedItems, flatItemList, requiredData) {
        return selectedItems.length > 0
            ? (selectedItems.length === flatItemList.length
                ? CheckboxState.CHECKED
                : requiredData.length && requiredData.length === selectedItems.length ? CheckboxState.UNCHECKED : CheckboxState.PARTIAL)
            : CheckboxState.UNCHECKED;
    }
    isShown(group) {
        return this.relations[group.id].parents.length
            ? this.relations[group.id].parents.every(parent => {
                return this.expandedIds.has(parent.id);
            })
            : true;
    }
    toggle(group) {
        const include = !this.expandedIds.has(group.id);
        this.ds.toggle(group, include);
        if (include) {
            this.expandedIds.add(group.id);
        }
        else {
            this.expandedIds.delete(group.id);
            this.relations[group.id].children.forEach(child => this.expandedIds.delete(child.id));
        }
    }
    trackByFn(_, group) {
        return group.id;
    }
    checkParentSelection(group) {
        const parentItems = this.relations[group.id].parents;
        parentItems.forEach(parent => {
            this.selectedGroups[parent.id] = isGroupSelected(this.selectedGroups, this.relations[parent.id].children, this.implicitParentSelection);
            if (this.implicitParentSelection && this.selectedGroups[parent.id] === CheckboxState.CHECKED) {
                // push immediate parent `selectedItems` for `implicitParentSelection`
                this.selectedItems.push(parent);
                /**
                 * Let A be parent of B
                 * If all children of A are selected and then all children of B are selected
                 * then A must also get implicitly selected with B.
                 */
                this.checkParentSelection(parent);
            }
            else {
                /**
                 * As a child or children cannot be marked `unremovable`,
                 * currently we are not checking for the condition of `unremovable` when removing parents.
                 *
                 * If children could also be marked unremovable then the condition could be like :
                 * Verify this thoroughly before using this condition because the scope could be
                 * differnet with `implicitParentSelection`
                 *
                 * this.selectedItems = this.selectedItems.filter(item => item.id !== parent.id && !item.unremovable);
                 */
                // remove parent
                this.selectedItems = this.selectedItems.filter(item => item.id !== parent.id);
            }
        });
    }
    generateLists() {
        this.requiredData = this.availableItems.filter(_ => _.unremovable).map(_ => String(_.id));
        this.itemList = this.filteredAvailableItems();
        this.flatItemList = getFlattenList(this.itemList);
        if (this.searchText.length || this.onlySelected) {
            /**
             * While searching or while in 'View Selected', by default,
             * expand all the parent nodes from the filtered list.
             * All the other nodes should be in collapsed state.
            */
            this.expandedIds.clear();
            this.expandParentNodes(this.itemList);
        }
        this.ds = new MshDataSource(this.flatItemList, this.relations, !!this.searchText
            ? this.flatItemList
            : this.flatItemList.filter(item => this.isShown(item)));
    }
    /**
     * This function will expand all the parent nodes.
     * All intermediate child nodes of such parent nodes are also expanded.
    */
    expandParentNodes(list) {
        list.forEach(item => {
            if (hasChildren(item)) {
                this.expandedIds.add(item.id);
                this.expandParentNodes(item.children);
            }
        });
    }
    filteredAvailableItems() {
        if (this.searchText.length) {
            return deepSearch(this.availableItems, this.searchText, this.showItemId);
        }
        return this.onlySelected
            ? getSelectedItems(this.availableItems, this.selectedItems, this.selectedGroups)
            : this.availableItems;
    }
    setCheckboxes(items, value) {
        // initial selection to elements existing in model = selectedItems
        items.forEach(group => {
            this.selectedGroups[group.id] = value;
        });
        // set their parent state depending on theirs existence
        items.forEach(group => {
            this.relations[group.id].parents.forEach(parent => {
                if (!this.selectedGroups[parent.id]) {
                    this.selectedGroups[parent.id] = isGroupSelected(this.selectedGroups, this.relations[parent.id].children, this.implicitParentSelection);
                }
            });
        });
    }
}
MultiselectHierarchicalListComponent.ɵfac = function MultiselectHierarchicalListComponent_Factory(t) { return new (t || MultiselectHierarchicalListComponent)(); };
MultiselectHierarchicalListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectHierarchicalListComponent, selectors: [["pmcc-multiselect-hierarchical-list"]], inputs: { showAvailableItemCount: "showAvailableItemCount", showItemId: "showItemId", labels: "labels", availableItems: "availableItems", selectedItems: "selectedItems", textWrap: "textWrap", alignRight: "alignRight", enableSelectAll: "enableSelectAll", implicitParentSelection: "implicitParentSelection", maxLimitOne: "maxLimitOne", triggerWidth: "triggerWidth" }, outputs: { cancelCallback: "cancelCallback", selectedItemsChange: "selectedItemsChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 17, vars: 9, consts: [[1, "top-border"], [1, "search-bar", 3, "ngClass"], [1, "label"], ["pmccClear", "", "fullWidth", ""], ["pmccInput", "", "type", "text", 3, "ngModel", "ngModelChange"], ["class", "result-bar", 3, "ngClass", 4, "ngIf"], ["class", "list", 4, "ngIf"], ["class", "no-match-message", 4, "ngIf"], [1, "button-bar"], ["pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", 3, "click"], [1, "pmcc-right"], ["type", "button", "pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", 1, "toggle-button", 3, "disabled", "textContent", "click"], ["type", "button", "pmccButton", "", "pmccSize", "md", 3, "click"], [1, "result-bar", 3, "ngClass"], [3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "ngIf"], [3, "ngModel", "ngModelChange"], [1, "list"], [1, "list", 3, "itemSize"], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplateCacheSize"], [3, "group", "maxLimitExceeded", "maxLimitOne", "notToBeDisabled", "requiredData", "expanded", "level", "showItemId", "selectedGroups", "toggle", "selectedItemsChange"], [1, "no-match-message"], [1, "pmcc-ico-info", "pmcc-ico-6x"], [3, "textContent"]], template: function MultiselectHierarchicalListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "Search:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "pmcc-input", 3);
        ɵngcc0.ɵɵelementStart(5, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function MultiselectHierarchicalListComponent_Template_input_ngModelChange_5_listener($event) { return ctx.onSearch($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, MultiselectHierarchicalListComponent_div_6_Template, 4, 6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, MultiselectHierarchicalListComponent_ul_7_Template, 3, 4, "ul", 6);
        ɵngcc0.ɵɵtemplate(8, MultiselectHierarchicalListComponent_div_8_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "button", 9);
        ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalListComponent_Template_button_click_10_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(11, " Cancel ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span", 10);
        ɵngcc0.ɵɵelementStart(13, "button", 11);
        ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalListComponent_Template_button_click_13_listener() { return ctx.toggleSelectedState(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, " \u00A0 ");
        ɵngcc0.ɵɵelementStart(15, "button", 12);
        ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalListComponent_Template_button_click_15_listener() { return ctx.done(); });
        ɵngcc0.ɵɵtext(16, " OK ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c57, !ctx.enableSelectAll));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableSelectAll || ctx.showAvailableItemCount);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.flatItemList.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.availableItems.length && ctx.searchText.length);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", !ctx.selectedItems.length)("textContent", ctx.onlySelected ? "View All" : "View Selected");
    } }, directives: function () { return [ɵngcc1.NgClass, InputComponent, InputDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgIf, ButtonDirective, CheckboxComponent, ɵngcc5.CdkVirtualScrollViewport, ɵngcc5.CdkFixedSizeVirtualScroll, ɵngcc5.CdkVirtualForOf, MultiselectHierarchicalItemComponent]; }, pipes: function () { return [ApplyPipe]; }, styles: ["[_nghost-%COMP%]{position:relative;top:-1px;border:1px solid #c9c9c9;border-top:none;background-color:#fff;border-bottom-right-radius:3px;border-bottom-left-radius:3px;width:280px}[_nghost-%COMP%]   .top-border[_ngcontent-%COMP%]{height:1px;width:100%;background-color:#c9c9c9}[_nghost-%COMP%]   .result-bar[_ngcontent-%COMP%]{position:relative;padding:9px 15px;background-color:#f5f5f5;border-top:1px solid #c9c9c9;border-bottom:1px solid #c9c9c9;box-shadow:0 2px 8px #0000001f;height:34px}[_nghost-%COMP%]   .result-bar[_ngcontent-%COMP%]   pmcc-checkbox[_ngcontent-%COMP%]{margin-right:5px}[_nghost-%COMP%]   .hide-result-bar[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   .search-bar[_ngcontent-%COMP%]{display:flex;padding:9px 15px}[_nghost-%COMP%]   .search-bar[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;line-height:29px;font-size:13px;padding:0;margin-right:10px}[_nghost-%COMP%]   .show-search-border[_ngcontent-%COMP%]{border-bottom:1px solid #e7e7e7}[_nghost-%COMP%]   ul.list[_ngcontent-%COMP%]{background:#fff;max-height:244px;overflow-x:hidden;overflow-y:auto;padding:0;margin:0;list-style:none}[_nghost-%COMP%]   ul.list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]{height:244px;overflow-x:hidden;overflow-y:auto}[_nghost-%COMP%]   ul.list.wrap[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:normal}[_nghost-%COMP%]   ul.list.nowrap[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:nowrap}[_nghost-%COMP%]   ul.list.word-break[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:normal;word-break:break-all}[_nghost-%COMP%]   .loading[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-flow:column;height:300px}[_nghost-%COMP%]   .loading[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin:10px}[_nghost-%COMP%]   .max-row-exceeded[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]{color:#c4c4c4}[_nghost-%COMP%]   .button-bar[_ngcontent-%COMP%]{background:#fff;border-top:1px solid #dcdbdb;padding:10px;box-shadow:0 2px 8px #0000001f}[_nghost-%COMP%]   .button-bar[_ngcontent-%COMP%]   .toggle-button[_ngcontent-%COMP%]{min-width:100px}[_nghost-%COMP%]   .button-bar[_ngcontent-%COMP%] > .pmcc-right[_ngcontent-%COMP%]{float:right}[_nghost-%COMP%]   .button-bar[_ngcontent-%COMP%] > .pmcc-right[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:5px}"] });
MultiselectHierarchicalListComponent.propDecorators = {
    showAvailableItemCount: [{ type: Input }],
    showItemId: [{ type: Input }],
    labels: [{ type: Input }],
    availableItems: [{ type: Input }],
    selectedItems: [{ type: Input }],
    textWrap: [{ type: Input }],
    triggerWidth: [{ type: Input }],
    alignRight: [{ type: Input }],
    enableSelectAll: [{ type: Input }],
    implicitParentSelection: [{ type: Input }],
    maxLimitOne: [{ type: Input }],
    cancelCallback: [{ type: Output }],
    selectedItemsChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectHierarchicalListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-hierarchical-list',
                template: "<div class=\"top-border\"></div>\n<div class=\"search-bar\" \n  [ngClass]=\"{'show-search-border':!enableSelectAll}\">\n  <span class=\"label\">Search:</span>\n  <pmcc-input\n    pmccClear\n    fullWidth>\n    <input\n      pmccInput\n      type=\"text\"\n      [ngModel]=\"searchText\"\n      (ngModelChange)=\"onSearch($event)\"/>\n  </pmcc-input>\n</div>\n\n<div class=\"result-bar\"\n     *ngIf=\"enableSelectAll || showAvailableItemCount\"\n     [ngClass]=\"{'hide-result-bar': !enableSelectAll }\">\n  <pmcc-checkbox\n    *ngIf=\"!onlySelected && enableSelectAll && !searchText.length\"\n    [ngModel]=\"selectedItems | apply : isAllSelected: flatItemList : requiredData\"\n    (ngModelChange)=\"selectAll($event)\"></pmcc-checkbox>\n  <ng-template [ngIf]=\"!onlySelected && showAvailableItemCount\">\n    Select All ({{ flatItemList.length }})\n  </ng-template>\n  <ng-template [ngIf]=\"onlySelected\">\n    {{selectedItems.length}} {{(selectedItems.length > 1) ? labels.objectPlural : labels.objectSingular}} Selected\n  </ng-template>\n</div>\n\n<ul class=\"list\"\n    *ngIf=\"flatItemList.length\">\n  <cdk-virtual-scroll-viewport\n    class=\"list\"\n    [itemSize]=\"35\"\n  >\n    <ng-container *cdkVirtualFor=\"let group of ds; trackBy: trackByFn;templateCacheSize: 0\">\n      <pmcc-multiselect-hierarchical-item\n        [group]=\"group\"\n        [maxLimitExceeded]=\"maxLimitExceeded\"\n        [maxLimitOne]=\"maxLimitOne\"\n        [notToBeDisabled]=\"nonDisabledItemList\"\n        [requiredData]=\"requiredData\"\n        [expanded]=\"isExpanded(group)\"\n        (toggle)=\"toggle(group)\"\n        [level]=\"group ? relations[group.id].parents.length : 0\"\n        [showItemId]=\"showItemId\"\n        [selectedGroups]=\"selectedGroups\"\n        (selectedItemsChange)=\"onSelectedItemsChange($event)\"\n      ></pmcc-multiselect-hierarchical-item>\n    </ng-container>\n  </cdk-virtual-scroll-viewport>\n</ul>\n\n<div class=\"no-match-message\"\n     *ngIf=\"!availableItems.length && searchText.length\">\n  <span class=\"pmcc-ico-info pmcc-ico-6x\"></span>\n  <div [textContent]=\"'0 ' + labels.objectPlural + ' Found'\"></div>\n</div>\n\n<div class=\"button-bar\">\n  <button pmccButton pmccVariant=\"secondary\" pmccSize=\"md\" (click)=\"cancel()\">\n    Cancel\n  </button>\n  <span class=\"pmcc-right\">\n    <button\n      type=\"button\"\n      pmccButton\n      pmccVariant=\"secondary\"\n      pmccSize=\"md\"\n      class=\"toggle-button\"\n      (click)=\"toggleSelectedState()\"\n      [disabled]=\"!selectedItems.length\"\n      [textContent]=\"onlySelected ? 'View All' : 'View Selected'\"\n    ></button>\n    &nbsp;\n    <button type=\"button\" pmccButton pmccSize=\"md\" (click)=\"done()\">\n      OK\n    </button>\n  </span>\n</div>\n",
                styles: [":host{position:relative;top:-1px;border:1px solid #c9c9c9;border-top:none;background-color:#fff;border-bottom-right-radius:3px;border-bottom-left-radius:3px;width:280px}:host .top-border{height:1px;width:100%;background-color:#c9c9c9}:host .result-bar{position:relative;padding:9px 15px;background-color:#f5f5f5;border-top:1px solid #c9c9c9;border-bottom:1px solid #c9c9c9;box-shadow:0 2px 8px #0000001f;height:34px}:host .result-bar pmcc-checkbox{margin-right:5px}:host .hide-result-bar{display:none}:host .search-bar{display:flex;padding:9px 15px}:host .search-bar .label{font-weight:700;line-height:29px;font-size:13px;padding:0;margin-right:10px}:host .show-search-border{border-bottom:1px solid #e7e7e7}:host ul.list{background:#fff;max-height:244px;overflow-x:hidden;overflow-y:auto;padding:0;margin:0;list-style:none}:host ul.list .list{height:244px;overflow-x:hidden;overflow-y:auto}:host ul.list.wrap li span{white-space:normal}:host ul.list.nowrap li span{white-space:nowrap}:host ul.list.word-break li span{white-space:normal;word-break:break-all}:host .loading,:host .no-match-message{display:flex;align-items:center;justify-content:center;flex-flow:column;height:300px}:host .loading span,:host .no-match-message span{margin:10px}:host .max-row-exceeded,:host .no-match-message{color:#c4c4c4}:host .button-bar{background:#fff;border-top:1px solid #dcdbdb;padding:10px;box-shadow:0 2px 8px #0000001f}:host .button-bar .toggle-button{min-width:100px}:host .button-bar>.pmcc-right{float:right}:host .button-bar>.pmcc-right button+button{margin-left:5px}"]
            }]
    }], function () { return []; }, { showAvailableItemCount: [{
            type: Input
        }], showItemId: [{
            type: Input
        }], labels: [{
            type: Input
        }], availableItems: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], enableSelectAll: [{
            type: Input
        }], implicitParentSelection: [{
            type: Input
        }], maxLimitOne: [{
            type: Input
        }], cancelCallback: [{
            type: Output
        }], selectedItemsChange: [{
            type: Output
        }], triggerWidth: [{
            type: Input
        }] }); })();

class MultiselectHierarchicalItemComponent {
    constructor() {
        this.requiredData = [];
        this.showItemId = false;
        this.level = 0;
        this.expanded = false;
        this.maxLimitOne = false;
        this.maxLimitExceeded = false;
        this.selectedItemsChange = new EventEmitter();
        this.toggle = new EventEmitter();
        this.levels = [];
        this.isDisabled = function (requiredData, id, maxLimitOne, maxLimitExceeded, idNotToBeDisabled) {
            return requiredData.indexOf(id) > -1 || (maxLimitOne && maxLimitExceeded && !idNotToBeDisabled.includes(id));
        };
    }
    ngOnChanges() {
        this.levels = new Array(this.level);
    }
    switchGroup(value) {
        this.selectedItemsChange.emit({ value, group: this.group });
    }
    hasChildren(group) {
        return hasChildren(group);
    }
    doToggle(event) {
        // On deselect item it may be removed from DOM (clickOutside triggers and closes the popped list)
        event.stopPropagation();
        if (hasChildren(this.group)) {
            this.toggle.emit();
        }
        else {
            this.switchGroup(this.selectedGroups[this.group.id] ? 0 : 1);
        }
    }
    title(group, showItemId = false) {
        return showItemId ? '(' + group.id + ') ' + group.label : group.label;
    }
}
MultiselectHierarchicalItemComponent.ɵfac = function MultiselectHierarchicalItemComponent_Factory(t) { return new (t || MultiselectHierarchicalItemComponent)(); };
MultiselectHierarchicalItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectHierarchicalItemComponent, selectors: [["pmcc-multiselect-hierarchical-item"]], inputs: { requiredData: "requiredData", showItemId: "showItemId", level: "level", expanded: "expanded", maxLimitOne: "maxLimitOne", maxLimitExceeded: "maxLimitExceeded", selectedGroups: "selectedGroups", group: "group", notToBeDisabled: "notToBeDisabled" }, outputs: { selectedItemsChange: "selectedItemsChange", toggle: "toggle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 53, consts: [[3, "ngClass"], [3, "ngModel", "disabled", "ngModelChange"], ["class", "pmcc-ico-empty", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click", 4, "ngIf"], [1, "pmcc-truncate", 3, "ngClass", "textContent", "title", "click"], [1, "pmcc-ico-empty", 3, "ngClass", "click"], [3, "ngClass", "click"]], template: function MultiselectHierarchicalItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵpipe(1, "apply");
        ɵngcc0.ɵɵelementStart(2, "pmcc-checkbox", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function MultiselectHierarchicalItemComponent_Template_pmcc_checkbox_ngModelChange_2_listener($event) { return ctx.switchGroup($event); });
        ɵngcc0.ɵɵpipe(3, "apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, MultiselectHierarchicalItemComponent_i_4_Template, 2, 17, "i", 2);
        ɵngcc0.ɵɵtemplate(5, MultiselectHierarchicalItemComponent_i_5_Template, 1, 4, "i", 3);
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵlistener("click", function MultiselectHierarchicalItemComponent_Template_span_click_6_listener($event) { return ctx.doToggle($event); });
        ɵngcc0.ɵɵpipe(7, "apply");
        ɵngcc0.ɵɵpipe(8, "apply");
        ɵngcc0.ɵɵpipe(9, "apply");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(34, _c60, ctx.hasChildren(ctx.group), ɵngcc0.ɵɵpipeBind3(1, 8, ctx.requiredData, ctx.isDisabled, ctx.group.id)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.selectedGroups[ctx.group.id] || 0)("disabled", ɵngcc0.ɵɵpipeBindV(3, 12, ɵngcc0.ɵɵpureFunction6(37, _c58, ctx.requiredData, ctx.isDisabled, ctx.group.id, ctx.maxLimitOne, ctx.maxLimitExceeded, ctx.notToBeDisabled)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.levels);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasChildren(ctx.group));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(51, _c4, ɵngcc0.ɵɵpipeBindV(7, 19, ɵngcc0.ɵɵpureFunction6(44, _c58, ctx.requiredData, ctx.isDisabled, ctx.group.id, ctx.maxLimitOne, ctx.maxLimitExceeded, ctx.notToBeDisabled))))("textContent", ɵngcc0.ɵɵpipeBind3(8, 26, ctx.group, ctx.title, ctx.showItemId))("title", ɵngcc0.ɵɵpipeBind3(9, 30, ctx.group, ctx.title, ctx.showItemId));
    } }, directives: [ɵngcc1.NgClass, CheckboxComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgForOf, ɵngcc1.NgIf], pipes: [ApplyPipe], styles: ["[_nghost-%COMP%]   pmcc-checkbox[_ngcontent-%COMP%]{margin-right:10px}[_nghost-%COMP%]   li[_ngcontent-%COMP%]{display:flex;padding:9px 15px;border-bottom:1px solid #e7e7e7}[_nghost-%COMP%]   li[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]   li[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{color:#8b8b8b}[_nghost-%COMP%]   li.has-children[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#0085cc}[_nghost-%COMP%]   li[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#3a3939}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}"] });
MultiselectHierarchicalItemComponent.propDecorators = {
    requiredData: [{ type: Input }],
    showItemId: [{ type: Input }],
    selectedGroups: [{ type: Input }],
    level: [{ type: Input }],
    expanded: [{ type: Input }],
    group: [{ type: Input }],
    maxLimitOne: [{ type: Input }],
    maxLimitExceeded: [{ type: Input }],
    notToBeDisabled: [{ type: Input }],
    selectedItemsChange: [{ type: Output }],
    toggle: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectHierarchicalItemComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-hierarchical-item',
                template: "<li [ngClass]=\"{'has-children': hasChildren(group), 'disabled':requiredData | apply: isDisabled : group.id}\">\n  <pmcc-checkbox\n    [ngModel]=\"selectedGroups[group.id] || 0\"\n    [disabled]=\"requiredData | apply: isDisabled : group.id: maxLimitOne: maxLimitExceeded: notToBeDisabled\"\n    (ngModelChange)=\"switchGroup($event)\">\n  </pmcc-checkbox>\n\n  <i class=\"pmcc-ico-empty\"\n     [ngClass]=\"{'disabled':requiredData | apply: isDisabled : group.id : maxLimitOne: maxLimitExceeded: notToBeDisabled}\"\n     (click)=\"doToggle($event)\"\n     *ngFor=\"let i of levels\">\n  </i>\n\n  <i *ngIf=\"hasChildren(group)\"\n     (click)=\"doToggle($event)\"\n     [ngClass]=\"{\n       'pmcc-ico-caret-right': !expanded,\n       'pmcc-ico-caret-down': expanded\n     }\"></i>\n\n  <span class=\"pmcc-truncate\"\n        [ngClass]=\"{'disabled':requiredData | apply: isDisabled : group.id : maxLimitOne: maxLimitExceeded: notToBeDisabled}\"\n        (click)=\"doToggle($event)\"\n        [textContent]=\"group | apply: title: showItemId\"\n        [title]=\"group | apply: title: showItemId\">\n  </span>\n</li>\n",
                styles: [":host pmcc-checkbox{margin-right:10px}:host li{display:flex;padding:9px 15px;border-bottom:1px solid #e7e7e7}:host li>*{cursor:pointer}:host li>i{color:#8b8b8b}:host li.has-children>span{color:#0085cc}:host li>span{color:#3a3939}:host .disabled{pointer-events:none;opacity:.6}"]
            }]
    }], function () { return []; }, { requiredData: [{
            type: Input
        }], showItemId: [{
            type: Input
        }], level: [{
            type: Input
        }], expanded: [{
            type: Input
        }], maxLimitOne: [{
            type: Input
        }], maxLimitExceeded: [{
            type: Input
        }], selectedItemsChange: [{
            type: Output
        }], toggle: [{
            type: Output
        }], selectedGroups: [{
            type: Input
        }], group: [{
            type: Input
        }], notToBeDisabled: [{
            type: Input
        }] }); })();

const COMPONENTS = [
    MultiselectHierarchicalComponent,
    MultiselectHierarchicalListComponent,
    MultiselectHierarchicalItemComponent,
];
class MultiselectHierarchicalModule {
}
MultiselectHierarchicalModule.ɵfac = function MultiselectHierarchicalModule_Factory(t) { return new (t || MultiselectHierarchicalModule)(); };
MultiselectHierarchicalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MultiselectHierarchicalModule });
MultiselectHierarchicalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            InputModule,
            CheckboxModule,
            UtilsModule,
            ScrollingModule,
            LayoutModule,
            ButtonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectHierarchicalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...COMPONENTS,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    InputModule,
                    CheckboxModule,
                    UtilsModule,
                    ScrollingModule,
                    LayoutModule,
                    ButtonModule,
                    IconModule
                ],
                exports: [
                    ...COMPONENTS,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultiselectHierarchicalModule, { declarations: function () { return [MultiselectHierarchicalComponent, MultiselectHierarchicalListComponent, MultiselectHierarchicalItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule, InputModule, CheckboxModule, UtilsModule, ScrollingModule, LayoutModule, ButtonModule, IconModule]; }, exports: function () { return [MultiselectHierarchicalComponent, MultiselectHierarchicalListComponent, MultiselectHierarchicalItemComponent]; } }); })();

function byId(item) {
    return (i) => i.id === item.id;
}
function changeIs(change, expected) {
    return change === expected || change === 3 /* Both */;
}
/**
 * Data source for multiselect that handles selection and deselection of items
 * between available and selected.
 */
class MultiselectDataSource {
    constructor(available, initialSelected) {
        this._availableFilter = '';
        this._selectedFilter = '';
        // to be used with | async
        this.available$ = new Subject();
        this.selected$ = new Subject();
        // to be used with | async
        this.filteredAvailable$ = new BehaviorSubject([]);
        this.filteredSelected$ = new BehaviorSubject([]);
        this.allItems = available;
        this.selectedItems = initialSelected.filter(item => this.allItems.find(byId(item)));
        this.setAvailableItems();
        this.filteredAvailableItems = this.availableItems;
        this.filteredSelectedItems = this.selectedItems;
        this.available$.next(this.availableItems);
        this.selected$.next(this.selectedItems);
        this.filteredAvailable$.next(this.availableItems);
        this.filteredSelected$.next(this.selectedItems);
        this.applyFilters();
    }
    get selected() {
        return this.selectedItems;
    }
    get availableObservable() {
        return this.available$;
    }
    get selectedObservable() {
        return this.selected$;
    }
    get filteredAvailableObservable() {
        return this.filteredAvailable$;
    }
    get filteredSelectedObservable() {
        return this.filteredSelected$;
    }
    get availableFilter() {
        return this._availableFilter;
    }
    get selectedFilter() {
        return this._selectedFilter;
    }
    select(item) {
        const index = this.availableItems.findIndex(byId(item));
        if (index !== -1) {
            this.selectedItems.push(this.availableItems[index]);
            this.availableItems.splice(index, 1);
            this.applyChanges(3 /* Both */, 3 /* Both */);
        }
    }
    deselect(item) {
        const index = this.selectedItems.findIndex(byId(item));
        if (index !== -1) {
            this.availableItems = this.allItems.filter(i => this.availableItems.find(byId(i)) || i.id === item.id);
            this.selectedItems.splice(index, 1);
            this.applyChanges(3 /* Both */, 3 /* Both */);
        }
    }
    selectAll() {
        this.selectedItems = this.selectedItems.concat(this.filteredAvailable$.value);
        this.availableItems = this.availableItems.filter(item => !this.filteredAvailable$.value.find(byId(item)));
        this.applyChanges(3 /* Both */, 3 /* Both */);
    }
    deselectAll() {
        this.availableItems = this.availableItems.concat(this.filteredSelected$.value);
        this.selectedItems = this.selectedItems.filter(item => !this.filteredSelected$.value.find(byId(item)));
        this.applyChanges(3 /* Both */, 3 /* Both */);
    }
    filterAvailable(query) {
        this._availableFilter = query.toLowerCase();
        this.applyChanges(0 /* None */, 1 /* Available */);
    }
    filterSelected(query) {
        this._selectedFilter = query.toLowerCase();
        this.applyChanges(0 /* None */, 2 /* Selected */);
    }
    updateAvailableItems(available) {
        this.allItems = available;
        this.setAvailableItems();
        this.applyChanges(0 /* None */, 1 /* Available */);
    }
    updateSelectedItems(selected) {
        this.setSelectedItems(selected);
        this.setAvailableItems();
        // We don't want to emit selectedItemsChange here
        // because it would result in the data source
        // emitting selectedItemsChange right after you updateSelectedItems.
        // We want it to emit only when selected items were changed
        // as a result of selecting/deselecting items.
        this.applyChanges(1 /* Available */, 3 /* Both */);
    }
    dispose() {
        this.available$.complete();
        this.selected$.complete();
    }
    applyFilters() {
        const selected = this.selectedItems;
        if (this._selectedFilter) {
            this.filteredSelectedItems = selected.filter(item => item.name.toLowerCase().includes(this._selectedFilter));
        }
        else {
            this.filteredSelectedItems = selected;
        }
        this.filteredAvailableItems = this.availableItems.filter(item => this.selectedItems.indexOf(item) === -1 &&
            item.name.toLowerCase().includes(this._availableFilter));
    }
    applyChanges(itemsChange, filteredItemsChange) {
        this.applyFilters();
        this.emitChanges(itemsChange, filteredItemsChange);
    }
    emitChanges(itemsChange, filteredItemsChange) {
        if (changeIs(itemsChange, 1 /* Available */)) {
            this.available$.next(this.availableItems);
        }
        if (changeIs(filteredItemsChange, 1 /* Available */)) {
            this.filteredAvailable$.next(this.filteredAvailableItems);
        }
        if (changeIs(itemsChange, 2 /* Selected */)) {
            this.selected$.next(this.selectedItems);
        }
        if (changeIs(filteredItemsChange, 2 /* Selected */)) {
            this.filteredSelected$.next(this.filteredSelectedItems);
        }
    }
    setAvailableItems() {
        this.availableItems = this.allItems.filter(item => !this.selectedItems.find(byId(item)));
    }
    setSelectedItems(selected) {
        this.selectedItems = selected.filter(item => this.allItems.find(byId(item)));
    }
}

/**
 * Demo example
 * <example-url>/demo/#/pmcc/multiselect-inline</example-url>
 */
class MultiselectInlineComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this._ds = new MultiselectDataSource([], []);
        this._maxSelectedItems = 0;
        /**
         * Wrapping style to apply to labels within the available and selected items.
         */
        this.textWrap = 'nowrap';
        /**
         * Lists height.
         */
        this.height = '262px';
        /**
         * Show loader while searching
         */
        this.showLoading = false;
        /**
         * To facilitate the two-way binding for the `selectedItems` input.
         */
        this.selectedItemsChange = new EventEmitter();
        /**
         * To delegate available items search.
         * TODO: rename this to searchAvailable in next major version release
         */
        this.search = new EventEmitter();
        /**
         * To delegate selected items search.
         */
        this.searchSelected = new EventEmitter();
        /**
         * Emitted when "Select All" was clicked.
         */
        this.allSelected = new EventEmitter();
        /**
         * Emitted when "Clear All" was clicked.
         */
        this.allCleared = new EventEmitter();
        this.selectItem = this.selectItem.bind(this);
        this.deselectItem = this.deselectItem.bind(this);
    }
    /**
     * Items that user can select.
     */
    set availableItems(value) {
        this._ds.updateAvailableItems(value);
    }
    /**
     * Items that have already been selected.
     */
    get selectedItems() {
        return this._ds.selected;
    }
    set selectedItems(value) {
        this._ds.updateSelectedItems(value);
    }
    /**
     * Limits the total number of items that may be selected.
     */
    get maxSelectedItems() {
        return this._maxSelectedItems;
    }
    set maxSelectedItems(value) {
        this._maxSelectedItems = coerceNumberProperty(value);
    }
    get ds() {
        return this._ds;
    }
    get limitReached() {
        return (!!this._maxSelectedItems &&
            this._ds.selected.length >= this._maxSelectedItems);
    }
    ngOnInit() {
        this._ds.selectedObservable.subscribe(selected => this.selectedItemsChange.emit(selected));
    }
    ngOnDestroy() {
        this._ds.dispose();
    }
    selectItem(item) {
        if (!this.limitReached) {
            this._ds.select(item);
        }
    }
    deselectItem(item) {
        this._ds.deselect(item);
    }
    selectAll() {
        this.ds.selectAll();
        this.allSelected.emit();
    }
    deselectAll() {
        this.ds.deselectAll();
        this.allCleared.emit();
    }
    filterAvailableItems(query) {
        if (this.search.observers.length) {
            // if `(search)` output was subscribed to,
            // emit the query
            this.search.emit(query);
        }
        else {
            // else filter locally
            this._ds.filterAvailable(query);
        }
    }
    filterSelectedItems(query) {
        if (this.searchSelected.observers.length) {
            // if `(searchSelected)` output was subscribed to,
            // emit the query
            this.searchSelected.emit(query);
        }
        else {
            // else filter locally
            this._ds.filterSelected(query);
        }
    }
}
MultiselectInlineComponent.ɵfac = function MultiselectInlineComponent_Factory(t) { return new (t || MultiselectInlineComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MultiselectInlineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectInlineComponent, selectors: [["pmcc-multiselect-inline"]], inputs: { textWrap: "textWrap", height: "height", showLoading: "showLoading", availableItems: "availableItems", selectedItems: "selectedItems", maxSelectedItems: "maxSelectedItems", availableItemsTemplate: "availableItemsTemplate", selectedItemsTemplate: "selectedItemsTemplate" }, outputs: { selectedItemsChange: "selectedItemsChange", search: "search", searchSelected: "searchSelected", allSelected: "allSelected", allCleared: "allCleared" }, decls: 19, vars: 34, consts: [[1, "section"], ["class", "pmcc-flex max-selected-items-notice", 4, "ngIf"], ["buttonLabel", "Select\u00A0All", 3, "canSelect", "removeButton", "filter", "selected"], [1, "scroll-container"], ["class", "pmcc-table", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["customAvailableItems", ""], [1, "section", "selected-items"], ["buttonLabel", "Clear\u00A0All", 3, "canSelect", "filter", "selected"], [4, "ngIf", "ngIfElse"], ["customSelectedItems", ""], ["class", "pmcc-multiselect-inline-loading", 3, "height", "width", 4, "ngIf"], [1, "pmcc-flex", "max-selected-items-notice"], [1, "pmcc-left"], ["notice", ""], [1, "pmcc-table"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], [3, "ngClass", "title"], [1, "pmcc-ico-close"], [1, "pmcc-multiselect-inline-loading"], ["name", "processing", "size", "4x", "effect", "spin"]], template: function MultiselectInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵtemplate(1, MultiselectInlineComponent_div_1_Template, 6, 4, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "pmcc-multiselect-toolbar", 2);
        ɵngcc0.ɵɵlistener("filter", function MultiselectInlineComponent_Template_pmcc_multiselect_toolbar_filter_2_listener($event) { return ctx.filterAvailableItems($event); })("selected", function MultiselectInlineComponent_Template_pmcc_multiselect_toolbar_selected_2_listener() { return ctx.selectAll(); });
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, MultiselectInlineComponent_table_5_Template, 4, 3, "table", 4);
        ɵngcc0.ɵɵtemplate(6, MultiselectInlineComponent_ng_template_6_Template, 0, 0, "ng-template", 5, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵpipe(8, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "section", 7);
        ɵngcc0.ɵɵtemplate(10, MultiselectInlineComponent_div_10_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵelementStart(11, "pmcc-multiselect-toolbar", 8);
        ɵngcc0.ɵɵlistener("filter", function MultiselectInlineComponent_Template_pmcc_multiselect_toolbar_filter_11_listener($event) { return ctx.filterSelectedItems($event); })("selected", function MultiselectInlineComponent_Template_pmcc_multiselect_toolbar_selected_11_listener() { return ctx.deselectAll(); });
        ɵngcc0.ɵɵpipe(12, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵtemplate(14, MultiselectInlineComponent_table_14_Template, 4, 3, "table", 9);
        ɵngcc0.ɵɵtemplate(15, MultiselectInlineComponent_ng_template_15_Template, 0, 0, "ng-template", 5, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵpipe(17, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, MultiselectInlineComponent_div_18_Template, 2, 4, "div", 11);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(7);
        const _r6 = ɵngcc0.ɵɵreference(16);
        let tmp_1_0;
        let tmp_9_0;
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxSelectedItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("canSelect", (tmp_1_0 = ɵngcc0.ɵɵpipeBind1(3, 18, ctx.ds == null ? null : ctx.ds.filteredAvailableObservable)) == null ? null : tmp_1_0.length)("removeButton", !!ctx.maxSelectedItems);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("height", ctx.height);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.availableItemsTemplate)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.availableItemsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(26, _c61, ɵngcc0.ɵɵpipeBind1(8, 20, ctx.ds == null ? null : ctx.ds.filteredAvailableObservable), ctx.selectItem, ctx.ds == null ? null : ctx.ds.availableFilter));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxSelectedItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("canSelect", (tmp_9_0 = ɵngcc0.ɵɵpipeBind1(12, 22, ctx.ds == null ? null : ctx.ds.filteredSelectedObservable)) == null ? null : tmp_9_0.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("height", ctx.height);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.selectedItemsTemplate)("ngIfElse", _r6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.selectedItemsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(30, _c62, ɵngcc0.ɵɵpipeBind1(17, 24, ctx.ds == null ? null : ctx.ds.filteredSelectedObservable), ctx.deselectItem, ctx.ds == null ? null : ctx.ds.selectedFilter));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLoading);
    } }, directives: function () { return [ɵngcc1.NgIf, MultiselectToolbarComponent, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, ɵngcc1.NgClass, IconComponent, IconEffectDirective]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-shrink:0}[_nghost-%COMP%]   .pmcc-multiselect-inline-message[_ngcontent-%COMP%]{color:#666}.max-selected-items-notice[_ngcontent-%COMP%]{padding:10px 0}.section[_ngcontent-%COMP%]{flex:1}.section[_ngcontent-%COMP%]:first-of-type{border-right:1px solid #ccc}.section[_ngcontent-%COMP%]:first-of-type     .pmcc-table th{background:#fff;border-top:none;border-left:none;border-right:none}.section[_ngcontent-%COMP%]:first-of-type     .pmcc-table td{border:none}.section[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}.section[_ngcontent-%COMP%]   .scroll-container[_ngcontent-%COMP%]{padding:0 17px 10px 10px;overflow-y:auto}  .selected-items table{width:100%;border-collapse:initial;border-spacing:0 .5em;margin:0;color:#545454;background-color:#fff}  .selected-items thead{background:#fff}  .selected-items th{text-align:left;padding:5px;background:#fff;border-bottom:2px solid #ebebeb;border-left:0;border-right:0}  .selected-items td{padding:8px 6px 7px;background:#f1f1f1;border-left:1px solid #f1f1f1}  .selected-items td:first-of-type{border-top-left-radius:3px;border-bottom-left-radius:3px;color:#666}  .selected-items td:last-of-type{width:37px;border-top-right-radius:3px;border-bottom-right-radius:3px;color:#ccc;text-align:center;vertical-align:middle}  .selected-items td:last-child{border-left:2px solid #fff}  .selected-items .pmcc-ico-close{font-size:9px;font-weight:700}.blink[_ngcontent-%COMP%]{animation:blinker 1s linear 3}@keyframes blinker{50%{opacity:0}}.pmcc-multiselect-inline-loading[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-flow:column;position:absolute;background:#ffffffbf}"] });
MultiselectInlineComponent.ctorParameters = () => [
    { type: ElementRef }
];
MultiselectInlineComponent.propDecorators = {
    availableItems: [{ type: Input }],
    selectedItems: [{ type: Input }],
    maxSelectedItems: [{ type: Input }],
    textWrap: [{ type: Input }],
    height: [{ type: Input }],
    availableItemsTemplate: [{ type: Input }],
    selectedItemsTemplate: [{ type: Input }],
    showLoading: [{ type: Input }],
    selectedItemsChange: [{ type: Output }],
    search: [{ type: Output }],
    searchSelected: [{ type: Output }],
    allSelected: [{ type: Output }],
    allCleared: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectInlineComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-inline',
                template: "<section class=\"section\">\n  <div *ngIf=\"maxSelectedItems\" class=\"pmcc-flex max-selected-items-notice\">\n    <span class=\"pmcc-left\">\n      <strong [class.blink]=\"limitReached\">\n        <ng-container *ngIf=\"limitReached; else notice\">\n          Maximum number of items selected!\n        </ng-container>\n        <ng-template #notice>\n          Select up to {{ maxSelectedItems }} items.\n        </ng-template>\n      </strong>\n    </span>\n  </div>\n  <pmcc-multiselect-toolbar\n    buttonLabel=\"Select&nbsp;All\"\n    [canSelect]=\"(ds?.filteredAvailableObservable | async)?.length\"\n    [removeButton]=\"!!maxSelectedItems\"\n    (filter)=\"filterAvailableItems($event)\"\n    (selected)=\"selectAll()\"\n  ></pmcc-multiselect-toolbar>\n\n  <div class=\"scroll-container\" [style.height]=\"height\">\n    <table\n      *ngIf=\"!availableItemsTemplate; else customAvailableItems\"\n      class=\"pmcc-table\"\n    >\n      <tbody>\n        <tr\n          *ngFor=\"let item of (ds?.filteredAvailableObservable | async)\"\n          (click)=\"selectItem(item)\"\n        >\n          <td [ngClass]=\"textWrap\" [title]=\"item.name\">\n            {{ item.name }}\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <ng-template\n      #customAvailableItems\n      [ngTemplateOutlet]=\"availableItemsTemplate\"\n      [ngTemplateOutletContext]=\"{\n        availableItems: ds?.filteredAvailableObservable | async,\n        selectItem: selectItem,\n        filter: ds?.availableFilter\n      }\"\n    ></ng-template>\n  </div>\n</section>\n<section class=\"section selected-items\">\n  <div *ngIf=\"maxSelectedItems\" class=\"pmcc-flex max-selected-items-notice\">\n    &nbsp;\n  </div>\n  <pmcc-multiselect-toolbar\n    buttonLabel=\"Clear&nbsp;All\"\n    [canSelect]=\"(ds?.filteredSelectedObservable | async)?.length\"\n    (filter)=\"filterSelectedItems($event)\"\n    (selected)=\"deselectAll()\"\n  ></pmcc-multiselect-toolbar>\n\n  <div class=\"scroll-container\" [style.height]=\"height\">\n    <table *ngIf=\"!selectedItemsTemplate; else customSelectedItems\">\n      <tbody>\n        <tr\n          *ngFor=\"let item of (ds?.filteredSelectedObservable | async)\"\n          (click)=\"deselectItem(item)\"\n        >\n          <td [ngClass]=\"textWrap\" [title]=\"item.name\">{{ item.name }}</td>\n          <td><span class=\"pmcc-ico-close\"></span></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <ng-template\n      #customSelectedItems\n      [ngTemplateOutlet]=\"selectedItemsTemplate\"\n      [ngTemplateOutletContext]=\"{\n        selectedItems: ds?.filteredSelectedObservable | async,\n        deselectItem: deselectItem,\n        filter: ds?.selectedFilter\n      }\"\n    ></ng-template>\n  </div>\n</section>\n\n\n<div\n  class=\"pmcc-multiselect-inline-loading\"\n  *ngIf=\"showLoading\"\n  [style.height.px]=\"elRef.nativeElement.offsetHeight\"\n  [style.width.px]=\"elRef.nativeElement.offsetWidth\"\n>\n  <pmcc-icon name=\"processing\" size=\"4x\" effect=\"spin\"></pmcc-icon>\n</div>\n",
                styles: [":host{display:flex;flex-shrink:0}:host .pmcc-multiselect-inline-message{color:#666}.max-selected-items-notice{padding:10px 0}.section{flex:1}.section:first-of-type{border-right:1px solid #ccc}.section:first-of-type ::ng-deep .pmcc-table th{background:#fff;border-top:none;border-left:none;border-right:none}.section:first-of-type ::ng-deep .pmcc-table td{border:none}.section tr{cursor:pointer}.section .scroll-container{padding:0 17px 10px 10px;overflow-y:auto}::ng-deep .selected-items table{width:100%;border-collapse:initial;border-spacing:0 .5em;margin:0;color:#545454;background-color:#fff}::ng-deep .selected-items thead{background:#fff}::ng-deep .selected-items th{text-align:left;padding:5px;background:#fff;border-bottom:2px solid #ebebeb;border-left:0;border-right:0}::ng-deep .selected-items td{padding:8px 6px 7px;background:#f1f1f1;border-left:1px solid #f1f1f1}::ng-deep .selected-items td:first-of-type{border-top-left-radius:3px;border-bottom-left-radius:3px;color:#666}::ng-deep .selected-items td:last-of-type{width:37px;border-top-right-radius:3px;border-bottom-right-radius:3px;color:#ccc;text-align:center;vertical-align:middle}::ng-deep .selected-items td:last-child{border-left:2px solid #fff}::ng-deep .selected-items .pmcc-ico-close{font-size:9px;font-weight:700}.blink{animation:blinker 1s linear 3}@keyframes blinker{50%{opacity:0}}.pmcc-multiselect-inline-loading{display:flex;align-items:center;justify-content:center;flex-flow:column;position:absolute;background:#ffffffbf}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { textWrap: [{
            type: Input
        }], height: [{
            type: Input
        }], showLoading: [{
            type: Input
        }], selectedItemsChange: [{
            type: Output
        }], search: [{
            type: Output
        }], searchSelected: [{
            type: Output
        }], allSelected: [{
            type: Output
        }], allCleared: [{
            type: Output
        }], availableItems: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], maxSelectedItems: [{
            type: Input
        }], availableItemsTemplate: [{
            type: Input
        }], selectedItemsTemplate: [{
            type: Input
        }] }); })();

class MultiselectToolbarComponent {
    constructor() {
        this._filterDebouncer = new Subject();
        this.filter = new EventEmitter();
        this.selected = new EventEmitter();
    }
    ngOnInit() {
        const DEBOUNCE_TIME = 400;
        this._filterDebouncer.pipe(debounceTime(DEBOUNCE_TIME)).subscribe((query) => this.filter.emit(query));
    }
    ngOnDestroy() {
        this._filterDebouncer.unsubscribe();
    }
    onSelect() {
        this.selected.emit();
    }
    onFilter(query) {
        this._filterDebouncer.next(query);
    }
}
MultiselectToolbarComponent.ɵfac = function MultiselectToolbarComponent_Factory(t) { return new (t || MultiselectToolbarComponent)(); };
MultiselectToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiselectToolbarComponent, selectors: [["pmcc-multiselect-toolbar"]], inputs: { canSelect: "canSelect", buttonLabel: "buttonLabel", removeButton: "removeButton" }, outputs: { filter: "filter", selected: "selected" }, decls: 5, vars: 1, consts: [[1, "label"], ["pmccClear", "", "fullWidth", ""], ["pmccInput", "", "type", "text", "aria-label", "filter items", 3, "input"], ["class", "pmcc-ms-inline-btn-div", 4, "ngIf"], [1, "pmcc-ms-inline-btn-div"], ["pmccButton", "", "pmccVariant", "secondary", "pmccSize", "md", 3, "disabled", "click"]], template: function MultiselectToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1, "Search:\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "pmcc-input", 1);
        ɵngcc0.ɵɵelementStart(3, "input", 2);
        ɵngcc0.ɵɵlistener("input", function MultiselectToolbarComponent_Template_input_input_3_listener($event) { return ctx.onFilter($event.target.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, MultiselectToolbarComponent_span_4_Template, 3, 2, "span", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.removeButton);
    } }, directives: [InputComponent, InputDirective, ɵngcc1.NgIf, ButtonDirective], styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:space-between;padding:10px 17px 10px 10px}.label[_ngcontent-%COMP%]{font-weight:700}.pmcc-ms-inline-btn-div[_ngcontent-%COMP%]{margin-left:10px;padding-left:10px;border-left:1px solid #ccc}"], changeDetection: 0 });
MultiselectToolbarComponent.propDecorators = {
    canSelect: [{ type: Input }],
    buttonLabel: [{ type: Input }],
    removeButton: [{ type: Input }],
    filter: [{ type: Output }],
    selected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-toolbar',
                template: "<span class=\"label\">Search:&nbsp;</span>\n<pmcc-input pmccClear fullWidth>\n  <input\n    pmccInput\n    type=\"text\"\n    aria-label=\"filter items\"\n    (input)=\"onFilter($event.target.value)\"\n  />\n</pmcc-input>\n<span class=\"pmcc-ms-inline-btn-div\" *ngIf=\"!removeButton\">\n  <button\n    pmccButton\n    pmccVariant=\"secondary\"\n    pmccSize=\"md\"\n    [disabled]=\"!canSelect\"\n    (click)=\"onSelect()\"\n  >\n    {{ buttonLabel }}\n  </button>\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;align-items:center;justify-content:space-between;padding:10px 17px 10px 10px}.label{font-weight:700}.pmcc-ms-inline-btn-div{margin-left:10px;padding-left:10px;border-left:1px solid #ccc}"]
            }]
    }], function () { return []; }, { filter: [{
            type: Output
        }], selected: [{
            type: Output
        }], canSelect: [{
            type: Input
        }], buttonLabel: [{
            type: Input
        }], removeButton: [{
            type: Input
        }] }); })();

class MultiselectInlineModule {
}
MultiselectInlineModule.ɵfac = function MultiselectInlineModule_Factory(t) { return new (t || MultiselectInlineModule)(); };
MultiselectInlineModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MultiselectInlineModule });
MultiselectInlineModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, InputModule, ButtonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectInlineModule, [{
        type: NgModule,
        args: [{
                declarations: [MultiselectInlineComponent, MultiselectToolbarComponent],
                imports: [CommonModule, InputModule, ButtonModule, IconModule],
                exports: [MultiselectInlineComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultiselectInlineModule, { declarations: function () { return [MultiselectInlineComponent, MultiselectToolbarComponent]; }, imports: function () { return [CommonModule, InputModule, ButtonModule, IconModule]; }, exports: function () { return [MultiselectInlineComponent]; } }); })();

class SelectMsTriggerModule {
}
SelectMsTriggerModule.ɵfac = function SelectMsTriggerModule_Factory(t) { return new (t || SelectMsTriggerModule)(); };
SelectMsTriggerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SelectMsTriggerModule });
SelectMsTriggerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectMsTriggerModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectMsTriggerComponent, SelectMsControllerDirective],
                imports: [CommonModule],
                exports: [SelectMsTriggerComponent, SelectMsControllerDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectMsTriggerModule, { declarations: function () { return [SelectMsTriggerComponent, SelectMsControllerDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SelectMsTriggerComponent, SelectMsControllerDirective]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/spinner</example-url>
 */
class SpinnerComponent {
    constructor(elRef, cd) {
        this.elRef = elRef;
        this.cd = cd;
        this.blocking = true;
        this.fullPage = false;
        this.defaultSize = 1;
    }
    get _size() {
        return this.size || this.defaultSize;
    }
    calcDefaultSize() {
        if (!this.size) {
            const parentEl = this.elRef.nativeElement.parentElement;
            this.defaultSize = this.detectSize(Math.min(parentEl.clientHeight, parentEl.clientWidth));
            this.cd.detectChanges();
        }
    }
    ngAfterViewInit() {
        this.calcDefaultSize();
    }
    onWindowResize() {
        this.calcDefaultSize();
    }
    detectSize(value) {
        let size = 1;
        /* tslint:disable */
        if (value > 48) {
            size = 6;
        }
        else if (value > 36) {
            size = 5;
        }
        else if (value > 24) {
            size = 4;
        }
        else if (value > 17) {
            size = 3;
        }
        else if (value > 15) {
            size = 2;
        }
        return size;
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["pmcc-spinner"]], hostBindings: function SpinnerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function SpinnerComponent_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { blocking: "blocking", fullPage: "fullPage", size: "size" }, ngContentSelectors: _c1, decls: 7, vars: 7, consts: [[1, "spinner-wrapper"], [1, "spinner", "loading-icon", "pmcc-effect-spin", 3, "ngClass"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 270.9 270.9"], ["d", "M135.5 200.6q-4.8 0-8.8 3.5-4 3.6-4 8.9v45.2q0 5.6 4 9.2 4 3.5 8.8 3.5 4.7 0 8.7-3.5 4-3.6 4-9.2v-46q0-4.8-4-8.2-4-3.4-8.7-3.4zm0-200.6q-4.8 0-8.8 3.6-4 3.5-4 9.1v46q0 4.8 3.8 8.8 3.7 4 9 4 4.7 0 8.7-3.8 4-3.7 4-9v-46q0-5.6-4-9.1-4-3.6-8.7-3.6zm-32.6 191.3q-4-2.7-9.1-1-5.2 1.5-8 5.8l-22.6 39.6q-2.6 4.8-1 9.6 1.6 4.7 5.5 7.6 4 2.7 9.3 1.1 5.3-1.6 8-5.6l22.4-40q2.7-4.7 1.5-9.4-1.2-4.8-6-7.7zM203.2 18q-4-2.7-9.3-1-5.3 1.5-7.9 5.5l-22.5 39.7q-2.6 4.2-1 9.4 1.5 5.1 5.5 7.8 4 2.6 9.1 1.2 5.2-1.5 8.1-5.7l22.5-39.7q2.6-4.8 1-9.7-1.5-4.9-5.5-7.5zM79.4 168q-2.7-4.2-7.6-5.8-4.9-1.6-9.4 1.3l-40 22.5q-3.9 2.6-5.5 7.8-1.6 5.2 1 9.4 3 4 7.8 5.6 4.7 1.5 9.5-1.1l39.7-22.5q4.2-2.9 5.4-8 1.2-5.2-1-9.2zM252.9 67.7q-2.9-4.2-7.6-5.7-4.8-1.4-9.6 1.2l-39.6 22.5q-4.3 2.7-5.9 7.6-1.6 4.9 1.4 9.6 2.6 4 7.5 5.6 4.9 1.6 9.4-1l40-22.6q4-2.9 5.5-8 1.6-5.2-1-9.2zM70.4 135.5q0-4.8-3.6-8.8-3.6-4-9.1-4h-45q-5.6 0-9.1 4-3.6 4-3.6 8.8 0 4.7 3.6 8.7 3.5 4 9.1 4h46q4.8 0 8.2-4 3.5-4 3.5-8.7zm200.5 0q0-4.8-3.5-8.8-3.6-4-9.2-4h-46q-4.8 0-8.7 3.6-4 3.6-4 9.2 0 4.7 3.7 8.7 3.7 4 9 4h46q5.6 0 9.2-4 3.5-4 3.5-8.7zM191.6 168q2.6-4.2 7.5-5.8 4.9-1.6 9.4 1.3l40 22.5q4 2.6 5.5 7.8 1.6 5.2-1 9.4-3 4-7.7 5.6-4.8 1.5-9.6-1.1l-39.6-22.5q-4.3-2.9-5.5-8-1.2-5.2 1-9.2zM18 67.7q2.9-4.2 7.7-5.7 4.7-1.4 9.5 1.2l39.7 22.5q4.2 2.7 5.8 7.6 1.6 4.9-1.3 9.6-2.7 4-7.6 5.6-4.9 1.6-9.4-1l-40-22.6Q18.6 82 17 77q-1.6-5.2 1-9.2zm150 123.6q4-2.7 9.1-1 5.2 1.5 8.1 5.8l22.5 39.6q2.6 4 1 9.2-1.5 5.1-5.5 8-4 2.7-9.3 1.1-5.3-1.6-7.9-5.6l-22.5-40q-2.6-4.7-1.4-9.4 1.1-4.8 6-7.7zM67.7 18q4-2.7 9.3-1 5.3 1.5 8 5.5l22.4 39.7q2.7 4.2 1 9.4-1.5 5.1-5.5 7.8-4 2.6-9.1 1.2-5.2-1.5-8-5.7L63.1 35.2q-2.6-4.8-1-9.7 1.6-4.9 5.5-7.5z"], [1, "content"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 2);
        ɵngcc0.ɵɵelement(4, "path", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("pointer-events", ctx.blocking ? "auto" : "none")("position", ctx.fullPage ? "fixed" : "absolute");
        ɵngcc0.ɵɵclassProp("background", ctx.blocking);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", "pmcc-ico-" + ctx._size + "x");
    } }, directives: [ɵngcc1.NgClass], styles: [".spinner-wrapper[_ngcontent-%COMP%]{z-index:2;left:0;top:0;right:0;bottom:0;visibility:visible;overflow:hidden}.spinner-wrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.spinner-wrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .spinner[_ngcontent-%COMP%]{display:block;margin:0 auto 5px}.background[_ngcontent-%COMP%]{background:#ffffffbf}.loading-icon[_ngcontent-%COMP%]{color:#222121}"], changeDetection: 0 });
SpinnerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
SpinnerComponent.propDecorators = {
    size: [{ type: Input }],
    blocking: [{ type: Input }],
    fullPage: [{ type: Input }],
    onWindowResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-spinner',
                template: "<div\n  class=\"spinner-wrapper\"\n  [class.background]=\"blocking\"\n  [style.pointer-events]=\"blocking ? 'auto' : 'none'\"\n  [style.position]=\"fullPage ? 'fixed' : 'absolute'\"\n>\n  <div>\n    <div\n      class=\"spinner loading-icon pmcc-effect-spin\"\n      [ngClass]=\"'pmcc-ico-' + _size + 'x'\"\n    >\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 270.9 270.9\"\n      >\n        <path d=\"M135.5 200.6q-4.8 0-8.8 3.5-4 3.6-4 8.9v45.2q0 5.6 4 9.2 4 3.5 8.8 3.5 4.7 0 8.7-3.5 4-3.6 4-9.2v-46q0-4.8-4-8.2-4-3.4-8.7-3.4zm0-200.6q-4.8 0-8.8 3.6-4 3.5-4 9.1v46q0 4.8 3.8 8.8 3.7 4 9 4 4.7 0 8.7-3.8 4-3.7 4-9v-46q0-5.6-4-9.1-4-3.6-8.7-3.6zm-32.6 191.3q-4-2.7-9.1-1-5.2 1.5-8 5.8l-22.6 39.6q-2.6 4.8-1 9.6 1.6 4.7 5.5 7.6 4 2.7 9.3 1.1 5.3-1.6 8-5.6l22.4-40q2.7-4.7 1.5-9.4-1.2-4.8-6-7.7zM203.2 18q-4-2.7-9.3-1-5.3 1.5-7.9 5.5l-22.5 39.7q-2.6 4.2-1 9.4 1.5 5.1 5.5 7.8 4 2.6 9.1 1.2 5.2-1.5 8.1-5.7l22.5-39.7q2.6-4.8 1-9.7-1.5-4.9-5.5-7.5zM79.4 168q-2.7-4.2-7.6-5.8-4.9-1.6-9.4 1.3l-40 22.5q-3.9 2.6-5.5 7.8-1.6 5.2 1 9.4 3 4 7.8 5.6 4.7 1.5 9.5-1.1l39.7-22.5q4.2-2.9 5.4-8 1.2-5.2-1-9.2zM252.9 67.7q-2.9-4.2-7.6-5.7-4.8-1.4-9.6 1.2l-39.6 22.5q-4.3 2.7-5.9 7.6-1.6 4.9 1.4 9.6 2.6 4 7.5 5.6 4.9 1.6 9.4-1l40-22.6q4-2.9 5.5-8 1.6-5.2-1-9.2zM70.4 135.5q0-4.8-3.6-8.8-3.6-4-9.1-4h-45q-5.6 0-9.1 4-3.6 4-3.6 8.8 0 4.7 3.6 8.7 3.5 4 9.1 4h46q4.8 0 8.2-4 3.5-4 3.5-8.7zm200.5 0q0-4.8-3.5-8.8-3.6-4-9.2-4h-46q-4.8 0-8.7 3.6-4 3.6-4 9.2 0 4.7 3.7 8.7 3.7 4 9 4h46q5.6 0 9.2-4 3.5-4 3.5-8.7zM191.6 168q2.6-4.2 7.5-5.8 4.9-1.6 9.4 1.3l40 22.5q4 2.6 5.5 7.8 1.6 5.2-1 9.4-3 4-7.7 5.6-4.8 1.5-9.6-1.1l-39.6-22.5q-4.3-2.9-5.5-8-1.2-5.2 1-9.2zM18 67.7q2.9-4.2 7.7-5.7 4.7-1.4 9.5 1.2l39.7 22.5q4.2 2.7 5.8 7.6 1.6 4.9-1.3 9.6-2.7 4-7.6 5.6-4.9 1.6-9.4-1l-40-22.6Q18.6 82 17 77q-1.6-5.2 1-9.2zm150 123.6q4-2.7 9.1-1 5.2 1.5 8.1 5.8l22.5 39.6q2.6 4 1 9.2-1.5 5.1-5.5 8-4 2.7-9.3 1.1-5.3-1.6-7.9-5.6l-22.5-40q-2.6-4.7-1.4-9.4 1.1-4.8 6-7.7zM67.7 18q4-2.7 9.3-1 5.3 1.5 8 5.5l22.4 39.7q2.7 4.2 1 9.4-1.5 5.1-5.5 7.8-4 2.6-9.1 1.2-5.2-1.5-8-5.7L63.1 35.2q-2.6-4.8-1-9.7 1.6-4.9 5.5-7.5z\"/>\n      </svg>\n    </div>\n    <div class=\"content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".spinner-wrapper{z-index:2;left:0;top:0;right:0;bottom:0;visibility:visible;overflow:hidden}.spinner-wrapper>div{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.spinner-wrapper>div>.spinner{display:block;margin:0 auto 5px}.background{background:#ffffffbf}.loading-icon{color:#222121}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { blocking: [{
            type: Input
        }], fullPage: [{
            type: Input
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize']
        }], size: [{
            type: Input
        }] }); })();

class SpinnerModule {
}
SpinnerModule.ɵfac = function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(); };
SpinnerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                declarations: [SpinnerComponent],
                imports: [CommonModule, IconModule],
                exports: [SpinnerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SpinnerModule, { declarations: function () { return [SpinnerComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [SpinnerComponent]; } }); })();

class AvailableSectionHeaderComponent {
    constructor() {
        this.selectedAll = new EventEmitter();
    }
    selectAll() {
        this.selectedAll.emit();
    }
}
AvailableSectionHeaderComponent.ɵfac = function AvailableSectionHeaderComponent_Factory(t) { return new (t || AvailableSectionHeaderComponent)(); };
AvailableSectionHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AvailableSectionHeaderComponent, selectors: [["pmcc-multiselect-available-section-header"]], inputs: { isSelectAllDisabled: "isSelectAllDisabled", selectedItemsLimit: "selectedItemsLimit", warnMaxLimit: "warnMaxLimit", selectionLimitMessage: "selectionLimitMessage", instructions: "instructions", isLimitReached: "isLimitReached", selectAllTooltip: "selectAllTooltip" }, outputs: { selectedAll: "selectedAll" }, decls: 4, vars: 3, consts: [[1, "pmcc-ms-section-header"], [4, "ngIf"], ["class", "pmcc-ms-selected-items-limit pmcc-ms-section-header-message", 3, "ngClass", 4, "ngIf"], ["class", "instructions-spacer pmcc-ms-section-header-message", 4, "ngIf"], ["pmccButton", "", "pmccVariant", "secondary", 3, "disabled", "click"], ["name", "info", "class", "pmcc-ms-tooltip-info-icon", 3, "pmccTooltip", 4, "ngIf"], ["name", "info", 1, "pmcc-ms-tooltip-info-icon", 3, "pmccTooltip"], [1, "pmcc-ms-selected-items-limit", "pmcc-ms-section-header-message", 3, "ngClass"], [3, "hidden"], [1, "instructions-spacer", "pmcc-ms-section-header-message"]], template: function AvailableSectionHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AvailableSectionHeaderComponent_div_1_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, AvailableSectionHeaderComponent_div_2_Template, 5, 7, "div", 2);
        ɵngcc0.ɵɵtemplate(3, AvailableSectionHeaderComponent_div_3_Template, 1, 0, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItemsLimit === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItemsLimit > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.instructions);
    } }, directives: [ɵngcc1.NgIf, ButtonDirective, IconComponent, TooltipDirective, ɵngcc1.NgClass], encapsulation: 2 });
AvailableSectionHeaderComponent.propDecorators = {
    isSelectAllDisabled: [{ type: Input }],
    selectedItemsLimit: [{ type: Input }],
    warnMaxLimit: [{ type: Input }],
    selectionLimitMessage: [{ type: Input }],
    instructions: [{ type: Input }],
    isLimitReached: [{ type: Input }],
    selectAllTooltip: [{ type: Input }],
    selectedAll: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AvailableSectionHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-available-section-header',
                template: "<div class=\"pmcc-ms-section-header\">\n  <div *ngIf=\"selectedItemsLimit === 0\">\n    <button\n      pmccButton\n      pmccVariant=\"secondary\"\n      [disabled]=\"isSelectAllDisabled\"\n      (click)=\"selectAll()\"\n    >\n      Select All\n    </button>\n    <pmcc-icon\n      *ngIf=\"selectAllTooltip\"\n      name=\"info\"\n      class=\"pmcc-ms-tooltip-info-icon\"\n      [pmccTooltip]=\"selectAllTooltip\"\n    ></pmcc-icon>\n  </div>\n  <div\n    *ngIf=\"selectedItemsLimit > 0\"\n    class=\"pmcc-ms-selected-items-limit pmcc-ms-section-header-message\"\n    [ngClass]=\"{ 'pmcc-flash': warnMaxLimit }\"\n  >\n    <span [hidden]=\"isLimitReached\">\n      Select up to {{ selectedItemsLimit }} items\n    </span>\n    <span [hidden]=\"!isLimitReached\">\n      {{ selectionLimitMessage }}\n    </span>\n  </div>\n  <div class=\"instructions-spacer pmcc-ms-section-header-message\" *ngIf=\"instructions\"></div>\n</div>\n"
            }]
    }], function () { return []; }, { selectedAll: [{
            type: Output
        }], isSelectAllDisabled: [{
            type: Input
        }], selectedItemsLimit: [{
            type: Input
        }], warnMaxLimit: [{
            type: Input
        }], selectionLimitMessage: [{
            type: Input
        }], instructions: [{
            type: Input
        }], isLimitReached: [{
            type: Input
        }], selectAllTooltip: [{
            type: Input
        }] }); })();

class ButtonBarComponent {
    constructor() {
        this.layerClosed = new EventEmitter();
    }
    closeLayer(param) {
        this.layerClosed.emit(param);
    }
}
ButtonBarComponent.ɵfac = function ButtonBarComponent_Factory(t) { return new (t || ButtonBarComponent)(); };
ButtonBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonBarComponent, selectors: [["pmcc-multiselect-button-bar"]], inputs: { isDoneDisabled: "isDoneDisabled" }, outputs: { layerClosed: "layerClosed" }, decls: 7, vars: 1, consts: [[1, "pmcc-button-bar", "pmcc-flex"], [1, "pmcc-left"], ["type", "button", 1, "pmcc-btn-lg", "pmcc-secondary", 3, "click"], [1, "pmcc-right"], ["type", "button", 1, "pmcc-btn-lg", "pmcc-primary", 3, "disabled", "click"]], template: function ButtonBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_Template_button_click_2_listener() { return ctx.closeLayer("cancel"); });
        ɵngcc0.ɵɵtext(3, " Cancel ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_Template_button_click_5_listener() { return ctx.closeLayer("close"); });
        ɵngcc0.ɵɵtext(6, " Done ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDoneDisabled);
    } }, encapsulation: 2 });
ButtonBarComponent.propDecorators = {
    isDoneDisabled: [{ type: Input }],
    layerClosed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonBarComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-button-bar',
                template: "<div class=\"pmcc-button-bar pmcc-flex\">\n  <div class=\"pmcc-left\">\n    <button\n      type=\"button\"\n      class=\"pmcc-btn-lg pmcc-secondary\"\n      (click)=\"closeLayer('cancel')\"\n    >\n      Cancel\n    </button>\n  </div>\n  <div class=\"pmcc-right\">\n    <button\n      type=\"button\"\n      [disabled]=\"isDoneDisabled\"\n      class=\"pmcc-btn-lg pmcc-primary\"\n      (click)=\"closeLayer('close')\"\n    >\n      Done\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { layerClosed: [{
            type: Output
        }], isDoneDisabled: [{
            type: Input
        }] }); })();

const searchDebounceTime = 400;
class SearchComponent {
    constructor() {
        this.changed = new EventEmitter();
        this.searchCleared = new EventEmitter();
        this.inputChange = new Subject();
        this.inputChangeSubscription = this.inputChange
            .asObservable()
            .pipe(debounceTime(searchDebounceTime))
            .subscribe(value => this.changed.emit(value));
    }
    ngOnDestroy() {
        this.inputChangeSubscription.unsubscribe();
    }
    search(event) {
        this.inputChange.next(event.target.value || '');
    }
    clearSearch(event) {
        event.stopPropagation();
        this.searchCleared.emit();
    }
    focusInput() {
        this.searchInput.nativeElement.focus();
    }
}
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(); };
SearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["pmcc-multiselect-search"]], viewQuery: function SearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c22, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, inputs: { query: "query" }, outputs: { changed: "changed", searchCleared: "searchCleared" }, decls: 6, vars: 2, consts: [[1, "pmcc-input-search"], [1, "label"], ["type", "text", 3, "value", "input"], ["searchInput", ""], ["class", "pmcc-ico-close", 3, "click", 4, "ngIf"], [1, "pmcc-ico-close", 3, "click"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2, "Search: ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "input", 2, 3);
        ɵngcc0.ɵɵlistener("input", function SearchComponent_Template_input_input_3_listener($event) { return ctx.search($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, SearchComponent_span_5_Template, 1, 0, "span", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("value", ctx.query);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.query);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
SearchComponent.propDecorators = {
    searchInput: [{ type: ViewChild, args: ['searchInput', { static: true },] }],
    query: [{ type: Input }],
    changed: [{ type: Output }],
    searchCleared: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-search',
                template: "<div class=\"pmcc-input-search\">\n  <span class=\"label\">Search: </span>\n  <input\n    #searchInput\n    type=\"text\"\n    [value]=\"query\"\n    (input)=\"search($event)\"\n  />\n  <span\n    class=\"pmcc-ico-close\"\n    *ngIf=\"query\"\n    (click)=\"clearSearch($event)\"\n  ></span>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { changed: [{
            type: Output
        }], searchCleared: [{
            type: Output
        }], searchInput: [{
            type: ViewChild,
            args: ['searchInput', { static: true }]
        }], query: [{
            type: Input
        }] }); })();

class SelectedSectionHeaderComponent {
    constructor() {
        this.deselectedAll = new EventEmitter();
    }
    deselectAll() {
        this.deselectedAll.emit();
    }
}
SelectedSectionHeaderComponent.ɵfac = function SelectedSectionHeaderComponent_Factory(t) { return new (t || SelectedSectionHeaderComponent)(); };
SelectedSectionHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectedSectionHeaderComponent, selectors: [["pmcc-multiselect-selected-section-header"]], inputs: { instructions: "instructions", showClearAll: "showClearAll", isDeselectAllDisabled: "isDeselectAllDisabled" }, outputs: { deselectedAll: "deselectedAll" }, decls: 3, vars: 2, consts: [[1, "pmcc-ms-section-header"], ["pmccButton", "", "pmccVariant", "secondary", 3, "disabled", "click", 4, "ngIf"], ["class", "pmcc-ms-section-header-message", 4, "ngIf"], ["pmccButton", "", "pmccVariant", "secondary", 3, "disabled", "click"], [1, "pmcc-ms-section-header-message"]], template: function SelectedSectionHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SelectedSectionHeaderComponent_button_1_Template, 2, 1, "button", 1);
        ɵngcc0.ɵɵtemplate(2, SelectedSectionHeaderComponent_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClearAll);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.instructions);
    } }, directives: [ɵngcc1.NgIf, ButtonDirective], encapsulation: 2 });
SelectedSectionHeaderComponent.propDecorators = {
    instructions: [{ type: Input }],
    showClearAll: [{ type: Input }],
    isDeselectAllDisabled: [{ type: Input }],
    deselectedAll: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedSectionHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multiselect-selected-section-header',
                template: "<div class=\"pmcc-ms-section-header\">\n  <button\n    pmccButton\n    *ngIf=\"showClearAll\"\n    pmccVariant=\"secondary\"\n    [disabled]=\"isDeselectAllDisabled\"\n    (click)=\"deselectAll()\"\n  >\n    Clear All\n  </button>\n  <div class=\"pmcc-ms-section-header-message\" *ngIf=\"instructions\">\n    <strong>{{ instructions }}:</strong>\n  </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { deselectedAll: [{
            type: Output
        }], instructions: [{
            type: Input
        }], showClearAll: [{
            type: Input
        }], isDeselectAllDisabled: [{
            type: Input
        }] }); })();

class MultiselectModule {
}
MultiselectModule.ɵfac = function MultiselectModule_Factory(t) { return new (t || MultiselectModule)(); };
MultiselectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MultiselectModule });
MultiselectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, InfiniteScrollModule, SelectMsTriggerModule, SpinnerModule, ButtonModule, IconModule, TooltipModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiselectModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MultiselectComponent,
                    SelectedSectionHeaderComponent,
                    SearchComponent,
                    SelectedSectionListComponent,
                    AvailableSectionTemplateComponent,
                    AvailableSectionHeaderComponent,
                    ButtonBarComponent,
                    AvailableSectionListComponent,
                    SelectedSectionTemplateComponent
                ],
                imports: [CommonModule, InfiniteScrollModule, SelectMsTriggerModule, SpinnerModule, ButtonModule, IconModule, TooltipModule],
                exports: [MultiselectComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultiselectModule, { declarations: function () { return [MultiselectComponent, SelectedSectionHeaderComponent, SearchComponent, SelectedSectionListComponent, AvailableSectionTemplateComponent, AvailableSectionHeaderComponent, ButtonBarComponent, AvailableSectionListComponent, SelectedSectionTemplateComponent]; }, imports: function () { return [CommonModule, InfiniteScrollModule, SelectMsTriggerModule, SpinnerModule, ButtonModule, IconModule, TooltipModule]; }, exports: function () { return [MultiselectComponent]; } }); })();

const initializationDelay = 50;
class MultistepComponent {
    constructor(element) {
        this.element = element;
        this.hideTopNav = false;
        this.height = '400px';
    }
    ngOnInit() {
        setTimeout(() => {
            this.goToStep(this.steps[0]);
        }, initializationDelay);
    }
    goToStep(step) {
        if (!step.enabled) {
            return;
        }
        const element = this.element.nativeElement.parentElement;
        const stepElement = element.querySelector(`.pmcc-multistep-step-content.${step.id}`);
        stepElement.style.height = this.height;
        stepElement.scrollTop = 0;
        this.steps.forEach(s => s.selected = s === step);
        this.prevStep = step.prevStepIndex > -1 ? this.steps[step.prevStepIndex] : null;
        this.nextStep = step.nextStepIndex > -1 ? this.steps[step.nextStepIndex] : null;
        const wrapper = element.querySelector('.pmcc-multistep-content');
        const container = element.querySelector('.pmcc-multistep-content-scroll-canvas');
        container.style.left = `${-stepElement.offsetLeft}px`;
        wrapper.scrollTop = 0;
    }
}
MultistepComponent.ɵfac = function MultistepComponent_Factory(t) { return new (t || MultistepComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MultistepComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultistepComponent, selectors: [["pmcc-multistep"]], inputs: { hideTopNav: "hideTopNav", height: "height", steps: "steps" }, ngContentSelectors: _c1, decls: 13, vars: 6, consts: [["id", "pmcc-multistep", 1, "pmcc-multistep"], [1, "pmcc-multistep-nav-top", 3, "hidden"], [1, "pmcc-flex"], [1, "pmcc-center"], ["class", "pmcc-multistep-step", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "pmcc-multistep-content"], [1, "pmcc-multistep-content-scroll-canvas"], [1, "pmcc-multistep-nav-bottom"], ["type", "button", "class", "pmcc-btn-sm pmcc-secondary", 3, "disabled", "click", 4, "ngIf"], [1, "pmcc-multistep-step", 3, "ngClass", "click"], ["type", "button", 1, "pmcc-btn-sm", "pmcc-secondary", 3, "disabled", "click"]], template: function MultistepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, MultistepComponent_div_4_Template, 2, 5, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵelementStart(10, "div", 3);
        ɵngcc0.ɵɵtemplate(11, MultistepComponent_button_11_Template, 2, 2, "button", 8);
        ɵngcc0.ɵɵtemplate(12, MultistepComponent_button_12_Template, 2, 2, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.hideTopNav);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("height", ctx.height);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prevStep);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.nextStep);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgClass], styles: [".pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-bottom[_ngcontent-%COMP%]{margin-top:10px;padding-top:10px;border-top:1px dotted #9f9f9f}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-bottom[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:10px}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-top[_ngcontent-%COMP%]{border-bottom:1px dotted #9f9f9f}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-top[_ngcontent-%COMP%]   .pmcc-multistep-step[_ngcontent-%COMP%]{margin:10px 20px;padding:5px;font:normal 13px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;font-size:16px;color:#7e7e7e;cursor:pointer}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-top[_ngcontent-%COMP%]   .pmcc-multistep-step.selected[_ngcontent-%COMP%]{border-bottom:2px solid #0185cc;color:#626262;margin:10px 20px 8px}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-nav-top[_ngcontent-%COMP%]   .pmcc-multistep-step.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-content[_ngcontent-%COMP%]{position:relative;margin:10px 0;overflow-y:hidden;overflow-x:hidden;white-space:nowrap}.pmcc-multistep[_ngcontent-%COMP%]   .pmcc-multistep-content[_ngcontent-%COMP%]   .pmcc-multistep-content-scroll-canvas[_ngcontent-%COMP%]{position:relative;left:0;top:0;transition:left .25s ease-in}"] });
MultistepComponent.ctorParameters = () => [
    { type: ElementRef }
];
MultistepComponent.propDecorators = {
    hideTopNav: [{ type: Input }],
    height: [{ type: Input }],
    steps: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultistepComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-multistep',
                template: "<div id=\"pmcc-multistep\" class=\"pmcc-multistep\">\n  <div [hidden]=\"hideTopNav\" class=\"pmcc-multistep-nav-top\">\n    <div class=\"pmcc-flex\">\n      <div class=\"pmcc-center\">\n        <div\n          class=\"pmcc-multistep-step\"\n          [ngClass]=\"{ selected: step.selected, disabled: !step.enabled }\"\n          (click)=\"goToStep( step )\"\n          *ngFor=\"let step of steps\"\n        >\n          {{ step.label }}\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"pmcc-multistep-content\">\n    <div class=\"pmcc-multistep-content-scroll-canvas\" [style.height]=\"height\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n  <div class=\"pmcc-multistep-nav-bottom\">\n    <div class=\"pmcc-flex\">\n      <div class=\"pmcc-center\">\n        <button\n          type=\"button\"\n          [disabled]=\"!prevStep.enabled\"\n          *ngIf=\"prevStep\"\n          class=\"pmcc-btn-sm pmcc-secondary\"\n          (click)=\"goToStep(prevStep)\"\n        >\n          {{ prevStep.previousButtonLabel }}\n        </button>\n        <button\n          type=\"button\"\n          [disabled]=\"!nextStep.enabled\"\n          *ngIf=\"nextStep\"\n          class=\"pmcc-btn-sm pmcc-secondary\"\n          (click)=\"goToStep(nextStep)\"\n        >\n          {{ nextStep.nextButtonLabel }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".pmcc-multistep .pmcc-multistep-nav-bottom{margin-top:10px;padding-top:10px;border-top:1px dotted #9f9f9f}.pmcc-multistep .pmcc-multistep-nav-bottom button+button{margin-left:10px}.pmcc-multistep .pmcc-multistep-nav-top{border-bottom:1px dotted #9f9f9f}.pmcc-multistep .pmcc-multistep-nav-top .pmcc-multistep-step{margin:10px 20px;padding:5px;font:normal 13px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;font-size:16px;color:#7e7e7e;cursor:pointer}.pmcc-multistep .pmcc-multistep-nav-top .pmcc-multistep-step.selected{border-bottom:2px solid #0185cc;color:#626262;margin:10px 20px 8px}.pmcc-multistep .pmcc-multistep-nav-top .pmcc-multistep-step.disabled{color:#ccc;cursor:not-allowed}.pmcc-multistep .pmcc-multistep-content{position:relative;margin:10px 0;overflow-y:hidden;overflow-x:hidden;white-space:nowrap}.pmcc-multistep .pmcc-multistep-content .pmcc-multistep-content-scroll-canvas{position:relative;left:0;top:0;transition:left .25s ease-in}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { hideTopNav: [{
            type: Input
        }], height: [{
            type: Input
        }], steps: [{
            type: Input
        }] }); })();

class MultistepModule {
}
MultistepModule.ɵfac = function MultistepModule_Factory(t) { return new (t || MultistepModule)(); };
MultistepModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MultistepModule });
MultistepModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultistepModule, [{
        type: NgModule,
        args: [{
                declarations: [MultistepComponent],
                imports: [CommonModule],
                exports: [MultistepComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultistepModule, { declarations: function () { return [MultistepComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MultistepComponent]; } }); })();

var PmccNotification;
(function (PmccNotification) {
    // TODO: Unify this enum and the type from message-box component
    let NotificationType;
    (function (NotificationType) {
        NotificationType["SUCCESS"] = "SUCCESS";
        NotificationType["ERROR"] = "ERROR";
        NotificationType["WARNING"] = "WARNING";
        NotificationType["INFORM"] = "INFORM";
    })(NotificationType = PmccNotification.NotificationType || (PmccNotification.NotificationType = {}));
    PmccNotification.notificationDefaultOptions = {
        timeout: 5000,
        dismissButton: true,
        pauseOnHover: true,
        deleteOnNavigation: true,
    };
    PmccNotification.notificationErrorOptions = {
        timeout: 0,
        dismissButton: true,
        pauseOnHover: true,
        deleteOnNavigation: true,
    };
})(PmccNotification || (PmccNotification = {}));

class PausableTimer {
    constructor(callback, timeout) {
        this.callback = callback;
        this.timeout = timeout;
        this._remaining = this.timeout;
        this.resume();
    }
    pause() {
        this.cancel();
        this._remaining -= Date.now() - this._startedAt;
    }
    resume() {
        this.cancel();
        this._startedAt = Date.now();
        this._timerId = setTimeout(this.callback, this._remaining);
    }
    cancel() {
        clearTimeout(this._timerId);
    }
}

var NotificationType$1 = PmccNotification.NotificationType;
var notificationErrorOptions = PmccNotification.notificationErrorOptions;
var notificationDefaultOptions = PmccNotification.notificationDefaultOptions;
const RESET_ON_NAVIGATION = new InjectionToken('RESET_ON_NAVIGATION');
const skipResetOnNavigationProvider = {
    provide: RESET_ON_NAVIGATION,
    useValue: false,
};
const ResetOnNavigationProvider = {
    provide: RESET_ON_NAVIGATION,
    useValue: true,
};
class NotificationService {
    constructor(router, resetOnNavigation) {
        this._data = [];
        this._timers = new Map();
        this.routeSubscription = Subscription.EMPTY;
        if (resetOnNavigation || resetOnNavigation === null) {
            this.routeSubscription = router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
                this.deleteNotificationsOnNavigate();
            });
        }
    }
    deleteNotificationsOnNavigate() {
        this._data = this._data.filter(notification => !notification.options.deleteOnNavigation);
        this._timers.forEach((timer, notification) => {
            if (notification.options.deleteOnNavigation) {
                timer.cancel();
                this._timers.delete(notification);
            }
        });
    }
    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }
    get data() {
        return this._data;
    }
    create(texts, type = NotificationType$1.SUCCESS, externalOptions = {}) {
        const defaultOptions = type === NotificationType$1.ERROR
            ? notificationErrorOptions
            : notificationDefaultOptions;
        const options = Object.assign(Object.assign({}, defaultOptions), externalOptions);
        const notification = Object.assign(Object.assign({ created: new Date().getTime() }, texts), { type, options: Object.assign(Object.assign({}, defaultOptions), options) });
        this.addNotification(notification);
        return notification;
    }
    createFromTemplate(template, type = NotificationType$1.WARNING, externalOptions = {}) {
        const defaultOptions = type === NotificationType$1.ERROR
            ? notificationErrorOptions
            : notificationDefaultOptions;
        const options = Object.assign(Object.assign({}, defaultOptions), externalOptions);
        const notification = {
            created: new Date().getTime(),
            template,
            type,
            options
        };
        this.addNotification(notification);
        return notification;
    }
    delete(createdOrNotification) {
        const predicate = typeof createdOrNotification === 'number'
            ? (item) => createdOrNotification === item.created
            : (item) => createdOrNotification === item;
        const notificationIdx = this._data.findIndex(predicate);
        if (notificationIdx !== -1) {
            const notification = this._data[notificationIdx];
            this._data.splice(notificationIdx, 1);
            this.cancelTimerFor(notification);
        }
    }
    deleteAll() {
        this._data = [];
        this._timers.forEach(timer => timer.cancel());
        this._timers.clear();
    }
    hold(notification) {
        const timer = this._timers.get(notification);
        if (timer) {
            timer.pause();
        }
    }
    release(notification) {
        const timer = this._timers.get(notification);
        if (timer) {
            timer.resume();
        }
    }
    addNotification(notification) {
        this._data.push(notification);
        if (notification.options.timeout) {
            this._timers.set(notification, new PausableTimer(() => this.delete(notification), notification.options.timeout));
        }
    }
    cancelTimerFor(notification) {
        const timer = this._timers.get(notification);
        if (timer) {
            timer.cancel();
            this._timers.delete(notification);
        }
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(ɵngcc6.Router), ɵngcc0.ɵɵinject(RESET_ON_NAVIGATION, 8)); };
NotificationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(RESET_ON_NAVIGATION, 8)); }, token: NotificationService, providedIn: "root" });
NotificationService.ctorParameters = () => [
    { type: Router },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [RESET_ON_NAVIGATION,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc6.Router }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RESET_ON_NAVIGATION]
            }] }]; }, null); })();

var NotificationType = PmccNotification.NotificationType;
class NotificationComponent {
    constructor(notificationService) {
        this.notificationService = notificationService;
        this.NotificationType = NotificationType;
    }
    dismiss() {
        this.notificationService.delete(this.notification);
    }
    mouseEnter() {
        if (this.canHold()) {
            this.notificationService.hold(this.notification);
        }
    }
    mouseLeave() {
        if (this.canHold()) {
            this.notificationService.release(this.notification);
        }
    }
    canHold() {
        const { timeout, pauseOnHover } = this.notification.options;
        return timeout > 0 && pauseOnHover;
    }
}
NotificationComponent.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationService)); };
NotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["pmcc-notification"]], hostVars: 10, hostBindings: function NotificationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function NotificationComponent_mouseenter_HostBindingHandler() { return ctx.mouseEnter(); })("mouseleave", function NotificationComponent_mouseleave_HostBindingHandler() { return ctx.mouseLeave(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-message-box", true)("pmcc-confirm", ctx.notification.type === ctx.NotificationType.SUCCESS)("pmcc-error", ctx.notification.type === ctx.NotificationType.ERROR)("pmcc-action-required", ctx.notification.type === ctx.NotificationType.WARNING)("pmcc-inform", ctx.notification.type === ctx.NotificationType.INFORM);
    } }, inputs: { notification: "notification" }, decls: 3, vars: 3, consts: [[3, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "pmcc-close-message", 3, "click", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [3, "ngTemplateOutlet"], [1, "pmcc-close-message", 3, "click"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationComponent_ng_template_0_Template, 2, 2, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, NotificationComponent_ng_container_1_Template, 1, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, NotificationComponent_span_2_Template, 1, 0, "span", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.notification.template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.notification.template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.notification == null ? null : ctx.notification.options == null ? null : ctx.notification.options.dismissButton);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{margin:5px 0}"] });
NotificationComponent.ctorParameters = () => [
    { type: NotificationService }
];
NotificationComponent.propDecorators = {
    notification: [{ type: Input }],
    mouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
    mouseLeave: [{ type: HostListener, args: ['mouseleave',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-notification',
                template: "<ng-template [ngIf]=\"!notification.template\">\n  <label *ngIf=\"notification.text\" [innerHTML]=\"notification.text\"></label>\n  <span *ngIf=\"notification.subtext\" [innerHTML]=\"notification.subtext\"></span>\n</ng-template>\n<ng-container\n  *ngIf=\"notification.template\"\n  [ngTemplateOutlet]=\"notification.template\"\n></ng-container>\n<span\n  *ngIf=\"notification?.options?.dismissButton\"\n  class=\"pmcc-close-message\"\n  (click)=\"dismiss()\"\n></span>\n",
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-message-box]': 'true',
                    '[class.pmcc-confirm]': 'notification.type === NotificationType.SUCCESS',
                    '[class.pmcc-error]': 'notification.type === NotificationType.ERROR',
                    '[class.pmcc-action-required]': 'notification.type === NotificationType.WARNING',
                    '[class.pmcc-inform]': 'notification.type === NotificationType.INFORM'
                },
                styles: [":host{margin:5px 0}"]
            }]
    }], function () { return [{ type: NotificationService }]; }, { mouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], mouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], notification: [{
            type: Input
        }] }); })();

class NotificationListComponent {
    constructor(notificationService) {
        this.notificationService = notificationService;
    }
    get notifications() {
        return this.notificationService.data;
    }
}
NotificationListComponent.ɵfac = function NotificationListComponent_Factory(t) { return new (t || NotificationListComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationService)); };
NotificationListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationListComponent, selectors: [["pmcc-notification-list"]], hostVars: 2, hostBindings: function NotificationListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-notification-list", true);
    } }, decls: 1, vars: 1, consts: [[3, "notification", 4, "ngFor", "ngForOf"], [3, "notification"]], template: function NotificationListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationListComponent_pmcc_notification_0_Template, 1, 1, "pmcc-notification", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.notifications);
    } }, directives: [ɵngcc1.NgForOf, NotificationComponent], encapsulation: 2 });
NotificationListComponent.ctorParameters = () => [
    { type: NotificationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-notification-list',
                template: "<pmcc-notification\n  *ngFor=\"let item of notifications\"\n  [notification]=\"item\"\n></pmcc-notification>\n",
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-notification-list]': 'true'
                }
            }]
    }], function () { return [{ type: NotificationService }]; }, null); })();

class NotifiersModule {
}
NotifiersModule.ɵfac = function NotifiersModule_Factory(t) { return new (t || NotifiersModule)(); };
NotifiersModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NotifiersModule });
NotifiersModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotifiersModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MessageBoxTogglerComponent,
                    NotificationComponent,
                    NotificationListComponent,
                    MessageBoxComponent
                ],
                imports: [CommonModule, IconModule],
                exports: [
                    MessageBoxTogglerComponent,
                    NotificationComponent,
                    NotificationListComponent,
                    MessageBoxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotifiersModule, { declarations: function () { return [MessageBoxTogglerComponent, NotificationComponent, NotificationListComponent, MessageBoxComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [MessageBoxTogglerComponent, NotificationComponent, NotificationListComponent, MessageBoxComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/page-not-found</example-url>
 */
class PageNotFoundComponent {
    constructor() {
        this.home = '/v2/navigator/to/home';
    }
    goBack() {
        window.history.back();
    }
}
PageNotFoundComponent.ɵfac = function PageNotFoundComponent_Factory(t) { return new (t || PageNotFoundComponent)(); };
PageNotFoundComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PageNotFoundComponent, selectors: [["pmcc-page-not-found"]], inputs: { home: "home" }, decls: 28, vars: 1, consts: [[1, "pgnf"], [1, "pmcc-container"], [1, "pmcc-row"], [1, "pmcc-col"], [1, ""], [1, "pmcc-mar-bottom-sm"], [1, "heading-summary"], [1, "error-code"], [1, "back-action"], [1, "pmcc-btn-lg", "pmcc-primary", 3, "click"], [1, "extra-links"], [3, "href"], ["href", "mailto:support@pubmatic.com"], [1, "svg-pos"], ["xmlns", "http://www.w3.org/2000/svg", "width", "200", "viewBox", "0 0 153.6 126.4"], ["d", "M44.16 118.64c-1.583-1.583-1.094-3.57 1.24-5.048 3.452-2.184 4.92-4.485 5.484-8.592.456-3.318.762-3.8 2.42-3.8 1.043 0 1.897.342 1.897.76 0 3.02-2.084 9.292-3.742 11.263l-2 2.377h21.395c20.31 0 21.333-.07 20.168-1.4-2.296-2.62-3.82-6.513-3.82-9.76 0-2.642.28-3.24 1.51-3.24 1.188 0 1.63.81 2.075 3.8.458 3.076 1.237 4.445 4.09 7.187 3.665 3.52 4.187 4.833 2.565 6.454-1.374 1.374-51.906 1.374-53.28 0zM5.964 97.636L4 95.673V17.927l3.943-3.942 39.03.208C85.397 14.397 86 14.425 86 16s-.667 1.607-38.8 2l-38.8.4v76.8H130l.4-19.6c.386-18.934.454-19.6 2-19.6s1.607.608 1.826 18.4c.124 10.12.03 19.2-.2 20.178s-1.22 2.508-2.177 3.4c-1.718 1.6-2.57 1.622-62.827 1.622H7.927zm12.17-14.57c-.293-.293-.533-1.193-.533-2 0-1.408 2.146-1.467 53.225-1.467 48.065 0 53.273.124 53.717 1.28.27.704-.01 1.6-.625 1.988-1.284.813-104.974 1.007-105.783.198zM138.586 54.63l-8.913-9.002-4.637 2.36c-11.713 5.963-24.777 2.044-31.074-9.323C91.866 34.88 91.6 33.636 91.6 27.6c0-6.124.247-7.238 2.48-11.2 11.846-21.026 42.956-12.76 42.956 11.412 0 4.55-.418 6.26-2.533 10.36l-2.533 4.912 8.896 9.017c8.154 8.265 9.648 10.528 7.435 11.266-.44.147-4.81-3.784-9.713-8.736zm-18.932-8.208c11.163-3.33 17.072-16.237 12.28-26.823-7.948-17.558-32.206-14.878-36.75 4.06-2.258 9.414 3.536 19.276 13.388 22.792 3.95 1.4 6.284 1.404 11.08-.027zm-14.577-8.853c-.47-1.225.315-2.415 4.86-7.377l2.388-2.606-3.763-3.82c-2.07-2.102-3.763-4.26-3.763-4.793 0-2.04 3.002-.835 6.306 2.53l3.44 3.504 3.23-3.504c1.776-1.927 3.703-3.504 4.28-3.504 2.3 0 1.884 1.786-1.3 5.563l-3.34 3.962 3.762 4.403c3.485 4.08 4.077 6.07 1.806 6.07-.51 0-2.65-1.7-4.76-3.777l-3.835-3.778-3.654 4.178c-3.858 4.4-4.886 4.946-5.652 2.948z", "fill", "#a5c9ef"], ["d", "M43.657 117.46c-.36-.94.552-2.32 3.053-4.617 3.384-3.107 4.147-4.616 4.666-9.234.136-1.207.82-2.105 1.733-2.28 1.358-.26 1.47.12 1.12 3.772-.244 2.543-1.186 5.263-2.52 7.28l-2.13 3.22H93.1l-2.165-2.26c-2.28-2.38-3.734-6.247-3.734-9.935 0-1.672.387-2.205 1.6-2.205 1.237 0 1.6.533 1.6 2.348 0 3.714 1.393 6.448 4.94 9.69 6.063 5.542 5.97 5.563-24.428 5.563-24.28 0-26.787-.123-27.254-1.34zM8.286 98.814C3.95 97.045 4 97.526 4 56.667V18.89l3.86-4.49 37.47-.23 39.27.215c1.88.465 2.54 2.804.8 2.83-.55.008-17.798.002-38.328-.015-33.078-.026-37.473.115-38.6 1.242S7.2 23.97 7.2 56.8c0 32.648.15 37.236 1.257 38.343 1.12 1.12 7.722 1.257 60.64 1.257 45.12 0 59.613-.23 60.343-.96.7-.7.963-6.14.972-19.4.012-17.91.49-21.86 2.41-19.94.606.606.863 7.07.808 20.394-.075 18.367-.173 19.6-1.676 21.105-1.566 1.57-2.77 1.603-61.775 1.757-33.098.086-60.95-.158-61.892-.542zm9.466-17.41C18.006 80.082 21.11 80 71.21 80c46.746 0 53.19.146 53.19 1.2s-6.565 1.225-53.46 1.405c-50.63.195-53.445.13-53.19-1.2zM138.4 54.4c-4.604-4.62-8.795-8.4-9.312-8.4s-2.688.907-4.825 2.015c-8.45 4.384-17.77 3.19-24.864-3.187-10.47-9.413-10.47-25.042 0-34.456 10.98-9.87 27.37-6.955 34.637 6.162 2.098 3.787 2.363 5.03 2.363 11.066 0 6.002-.27 7.3-2.312 10.972l-2.312 4.172 6.43 7.028c3.537 3.866 7.367 7.9 8.512 8.967 2.217 2.066 2.74 4.06 1.067 4.06-.558 0-4.78-3.78-9.386-8.4zm-18.21-7.75c4.24-1.27 10.5-7.026 12.228-11.243 3.017-7.366 1.16-16.507-4.492-22.104C116.168 1.66 96.342 8.92 94.645 25.5c-.858 8.377 3.253 15.9 10.86 19.875 4.72 2.466 9.376 2.873 14.683 1.283zm-15.39-9.692c0-.574 1.3-2.284 2.866-3.8 4.947-4.76 4.983-5.243.718-9.573-3.45-3.502-4.113-5.583-1.78-5.583.5 0 2.456 1.7 4.346 3.8l3.436 3.8 3.407-3.807c1.874-2.094 3.857-3.804 4.407-3.8 2 .013.923 2.824-2.368 6.178l-3.368 3.432 3.877 3.937c2.8 2.84 3.727 4.328 3.338 5.34-.454 1.184-1.205.747-4.768-2.77l-4.23-4.177-3.773 4.033c-3.667 3.92-6.11 5.116-6.11 2.99z", "fill", "#12a3bf"]], template: function PageNotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "h1", 5);
        ɵngcc0.ɵɵtext(6, "Page Not Found");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtext(8, "We are sorry, we can't find the page you're looking for.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtext(10, "Error code: 404");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "button", 9);
        ɵngcc0.ɵɵlistener("click", function PageNotFoundComponent_Template_button_click_12_listener() { return ctx.goBack(); });
        ɵngcc0.ɵɵtext(13, "Go Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 10);
        ɵngcc0.ɵɵelementStart(15, "p");
        ɵngcc0.ɵɵtext(16, "Here are some other helpful links:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div");
        ɵngcc0.ɵɵelementStart(18, "a", 11);
        ɵngcc0.ɵɵtext(19, "Home");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div");
        ɵngcc0.ɵɵelementStart(21, "a", 12);
        ɵngcc0.ɵɵtext(22, "Contact Support");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 3);
        ɵngcc0.ɵɵelementStart(24, "div", 13);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(25, "svg", 14);
        ɵngcc0.ɵɵelement(26, "path", 15);
        ɵngcc0.ɵɵelement(27, "path", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(18);
        ɵngcc0.ɵɵproperty("href", ctx.home, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [".pgnf[_ngcontent-%COMP%]{display:block;width:100%;max-width:740px;border-radius:5px;padding:25px;font-size:13px;margin:100px auto}.pgnf[_ngcontent-%COMP%]   .error-code[_ngcontent-%COMP%], .pgnf[_ngcontent-%COMP%]   .heading-summary[_ngcontent-%COMP%]{margin-bottom:20px}.pgnf[_ngcontent-%COMP%]   .back-action[_ngcontent-%COMP%]{margin-bottom:30px}.pgnf[_ngcontent-%COMP%]   .extra-links[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-bottom:10px}.pgnf[_ngcontent-%COMP%]   .extra-links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-weight:700}.pgnf[_ngcontent-%COMP%]   .svg-pos[_ngcontent-%COMP%]{text-align:right}"] });
PageNotFoundComponent.ctorParameters = () => [];
PageNotFoundComponent.propDecorators = {
    home: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageNotFoundComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-page-not-found',
                template: "<div class=\"pgnf\">\n  <div class=\"pmcc-container\">\n    <div class=\"pmcc-row\">\n      <div class=\"pmcc-col\">\n        <div class=\" \">\n          <h1 class=\"pmcc-mar-bottom-sm\">Page Not Found</h1>\n          <div class=\"heading-summary\">We are sorry, we can't find the page you're looking for.</div>\n          <div class=\"error-code\">Error code: 404</div>\n          <div class=\"back-action\">\n            <button class=\"pmcc-btn-lg pmcc-primary\" (click)=\"goBack()\">Go Back</button>\n          </div>\n          <div class=\"extra-links\">\n            <p>Here are some other helpful links:</p>\n            <div><a [href]=home>Home</a></div>\n            <div><a href=\"mailto:support@pubmatic.com\">Contact Support</a></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"pmcc-col\">\n        <div class=\"svg-pos\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\"\n               width=\"200\"\n               viewBox=\"0 0 153.6 126.4\">\n            <path\n              d=\"M44.16 118.64c-1.583-1.583-1.094-3.57 1.24-5.048 3.452-2.184 4.92-4.485 5.484-8.592.456-3.318.762-3.8 2.42-3.8 1.043 0 1.897.342 1.897.76 0 3.02-2.084 9.292-3.742 11.263l-2 2.377h21.395c20.31 0 21.333-.07 20.168-1.4-2.296-2.62-3.82-6.513-3.82-9.76 0-2.642.28-3.24 1.51-3.24 1.188 0 1.63.81 2.075 3.8.458 3.076 1.237 4.445 4.09 7.187 3.665 3.52 4.187 4.833 2.565 6.454-1.374 1.374-51.906 1.374-53.28 0zM5.964 97.636L4 95.673V17.927l3.943-3.942 39.03.208C85.397 14.397 86 14.425 86 16s-.667 1.607-38.8 2l-38.8.4v76.8H130l.4-19.6c.386-18.934.454-19.6 2-19.6s1.607.608 1.826 18.4c.124 10.12.03 19.2-.2 20.178s-1.22 2.508-2.177 3.4c-1.718 1.6-2.57 1.622-62.827 1.622H7.927zm12.17-14.57c-.293-.293-.533-1.193-.533-2 0-1.408 2.146-1.467 53.225-1.467 48.065 0 53.273.124 53.717 1.28.27.704-.01 1.6-.625 1.988-1.284.813-104.974 1.007-105.783.198zM138.586 54.63l-8.913-9.002-4.637 2.36c-11.713 5.963-24.777 2.044-31.074-9.323C91.866 34.88 91.6 33.636 91.6 27.6c0-6.124.247-7.238 2.48-11.2 11.846-21.026 42.956-12.76 42.956 11.412 0 4.55-.418 6.26-2.533 10.36l-2.533 4.912 8.896 9.017c8.154 8.265 9.648 10.528 7.435 11.266-.44.147-4.81-3.784-9.713-8.736zm-18.932-8.208c11.163-3.33 17.072-16.237 12.28-26.823-7.948-17.558-32.206-14.878-36.75 4.06-2.258 9.414 3.536 19.276 13.388 22.792 3.95 1.4 6.284 1.404 11.08-.027zm-14.577-8.853c-.47-1.225.315-2.415 4.86-7.377l2.388-2.606-3.763-3.82c-2.07-2.102-3.763-4.26-3.763-4.793 0-2.04 3.002-.835 6.306 2.53l3.44 3.504 3.23-3.504c1.776-1.927 3.703-3.504 4.28-3.504 2.3 0 1.884 1.786-1.3 5.563l-3.34 3.962 3.762 4.403c3.485 4.08 4.077 6.07 1.806 6.07-.51 0-2.65-1.7-4.76-3.777l-3.835-3.778-3.654 4.178c-3.858 4.4-4.886 4.946-5.652 2.948z\"\n              fill=\"#a5c9ef\"/>\n            <path\n              d=\"M43.657 117.46c-.36-.94.552-2.32 3.053-4.617 3.384-3.107 4.147-4.616 4.666-9.234.136-1.207.82-2.105 1.733-2.28 1.358-.26 1.47.12 1.12 3.772-.244 2.543-1.186 5.263-2.52 7.28l-2.13 3.22H93.1l-2.165-2.26c-2.28-2.38-3.734-6.247-3.734-9.935 0-1.672.387-2.205 1.6-2.205 1.237 0 1.6.533 1.6 2.348 0 3.714 1.393 6.448 4.94 9.69 6.063 5.542 5.97 5.563-24.428 5.563-24.28 0-26.787-.123-27.254-1.34zM8.286 98.814C3.95 97.045 4 97.526 4 56.667V18.89l3.86-4.49 37.47-.23 39.27.215c1.88.465 2.54 2.804.8 2.83-.55.008-17.798.002-38.328-.015-33.078-.026-37.473.115-38.6 1.242S7.2 23.97 7.2 56.8c0 32.648.15 37.236 1.257 38.343 1.12 1.12 7.722 1.257 60.64 1.257 45.12 0 59.613-.23 60.343-.96.7-.7.963-6.14.972-19.4.012-17.91.49-21.86 2.41-19.94.606.606.863 7.07.808 20.394-.075 18.367-.173 19.6-1.676 21.105-1.566 1.57-2.77 1.603-61.775 1.757-33.098.086-60.95-.158-61.892-.542zm9.466-17.41C18.006 80.082 21.11 80 71.21 80c46.746 0 53.19.146 53.19 1.2s-6.565 1.225-53.46 1.405c-50.63.195-53.445.13-53.19-1.2zM138.4 54.4c-4.604-4.62-8.795-8.4-9.312-8.4s-2.688.907-4.825 2.015c-8.45 4.384-17.77 3.19-24.864-3.187-10.47-9.413-10.47-25.042 0-34.456 10.98-9.87 27.37-6.955 34.637 6.162 2.098 3.787 2.363 5.03 2.363 11.066 0 6.002-.27 7.3-2.312 10.972l-2.312 4.172 6.43 7.028c3.537 3.866 7.367 7.9 8.512 8.967 2.217 2.066 2.74 4.06 1.067 4.06-.558 0-4.78-3.78-9.386-8.4zm-18.21-7.75c4.24-1.27 10.5-7.026 12.228-11.243 3.017-7.366 1.16-16.507-4.492-22.104C116.168 1.66 96.342 8.92 94.645 25.5c-.858 8.377 3.253 15.9 10.86 19.875 4.72 2.466 9.376 2.873 14.683 1.283zm-15.39-9.692c0-.574 1.3-2.284 2.866-3.8 4.947-4.76 4.983-5.243.718-9.573-3.45-3.502-4.113-5.583-1.78-5.583.5 0 2.456 1.7 4.346 3.8l3.436 3.8 3.407-3.807c1.874-2.094 3.857-3.804 4.407-3.8 2 .013.923 2.824-2.368 6.178l-3.368 3.432 3.877 3.937c2.8 2.84 3.727 4.328 3.338 5.34-.454 1.184-1.205.747-4.768-2.77l-4.23-4.177-3.773 4.033c-3.667 3.92-6.11 5.116-6.11 2.99z\"\n              fill=\"#12a3bf\"/>\n          </svg>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".pgnf{display:block;width:100%;max-width:740px;border-radius:5px;padding:25px;font-size:13px;margin:100px auto}.pgnf .error-code,.pgnf .heading-summary{margin-bottom:20px}.pgnf .back-action{margin-bottom:30px}.pgnf .extra-links>*{margin-bottom:10px}.pgnf .extra-links a{font-weight:700}.pgnf .svg-pos{text-align:right}"]
            }]
    }], function () { return []; }, { home: [{
            type: Input
        }] }); })();

class PageNotFoundModule {
}
PageNotFoundModule.ɵfac = function PageNotFoundModule_Factory(t) { return new (t || PageNotFoundModule)(); };
PageNotFoundModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PageNotFoundModule });
PageNotFoundModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageNotFoundModule, [{
        type: NgModule,
        args: [{
                declarations: [PageNotFoundComponent],
                imports: [
                    CommonModule
                ],
                exports: [PageNotFoundComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageNotFoundModule, { declarations: function () { return [PageNotFoundComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PageNotFoundComponent]; } }); })();

class PageTitleComponent {
    constructor() {
        this.showHelpIcon = true;
    }
    ngOnChanges() {
        this.showHelpIcon = !!(this.helpLink || this.helpTooltip);
    }
}
PageTitleComponent.ɵfac = function PageTitleComponent_Factory(t) { return new (t || PageTitleComponent)(); };
PageTitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PageTitleComponent, selectors: [["pmcc-page-title"]], inputs: { heading: "heading", helpLink: "helpLink", helpTooltip: "helpTooltip" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: function () { let i18n_65; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_4467732120526767090$$FESM2015_PUBMATIC_PMCC_JS_66 = goog.getMsg("{$interpolation}\u00A0", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_65 = MSG_EXTERNAL_4467732120526767090$$FESM2015_PUBMATIC_PMCC_JS_66;
    }
    else {
        i18n_65 = $localize `:␟3bb5786097946a404ae688d6b2579ec840762b3d␟4467732120526767090:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } return [[1, "pmcc-page-title"], i18n_65, ["data-pm-id", "helpLink", 3, "pmccTooltip", 4, "ngIf"], ["data-pm-id", "helpLink", 3, "pmccTooltip"], ["target", "blank", "rel", "noopener noreferrer", 3, "href", 4, "ngIf"], ["name", "info", "size", "3x", 4, "ngIf"], ["target", "blank", "rel", "noopener noreferrer", 3, "href"], ["name", "info", "size", "3x"]]; }, template: function PageTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1", 0);
        ɵngcc0.ɵɵelementStart(1, "span");
        ɵngcc0.ɵɵi18n(2, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, PageTitleComponent_span_3_Template, 3, 3, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵi18nExp(ctx.heading);
        ɵngcc0.ɵɵi18nApply(2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showHelpIcon);
    } }, directives: [ɵngcc1.NgIf, TooltipDirective, IconComponent], styles: ["[_nghost-%COMP%]   .pmcc-page-title[_ngcontent-%COMP%]{margin:20px 0}[_nghost-%COMP%]   pmcc-icon[_ngcontent-%COMP%]{cursor:pointer;color:#222121}"], changeDetection: 0 });
PageTitleComponent.propDecorators = {
    heading: [{ type: Input }],
    helpLink: [{ type: Input }],
    helpTooltip: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageTitleComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-page-title',
                template: "<h1 class=\"pmcc-page-title\">\n  <span i18n>{{ heading }}&nbsp;</span>\n\n  <span *ngIf=\"showHelpIcon\"\n        data-pm-id=\"helpLink\"\n        [pmccTooltip]=\"helpTooltip || 'Help'\">\n    <a *ngIf=\"helpLink\"\n       [href]=\"helpLink\"\n       target=\"blank\"\n       rel=\"noopener noreferrer\">\n      <pmcc-icon name=\"info\" size=\"3x\"></pmcc-icon>\n    </a>\n    <pmcc-icon *ngIf=\"!helpLink\" name=\"info\" size=\"3x\"></pmcc-icon>\n  </span>\n</h1>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host .pmcc-page-title{margin:20px 0}:host pmcc-icon{cursor:pointer;color:#222121}"]
            }]
    }], function () { return []; }, { heading: [{
            type: Input
        }], helpLink: [{
            type: Input
        }], helpTooltip: [{
            type: Input
        }] }); })();

class PageTitleModule {
}
PageTitleModule.ɵfac = function PageTitleModule_Factory(t) { return new (t || PageTitleModule)(); };
PageTitleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PageTitleModule });
PageTitleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TooltipModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageTitleModule, [{
        type: NgModule,
        args: [{
                declarations: [PageTitleComponent],
                imports: [CommonModule, TooltipModule, IconModule],
                exports: [PageTitleComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageTitleModule, { declarations: function () { return [PageTitleComponent]; }, imports: function () { return [CommonModule, TooltipModule, IconModule]; }, exports: function () { return [PageTitleComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/panel</example-url>
 */
class PanelComponent {
    constructor() {
        this._type = 'default';
    }
    set type(val) {
        this._type = val;
    }
    get type() {
        return this._type;
    }
}
PanelComponent.ɵfac = function PanelComponent_Factory(t) { return new (t || PanelComponent)(); };
PanelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PanelComponent, selectors: [["pmcc-panel"]], hostVars: 6, hostBindings: function PanelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-panel", ctx.type !== "light")("pmcc-panel-light", ctx.type === "light")("pmcc-panel-tabbed", ctx.type === "tabbed");
    } }, inputs: { type: "type" }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function PanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [_c67], encapsulation: 2, changeDetection: 0 });
PanelComponent.propDecorators = {
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PanelComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-panel',
                template: "<ng-content></ng-content>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    '[class.pmcc-panel]': 'type !== "light"',
                    '[class.pmcc-panel-light]': 'type === "light"',
                    '[class.pmcc-panel-tabbed]': 'type === "tabbed"'
                },
                styles: [".pmcc-panel{font-size:13px;position:relative;display:block}.pmcc-panel .pmcc-group>*{margin-top:5px;margin-bottom:5px}.pmcc-panel .pmcc-toolbar{position:relative;display:block;background-color:#d5d6d7;padding:5px 10px}.pmcc-panel .pmcc-toolbar.pmcc-pagination{background-color:#fefefe!important}.pmcc-panel .pmcc-panel-header,.pmcc-panel .pmcc-sub-header,.pmcc-panel footer,.pmcc-panel header{position:relative;padding-left:10px;padding-right:10px;background:#6b747a;display:block}.pmcc-panel .pmcc-panel-header .pmcc-title,.pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel footer .pmcc-title,.pmcc-panel header .pmcc-title{letter-spacing:.3px;color:#fff;font:normal 16px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif}.pmcc-panel.pmcc-panel-white .pmcc-panel-header,.pmcc-panel.pmcc-panel-white .pmcc-sub-header,.pmcc-panel.pmcc-panel-white footer,.pmcc-panel.pmcc-panel-white header{background:#fff}.pmcc-panel.pmcc-panel-white .pmcc-panel-header .pmcc-title,.pmcc-panel.pmcc-panel-white .pmcc-sub-header .pmcc-title,.pmcc-panel.pmcc-panel-white footer .pmcc-title,.pmcc-panel.pmcc-panel-white header .pmcc-title{color:#222121;font-size:18px;font-weight:bolder;font-family:Helvetica,Arial,Calibri,sans-serif}.pmcc-panel .pmcc-sub-header{letter-spacing:.3px;background-color:#eaeaea;color:#222121;font:normal 14px Helvetica Neue Medium,HelveticaNeue-Medium,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;padding-top:10px;padding-bottom:10px;border-radius:3px}.pmcc-panel .pmcc-content,.pmcc-panel .pmcc-sub-content{background:#fff;display:block;padding:10px;overflow:auto;font-size:13px;color:#222121}.pmcc-panel .pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel footer{background-color:#f5f5f5;color:#6b747a;font:normal 12px Arial,Helvetica,Calibri,sans-serif}.pmcc-panel .pmcc-content:first-child:last-child,.pmcc-panel .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-content.hidden{height:0}.pmcc-panel+.pmcc-panel,.pmcc-panel+.pmcc-panel-light{margin-top:20px}.pmcc-panel>*{border-left:1px solid #c3c3c3;border-right:1px solid #c3c3c3;border-bottom:1px solid #c3c3c3}.pmcc-panel>:first-child{border-top:1px solid #c3c3c3;border-top-left-radius:3px;border-top-right-radius:3px}.pmcc-panel>:not([style*=\"display:none\"]):last-child{border-bottom:1px solid #c3c3c3;border-bottom-left-radius:3px;border-bottom-right-radius:3px;box-shadow:0 2px 3px #0202021f}.pmcc-panel.pmcc-filter .pmcc-content,.pmcc-panel.pmcc-filter .pmcc-sub-content{background:#f5f5f5;border:none;box-shadow:none;padding:20px 15px;color:#656d6f}.pmcc-panel-light{background:#fff;position:relative;margin-top:0;display:block;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-shadow:#00000003 0 0 1px;border:1px solid #b8b6b7;padding:20px;border-radius:5px}.pmcc-panel-light+.pmcc-panel,.pmcc-panel-light+.pmcc-panel-light{margin-top:20px}.pmcc-panel-light>.pmcc-content,.pmcc-panel .pmcc-panel-light>.pmcc-sub-content{background:#fff;padding:10px 0;overflow:auto}.pmcc-panel-light>.pmcc-content.pmcc-no-pad,.pmcc-panel .pmcc-panel-light>.pmcc-no-pad.pmcc-sub-content{padding:0}.pmcc-panel-light .pmcc-content:first-child:last-child,.pmcc-panel-light .pmcc-panel .pmcc-sub-content:first-child:last-child,.pmcc-panel .pmcc-panel-light .pmcc-sub-content:first-child:last-child{border-radius:3px}.pmcc-panel-light .pmcc-content.hidden,.pmcc-panel-light .pmcc-panel .hidden.pmcc-sub-content,.pmcc-panel .pmcc-panel-light .hidden.pmcc-sub-content{height:0}.pmcc-panel-light .pmcc-panel .pmcc-sub-header .pmcc-title,.pmcc-panel-light footer .pmcc-title,.pmcc-panel-light header .pmcc-title,.pmcc-panel .pmcc-panel-light .pmcc-sub-header .pmcc-title{font:normal 16px Helvetica Neue Light,HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,Calibri,sans-serif;margin:0;padding:0 0 10px}.pmcc-panel-light>*+*{border-top:1px solid #c7c7c7}.pmcc-horizontal-panel-divider{display:block;text-align:center;overflow:hidden;white-space:nowrap}.pmcc-horizontal-panel-divider>span{position:relative;display:inline-block;margin:6px 0}.pmcc-horizontal-panel-divider>span:after,.pmcc-horizontal-panel-divider>span:before{content:\"\";position:absolute;top:50%;width:9999px;height:1px;background:#d4d4d4}.pmcc-horizontal-panel-divider>span:before{right:100%;margin-right:15px}.pmcc-horizontal-panel-divider>span:after{left:100%;margin-left:15px}"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }] }); })();

class PanelModule {
}
PanelModule.ɵfac = function PanelModule_Factory(t) { return new (t || PanelModule)(); };
PanelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PanelModule });
PanelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PanelModule, [{
        type: NgModule,
        args: [{
                declarations: [PanelComponent],
                imports: [
                    CommonModule
                ],
                exports: [PanelComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PanelModule, { declarations: function () { return [PanelComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PanelComponent]; } }); })();

/**
 * To cover the use case where a process unexpectedly takes longer to complete
 * than the fixed value, the progress bar pauses at 90%.
 */
const stopProgressAt = 90;
class ProgressBarComponent {
    constructor(cd, ngZone) {
        this.cd = cd;
        this.ngZone = ngZone;
        this._percentDone = 0;
        this.timer$ = Subscription.EMPTY;
        this.minProgress = 0;
        this.maxProgress = 100;
        this.color = '#16ab17';
    }
    get percentDone() {
        return this._percentDone;
    }
    set percentDone(value) {
        this._percentDone = clamp(coerceNumberProperty(value), this.minProgress, this.maxProgress);
    }
    set duration(value) {
        this._duration = coerceNumberProperty(value, undefined);
    }
    set autoStart(value) {
        this._autoStart = coerceBooleanProperty$1(value);
    }
    get isRunning() {
        return !this.timer$.closed;
    }
    ngOnInit() {
        if (this._autoStart) {
            this.start();
        }
    }
    ngOnDestroy() {
        this.pause();
    }
    /**
     * Start the progress.
     * Noop if duration is not specified.
     */
    start() {
        if (this._duration != null) {
            this.ngZone.runOutsideAngular(() => this.setupTimer());
        }
    }
    /**
     * Pause the progress.
     * Can be continued by calling `start`.
     */
    pause() {
        this.timer$.unsubscribe();
    }
    /**
     * Reset the progress and start from 0.
     */
    restart() {
        this.pause();
        this.reset();
        this.start();
    }
    /**
     * Set the progress to 0 and stop.
     */
    reset() {
        this.setPercentDone(this.minProgress);
        if (this.isRunning) {
            this.pause();
        }
    }
    /**
     * Set the progress to specified value.
     */
    setPercentDone(percentDone) {
        this.percentDone = percentDone;
        this.cd.markForCheck();
    }
    /**
     * Complete the progress and stop.
     */
    complete() {
        this.setPercentDone(this.maxProgress);
        this.pause();
    }
    setupTimer() {
        const interval = this._duration / this.maxProgress;
        this.timer$ = timer(interval, interval) // initial delay, timer interval
            .pipe(tap(() => this.ngZone.run(() => this.setPercentDone(this.percentDone + 1))), 
        // stop the progress when `stopProgressAt` is reached
        takeWhile(() => this.percentDone < stopProgressAt))
            .subscribe();
    }
}
ProgressBarComponent.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ProgressBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["pmcc-progress-bar"]], hostVars: 3, hostBindings: function ProgressBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-valuemin", ctx.minProgress)("aria-valuemax", ctx.maxProgress)("aria-valuenow", ctx.percentDone);
    } }, inputs: { color: "color", percentDone: "percentDone", duration: "duration", autoStart: "autoStart" }, decls: 2, vars: 4, consts: [[1, "pmcc-progress"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\u00A0\n");
        ɵngcc0.ɵɵelement(1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.percentDone, "%")("background-color", ctx.color);
    } }, styles: ["[_nghost-%COMP%]{display:block;position:relative;width:100%;background-color:#f9f9f9;border:1px solid #dbdbdb;border-radius:15px;overflow:hidden}[_nghost-%COMP%]   .pmcc-progress[_ngcontent-%COMP%]{position:absolute;width:0;height:100%;top:0;left:0;z-index:1}"], changeDetection: 0 });
ProgressBarComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NgZone }
];
ProgressBarComponent.propDecorators = {
    minProgress: [{ type: HostBinding, args: ['attr.aria-valuemin',] }],
    maxProgress: [{ type: HostBinding, args: ['attr.aria-valuemax',] }],
    color: [{ type: Input }],
    percentDone: [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuenow',] }],
    duration: [{ type: Input }],
    autoStart: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-progress-bar',
                template: "&nbsp;\n<div class=\"pmcc-progress\" [style.width.%]=\"percentDone\" [style.background-color]=\"color\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;position:relative;width:100%;background-color:#f9f9f9;border:1px solid #dbdbdb;border-radius:15px;overflow:hidden}:host .pmcc-progress{position:absolute;width:0;height:100%;top:0;left:0;z-index:1}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { minProgress: [{
            type: HostBinding,
            args: ['attr.aria-valuemin']
        }], maxProgress: [{
            type: HostBinding,
            args: ['attr.aria-valuemax']
        }], color: [{
            type: Input
        }], percentDone: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }], duration: [{
            type: Input
        }], autoStart: [{
            type: Input
        }] }); })();

class ProgressBarModule {
}
ProgressBarModule.ɵfac = function ProgressBarModule_Factory(t) { return new (t || ProgressBarModule)(); };
ProgressBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProgressBarModule });
ProgressBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarModule, [{
        type: NgModule,
        args: [{
                declarations: [ProgressBarComponent],
                imports: [CommonModule],
                exports: [ProgressBarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProgressBarModule, { declarations: function () { return [ProgressBarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ProgressBarComponent]; } }); })();

/**
 * This is used to solve circular dependency issue.
 * RadioGroup uses RadioButton as a @ContentChildren() and
 * RadioButton injects RadioGroup to communicate with it.
 */
const RADIO_GROUP = new InjectionToken('RadioGroup');

/**
 * Demo example
 * <example-url>/demo/#/pmcc/radio-button</example-url>
 */
class RadioButtonComponent {
    constructor(radioGroup) {
        this.radioGroup = radioGroup;
        this._value = null;
        this._required = false;
        this._disabled = false;
        this._checked = false;
        this._groupChangesSubscription = Subscription.EMPTY;
        this.noSelectClassName = true;
        /**
         * Event emitted when the group value changes.
         * Emitted only when the value changes triggered by interaction.
         */
        this.change = new EventEmitter();
        this.onModelChange = () => { };
    }
    /**
     * The value that would be set when the button is checked
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.radioGroup && !this._checked) {
                this.checked = this.radioGroup.value === value;
            }
        }
    }
    get disabled() {
        return this._disabled || (!!this.radioGroup && this.radioGroup.disabled);
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty(disabled);
    }
    get checked() {
        return this._checked;
    }
    set checked(checked) {
        this._checked = coerceBooleanProperty(checked);
    }
    get required() {
        return this._required || (!!this.radioGroup && this.radioGroup.required);
    }
    set required(required) {
        this._required = required;
    }
    ngOnInit() {
        if (this.radioGroup) {
            this.checked = this.radioGroup.value === this._value;
            this.name = this.radioGroup.name;
            this._groupChangesSubscription = this.radioGroup.valueChange.subscribe(value => (this.checked = this._value === value));
        }
    }
    ngOnDestroy() {
        this._groupChangesSubscription.unsubscribe();
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(val) {
        this.checked = val === this._value;
    }
    onInputChange(event) {
        // Stop propagation for change event of the input element.
        // Otherwise it bubbles up and the callback gets called with an event object
        event.stopPropagation();
        this.checked = true;
        this.onModelChange(this._value);
        this.change.emit({
            value: this._value,
            checked: this.checked
        });
        if (this.radioGroup) {
            this.radioGroup.onChange(this._value);
        }
    }
    onInputClick(event) {
        // Prevent host's (click) event from triggering twice
        event.stopPropagation();
    }
    onBlur() {
        this.onTouched();
    }
}
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(ɵngcc0.ɵɵdirectiveInject(RADIO_GROUP, 8)); };
RadioButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["pmcc-radio-button"]], hostVars: 4, hostBindings: function RadioButtonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function RadioButtonComponent_blur_HostBindingHandler() { return ctx.onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-no-select", ctx.noSelectClassName)("pmcc-disabled", ctx.disabled);
    } }, inputs: { value: "value", checked: "checked", disabled: "disabled", required: "required", name: "name", id: "id", label: "label" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => RadioButtonComponent)
            }
        ])], decls: 4, vars: 8, consts: [["data-pm-id", "radio-icon", 1, "pmcc-rb-flag"], ["type", "radio", 1, "pmcc-visually-hidden", 3, "id", "checked", "disabled", "required", "change", "click"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label");
        ɵngcc0.ɵɵelement(1, "i", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementStart(3, "input", 1);
        ɵngcc0.ɵɵlistener("change", function RadioButtonComponent_Template_input_change_3_listener($event) { return ctx.onInputChange($event); })("click", function RadioButtonComponent_Template_input_click_3_listener($event) { return ctx.onInputClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("pmcc-rb-selected", ctx.checked);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("checked", ctx.checked)("disabled", ctx.disabled)("required", ctx.required);
        ɵngcc0.ɵɵattribute("name", ctx.name);
    } }, styles: ["[_nghost-%COMP%]{display:inline-block;cursor:pointer}.pmcc-disabled[_nghost-%COMP%]{opacity:.5;cursor:not-allowed;pointer-events:none}[_nghost-%COMP%]   label[_ngcontent-%COMP%]{margin-right:5px;cursor:inherit;position:relative}[_nghost-%COMP%]   .pmcc-rb-flag[_ngcontent-%COMP%]{position:relative;display:inline-block;height:14px;width:14px;border:1px solid #c9c9c9;border-radius:50%;background:#fff;box-sizing:initial;vertical-align:bottom;margin-right:5px}[_nghost-%COMP%]   .pmcc-rb-flag[_ngcontent-%COMP%]:after{content:\"\";display:inline-block;position:absolute}[_nghost-%COMP%]   .pmcc-rb-flag.pmcc-rb-selected[_ngcontent-%COMP%]:after{left:2px;top:2px;background:#0196d8;width:10px;height:10px;border-radius:50%}.pmcc-radio-button-group.pmcc-error[_ngcontent-%COMP%]{border:1px solid #c5242a!important;padding:5px 10px;display:inline-block;border-radius:3px}"] });
RadioButtonComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [RADIO_GROUP,] }] }
];
RadioButtonComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.pmcc-disabled',] }],
    checked: [{ type: Input }],
    required: [{ type: Input }],
    noSelectClassName: [{ type: HostBinding, args: ['class.pmcc-no-select',] }],
    label: [{ type: Input }],
    change: [{ type: Output }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-radio-button',
                template: "<label>\n  <i\n    class=\"pmcc-rb-flag\"\n    [class.pmcc-rb-selected]=\"checked\"\n    data-pm-id=\"radio-icon\"\n  ></i>{{ label }}\n  <input\n    [id]=\"id\"\n    type=\"radio\"\n    class=\"pmcc-visually-hidden\"\n    [checked]=\"checked\"\n    [disabled]=\"disabled\"\n    [required]=\"required\"\n    [attr.name]=\"name\"\n    (change)=\"onInputChange($event)\"\n    (click)=\"onInputClick($event)\"\n  />\n</label>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => RadioButtonComponent)
                    }
                ],
                styles: [":host{display:inline-block;cursor:pointer}:host.pmcc-disabled{opacity:.5;cursor:not-allowed;pointer-events:none}:host label{margin-right:5px;cursor:inherit;position:relative}:host .pmcc-rb-flag{position:relative;display:inline-block;height:14px;width:14px;border:1px solid #c9c9c9;border-radius:50%;background:#fff;box-sizing:initial;vertical-align:bottom;margin-right:5px}:host .pmcc-rb-flag:after{content:\"\";display:inline-block;position:absolute}:host .pmcc-rb-flag.pmcc-rb-selected:after{left:2px;top:2px;background:#0196d8;width:10px;height:10px;border-radius:50%}.pmcc-radio-button-group.pmcc-error{border:1px solid #c5242a!important;padding:5px 10px;display:inline-block;border-radius:3px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RADIO_GROUP]
            }] }]; }, { noSelectClassName: [{
            type: HostBinding,
            args: ['class.pmcc-no-select']
        }], change: [{
            type: Output
        }], value: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.pmcc-disabled']
        }], required: [{
            type: Input
        }], name: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], id: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

let nextId = 0;
class RadioGroupComponent {
    constructor() {
        this._disabled = false;
        this._required = false;
        this._name = `pmcc-radio-group-${nextId++}`;
        this.role = 'radiogroup';
        this.valueChange = new EventEmitter();
        this.change = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.updateSelectedRadio();
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
        this.updateRadioName();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = disabled;
        this.updateRadioDisabled();
    }
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = coerceBooleanProperty$1(required);
    }
    onChange(value) {
        const valueChanged = this._value !== value;
        this._value = value;
        this.onModelChange(this._value);
        if (valueChanged) {
            this.valueChange.emit(this._value);
            this.change.emit({
                value: this._value,
                checked: true
            });
        }
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.value = value;
    }
    updateSelectedRadio() {
        if (this.radios) {
            this.radios.forEach(btn => (btn.checked = this.value === btn.value));
        }
    }
    updateRadioDisabled() {
        if (this.radios) {
            this.radios.forEach(btn => (btn.disabled = this._disabled));
        }
    }
    updateRadioName() {
        if (this.radios) {
            this.radios.forEach(btn => (btn.name = this._name));
        }
    }
}
RadioGroupComponent.ɵfac = function RadioGroupComponent_Factory(t) { return new (t || RadioGroupComponent)(); };
RadioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioGroupComponent, selectors: [["pmcc-radio-group"]], contentQueries: function RadioGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, RadioButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radios = _t);
    } }, hostVars: 1, hostBindings: function RadioGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { value: "value", name: "name", disabled: "disabled", required: "required" }, outputs: { valueChange: "valueChange", change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioGroupComponent),
                multi: true
            },
            {
                provide: RADIO_GROUP,
                useExisting: forwardRef(() => RadioGroupComponent)
            }
        ])], ngContentSelectors: _c1, decls: 1, vars: 0, template: function RadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
RadioGroupComponent.propDecorators = {
    radios: [{ type: ContentChildren, args: [RadioButtonComponent, { descendants: true },] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    value: [{ type: Input }],
    name: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    valueChange: [{ type: Output }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-radio-group',
                template: '<ng-content></ng-content>',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioGroupComponent),
                        multi: true
                    },
                    {
                        provide: RADIO_GROUP,
                        useExisting: forwardRef(() => RadioGroupComponent)
                    }
                ]
            }]
    }], function () { return []; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], valueChange: [{
            type: Output
        }], change: [{
            type: Output
        }], value: [{
            type: Input
        }], name: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], radios: [{
            type: ContentChildren,
            args: [RadioButtonComponent, { descendants: true }]
        }] }); })();

class RadioButtonModule {
}
RadioButtonModule.ɵfac = function RadioButtonModule_Factory(t) { return new (t || RadioButtonModule)(); };
RadioButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RadioButtonModule });
RadioButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioButtonComponent, RadioGroupComponent],
                imports: [CommonModule],
                exports: [RadioButtonComponent, RadioGroupComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioButtonModule, { declarations: function () { return [RadioButtonComponent, RadioGroupComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [RadioButtonComponent, RadioGroupComponent]; } }); })();

const moveEventTypes = ['touchmove', 'mousemove'];
const endEventTypes = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
function getCurrentX(event) {
    return ('touches' in event ? event.touches[0] : event).pageX;
}
/**
 * Directive that corresponds to a range selector draggable handles.
 * Emits `move` event with the offset from initial position (X axis only).
 */
/** @dynamic */
class RangeHandleDirective {
    constructor(elRef, document, renderer) {
        this.elRef = elRef;
        this.document = document;
        this.renderer = renderer;
        this.move = new EventEmitter();
    }
    onStart(event) {
        const interactionStartX = getCurrentX(event);
        const initialPosX = this.elRef.nativeElement.offsetLeft;
        let listeners = [];
        const onMove = (e) => this.move.emit(initialPosX + getCurrentX(e) - interactionStartX);
        // `renderer.listen()` returns a function that removes the listener when called.
        const onEnd = () => listeners.forEach(listener => listener());
        // apply move and end listeners to `document`
        listeners = moveEventTypes
            .map(eventType => this.renderer.listen(this.document, eventType, onMove))
            .concat(endEventTypes.map(eventType => this.renderer.listen(this.document, eventType, onEnd)));
    }
}
RangeHandleDirective.ɵfac = function RangeHandleDirective_Factory(t) { return new (t || RangeHandleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
RangeHandleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RangeHandleDirective, selectors: [["pmcc-range-handle"]], hostBindings: function RangeHandleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function RangeHandleDirective_mousedown_HostBindingHandler($event) { return ctx.onStart($event); })("touchstart", function RangeHandleDirective_touchstart_HostBindingHandler($event) { return ctx.onStart($event); });
    } }, outputs: { move: "move" } });
RangeHandleDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
RangeHandleDirective.propDecorators = {
    move: [{ type: Output }],
    onStart: [{ type: HostListener, args: ['mousedown', ['$event'],] }, { type: HostListener, args: ['touchstart', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeHandleDirective, [{
        type: Directive,
        args: [{
                // it doesn't have a template so it makes sense
                // to use Directive.
                // tslint:disable-next-line
                selector: 'pmcc-range-handle'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { move: [{
            type: Output
        }], onStart: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }, {
            type: HostListener,
            args: ['touchstart', ['$event']]
        }] }); })();

const toPercent = (num) => num * 100;
const ɵ0$1 = toPercent;
const identity = (arg) => arg;
const ɵ1$1 = identity;
class RangeSelectorComponent {
    constructor() {
        this._numTicks = 0;
        this._roundTo = identity;
        this._low = 0;
        this._high = 0;
    }
    /**
     * Range selector's track width.
     */
    get trackWidth() {
        return this.track.nativeElement.clientWidth;
    }
    /**
     * Number of ticks to display on the track.
     * No ticks are rendered when 0 is passed.
     */
    get numTicks() {
        return this._numTicks;
    }
    set numTicks(value) {
        this._numTicks = coerceNumberProperty(value);
    }
    /**
     * Custom rounding function.
     */
    set roundTo(fn) {
        this._roundTo = fn || identity;
    }
    get min() {
        return this.range.min;
    }
    get max() {
        return this.range.max;
    }
    get high() {
        return this._high;
    }
    get low() {
        return this._low;
    }
    /**
     * Left handle offset in %.
     */
    get leftHandleOffset() {
        return toPercent((this.low - this.min) / this.rangeSize());
    }
    /**
     * Right handle offset in %.
     */
    get rightHandleOffset() {
        return toPercent((this.high - this.min) / this.rangeSize());
    }
    ngDoCheck() {
        // Range values can be mutated outside this component,
        // so it is possible that low and high are invalid, e.g. low > high.
        // Since ngOnChange won't be called on range's property mutation,
        // we keep this invariant manually here.
        this._low = this.clampLow(this.range.low);
        this._high = this.clampHigh(this.range.high);
        if (this._low !== this.range.low || this._high !== this.range.high) {
            // if we did intervene and fixed range values, we need to
            // apply them to the model in the next tick (to avoid ExpressionChangedAfterItHasBeenCheckedError);
            Promise.resolve().then(() => {
                this.range.low = this._low;
                this.range.high = this._high;
            });
        }
    }
    onLeftMove(offset) {
        this.range.low = this.clampLow(this.valueFromOffset(offset));
    }
    onRightMove(offset) {
        this.range.high = this.clampHigh(this.valueFromOffset(offset));
    }
    /**
     * Calculates range value based on the offset in pixels from
     * the start of the track.
     */
    valueFromOffset(offset) {
        return this._roundTo((offset / this.trackWidth) * this.rangeSize() + this.min);
    }
    /**
     * Makes sure that min <= range.low <= high.
     */
    clampLow(low) {
        return clamp(low, this.min, this.high);
    }
    /**
     * Makes sure that low <= range.high <= max.
     */
    clampHigh(high) {
        return clamp(high, this.low, this.max);
    }
    rangeSize() {
        return this.max - this.min;
    }
}
RangeSelectorComponent.ɵfac = function RangeSelectorComponent_Factory(t) { return new (t || RangeSelectorComponent)(); };
RangeSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RangeSelectorComponent, selectors: [["pmcc-range-selector"]], viewQuery: function RangeSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c68, 7);
        ɵngcc0.ɵɵviewQuery(_c69, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c70, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.track = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftHandle = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rightHandle = _t.first);
    } }, hostVars: 2, hostBindings: function RangeSelectorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-min", ctx.min)("data-max", ctx.max);
    } }, inputs: { numTicks: "numTicks", roundTo: "roundTo", range: "range" }, decls: 8, vars: 15, consts: [[1, "pmcc-range-track"], ["track", ""], [3, "tickCount"], ["role", "slider", 3, "move"], ["leftHandle", ""], [1, "band"], ["rightHandle", ""]], template: function RangeSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelement(2, "pmcc-range-ticks", 2);
        ɵngcc0.ɵɵelementStart(3, "pmcc-range-handle", 3, 4);
        ɵngcc0.ɵɵlistener("move", function RangeSelectorComponent_Template_pmcc_range_handle_move_3_listener($event) { return ctx.onLeftMove($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "pmcc-range-handle", 3, 6);
        ɵngcc0.ɵɵlistener("move", function RangeSelectorComponent_Template_pmcc_range_handle_move_6_listener($event) { return ctx.onRightMove($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("tickCount", ctx.numTicks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("left", ctx.leftHandleOffset, "%");
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.low)("aria-valuemin", ctx.min)("aria-valuemax", ctx.high);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("left", ctx.leftHandleOffset, "%")("width", ctx.rightHandleOffset - ctx.leftHandleOffset, "%");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("left", ctx.rightHandleOffset, "%");
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.high)("aria-valuemin", ctx.low)("aria-valuemax", ctx.max);
    } }, directives: function () { return [RangeTicksComponent, RangeHandleDirective]; }, styles: ["[_nghost-%COMP%]{-webkit-user-select:none;user-select:none;display:block;height:40px;font:13px Helvetica,Arial;position:relative;margin-top:2px;padding-left:13px;padding-right:13px}[_nghost-%COMP%]:after, [_nghost-%COMP%]:before{position:absolute;display:inline-block;top:25px;color:#222121;z-index:2}[_nghost-%COMP%]:before{content:attr(data-min);left:13px}[_nghost-%COMP%]:after{content:attr(data-max);right:13px}[_nghost-%COMP%]   .pmcc-range-track[_ngcontent-%COMP%]{position:relative;display:inline-block;width:100%;height:10px;margin-top:7px;background:#f5f5f5;border:1px solid #ddd}[_nghost-%COMP%]   .band[_ngcontent-%COMP%]{position:absolute;top:-1px;height:10px;border:1px solid #c9dce4;background-color:#d9edf6}[_nghost-%COMP%]   pmcc-range-handle[_ngcontent-%COMP%]{display:inline-flex;align-items:center;position:absolute;width:13px;top:0;bottom:0;z-index:4;line-height:18px}[_nghost-%COMP%]   pmcc-range-handle[_ngcontent-%COMP%]:before{content:\"||\";display:inline-block;padding:3px 2px;background:#fdfdfd;border:1px solid #999;cursor:ew-resize;color:#999}[_nghost-%COMP%]   pmcc-range-handle[_ngcontent-%COMP%]:first-of-type:before{position:relative;left:-13px;border-top-left-radius:3px;border-bottom-left-radius:3px}[_nghost-%COMP%]   pmcc-range-handle[_ngcontent-%COMP%]:last-of-type:before{border-top-right-radius:3px;border-bottom-right-radius:3px}"] });
RangeSelectorComponent.propDecorators = {
    track: [{ type: ViewChild, args: ['track', { static: true },] }],
    leftHandle: [{ type: ViewChild, args: ['leftHandle', { read: ElementRef, static: true },] }],
    rightHandle: [{ type: ViewChild, args: ['rightHandle', { read: ElementRef, static: true },] }],
    range: [{ type: Input }],
    numTicks: [{ type: Input }],
    roundTo: [{ type: Input }],
    min: [{ type: HostBinding, args: ['attr.data-min',] }],
    max: [{ type: HostBinding, args: ['attr.data-max',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-range-selector',
                template: "<div #track class=\"pmcc-range-track\">\n  <pmcc-range-ticks [tickCount]=\"numTicks\"></pmcc-range-ticks>\n\n  <pmcc-range-handle\n    #leftHandle\n    role=\"slider\"\n    [attr.aria-valuenow]=\"low\"\n    [attr.aria-valuemin]=\"min\"\n    [attr.aria-valuemax]=\"high\"\n    [style.left.%]=\"leftHandleOffset\"\n    (move)=\"onLeftMove($event)\"\n  ></pmcc-range-handle>\n  <div\n    class=\"band\"\n    [style.left.%]=\"leftHandleOffset\"\n    [style.width.%]=\"rightHandleOffset - leftHandleOffset\"\n  ></div>\n  <pmcc-range-handle\n    #rightHandle\n    role=\"slider\"\n    [attr.aria-valuenow]=\"high\"\n    [attr.aria-valuemin]=\"low\"\n    [attr.aria-valuemax]=\"max\"\n    [style.left.%]=\"rightHandleOffset\"\n    (move)=\"onRightMove($event)\"\n  ></pmcc-range-handle>\n</div>\n",
                styles: [":host{-webkit-user-select:none;user-select:none;display:block;height:40px;font:13px Helvetica,Arial;position:relative;margin-top:2px;padding-left:13px;padding-right:13px}:host:after,:host:before{position:absolute;display:inline-block;top:25px;color:#222121;z-index:2}:host:before{content:attr(data-min);left:13px}:host:after{content:attr(data-max);right:13px}:host .pmcc-range-track{position:relative;display:inline-block;width:100%;height:10px;margin-top:7px;background:#f5f5f5;border:1px solid #ddd}:host .band{position:absolute;top:-1px;height:10px;border:1px solid #c9dce4;background-color:#d9edf6}:host pmcc-range-handle{display:inline-flex;align-items:center;position:absolute;width:13px;top:0;bottom:0;z-index:4;line-height:18px}:host pmcc-range-handle:before{content:\"||\";display:inline-block;padding:3px 2px;background:#fdfdfd;border:1px solid #999;cursor:ew-resize;color:#999}:host pmcc-range-handle:first-of-type:before{position:relative;left:-13px;border-top-left-radius:3px;border-bottom-left-radius:3px}:host pmcc-range-handle:last-of-type:before{border-top-right-radius:3px;border-bottom-right-radius:3px}"]
            }]
    }], function () { return []; }, { numTicks: [{
            type: Input
        }], roundTo: [{
            type: Input
        }], min: [{
            type: HostBinding,
            args: ['attr.data-min']
        }], max: [{
            type: HostBinding,
            args: ['attr.data-max']
        }], track: [{
            type: ViewChild,
            args: ['track', { static: true }]
        }], leftHandle: [{
            type: ViewChild,
            args: ['leftHandle', { read: ElementRef, static: true }]
        }], rightHandle: [{
            type: ViewChild,
            args: ['rightHandle', { read: ElementRef, static: true }]
        }], range: [{
            type: Input
        }] }); })();

/**
 * Renders specified number of ticks for range selector.
 * Ticks are distributed evenly using flex: 1.
 */
class RangeTicksComponent {
    constructor(cd) {
        this.cd = cd;
        this._ticks = [];
    }
    set tickCount(value) {
        if (value !== this._ticks.length) {
            this._ticks = new Array(value).fill(null);
            this.cd.markForCheck();
        }
    }
    get ticks() {
        return this._ticks;
    }
}
RangeTicksComponent.ɵfac = function RangeTicksComponent_Factory(t) { return new (t || RangeTicksComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
RangeTicksComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RangeTicksComponent, selectors: [["pmcc-range-ticks"]], inputs: { tickCount: "tickCount" }, decls: 1, vars: 1, consts: [["class", "pmcc-range-tick", 4, "ngFor", "ngForOf"], [1, "pmcc-range-tick"]], template: function RangeTicksComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RangeTicksComponent_div_0_Template, 1, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ticks);
    } }, directives: [ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]{position:absolute;left:0;right:0;bottom:0;display:inline-flex;overflow:hidden;height:100%;z-index:2}[_nghost-%COMP%]   .pmcc-range-tick[_ngcontent-%COMP%]{position:relative;flex:1;height:100%}[_nghost-%COMP%]   .pmcc-range-tick[_ngcontent-%COMP%]:not(:last-of-type){border-right:1px solid #b1c2c9}"], changeDetection: 0 });
RangeTicksComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
RangeTicksComponent.propDecorators = {
    tickCount: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeTicksComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-range-ticks',
                template: "<div class=\"pmcc-range-tick\" *ngFor=\"let tick of ticks\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{position:absolute;left:0;right:0;bottom:0;display:inline-flex;overflow:hidden;height:100%;z-index:2}:host .pmcc-range-tick{position:relative;flex:1;height:100%}:host .pmcc-range-tick:not(:last-of-type){border-right:1px solid #b1c2c9}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { tickCount: [{
            type: Input
        }] }); })();

class RangeSelectorModule {
}
RangeSelectorModule.ɵfac = function RangeSelectorModule_Factory(t) { return new (t || RangeSelectorModule)(); };
RangeSelectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RangeSelectorModule });
RangeSelectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeSelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    RangeSelectorComponent,
                    RangeTicksComponent,
                    RangeHandleDirective
                ],
                imports: [CommonModule],
                exports: [RangeSelectorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RangeSelectorModule, { declarations: function () { return [RangeSelectorComponent, RangeTicksComponent, RangeHandleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [RangeSelectorComponent]; } }); })();

function scrollbarWidth() {
    const div = document.createElement('div');
    div.style.width = '100px';
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    div.style.top = '-9999px';
    document.body.appendChild(div);
    const width = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return width;
}
/**
 * This component represents a table with a fixed header.
 * Since native HTML tables don't support this feature,
 * we split the table into two - the first renders table head,
 * the second renders table body wrapped in a scrollable container.
 */
class ScrollableTableComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        this.pmccScrollEnd = new EventEmitter();
        this.scrollbarWidth = scrollbarWidth();
        this.hasScroll = false;
    }
    ngAfterContentInit() {
        setTimeout(() => this.checkScroll());
    }
    checkScroll() {
        const el = this.container.nativeElement;
        this.hasScroll = el.scrollHeight > el.offsetHeight;
        this._cdr.detectChanges();
    }
    onHeadScroll() {
        this.container.nativeElement.scrollLeft = this.header.nativeElement.scrollLeft;
    }
    onScroll() {
        const el = this.container.nativeElement;
        if (this.pmccScrollEnd.observers.length > 0
            && (el.scrollTop + el.offsetHeight >= el.scrollHeight)) {
            this.pmccScrollEnd.emit();
        }
        this.header.nativeElement.scrollLeft = el.scrollLeft;
    }
}
ScrollableTableComponent.ɵfac = function ScrollableTableComponent_Factory(t) { return new (t || ScrollableTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ScrollableTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollableTableComponent, selectors: [["pmcc-scrollable-table"]], viewQuery: function ScrollableTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c71, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c72, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, inputs: { scrollableTableHeaderClasses: "scrollableTableHeaderClasses", scrollableTableBodyClasses: "scrollableTableBodyClasses", scrollableTableHeight: "scrollableTableHeight" }, outputs: { pmccScrollEnd: "pmccScrollEnd" }, ngContentSelectors: _c74, decls: 9, vars: 8, consts: [[1, "header-container", 3, "scroll"], ["scrollableTableHeader", ""], [1, "pmcc-table", "pmcc-fixed-header", 3, "ngClass"], [1, "pmcc-table-scrollable", 3, "scroll"], ["scrollableTable", ""], [1, "pmcc-table", 3, "ngClass", "cdkObserveContent"]], template: function ScrollableTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c73);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("scroll", function ScrollableTableComponent_Template_div_scroll_0_listener() { return ctx.onHeadScroll(); });
        ɵngcc0.ɵɵelementStart(2, "table", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3, 4);
        ɵngcc0.ɵɵlistener("scroll", function ScrollableTableComponent_Template_div_scroll_4_listener() { return ctx.onScroll(); });
        ɵngcc0.ɵɵelementStart(6, "table", 5);
        ɵngcc0.ɵɵlistener("cdkObserveContent", function ScrollableTableComponent_Template_table_cdkObserveContent_6_listener() { return ctx.checkScroll(); });
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵprojection(8, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("padding-right", ctx.hasScroll ? ctx.scrollbarWidth : 0, "px");
        ɵngcc0.ɵɵclassProp("has-scroll", ctx.hasScroll);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.scrollableTableHeaderClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("max-height", ctx.scrollableTableHeight, "px");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.scrollableTableBodyClasses);
    } }, directives: [ɵngcc1.NgClass, ɵngcc2.CdkObserveContent], styles: [".header-container[_ngcontent-%COMP%]{overflow-x:auto;-ms-overflow-style:none;scrollbar-width:none;border:1px solid #ebebeb}.header-container[_ngcontent-%COMP%]   .pmcc-table[_ngcontent-%COMP%]{margin-top:0}.header-container[_ngcontent-%COMP%]     th{border-top:none;border-bottom:none}.header-container.has-scroll[_ngcontent-%COMP%]{background-color:#f5f5f5}.header-container.has-scroll[_ngcontent-%COMP%]     th:last-of-type{border-right:none}.header-container[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}"] });
ScrollableTableComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ScrollableTableComponent.propDecorators = {
    scrollableTableHeaderClasses: [{ type: Input }],
    scrollableTableBodyClasses: [{ type: Input }],
    scrollableTableHeight: [{ type: Input }],
    pmccScrollEnd: [{ type: Output }],
    header: [{ type: ViewChild, args: ['scrollableTableHeader', { read: ElementRef },] }],
    container: [{ type: ViewChild, args: ['scrollableTable',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollableTableComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-scrollable-table',
                template: "<div\n  #scrollableTableHeader\n  (scroll)=\"onHeadScroll()\"\n  class=\"header-container\"\n  [class.has-scroll]=\"hasScroll\"\n  [style.padding-right.px]=\"hasScroll ? scrollbarWidth : 0\"\n>\n  <table\n    class=\"pmcc-table pmcc-fixed-header\"\n    [ngClass]=\"scrollableTableHeaderClasses\"\n  >\n    <ng-content select=\"thead\"></ng-content>\n  </table>\n</div>\n<div\n  #scrollableTable\n  (scroll)=\"onScroll()\"\n  class=\"pmcc-table-scrollable\"\n  [style.maxHeight.px]=\"scrollableTableHeight\"\n>\n  <table\n    class=\"pmcc-table\"\n    [ngClass]=\"scrollableTableBodyClasses\"\n    (cdkObserveContent)=\"checkScroll()\"\n  >\n    <ng-content select=\"tbody\"></ng-content>\n    <ng-content select=\"tfoot\"></ng-content>\n  </table>\n</div>\n",
                styles: [".header-container{overflow-x:auto;-ms-overflow-style:none;scrollbar-width:none;border:1px solid #ebebeb}.header-container .pmcc-table{margin-top:0}.header-container ::ng-deep th{border-top:none;border-bottom:none}.header-container.has-scroll{background-color:#f5f5f5}.header-container.has-scroll ::ng-deep th:last-of-type{border-right:none}.header-container::-webkit-scrollbar{display:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { pmccScrollEnd: [{
            type: Output
        }], scrollableTableHeaderClasses: [{
            type: Input
        }], scrollableTableBodyClasses: [{
            type: Input
        }], scrollableTableHeight: [{
            type: Input
        }], header: [{
            type: ViewChild,
            args: ['scrollableTableHeader', { read: ElementRef }]
        }], container: [{
            type: ViewChild,
            args: ['scrollableTable']
        }] }); })();

/* tslint:disable:no-magic-numbers */
class TableStickyColumnsDirective {
    constructor(tableRef) {
        this.tableRef = tableRef;
        this.scrollSubscription = Subscription.EMPTY;
        this.colWidth = [];
        this.leftOfCol = [];
        this.mapStickyCol = [];
        this.stickyColIndices = [];
        this.leftOfCol[0] = 0;
        this.table = [];
    }
    ngOnInit() {
        let div = this.tableRef.nativeElement.parentElement;
        let headerDiv;
        if (div.style.overflowX !== 'auto' && div.style.overflowX !== 'scroll') {
            div = this.tableRef.nativeElement.querySelector('.pmcc-table-scrollable');
            headerDiv = this.tableRef.nativeElement.querySelector('.header-container');
        }
        this.scrollSubscription = fromEvent(div, 'scroll').subscribe(() => {
            let theads = div.querySelectorAll('th');
            if (headerDiv) {
                theads = headerDiv.querySelectorAll('th');
            }
            const trows = div.querySelectorAll('tr');
            theads.forEach((thcell, ind) => {
                if (this.stickyColIndices.slice(-1)[0] === ind) {
                    const lastStickyCellLeft = thcell.getBoundingClientRect().left;
                    const divLeft = div.getBoundingClientRect().left;
                    let difference = Math.fround(lastStickyCellLeft - divLeft);
                    if (headerDiv) {
                        difference -= 1;
                    }
                    if (difference === Math.fround(Number(thcell.style.left.slice(0, -2)))) {
                        thcell.style.boxShadow = `3px 0 10px 0px rgba(201, 201, 201, 0.5)`;
                        trows.forEach(row => {
                            row.querySelectorAll('td').forEach((td, index) => {
                                if (index === ind) {
                                    td.style.boxShadow = `3px 0 10px 0px rgba(201, 201, 201, 0.5)`;
                                }
                            });
                        });
                    }
                    else {
                        thcell.style.boxShadow = null;
                        trows.forEach((tr) => {
                            tr.querySelectorAll('td').forEach((td, index) => {
                                if (index === ind) {
                                    td.style.boxShadow = null;
                                }
                            });
                        });
                    }
                }
            });
        });
    }
    ngOnDestroy() {
        this.scrollSubscription.unsubscribe();
    }
    ngAfterViewInit() {
        this.table = this.tableRef.nativeElement.querySelectorAll('table');
        if (this.table.length === 0) {
            this.tableRef.nativeElement.classList.add('pmcc-sticky-column');
        }
        else {
            this.table.forEach((item) => {
                item.classList.add('pmcc-sticky-column');
            });
        }
        const tbody = this.tableRef.nativeElement.querySelector('table tbody');
        const thead = this.tableRef.nativeElement.querySelector('table thead');
        this.colWidth = [];
        this.leftOfCol = [];
        this.mapStickyCol = [];
        this.leftOfCol[0] = 0;
        this.addStickyClass(thead);
        this.setStickyColumnsThead(thead);
        this.setStickyColumnsTbody(tbody);
    }
    ngAfterViewChecked() {
        const tbody = this.tableRef.nativeElement.querySelector('table tbody');
        const thead = this.tableRef.nativeElement.querySelector('table thead');
        this.colWidth = [];
        this.leftOfCol = [];
        this.mapStickyCol = [];
        this.leftOfCol[0] = 0;
        this.addStickyClass(thead);
        this.setStickyColumnsThead(thead);
        this.setStickyColumnsTbody(tbody);
    }
    addStickyClass(thead) {
        thead.querySelectorAll('th').forEach((thcell, ind) => {
            if (thcell.querySelector('pmcc-table-actions')) {
                this.stickyColIndices.unshift(0);
            }
            if (this.stickyColIndices.includes(ind)) {
                thcell.classList.add('sticky-cell');
            }
        });
    }
    setStickyColumnsThead(t) {
        t.querySelectorAll('th').forEach((thcell, ind) => {
            if (ind === 0 && thcell.querySelector('pmcc-table-actions')) {
                thcell.style.left = `${this.leftOfCol.slice(-1)[0]}px`;
                thcell.style.position = `sticky`;
                thcell.style.zIndex = `1`;
                this.colWidth[0] = thcell.getBoundingClientRect().width;
                this.mapStickyCol.push(ind);
            }
            else if (thcell.classList.contains('sticky-cell')) {
                if (this.colWidth.length === 0) {
                    this.colWidth[0] = thcell.getBoundingClientRect().width;
                }
                else {
                    this.leftOfCol.push(this.colWidth.slice(-1)[0]);
                    this.colWidth.push(thcell.getBoundingClientRect().width + this.colWidth.slice(-1)[0]);
                }
                this.mapStickyCol.push(ind);
                thcell.style.left = `${this.leftOfCol.slice(-1)[0]}px`;
                thcell.style.position = `sticky`;
                thcell.style.zIndex = `1`;
            }
        });
    }
    setStickyColumnsTbody(t) {
        t.querySelectorAll('tr').forEach((row) => {
            row.querySelectorAll('td').forEach((cell, cellIndex) => {
                if (this.mapStickyCol.includes(cellIndex)) {
                    cell.style.left = `${this.leftOfCol[this.mapStickyCol.indexOf(cellIndex)]}px`;
                    cell.style.position = `sticky`;
                    cell.style.zIndex = `1`;
                }
            });
        });
    }
}
TableStickyColumnsDirective.ɵfac = function TableStickyColumnsDirective_Factory(t) { return new (t || TableStickyColumnsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TableStickyColumnsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TableStickyColumnsDirective, selectors: [["", "pmccTableStickyColumns", ""]], inputs: { stickyColIndices: "stickyColIndices" } });
TableStickyColumnsDirective.ctorParameters = () => [
    { type: ElementRef }
];
TableStickyColumnsDirective.propDecorators = {
    stickyColIndices: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableStickyColumnsDirective, [{
        type: Directive,
        args: [{
                selector: '[pmccTableStickyColumns]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { stickyColIndices: [{
            type: Input
        }] }); })();

class ScrollableTableModule {
}
ScrollableTableModule.ɵfac = function ScrollableTableModule_Factory(t) { return new (t || ScrollableTableModule)(); };
ScrollableTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ScrollableTableModule });
ScrollableTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ObserversModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollableTableModule, [{
        type: NgModule,
        args: [{
                declarations: [ScrollableTableComponent, TableStickyColumnsDirective],
                imports: [CommonModule, ObserversModule],
                exports: [ScrollableTableComponent, TableStickyColumnsDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ScrollableTableModule, { declarations: function () { return [ScrollableTableComponent, TableStickyColumnsDirective]; }, imports: function () { return [CommonModule, ObserversModule]; }, exports: function () { return [ScrollableTableComponent, TableStickyColumnsDirective]; } }); })();

class SingleselectComponent extends PopupDirective {
    constructor(_el, _overlayService, _viewContainerRef, viewPortMargin) {
        super(_el, _overlayService);
        this._viewContainerRef = _viewContainerRef;
        this.viewPortMargin = viewPortMargin;
        this.baseClass = true;
        this.disabled = false;
        this.active = false;
        this.sm = true;
        this.md = false;
        this.lg = false;
        this.width = 140;
        this.defaultLabel = 'Select';
        this.showLoading = false;
        this.textWrap = 'nowrap';
        this.instructions = '';
        this.searchText = '';
        this.settings = {};
        this.maxNumRecordsReturned = 20;
        this.matchesExceedsLimitMessage = 'More results found, please refine your search.';
        this.noMatchesFoundMessage = 'No results found.';
        this.align = 'left';
        this.debounceTime = 400;
        this.searchCallback = new EventEmitter();
        /**
         * This is to support old way.
         * @deprecated Use event `change` instead
         * */
        this.doneCallback = new EventEmitter();
        this.change = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.open = new EventEmitter();
        this.caretWithPaddingWidth = 12;
        this.defaultSettings = {
            showDeselectAll: true,
            layerPositioning: 'overlay',
        };
        this.isOpened = false;
        this._localQuery = '';
        this._size = 'sm';
        this._availableItems = [];
        this.closeSubscription = Subscription.EMPTY;
        this._selectedItems = [];
        this._searchDebouncer = new Subject();
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
    }
    set size(size) {
        this._size = size;
        this.sm = size === 'sm';
        this.md = size === 'md';
        this.lg = size === 'lg';
    }
    get availableItems() {
        return this._availableItems;
    }
    set availableItems(options) {
        this._availableItems = options;
        this.filterAvailableItems();
    }
    get selectedItem() {
        return this._selectedItem;
    }
    set selectedItem(item) {
        this._selectedItem = item;
        this._selectedItems = item ? [item] : [];
    }
    /**
     * This is to support old way.
     * TODO : Remove selectedItems and its dependencies in next major release
     * @deprecated Use `selectedItem` instead
     * */
    get selectedItems() {
        return this._selectedItems;
    }
    set selectedItems(items) {
        this._selectedItems = items;
        this._selectedItem = items && items.length ? items[0] : null;
    }
    get filteredAvailableItems() {
        return this._filteredAvailableItems;
    }
    /**
     * handle the ESC key
     */
    onEscape(event) {
        if (this.active) {
            event.stopImmediatePropagation();
            this.hide(false);
        }
    }
    onFocus(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (this.active) {
            this.hide();
        }
        else {
            this.setQuery('');
            this._show();
        }
    }
    get label() {
        if (!this.selectedItem) {
            return this.defaultLabel;
        }
        if (this.selectedLabel) {
            return this.selectedLabel(this.selectedItem);
        }
        return this.selectedItem.name;
    }
    ngOnInit() {
        this._searchDebouncer.pipe(debounceTime(this.debounceTime)).subscribe((query) => this.searchCallback.emit(query));
    }
    ngOnChanges() {
        const triggerElement = this._el.nativeElement.querySelector('.input-wrapper');
        this.mergedSettings = Object.assign(this.defaultSettings, this.settings);
        this._positionStrategy = this.createPositionStrategy(triggerElement);
        this._scrollStrategy = this._overlayService.scrollStrategies.reposition();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.closeSubscription.unsubscribe();
        this._searchDebouncer.unsubscribe();
    }
    selectedItemChange(selectedItem) {
        this.selectedItem = selectedItem;
        this._selectedItems = selectedItem ? [selectedItem] : [];
        this.change.emit(selectedItem);
        this.doneCallback.emit(this.selectedItems);
        this.onModelChange(selectedItem);
        this.hide(true);
    }
    searchChange(query) {
        if (this.searchCallback.observers.length) {
            this._searchDebouncer.next(query);
        }
        else {
            this.setQuery(query);
        }
    }
    hide(done = false) {
        if (this.active) {
            this.onTouched();
            this.active = false;
            this.isOpened = false;
            if (!done) {
                this.cancelCallback.emit();
            }
            if (this.mergedSettings.layerPositioning === 'push') {
                this.isOpened = false;
            }
            else if (this.overlayRef) {
                this.overlayRef.detach();
            }
            this._el.nativeElement.querySelector('input').blur();
        }
    }
    writeValue(obj) {
        this.selectedItem = Array.isArray(obj) ? obj[0] : obj;
        this.selectedItems = obj == null ? [] : coerceArray(obj);
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    get size() {
        return this._size;
    }
    filterAvailableItems() {
        if (!this._localQuery) {
            this._filteredAvailableItems = this._availableItems;
        }
        const lowerCasedQuery = this._localQuery.toLowerCase();
        this._filteredAvailableItems = this._availableItems.filter(item => item.name.toLowerCase().indexOf(lowerCasedQuery) > -1);
    }
    setQuery(query) {
        this._localQuery = query;
        this.filterAvailableItems();
    }
    _show() {
        this.controlElementWidth = Math.round(this._el.nativeElement.clientWidth);
        this.open.emit();
        this.active = true;
        if (this.mergedSettings.layerPositioning === 'overlay') {
            this.portal = {
                templateRef: this.templateRef,
                viewContainerRef: this._viewContainerRef
            };
            const overlay = this.createOverlay(this._positionStrategy, this._scrollStrategy);
            overlay.attach(this.portal);
            this.closeSubscription = overlay.close.subscribe(() => {
                this.hide();
            });
        }
        else {
            this.isOpened = true;
        }
    }
    createPositionStrategy(triggerElement) {
        const offsetY = -1;
        // right aligned positions that always be available.
        const preferredPositions = [
            {
                originPos: { originX: 'end', originY: 'bottom' },
                overlayPos: { overlayX: 'end', overlayY: 'top' },
                offsetY,
                panelClassName: 'pmcc-s-align-right'
            },
            {
                originPos: { originX: 'end', originY: 'top' },
                overlayPos: { overlayX: 'end', overlayY: 'bottom' },
                offsetY: -offsetY,
                panelClassName: ['pmcc-s-align-right', 'is-above-trigger'],
                originClassName: 'is-below-overlay'
            }
        ];
        const alignRight = this.align === 'right';
        if (alignRight !== true) {
            // if right alignment is not forced,
            // add left aligned position to the front
            preferredPositions.unshift({
                originPos: { originX: 'start', originY: 'bottom' },
                overlayPos: { overlayX: 'start', overlayY: 'top' },
                offsetY
            }, {
                originPos: { originX: 'start', originY: 'top' },
                overlayPos: { overlayX: 'start', overlayY: 'bottom' },
                offsetY: -offsetY,
                panelClassName: 'is-above-trigger',
                originClassName: 'is-below-overlay'
            });
        }
        return this._overlayService
            .position()
            .connectedTo(triggerElement).withPositions(preferredPositions)
            .withViewportMargin(this.viewPortMargin)
            .withFlexibleDimensions();
    }
    overlayConfig() {
        // @todo this is a hack to pass overlay config.
        //   will be removed when both multiselect and singleselect use
        //   shared trigger code.
        return { panelClassName: ['pmcc-singleselect-pane', this._size], backdrop: BackDrop.TRANSPARENT };
    }
}
SingleselectComponent.ɵfac = function SingleselectComponent_Factory(t) { return new (t || SingleselectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(OverlayService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(VIEWPORT_MARGIN)); };
SingleselectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SingleselectComponent, selectors: [["pmcc-singleselect"]], viewQuery: function SingleselectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, hostVars: 12, hostBindings: function SingleselectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.escape", function SingleselectComponent_keydown_escape_HostBindingHandler($event) { return ctx.onEscape($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("singleselect", ctx.baseClass)("disabled", ctx.disabled)("active", ctx.active)("sm", ctx.sm)("md", ctx.md)("lg", ctx.lg);
    } }, inputs: { disabled: "disabled", width: "width", defaultLabel: "defaultLabel", showLoading: "showLoading", textWrap: "textWrap", instructions: "instructions", searchText: "searchText", settings: "settings", maxNumRecordsReturned: "maxNumRecordsReturned", matchesExceedsLimitMessage: "matchesExceedsLimitMessage", noMatchesFoundMessage: "noMatchesFoundMessage", align: "align", debounceTime: "debounceTime", size: "size", availableItems: "availableItems", selectedItem: "selectedItem", selectedItems: "selectedItems", selectedLabel: "selectedLabel", availableItemsTemplate: "availableItemsTemplate", selectedItemsTemplate: "selectedItemsTemplate" }, outputs: { searchCallback: "searchCallback", doneCallback: "doneCallback", change: "change", cancelCallback: "cancelCallback", open: "open" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SingleselectComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 11, consts: [[1, "input-wrapper", 3, "ngClass"], ["type", "text", "readonly", "", 1, "pmcc-singleselect-input", 3, "disabled", "value", "title", "mousedown", "focus", "blur"], [1, "pmcc-singleselect-caret", 3, "mousedown"], [1, "portal"], [3, "ngIf"], [3, "size", "availableItemsTemplate", "textWrap", "selectedItemTemplate", "availableItems", "selectedItem", "searchText", "showLoading", "settings", "instructions", "noMatchesFoundMessage", "maxNumRecordsExceeded", "matchesExceedsLimitMessage", "alignRight", "triggerWidth", "searchChange", "selectedItemChange"]], template: function SingleselectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("mousedown", function SingleselectComponent_Template_input_mousedown_1_listener($event) { return ctx.onFocus($event); })("focus", function SingleselectComponent_Template_input_focus_1_listener($event) { return ctx.onFocus($event); })("blur", function SingleselectComponent_Template_input_blur_1_listener() { return ctx.hide(false); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵlistener("mousedown", function SingleselectComponent_Template_span_mousedown_2_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, SingleselectComponent_ng_template_4_Template, 1, 15, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c4, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("value", ctx.label)("title", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("left", ctx.width - ctx.caretWithPaddingWidth, "px");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpened);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, SingleselectListComponent]; }, styles: [".pmcc-form-control-invalid   [_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{border:1px solid #c5242a}[_nghost-%COMP%]{position:relative;display:inline-block;font:normal 13px Arial,Helvetica,Calibri,sans-serif}.disabled[_nghost-%COMP%]{box-shadow:none;cursor:not-allowed;opacity:.5;pointer-events:none}.disabled[_nghost-%COMP%]   .pmcc-singleselect-caret[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   input[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{display:inline-block;position:relative;border-radius:3px;border:1px solid #c9c9c9;background-color:#fff}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:4px 10px 3px 5px;position:relative;border:0;cursor:pointer;background-color:initial;text-shadow:0 0 0 #212121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]   .pmcc-singleselect-caret[_ngcontent-%COMP%]{position:absolute;top:4px;line-height:1}[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]   .pmcc-singleselect-caret[_ngcontent-%COMP%]:after{position:relative;height:10px;content:\"a\";color:#787878;font-family:pmcc-ico;cursor:default}.active[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{border-radius:3px;z-index:29001}.active[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]:not(.is-below-overlay){margin-bottom:1px;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.active[_nghost-%COMP%]   .input-wrapper.is-below-overlay[_ngcontent-%COMP%]{margin-top:1px;border-top:0;border-top-left-radius:0;border-top-right-radius:0}"] });
SingleselectComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: OverlayService },
    { type: ViewContainerRef },
    { type: undefined, decorators: [{ type: Inject, args: [VIEWPORT_MARGIN,] }] }
];
SingleselectComponent.propDecorators = {
    baseClass: [{ type: HostBinding, args: ['class.singleselect',] }],
    disabled: [{ type: HostBinding, args: ['class.disabled',] }, { type: Input }],
    active: [{ type: HostBinding, args: ['class.active',] }],
    sm: [{ type: HostBinding, args: ['class.sm',] }],
    md: [{ type: HostBinding, args: ['class.md',] }],
    lg: [{ type: HostBinding, args: ['class.lg',] }],
    size: [{ type: Input }],
    width: [{ type: Input }],
    defaultLabel: [{ type: Input }],
    selectedLabel: [{ type: Input }],
    showLoading: [{ type: Input }],
    textWrap: [{ type: Input }],
    instructions: [{ type: Input }],
    availableItems: [{ type: Input }],
    searchText: [{ type: Input }],
    availableItemsTemplate: [{ type: Input }],
    selectedItemsTemplate: [{ type: Input }],
    settings: [{ type: Input }],
    maxNumRecordsReturned: [{ type: Input }],
    matchesExceedsLimitMessage: [{ type: Input }],
    noMatchesFoundMessage: [{ type: Input }],
    align: [{ type: Input }],
    debounceTime: [{ type: Input }],
    searchCallback: [{ type: Output }],
    doneCallback: [{ type: Output }],
    change: [{ type: Output }],
    cancelCallback: [{ type: Output }],
    open: [{ type: Output }],
    templateRef: [{ type: ViewChild, args: [TemplateRef, { static: true },] }],
    selectedItem: [{ type: Input }],
    selectedItems: [{ type: Input }],
    onEscape: [{ type: HostListener, args: ['document:keydown.escape', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SingleselectComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-singleselect',
                template: "<div class=\"input-wrapper\" [ngClass]=\"{'disabled': disabled}\">\n  <input type=\"text\"\n         class=\"pmcc-singleselect-input\"\n         [disabled]=\"disabled\"\n         (mousedown)=\"onFocus($event)\"\n         (focus)=\"onFocus($event)\"\n         (blur)=\"hide(false)\"\n         [value]=\"label\"\n         [title]=\"label\"\n         [style.width.px]=\"width\"\n         readonly>\n  <span (mousedown)=\"onFocus($event)\"\n        class=\"pmcc-singleselect-caret\"\n        [style.left.px]=\"width-caretWithPaddingWidth\"></span>\n</div>\n<div class=\"portal\">\n  <ng-template [ngIf]=\"isOpened\">\n    <pmcc-singleselect-list\n      [size]=\"size\"\n      [availableItemsTemplate]=\"availableItemsTemplate\"\n      [textWrap]=\"textWrap\"\n      [selectedItemTemplate]=\"selectedItemsTemplate\"\n      [availableItems]=\"filteredAvailableItems\"\n      [selectedItem]=\"selectedItem\"\n      [searchText]=\"searchText\"\n      (searchChange)=\"searchChange($event)\"\n      (selectedItemChange)=\"selectedItemChange($event)\"\n      [showLoading]=\"showLoading\"\n      [settings]=\"mergedSettings\"\n      [instructions]=\"instructions\"\n      [noMatchesFoundMessage]=\"noMatchesFoundMessage\"\n      [maxNumRecordsExceeded]=\"maxNumRecordsReturned < availableItems.length\"\n      [matchesExceedsLimitMessage]=\"matchesExceedsLimitMessage\"\n      [alignRight]=\"align === 'right'\"\n      [triggerWidth]=\"controlElementWidth\">\n    </pmcc-singleselect-list>\n  </ng-template>\n</div>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SingleselectComponent),
                        multi: true
                    }
                ],
                styles: [".pmcc-form-control-invalid :host .input-wrapper{border:1px solid #c5242a}:host{position:relative;display:inline-block;font:normal 13px Arial,Helvetica,Calibri,sans-serif}:host.disabled{box-shadow:none;cursor:not-allowed;opacity:.5;pointer-events:none}:host.disabled .pmcc-singleselect-caret,:host.disabled input{cursor:not-allowed;pointer-events:none}:host .input-wrapper{display:inline-block;position:relative;border-radius:3px;border:1px solid #c9c9c9;background-color:#fff}:host .input-wrapper input{font:normal 13px Arial,Helvetica,Calibri,sans-serif;padding:4px 10px 3px 5px;position:relative;border:0;cursor:pointer;background-color:initial;text-shadow:0 0 0 #212121;text-overflow:ellipsis;-webkit-user-select:none;user-select:none}:host .input-wrapper .pmcc-singleselect-caret{position:absolute;top:4px;line-height:1}:host .input-wrapper .pmcc-singleselect-caret:after{position:relative;height:10px;content:\"a\";color:#787878;font-family:pmcc-ico;cursor:default}:host.active .input-wrapper{border-radius:3px;z-index:29001}:host.active .input-wrapper:not(.is-below-overlay){margin-bottom:1px;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}:host.active .input-wrapper.is-below-overlay{margin-top:1px;border-top:0;border-top-left-radius:0;border-top-right-radius:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: OverlayService }, { type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [VIEWPORT_MARGIN]
            }] }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.singleselect']
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }, {
            type: Input
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }], sm: [{
            type: HostBinding,
            args: ['class.sm']
        }], md: [{
            type: HostBinding,
            args: ['class.md']
        }], lg: [{
            type: HostBinding,
            args: ['class.lg']
        }], width: [{
            type: Input
        }], defaultLabel: [{
            type: Input
        }], showLoading: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], instructions: [{
            type: Input
        }], searchText: [{
            type: Input
        }], settings: [{
            type: Input
        }], maxNumRecordsReturned: [{
            type: Input
        }], matchesExceedsLimitMessage: [{
            type: Input
        }], noMatchesFoundMessage: [{
            type: Input
        }], align: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], searchCallback: [{
            type: Output
        }], doneCallback: [{
            type: Output
        }], change: [{
            type: Output
        }], cancelCallback: [{
            type: Output
        }], open: [{
            type: Output
        }], size: [{
            type: Input
        }], availableItems: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], 
    /**
     * handle the ESC key
     */
    onEscape: [{
            type: HostListener,
            args: ['document:keydown.escape', ['$event']]
        }], selectedLabel: [{
            type: Input
        }], availableItemsTemplate: [{
            type: Input
        }], selectedItemsTemplate: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();

class SingleselectListComponent {
    constructor() {
        this.maxNumRecordsExceeded = false;
        this.matchesExceedsLimitMessage = 'More results found, please refine your search.';
        this.noMatchesFoundMessage = 'No results found.';
        this.size = 'sm';
        this.textWrap = 'nowrap';
        this.instructions = '';
        this.showLoading = false;
        this.settings = {};
        this.alignRight = false;
        // TODO : Remove selectedItems and its dependencies in next major release
        this._selectedItems = [];
        this.selectedItemChange = new EventEmitter();
        this.searchChange = new EventEmitter();
        this._searchText = '';
        this.viewableAvailableItems = [];
        this._availableItems = [];
        this.include = this.include.bind(this);
        this.exclude = this.exclude.bind(this);
    }
    set availableItems(value) {
        this._availableItems = value;
        this._generateViewableAvailableItem();
    }
    set selectedItem(value) {
        this._selectedItem = value;
        this._selectedItems = value ? [value] : [];
        this._generateViewableAvailableItem();
    }
    get selectedItem() {
        return this._selectedItem;
    }
    /**
     * This is to support old way.
     * TODO : Remove selectedItems and its dependencies in next major release
     * @deprecated Use `selectedItem` instead
     * */
    get selectedItems() {
        return this._selectedItems;
    }
    set selectedItems(items) {
        this._selectedItems = items;
        this.selectedItem = items && items.length ? items[0] : null;
    }
    set searchText(txt) {
        if (txt !== this._searchText) {
            this._searchText = txt;
            this.searchChange.emit(txt);
        }
    }
    get searchText() {
        return this._searchText;
    }
    ngAfterViewInit() {
        Promise.resolve().then(() => {
            this.searchInputElRef.nativeElement.focus();
        });
    }
    include(item) {
        this.selectedItem = item;
        this._selectedItems = [item];
        this.selectedItemChange.emit(this.selectedItem);
    }
    exclude(item) {
        this.selectedItem = null;
        this._selectedItems = [];
        this.selectedItemChange.emit(this.selectedItem);
    }
    onSearch(searchText) {
        this.searchText = searchText;
    }
    trackByFn(_, item) {
        return item.id;
    }
    get showSelectedItems() {
        return this.selectedItem && !this.searchText.length && !this.showLoading;
    }
    get showAvailableItems() {
        return this.viewableAvailableItems.length && !this.showLoading;
    }
    get showDefaultSelectedItems() {
        return !this.selectedItemTemplate && this.showSelectedItems;
    }
    get showSelectedWithAvailable() {
        return this.showDefaultSelectedItems && this.showDefaultAvailableItems;
    }
    get showDefaultAvailableItems() {
        return !this.availableItemsTemplate && this.showAvailableItems;
    }
    _generateViewableAvailableItem() {
        if (this.selectedItem) {
            this.viewableAvailableItems = this._availableItems.filter(item => item.id !== this._selectedItem.id);
        }
        else {
            this.viewableAvailableItems = this._availableItems;
        }
    }
}
SingleselectListComponent.ɵfac = function SingleselectListComponent_Factory(t) { return new (t || SingleselectListComponent)(); };
SingleselectListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SingleselectListComponent, selectors: [["pmcc-singleselect-list"]], viewQuery: function SingleselectListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c75, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInputElRef = _t.first);
    } }, inputs: { maxNumRecordsExceeded: "maxNumRecordsExceeded", matchesExceedsLimitMessage: "matchesExceedsLimitMessage", noMatchesFoundMessage: "noMatchesFoundMessage", size: "size", textWrap: "textWrap", instructions: "instructions", showLoading: "showLoading", settings: "settings", alignRight: "alignRight", availableItems: "availableItems", selectedItem: "selectedItem", searchText: "searchText", availableItemsTemplate: "availableItemsTemplate", selectedItemTemplate: "selectedItemTemplate", triggerWidth: "triggerWidth" }, outputs: { selectedItemChange: "selectedItemChange", searchChange: "searchChange" }, decls: 19, vars: 20, consts: [[1, "pmcc-menu", 3, "ngClass"], ["class", "header", 3, "textContent", 4, "ngIf"], ["class", "header", 4, "ngIf"], [1, "search"], [1, "label"], ["pmccClear", "", "fullWidth", "", "data-pm-id", "search-input", 1, "input"], ["pmccInput", "", "type", "text", 3, "ngModel", "ngModelChange"], ["searchInputEl", ""], ["data-pm-id", "items-available", 1, "pmcc-available-list", 3, "ngClass"], ["defaultSelectedItemTemplate", ""], ["defaultAvailableItemsTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "no-match-message", 4, "ngIf"], ["class", "loading", 4, "ngIf"], ["class", "max-row-exceeded", 3, "textContent", 4, "ngIf"], [1, "header", 3, "textContent"], [1, "header"], ["pmccButton", "", "pmccVariant", "secondary", "data-pm-id", "clear-selection-btn", 3, "click"], ["class", "item pmcc-truncate selected", "data-pm-id", "selected-item", 3, "ngClass", "title", "click", 4, "ngIf"], ["data-pm-id", "selected-item", 1, "item", "pmcc-truncate", "selected", 3, "ngClass", "title", "click"], [3, "textContent"], ["autosize", "", 1, "list", 3, "itemSize"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "item pmcc-truncate", "data-pm-id", "list-item", 3, "ngClass", "title", "click", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy"], [3, "ngTemplateOutlet"], ["data-pm-id", "list-item", 1, "item", "pmcc-truncate", 3, "ngClass", "title", "click"], [1, "no-match-message"], ["name", "info", "size", "6x"], [1, "loading"], ["name", "processing", "size", "4x", "effect", "spin"], [1, "max-row-exceeded", 3, "textContent"]], template: function SingleselectListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SingleselectListComponent_div_1_Template, 1, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SingleselectListComponent_div_2_Template, 3, 0, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5, "Search:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "pmcc-input", 5);
        ɵngcc0.ɵɵelementStart(7, "input", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function SingleselectListComponent_Template_input_ngModelChange_7_listener($event) { return ctx.onSearch($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, SingleselectListComponent_ng_template_10_Template, 1, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, SingleselectListComponent_ng_template_12_Template, 3, 4, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, SingleselectListComponent_ng_container_14_Template, 1, 8, "ng-container", 11);
        ɵngcc0.ɵɵelementContainer(15, 12);
        ɵngcc0.ɵɵtemplate(16, SingleselectListComponent_div_16_Template, 3, 1, "div", 13);
        ɵngcc0.ɵɵtemplate(17, SingleselectListComponent_div_17_Template, 2, 0, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, SingleselectListComponent_div_18_Template, 1, 1, "div", 15);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r5 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵclassProp("layer-push", (ctx.settings == null ? null : ctx.settings.layerPositioning) === "push");
        ɵngcc0.ɵɵproperty("ngClass", ctx.size);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.instructions.length && !ctx.selectedItem && !ctx.searchText.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem && !ctx.searchText.length && ctx.settings.showDeselectAll);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.textWrap);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showSelectedWithAvailable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.showDefaultAvailableItems ? _r5 : ctx.availableItemsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction6(13, _c77, ctx.include, ctx.viewableAvailableItems, ctx.selectedItem, ctx.selectedItems, ctx.selectedItemChange, ctx.textWrap));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.viewableAvailableItems.length && !ctx.showLoading && ctx.searchText.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showLoading && ctx.maxNumRecordsExceeded && ctx.searchText.length && ctx.viewableAvailableItems.length);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, InputComponent, InputDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgTemplateOutlet, ButtonDirective, ɵngcc5.CdkVirtualScrollViewport, ɵngcc5.CdkFixedSizeVirtualScroll, ɵngcc5.CdkVirtualForOf, IconComponent, IconEffectDirective], styles: ["[_nghost-%COMP%]   .pmcc-menu[_ngcontent-%COMP%]{border:1px solid #c9c9c9;box-sizing:border-box;width:100%;height:100%;padding:1em;border-radius:3px;font-size:13px;background-color:#fff;overflow:hidden;display:flex;flex-direction:column}[_nghost-%COMP%]   .header[_ngcontent-%COMP%]{width:100%;position:relative;min-height:25px;margin-bottom:1em;padding-bottom:.5em;font-weight:700;border-bottom:1px solid #ccc}[_nghost-%COMP%]   .sm[_ngcontent-%COMP%]{width:255px}[_nghost-%COMP%]   .sm[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{width:214px}[_nghost-%COMP%]   .md[_ngcontent-%COMP%]{width:340px}[_nghost-%COMP%]   .md[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{width:298px!important}[_nghost-%COMP%]   .lg[_ngcontent-%COMP%]{width:870px}[_nghost-%COMP%]   .lg[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{width:827px!important}[_nghost-%COMP%]   .search[_ngcontent-%COMP%]{display:flex;margin-bottom:13px}[_nghost-%COMP%]   .search[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;line-height:29px;font-size:13px;padding:0;margin-right:10px}[_nghost-%COMP%]   .search[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{flex:1!important}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]{overflow-x:hidden;overflow-y:auto;display:flex;flex-direction:column;flex:1}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]{flex:1;height:100%;width:100%;overflow-x:hidden}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{cursor:pointer;margin:0 0 4px;padding:8px 0;color:#0085cc;text-decoration:none;border-bottom:1px solid #e7e7e7}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item.selected[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#000;font-weight:700}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item.wrap[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{white-space:normal}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item.nowrap[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{white-space:nowrap}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item.word-break[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{white-space:normal;word-break:break-all}[_nghost-%COMP%]   .pmcc-available-list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{text-decoration:none}[_nghost-%COMP%]   .loading[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-flow:column;height:100%;width:100%}[_nghost-%COMP%]   .loading[_ngcontent-%COMP%]   pmcc-icon[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]   pmcc-icon[_ngcontent-%COMP%]{margin:10px}[_nghost-%COMP%]   .max-row-exceeded[_ngcontent-%COMP%], [_nghost-%COMP%]   .no-match-message[_ngcontent-%COMP%]{color:#c4c4c4}  .pmcc-overlay-pane.pmcc-singleselect-pane.pmcc-s-align-right.is-above-trigger .pmcc-menu{border-radius:3px 3px 0 3px}  .pmcc-overlay-pane.pmcc-singleselect-pane.pmcc-s-align-right:not(.is-above-trigger) .pmcc-menu{border-radius:3px 0 3px 3px}  .pmcc-overlay-pane.pmcc-singleselect-pane.is-above-trigger .pmcc-menu{border-radius:3px 3px 3px 0}  .pmcc-overlay-pane.pmcc-singleselect-pane:not(.is-above-trigger) .pmcc-menu{border-radius:0 3px 3px 3px}  .pmcc-overlay-pane.pmcc-singleselect-pane.sm{height:257px}  .pmcc-overlay-pane.pmcc-singleselect-pane.md{height:298px}  .pmcc-overlay-pane.pmcc-singleselect-pane.lg{height:377px}.pmcc-menu.layer-push[_ngcontent-%COMP%]{position:relative;top:-2px;border-radius:0 3px 3px 3px}.pmcc-menu.layer-push.pmcc-s-align-right[_ngcontent-%COMP%]{border-radius:3px 0 3px 3px}.pmcc-menu.layer-push.sm[_ngcontent-%COMP%]{height:257px}.pmcc-menu.layer-push.md[_ngcontent-%COMP%]{height:298px}.pmcc-menu.layer-push.lg[_ngcontent-%COMP%]{height:377px}"] });
SingleselectListComponent.ctorParameters = () => [];
SingleselectListComponent.propDecorators = {
    maxNumRecordsExceeded: [{ type: Input }],
    matchesExceedsLimitMessage: [{ type: Input }],
    noMatchesFoundMessage: [{ type: Input }],
    size: [{ type: Input }],
    textWrap: [{ type: Input }],
    instructions: [{ type: Input }],
    showLoading: [{ type: Input }],
    settings: [{ type: Input }],
    availableItems: [{ type: Input }],
    selectedItem: [{ type: Input }],
    availableItemsTemplate: [{ type: Input }],
    selectedItemTemplate: [{ type: Input }],
    triggerWidth: [{ type: Input }],
    alignRight: [{ type: Input }],
    selectedItemChange: [{ type: Output }],
    searchChange: [{ type: Output }],
    searchInputElRef: [{ type: ViewChild, args: ['searchInputEl',] }],
    searchText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SingleselectListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-singleselect-list',
                template: "<div class=\"pmcc-menu\"\n     [class.layer-push]=\"settings?.layerPositioning === 'push'\"\n     [ngClass]=\"size\">\n  <div *ngIf=\"instructions.length && !selectedItem && !searchText.length\"\n       class=\"header\"\n       [textContent]=\"instructions\">\n  </div>\n  <div *ngIf=\"selectedItem && !searchText.length && settings.showDeselectAll\"\n       class=\"header\">\n    <button\n      pmccButton\n      pmccVariant=\"secondary\"\n      (click)=\"exclude()\"\n      data-pm-id=\"clear-selection-btn\"\n    >Clear</button>\n  </div>\n\n  <div class=\"search\">\n    <span class=\"label\">Search:</span>\n    <pmcc-input\n      pmccClear\n      fullWidth\n      class=\"input\"\n      data-pm-id=\"search-input\"\n    >\n      <input\n        pmccInput\n        #searchInputEl\n        type=\"text\"\n        [ngModel]=\"searchText\"\n        (ngModelChange)=\"onSearch($event)\"/>\n    </pmcc-input>\n  </div>\n\n  <div\n    class=\"pmcc-available-list\"\n    [ngClass]=\"textWrap\"\n    data-pm-id=\"items-available\"\n  >\n\n    <ng-template #defaultSelectedItemTemplate>\n      <div *ngIf=\"selectedItem\"\n           class=\"item pmcc-truncate selected\"\n           [ngClass]=\"textWrap\"\n           [title]=\"selectedItem.name\"\n           (click)=\"exclude(selectedItem)\"\n           data-pm-id=\"selected-item\"\n      >\n        <a [textContent]=\"selectedItem.name\"></a>\n      </div>\n    </ng-template>\n\n    <ng-template #defaultAvailableItemsTemplate>\n      <cdk-virtual-scroll-viewport\n        class=\"list\"\n        [itemSize]=\"31\"\n        autosize>\n        <ng-container *ngIf=\"showSelectedWithAvailable\"\n                      [ngTemplateOutlet]=\"defaultSelectedItemTemplate\"></ng-container>\n        <div *cdkVirtualFor=\"let item of viewableAvailableItems;trackBy: trackByFn\"\n             [ngClass]=\"textWrap\"\n             class=\"item pmcc-truncate\"\n             [title]=\"item.name\"\n             (click)=\"include(item)\"\n             data-pm-id=\"list-item\"\n        >\n          <a [textContent]=\"item.name\"></a>\n        </div>\n      </cdk-virtual-scroll-viewport>\n    </ng-template>\n\n    <ng-container\n      *ngIf=\"!showSelectedWithAvailable\"\n      [ngTemplateOutlet]=\"showDefaultSelectedItems ? defaultSelectedItemTemplate : selectedItemTemplate\"\n      [ngTemplateOutletContext]=\"{exclude: exclude,\n                                  selectedItem: selectedItem,\n                                  selectedItems: selectedItems,\n                                  selectedItemChange: selectedItemChange,\n                                  textWrap: textWrap}\">\n    </ng-container>\n\n    <ng-container\n      [ngTemplateOutlet]=\"showDefaultAvailableItems ? defaultAvailableItemsTemplate : availableItemsTemplate\"\n      [ngTemplateOutletContext]=\"{include: include,\n                                  viewableAvailableItems: viewableAvailableItems,\n                                  selectedItem: selectedItem,\n                                  selectedItems: selectedItems,\n                                  selectedItemChange: selectedItemChange,\n                                  textWrap: textWrap}\">\n    </ng-container>\n\n    <div class=\"no-match-message\"\n         *ngIf=\"!viewableAvailableItems.length && !showLoading && searchText.length\">\n      <pmcc-icon name=\"info\" size=\"6x\"></pmcc-icon>\n      <div [textContent]=\"noMatchesFoundMessage\"></div>\n    </div>\n\n    <div class=\"loading\"\n         *ngIf=\"showLoading\">\n      <pmcc-icon name=\"processing\" size=\"4x\" effect=\"spin\"></pmcc-icon>\n    </div>\n  </div>\n\n  <div class=\"max-row-exceeded\"\n       *ngIf=\"!showLoading && maxNumRecordsExceeded && searchText.length && viewableAvailableItems.length\"\n       [textContent]=\"matchesExceedsLimitMessage\">\n  </div>\n</div>\n",
                styles: [":host .pmcc-menu{border:1px solid #c9c9c9;box-sizing:border-box;width:100%;height:100%;padding:1em;border-radius:3px;font-size:13px;background-color:#fff;overflow:hidden;display:flex;flex-direction:column}:host .header{width:100%;position:relative;min-height:25px;margin-bottom:1em;padding-bottom:.5em;font-weight:700;border-bottom:1px solid #ccc}:host .sm{width:255px}:host .sm .item{width:214px}:host .md{width:340px}:host .md .item{width:298px!important}:host .lg{width:870px}:host .lg .item{width:827px!important}:host .search{display:flex;margin-bottom:13px}:host .search .label{font-weight:700;line-height:29px;font-size:13px;padding:0;margin-right:10px}:host .search .input{flex:1!important}:host .pmcc-available-list{overflow-x:hidden;overflow-y:auto;display:flex;flex-direction:column;flex:1}:host .pmcc-available-list .list{flex:1;height:100%;width:100%;overflow-x:hidden}:host .pmcc-available-list .item{cursor:pointer;margin:0 0 4px;padding:8px 0;color:#0085cc;text-decoration:none;border-bottom:1px solid #e7e7e7}:host .pmcc-available-list .item.selected>a{color:#000;font-weight:700}:host .pmcc-available-list .item.wrap>a{white-space:normal}:host .pmcc-available-list .item.nowrap>a{white-space:nowrap}:host .pmcc-available-list .item.word-break>a{white-space:normal;word-break:break-all}:host .pmcc-available-list .item>a{text-decoration:none}:host .loading,:host .no-match-message{display:flex;align-items:center;justify-content:center;flex-flow:column;height:100%;width:100%}:host .loading pmcc-icon,:host .no-match-message pmcc-icon{margin:10px}:host .max-row-exceeded,:host .no-match-message{color:#c4c4c4}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.pmcc-s-align-right.is-above-trigger .pmcc-menu{border-radius:3px 3px 0 3px}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.pmcc-s-align-right:not(.is-above-trigger) .pmcc-menu{border-radius:3px 0 3px 3px}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.is-above-trigger .pmcc-menu{border-radius:3px 3px 3px 0}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane:not(.is-above-trigger) .pmcc-menu{border-radius:0 3px 3px 3px}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.sm{height:257px}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.md{height:298px}::ng-deep .pmcc-overlay-pane.pmcc-singleselect-pane.lg{height:377px}.pmcc-menu.layer-push{position:relative;top:-2px;border-radius:0 3px 3px 3px}.pmcc-menu.layer-push.pmcc-s-align-right{border-radius:3px 0 3px 3px}.pmcc-menu.layer-push.sm{height:257px}.pmcc-menu.layer-push.md{height:298px}.pmcc-menu.layer-push.lg{height:377px}"]
            }]
    }], function () { return []; }, { maxNumRecordsExceeded: [{
            type: Input
        }], matchesExceedsLimitMessage: [{
            type: Input
        }], noMatchesFoundMessage: [{
            type: Input
        }], size: [{
            type: Input
        }], textWrap: [{
            type: Input
        }], instructions: [{
            type: Input
        }], showLoading: [{
            type: Input
        }], settings: [{
            type: Input
        }], alignRight: [{
            type: Input
        }], selectedItemChange: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], availableItems: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], searchText: [{
            type: Input
        }], availableItemsTemplate: [{
            type: Input
        }], selectedItemTemplate: [{
            type: Input
        }], triggerWidth: [{
            type: Input
        }], searchInputElRef: [{
            type: ViewChild,
            args: ['searchInputEl']
        }] }); })();

class SingleselectModule {
}
SingleselectModule.ɵfac = function SingleselectModule_Factory(t) { return new (t || SingleselectModule)(); };
SingleselectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SingleselectModule });
SingleselectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            LayoutModule,
            InputModule,
            ScrollingModule,
            ButtonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SingleselectModule, [{
        type: NgModule,
        args: [{
                declarations: [SingleselectComponent, SingleselectListComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    LayoutModule,
                    InputModule,
                    ScrollingModule,
                    ButtonModule,
                    IconModule
                ],
                exports: [SingleselectComponent, SingleselectListComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SingleselectModule, { declarations: function () { return [SingleselectComponent, SingleselectListComponent]; }, imports: function () { return [CommonModule,
        FormsModule, LayoutModule, InputModule, ScrollingModule, ButtonModule, IconModule]; }, exports: function () { return [SingleselectComponent, SingleselectListComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/sortable-list</example-url>
 */
class SortableItemComponent {
    constructor() {
        this.role = 'listitem';
    }
}
SortableItemComponent.ɵfac = function SortableItemComponent_Factory(t) { return new (t || SortableItemComponent)(); };
SortableItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SortableItemComponent, selectors: [["pmcc-sortable-item"]], hostVars: 1, hostBindings: function SortableItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { item: "item" }, decls: 4, vars: 1, consts: [["name", "draggable"]], template: function SortableItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "pmcc-icon", 0);
        ɵngcc0.ɵɵtext(1, "\u00A0\n");
        ɵngcc0.ɵɵelementStart(2, "span");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.name);
    } }, directives: [IconComponent], styles: ["[_nghost-%COMP%]{display:flex;width:100%;height:25px;padding:5px;background:#f1f1f1;color:#999;cursor:ns-resize}[_nghost-%COMP%]:not(:last-of-type){margin-bottom:5px}.highlighted[_nghost-%COMP%]{background:#fff;color:#222121;border:1px dashed #d5d5d5}"] });
SortableItemComponent.propDecorators = {
    item: [{ type: Input }],
    role: [{ type: HostBinding, args: ['attr.role',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortableItemComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-sortable-item',
                template: "<pmcc-icon name=\"draggable\"></pmcc-icon>&nbsp;\n<span>{{ item.name }}</span>\n",
                styles: [":host{display:flex;width:100%;height:25px;padding:5px;background:#f1f1f1;color:#999;cursor:ns-resize}:host:not(:last-of-type){margin-bottom:5px}:host.highlighted{background:#fff;color:#222121;border:1px dashed #d5d5d5}"]
            }]
    }], function () { return []; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], item: [{
            type: Input
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/sortable-list</example-url>
 */
class SortableListComponent {
    constructor() {
        this.role = 'list';
    }
    onDrop({ previousIndex, currentIndex }) {
        moveItemInArray(this.list, previousIndex, currentIndex);
        this.list.forEach((item, i) => (item.order = i));
    }
}
SortableListComponent.ɵfac = function SortableListComponent_Factory(t) { return new (t || SortableListComponent)(); };
SortableListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SortableListComponent, selectors: [["pmcc-sortable-list"]], hostVars: 1, hostBindings: function SortableListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { list: "list" }, decls: 2, vars: 1, consts: [["cdkDropList", "", "cdkDropListLockAxis", "y", 1, "pmcc-sortable-list", 3, "cdkDropListDropped"], ["cdkDrag", "", "cdkDragBoundary", ".pmcc-sortable-list", 3, "item", 4, "ngFor", "ngForOf"], ["cdkDrag", "", "cdkDragBoundary", ".pmcc-sortable-list", 3, "item"], ["class", "highlighted", 3, "item", 4, "cdkDragPlaceholder"], [1, "highlighted", 3, "item"]], template: function SortableListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵlistener("cdkDropListDropped", function SortableListComponent_Template_ul_cdkDropListDropped_0_listener($event) { return ctx.onDrop($event); });
        ɵngcc0.ɵɵtemplate(1, SortableListComponent_pmcc_sortable_item_1_Template, 2, 1, "pmcc-sortable-item", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: [ɵngcc7.CdkDropList, ɵngcc1.NgForOf, SortableItemComponent, ɵngcc7.CdkDrag, ɵngcc7.CdkDragPlaceholder], styles: [".pmcc-sortable-list[_ngcontent-%COMP%]{display:inline-block;padding:0!important;list-style:none;position:relative;overflow:visible;width:100%}.pmcc-sortable-list.cdk-drop-list-dragging[_ngcontent-%COMP%], .pmcc-sortable-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:grabbing}.pmcc-sortable-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   pmcc-sortable-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .1s ease-in-out}.cdk-drag-preview[_ngcontent-%COMP%]{opacity:.85}"] });
SortableListComponent.propDecorators = {
    list: [{ type: Input }],
    role: [{ type: HostBinding, args: ['attr.role',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortableListComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-sortable-list',
                template: "<ul\n  class=\"pmcc-sortable-list\"\n  cdkDropList\n  cdkDropListLockAxis=\"y\"\n  (cdkDropListDropped)=\"onDrop($event)\"\n>\n  <pmcc-sortable-item\n    *ngFor=\"let item of list\"\n    [item]=\"item\"\n    cdkDrag\n    cdkDragBoundary=\".pmcc-sortable-list\"\n  >\n    <!-- dragged item placeholder -->\n    <pmcc-sortable-item\n      *cdkDragPlaceholder\n      [item]=\"item\"\n      class=\"highlighted\"\n    ></pmcc-sortable-item>\n  </pmcc-sortable-item>\n</ul>\n",
                styles: [".pmcc-sortable-list{display:inline-block;padding:0!important;list-style:none;position:relative;overflow:visible;width:100%}.pmcc-sortable-list.cdk-drop-list-dragging,.pmcc-sortable-list.cdk-drop-list-dragging *{cursor:grabbing}.pmcc-sortable-list.cdk-drop-list-dragging pmcc-sortable-item:not(.cdk-drag-placeholder){transition:transform .1s ease-in-out}.cdk-drag-preview{opacity:.85}"]
            }]
    }], function () { return []; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], list: [{
            type: Input
        }] }); })();

class SortableListModule {
}
SortableListModule.ɵfac = function SortableListModule_Factory(t) { return new (t || SortableListModule)(); };
SortableListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SortableListModule });
SortableListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, DragDropModule, IconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortableListModule, [{
        type: NgModule,
        args: [{
                declarations: [SortableListComponent, SortableItemComponent],
                imports: [CommonModule, DragDropModule, IconModule],
                exports: [SortableListComponent, SortableItemComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SortableListModule, { declarations: function () { return [SortableListComponent, SortableItemComponent]; }, imports: function () { return [CommonModule, DragDropModule, IconModule]; }, exports: function () { return [SortableListComponent, SortableItemComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/switch</example-url>
 */
class SwitchComponent {
    constructor() {
        this.change = new EventEmitter();
        this._disabled = false;
        this._value = false;
        this.onChange = noop;
        this.onTouched = noop;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = coerceBooleanProperty(value);
    }
    get checked() {
        return this._value;
    }
    set checked(value) {
        this._value = coerceBooleanProperty(value);
    }
    toggle() {
        if (!this.disabled) {
            this.value = !this.value;
            this.change.emit(this.value);
            this.onChange(this.value);
            this.onTouched();
        }
    }
    writeValue(value) {
        if (value !== this.value) {
            this.value = value;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
SwitchComponent.ɵfac = function SwitchComponent_Factory(t) { return new (t || SwitchComponent)(); };
SwitchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SwitchComponent, selectors: [["pmcc-switch"]], inputs: { disabled: "disabled", value: "value", checked: "checked", labelTrue: "labelTrue", labelFalse: "labelFalse", leftLabel: "leftLabel", rightLabel: "rightLabel" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => SwitchComponent)
            }
        ])], decls: 6, vars: 8, consts: [[1, "pmcc-switch", 3, "ngClass", "click"], [1, "pmcc-switch-wrapper"], ["class", "left-label", 4, "ngIf"], ["class", "off", 4, "ngIf"], ["class", "on", 4, "ngIf"], ["class", "right-label", 4, "ngIf"], [1, "left-label"], [1, "off"], [1, "handle"], [4, "ngIf"], [1, "on"], [1, "right-label"]], template: function SwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function SwitchComponent_Template_div_click_0_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SwitchComponent_label_2_Template, 2, 1, "label", 2);
        ɵngcc0.ɵɵtemplate(3, SwitchComponent_div_3_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(4, SwitchComponent_div_4_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, SwitchComponent_label_5_Template, 2, 1, "label", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c78, ctx.disabled, !ctx.labelFalse || !ctx.labelTrue));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.leftLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value === false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value === true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.rightLabel);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], encapsulation: 2 });
SwitchComponent.propDecorators = {
    labelTrue: [{ type: Input }],
    labelFalse: [{ type: Input }],
    leftLabel: [{ type: Input }],
    rightLabel: [{ type: Input }],
    change: [{ type: Output }],
    disabled: [{ type: Input }],
    value: [{ type: Input }],
    checked: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitchComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-switch',
                template: "<div\n  (click)=\"toggle()\"\n  class=\"pmcc-switch\"\n  [ngClass]=\"{\n    disabled: disabled,\n    'pmcc-new-switch': !labelFalse || !labelTrue\n  }\"\n>\n  <div class='pmcc-switch-wrapper'>\n    <label class=\"left-label\" *ngIf=\"leftLabel\">\n      {{leftLabel}}\n    </label>\n    <div\n      class=\"off\"\n      *ngIf=\"value === false\"\n    >\n      <div class=\"handle\"></div>\n      <label *ngIf=\"labelFalse\">{{ labelFalse }}</label>\n    </div>\n    <div\n      class=\"on\"\n      *ngIf=\"value === true\"\n    >\n      <label *ngIf=\"labelTrue\">{{ labelTrue }}</label>\n      <div class='handle'></div>\n    </div>\n    <label class=\"right-label\" *ngIf=\"rightLabel\">\n      {{rightLabel}}\n    </label>\n  </div>\n</div>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => SwitchComponent)
                    }
                ]
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], disabled: [{
            type: Input
        }], value: [{
            type: Input
        }], checked: [{
            type: Input
        }], labelTrue: [{
            type: Input
        }], labelFalse: [{
            type: Input
        }], leftLabel: [{
            type: Input
        }], rightLabel: [{
            type: Input
        }] }); })();

class SwitchModule {
}
SwitchModule.ɵfac = function SwitchModule_Factory(t) { return new (t || SwitchModule)(); };
SwitchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SwitchModule });
SwitchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [SwitchComponent],
                imports: [CommonModule],
                exports: [SwitchComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchModule, { declarations: function () { return [SwitchComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SwitchComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/tabs</example-url>
 */
class TabComponent {
    constructor() {
        this.sequence = 0;
    }
    get label() {
        return this.name;
    }
}
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(); };
TabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabComponent, selectors: [["pmcc-tab"]], inputs: { sequence: "sequence", selected: "selected", name: "name", appearsInOverflowMenu: "appearsInOverflowMenu", disabled: "disabled", required: "required", maxHeight: "maxHeight", tooltip: "tooltip" }, ngContentSelectors: _c1, decls: 1, vars: 1, consts: [["class", "pmcc-tab-panel", 3, "max-height", 4, "ngIf"], [1, "pmcc-tab-panel"]], template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TabComponent_div_0_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selected);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
TabComponent.propDecorators = {
    selected: [{ type: Input }],
    name: [{ type: Input }],
    sequence: [{ type: Input }],
    appearsInOverflowMenu: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    maxHeight: [{ type: Input }],
    tooltip: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-tab',
                template: "<div\n  class=\"pmcc-tab-panel\"\n  *ngIf=\"selected\"\n  [style.max-height]=\"maxHeight == null ? 'auto' : maxHeight\"\n>\n  <ng-content></ng-content>\n</div>\n"
            }]
    }], function () { return []; }, { sequence: [{
            type: Input
        }], selected: [{
            type: Input
        }], name: [{
            type: Input
        }], appearsInOverflowMenu: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], tooltip: [{
            type: Input
        }] }); })();

class TableActionsComponent extends EscapableDirective {
    constructor(cd) {
        super();
        this.cd = cd;
        this._isToggleAll = false;
        this._disableCheckbox = false;
        this._hideCheckbox = false;
        this._disabled = false;
        /**
         * Set title for [actions]
         */
        this.menuTitle = 'Actions';
        /**
         * Change the title for [selectors]
         */
        this.selectorsTitle = 'Selection';
        /**
         * Event which emits the underlying model assigned to it. Array when isToggleAll=true or an object
         */
        this.modelChange = new EventEmitter();
        this.isMenuOpen = false;
    }
    /**
     * Set isToggleAll = true for Toggle checkbox to control selection in [model] array
     */
    get isToggleAll() {
        return this._isToggleAll;
    }
    set isToggleAll(value) {
        this._isToggleAll = coerceBooleanProperty$1(value);
    }
    /**
     * Set disableCheckbox for disabling the checkbox
     */
    get disableCheckbox() {
        return this._disableCheckbox;
    }
    set disableCheckbox(value) {
        this._disableCheckbox = coerceBooleanProperty$1(value);
    }
    /**
     * As the name says, hides checkbox
     */
    get hideCheckbox() {
        return this._hideCheckbox;
    }
    set hideCheckbox(value) {
        this._hideCheckbox = coerceBooleanProperty$1(value);
    }
    /**
     * Set disable for disabling the checkbox and actions menu
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty$1(value);
    }
    get checkboxValue() {
        if (this._isToggleAll) {
            const selectedItemsCount = this.model.reduce((acc, curr) => acc + (curr.selected === 1 ? 1 : 0), 0);
            if (selectedItemsCount === 0) {
                return CheckboxState.UNCHECKED;
            }
            else if (selectedItemsCount === this.model.length) {
                return CheckboxState.CHECKED;
            }
            else {
                return CheckboxState.PARTIAL;
            }
        }
        return this.model && this.model.selected;
    }
    get isEscapable() {
        return this.isMenuOpen;
    }
    _onEscape(event) {
        this.hideMenu();
    }
    ngOnChanges() {
        this.checkModelError();
        if (this.model) {
            this.checkboxSubscription = TableActionsComponent.checkboxObserver.subscribe(() => this.cd.markForCheck());
        }
    }
    ngOnDestroy() {
        this.hideMenu();
        if (this.checkboxSubscription && !this.checkboxSubscription.closed) {
            this.checkboxSubscription.unsubscribe();
            TableActionsComponent.checkboxObserver.next();
        }
    }
    onMenuItemClick(action = null) {
        if (action && !this.isActionDisabled(action) && action.callback) {
            const actionData = this._isToggleAll
                ? this.model && this.getSelectedItems()
                : this.model || {};
            action.callback(actionData);
        }
        this.hideMenu();
    }
    onCheckboxClick(isSelected) {
        if (this._isToggleAll) {
            this.toggleAllSelection(isSelected);
        }
        else {
            this.model.selected = isSelected;
        }
        TableActionsComponent.checkboxObserver.next();
        this.modelChange.emit(this.model);
    }
    onMenuClick() {
        this.isMenuOpen = !this.isMenuOpen;
    }
    showMenu() {
        this.isMenuOpen = true;
    }
    hideMenu() {
        this.isMenuOpen = false;
    }
    isActionDisabled(action) {
        return typeof action.isDisabled === 'function'
            ? action.isDisabled()
            : action.isDisabled;
    }
    getSelectedItems() {
        return this.model.filter(i => i.selected === 1);
    }
    toggleAllSelection(isSelected) {
        this.model.forEach((item) => {
            if (!item.disabled) {
                item.selected = isSelected;
            }
            return item;
        });
    }
    checkModelError() {
        if (!this.model && !this._hideCheckbox) {
            throw new Error('PmccTableActions:[model] should be set,and is needed for checkbox');
        }
        else if (this.model && this._isToggleAll && !this.model.length) {
            throw new Error('PmccTableActions:[model] should non be empty array when isToggleAll=true');
        }
    }
}
TableActionsComponent.ɵfac = function TableActionsComponent_Factory(t) { return new (t || TableActionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
TableActionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableActionsComponent, selectors: [["pmcc-table-actions"]], inputs: { menuTitle: "menuTitle", selectorsTitle: "selectorsTitle", isToggleAll: "isToggleAll", disableCheckbox: "disableCheckbox", hideCheckbox: "hideCheckbox", disabled: "disabled", model: "model", actions: "actions", selectors: "selectors" }, outputs: { modelChange: "modelChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 11, consts: [[1, "table-actions", 3, "ngClass"], ["data-pm-id", "table-action-ckbx", 3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], ["trigger", ""], ["name", "actions-menu", "class", "action-btn", "data-pm-id", "table-action-btn", 3, "click", 4, "ngIf"], ["pmccOverlay", "", 3, "pmccOverlayOpen", "pmccPositionAdjacent", "pmccOverlayScrollStrategy", "pmccOverlayOpenChange"], ["data-pm-id", "table-action-ckbx", 3, "ngModel", "disabled", "ngModelChange"], ["name", "actions-menu", "data-pm-id", "table-action-btn", 1, "action-btn", 3, "click"], ["data-pm-id", "table-actions-popover", 1, "action-menu-container"], ["class", "action-menu", 4, "ngIf"], [1, "action-menu"], [1, "title", 3, "click"], [1, "pmcc-label"], [3, "ngClass", "pmccTooltip", "innerHTML", "click", 4, "ngFor", "ngForOf"], ["data-pm-id", "table-action", 3, "ngClass", "pmccTooltip", "innerHTML", "click", 4, "ngFor", "ngForOf"], ["data-pm-id", "table-action", 3, "ngClass", "pmccTooltip", "innerHTML", "click"], [3, "ngClass", "pmccTooltip", "innerHTML", "click"]], template: function TableActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TableActionsComponent_pmcc_checkbox_1_Template, 1, 2, "pmcc-checkbox", 1);
        ɵngcc0.ɵɵelementStart(2, "span", null, 2);
        ɵngcc0.ɵɵtemplate(4, TableActionsComponent_pmcc_icon_4_Template, 1, 0, "pmcc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TableActionsComponent_ng_template_5_Template, 7, 3, "ng-template", 4);
        ɵngcc0.ɵɵlistener("pmccOverlayOpenChange", function TableActionsComponent_Template_ng_template_pmccOverlayOpenChange_5_listener($event) { return ctx.isMenuOpen = $event; });
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c80, !!ctx.actions && ctx.actions.length && !ctx.hideCheckbox, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideCheckbox);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("pmcc-ta-trigger-disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.actions && ctx.actions.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.isMenuOpen)("pmccPositionAdjacent", _r1)("pmccOverlayScrollStrategy", "close");
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, OverlayDirective, AdjacentPositionDirective, CheckboxComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, IconComponent, ɵngcc1.NgForOf, TooltipDirective], styles: [".table-actions[_ngcontent-%COMP%]{display:inline-block}.table-actions.has-both[_ngcontent-%COMP%]{min-width:30px}.table-actions.pmcc-ta-disabled[_ngcontent-%COMP%]{cursor:not-allowed}.table-actions[_ngcontent-%COMP%]   .pmcc-ta-trigger-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}.table-actions[_ngcontent-%COMP%]   pmcc-checkbox[_ngcontent-%COMP%]{vertical-align:middle}.action-btn.pmcc-ico-actions-menu[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;vertical-align:middle;padding:1px 3px}.action-btn.pmcc-ico-actions-menu[_ngcontent-%COMP%]:hover{color:#222121}.action-menu-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3}.action-menu-container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] + ul[_ngcontent-%COMP%]{border-left:1px solid #f5f5f5}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]{display:block;min-width:100px;max-width:640px;max-height:400px;list-style:none;margin:0;padding:0;overflow:auto;overflow-x:hidden}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#222121;cursor:pointer;padding:8px 16px;text-decoration:none;display:block;white-space:nowrap;font-weight:400}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.highlight[_ngcontent-%COMP%], .action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#f0f0f0}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]{color:#bfbfbf;cursor:not-allowed}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]:hover{background:none}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]{background:#f5f5f5;border-bottom:1px solid #e6e6e6}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]   .pmcc-label[_ngcontent-%COMP%]{font-weight:700}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]   .pmcc-description[_ngcontent-%COMP%]{color:#777c80}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.title[_ngcontent-%COMP%]:hover{background:#f5f5f5;cursor:default}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]{border-top:1px solid #f5f5f5}.action-menu-container[_ngcontent-%COMP%]   .action-menu[_ngcontent-%COMP%]   li.divider[_ngcontent-%COMP%]{height:2px;background:#c3c3c3;padding:0!important}"] });
TableActionsComponent.checkboxObserver = new Subject();
TableActionsComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
TableActionsComponent.propDecorators = {
    model: [{ type: Input }],
    actions: [{ type: Input }],
    menuTitle: [{ type: Input }],
    isToggleAll: [{ type: Input }],
    disableCheckbox: [{ type: Input }],
    hideCheckbox: [{ type: Input }],
    selectorsTitle: [{ type: Input }],
    selectors: [{ type: Input }],
    disabled: [{ type: Input }],
    modelChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableActionsComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-actions',
                template: "<div class=\"table-actions\"\n     [ngClass]=\"{'has-both': !!actions && actions.length && !hideCheckbox,\n                  'pmcc-ta-disabled': disabled}\">\n  <pmcc-checkbox\n    *ngIf=\"!hideCheckbox\"\n    [ngModel]=\"checkboxValue || 0\"\n    [disabled]=\"disableCheckbox || disabled\"\n    (ngModelChange)=\"onCheckboxClick($event)\"\n    data-pm-id=\"table-action-ckbx\"\n  >\n  </pmcc-checkbox>\n  <span \n    #trigger [class.pmcc-ta-trigger-disabled]=\"disabled\">\n    <pmcc-icon\n      *ngIf=\"!!actions && actions.length\"\n      name=\"actions-menu\"\n      class=\"action-btn\"\n      (click)=\"onMenuClick()\"\n      data-pm-id=\"table-action-btn\"\n    ></pmcc-icon>\n  </span>\n</div>\n\n<ng-template\n  pmccOverlay\n  [(pmccOverlayOpen)]=\"isMenuOpen\"\n  [pmccPositionAdjacent]=\"trigger\"\n  [pmccOverlayScrollStrategy]=\"'close'\">\n  <div class=\"action-menu-container\" data-pm-id=\"table-actions-popover\">\n    <ul class=\"action-menu\"\n        *ngIf=\"!!selectors && selectors.length\">\n      <li (click)=\"onMenuItemClick($event)\"\n          class=\"title\">\n        <span class=\"pmcc-label\">{{ selectorsTitle }}</span>\n      </li>\n      <li\n        [ngClass]=\"{\n          'disabled': isActionDisabled(selector),\n          'pmcc-trend-negative': selector.isNegative\n        }\"\n        *ngFor=\"let selector of selectors\"\n        (click)=\"onMenuItemClick(selector)\"\n        [pmccTooltip]=\"selector.tooltip\"\n        [innerHTML]=\"selector.label\"\n        data-pm-id=\"table-action\"\n      >\n      </li>\n    </ul>\n    <ul class=\"action-menu\">\n      <li (click)=\"onMenuItemClick($event)\" class=\"title\">\n        <span class=\"pmcc-label\">{{ menuTitle }}</span>\n      </li>\n      <li\n        [ngClass]=\"{\n          'disabled': isActionDisabled(action),\n          'pmcc-trend-negative': action.isNegative\n        }\"\n        *ngFor=\"let action of actions\"\n        (click)=\"onMenuItemClick(action)\"\n        [pmccTooltip]=\"action.tooltip\"\n        [innerHTML]=\"action.label\">\n      </li>\n    </ul>\n  </div>\n</ng-template>\n",
                styles: [".table-actions{display:inline-block}.table-actions.has-both{min-width:30px}.table-actions.pmcc-ta-disabled{cursor:not-allowed}.table-actions .pmcc-ta-trigger-disabled{pointer-events:none;opacity:.5}.table-actions pmcc-checkbox{vertical-align:middle}.action-btn.pmcc-ico-actions-menu{display:inline-block;cursor:pointer;vertical-align:middle;padding:1px 3px}.action-btn.pmcc-ico-actions-menu:hover{color:#222121}.action-menu-container{display:flex;flex-direction:row;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3}.action-menu-container ul+ul{border-left:1px solid #f5f5f5}.action-menu-container .action-menu{display:block;min-width:100px;max-width:640px;max-height:400px;list-style:none;margin:0;padding:0;overflow:auto;overflow-x:hidden}.action-menu-container .action-menu li{color:#222121;cursor:pointer;padding:8px 16px;text-decoration:none;display:block;white-space:nowrap;font-weight:400}.action-menu-container .action-menu li.highlight,.action-menu-container .action-menu li:hover{background:#f0f0f0}.action-menu-container .action-menu li.disabled{color:#bfbfbf;cursor:not-allowed}.action-menu-container .action-menu li.disabled:hover{background:none}.action-menu-container .action-menu li.title{background:#f5f5f5;border-bottom:1px solid #e6e6e6}.action-menu-container .action-menu li.title .pmcc-label{font-weight:700}.action-menu-container .action-menu li.title .pmcc-description{color:#777c80}.action-menu-container .action-menu li.title:hover{background:#f5f5f5;cursor:default}.action-menu-container .action-menu li+li{border-top:1px solid #f5f5f5}.action-menu-container .action-menu li.divider{height:2px;background:#c3c3c3;padding:0!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { menuTitle: [{
            type: Input
        }], selectorsTitle: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], isToggleAll: [{
            type: Input
        }], disableCheckbox: [{
            type: Input
        }], hideCheckbox: [{
            type: Input
        }], disabled: [{
            type: Input
        }], model: [{
            type: Input
        }], actions: [{
            type: Input
        }], selectors: [{
            type: Input
        }] }); })();

const EXPORT_DECLARATIONS = [
    TableActionsComponent
];
class TableActionsModule {
}
TableActionsModule.ɵfac = function TableActionsModule_Factory(t) { return new (t || TableActionsModule)(); };
TableActionsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableActionsModule });
TableActionsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TooltipModule,
            CheckboxModule,
            FormsModule,
            LayoutModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableActionsModule, [{
        type: NgModule,
        args: [{
                declarations: EXPORT_DECLARATIONS,
                imports: [
                    CommonModule,
                    TooltipModule,
                    CheckboxModule,
                    FormsModule,
                    LayoutModule,
                    IconModule
                ],
                exports: [
                    ...EXPORT_DECLARATIONS
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableActionsModule, { declarations: function () { return [TableActionsComponent]; }, imports: function () { return [CommonModule, TooltipModule, CheckboxModule, FormsModule, LayoutModule, IconModule]; }, exports: function () { return [TableActionsComponent]; } }); })();

class TableTreeComponent {
    constructor() {
        this._links = {};
        /**
         * Emitted when a row is expanded/collapsed.
         */
        this.toggle = new EventEmitter();
        /**
         * Stores expanded state of the rows.
         */
        this.isExpanded = {};
        /**
         * Row expand/collapse event handler
         */
        this.onToggle = (id) => {
            this.toggle.emit(id);
            this.isExpanded[id] = !this.isExpanded[id];
        };
    }
    get links() {
        return this._links;
    }
    ngOnChanges(changes) {
        if ('treeData' in changes) {
            this.populateLinks();
        }
    }
    /**
     * Computes links for each level in the table in the form of
     * [1, 0, 1],
     *   where
     *      1 - indicates a link
     *      0 - no link.
     */
    populateLinks() {
        const populateInner = (data) => {
            data.forEach((datum, i, arr) => {
                const lastParent = i === arr.length - 1;
                if (datum.items) {
                    datum.items.forEach(item => {
                        const parentLinks = this._links[datum.id] || [];
                        const links = parentLinks.slice();
                        if (lastParent && links[links.length - 1] === 1) {
                            links[links.length - 1] = 0;
                        }
                        links.push(1);
                        this._links[item.id] = links;
                    });
                    populateInner(datum.items);
                }
            });
        };
        populateInner(this.treeData);
    }
}
TableTreeComponent.ɵfac = function TableTreeComponent_Factory(t) { return new (t || TableTreeComponent)(); };
TableTreeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableTreeComponent, selectors: [["pmcc-table-tree"]], inputs: { headerTemplate: "headerTemplate", rowTemplate: "rowTemplate", treeData: "treeData", numColumns: "numColumns" }, outputs: { toggle: "toggle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [["cellpadding", "0", "cellspacing", "0", "width", "100%", 1, "pmcc-table-tree"], [3, "ngTemplateOutlet"], [4, "ngFor", "ngForOf"], ["rowTemplateInner", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngClass"], ["pmccTableTreeNester", "", 3, "item", "isExpanded", "numColumns", "rowTemplate", "level", "toggle"]], template: function TableTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "table", 0);
        ɵngcc0.ɵɵelementStart(1, "thead");
        ɵngcc0.ɵɵelementStart(2, "tr");
        ɵngcc0.ɵɵelementContainer(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TableTreeComponent_tbody_4_Template, 2, 8, "tbody", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TableTreeComponent_ng_template_5_Template, 3, 14, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.treeData);
    } }, directives: function () { return [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, ɵngcc1.NgClass, TableTreeNesterComponent]; }, styles: ["pmcc-table-tree-toggler{display:block}.pmcc-table-tree{position:relative;left:0}.pmcc-table-tree tbody:last-child>tr>td>pmcc-table-tree-toggler .link-leaf:after{visibility:hidden}.pmcc-table-tree .pmcc-text-center{text-align:center}.pmcc-table-tree .pmcc-text-right{text-align:right}.pmcc-table-tree thead th{background-color:#f5f5f5;text-align:left;padding:5px;border:1px solid #ebebeb;border-width:1px 0 2px}.pmcc-table-tree tbody{border:0;padding:0;margin:0}.pmcc-table-tree tbody tr td{border-bottom:1px solid #ebebeb}.pmcc-table-tree tbody tr td+td{border-left:1px solid #ebebeb}.pmcc-table-tree tbody>tr.expanded td{background-color:#e7e7e7;font-weight:700}.pmcc-table-tree .td-nested-row{padding:0;border:0;margin:0;height:0;background-color:#f8f8f8}.pmcc-table-tree .td-nested-row tbody>tr td{background-color:initial;font-weight:400}.pmcc-table-tree .td-nested-row.show{background-color:#f8f8f8}.pmcc-table-tree .td-nested-row.show>div{overflow:auto}.pmcc-table-tree .td-nested-row .pmcc-table-tree{margin-bottom:0;border:0;background:none}.pmcc-table-tree .td-nested-row .pmcc-table-tree tr:last-child{border:0}.pmcc-table-tree-toggler{min-height:17px;padding-left:5px}.pmcc-table-tree-toggler .link,.pmcc-table-tree-toggler .link-leaf{position:relative;width:13px}.pmcc-table-tree-toggler .link-leaf:after,.pmcc-table-tree-toggler .link-leaf:before,.pmcc-table-tree-toggler .link:after,.pmcc-table-tree-toggler .link:before{content:\"\";position:absolute;display:inline-block;width:50%;right:0}.pmcc-table-tree-toggler .link:after{top:0;height:100%;border-left:1px dotted #999}.pmcc-table-tree-toggler .link-leaf:before{top:0;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.pmcc-table-tree-toggler .link-leaf:after{bottom:0;height:50%;border-left:1px dotted #999}.pmcc-table-tree-toggler .pmcc-left{align-items:flex-start}.pmcc-table-tree-toggler .pmcc-toggler-content{justify-content:flex-start;padding:5px 8px 5px 3px}.pmcc-table-tree-toggler .tree-node.empty+.pmcc-toggler-content{padding-left:5px}.pmcc-table-tree-toggler.pmcc-treenode-leaf{cursor:default}.pmcc-table-tree-toggler.pmcc-treenode-leaf .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"empty\";visibility:hidden;display:none}.pmcc-table-tree-toggler.pmcc-treenode-leaf .pmcc-badge{display:none}.pmcc-table-tree-toggler.pmcc-treenode-expanded{cursor:pointer}.pmcc-table-tree-toggler.pmcc-treenode-expanded .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"a\"}.pmcc-table-tree-toggler.pmcc-treenode-collapsed{cursor:pointer}.pmcc-table-tree-toggler.pmcc-treenode-collapsed .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"d\"}.pmcc-table-tree-toggler .pmcc-treenode-count{padding:5px;min-width:70px}"], encapsulation: 2 });
TableTreeComponent.propDecorators = {
    headerTemplate: [{ type: Input }],
    rowTemplate: [{ type: Input }],
    treeData: [{ type: Input }],
    numColumns: [{ type: Input }],
    toggle: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-tree',
                template: "<table class=\"pmcc-table-tree\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n  <thead>\n  <tr>\n    <ng-container [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n  </tr>\n  </thead>\n  <tbody *ngFor=\"let item of treeData\">\n  <ng-container\n    [ngTemplateOutlet]=\"rowTemplateInner\"\n    [ngTemplateOutletContext]=\"{\n      isExpanded: isExpanded,\n      rowTemplate: rowTemplateInner,\n      numColumns: numColumns,\n      item: item,\n      level: 0,\n      toggle: onToggle\n    }\">\n  </ng-container>\n  </tbody>\n</table>\n\n<ng-template\n  #rowTemplateInner\n  let-item=\"item\"\n  let-isExpanded=\"isExpanded\"\n  let-numColumns=\"numColumns\"\n  let-level=\"level\"\n  let-toggle=\"toggle\"\n>\n  <tr [ngClass]=\"isExpanded[item.id] && item?.items?.length && 'expanded'\">\n    <ng-container\n      [ngTemplateOutlet]=\"rowTemplate\"\n      [ngTemplateOutletContext]=\"{\n        isExpanded: isExpanded,\n        numColumns: numColumns,\n        item: item,\n        level: level,\n        toggle: toggle\n     }\">\n    </ng-container>\n  </tr>\n\n  <tr\n    pmccTableTreeNester\n    [item]=\"item\"\n    [isExpanded]=\"isExpanded\"\n    [numColumns]=\"numColumns\"\n    [rowTemplate]=\"rowTemplateInner\"\n    [level]=\"level\"\n    (toggle)=\"toggle($event)\"\n  ></tr>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["pmcc-table-tree-toggler{display:block}.pmcc-table-tree{position:relative;left:0}.pmcc-table-tree tbody:last-child>tr>td>pmcc-table-tree-toggler .link-leaf:after{visibility:hidden}.pmcc-table-tree .pmcc-text-center{text-align:center}.pmcc-table-tree .pmcc-text-right{text-align:right}.pmcc-table-tree thead th{background-color:#f5f5f5;text-align:left;padding:5px;border:1px solid #ebebeb;border-width:1px 0 2px}.pmcc-table-tree tbody{border:0;padding:0;margin:0}.pmcc-table-tree tbody tr td{border-bottom:1px solid #ebebeb}.pmcc-table-tree tbody tr td+td{border-left:1px solid #ebebeb}.pmcc-table-tree tbody>tr.expanded td{background-color:#e7e7e7;font-weight:700}.pmcc-table-tree .td-nested-row{padding:0;border:0;margin:0;height:0;background-color:#f8f8f8}.pmcc-table-tree .td-nested-row tbody>tr td{background-color:initial;font-weight:400}.pmcc-table-tree .td-nested-row.show{background-color:#f8f8f8}.pmcc-table-tree .td-nested-row.show>div{overflow:auto}.pmcc-table-tree .td-nested-row .pmcc-table-tree{margin-bottom:0;border:0;background:none}.pmcc-table-tree .td-nested-row .pmcc-table-tree tr:last-child{border:0}.pmcc-table-tree-toggler{min-height:17px;padding-left:5px}.pmcc-table-tree-toggler .link,.pmcc-table-tree-toggler .link-leaf{position:relative;width:13px}.pmcc-table-tree-toggler .link-leaf:after,.pmcc-table-tree-toggler .link-leaf:before,.pmcc-table-tree-toggler .link:after,.pmcc-table-tree-toggler .link:before{content:\"\";position:absolute;display:inline-block;width:50%;right:0}.pmcc-table-tree-toggler .link:after{top:0;height:100%;border-left:1px dotted #999}.pmcc-table-tree-toggler .link-leaf:before{top:0;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.pmcc-table-tree-toggler .link-leaf:after{bottom:0;height:50%;border-left:1px dotted #999}.pmcc-table-tree-toggler .pmcc-left{align-items:flex-start}.pmcc-table-tree-toggler .pmcc-toggler-content{justify-content:flex-start;padding:5px 8px 5px 3px}.pmcc-table-tree-toggler .tree-node.empty+.pmcc-toggler-content{padding-left:5px}.pmcc-table-tree-toggler.pmcc-treenode-leaf{cursor:default}.pmcc-table-tree-toggler.pmcc-treenode-leaf .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"empty\";visibility:hidden;display:none}.pmcc-table-tree-toggler.pmcc-treenode-leaf .pmcc-badge{display:none}.pmcc-table-tree-toggler.pmcc-treenode-expanded{cursor:pointer}.pmcc-table-tree-toggler.pmcc-treenode-expanded .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"a\"}.pmcc-table-tree-toggler.pmcc-treenode-collapsed{cursor:pointer}.pmcc-table-tree-toggler.pmcc-treenode-collapsed .pmcc-table-tree-node:before{font-family:pmcc-ico;content:\" \";display:inline-block;font-size:11px;width:13px;height:15px;content:\"d\"}.pmcc-table-tree-toggler .pmcc-treenode-count{padding:5px;min-width:70px}"]
            }]
    }], function () { return []; }, { toggle: [{
            type: Output
        }], headerTemplate: [{
            type: Input
        }], rowTemplate: [{
            type: Input
        }], treeData: [{
            type: Input
        }], numColumns: [{
            type: Input
        }] }); })();

class TableTreeNesterComponent {
    constructor(tree) {
        this.tree = tree;
        this.toggle = new EventEmitter();
        this.onToggle = (id) => {
            this.toggle.emit(id);
        };
    }
    ngOnChanges(changes) {
        if ('item' in changes) {
            if (!this.tree.links[this.item.id] && this.level) {
                this.tree.populateLinks();
            }
        }
    }
}
TableTreeNesterComponent.ɵfac = function TableTreeNesterComponent_Factory(t) { return new (t || TableTreeNesterComponent)(ɵngcc0.ɵɵdirectiveInject(TableTreeComponent)); };
TableTreeNesterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableTreeNesterComponent, selectors: [["", "pmccTableTreeNester", ""]], inputs: { rowTemplate: "rowTemplate", numColumns: "numColumns", isExpanded: "isExpanded", item: "item", level: "level" }, outputs: { toggle: "toggle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c83, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "td-nested-row", 3, "ngClass"], ["cellspacing", "0", "cellpadding", "0", "width", "100%", 1, "pmcc-table-tree"], [4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function TableTreeNesterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TableTreeNesterComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isExpanded[ctx.item.id]);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
TableTreeNesterComponent.ctorParameters = () => [
    { type: TableTreeComponent }
];
TableTreeNesterComponent.propDecorators = {
    rowTemplate: [{ type: Input }],
    numColumns: [{ type: Input }],
    isExpanded: [{ type: Input }],
    item: [{ type: Input }],
    level: [{ type: Input }],
    toggle: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeNesterComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[pmccTableTreeNester]',
                template: "<ng-container *ngIf=\"isExpanded[item.id]\">\n  <td\n    [attr.colspan]=\"numColumns\"\n    class=\"td-nested-row\"\n    [ngClass]=\"{ show: isExpanded[item.id] }\"\n  >\n    <table class=\"pmcc-table-tree\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n      <thead></thead>\n      <tbody *ngFor=\"let item of item.items\">\n      <ng-container\n        [ngTemplateOutlet]=\"rowTemplate\"\n        [ngTemplateOutletContext]=\"{\n          rowTemplate: rowTemplate,\n          numColumns: numColumns,\n          isExpanded: isExpanded,\n          item: item,\n          level: level + 1,\n          toggle: onToggle\n      }\"\n      ></ng-container>\n      </tbody>\n    </table>\n  </td>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: TableTreeComponent }]; }, { toggle: [{
            type: Output
        }], rowTemplate: [{
            type: Input
        }], numColumns: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }], item: [{
            type: Input
        }], level: [{
            type: Input
        }] }); })();

class TableTreeTogglerComponent {
    constructor(tree) {
        this.tree = tree;
        this.label = 'Please specify a label';
        this.count = 0;
        this.toggle = new EventEmitter();
    }
    get links() {
        return this.tree.links[this.id];
    }
    get togglerClass() {
        let type = 'collapsed';
        if (this.count === 0) {
            type = 'leaf';
        }
        else if (this.isExpanded[this.id]) {
            type = 'expanded';
        }
        return `pmcc-treenode-${type}`;
    }
    onClick() {
        if (this.count !== 0) {
            this.toggle.emit(this.id);
        }
    }
}
TableTreeTogglerComponent.ɵfac = function TableTreeTogglerComponent_Factory(t) { return new (t || TableTreeTogglerComponent)(ɵngcc0.ɵɵdirectiveInject(TableTreeComponent)); };
TableTreeTogglerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableTreeTogglerComponent, selectors: [["pmcc-table-tree-toggler"]], inputs: { label: "label", count: "count", id: "id", isExpanded: "isExpanded", level: "level", loading: "loading" }, outputs: { toggle: "toggle" }, ngContentSelectors: _c1, decls: 11, vars: 22, consts: [[1, "pmcc-flex", "pmcc-table-tree-toggler", 3, "ngClass", "click"], [3, "visibility", "link", "link-leaf", 4, "ngFor", "ngForOf"], [1, "pmcc-left", "tree-node"], ["class", "pmcc-table-tree-node", 4, "ngIf", "ngIfElse"], ["loader", ""], [1, "pmcc-left", "pmcc-toggler-content"], [1, "pmcc-truncate", 3, "title"], [1, "pmcc-right", "pmcc-treenode-count"], ["class", "pmcc-badge pmcc-count pmcc-truncate", 3, "title", 4, "ngIf"], [1, "pmcc-table-tree-node"], [1, "pmcc-effect-spin", "pmcc-ico-processing", 2, "vertical-align", "middle", "text-align", "center"], [1, "pmcc-badge", "pmcc-count", "pmcc-truncate", 3, "title"]], template: function TableTreeTogglerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function TableTreeTogglerComponent_Template_div_click_0_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵtemplate(1, TableTreeTogglerComponent_span_1_Template, 1, 6, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TableTreeTogglerComponent_span_3_Template, 1, 0, "span", 3);
        ɵngcc0.ɵɵtemplate(4, TableTreeTogglerComponent_ng_template_4_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtemplate(10, TableTreeTogglerComponent_span_10_Template, 3, 4, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("ngClass", ctx.togglerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.links);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("flex-grow", 0)("flex-shrink", 1);
        ɵngcc0.ɵɵclassProp("empty", !ctx.count);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("flex-grow", 1)("flex-shrink", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("flex-grow", 0)("flex-shrink", 1)("flex-basis", 70, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.count);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf], pipes: [ɵngcc1.DecimalPipe], encapsulation: 2 });
TableTreeTogglerComponent.ctorParameters = () => [
    { type: TableTreeComponent }
];
TableTreeTogglerComponent.propDecorators = {
    id: [{ type: Input }],
    isExpanded: [{ type: Input }],
    label: [{ type: Input }],
    count: [{ type: Input }],
    level: [{ type: Input }],
    loading: [{ type: Input }],
    toggle: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeTogglerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-tree-toggler',
                template: "<div\n  class=\"pmcc-flex pmcc-table-tree-toggler\"\n  [ngClass]=\"togglerClass\"\n  (click)=\"onClick()\"\n>\n  <span\n    *ngFor=\"let i of links; last as last\"\n    [style.visibility]=\"i == 0 ? 'hidden' : null\"\n    [class.link]=\"!last\"\n    [class.link-leaf]=\"last\"\n  ></span>\n\n  <div\n    class=\"pmcc-left tree-node\"\n    [class.empty]=\"!count\"\n    [style.flex-grow]=\"0\"\n    [style.flex-shrink]=\"1\"\n  >\n    <span *ngIf=\"!loading; else loader\" class=\"pmcc-table-tree-node\"></span>\n    <ng-template #loader>\n      <i\n        class=\"pmcc-effect-spin pmcc-ico-processing\"\n        style=\"vertical-align: middle; text-align: center;\"\n      ></i>\n    </ng-template>\n  </div>\n  <div\n    class=\"pmcc-left pmcc-toggler-content\"\n    [style.flex-grow]=\"1\"\n    [style.flex-shrink]=\"1\"\n  >\n    <span class=\"pmcc-truncate\" [title]=\"label\">\n      <ng-content></ng-content>\n    </span>\n  </div>\n  <div\n    class=\"pmcc-right pmcc-treenode-count\"\n    [style.flex-grow]=\"0\"\n    [style.flex-shrink]=\"1\"\n    [style.flex-basis.px]=\"70\"\n  >\n    <span class=\"pmcc-badge pmcc-count pmcc-truncate\" *ngIf=\"count\" [title]=\"count\">\n      {{ count | number }}\n    </span>\n  </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: TableTreeComponent }]; }, { label: [{
            type: Input
        }], count: [{
            type: Input
        }], toggle: [{
            type: Output
        }], id: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }], level: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();

class TableTreeModule {
}
TableTreeModule.ɵfac = function TableTreeModule_Factory(t) { return new (t || TableTreeModule)(); };
TableTreeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableTreeModule });
TableTreeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TableTreeComponent,
                    TableTreeNesterComponent,
                    TableTreeTogglerComponent,
                ],
                imports: [CommonModule],
                exports: [
                    TableTreeComponent,
                    TableTreeTogglerComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableTreeModule, { declarations: function () { return [TableTreeComponent, TableTreeNesterComponent, TableTreeTogglerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TableTreeComponent, TableTreeTogglerComponent]; } }); })();

class TableTreeMultiselectComponent {
    constructor() {
        this.columnHeaders = [];
        this.rowSelected = new EventEmitter();
        this.rowDeselected = new EventEmitter();
        this.rowExpanded = new EventEmitter();
        this.rowCollapsed = new EventEmitter();
        this.updateRowSelection = (row) => {
            if (!this.selectedRows[row.id]) {
                this.selectedRows[row.id] = row;
                this.onRowSelect(row);
            }
        };
        this.updateRowDeselection = (row) => {
            if (this.selectedRows[row.id]) {
                delete this.selectedRows[row.id];
                this.onRowDeselect(row);
            }
        };
        this.onRowSelect = (row) => {
            this.rowSelected.emit(row);
        };
        this.onRowDeselect = (row) => {
            this.rowDeselected.emit(row);
        };
        this.onRowExpand = (row) => {
            this.rowExpanded.emit(row);
        };
        this.onRowCollapse = (row) => {
            this.rowCollapsed.emit(row);
        };
    }
    ngOnInit() {
        this.tableAttrs = {
            colspan: this.columnHeaders.length + 1,
            collapsecol: this.columnHeaders.findIndex(header => header.isExpandable),
        };
    }
}
TableTreeMultiselectComponent.ɵfac = function TableTreeMultiselectComponent_Factory(t) { return new (t || TableTreeMultiselectComponent)(); };
TableTreeMultiselectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableTreeMultiselectComponent, selectors: [["pmcc-table-tree-multiselect"]], inputs: { columnHeaders: "columnHeaders", selectedRows: "selectedRows", rows: "rows", selectionDisabled: "selectionDisabled" }, outputs: { rowSelected: "rowSelected", rowDeselected: "rowDeselected", rowExpanded: "rowExpanded", rowCollapsed: "rowCollapsed" }, decls: 8, vars: 2, consts: [[1, "pmcc-ttms"], [1, "pmcc-table"], [1, "ttms-select-col", "ttms-col"], ["class", "ttms-col", 3, "ttms-title-col", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "ttms-col"], [3, "row", "tableAttrs", "level", "selectionDisabled", "selectedRows", "rowSelected", "rowExpanded", "rowCollapsed", "rowDeselected"]], template: function TableTreeMultiselectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "table", 1);
        ɵngcc0.ɵɵelementStart(2, "thead");
        ɵngcc0.ɵɵelementStart(3, "tr");
        ɵngcc0.ɵɵelement(4, "th", 2);
        ɵngcc0.ɵɵtemplate(5, TableTreeMultiselectComponent_th_5_Template, 2, 3, "th", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "tbody");
        ɵngcc0.ɵɵtemplate(7, TableTreeMultiselectComponent_tr_7_Template, 3, 6, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columnHeaders);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.rows);
    } }, directives: function () { return [ɵngcc1.NgForOf, TableTreeMultiselectRowComponent]; }, styles: [_c86] });
TableTreeMultiselectComponent.propDecorators = {
    selectedRows: [{ type: Input }],
    rows: [{ type: Input }],
    columnHeaders: [{ type: Input }],
    selectionDisabled: [{ type: Input }],
    rowSelected: [{ type: Output }],
    rowDeselected: [{ type: Output }],
    rowExpanded: [{ type: Output }],
    rowCollapsed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeMultiselectComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-tree-multiselect',
                template: "<div class=\"pmcc-ttms\">\n  <table class=\"pmcc-table\">\n    <thead>\n    <tr>\n      <th class=\"ttms-select-col ttms-col\"></th>\n      <th\n        class=\"ttms-col\"\n        *ngFor=\"let columnHeader of columnHeaders; let index=index\"\n        [class.ttms-title-col]=\"index == tableAttrs.collapsecol\"\n      >\n        {{ columnHeader.label }}\n      </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let row of rows\">\n      <td [attr.colspan]=\"tableAttrs.colspan\">\n        <pmcc-table-tree-multiselect-row\n          [row]=\"row\"\n          (rowSelected)=\"updateRowSelection($event)\"\n          (rowExpanded)= \"onRowExpand($event);\"\n          (rowCollapsed) = \"onRowCollapse($event)\"\n          (rowDeselected)=\"updateRowDeselection($event)\"\n          [tableAttrs]=\"tableAttrs\"\n          [level]=\"0\"\n          [selectionDisabled]=\"selectionDisabled\"\n          [selectedRows]=\"selectedRows\"\n        ></pmcc-table-tree-multiselect-row>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n",
                styles: [".pmcc-ttms{border-spacing:0;border:0;overflow:auto;table-layout:fixed;border-collapse:collapse;border-right:1px solid #ebebeb}td,th,tr{padding:0;border:0;margin:0;vertical-align:middle}tr.row-selected td.ttms-col,tr.row-selected td.ttms-col:hover{background:#e2f4fe}tr td,tr td:hover{background:#fff}.ttms-col{border-left:1px solid #ebebeb;width:15%;padding:0 5px}table{border-bottom:1px solid #ebebeb;width:100%;border-spacing:0;table-layout:fixed;border-collapse:collapse}table table{border-bottom:0 solid #ebebeb}.ttms-select-col{width:30px;min-width:30px;max-width:30px}.ttms-select-col .ttms-caret-align{margin-bottom:2px}.ttms-title-col{width:auto;text-overflow:ellipsis;overflow:hidden;position:relative}.ttms-title-col span.label.cell:hover{color:#0196d8;cursor:pointer}.tree-node{display:flex;align-items:stretch}.tree-node span.fas{margin-left:4px;align-self:center}.tree-node span.leg{position:relative;display:inline-block;width:25px;align-self:stretch}.tree-node span.leg:after,.tree-node span.leg:before{content:\"\";position:absolute;display:inline-block}.tree-node span.leg.bypass:after{right:0;top:0;width:50%;height:100%;border-left:1px dotted #999}.tree-node span.leg.mid:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node span.leg.mid:after{right:0;bottom:0;width:50%;height:50%;border-left:1px dotted #999}.tree-node span.leg.last:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node span.leg.last.blank:after,.tree-node span.leg.last.blank:before{border:0}.tree-node span.leg.label{flex:1;padding:8px}"]
            }]
    }], function () { return []; }, { columnHeaders: [{
            type: Input
        }], rowSelected: [{
            type: Output
        }], rowDeselected: [{
            type: Output
        }], rowExpanded: [{
            type: Output
        }], rowCollapsed: [{
            type: Output
        }], selectedRows: [{
            type: Input
        }], rows: [{
            type: Input
        }], selectionDisabled: [{
            type: Input
        }] }); })();

class TableTreeMultiselectRowComponent {
    constructor() {
        this.rowSelected = new EventEmitter();
        this.rowDeselected = new EventEmitter();
        this.rowExpanded = new EventEmitter();
        this.rowCollapsed = new EventEmitter();
        this.updateSelectionToParent = new EventEmitter();
        this.expanded = false;
        this.selectedImmediateChildrenCount = 0;
        this.selectBoxOptions = [];
        this.bypasses = [];
        this.selectChildrenOnLoad = false;
    }
    get rowUtil() {
        return {
            id: this.row.id,
            data: this.row.customData,
            childrenCount: (this.row.children || []).length,
            select: () => this.select(),
            deselect: () => this.deselect(),
            selectChildren: () => this.selectChildren(),
            deselectChildren: () => this.deselectChildren(),
            selectAll: () => this.selectAll(),
            deselectAll: () => this.deselectAll(),
            addChildren: (rows) => this.addChildren(rows)
        };
    }
    getRowActions() {
        const that = this;
        const areChildrenSelectable = () => (that.row.isParent &&
            (
            // None of the children are selected, may be this condition is for delayed loaded children
            that.selectedImmediateChildrenCount === 0 ||
                // Or atleast not all of them are selected
                (that.selectedImmediateChildrenCount !== (that.row.children && that.row.children.length))));
        return [{
                label: 'Select Item Only',
                get isDisabled() {
                    return that.selectionDisabled || !!that.selected;
                },
                callback: () => that.select(),
            }, {
                label: 'Select Children Only',
                get isDisabled() {
                    return that.selectionDisabled || !areChildrenSelectable();
                },
                callback: () => that.selectChildren(),
            }, {
                label: 'Select Item + Children',
                get isDisabled() {
                    return that.selectionDisabled || !!that.selected || !areChildrenSelectable();
                },
                callback: () => that.selectAll(),
            }, {
                label: 'Deselect Item Only',
                get isDisabled() {
                    return !that.selected;
                },
                callback: () => that.deselect(),
            }, {
                label: 'Deselect Children Only',
                get isDisabled() {
                    return !that.row.isParent || that.selectedImmediateChildrenCount === 0;
                },
                callback: () => that.deselectChildren()
            }, {
                label: 'Deselect Item + Children',
                get isDisabled() {
                    return (!that.row.isParent ||
                        that.selectedImmediateChildrenCount === 0 ||
                        !that.selected);
                },
                callback: () => that.deselectAll(),
            }];
    }
    ngOnInit() {
        if (this.selectedRows[this.row.id] || this.row.selected) {
            this.select();
        }
        this.selectBoxOptions = this.getRowActions();
        this.bypasses = new Array(this.level).fill(null);
    }
    select() {
        if (this.selectionDisabled || this.selected) {
            return;
        }
        this.selected = true;
        this.rowSelected.emit(this.rowUtil);
        this.updateSelectionToParent.emit({
            oldValue: 0,
            newValue: 1,
        });
    }
    deselect() {
        if (!this.selected) {
            return;
        }
        this.selected = false;
        this.rowDeselected.emit(this.rowUtil);
        this.updateSelectionToParent.emit({
            oldValue: 1,
            newValue: 0,
        });
    }
    selectChildren() {
        if (!(this.row.children && this.row.children.length)) {
            this.selectChildrenOnLoad = true;
        }
        this.expandRow();
        if (this.childRows) {
            this.childRows.forEach(row => row.select());
        }
    }
    deselectChildren() {
        if (this.childRows) {
            this.childRows.forEach(row => row.deselect());
        }
    }
    selectAll() {
        this.select();
        this.selectChildren();
    }
    deselectAll() {
        this.deselect();
        this.deselectChildren();
    }
    toggleExpand() {
        if (this.expanded) {
            this.collapseRow();
        }
        else {
            this.expandRow();
        }
    }
    toggleSelect() {
        if (this.selected) {
            this.deselect();
        }
        else {
            this.select();
        }
    }
    expandRow() {
        if (!this.expanded) {
            this.expanded = true;
            this.onRowExpand(this.rowUtil);
        }
    }
    collapseRow() {
        if (this.expanded) {
            this.expanded = false;
            this.onRowCollapse(this.rowUtil);
        }
    }
    onRowSelect(row) {
        this.rowSelected.emit(row);
    }
    onRowDeselect(row) {
        this.rowDeselected.emit(row);
    }
    onRowExpand(row) {
        this.rowExpanded.emit(row);
    }
    onRowCollapse(row) {
        this.rowCollapsed.emit(row);
    }
    updateSelectionFromChildren({ oldValue, newValue }) {
        this.selectedImmediateChildrenCount += newValue - oldValue;
    }
    addChildren(rows) {
        this.row.children = rows;
        if (this.selectChildrenOnLoad) {
            this.selectChildrenOnLoad = false;
            rows.map(row => row.selected = true);
        }
    }
}
TableTreeMultiselectRowComponent.ɵfac = function TableTreeMultiselectRowComponent_Factory(t) { return new (t || TableTreeMultiselectRowComponent)(); };
TableTreeMultiselectRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableTreeMultiselectRowComponent, selectors: [["pmcc-table-tree-multiselect-row"]], viewQuery: function TableTreeMultiselectRowComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TableTreeMultiselectRowComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.childRows = _t);
    } }, inputs: { selected: "selected", tableAttrs: "tableAttrs", level: "level", selectionDisabled: "selectionDisabled", row: "row", selectedRows: "selectedRows" }, outputs: { rowSelected: "rowSelected", rowDeselected: "rowDeselected", rowExpanded: "rowExpanded", rowCollapsed: "rowCollapsed", updateSelectionToParent: "updateSelectionToParent" }, decls: 10, vars: 7, consts: [[1, "ttms-select-col", "ttms-col"], [1, "ttms-caret-align"], [3, "model", "actions", "hideCheckbox"], ["class", "ttms-col", 3, "ttms-title-col", 4, "ngFor", "ngForOf"], [3, "hidden", 4, "ngFor", "ngForOf"], [1, "ttms-col"], [1, "tree-node"], [4, "ngIf"], ["class", "leg mid", 4, "ngIf"], ["class", "fas fa-caret-right pmcc-ico-2x pmcc-pointer", 3, "ngClass", "click", 4, "ngIf"], [1, "leg", "label", "cell", "column-content", 3, "innerHTML", "click"], ["class", "leg bypass", 4, "ngFor", "ngForOf"], [1, "leg", "bypass"], [1, "leg", "mid"], [1, "fas", "fa-caret-right", "pmcc-ico-2x", "pmcc-pointer", 3, "ngClass", "click"], [3, "hidden"], [3, "row", "tableAttrs", "level", "selectedRows", "rowSelected", "rowDeselected", "rowExpanded", "rowCollapsed", "updateSelectionToParent"]], template: function TableTreeMultiselectRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "table");
        ɵngcc0.ɵɵelement(2, "thead");
        ɵngcc0.ɵɵelementStart(3, "tbody");
        ɵngcc0.ɵɵelementStart(4, "tr");
        ɵngcc0.ɵɵelementStart(5, "td", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelement(7, "pmcc-table-actions", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, TableTreeMultiselectRowComponent_td_8_Template, 6, 6, "td", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, TableTreeMultiselectRowComponent_tr_9_Template, 3, 6, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("row-selected", ctx.selected);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("model", ctx.selected)("actions", ctx.selectBoxOptions)("hideCheckbox", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.row.columnValues);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.row.children);
    } }, directives: [TableActionsComponent, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgClass, TableTreeMultiselectRowComponent], styles: [_c86] });
TableTreeMultiselectRowComponent.propDecorators = {
    tableAttrs: [{ type: Input }],
    level: [{ type: Input }],
    selected: [{ type: Input }],
    selectionDisabled: [{ type: Input }],
    row: [{ type: Input }],
    selectedRows: [{ type: Input }],
    rowSelected: [{ type: Output }],
    rowDeselected: [{ type: Output }],
    rowExpanded: [{ type: Output }],
    rowCollapsed: [{ type: Output }],
    updateSelectionToParent: [{ type: Output }],
    childRows: [{ type: ViewChildren, args: [TableTreeMultiselectRowComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeMultiselectRowComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-tree-multiselect-row',
                template: "<div>\n  <table>\n    <thead></thead>\n    <tbody>\n      <tr [class.row-selected]=\"selected\">\n        <td class=\"ttms-select-col ttms-col\">\n          <div class=\"ttms-caret-align\">\n            <pmcc-table-actions\n              [model]=\"selected\"\n              [actions]=\"selectBoxOptions\"\n              [hideCheckbox]=\"true\"\n            ></pmcc-table-actions>\n          </div>\n        </td>\n        <td\n          *ngFor=\"let columnValue of row.columnValues; let index=index\"\n          class=\"ttms-col\"\n          [class.ttms-title-col]=\"index == tableAttrs.collapsecol\"\n        >\n          <span class=\"tree-node\">\n            <ng-container *ngIf=\"index == tableAttrs.collapsecol\">\n              <span\n                class=\"leg bypass\"\n                *ngFor=\"let _ of bypasses\"\n              ></span>\n            </ng-container>\n            <span class=\"leg mid\" *ngIf=\"index == tableAttrs.collapsecol\"></span>\n            <span\n              class=\"fas fa-caret-right pmcc-ico-2x pmcc-pointer\"\n              (click)=\"toggleExpand()\"\n              *ngIf=\"index === tableAttrs.collapsecol && row.isParent\"\n              [ngClass]=\"{\n                'pmcc-ico-caret-right' : !expanded,\n                'pmcc-ico-caret-down': expanded\n              }\"\n            ></span>\n            <span\n              class=\"leg label cell column-content\"\n              (click)=\"toggleSelect()\"\n              [innerHTML]=\"columnValue\"\n            ></span>\n          </span>\n        </td>\n      </tr>\n\n      <tr\n        *ngFor=\"let row of row.children\"\n        [hidden]=\"!expanded\"\n      >\n        <td [attr.colspan]=\"tableAttrs.colspan\">\n          <pmcc-table-tree-multiselect-row\n            [row]=\"row\"\n            [tableAttrs]=\"tableAttrs\"\n            [level]=\"level + 1\"\n            [selectedRows]=\"selectedRows\"\n            (rowSelected)=\"onRowSelect($event)\"\n            (rowDeselected)=\"onRowDeselect($event)\"\n            (rowExpanded)=\"onRowExpand($event)\"\n            (rowCollapsed)=\"onRowCollapse($event)\"\n            (updateSelectionToParent)=\"updateSelectionFromChildren($event)\"\n          ></pmcc-table-tree-multiselect-row>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n",
                styles: [".pmcc-ttms{border-spacing:0;border:0;overflow:auto;table-layout:fixed;border-collapse:collapse;border-right:1px solid #ebebeb}td,th,tr{padding:0;border:0;margin:0;vertical-align:middle}tr.row-selected td.ttms-col,tr.row-selected td.ttms-col:hover{background:#e2f4fe}tr td,tr td:hover{background:#fff}.ttms-col{border-left:1px solid #ebebeb;width:15%;padding:0 5px}table{border-bottom:1px solid #ebebeb;width:100%;border-spacing:0;table-layout:fixed;border-collapse:collapse}table table{border-bottom:0 solid #ebebeb}.ttms-select-col{width:30px;min-width:30px;max-width:30px}.ttms-select-col .ttms-caret-align{margin-bottom:2px}.ttms-title-col{width:auto;text-overflow:ellipsis;overflow:hidden;position:relative}.ttms-title-col span.label.cell:hover{color:#0196d8;cursor:pointer}.tree-node{display:flex;align-items:stretch}.tree-node span.fas{margin-left:4px;align-self:center}.tree-node span.leg{position:relative;display:inline-block;width:25px;align-self:stretch}.tree-node span.leg:after,.tree-node span.leg:before{content:\"\";position:absolute;display:inline-block}.tree-node span.leg.bypass:after{right:0;top:0;width:50%;height:100%;border-left:1px dotted #999}.tree-node span.leg.mid:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node span.leg.mid:after{right:0;bottom:0;width:50%;height:50%;border-left:1px dotted #999}.tree-node span.leg.last:before{right:0;top:0;width:50%;height:50%;border-left:1px dotted #999;border-bottom:1px dotted #999}.tree-node span.leg.last.blank:after,.tree-node span.leg.last.blank:before{border:0}.tree-node span.leg.label{flex:1;padding:8px}"]
            }]
    }], function () { return []; }, { rowSelected: [{
            type: Output
        }], rowDeselected: [{
            type: Output
        }], rowExpanded: [{
            type: Output
        }], rowCollapsed: [{
            type: Output
        }], updateSelectionToParent: [{
            type: Output
        }], selected: [{
            type: Input
        }], tableAttrs: [{
            type: Input
        }], level: [{
            type: Input
        }], selectionDisabled: [{
            type: Input
        }], row: [{
            type: Input
        }], selectedRows: [{
            type: Input
        }], childRows: [{
            type: ViewChildren,
            args: [TableTreeMultiselectRowComponent]
        }] }); })();

class TableTreeMultiselectModule {
}
TableTreeMultiselectModule.ɵfac = function TableTreeMultiselectModule_Factory(t) { return new (t || TableTreeMultiselectModule)(); };
TableTreeMultiselectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableTreeMultiselectModule });
TableTreeMultiselectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TableActionsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableTreeMultiselectModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TableTreeMultiselectComponent,
                    TableTreeMultiselectRowComponent,
                ],
                imports: [
                    CommonModule,
                    TableActionsModule,
                ],
                exports: [
                    TableTreeMultiselectComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableTreeMultiselectModule, { declarations: function () { return [TableTreeMultiselectComponent, TableTreeMultiselectRowComponent]; }, imports: function () { return [CommonModule, TableActionsModule]; }, exports: function () { return [TableTreeMultiselectComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/tabs</example-url>
 */
class TabsetComponent {
    constructor() {
        this.type = 'pill';
        this.isPmccTabs = true;
    }
    get isTabs() {
        return this.type === 'tab';
    }
    get isPills() {
        return this.type === 'pill';
    }
    get isPanel() {
        return this.type === 'panel';
    }
    ngAfterContentInit() {
        this.updateTabs();
        this.tabsSubscription = this.tabsQueryList.changes.subscribe(() => {
            this.updateTabs();
        });
    }
    ngOnDestroy() {
        this.tabsSubscription.unsubscribe();
    }
    ngOnChanges(changes) {
        if ('maxHeight' in changes && this.tabs) {
            this.updateTabMaxHeight();
        }
    }
    selectTab(tab) {
        this.tabsQueryList.forEach(t => t.selected = false);
        tab.selected = true;
    }
    updateTabs() {
        this.updateTabsFromQueryList();
        this.updateTabMaxHeight();
    }
    updateTabsFromQueryList() {
        this.tabs = this.tabsQueryList.toArray().sort((a, b) => {
            if (a.sequence && a.sequence > b.sequence) {
                return 1;
            }
            if (a.sequence && a.sequence < b.sequence) {
                return -1;
            }
            return 0;
        });
    }
    updateTabMaxHeight() {
        this.tabs.forEach(tab => {
            if (tab.maxHeight == null && this.maxHeight != null) {
                tab.maxHeight = this.maxHeight;
            }
        });
    }
}
TabsetComponent.ɵfac = function TabsetComponent_Factory(t) { return new (t || TabsetComponent)(); };
TabsetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabsetComponent, selectors: [["pmcc-tabset"]], contentQueries: function TabsetComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabsQueryList = _t);
    } }, hostVars: 8, hostBindings: function TabsetComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-tabs", ctx.isPmccTabs)("pmcc-tab-style", ctx.isTabs)("pmcc-pill-style", ctx.isPills)("pmcc-tab-panel-style", ctx.isPanel);
    } }, inputs: { type: "type", maxHeight: "maxHeight" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 3, vars: 1, consts: [[1, "pmcc-tabs"], [3, "ngClass", "pmccTooltip", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "pmccTooltip", "click"], [3, "ngClass"]], template: function TabsetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, TabsetComponent_li_1_Template, 3, 11, "li", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabs);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, TooltipDirective], encapsulation: 2 });
TabsetComponent.propDecorators = {
    maxHeight: [{ type: Input }],
    type: [{ type: Input }],
    tabsQueryList: [{ type: ContentChildren, args: [TabComponent,] }],
    isPmccTabs: [{ type: HostBinding, args: ['class.pmcc-tabs',] }],
    isTabs: [{ type: HostBinding, args: ['class.pmcc-tab-style',] }],
    isPills: [{ type: HostBinding, args: ['class.pmcc-pill-style',] }],
    isPanel: [{ type: HostBinding, args: ['class.pmcc-tab-panel-style',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsetComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-tabset',
                template: "<!-- todo: add <pmcc-services-overflow> -->\n\n<ul class=\"pmcc-tabs\">\n  <li\n    *ngFor=\"let tab of tabs\"\n    [ngClass]=\"{\n      'pmcc-tab-selected': tab.selected,\n      'pmcc-tab-hidden': tab.appearsInOverflowMenu,\n      'pmcc-disabled': tab.disabled\n    }\"\n    (click)=\"selectTab(tab)\"\n    [pmccTooltip]=\"tab.tooltip\"\n    [attr.data-pm-id]=\"'tab-selector-' + tab.sequence\"\n  >\n    <span [ngClass]=\"{ 'pmcc-required': tab.required }\">\n      {{ tab.label }}\n    </span>\n  </li>\n</ul>\n\n<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], isPmccTabs: [{
            type: HostBinding,
            args: ['class.pmcc-tabs']
        }], isTabs: [{
            type: HostBinding,
            args: ['class.pmcc-tab-style']
        }], isPills: [{
            type: HostBinding,
            args: ['class.pmcc-pill-style']
        }], isPanel: [{
            type: HostBinding,
            args: ['class.pmcc-tab-panel-style']
        }], maxHeight: [{
            type: Input
        }], tabsQueryList: [{
            type: ContentChildren,
            args: [TabComponent]
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/tabs</example-url>
 */
class TabsVerticalComponent {
    constructor() {
        this.selectedTabChange = new EventEmitter();
        this.isBgGrayLt = true;
        this.isTabsVertical = true;
    }
    selectTab(tab) {
        if (!tab.disabled) {
            this.selectedTabChange.emit(tab);
        }
    }
    isSelectedTab(tab) {
        return tab === this.selectedTab;
    }
    getUniqueId(tab) {
        return `${(this.id || 'pmcc')}-${encodeURI(tab.label.toLowerCase().replace(' ', '-'))}`;
    }
}
TabsVerticalComponent.ɵfac = function TabsVerticalComponent_Factory(t) { return new (t || TabsVerticalComponent)(); };
TabsVerticalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabsVerticalComponent, selectors: [["", "pmccTabsVertical", ""]], hostVars: 4, hostBindings: function TabsVerticalComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("pmcc-bg-gray-lt", ctx.isBgGrayLt)("pmcc-tabs-vertical", ctx.isTabsVertical);
    } }, inputs: { id: "id", markerStyle: "markerStyle", tabs: "tabs", selectedTab: "selectedTab" }, outputs: { selectedTabChange: "selectedTabChange" }, attrs: _c89, decls: 2, vars: 1, consts: [[3, "ngClass", "pmccTooltip", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "pmccTooltip", "click"], [1, "pmcc-truncate"], [3, "ngClass"]], template: function TabsVerticalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul");
        ɵngcc0.ɵɵtemplate(1, TabsVerticalComponent_li_1_Template, 5, 18, "li", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabs);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, TooltipDirective], encapsulation: 2 });
TabsVerticalComponent.propDecorators = {
    id: [{ type: Input }],
    markerStyle: [{ type: Input }],
    tabs: [{ type: Input }],
    selectedTab: [{ type: Input }],
    selectedTabChange: [{ type: Output }],
    isBgGrayLt: [{ type: HostBinding, args: ['class.pmcc-bg-gray-lt',] }],
    isTabsVertical: [{ type: HostBinding, args: ['class.pmcc-tabs-vertical',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsVerticalComponent, [{
        type: Component,
        args: [{
                /* tslint:disable-next-line */ /* compatibility with AngularJS pmcc */
                selector: '[pmccTabsVertical]',
                template: "<ul>\n  <li\n    *ngFor=\"let tab of tabs\"\n    [attr.data-pm-id]=\"getUniqueId(tab)\"\n    [ngClass]=\"{\n      'pmcc-tab-selected': isSelectedTab(tab),\n      'pmcc-error': tab.error,\n      'pmcc-disabled': tab.disabled\n    }\"\n    (click)=\"selectTab(tab)\"\n    [pmccTooltip]=\"tab.tooltip\"\n  >\n    <span class=\"pmcc-truncate\">\n      <span [ngClass]=\"{ 'pmcc-required': tab.required }\">\n        {{tab.label}}&nbsp;\n      </span>\n    </span>\n\n    <div\n      class=\"{{ markerStyle }}\"\n      [ngClass]=\"{\n        'pmcc-tab-marker-on': tab.checked || tab.error,\n        'pmcc-tab-marker': !tab.checked && !tab.error\n      }\"\n    ></div>\n  </li>\n</ul>\n"
            }]
    }], function () { return []; }, { selectedTabChange: [{
            type: Output
        }], isBgGrayLt: [{
            type: HostBinding,
            args: ['class.pmcc-bg-gray-lt']
        }], isTabsVertical: [{
            type: HostBinding,
            args: ['class.pmcc-tabs-vertical']
        }], id: [{
            type: Input
        }], markerStyle: [{
            type: Input
        }], tabs: [{
            type: Input
        }], selectedTab: [{
            type: Input
        }] }); })();

class TabsModule {
}
TabsModule.ɵfac = function TabsModule_Factory(t) { return new (t || TabsModule)(); };
TabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TabsModule });
TabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TooltipModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsModule, [{
        type: NgModule,
        args: [{
                declarations: [TabsetComponent, TabComponent, TabsVerticalComponent],
                imports: [CommonModule, TooltipModule],
                exports: [TabsetComponent, TabComponent, TabsVerticalComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabsModule, { declarations: function () { return [TabsetComponent, TabComponent, TabsVerticalComponent]; }, imports: function () { return [CommonModule, TooltipModule]; }, exports: function () { return [TabsetComponent, TabComponent, TabsVerticalComponent]; } }); })();

class TimeOptionDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.selected = false;
        this.role = 'listitem';
    }
    setActiveStyles() {
        this.selected = true;
        this.scrollIntoView();
    }
    setInactiveStyles() {
        this.selected = false;
    }
    scrollIntoView() {
        this.elRef.nativeElement.scrollIntoView({ block: 'nearest' });
    }
}
TimeOptionDirective.ɵfac = function TimeOptionDirective_Factory(t) { return new (t || TimeOptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TimeOptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TimeOptionDirective, selectors: [["", "pmccTimeOption", ""]], hostVars: 3, hostBindings: function TimeOptionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassProp("selected", ctx.selected);
    } } });
TimeOptionDirective.ctorParameters = () => [
    { type: ElementRef }
];
TimeOptionDirective.propDecorators = {
    selected: [{ type: HostBinding, args: ['class.selected',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeOptionDirective, [{
        type: Directive,
        args: [{ selector: '[pmccTimeOption]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { selected: [{
            type: HostBinding,
            args: ['class.selected']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }] }); })();

var ApprovedTimeString;
(function (ApprovedTimeString) {
    ApprovedTimeString["ASAP"] = "ASAP";
    ApprovedTimeString["Ongoing"] = "Ongoing";
})(ApprovedTimeString || (ApprovedTimeString = {}));
const approvedTimeStrings = Object.values(ApprovedTimeString);
const minutesInHour = 60;
const hoursInDay = 24;
const halfDay = 12;
function sameTime(time1, time2) {
    return (time1 != null &&
        time2 != null &&
        time1.hours === time2.hours &&
        time1.minutes === time2.minutes &&
        time1.format === time2.format);
}
function isApprovedTimeString(val) {
    return !!approvedTimeStrings.find(str => str === val);
}

class TimeOptionsComponent {
    constructor(cd) {
        this.cd = cd;
        this.tabIndex = 0;
        this.role = 'list';
        this.timeOptions = [];
        this.select = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.timeOptions || changes.selectedOption) {
            this.setFocusedOption();
        }
    }
    ngAfterViewInit() {
        this.keyManager = new ActiveDescendantKeyManager(this.optionsQueryList);
    }
    onSelect(option) {
        this.select.emit(option);
    }
    onKeyDown(event) {
        const keyManager = this.keyManager;
        if (event.key === 'Enter') {
            const selectedOption = this.timeOptions[keyManager.activeItemIndex];
            if (selectedOption) {
                event.preventDefault();
                this.onSelect(selectedOption);
            }
        }
        else {
            keyManager.onKeydown(event);
            this.cd.markForCheck();
        }
    }
    scrollIntoSelectedOption() {
        if (this.keyManager.activeItem) {
            this.keyManager.activeItem.scrollIntoView();
        }
    }
    setFocusedOption() {
        setTimeout(() => {
            const selectedOptionIdx = this.timeOptions.findIndex(option => sameTime(option, this.selectedOption));
            if (selectedOptionIdx !== -1) {
                this.keyManager.setActiveItem(selectedOptionIdx);
                this.cd.markForCheck();
            }
        });
    }
}
TimeOptionsComponent.ɵfac = function TimeOptionsComponent_Factory(t) { return new (t || TimeOptionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
TimeOptionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TimeOptionsComponent, selectors: [["pmcc-time-options"]], viewQuery: function TimeOptionsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TimeOptionDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.optionsQueryList = _t);
    } }, hostVars: 2, hostBindings: function TimeOptionsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function TimeOptionsComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", ctx.tabIndex)("role", ctx.role);
    } }, inputs: { timeOptions: "timeOptions", selectedOption: "selectedOption" }, outputs: { select: "select" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["pmccTimeOption", "", "class", "pmcc-time-option", "data-pm-id", "time-options", 3, "click", 4, "ngFor", "ngForOf"], ["pmccTimeOption", "", "data-pm-id", "time-options", 1, "pmcc-time-option", 3, "click"]], template: function TimeOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimeOptionsComponent_div_0_Template, 3, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.timeOptions);
    } }, directives: function () { return [ɵngcc1.NgForOf, TimeOptionDirective]; }, pipes: function () { return [TimePipe]; }, styles: ["[_nghost-%COMP%]{display:block;max-height:215px;overflow-y:scroll;position:relative;cursor:default;outline:none}.pmcc-time-option[_ngcontent-%COMP%]{border:1px solid #c7c7c7;color:#0085cc;display:block;padding:10px}.pmcc-time-option[_ngcontent-%COMP%]:not(:last-child){border-bottom:none}.pmcc-time-option.selected[_ngcontent-%COMP%], .pmcc-time-option[_ngcontent-%COMP%]:hover{color:#fff;background:#0085cc}"], changeDetection: 0 });
TimeOptionsComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
TimeOptionsComponent.propDecorators = {
    optionsQueryList: [{ type: ViewChildren, args: [TimeOptionDirective,] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabIndex',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    timeOptions: [{ type: Input }],
    selectedOption: [{ type: Input }],
    select: [{ type: Output }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-time-options',
                template: "<div\n  pmccTimeOption\n  *ngFor=\"let option of timeOptions\"\n  class=\"pmcc-time-option\"\n  (click)=\"onSelect(option)\"\n  data-pm-id=\"time-options\"\n>\n  {{ option | pmccTime }}\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;max-height:215px;overflow-y:scroll;position:relative;cursor:default;outline:none}.pmcc-time-option{border:1px solid #c7c7c7;color:#0085cc;display:block;padding:10px}.pmcc-time-option:not(:last-child){border-bottom:none}.pmcc-time-option.selected,.pmcc-time-option:hover{color:#fff;background:#0085cc}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], timeOptions: [{
            type: Input
        }], select: [{
            type: Output
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], optionsQueryList: [{
            type: ViewChildren,
            args: [TimeOptionDirective]
        }], selectedOption: [{
            type: Input
        }] }); })();

function getTimePartUnderCaret(input) {
    const selectionStart = input.selectionStart;
    if (selectionStart <= 2) {
        return 0 /* Hours */;
    }
    else if (selectionStart > 2 && selectionStart <= 5) { // tslint:disable-line
        return 1 /* Minutes */;
    }
    return 2 /* Meridiem */;
}
const incrementHours = (time, direction) => (Object.assign(Object.assign({}, time), { hours: rotate(time.hours + direction, 0, hoursInDay - 1) }));
const ɵ0 = incrementHours;
const incrementMinutes = (time, direction) => (Object.assign(Object.assign({}, time), { minutes: rotate(time.minutes + direction, 0, minutesInHour - 1) }));
const ɵ1 = incrementMinutes;
const incrementMeridiem = (time) => (Object.assign(Object.assign({}, time), { hours: rotate(time.hours + halfDay, 0, hoursInDay - 1) }));
const ɵ2 = incrementMeridiem;
function updateTimeFor(time, timePart, direction) {
    if (timePart === 0 /* Hours */) {
        return incrementHours(time, direction);
    }
    if (timePart === 1 /* Minutes */) {
        return incrementMinutes(time, direction);
    }
    if (timePart === 2 /* Meridiem */) {
        return incrementMeridiem(time);
    }
    return time;
}
const getHoursOr = (time, fallback) => time == null ? fallback : time.hours;
const ɵ3 = getHoursOr;
const getMinutesOr = (time, fallback) => time == null ? fallback : time.minutes;
const ɵ4 = getMinutesOr;
function generateTimeIntervals(timeFormat, startTime, endTime, minuteInterval = 15) {
    const intervals = [];
    function addIntervalsForHour(hour, start, end) {
        for (let minutes = start; minutes < end; minutes += minuteInterval) {
            intervals.push({
                hours: hour,
                minutes,
                format: timeFormat
            });
        }
    }
    const startHour = getHoursOr(startTime, 0);
    const endHour = getHoursOr(endTime, hoursInDay);
    const startMinutes = Math.ceil(getMinutesOr(startTime, 0) / minuteInterval) * minuteInterval;
    const endMinutes = getMinutesOr(endTime, -1);
    addIntervalsForHour(startHour, startMinutes, minutesInHour);
    for (let hour = startHour + 1; hour < endHour; hour++) {
        addIntervalsForHour(hour, 0, minutesInHour);
    }
    addIntervalsForHour(endHour, 0, endMinutes + 1);
    return intervals;
}
function toTimeString(time) {
    if (time != null) {
        const { hours, minutes, format } = time;
        let timeString = `${zeroPad(format === 12 /* AMPM */ ? _24to12(hours) : hours)}:${zeroPad(minutes)}`;
        if (format === 12 /* AMPM */) {
            timeString += ` ${getMeridiem(hours)}`;
        }
        return timeString;
    }
    return '';
}
const timeStringRegex = /^(\d\d):(\d\d)( am| pm)?$/i;
function fromTimeString(timeString = '') {
    const match = timeString.match(timeStringRegex);
    if (match) {
        let hours = +match[1];
        const minutes = +match[2];
        const TIME_SHIFT_PART_INDEX = 3;
        const meridiem = match[TIME_SHIFT_PART_INDEX];
        if (meridiem) {
            hours = _12to24(hours, meridiem.trim().toLowerCase());
        }
        return {
            hours,
            minutes,
            format: meridiem ? 12 /* AMPM */ : 24 /* Hour24 */
        };
    }
    return undefined;
}
function isWithinRange(time, startTime, endTime) {
    if (time == null) {
        return true;
    }
    const minutes = getTimeInMinutes(time, 0);
    return (minutes >= getTimeInMinutes(startTime, 0) &&
        minutes <= getTimeInMinutes(endTime, Infinity));
}
function getTimeInMinutes(time, fallback) {
    return time == null ? fallback : time.hours * minutesInHour + time.minutes;
}
function _24to12(hour) {
    if (hour === 0) {
        return halfDay;
    }
    else if (hour > halfDay) {
        return hour % halfDay;
    }
    return hour;
}
function _12to24(hour, meridiem) {
    let shift = 0;
    const SHIFT_HOURS = 12;
    if (meridiem === 'pm' && hour !== halfDay) {
        shift = SHIFT_HOURS;
    }
    else if (meridiem === 'am' && hour === halfDay) {
        shift = -SHIFT_HOURS;
    }
    return rotate(hour + shift, 0, hoursInDay - 1);
}
function getMeridiem(hours) {
    return hours < halfDay ? 'am' : 'pm';
}
function zeroPad(number) {
    const numString = `${number}`;
    return numString.length === 1 ? `0${numString}` : numString;
}

/**
 * When selectionStart and selectionEnd supplied to <input />
 * don't change, the caret position does not get updated.
 * This causes caret to jump.
 * To mitigate this, we add a small random number to it. This way it differs
 * every time and the position gets updated. The number itself is converted
 * to an integer internally.
 */
function saveCaretPos(input) {
    return input.selectionStart + Math.random() / 1000;
}
function valueChanged(val1, val2) {
    if (typeof val1 !== typeof val2) {
        return true;
    }
    return typeof val1 === 'string'
        ? val1 !== val2
        : !sameTime(val1, val2);
}
function valueFromString(str) {
    return isApprovedTimeString(str) ? str : fromTimeString(str);
}
class TimePickerComponent {
    constructor(locale) {
        this._timeOptions = [];
        this._placeholder = '';
        this._minuteInterval = 15;
        /**
         * Caret position saved before hours, minutes or meridiem
         * is updated with arrow keys.
         */
        this.caretPos = 0;
        /**
         * Whether input is currently focused.
         * Error state should not be indicated when it is.
         */
        this.focused = false;
        this.hasError = false;
        /**
         * Event emitted when the value changes.
         * Emitted only when the change is triggered by user interaction.
         */
        this.change = new EventEmitter();
        this.onModelChange = () => { };
        this.onTouched = () => { };
        this.timeFormat = locale === 'en-us' ? 12 /* AMPM */ : 24 /* Hour24 */;
    }
    set minuteInterval(value) {
        const QUARTER_OF_HOUR = 15;
        this._minuteInterval = coerceNumberProperty(value, QUARTER_OF_HOUR);
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        this._placeholder = value || '';
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    set value(value) {
        this.setValueAndValidate(valueFromString(`${value}`));
    }
    set startTime(value) {
        this._startTime = fromTimeString(value);
    }
    set endTime(value) {
        this._endTime = fromTimeString(value);
    }
    get timeOptions() {
        return this._timeOptions;
    }
    get currentTime() {
        return this._value;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    /**
     * Indicate error state only when the input is not focused
     * and the popover is closed.
     */
    get shouldShowError() {
        return this.hasError && !this.isHostFocused;
    }
    get isHostFocused() {
        return this.focused || this.popoverTrigger.isOpen;
    }
    ngOnInit() {
        this.generateTimeOptions();
    }
    ngOnChanges(changes) {
        if ('startTime' in changes ||
            'endTime' in changes ||
            'minuteInterval' in changes) {
            // these inputs affect the final options list,
            // so we must recreate it and validate current option
            this.generateTimeOptions();
            this.hasError = this.validateValue(this._value);
        }
    }
    /**
     * When time is selected from the time options list
     */
    onTimeSelect(time) {
        this.setValueAndValidate(time);
        this.popoverTrigger.close();
        this.emitChange();
    }
    /**
     * Increment time part under the caret
     */
    onArrowUp(event) {
        event.preventDefault();
        this.updateTime(event.target, 1 /* Next */);
    }
    /**
     * Decrement time part under the caret
     */
    onArrowDown(event) {
        event.preventDefault();
        this.updateTime(event.target, -1 /* Prev */);
    }
    onBlur() {
        this.focused = false;
        if (!this.hasError) {
            // don't emit changes if the value is invalid
            this.emitChange();
        }
        this.onTouched();
    }
    onInput(event) {
        const target = event.target;
        const inputValue = target.value;
        const newVal = valueFromString(inputValue);
        this.hasError =
            (newVal == null && !!inputValue.length) || this.validateValue(newVal);
        if (newVal != null) {
            this.caretPos = saveCaretPos(target);
            this.setValue(newVal);
        }
    }
    emitChange() {
        if (this.valueChanged()) {
            const timeString = typeof this._value === 'string'
                ? this._value
                : toTimeString(this._value);
            this.change.emit(timeString);
            this.onModelChange(timeString);
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(obj) {
        this.value = `${obj == null ? '' : obj}`;
    }
    generateTimeOptions() {
        this._timeOptions = generateTimeIntervals(this.timeFormat, this._startTime, this._endTime, this._minuteInterval);
    }
    updateTime(input, direction) {
        this.caretPos = saveCaretPos(input);
        const time = fromTimeString(input.value);
        this.setValueAndValidate(updateTimeFor(time, getTimePartUnderCaret(input), direction));
    }
    valueChanged() {
        return valueChanged(this._prevValue, this._value);
    }
    setValue(time) {
        this._prevValue = this._value;
        this._value = time;
    }
    setValueAndValidate(time) {
        this.setValue(time);
        this.hasError = this.validateValue(time);
    }
    validateTime(time) {
        return !isWithinRange(time, this._startTime, this._endTime);
    }
    validateValue(time) {
        return isApprovedTimeString(time) ? false : this.validateTime(time);
    }
}
TimePickerComponent.ɵfac = function TimePickerComponent_Factory(t) { return new (t || TimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(LOCALE)); };
TimePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TimePickerComponent, selectors: [["pmcc-time-picker"]], viewQuery: function TimePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PopoverTriggerDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popoverTrigger = _t.first);
    } }, hostVars: 2, hostBindings: function TimePickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("focus", ctx.isHostFocused);
    } }, inputs: { minuteInterval: "minuteInterval", placeholder: "placeholder", disabled: "disabled", required: "required", value: "value", startTime: "startTime", endTime: "endTime", width: "width" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => TimePickerComponent)
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 17, consts: [["data-pm-id", "time-input"], ["type", "text", 3, "value", "required", "placeholder", "selectionStart", "selectionEnd", "disabled", "keydown.arrowup", "keydown.arrowdown", "keyup.enter", "input", "focus", "blur"], ["align", "after", "data-pm-id", "time-picker-btn", 3, "pmccPopoverDisabled", "pmccPopoverTrigger", "opened", "closed"], ["pmccButton", "", "pmccVariant", "secondary", 3, "disabled", "keydown"], ["name", "clock"], ["hideCloseIcon", ""], ["popover", ""], [3, "selectedOption", "timeOptions", "select"], ["options", ""]], template: function TimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r2 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "pmcc-input", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("keydown.arrowup", function TimePickerComponent_Template_input_keydown_arrowup_1_listener($event) { return ctx.onArrowUp($event); })("keydown.arrowdown", function TimePickerComponent_Template_input_keydown_arrowdown_1_listener($event) { return ctx.onArrowDown($event); })("keyup.enter", function TimePickerComponent_Template_input_keyup_enter_1_listener() { return ctx.emitChange(); })("input", function TimePickerComponent_Template_input_input_1_listener($event) { return ctx.onInput($event); })("focus", function TimePickerComponent_Template_input_focus_1_listener() { return ctx.focused = true; })("blur", function TimePickerComponent_Template_input_blur_1_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵpipe(2, "pmccTime");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "pmcc-addon", 2);
        ɵngcc0.ɵɵlistener("opened", function TimePickerComponent_Template_pmcc_addon_opened_3_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r1 = ɵngcc0.ɵɵreference(9); return _r1.scrollIntoSelectedOption(); })("closed", function TimePickerComponent_Template_pmcc_addon_closed_3_listener() { return ctx.onTouched(); });
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("keydown", function TimePickerComponent_Template_button_keydown_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const _r1 = ɵngcc0.ɵɵreference(9); return _r1.onKeyDown($event); });
        ɵngcc0.ɵɵelement(5, "pmcc-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "pmcc-popover", 5, 6);
        ɵngcc0.ɵɵelementStart(8, "pmcc-time-options", 7, 8);
        ɵngcc0.ɵɵlistener("select", function TimePickerComponent_Template_pmcc_time_options_select_8_listener($event) { return ctx.onTimeSelect($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵclassProp("pmcc-error", ctx.shouldShowError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵproperty("value", ɵngcc0.ɵɵpipeBind1(2, 15, ctx.currentTime))("required", ctx.required)("placeholder", ctx.placeholder)("selectionStart", ctx.caretPos)("selectionEnd", ctx.caretPos)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pmccPopoverDisabled", ctx.disabled)("pmccPopoverTrigger", _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("selectedOption", ctx.currentTime)("timeOptions", ctx.timeOptions);
    } }, directives: function () { return [InputComponent, AddonDirective, PopoverTriggerDirective, ButtonDirective, IconComponent, PopoverComponent, TimeOptionsComponent]; }, pipes: function () { return [TimePipe]; }, styles: ["[_nghost-%COMP%]{display:inline-block;margin-right:5px}.focus[_nghost-%COMP%], [_nghost-%COMP%]:focus{outline:2px auto #0085ccbf}.focus[_nghost-%COMP%]   input[_ngcontent-%COMP%], [_nghost-%COMP%]:focus   input[_ngcontent-%COMP%]{outline:none}[_nghost-%COMP%]   pmcc-input[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{outline:0}[_nghost-%COMP%]   pmcc-addon[_ngcontent-%COMP%]{padding:0}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{height:100%;border:0;font-size:17px;line-height:17px;border-bottom-left-radius:0;border-top-left-radius:0}[_nghost-%COMP%]   button[_ngcontent-%COMP%]   .pmcc-ico[_ngcontent-%COMP%], [_nghost-%COMP%]   button[_ngcontent-%COMP%]   .pmcc-ico[_ngcontent-%COMP%]:before{width:auto;height:auto}[_nghost-%COMP%]   button.hover[_ngcontent-%COMP%], [_nghost-%COMP%]   button[_ngcontent-%COMP%]:hover{box-shadow:none}"] });
TimePickerComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE,] }] }
];
TimePickerComponent.propDecorators = {
    popoverTrigger: [{ type: ViewChild, args: [PopoverTriggerDirective, { static: true },] }],
    minuteInterval: [{ type: Input }],
    placeholder: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    value: [{ type: Input }],
    startTime: [{ type: Input }],
    endTime: [{ type: Input }],
    width: [{ type: Input }],
    isHostFocused: [{ type: HostBinding, args: ['class.focus',] }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-time-picker',
                template: "<pmcc-input [class.pmcc-error]=\"shouldShowError\" data-pm-id=\"time-input\">\n  <input\n    type=\"text\"\n    [style.width.px]=\"width\"\n    [value]=\"currentTime | pmccTime\"\n    [required]=\"required\"\n    [placeholder]=\"placeholder\"\n    [selectionStart]=\"caretPos\"\n    [selectionEnd]=\"caretPos\"\n    (keydown.arrowup)=\"onArrowUp($event)\"\n    (keydown.arrowdown)=\"onArrowDown($event)\"\n    (keyup.enter)=\"emitChange()\"\n    (input)=\"onInput($event)\"\n    (focus)=\"focused = true\"\n    (blur)=\"onBlur()\"\n    [disabled]=\"disabled\"\n  />\n  <pmcc-addon\n    align=\"after\"\n    [pmccPopoverDisabled]=\"disabled\"\n    [pmccPopoverTrigger]=\"popover\"\n    (opened)=\"options.scrollIntoSelectedOption()\"\n    (closed)=\"onTouched()\"\n    data-pm-id=\"time-picker-btn\"\n  >\n    <button\n      pmccButton\n      pmccVariant=\"secondary\"\n      (keydown)=\"options.onKeyDown($event)\"\n      [disabled]=\"disabled\"\n    >\n      <pmcc-icon name=\"clock\"></pmcc-icon>\n    </button>\n  </pmcc-addon>\n</pmcc-input>\n<pmcc-popover #popover hideCloseIcon>\n  <pmcc-time-options\n    #options\n    [selectedOption]=\"currentTime\"\n    [timeOptions]=\"timeOptions\"\n    (select)=\"onTimeSelect($event)\"\n  ></pmcc-time-options>\n</pmcc-popover>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => TimePickerComponent)
                    }
                ],
                styles: [":host{display:inline-block;margin-right:5px}:host.focus,:host:focus{outline:2px auto #0085ccbf}:host.focus input,:host:focus input{outline:none}:host pmcc-input button{outline:0}:host pmcc-addon{padding:0}:host button{height:100%;border:0;font-size:17px;line-height:17px;border-bottom-left-radius:0;border-top-left-radius:0}:host button .pmcc-ico,:host button .pmcc-ico:before{width:auto;height:auto}:host button.hover,:host button:hover{box-shadow:none}"]
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE]
            }] }]; }, { change: [{
            type: Output
        }], minuteInterval: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], value: [{
            type: Input
        }], startTime: [{
            type: Input
        }], endTime: [{
            type: Input
        }], width: [{
            type: Input
        }], isHostFocused: [{
            type: HostBinding,
            args: ['class.focus']
        }], popoverTrigger: [{
            type: ViewChild,
            args: [PopoverTriggerDirective, { static: true }]
        }] }); })();

/**
 * Prints Time or ApprovedTimeString
 *
 * const currentTime = {
 *   hours: 13,
 *   minutes: 30,
 *   format: TimeFormat:AMPM
 * }
 * {{ currentTime | pmccTime }}
 *   prints: '01:30 pm'
 *
 *
 * const currentTime = ApprovedTimeString.ASAP
 * {{ currentTime | pmccTime }}
 *   prints: 'ASAP'
 */
class TimePipe {
    transform(value) {
        return isApprovedTimeString(value) ? value : toTimeString(value);
    }
}
TimePipe.ɵfac = function TimePipe_Factory(t) { return new (t || TimePipe)(); };
TimePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "pmccTime", type: TimePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimePipe, [{
        type: Pipe,
        args: [{ name: 'pmccTime' }]
    }], null, null); })();

class TimePickerModule {
}
TimePickerModule.ɵfac = function TimePickerModule_Factory(t) { return new (t || TimePickerModule)(); };
TimePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TimePickerModule });
TimePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, InputModule, PopoverModule, IconModule, ButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TimePickerComponent,
                    TimeOptionsComponent,
                    TimeOptionDirective,
                    TimePipe
                ],
                imports: [CommonModule, InputModule, PopoverModule, IconModule, ButtonModule],
                exports: [TimePickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TimePickerModule, { declarations: function () { return [TimePickerComponent, TimeOptionsComponent, TimeOptionDirective, TimePipe]; }, imports: function () { return [CommonModule, InputModule, PopoverModule, IconModule, ButtonModule]; }, exports: function () { return [TimePickerComponent]; } }); })();

class MonthPickerComponent {
    constructor() {
        this.months = months.map(month => (Object.assign(Object.assign({}, month), { isSelected: false })));
        this.monthChange = new EventEmitter();
        this.disabled = false;
        this.readOnly = false;
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /* istanbul ignore next */
        this.onTouched = () => { };
        this.currentYear = (new Date()).getFullYear();
    }
    get month() {
        return this._month;
    }
    set month(date) {
        if (date) {
            const startOfMonth = new Date(date);
            this._month = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth(), 1);
        }
        else {
            this._month = null;
        }
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    ngOnChanges(changes) {
        if ('minMonth' in changes || 'maxMonth' in changes) {
            if (this.minMonth > this.maxMonth) {
                throw new Error('minMonth cannot be greater than maxMonth');
            }
            if (this.currentYear < this.minMonth.getFullYear() || this.currentYear > this.maxMonth.getFullYear()) {
                this.currentYear = this.minMonth.getFullYear();
            }
        }
    }
    focus() {
        this.datePickerField.focus();
    }
    blur() {
        this.datePickerField.blur();
    }
    selectMonth(month) {
        if (!month.isDisabled) {
            month.date = new Date(this.currentYear, month.value, 1);
            this.changeMonth(month.date);
        }
    }
    changeMonth(month) {
        this._month = month;
        this.popoverTrigger.close();
        this.monthChange.emit(month);
        this.onModelChange(month);
        this.onTouched();
    }
    setSelected(month) {
        this.resetAll();
        this.months[month.getMonth()].isSelected = true;
    }
    resetAll() {
        this.months.forEach((mon) => mon.isSelected = false);
    }
    setDisabledFlag() {
        this.months.forEach((mon) => {
            mon.isDisabled = this.isDisabled(new Date(this.currentYear, mon.value));
        });
    }
    isDisabled(date) {
        return !isValidDate(date, this.minMonth, this.maxMonth);
    }
    onFieldFocus() {
        if (!this.popoverTrigger.isOpen) {
            if (this.month) {
                this.currentYear = this.month.getFullYear();
            }
            this.refreshMonths();
            // open the popover when the month picker field is focused
            this.popoverTrigger.open();
        }
    }
    onKeyDown(event) {
        if (event.key === 'Tab' && this.popoverTrigger.isOpen) {
            // close the popover when the month picker field is blurred
            this.popoverTrigger.close();
        }
    }
    refreshMonths() {
        if (this.month && this.month.getFullYear() === this.currentYear) {
            this.setSelected(this.month);
        }
        else {
            this.resetAll();
        }
        this.setDisabledFlag();
    }
    get isIncrementYearDisabled() {
        return this.maxMonth && this.currentYear >= this.maxMonth.getFullYear();
    }
    get isDecrementYearDisabled() {
        return this.minMonth && this.currentYear <= this.minMonth.getFullYear();
    }
    incrementYear() {
        this.currentYear++;
        this.refreshMonths();
    }
    decrementYear() {
        this.currentYear--;
        this.refreshMonths();
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(month) {
        /* istanbul ignore next */
        if (month !== this.month) {
            this.month = month;
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
MonthPickerComponent.ɵfac = function MonthPickerComponent_Factory(t) { return new (t || MonthPickerComponent)(); };
MonthPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MonthPickerComponent, selectors: [["pmcc-month-picker"]], viewQuery: function MonthPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DatePickerFieldComponent, 5);
        ɵngcc0.ɵɵviewQuery(PopoverTriggerDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickerField = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popoverTrigger = _t.first);
    } }, inputs: { disabled: "disabled", readOnly: "readOnly", month: "month", required: "required", minMonth: "minMonth", maxMonth: "maxMonth", positionOverride: "positionOverride" }, outputs: { monthChange: "monthChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => MonthPickerComponent)
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 9, consts: [[3, "ngIf"], ["hideCloseIcon", "", 3, "positionOverride"], ["popover", ""], [1, "popover"], [1, "year"], [1, "prev-year", 3, "click"], ["name", "chevron-left", "size", "3x"], [1, "year-label"], [1, "next-year", 3, "click"], ["name", "chevron-right", "size", "3x"], [1, "months"], ["class", "month-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "disabled", "monthPickerFlag", "width", "date"], [3, "pmccPopoverTrigger", "required", "minDate", "maxDate", "monthPickerFlag", "width", "date", "focus", "keydown"], [1, "month-item", 3, "ngClass", "click"]], template: function MonthPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MonthPickerComponent_ng_template_0_Template, 1, 4, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, MonthPickerComponent_ng_template_1_Template, 1, 7, "ng-template", 0);
        ɵngcc0.ɵɵelementStart(2, "pmcc-popover", 1, 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function MonthPickerComponent_Template_button_click_6_listener() { return ctx.decrementYear(); });
        ɵngcc0.ɵɵelement(7, "pmcc-icon", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 8);
        ɵngcc0.ɵɵlistener("click", function MonthPickerComponent_Template_button_click_10_listener() { return ctx.incrementYear(); });
        ɵngcc0.ɵɵelement(11, "pmcc-icon", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵtemplate(13, MonthPickerComponent_div_13_Template, 3, 9, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly || ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.readOnly && !ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("positionOverride", ctx.positionOverride);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDecrementYearDisabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.currentYear, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isIncrementYearDisabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.months);
    } }, directives: [ɵngcc1.NgIf, PopoverComponent, IconComponent, ɵngcc1.NgForOf, DatePickerFieldComponent, PopoverTriggerDirective, ɵngcc1.NgClass], pipes: [ɵngcc1.SlicePipe], styles: [".popover[_ngcontent-%COMP%]{touch-action:none;width:198px;height:185px}.year[_ngcontent-%COMP%]{height:35px;text-align:center}.prev-year[_ngcontent-%COMP%]{float:left}.next-year[_ngcontent-%COMP%]{float:right}.disabled[_ngcontent-%COMP%]{opacity:.3;pointer-events:none}button[_ngcontent-%COMP%]{width:50px;height:20px;background:none;border:none;margin:0;padding:0;cursor:pointer}button[_ngcontent-%COMP%]:focus{outline:0}.year[_ngcontent-%COMP%]   .year-label[_ngcontent-%COMP%]{font-weight:700;font-size:16px;display:inline-block;margin:0 auto;line-height:22px}.months[_ngcontent-%COMP%]{margin:0;border:1px solid #c9c9c9}.month-item[_ngcontent-%COMP%]{display:inline-block;height:49px;width:49px;cursor:pointer;text-align:center;line-height:48px;border:.9px solid #c9c9c9;font-size:13px;font-weight:700}.month-item.disabled[_ngcontent-%COMP%]{opacity:.5;font-weight:400;cursor:not-allowed}.month-item.selected[_ngcontent-%COMP%]{background-color:#0085cc;color:#fff}.month-item.selected[_ngcontent-%COMP%]:focus, .month-item.selected[_ngcontent-%COMP%]:hover{background-color:#0085cc;color:#fff;opacity:.75}.month-item.highlight[_ngcontent-%COMP%], .month-item[_ngcontent-%COMP%]:focus, .month-item[_ngcontent-%COMP%]:hover{background-color:#e2f4fe}"] });
MonthPickerComponent.ctorParameters = () => [];
MonthPickerComponent.propDecorators = {
    datePickerField: [{ type: ViewChild, args: [DatePickerFieldComponent,] }],
    popoverTrigger: [{ type: ViewChild, args: [PopoverTriggerDirective,] }],
    monthChange: [{ type: Output }],
    disabled: [{ type: Input }],
    readOnly: [{ type: Input }],
    minMonth: [{ type: Input }],
    maxMonth: [{ type: Input }],
    positionOverride: [{ type: Input }],
    month: [{ type: Input }],
    required: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MonthPickerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-month-picker',
                template: "<ng-template [ngIf]=\"readOnly || disabled\">\n  <pmcc-date-picker-field\n    [disabled]=\"disabled\"\n    [monthPickerFlag]=\"true\"\n    [width]=\"115\"\n    [date]=\"month\"\n  ></pmcc-date-picker-field>\n</ng-template>\n<ng-template [ngIf]=\"!readOnly && !disabled\">\n  <pmcc-date-picker-field\n    [pmccPopoverTrigger]=\"popover\"\n    [required]=\"required\"\n    [minDate]=\"minMonth\"\n    [maxDate]=\"maxMonth\"\n    [monthPickerFlag]=\"true\"\n    [width]=\"115\"\n    [date]=\"month\"\n    (focus)=\"onFieldFocus()\"\n    (keydown)=\"onKeyDown($event)\"\n  ></pmcc-date-picker-field>\n</ng-template>\n<pmcc-popover #popover hideCloseIcon [positionOverride]=\"positionOverride\">\n  <div class=\"popover\">\n    <div class=\"year\">\n      <button class=\"prev-year\" [class.disabled]=\"isDecrementYearDisabled\" (click)=\"decrementYear()\">\n        <pmcc-icon name=\"chevron-left\" size=\"3x\"></pmcc-icon>\n      </button>\n      <span class=\"year-label\">\n        {{ currentYear }}\n      </span>\n      <button class=\"next-year\" [class.disabled]=\"isIncrementYearDisabled\" (click)=\"incrementYear()\">\n        <pmcc-icon name=\"chevron-right\" size=\"3x\"></pmcc-icon>\n      </button>\n    </div>\n    <div class=\"months\">\n      <div\n        class=\"month-item\"\n        *ngFor=\"let month of months\"\n        (click)=\"selectMonth(month)\"\n        [ngClass]=\"{\n          selected: month.isSelected,\n          disabled: month.isDisabled\n        }\">\n          {{ month.label | slice:0:3 }}\n      </div>\n    </div>\n  </div>\n</pmcc-popover>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => MonthPickerComponent)
                    }
                ],
                styles: [".popover{touch-action:none;width:198px;height:185px}.year{height:35px;text-align:center}.prev-year{float:left}.next-year{float:right}.disabled{opacity:.3;pointer-events:none}button{width:50px;height:20px;background:none;border:none;margin:0;padding:0;cursor:pointer}button:focus{outline:0}.year .year-label{font-weight:700;font-size:16px;display:inline-block;margin:0 auto;line-height:22px}.months{margin:0;border:1px solid #c9c9c9}.month-item{display:inline-block;height:49px;width:49px;cursor:pointer;text-align:center;line-height:48px;border:.9px solid #c9c9c9;font-size:13px;font-weight:700}.month-item.disabled{opacity:.5;font-weight:400;cursor:not-allowed}.month-item.selected{background-color:#0085cc;color:#fff}.month-item.selected:focus,.month-item.selected:hover{background-color:#0085cc;color:#fff;opacity:.75}.month-item.highlight,.month-item:focus,.month-item:hover{background-color:#e2f4fe}"]
            }]
    }], function () { return []; }, { monthChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], month: [{
            type: Input
        }], required: [{
            type: Input
        }], datePickerField: [{
            type: ViewChild,
            args: [DatePickerFieldComponent]
        }], popoverTrigger: [{
            type: ViewChild,
            args: [PopoverTriggerDirective]
        }], minMonth: [{
            type: Input
        }], maxMonth: [{
            type: Input
        }], positionOverride: [{
            type: Input
        }] }); })();

class MonthPickerModule {
}
MonthPickerModule.ɵfac = function MonthPickerModule_Factory(t) { return new (t || MonthPickerModule)(); };
MonthPickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MonthPickerModule });
MonthPickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            InputModule,
            PopoverModule,
            CalendarModule,
            IconModule,
            DatePickerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MonthPickerModule, [{
        type: NgModule,
        args: [{
                declarations: [MonthPickerComponent],
                imports: [
                    CommonModule,
                    InputModule,
                    PopoverModule,
                    CalendarModule,
                    IconModule,
                    DatePickerModule
                ],
                exports: [MonthPickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MonthPickerModule, { declarations: function () { return [MonthPickerComponent]; }, imports: function () { return [CommonModule, InputModule, PopoverModule, CalendarModule, IconModule, DatePickerModule]; }, exports: function () { return [MonthPickerComponent]; } }); })();

const SELECT = new InjectionToken('Select');

/**
 * Demo example
 * <example-url>/demo/#/pmcc/select</example-url>
 */
class SelectOptionComponent {
    constructor(select, elRef) {
        this.select = select;
        this.elRef = elRef;
        this._disabled = false;
        this.selected = false;
        this.highlight = false;
        this.label = '';
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    ngAfterContentInit() {
        /**
         * This is done to resolve
         * ERROR Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked.
         * Previous value: 'selected: false'. Current value: 'selected: true'.
         */
        this.selected = this.value === this.select.value;
    }
    selectOption(event) {
        event.stopPropagation();
        if (this.disabled || this.selected) {
            event.preventDefault();
            return;
        }
        this.select.onChange(this.value);
    }
}
SelectOptionComponent.ɵfac = function SelectOptionComponent_Factory(t) { return new (t || SelectOptionComponent)(ɵngcc0.ɵɵdirectiveInject(SELECT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SelectOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectOptionComponent, selectors: [["pmcc-select-option"]], inputs: { label: "label", disabled: "disabled", icon: "icon", value: "value" }, ngContentSelectors: _c1, decls: 4, vars: 6, consts: [[1, "pmcc-option-outer", 3, "ngClass", "click"], [1, "pmcc-option", "pmcc-truncate"], ["class", "pmcc-option-icon", 3, "name", 4, "ngIf"], [1, "pmcc-option-icon", 3, "name"]], template: function SelectOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function SelectOptionComponent_Template_div_click_0_listener($event) { return ctx.selectOption($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SelectOptionComponent_pmcc_icon_2_Template, 1, 1, "pmcc-icon", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(2, _c92, ctx.disabled, ctx.selected, ctx.highlight));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, IconComponent], styles: [".pmcc-option-outer[_ngcontent-%COMP%]{padding:0 15px;cursor:pointer}.pmcc-option-outer.highlight[_ngcontent-%COMP%], .pmcc-option-outer[_ngcontent-%COMP%]:hover{background:#f0f0f0}.pmcc-option-outer.selected[_ngcontent-%COMP%], .pmcc-option-outer.selected.highlighted[_ngcontent-%COMP%]{background-color:#e8f7ff}.pmcc-option-outer.disabled[_ngcontent-%COMP%]{color:#bfbfbf;cursor:not-allowed}.pmcc-option[_ngcontent-%COMP%]{display:block;padding:12px 5px;border-top:1px solid #ebebeb}.pmcc-option[_ngcontent-%COMP%]   .pmcc-option-icon[_ngcontent-%COMP%]{margin-right:5px}"] });
SelectOptionComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SELECT,] }] },
    { type: ElementRef }
];
SelectOptionComponent.propDecorators = {
    icon: [{ type: Input }],
    value: [{ type: Input }],
    label: [{ type: Input }],
    disabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectOptionComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select-option',
                template: "<div class=\"pmcc-option-outer\"\n    [ngClass]=\"{\n      'disabled': disabled,\n      'selected': selected,\n      'highlight': highlight\n    }\"\n    (click)=\"selectOption($event)\">\n  <div class=\"pmcc-option pmcc-truncate\">\n    <pmcc-icon *ngIf=\"icon\" class=\"pmcc-option-icon\" [name]=\"icon\"></pmcc-icon>\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: [".pmcc-option-outer{padding:0 15px;cursor:pointer}.pmcc-option-outer.highlight,.pmcc-option-outer:hover{background:#f0f0f0}.pmcc-option-outer.selected,.pmcc-option-outer.selected.highlighted{background-color:#e8f7ff}.pmcc-option-outer.disabled{color:#bfbfbf;cursor:not-allowed}.pmcc-option{display:block;padding:12px 5px;border-top:1px solid #ebebeb}.pmcc-option .pmcc-option-icon{margin-right:5px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SELECT]
            }] }, { type: ɵngcc0.ElementRef }]; }, { label: [{
            type: Input
        }], disabled: [{
            type: Input
        }], icon: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/select</example-url>
 */
class SelectComponent {
    constructor(elRef, changeDetector, ngZone) {
        this.elRef = elRef;
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        this.backdrop = BackDrop.TRANSPARENT;
        this.state = 0 /* Closed */;
        this._disabled = false;
        this._highlightedIndex = -1;
        this._selectedIndex = -1;
        this.controlElement = this.elRef.nativeElement;
        this.width = 120;
        this.valueChange = new EventEmitter();
        this.onModelChange = () => { };
        this.onTouched = () => { };
        this._defaultKeyHandler = this._defaultKeyHandler.bind(this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        if (!value) {
            this.label = null;
            this.icon = null;
            this._selectedIndex = -1;
        }
        this.updateSelectedOptions();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    get title() {
        return this.label || '';
    }
    get active() {
        return this.state === 2 /* Open */;
    }
    get tabIndex() {
        return this._disabled ? '' : '0';
    }
    get optionsArray() {
        return this.options.toArray();
    }
    onFocus() {
        if (!this._disabled) {
            if (this.state === 0 /* Closed */) {
                this.state = 2 /* Open */;
            }
        }
    }
    onMouseDown() {
        if (this._disabled) {
            return;
        }
        if (this.state === 2 /* Open */) {
            this.state = 1 /* Focused */;
        }
        else {
            this.setHighlighted(this._selectedIndex);
            this.state = 2 /* Open */;
        }
    }
    onChange(value) {
        this.hide();
        this.value = value;
        this.valueChange.emit(this.value);
        this.onModelChange(this.value);
        this.onTouched();
    }
    hide() {
        if (this.state === 2 /* Open */) {
            this.state = 0 /* Closed */;
        }
    }
    ngAfterContentInit() {
        this.updateSelectedOptions();
        if (this.options && this.options.length) {
            this._highlightedIndex = this._selectedIndex;
        }
        if (this.controlElement) {
            this.ngZone.runOutsideAngular(() => {
                this.controlElement.addEventListener('keydown', this._defaultKeyHandler);
            });
        }
    }
    ngOnDestroy() {
        if (this.controlElement) {
            this.ngZone.runOutsideAngular(() => {
                this.controlElement.removeEventListener('keydown', this._defaultKeyHandler);
            });
        }
    }
    updateSelectedOptions() {
        if (this.options) {
            this.options.forEach((option, currentIndex) => {
                option.selected = this.value === option.value;
                if (option.selected) {
                    this._selectedIndex = currentIndex;
                    this.label = option.label || option.elRef.nativeElement.innerText;
                    this.icon = option.icon;
                }
            });
        }
    }
    setHighlighted(index) {
        const current = this._highlightedIndex;
        if (this.optionsArray[current]) {
            this.optionsArray[current].highlight = false;
        }
        this._highlightedIndex = index;
        if (this.optionsArray[index]) {
            this.optionsArray[index].highlight = true;
        }
    }
    _selectOption(index) {
        if (index >= 0 && index < this.options.length) {
            this.setHighlighted(index);
        }
        this.changeDetector.markForCheck();
    }
    _next() {
        let i = this._highlightedIndex + 1;
        while (i < this.options.length && this._isSkippableItem(i)) {
            i++;
        }
        this._selectOption(i);
    }
    _previous() {
        let i = this._highlightedIndex - 1;
        while (i >= 0 && this._isSkippableItem(i)) {
            i--;
        }
        this._selectOption(i);
    }
    _selectByHighLightedIndex() {
        this.onChange(this.optionsArray[this._highlightedIndex].value);
    }
    _isSkippableItem(i) {
        return this.optionsArray[i].disabled;
    }
    _defaultKeyHandler(event) {
        if (this.state === 2 /* Open */) {
            switch (event.key) {
                case 'ArrowUp':
                    this._previous();
                    break;
                case 'ArrowDown':
                    this._next();
                    break;
                case 'Enter':
                    this._selectByHighLightedIndex();
                    break;
                case 'Escape':
                    event.stopImmediatePropagation();
                    this.ngZone.run(() => this.hide());
                    break;
                case 'Tab':
                    this.hide();
                    break;
            }
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    preventDefault(event) {
        if (this.state === 2 /* Open */) {
            switch (event.key) {
                case 'ArrowUp':
                case 'ArrowDown':
                    event.stopPropagation();
                    event.preventDefault();
                    break;
            }
        }
    }
}
SelectComponent.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["pmcc-select"]], contentQueries: function SelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SelectOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, hostVars: 6, hostBindings: function SelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function SelectComponent_focus_HostBindingHandler() { return ctx.onFocus(); })("mousedown", function SelectComponent_mousedown_HostBindingHandler() { return ctx.onMouseDown(); })("keydown", function SelectComponent_keydown_HostBindingHandler($event) { return ctx.preventDefault($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("title", ctx.title);
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabIndex);
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled)("active", ctx.active);
    } }, inputs: { width: "width", value: "value", disabled: "disabled", menuWidth: "menuWidth", menuHeight: "menuHeight" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => SelectComponent)
            },
            {
                provide: SELECT,
                useExisting: forwardRef(() => SelectComponent)
            }
        ])], ngContentSelectors: _c1, decls: 2, vars: 7, consts: [[3, "icon", "label", "width", "disabled"], ["pmccOverlay", "", "pmccOverlayCloseOutsideOn", "mousedown", 3, "pmccPositionAdjacent", "pmccOverlayOpen", "pmccOverlayBackdrop", "close"], [1, "pmcc-select-menu"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "pmcc-select-trigger", 0);
        ɵngcc0.ɵɵtemplate(1, SelectComponent_ng_template_1_Template, 2, 4, "ng-template", 1);
        ɵngcc0.ɵɵlistener("close", function SelectComponent_Template_ng_template_close_1_listener() { return ctx.hide(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("icon", ctx.icon)("label", ctx.label)("width", ctx.width)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("pmccPositionAdjacent", ctx.elRef)("pmccOverlayOpen", ctx.active)("pmccOverlayBackdrop", ctx.backdrop);
    } }, directives: [SelectTriggerComponent, OverlayDirective, AdjacentPositionDirective], styles: ["[_nghost-%COMP%]{display:inline-block;position:relative}.pmcc-select-menu[_ngcontent-%COMP%]{min-width:100px;max-width:640px;max-height:400px;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3;overflow:auto;overflow-x:hidden}"] });
SelectComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: NgZone }
];
SelectComponent.propDecorators = {
    width: [{ type: Input }],
    menuWidth: [{ type: Input }],
    menuHeight: [{ type: Input }],
    valueChange: [{ type: Output }],
    value: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.disabled',] }],
    title: [{ type: HostBinding, args: ['title',] }],
    active: [{ type: HostBinding, args: ['class.active',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    options: [{ type: ContentChildren, args: [SelectOptionComponent,] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onMouseDown: [{ type: HostListener, args: ['mousedown',] }],
    preventDefault: [{ type: HostListener, args: ['window:keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select',
                template: "<pmcc-select-trigger\n  [icon]=\"icon\"\n  [label]=\"label\"\n  [width]=\"width\"\n  [disabled]=\"disabled\"\n></pmcc-select-trigger>\n\n<ng-template\n  pmccOverlay\n  [pmccPositionAdjacent]=\"elRef\"\n  [pmccOverlayOpen]=\"active\"\n  [pmccOverlayBackdrop]=\"backdrop\"\n  pmccOverlayCloseOutsideOn=\"mousedown\"\n  (close)=\"hide()\">\n  <div\n    class=\"pmcc-select-menu\"\n    [style.width.px]=\"menuWidth\"\n    [style.height.px]=\"menuHeight\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => SelectComponent)
                    },
                    {
                        provide: SELECT,
                        useExisting: forwardRef(() => SelectComponent)
                    }
                ],
                styles: [":host{display:inline-block;position:relative}.pmcc-select-menu{min-width:100px;max-width:640px;max-height:400px;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3;overflow:auto;overflow-x:hidden}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { width: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], title: [{
            type: HostBinding,
            args: ['title']
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown']
        }], preventDefault: [{
            type: HostListener,
            args: ['window:keydown', ['$event']]
        }], menuWidth: [{
            type: Input
        }], menuHeight: [{
            type: Input
        }], options: [{
            type: ContentChildren,
            args: [SelectOptionComponent]
        }] }); })();

class SelectModule {
}
SelectModule.ɵfac = function SelectModule_Factory(t) { return new (t || SelectModule)(); };
SelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SelectModule });
SelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule,
            LayoutModule,
            SelectTriggerModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule,
                    LayoutModule,
                    SelectTriggerModule,
                ],
                declarations: [SelectComponent, SelectOptionComponent],
                exports: [SelectComponent, SelectOptionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectModule, { declarations: function () { return [SelectComponent, SelectOptionComponent]; }, imports: function () { return [CommonModule, IconModule, LayoutModule, SelectTriggerModule]; }, exports: function () { return [SelectComponent, SelectOptionComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/input</example-url>
 */
class IntegerDirective {
    constructor(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
        this.writeToForm = noop;
        this.onTouched = noop;
        this.invalidInteger = new EventEmitter();
        this.minExceed = new EventEmitter();
        this.maxExceed = new EventEmitter();
    }
    set min(value) {
        this._min = +value;
    }
    set max(value) {
        this._max = +value;
    }
    registerOnChange(fn) {
        this.writeToForm = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._el.nativeElement, 'disabled', isDisabled);
    }
    writeValue(value) {
        const fieldValue = value;
        if (value) {
            this.verifyInteger(fieldValue.toString());
        }
        else {
            this._el.nativeElement.value = '';
        }
    }
    onChange(event) {
        const fieldValue = event.target.value.toString();
        this.verifyInteger(fieldValue);
    }
    /**
     * Compares if the value is valid integer
     * between min and max value passed.
     */
    verifyInteger(fieldValue) {
        let newValue = fieldValue.replace(/[^-\d]/g, '');
        if (isNaN(newValue) || fieldValue !== newValue) {
            this.invalidInteger.emit(fieldValue);
            newValue = '';
        }
        else {
            if (newValue < this._min) {
                this.minExceed.emit(newValue);
                newValue = this._min;
            }
            if (newValue > this._max && newValue.length !== 0) {
                this.maxExceed.emit(newValue);
                newValue = this._max;
            }
            newValue = newValue.length === 0 ? '' : parseInt(newValue, 10);
        }
        this._el.nativeElement.value = newValue;
        this.writeToForm(newValue);
    }
    onBlur() {
        this.onTouched();
    }
}
IntegerDirective.ɵfac = function IntegerDirective_Factory(t) { return new (t || IntegerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
IntegerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IntegerDirective, selectors: [["input", "pmccInteger", ""]], hostBindings: function IntegerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function IntegerDirective_change_HostBindingHandler($event) { return ctx.onChange($event); })("blur", function IntegerDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { min: "min", max: "max" }, outputs: { invalidInteger: "invalidInteger", minExceed: "minExceed", maxExceed: "maxExceed" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => IntegerDirective),
                multi: true
            },
        ])] });
IntegerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
IntegerDirective.propDecorators = {
    invalidInteger: [{ type: Output }],
    minExceed: [{ type: Output }],
    maxExceed: [{ type: Output }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    onChange: [{ type: HostListener, args: ['change', ['$event'],] }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IntegerDirective, [{
        type: Directive,
        args: [{
                selector: 'input[pmccInteger]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => IntegerDirective),
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { invalidInteger: [{
            type: Output
        }], minExceed: [{
            type: Output
        }], maxExceed: [{
            type: Output
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], onChange: [{
            type: HostListener,
            args: ['change', ['$event']]
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

class IntegerModule {
}
IntegerModule.ɵfac = function IntegerModule_Factory(t) { return new (t || IntegerModule)(); };
IntegerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IntegerModule });
IntegerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IntegerModule, [{
        type: NgModule,
        args: [{
                declarations: [IntegerDirective],
                imports: [],
                exports: [IntegerDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IntegerModule, { declarations: [IntegerDirective], exports: [IntegerDirective] }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmcc/access-denied</example-url>
 */
class AccessDeniedComponent {
    goBack() {
        window.history.back();
    }
}
AccessDeniedComponent.ɵfac = function AccessDeniedComponent_Factory(t) { return new (t || AccessDeniedComponent)(); };
AccessDeniedComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccessDeniedComponent, selectors: [["pmcc-access-denied"]], decls: 20, vars: 0, consts: function () { let i18n_93; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_143318366100741906$$FESM2015_PUBMATIC_PMCC_JS_94 = goog.getMsg("Access Denied");
        i18n_93 = MSG_EXTERNAL_143318366100741906$$FESM2015_PUBMATIC_PMCC_JS_94;
    }
    else {
        i18n_93 = $localize `:␟e8c667b28a43557b33692e13d7f9bac3c5d0635e␟143318366100741906:Access Denied`;
    } let i18n_95; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_8050067010673714243$$FESM2015_PUBMATIC_PMCC_JS_96 = goog.getMsg("{$startParagraph}Your account is not authorized to access this feature.{$closeParagraph}{$startParagraph}Please contact your account manager for access.{$closeParagraph}", { "startParagraph": "[\uFFFD#9\uFFFD|\uFFFD#10\uFFFD]", "closeParagraph": "[\uFFFD/#9\uFFFD|\uFFFD/#10\uFFFD]" });
        i18n_95 = MSG_EXTERNAL_8050067010673714243$$FESM2015_PUBMATIC_PMCC_JS_96;
    }
    else {
        i18n_95 = $localize `:␟6021d065c9192fa3c597c3be100964fa3794a67f␟8050067010673714243:${"[\uFFFD#9\uFFFD|\uFFFD#10\uFFFD]"}:START_PARAGRAPH:Your account is not authorized to access this feature.${"[\uFFFD/#9\uFFFD|\uFFFD/#10\uFFFD]"}:CLOSE_PARAGRAPH:${"[\uFFFD#9\uFFFD|\uFFFD#10\uFFFD]"}:START_PARAGRAPH:Please contact your account manager for access.${"[\uFFFD/#9\uFFFD|\uFFFD/#10\uFFFD]"}:CLOSE_PARAGRAPH:`;
    } i18n_95 = ɵngcc0.ɵɵi18nPostprocess(i18n_95); let i18n_97; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_1673268207254826416$$FESM2015_PUBMATIC_PMCC_JS_98 = goog.getMsg("Error code: 403");
        i18n_97 = MSG_EXTERNAL_1673268207254826416$$FESM2015_PUBMATIC_PMCC_JS_98;
    }
    else {
        i18n_97 = $localize `:␟ab5dd128064426915bb9cb8ccb9ccf9bd7703387␟1673268207254826416:Error code: 403`;
    } return [[1, "pmcc-pgad"], [1, "pmcc-container"], [1, "pmcc-row"], [1, "pmcc-col"], [1, ""], [1, "pmcc-mar-bottom-sm"], i18n_93, [1, "pmcc-heading-summary"], i18n_95, [1, "pmcc-error-code"], i18n_97, [1, "pmcc-back-action"], [1, "pmcc-btn-lg", "pmcc-primary", 3, "click"], [1, "pmcc-svg-pos"], ["xmlns", "http://www.w3.org/2000/svg", "width", "160", "viewBox", "0 0 512 512"], ["fill", "#12a3bf", "d", "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"]]; }, template: function AccessDeniedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "h1", 5);
        ɵngcc0.ɵɵi18n(6, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵi18nStart(8, 8);
        ɵngcc0.ɵɵelement(9, "p");
        ɵngcc0.ɵɵelement(10, "p");
        ɵngcc0.ɵɵi18nEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵi18n(12, 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 11);
        ɵngcc0.ɵɵelementStart(14, "button", 12);
        ɵngcc0.ɵɵlistener("click", function AccessDeniedComponent_Template_button_click_14_listener() { return ctx.goBack(); });
        ɵngcc0.ɵɵtext(15, "Go Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 3);
        ɵngcc0.ɵɵelementStart(17, "div", 13);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(18, "svg", 14);
        ɵngcc0.ɵɵelement(19, "path", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".pmcc-pgad[_ngcontent-%COMP%]{display:block;width:100%;max-width:740px;border-radius:5px;padding:25px;font-size:13px;margin:100px auto}.pmcc-pgad[_ngcontent-%COMP%]   .pmcc-error-code[_ngcontent-%COMP%], .pmcc-pgad[_ngcontent-%COMP%]   .pmcc-heading-summary[_ngcontent-%COMP%]{margin-bottom:20px}.pmcc-pgad[_ngcontent-%COMP%]   .pmcc-back-action[_ngcontent-%COMP%]{margin-bottom:30px}.pmcc-pgad[_ngcontent-%COMP%]   .pmcc-svg-pos[_ngcontent-%COMP%]{text-align:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccessDeniedComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-access-denied',
                template: "<div class=\"pmcc-pgad\">\n  <div class=\"pmcc-container\">\n    <div class=\"pmcc-row\">\n      <div class=\"pmcc-col\">\n        <div class=\" \">\n          <h1\n            class=\"pmcc-mar-bottom-sm\"\n            i18n\n          >Access Denied</h1>\n          <div\n            class=\"pmcc-heading-summary\"\n            i18n\n          >\n          <p>Your account is not authorized to access this feature.</p>\n          <p>Please contact your account manager for access.</p>\n          </div>\n          <div\n            class=\"pmcc-error-code\"\n            i18n\n          >Error code: 403</div>\n          <div class=\"pmcc-back-action\">\n            <button\n              class=\"pmcc-btn-lg pmcc-primary\"\n              (click)=\"goBack()\"\n            >Go Back</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"pmcc-col\">\n        <div class=\"pmcc-svg-pos\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"160\"\n            viewBox=\"0 0 512 512\"\n          >\n            <path\n              fill=\"#12a3bf\"\n              d=\"M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z\"\n            ></path>\n          </svg>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".pmcc-pgad{display:block;width:100%;max-width:740px;border-radius:5px;padding:25px;font-size:13px;margin:100px auto}.pmcc-pgad .pmcc-error-code,.pmcc-pgad .pmcc-heading-summary{margin-bottom:20px}.pmcc-pgad .pmcc-back-action{margin-bottom:30px}.pmcc-pgad .pmcc-svg-pos{text-align:right}"]
            }]
    }], null, null); })();

class AccessDeniedModule {
}
AccessDeniedModule.ɵfac = function AccessDeniedModule_Factory(t) { return new (t || AccessDeniedModule)(); };
AccessDeniedModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AccessDeniedModule });
AccessDeniedModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccessDeniedModule, [{
        type: NgModule,
        args: [{
                declarations: [AccessDeniedComponent],
                imports: [
                    CommonModule
                ],
                exports: [AccessDeniedComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccessDeniedModule, { declarations: function () { return [AccessDeniedComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AccessDeniedComponent]; } }); })();

const Messages = {
    // tslint:disable-next-line: max-line-length
    AD_BLOCKER: 'Error: You are missing parts of the page due to an ad blocker being enabled. Disable your ad blocker to ensure you see everything.'
};

const AD_BLOCKER_CHECK_URL = 'https://cdn.pubmatic.com/common/ui-common-assets/ads-prebid.js';
class AdblockerNotificationComponent {
    constructor(http) {
        this.http = http;
        this.type = 'error';
        this.notificationMsg = Messages.AD_BLOCKER;
        this.closed = new EventEmitter();
        this.showNotificationMsg = false;
    }
    ngOnInit() {
        this.checkAdBlocker();
    }
    hideNotification() {
        this.showNotificationMsg = false;
        this.closed.emit();
    }
    checkAdBlocker() {
        this.http.get(AD_BLOCKER_CHECK_URL)
            .pipe(take(1))
            .subscribe(
        /* istanbul ignore next */
        data => { }, err => this.showNotificationMsg = err.status === 0);
    }
}
AdblockerNotificationComponent.ɵfac = function AdblockerNotificationComponent_Factory(t) { return new (t || AdblockerNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.HttpClient)); };
AdblockerNotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AdblockerNotificationComponent, selectors: [["pmcc-adblocker-notification"]], inputs: { type: "type", notificationMsg: "notificationMsg" }, outputs: { closed: "closed" }, decls: 1, vars: 1, consts: [["class", "pmcc-adblocker-notification-wrap", 4, "ngIf"], [1, "pmcc-adblocker-notification-wrap"], ["data-pm-id", "pmcc-adblocker-notification", 3, "type", "closed"], [3, "innerHTML"]], template: function AdblockerNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AdblockerNotificationComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNotificationMsg);
    } }, directives: [ɵngcc1.NgIf, MessageBoxComponent], styles: ["[_nghost-%COMP%]   .pmcc-adblocker-notification-wrap[_ngcontent-%COMP%]{padding:10px 10px 0}"] });
AdblockerNotificationComponent.ctorParameters = () => [
    { type: HttpClient }
];
AdblockerNotificationComponent.propDecorators = {
    type: [{ type: Input }],
    notificationMsg: [{ type: Input }],
    closed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdblockerNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-adblocker-notification',
                template: "<div class=\"pmcc-adblocker-notification-wrap\" *ngIf=\"showNotificationMsg\">\n  <pmcc-message-box\n    data-pm-id=\"pmcc-adblocker-notification\"\n    [type]=\"type\"\n    (closed)=\"hideNotification()\"\n  >\n    <span [innerHTML]=\"notificationMsg\"></span>\n  </pmcc-message-box>\n</div>\n",
                styles: [":host .pmcc-adblocker-notification-wrap{padding:10px 10px 0}"]
            }]
    }], function () { return [{ type: ɵngcc8.HttpClient }]; }, { type: [{
            type: Input
        }], notificationMsg: [{
            type: Input
        }], closed: [{
            type: Output
        }] }); })();

class AdblockerNotificationModule {
}
AdblockerNotificationModule.ɵfac = function AdblockerNotificationModule_Factory(t) { return new (t || AdblockerNotificationModule)(); };
AdblockerNotificationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AdblockerNotificationModule });
AdblockerNotificationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NotifiersModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdblockerNotificationModule, [{
        type: NgModule,
        args: [{
                declarations: [AdblockerNotificationComponent],
                imports: [CommonModule, NotifiersModule],
                exports: [AdblockerNotificationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AdblockerNotificationModule, { declarations: function () { return [AdblockerNotificationComponent]; }, imports: function () { return [CommonModule, NotifiersModule]; }, exports: function () { return [AdblockerNotificationComponent]; } }); })();

class CheckboxGroupComponent {
    constructor(cd) {
        this.cd = cd;
        this._model = [];
        this.falseValue = CheckboxState.UNCHECKED;
        this.trueValue = CheckboxState.CHECKED;
        this.someValue = CheckboxState.PARTIAL;
        this.valueProp = 'checked';
        /**
          * Will emit the value whenever model value is changed by Checkbox Group Component
        */
        this.modelChange = new EventEmitter();
        this.valueChange = new EventEmitter();
        /* istanbul ignore next */
        this.onModelChange = noop;
        /* istanbul ignore next */
        this.onTouched = noop;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        // Do not update value and call function if it's same as older
        if (this._value === value || value === undefined) {
            return;
        }
        this._oldValue = this._value;
        this._value = value;
        if (this.value !== this.someValue) {
            this.onInputChange(this.value);
        }
    }
    get model() {
        return this._model;
    }
    set model(value) {
        this._model = value;
        this.updateStateWithDelay();
    }
    onBlur() {
        this.onTouched();
    }
    ngOnInit() {
        if (this.model) {
            this.checkboxSubscription = CheckboxComponent.checkboxObserver.subscribe(() => {
                this.cd.markForCheck();
                this.updateState();
            });
        }
        this.updateStateWithDelay();
    }
    ngOnDestroy() {
        if (this.checkboxSubscription && !this.checkboxSubscription.closed) {
            this.checkboxSubscription.unsubscribe();
        }
    }
    onInputChange(event) {
        var _a;
        if ((_a = this.model) === null || _a === void 0 ? void 0 : _a.length) {
            if (event === this.trueValue) {
                this.model.forEach(item => item[this.valueProp] = this.trueValue);
            }
            else if (event === this.falseValue) {
                this.model.forEach(item => item[this.valueProp] = this.falseValue);
            }
            this.modelChange.emit(this.model);
            this.emitValueChange();
        }
    }
    updateStateWithDelay() {
        Promise.resolve().then(() => {
            this.updateState();
        });
    }
    updateState() {
        if (!this.model || !this.model.length) {
            this._value = this.falseValue;
            return;
        }
        let updatedValue = this.falseValue;
        const allChecked = this.model.every(x => x[this.valueProp] === this.trueValue);
        if (allChecked) {
            updatedValue = this.trueValue;
        }
        else {
            const someChecked = this.model.some(x => x[this.valueProp] === this.trueValue);
            if (someChecked) {
                updatedValue = this.someValue;
            }
        }
        this._oldValue = this._value;
        this._value = updatedValue;
        this.emitValueChange();
    }
    emitValueChange() {
        if (this._value !== this._oldValue) {
            this.onModelChange(this.value);
            this.valueChange.emit(this.value);
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(value) {
        if (value !== this.value && value != null) {
            this.value = value;
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
CheckboxGroupComponent.ɵfac = function CheckboxGroupComponent_Factory(t) { return new (t || CheckboxGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CheckboxGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxGroupComponent, selectors: [["pmcc-checkbox-group"]], hostBindings: function CheckboxGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function CheckboxGroupComponent_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { falseValue: "falseValue", trueValue: "trueValue", someValue: "someValue", valueProp: "valueProp", value: "value", model: "model", disabled: "disabled", id: "id", name: "name", label: "label", required: "required" }, outputs: { modelChange: "modelChange", valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => CheckboxGroupComponent)
            },
        ])], decls: 1, vars: 9, consts: [[3, "id", "name", "label", "ngModel", "falseValue", "trueValue", "someValue", "disabled", "required", "ngModelChange"]], template: function CheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pmcc-checkbox", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function CheckboxGroupComponent_Template_pmcc_checkbox_ngModelChange_0_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("name", ctx.name)("label", ctx.label)("ngModel", ctx.value)("falseValue", ctx.falseValue)("trueValue", ctx.trueValue)("someValue", ctx.someValue)("disabled", ctx.disabled)("required", ctx.required);
    } }, directives: [CheckboxComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator], encapsulation: 2 });
CheckboxGroupComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CheckboxGroupComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    label: [{ type: Input }],
    falseValue: [{ type: Input }],
    trueValue: [{ type: Input }],
    someValue: [{ type: Input }],
    valueProp: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    value: [{ type: Input }],
    model: [{ type: Input }],
    modelChange: [{ type: Output }],
    valueChange: [{ type: Output }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxGroupComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-checkbox-group',
                template: "<pmcc-checkbox\n  [id]=\"id\"\n  [name]=\"name\"\n  [label]=\"label\"\n  [(ngModel)]=\"value\"\n  [falseValue]=\"falseValue\"\n  [trueValue]=\"trueValue\"\n  [someValue]=\"someValue\"\n  [disabled]=\"disabled\"\n  [required]=\"required\"\n>\n</pmcc-checkbox>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => CheckboxGroupComponent)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { falseValue: [{
            type: Input
        }], trueValue: [{
            type: Input
        }], someValue: [{
            type: Input
        }], valueProp: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], value: [{
            type: Input
        }], model: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], disabled: [{
            type: Input
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], label: [{
            type: Input
        }], required: [{
            type: Input
        }] }); })();

class CheckboxGroupModule {
}
CheckboxGroupModule.ɵfac = function CheckboxGroupModule_Factory(t) { return new (t || CheckboxGroupModule)(); };
CheckboxGroupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxGroupModule });
CheckboxGroupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CheckboxModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckboxGroupComponent],
                imports: [
                    CheckboxModule,
                    FormsModule
                ],
                exports: [CheckboxGroupComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxGroupModule, { declarations: function () { return [CheckboxGroupComponent]; }, imports: function () { return [CheckboxModule, FormsModule]; }, exports: function () { return [CheckboxGroupComponent]; } }); })();

const SELECT_BOX_GROUP = new InjectionToken('SelectBoxGroup');

class SelectBoxComponent {
    constructor(selectBoxGroup) {
        this.selectBoxGroup = selectBoxGroup;
        this._selected = false;
        this._disabled = false;
        this.width = 152;
        this.height = 80;
        this.boxClicked = new EventEmitter();
    }
    /**
     * Box Item Value
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
        }
    }
    /**
     * Whether the item is selected.
     */
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = coerceBooleanProperty$1(value);
    }
    /**
      * Whether the item is disabled.
      */
    get disabled() {
        return this._disabled || (!!this.selectBoxGroup && this.selectBoxGroup.disabled);
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    onItemClick(event) {
        var _a, _b;
        event.preventDefault();
        event.stopPropagation();
        if (!this.disabled && !(((_a = this.selectBoxGroup) === null || _a === void 0 ? void 0 : _a.isSingleSelect) && this.selected)) {
            this.selected = !this.selected;
            (_b = this.selectBoxGroup) === null || _b === void 0 ? void 0 : _b.onChange({ value: this.value, selected: this.selected });
            this.boxClicked.emit({ value: this.value, selected: this.selected });
        }
    }
}
SelectBoxComponent.ɵfac = function SelectBoxComponent_Factory(t) { return new (t || SelectBoxComponent)(ɵngcc0.ɵɵdirectiveInject(SELECT_BOX_GROUP)); };
SelectBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectBoxComponent, selectors: [["pmcc-select-box"]], inputs: { width: "width", height: "height", value: "value", disabled: "disabled" }, outputs: { boxClicked: "boxClicked" }, ngContentSelectors: _c1, decls: 6, vars: 10, consts: [[1, "pmcc-sb-wrapper", 3, "ngClass", "click"], [1, "pmcc-sb-aid-wrapper"], ["class", "pmcc-sb-aid", 3, "checked", "disabled", 4, "ngIf", "ngIfElse"], ["checkboxTemplate", ""], [1, "pmcc-sb-aid", 3, "checked", "disabled"]], template: function SelectBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function SelectBoxComponent_Template_button_click_0_listener($event) { return ctx.onItemClick($event); });
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, SelectBoxComponent_pmcc_radio_button_2_Template, 1, 2, "pmcc-radio-button", 2);
        ɵngcc0.ɵɵtemplate(3, SelectBoxComponent_ng_template_3_Template, 1, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px")("height", ctx.height, "px");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c99, ctx.selected, ctx.disabled));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectBoxGroup == null ? null : ctx.selectBoxGroup.isSingleSelect)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, RadioButtonComponent, CheckboxComponent], styles: ["[_nghost-%COMP%]{position:relative;float:left;color:#000}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:10px;background-color:#fff;padding:8px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]:hover:not(.disabled):not(.selected), [_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]:hover:not(.selected):not(.disabled){background-color:#0196d826;box-shadow:0 0 10px 5px #9999991a;cursor:pointer}[_nghost-%COMP%] > .pmcc-sb-wrapper.selected[_ngcontent-%COMP%]:not(.disabled){background-color:#0196d826;border:2px solid #0196d8;box-shadow:none}[_nghost-%COMP%] > .pmcc-sb-wrapper.selected[_ngcontent-%COMP%]:not(.disabled)     .pmcc-sb-select-bold{font-weight:700}[_nghost-%COMP%] > .pmcc-sb-wrapper.disabled[_ngcontent-%COMP%]{background:repeating-linear-gradient(45deg,#c9c9c9,#c9c9c9 1px,#ebebeb 0,#ebebeb 12px)!important;cursor:not-allowed;border-color:1px solid #eaeaea}[_nghost-%COMP%] > .pmcc-sb-wrapper.disabled[_ngcontent-%COMP%]     .pmcc-sb-select-bold, [_nghost-%COMP%] > .pmcc-sb-wrapper.disabled[_ngcontent-%COMP%]     pmcc-icon{background:#ebebeb}[_nghost-%COMP%] > .pmcc-sb-wrapper.selected.disabled[_ngcontent-%COMP%]{box-shadow:none}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]    {font-size:9px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]     pmcc-icon{font-size:32px;width:32px;height:32px;margin-bottom:5px;color:#545454}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]     pmcc-icon:before{width:32px;height:32px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]     .pmcc-sb-select-bold{font-size:12px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%] > .pmcc-sb-aid[_ngcontent-%COMP%]{position:absolute;top:7px;left:7px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%] > .pmcc-sb-aid[_ngcontent-%COMP%]     .pmcc-cb-flag{height:16px;width:16px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%] > .pmcc-sb-aid[_ngcontent-%COMP%]     .pmcc-cb-flag.pmcc-cb-checked:after{height:8px;width:4px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%] > .pmcc-sb-aid[_ngcontent-%COMP%]     .pmcc-rb-flag{height:16px;width:16px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%] > .pmcc-sb-aid[_ngcontent-%COMP%]     .pmcc-rb-flag.pmcc-rb-selected:after{height:12px;width:12px}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]:not(.selected).disabled{color:#545454}[_nghost-%COMP%] > .pmcc-sb-wrapper[_ngcontent-%COMP%]:not(.selected).disabled   .pmcc-sb-aid-wrapper[_ngcontent-%COMP%]{display:none}"] });
SelectBoxComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SELECT_BOX_GROUP,] }] }
];
SelectBoxComponent.propDecorators = {
    width: [{ type: Input }],
    height: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    boxClicked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectBoxComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select-box',
                template: "<button\n  class=\"pmcc-sb-wrapper\"\n  [style.width.px]=\"width\"\n  [style.height.px]=\"height\"\n  [ngClass]=\"{'selected': selected, 'disabled': disabled}\"\n  (click)=\"onItemClick($event)\"\n>\n  <span class=\"pmcc-sb-aid-wrapper\">\n    <pmcc-radio-button\n      class=\"pmcc-sb-aid\"\n      [checked]=\"selected\"\n      [disabled]=\"disabled\"\n      *ngIf=\"selectBoxGroup?.isSingleSelect; else checkboxTemplate\">\n    </pmcc-radio-button>\n    <ng-template #checkboxTemplate>\n      <pmcc-checkbox\n        class=\"pmcc-sb-aid\"\n        [checked]=\"selected\"\n        [disabled]=\"disabled\">\n    </pmcc-checkbox>\n    </ng-template>\n  </span>\n  <ng-content></ng-content>\n</button>\n",
                styles: [":host{position:relative;float:left;color:#000}:host>.pmcc-sb-wrapper{border:1px solid #ccc;border-radius:10px;background-color:#fff;padding:8px}:host>.pmcc-sb-wrapper:hover:not(.disabled):not(.selected),:host>.pmcc-sb-wrapper:hover:not(.selected):not(.disabled){background-color:#0196d826;box-shadow:0 0 10px 5px #9999991a;cursor:pointer}:host>.pmcc-sb-wrapper.selected:not(.disabled){background-color:#0196d826;border:2px solid #0196d8;box-shadow:none}:host>.pmcc-sb-wrapper.selected:not(.disabled) ::ng-deep .pmcc-sb-select-bold{font-weight:700}:host>.pmcc-sb-wrapper.disabled{background:repeating-linear-gradient(45deg,#c9c9c9,#c9c9c9 1px,#ebebeb 0,#ebebeb 12px)!important;cursor:not-allowed;border-color:1px solid #eaeaea}:host>.pmcc-sb-wrapper.disabled ::ng-deep .pmcc-sb-select-bold,:host>.pmcc-sb-wrapper.disabled ::ng-deep pmcc-icon{background:#ebebeb}:host>.pmcc-sb-wrapper.selected.disabled{box-shadow:none}:host>.pmcc-sb-wrapper ::ng-deep{font-size:9px}:host>.pmcc-sb-wrapper ::ng-deep pmcc-icon{font-size:32px;width:32px;height:32px;margin-bottom:5px;color:#545454}:host>.pmcc-sb-wrapper ::ng-deep pmcc-icon:before{width:32px;height:32px}:host>.pmcc-sb-wrapper ::ng-deep .pmcc-sb-select-bold{font-size:12px}:host>.pmcc-sb-wrapper .pmcc-sb-aid-wrapper>.pmcc-sb-aid{position:absolute;top:7px;left:7px}:host>.pmcc-sb-wrapper .pmcc-sb-aid-wrapper>.pmcc-sb-aid ::ng-deep .pmcc-cb-flag{height:16px;width:16px}:host>.pmcc-sb-wrapper .pmcc-sb-aid-wrapper>.pmcc-sb-aid ::ng-deep .pmcc-cb-flag.pmcc-cb-checked:after{height:8px;width:4px}:host>.pmcc-sb-wrapper .pmcc-sb-aid-wrapper>.pmcc-sb-aid ::ng-deep .pmcc-rb-flag{height:16px;width:16px}:host>.pmcc-sb-wrapper .pmcc-sb-aid-wrapper>.pmcc-sb-aid ::ng-deep .pmcc-rb-flag.pmcc-rb-selected:after{height:12px;width:12px}:host>.pmcc-sb-wrapper:not(.selected).disabled{color:#545454}:host>.pmcc-sb-wrapper:not(.selected).disabled .pmcc-sb-aid-wrapper{display:none}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SELECT_BOX_GROUP]
            }] }]; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], boxClicked: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class SelectBoxGroupComponent {
    constructor() {
        this._value = [];
        this._disabled = false;
        this._required = false;
        this.onModelChange = noop;
        this.onTouched = noop;
        this.isSingleSelect = false;
        this.valueChange = new EventEmitter();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value ? value : [];
        this.updateSelectedBoxes();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty$1(disabled);
    }
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = coerceBooleanProperty$1(required);
    }
    ngAfterContentInit() {
        this.updateSelectedBoxes();
    }
    onChange(event) {
        this.onTouched();
        if (event.selected) {
            if (this.isSingleSelect) {
                this.value.pop();
            }
            this.value = [...this.value, event.value];
        }
        else {
            this.value = this.value.filter(v => v !== event.value);
        }
        this.onModelChange(this.value);
        this.valueChange.emit(this.value);
    }
    updateSelectedBoxes() {
        if (this.boxes && this.value) {
            this.boxes.forEach(box => box.selected = this.value.includes(box.value));
        }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Called when a new value needs to written to the ngModel.
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onChange handler.
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Registers onTouch handler.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * Sets disabled state to the control.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
SelectBoxGroupComponent.ɵfac = function SelectBoxGroupComponent_Factory(t) { return new (t || SelectBoxGroupComponent)(); };
SelectBoxGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectBoxGroupComponent, selectors: [["pmcc-select-box-group"]], contentQueries: function SelectBoxGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SelectBoxComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.boxes = _t);
    } }, inputs: { isSingleSelect: "isSingleSelect", value: "value", disabled: "disabled", required: "required" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => SelectBoxGroupComponent)
            },
            {
                provide: SELECT_BOX_GROUP,
                useExisting: forwardRef(() => SelectBoxGroupComponent)
            },
        ])], ngContentSelectors: _c1, decls: 1, vars: 0, template: function SelectBoxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:inline-block;position:relative}[_nghost-%COMP%]     pmcc-select-box{margin:4px}"] });
SelectBoxGroupComponent.propDecorators = {
    isSingleSelect: [{ type: Input }],
    valueChange: [{ type: Output }],
    boxes: [{ type: ContentChildren, args: [SelectBoxComponent,] }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectBoxGroupComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-select-box-group',
                template: "<ng-content></ng-content>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => SelectBoxGroupComponent)
                    },
                    {
                        provide: SELECT_BOX_GROUP,
                        useExisting: forwardRef(() => SelectBoxGroupComponent)
                    },
                ],
                styles: [":host{display:inline-block;position:relative}:host ::ng-deep pmcc-select-box{margin:4px}"]
            }]
    }], function () { return []; }, { isSingleSelect: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], boxes: [{
            type: ContentChildren,
            args: [SelectBoxComponent]
        }] }); })();

class SelectBoxGroupModule {
}
SelectBoxGroupModule.ɵfac = function SelectBoxGroupModule_Factory(t) { return new (t || SelectBoxGroupModule)(); };
SelectBoxGroupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SelectBoxGroupModule });
SelectBoxGroupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, CheckboxModule, RadioButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectBoxGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectBoxGroupComponent, SelectBoxComponent],
                imports: [CommonModule, FormsModule, CheckboxModule, RadioButtonModule],
                exports: [SelectBoxGroupComponent, SelectBoxComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectBoxGroupModule, { declarations: function () { return [SelectBoxGroupComponent, SelectBoxComponent]; }, imports: function () { return [CommonModule, FormsModule, CheckboxModule, RadioButtonModule]; }, exports: function () { return [SelectBoxGroupComponent, SelectBoxComponent]; } }); })();

class StickyFooterComponent {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.scrollSource = window;
        this.scrollSubscription = Subscription.EMPTY;
    }
    ngOnInit() {
        this.pmacFooterElement = document.querySelector('pmac-footer');
        this.updateScrollSource();
        /**
         * This is done to delay the setBottom on Consumer Application side
         * as the component template may be loaded based on API calls
         */
        const DELAY = 100;
        setTimeout(() => {
            this.setBottom();
        }, DELAY);
    }
    ngOnChanges() {
        this.updateScrollSource();
    }
    ngOnDestroy() {
        this.scrollSubscription.unsubscribe();
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(document.body);
        }
    }
    updateScrollSource() {
        if (this.pmacFooterElement) {
            if (this.scrollElementSelector) {
                this.scrollSource = document.querySelector(this.scrollElementSelector);
            }
            else {
                this.scrollSource = window;
            }
            this.ngZone.runOutsideAngular(() => {
                const AUDIT_TIME = 5;
                this.scrollSubscription.unsubscribe();
                this.scrollSubscription = fromEvent(this.scrollSource, 'scroll')
                    .pipe(auditTime(AUDIT_TIME))
                    .subscribe(() => this.setBottom());
            });
            this.resizeObserver = new ResizeObserver(_ => this.setBottom());
            this.resizeObserver.observe(document.body); // Observe height or width change on body element
        }
    }
    setBottom() {
        if (this.pmacFooterElement) {
            const calculatedBottom = window.innerHeight - this.pmacFooterElement.getBoundingClientRect().top;
            if (calculatedBottom >= 0) {
                this.stickyFooter.nativeElement.style.bottom = calculatedBottom + 'px';
            }
            else {
                this.stickyFooter.nativeElement.style.bottom = '0px';
            }
        }
    }
}
StickyFooterComponent.ɵfac = function StickyFooterComponent_Factory(t) { return new (t || StickyFooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
StickyFooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StickyFooterComponent, selectors: [["pmcc-sticky-footer"]], viewQuery: function StickyFooterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c100, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stickyFooter = _t.first);
    } }, inputs: { scrollElementSelector: "scrollElementSelector" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "pmcc-container-fluid", "pmcc-sf-wrapper"], ["stickyFooter", ""]], template: function StickyFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "footer", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".pmcc-sf-wrapper[_ngcontent-%COMP%]{position:fixed;background-color:#fff;z-index:1000;border:1px solid #ebebeb;box-shadow:0 -2px #ebebeb;width:100%;left:auto;bottom:0;max-width:1366px;margin:0 0 0 -80px}"] });
StickyFooterComponent.ctorParameters = () => [
    { type: NgZone }
];
StickyFooterComponent.propDecorators = {
    scrollElementSelector: [{ type: Input }],
    stickyFooter: [{ type: ViewChild, args: ['stickyFooter', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyFooterComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-sticky-footer',
                template: "<footer\n  #stickyFooter\n  class=\"pmcc-container-fluid pmcc-sf-wrapper\"\n>\n  <ng-content></ng-content>\n</footer>\n",
                styles: [".pmcc-sf-wrapper{position:fixed;background-color:#fff;z-index:1000;border:1px solid #ebebeb;box-shadow:0 -2px #ebebeb;width:100%;left:auto;bottom:0;max-width:1366px;margin:0 0 0 -80px}"]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { scrollElementSelector: [{
            type: Input
        }], stickyFooter: [{
            type: ViewChild,
            args: ['stickyFooter', { static: true }]
        }] }); })();

class StickyFooterModule {
}
StickyFooterModule.ɵfac = function StickyFooterModule_Factory(t) { return new (t || StickyFooterModule)(); };
StickyFooterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StickyFooterModule });
StickyFooterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [StickyFooterComponent],
                imports: [
                    CommonModule,
                ],
                exports: [StickyFooterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickyFooterModule, { declarations: function () { return [StickyFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [StickyFooterComponent]; } }); })();

class TableBulkActionComponent {
    constructor() {
        this.isVisible = false;
        this.buttonOption = [];
        this.name = 'table-action-1';
        this.noBulkActionTooltip = 'There are no bulk actions for the selected items. Select one item to perform single actions.';
    }
    get model() {
        return this._model;
    }
    set model(value) {
        this._model = value;
        this.onModelChange();
    }
    ngOnInit() {
        this.checkboxSubscription = CheckboxComponent.checkboxObserver.subscribe(_ => {
            this.onModelChange();
        });
    }
    ngOnDestroy() {
        if (this.checkboxSubscription && !this.checkboxSubscription.closed) {
            this.checkboxSubscription.unsubscribe();
        }
    }
    onModelChange() {
        this.selectedItemsModel = this.model.filter(x => x.checked);
        if (this.selectedItemsModel && this.selectedItemsModel.length >= 2) {
            this.isVisible = true;
        }
        else {
            this.isVisible = false;
        }
        TableBulkActionComponent.selectedItemsCount.next({ name: this.name, value: this.selectedItemsModel.length });
    }
}
TableBulkActionComponent.ɵfac = function TableBulkActionComponent_Factory(t) { return new (t || TableBulkActionComponent)(); };
TableBulkActionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableBulkActionComponent, selectors: [["pmcc-table-bulk-action"]], inputs: { name: "name", noBulkActionTooltip: "noBulkActionTooltip", model: "model", actions: "actions", buttonMenuLabel: "buttonMenuLabel", serviceMenuWidth: "serviceMenuWidth", serviceMenuHeight: "serviceMenuHeight" }, decls: 1, vars: 1, consts: [["class", "pmcc-flex pmcc-flex-row pmcc-align-items-center pmcc-pad-sm pmcc-tba-bulk-action-wrapper", 4, "ngIf"], [1, "pmcc-flex", "pmcc-flex-row", "pmcc-align-items-center", "pmcc-pad-sm", "pmcc-tba-bulk-action-wrapper"], [1, "pmcc-tba-divider"], [3, "actions", "model", "noBulkActionTooltip", "buttonMenuLabel", "isBulkAction", "serviceMenuWidth", "serviceMenuHeight"]], template: function TableBulkActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TableBulkActionComponent_div_0_Template, 5, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVisible && ctx.model.length);
    } }, directives: function () { return [ɵngcc1.NgIf, ButtonActionsComponent]; }, styles: [".pmcc-tba-bulk-action-wrapper[_ngcontent-%COMP%]{background-color:#f5f5f5;border:1px solid #ebebeb}.pmcc-tba-divider[_ngcontent-%COMP%]{background-color:#c9c9c9;width:1px;height:28px;margin-left:15px;margin-right:15px}"] });
TableBulkActionComponent.selectedItemsCount = new Subject();
TableBulkActionComponent.propDecorators = {
    model: [{ type: Input }],
    actions: [{ type: Input }],
    name: [{ type: Input }],
    noBulkActionTooltip: [{ type: Input }],
    buttonMenuLabel: [{ type: Input }],
    serviceMenuWidth: [{ type: Input }],
    serviceMenuHeight: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableBulkActionComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-bulk-action',
                template: "<div\n  *ngIf=\"isVisible && model.length\"\n  class=\"pmcc-flex pmcc-flex-row pmcc-align-items-center pmcc-pad-sm pmcc-tba-bulk-action-wrapper\"\n>\n  <b>{{selectedItemsModel?.length}} Selected</b>\n\n  <div class=\"pmcc-tba-divider\"></div>\n\n  <pmcc-button-actions\n    [actions]=\"actions\"\n    [model]=\"selectedItemsModel\"\n    [noBulkActionTooltip]=\"noBulkActionTooltip\"\n    [buttonMenuLabel]=\"buttonMenuLabel\"\n    [isBulkAction]=\"true\"\n    [serviceMenuWidth]=\"serviceMenuWidth\"\n    [serviceMenuHeight]=\"serviceMenuHeight\"\n  ></pmcc-button-actions>\n\n</div>\n",
                styles: [".pmcc-tba-bulk-action-wrapper{background-color:#f5f5f5;border:1px solid #ebebeb}.pmcc-tba-divider{background-color:#c9c9c9;width:1px;height:28px;margin-left:15px;margin-right:15px}"]
            }]
    }], function () { return []; }, { name: [{
            type: Input
        }], noBulkActionTooltip: [{
            type: Input
        }], model: [{
            type: Input
        }], actions: [{
            type: Input
        }], buttonMenuLabel: [{
            type: Input
        }], serviceMenuWidth: [{
            type: Input
        }], serviceMenuHeight: [{
            type: Input
        }] }); })();

class TableRowActionComponent {
    constructor() {
        this._disabled = false;
        this.buttonOption = [];
        this.isMenuOpen = false;
        this.name = 'table-action-1';
        /**
         * Event which emits the underlying model assigned to it.
         */
        this.modelChange = new EventEmitter();
    }
    /**
     * Set disableCheckbox for disabling the checkbox
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty$1(value);
    }
    get checkboxValue() {
        return this.model && this.model.checked;
    }
    get selectedCheckboxCount() {
        return TableRowActionComponent.selectedCheckboxCount[this.name];
    }
    set selectedCheckboxCount(value) {
        TableRowActionComponent.selectedCheckboxCount[this.name] = value;
    }
    ngOnInit() {
        // Set Initial Checkbox Value
        if (this.model && this.model.checked === undefined) {
            this.model.checked = CheckboxState.UNCHECKED;
        }
        // Subscription from Bulk Action
        this.menuVisibleSubscription = TableBulkActionComponent.selectedItemsCount.subscribe(tableBulkAction => {
            if (this.model.checked && this.selectedCheckboxCount === 1) {
                this.isMenuOpen = true;
            }
            else {
                this.isMenuOpen = false;
            }
            TableRowActionComponent.selectedCheckboxCount[tableBulkAction.name] = tableBulkAction.value;
        });
        // Set Default value for checkbox group name variable
        TableRowActionComponent.selectedCheckboxCount[this.name] = 0;
    }
    ngOnDestroy() {
        if (this.menuVisibleSubscription && !this.menuVisibleSubscription.closed) {
            this.menuVisibleSubscription.unsubscribe();
        }
    }
    hideMenu() {
        this.model.checked = CheckboxState.UNCHECKED;
        this.isMenuOpen = false;
        // Added checkbox observer as it will trigger change on checkbox group of deselecting model of this checkbox
        CheckboxComponent.checkboxObserver.next();
    }
    onCheckboxClick(isSelected) {
        this.model.checked = isSelected;
        this.isMenuOpen = !!isSelected;
        this.modelChange.emit(this.model);
        if (isSelected) {
            this.selectedCheckboxCount += 1;
        }
        else {
            this.selectedCheckboxCount -= 1;
        }
    }
}
TableRowActionComponent.ɵfac = function TableRowActionComponent_Factory(t) { return new (t || TableRowActionComponent)(); };
TableRowActionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableRowActionComponent, selectors: [["pmcc-table-row-action"]], inputs: { name: "name", disabled: "disabled", model: "model", actions: "actions", buttonMenuLabel: "buttonMenuLabel", serviceMenuWidth: "serviceMenuWidth", serviceMenuHeight: "serviceMenuHeight" }, outputs: { modelChange: "modelChange" }, decls: 4, vars: 3, consts: [[1, "pmcc-tra-pos-relative"], ["class", "pmcc-tra-action-menu-container", "data-pm-id", "pmcc-tra-popover", 4, "ngIf"], ["data-pm-id", "pmcc-tra-ckbx", 3, "ngModel", "disabled", "ngModelChange"], ["data-pm-id", "pmcc-tra-popover", 1, "pmcc-tra-action-menu-container"], [3, "actions", "model", "buttonMenuLabel", "serviceMenuWidth", "serviceMenuHeight", "actionClick"]], template: function TableRowActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TableRowActionComponent_div_1_Template, 2, 5, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "pmcc-checkbox", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function TableRowActionComponent_Template_pmcc_checkbox_ngModelChange_3_listener($event) { return ctx.onCheckboxClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMenuOpen && ctx.selectedCheckboxCount === 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.checkboxValue || 0)("disabled", ctx.disabled);
    } }, directives: function () { return [ɵngcc1.NgIf, CheckboxComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ButtonActionsComponent]; }, styles: [".pmcc-tra-pos-relative[_ngcontent-%COMP%]{position:relative}.pmcc-tra-action-menu-container[_ngcontent-%COMP%]{position:absolute;left:24px;top:-30px;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3;padding:5px}  tr:first-child .pmcc-tra-action-menu-container{top:3px}"] });
TableRowActionComponent.selectedCheckboxCount = {};
TableRowActionComponent.propDecorators = {
    model: [{ type: Input }],
    disabled: [{ type: Input }],
    actions: [{ type: Input }],
    name: [{ type: Input }],
    buttonMenuLabel: [{ type: Input }],
    serviceMenuWidth: [{ type: Input }],
    serviceMenuHeight: [{ type: Input }],
    modelChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableRowActionComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-table-row-action',
                template: "<!-- ACTION POPOVER -->\n<div class=\"pmcc-tra-pos-relative\">\n  <div\n    *ngIf=\"isMenuOpen && selectedCheckboxCount === 1\"\n    class=\"pmcc-tra-action-menu-container\"\n    data-pm-id=\"pmcc-tra-popover\"\n  >\n    <pmcc-button-actions\n      [actions]=\"actions\"\n      [model]=\"model\"\n      [buttonMenuLabel]=\"buttonMenuLabel\"\n      [serviceMenuWidth]=\"serviceMenuWidth\"\n      [serviceMenuHeight]=\"serviceMenuHeight\"\n      (actionClick)=\"hideMenu()\"\n    ></pmcc-button-actions>\n  </div>\n</div>\n\n<!-- ACTION CHECKBOX -->\n<div class=\"pmcc-tra-pos-relative\">\n  <pmcc-checkbox\n    data-pm-id=\"pmcc-tra-ckbx\"\n    [ngModel]=\"checkboxValue || 0\"\n    [disabled]=\"disabled\"\n    (ngModelChange)=\"onCheckboxClick($event)\"\n  >\n  </pmcc-checkbox>\n</div>\n",
                styles: [".pmcc-tra-pos-relative{position:relative}.pmcc-tra-action-menu-container{position:absolute;left:24px;top:-30px;box-shadow:0 4px 8px #0003;background:#fff;border-radius:0 0 3px 3px;border:1px solid #c3c3c3;padding:5px}::ng-deep tr:first-child .pmcc-tra-action-menu-container{top:3px}"]
            }]
    }], function () { return []; }, { name: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], model: [{
            type: Input
        }], actions: [{
            type: Input
        }], buttonMenuLabel: [{
            type: Input
        }], serviceMenuWidth: [{
            type: Input
        }], serviceMenuHeight: [{
            type: Input
        }] }); })();

class ButtonActionsComponent {
    constructor() {
        this._action = [];
        this.buttonOption = [];
        this.primaryActions = [];
        this.isBulkAction = false;
        this.actionClick = new EventEmitter();
    }
    get actions() {
        return this._action;
    }
    set actions(value) {
        this._action = value;
        this.setActions();
    }
    setActions() {
        if (!this.actions.length) {
            return;
        }
        this.filterActions();
    }
    filterActions() {
        const secondaryActions = [];
        this.primaryActions = [];
        this.actions.forEach(action => {
            if (action.isPrimary === true) {
                this.primaryActions.push(action);
            }
            else {
                secondaryActions.push(action);
            }
        });
        this.buttonOption = this.convertToServiceMenuInterface(secondaryActions);
    }
    onPrimaryActionClick(action) {
        if (action && action.callback) {
            action.callback(this.model);
        }
        this.actionClick.emit();
    }
    isActionDisabled(action) {
        return typeof action.isDisabled === 'function'
            ? action.isDisabled()
            : action.isDisabled;
    }
    convertToServiceMenuInterface(tableActionArray) {
        return tableActionArray.map(actionItem => {
            const { label, tooltip, isNegative, callback, children, subMenuWidth, subMenuHeight } = actionItem;
            const item = {
                label,
                tooltip,
                disable: this.isActionDisabled(actionItem),
                type: isNegative ? 'delete' : null,
                action: () => {
                    if (callback) {
                        callback(this.model);
                    }
                    this.actionClick.emit();
                },
            };
            if (children && children.length) {
                item.subMenu = {
                    options: this.convertToServiceMenuInterface(children),
                    width: subMenuWidth,
                    height: subMenuHeight,
                };
            }
            return item;
        });
    }
}
ButtonActionsComponent.ɵfac = function ButtonActionsComponent_Factory(t) { return new (t || ButtonActionsComponent)(); };
ButtonActionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonActionsComponent, selectors: [["pmcc-button-actions"]], inputs: { isBulkAction: "isBulkAction", actions: "actions", model: "model", serviceMenuWidth: "serviceMenuWidth", serviceMenuHeight: "serviceMenuHeight", noBulkActionTooltip: "noBulkActionTooltip", buttonMenuLabel: "buttonMenuLabel" }, outputs: { actionClick: "actionClick" }, decls: 3, vars: 2, consts: [[1, "pmcc-flex", "pmcc-flex-row"], ["pmccButton", "", "class", "pmcc-tra-button", "data-pm-id", "pmcc-tba-action-button", 3, "pmccVariant", "disabled", "pmccTooltip", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["pmccButton", "", "data-pm-id", "pmcc-tba-action-button", 1, "pmcc-tra-button", 3, "pmccVariant", "disabled", "pmccTooltip", "click"], ["class", "pmcc-ta-divider", 3, "ngClass", 4, "ngIf"], ["data-pm-id", "pmcc-tra-btn-menu", "pmccSize", "sm", "pmccVariant", "secondary", 1, "pmcc-tra-btn-menu", 3, "options", "disabled", "pmccTooltip", "scrollStrategy", "serviceMenuWidth", "serviceMenuHeight"], [4, "ngIf", "ngIfElse"], ["defaultText", ""], [1, "pmcc-ta-divider", 3, "ngClass"]], template: function ButtonActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ButtonActionsComponent_button_1_Template, 2, 4, "button", 1);
        ɵngcc0.ɵɵtemplate(2, ButtonActionsComponent_ng_container_2_Template, 6, 9, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.primaryActions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !((ctx.primaryActions == null ? null : ctx.primaryActions.length) && !(ctx.buttonOption == null ? null : ctx.buttonOption.length)));
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ButtonDirective, TooltipDirective, BtnMenuComponent, ɵngcc1.NgClass], styles: [".pmcc-tra-btn-menu[_ngcontent-%COMP%], .pmcc-tra-button[_ngcontent-%COMP%]{margin-top:2px;margin-bottom:2px;white-space:nowrap}.pmcc-tra-button[_ngcontent-%COMP%]{padding:3px 10px}.pmcc-ta-divider[_ngcontent-%COMP%]{background-color:#c9c9c9;width:1px;height:28px}.pmcc-tra-divider[_ngcontent-%COMP%]{margin-left:10px;margin-right:10px}.pmcc-tba-divider[_ngcontent-%COMP%]{margin-left:15px;margin-right:15px}button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:10px}"] });
ButtonActionsComponent.propDecorators = {
    actions: [{ type: Input }],
    model: [{ type: Input }],
    serviceMenuWidth: [{ type: Input }],
    serviceMenuHeight: [{ type: Input }],
    noBulkActionTooltip: [{ type: Input }],
    buttonMenuLabel: [{ type: Input }],
    isBulkAction: [{ type: Input }],
    actionClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonActionsComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-button-actions',
                template: "<div class=\"pmcc-flex pmcc-flex-row\">\n  <button\n    *ngFor=\"let primaryAction of primaryActions\"\n    pmccButton\n    class=\"pmcc-tra-button\"\n    [pmccVariant]=\"primaryAction?.isNegative ? 'action-red' : 'secondary'\"\n    [disabled]=\"isActionDisabled(primaryAction)\"\n    (click)=\"onPrimaryActionClick(primaryAction)\"\n    data-pm-id=\"pmcc-tba-action-button\"\n    [pmccTooltip]=\"primaryAction?.tooltip\"\n  >{{primaryAction.label}}</button>\n\n  <ng-container *ngIf=\"!(primaryActions?.length && !buttonOption?.length)\">\n    <div\n      class=\"pmcc-ta-divider\"\n      *ngIf=\"primaryActions?.length\"\n      [ngClass]=\"isBulkAction ? 'pmcc-tba-divider' : 'pmcc-tra-divider'\"\n    ></div>\n\n    <pmcc-btn-menu\n      data-pm-id=\"pmcc-tra-btn-menu\"\n      class=\"pmcc-tra-btn-menu\"\n      pmccSize=\"sm\"\n      pmccVariant=\"secondary\"\n      [options]=\"buttonOption\"\n      [disabled]=\"!actions.length\"\n      [pmccTooltip]=\"!actions.length ? noBulkActionTooltip : ''\"\n      [scrollStrategy]=\"'close'\"\n      [serviceMenuWidth]=\"serviceMenuWidth\"\n      [serviceMenuHeight]=\"serviceMenuHeight\"\n    >\n      <ng-container *ngIf=\"buttonMenuLabel;else defaultText\">\n        {{buttonMenuLabel}}\n      </ng-container>\n      <ng-template #defaultText>\n        {{ (actions?.length && primaryActions?.length) ? 'More Action' : 'Actions'}}\n      </ng-template>\n    </pmcc-btn-menu>\n  </ng-container>\n</div>\n",
                styles: [".pmcc-tra-btn-menu,.pmcc-tra-button{margin-top:2px;margin-bottom:2px;white-space:nowrap}.pmcc-tra-button{padding:3px 10px}.pmcc-ta-divider{background-color:#c9c9c9;width:1px;height:28px}.pmcc-tra-divider{margin-left:10px;margin-right:10px}.pmcc-tba-divider{margin-left:15px;margin-right:15px}button+button{margin-left:10px}"]
            }]
    }], function () { return []; }, { isBulkAction: [{
            type: Input
        }], actionClick: [{
            type: Output
        }], actions: [{
            type: Input
        }], model: [{
            type: Input
        }], serviceMenuWidth: [{
            type: Input
        }], serviceMenuHeight: [{
            type: Input
        }], noBulkActionTooltip: [{
            type: Input
        }], buttonMenuLabel: [{
            type: Input
        }] }); })();

class TableRowActionModule {
}
TableRowActionModule.ɵfac = function TableRowActionModule_Factory(t) { return new (t || TableRowActionModule)(); };
TableRowActionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableRowActionModule });
TableRowActionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ButtonModule,
            BtnMenuModule,
            CheckboxModule,
            TooltipModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableRowActionModule, [{
        type: NgModule,
        args: [{
                declarations: [TableRowActionComponent, ButtonActionsComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ButtonModule,
                    BtnMenuModule,
                    CheckboxModule,
                    TooltipModule,
                ],
                exports: [TableRowActionComponent, ButtonActionsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableRowActionModule, { declarations: function () { return [TableRowActionComponent, ButtonActionsComponent]; }, imports: function () { return [CommonModule,
        FormsModule, ButtonModule, BtnMenuModule, CheckboxModule, TooltipModule]; }, exports: function () { return [TableRowActionComponent, ButtonActionsComponent]; } }); })();

class TableBulkActionModule {
}
TableBulkActionModule.ɵfac = function TableBulkActionModule_Factory(t) { return new (t || TableBulkActionModule)(); };
TableBulkActionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableBulkActionModule });
TableBulkActionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ButtonModule,
            BtnMenuModule,
            TooltipModule,
            TableRowActionModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableBulkActionModule, [{
        type: NgModule,
        args: [{
                declarations: [TableBulkActionComponent],
                imports: [
                    CommonModule,
                    ButtonModule,
                    BtnMenuModule,
                    TooltipModule,
                    TableRowActionModule,
                ],
                exports: [TableBulkActionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableBulkActionModule, { declarations: function () { return [TableBulkActionComponent]; }, imports: function () { return [CommonModule, ButtonModule, BtnMenuModule, TooltipModule, TableRowActionModule]; }, exports: function () { return [TableBulkActionComponent]; } }); })();

class DrawerComponent extends EscapableDirective {
    constructor(renderer, document) {
        super();
        this.renderer = renderer;
        this.document = document;
        this._savedOverflowY = '';
        this.resizeSubscription = Subscription.EMPTY;
        this.showDrawer = false;
        // this will actually track click on backdrop and close the drawer if clicked on backdrop
        this.closeOnClickOutside = false;
        this.type = 'modal';
        this.page = '.pmcc-page';
        this.offsetTop = 56;
        this.drawerClosed = new EventEmitter();
        const mainPage = document.querySelector(this.page);
        if (mainPage) {
            this.offsetRight = mainPage.getBoundingClientRect().x;
        }
        else {
            this.offsetRight = document.body.getBoundingClientRect().x;
        }
    }
    ngOnChanges(changes) {
        if ('showDrawer' in changes) {
            const curVal = changes['showDrawer'].currentValue;
            if (curVal === true) {
                this._savedOverflowY = this.document.body.style.overflowY;
                this.setStyle('overflow-y', 'hidden');
            }
            else {
                this.setStyle('overflow-y', this._savedOverflowY);
            }
        }
    }
    ngOnInit() {
        this.height = `calc(100vh - ${this.offsetTop}px)`;
        this.resizeSubscription = fromEvent(window, 'resize')
            .pipe(auditTime(100))
            .subscribe(() => {
            this.offsetRight = this.document.querySelector(this.page).getBoundingClientRect().x;
        });
    }
    ngOnDestroy() {
        this.setStyle('overflow-y', this._savedOverflowY);
        this.resizeSubscription.unsubscribe();
    }
    backdrop() {
        return this.type === 'modal' ? BackDrop.DARK : BackDrop.TRANSPARENT;
    }
    close() {
        this.showDrawer = false;
        this.drawerClosed.emit();
    }
    get isEscapable() {
        return this.showDrawer;
    }
    _onEscape(event) {
        this.close();
    }
    setStyle(style, value) {
        this.renderer.setStyle(this.document.body, style, value);
    }
}
DrawerComponent.ɵfac = function DrawerComponent_Factory(t) { return new (t || DrawerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
DrawerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DrawerComponent, selectors: [["pmcc-drawer"]], inputs: { showDrawer: "showDrawer", closeOnClickOutside: "closeOnClickOutside", type: "type", page: "page", offsetTop: "offsetTop" }, outputs: { drawerClosed: "drawerClosed" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c102, decls: 1, vars: 4, consts: [["pmccOverlay", "", "pmccPositionScreenRight", "", 3, "pmccOverlayOpen", "pmccOverlayCloseOnClickBackdrop", "pmccOverlayCloseOnClickOutside", "pmccOverlayBackdrop", "close"], [1, "pmcc-drawer"], [1, "pmcc-drawer-header"], [1, "pmcc-drawer-content"]], template: function DrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c101);
        ɵngcc0.ɵɵtemplate(0, DrawerComponent_ng_template_0_Template, 5, 6, "ng-template", 0);
        ɵngcc0.ɵɵlistener("close", function DrawerComponent_Template_ng_template_close_0_listener() { return ctx.close(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("pmccOverlayOpen", ctx.showDrawer)("pmccOverlayCloseOnClickBackdrop", ctx.closeOnClickOutside)("pmccOverlayCloseOnClickOutside", false)("pmccOverlayBackdrop", ctx.backdrop());
    } }, directives: [OverlayDirective, ScreenRightPositionDirective], styles: [".pmcc-drawer[_ngcontent-%COMP%]{width:560px;background-color:#fff;overflow:auto;z-index:1000;position:relative;box-shadow:0 2px 8px #0000001f}.pmcc-drawer[_ngcontent-%COMP%]   .pmcc-drawer-header[_ngcontent-%COMP%]{justify-content:space-between;height:48px;background-color:#f5f5f5;padding:12px;margin-bottom:16px;position:sticky;top:0;z-index:1000}.pmcc-drawer[_ngcontent-%COMP%]   .pmcc-drawer-content[_ngcontent-%COMP%]{padding:0 12px 24px}"] });
DrawerComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
DrawerComponent.propDecorators = {
    showDrawer: [{ type: Input }],
    closeOnClickOutside: [{ type: Input }],
    type: [{ type: Input }],
    page: [{ type: Input }],
    offsetTop: [{ type: Input }],
    drawerClosed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DrawerComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-drawer',
                template: "<ng-template\n  pmccOverlay\n  [pmccOverlayOpen]=\"showDrawer\"\n  [pmccOverlayCloseOnClickBackdrop]=\"closeOnClickOutside\"\n  [pmccOverlayCloseOnClickOutside]=\"false\"\n  pmccPositionScreenRight\n  [pmccOverlayBackdrop]=\"backdrop()\"\n  (close)=\"close()\"\n>\n  <div class=\"pmcc-drawer\"\n    [style.marginRight.px]=\"offsetRight\"\n    [style.marginTop.px]=\"offsetTop\"\n    [style.height]=\"height\"\n  >\n    <div class=\"pmcc-drawer-header\">\n      <ng-content select=\".header\"></ng-content>\n    </div>\n    <div class=\"pmcc-drawer-content\">\n      <ng-content select=\".content\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n",
                styles: [".pmcc-drawer{width:560px;background-color:#fff;overflow:auto;z-index:1000;position:relative;box-shadow:0 2px 8px #0000001f}.pmcc-drawer .pmcc-drawer-header{justify-content:space-between;height:48px;background-color:#f5f5f5;padding:12px;margin-bottom:16px;position:sticky;top:0;z-index:1000}.pmcc-drawer .pmcc-drawer-content{padding:0 12px 24px}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { showDrawer: [{
            type: Input
        }], closeOnClickOutside: [{
            type: Input
        }], type: [{
            type: Input
        }], page: [{
            type: Input
        }], offsetTop: [{
            type: Input
        }], drawerClosed: [{
            type: Output
        }] }); })();

class DrawerModule {
}
DrawerModule.ɵfac = function DrawerModule_Factory(t) { return new (t || DrawerModule)(); };
DrawerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DrawerModule });
DrawerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, LayoutModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [DrawerComponent],
                imports: [CommonModule, LayoutModule],
                exports: [DrawerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DrawerModule, { declarations: function () { return [DrawerComponent]; }, imports: function () { return [CommonModule, LayoutModule]; }, exports: function () { return [DrawerComponent]; } }); })();

class SideNavigationComponent {
    constructor(element, router, ngZone) {
        this.element = element;
        this.router = router;
        this.ngZone = ngZone;
        this._scrollSubscription = Subscription.EMPTY;
        this.scrollSource = window;
        this.scrollOffset = 15;
        this.positionY = 20;
        this.offsetPositionY = 0;
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            const AUDIT_TIME = 5;
            this._scrollSubscription = fromEvent(this.scrollSource, 'scroll')
                .pipe(auditTime(AUDIT_TIME))
                .subscribe(() => this.setVisibility());
        });
        this.onInitialLoad();
    }
    onInitialLoad() {
        var _a;
        const urlArr = this.router.url.split('/');
        const currentPath = urlArr[urlArr.length - 1];
        const selectedItem = (_a = this.navigationItems) === null || _a === void 0 ? void 0 : _a.filter(i => currentPath === i.path)[0];
        if (selectedItem) {
            this.onItemSelect(selectedItem);
        }
    }
    ngOnDestroy() {
        this._scrollSubscription.unsubscribe();
    }
    setVisibility() {
        const element = this.element.nativeElement;
        const layer = this.layer.nativeElement;
        const parentEl = element.parentElement;
        const { bottom: parentBottom, height: parentHeight } = parentEl.getBoundingClientRect();
        const { height: elementHeight } = layer.getBoundingClientRect();
        const parentElPadTop = +this.getElementsComputedStyles(parentEl, 'padding-top').split('px')[0];
        const parentElPadBottom = +this.getElementsComputedStyles(parentEl, 'padding-bottom').split('px')[0];
        // No need to fix the Side navigation component if its height is equal to parent container without padding
        if (parentHeight - (parentElPadTop + parentElPadBottom) === elementHeight) {
            return;
        }
        layer.style.marginTop = '0px';
        if (element.getBoundingClientRect().top <= this.scrollOffset) {
            element.style.height = `${element.offsetHeight}px`;
            layer.classList.add('active');
            layer.style.top = `${this.offsetPositionY}px`;
        }
        else {
            element.style.height = 'auto';
            layer.classList.remove('active');
        }
        if (parentBottom <= (elementHeight + this.offsetPositionY + parentElPadBottom)) {
            layer.classList.remove('active');
            // Calculating inner height of parent element without top & bottom padding
            layer.style.marginTop = `${(parentHeight - elementHeight) - (parentElPadTop + parentElPadBottom)}px`;
        }
    }
    getElementsComputedStyles(elt, property) {
        return window.getComputedStyle(elt, null).getPropertyValue(property);
    }
    onItemSelect(navigationItem) {
        if (navigationItem === null || navigationItem === void 0 ? void 0 : navigationItem.offsetY) {
            this.offsetPositionY = navigationItem.offsetY + this.positionY;
        }
        else {
            this.offsetPositionY = this.positionY;
        }
    }
}
SideNavigationComponent.ɵfac = function SideNavigationComponent_Factory(t) { return new (t || SideNavigationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SideNavigationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideNavigationComponent, selectors: [["pmcc-side-navigation"]], viewQuery: function SideNavigationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layer = _t.first);
    } }, inputs: { scrollOffset: "scrollOffset", positionY: "positionY", navigationItems: "navigationItems" }, decls: 4, vars: 1, consts: [[1, "pmcc-fixed"], ["layer", ""], [1, "pmcc-side-nav"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["class", "pmcc-nav-item heading", 4, "ngSwitchCase"], ["class", "pmcc-nav-item divider", 4, "ngSwitchCase"], ["class", "pmcc-nav-item", 3, "routerLink", "routerLinkActive", "click", 4, "ngSwitchDefault"], [1, "pmcc-nav-item", "heading"], [1, "pmcc-nav-item", "divider"], [1, "pmcc-nav-item", 3, "routerLink", "routerLinkActive", "click"]], template: function SideNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, SideNavigationComponent_ng_container_3_Template, 5, 3, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.navigationItems);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc6.RouterLinkWithHref, ɵngcc6.RouterLinkActive], styles: [".pmcc-fixed.active[_ngcontent-%COMP%]{position:fixed;z-index:1000}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]{width:180px;background-color:#fff;overflow-x:hidden;padding:16px 0;max-height:800px}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]   .pmcc-nav-item[_ngcontent-%COMP%]{display:block;text-align:left;color:#000;padding:6px 16px;text-decoration:none;cursor:pointer}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]   .pmcc-nav-item.highlight[_ngcontent-%COMP%]{background-color:#e8f7ff}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]   .pmcc-nav-item.heading[_ngcontent-%COMP%]{cursor:default;font-weight:600;padding:10px 0;margin:8px 8px 0}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]   .pmcc-nav-item.heading[_ngcontent-%COMP%]:first-child{padding:0 0 10px}.pmcc-fixed[_ngcontent-%COMP%]   .pmcc-side-nav[_ngcontent-%COMP%]   .pmcc-nav-item.divider[_ngcontent-%COMP%]{cursor:default;height:1px;background:#eaeaea;padding:0!important;margin:8px}"] });
SideNavigationComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Router },
    { type: NgZone }
];
SideNavigationComponent.propDecorators = {
    layer: [{ type: ViewChild, args: ['layer', { static: true },] }],
    navigationItems: [{ type: Input }],
    scrollOffset: [{ type: Input }],
    positionY: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideNavigationComponent, [{
        type: Component,
        args: [{
                selector: 'pmcc-side-navigation',
                template: "<div #layer class=\"pmcc-fixed\">\n  <div class=\"pmcc-side-nav\">\n    <ng-container *ngFor=\"let item of navigationItems\">\n      <ng-container [ngSwitch]=\"item.type\">\n        <span\n          *ngSwitchCase=\"'heading'\"\n          class=\"pmcc-nav-item heading\">\n        {{ item.label }}\n        </span>\n        <div *ngSwitchCase=\"'divider'\" class=\"pmcc-nav-item divider\"></div>\n        <a\n          *ngSwitchDefault\n          class=\"pmcc-nav-item\"\n          [routerLink]=\"item.path\"\n          (click)=\"onItemSelect(item)\"\n          [routerLinkActive]=\"'highlight'\">\n        {{ item.label }}\n        </a>\n      </ng-container>\n    </ng-container>\n  </div>\n</div>\n",
                styles: [".pmcc-fixed.active{position:fixed;z-index:1000}.pmcc-fixed .pmcc-side-nav{width:180px;background-color:#fff;overflow-x:hidden;padding:16px 0;max-height:800px}.pmcc-fixed .pmcc-side-nav .pmcc-nav-item{display:block;text-align:left;color:#000;padding:6px 16px;text-decoration:none;cursor:pointer}.pmcc-fixed .pmcc-side-nav .pmcc-nav-item.highlight{background-color:#e8f7ff}.pmcc-fixed .pmcc-side-nav .pmcc-nav-item.heading{cursor:default;font-weight:600;padding:10px 0;margin:8px 8px 0}.pmcc-fixed .pmcc-side-nav .pmcc-nav-item.heading:first-child{padding:0 0 10px}.pmcc-fixed .pmcc-side-nav .pmcc-nav-item.divider{cursor:default;height:1px;background:#eaeaea;padding:0!important;margin:8px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc6.Router }, { type: ɵngcc0.NgZone }]; }, { scrollOffset: [{
            type: Input
        }], positionY: [{
            type: Input
        }], layer: [{
            type: ViewChild,
            args: ['layer', { static: true }]
        }], navigationItems: [{
            type: Input
        }] }); })();

class SideNavigationModule {
}
SideNavigationModule.ɵfac = function SideNavigationModule_Factory(t) { return new (t || SideNavigationModule)(); };
SideNavigationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SideNavigationModule });
SideNavigationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            AnchorLinksModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideNavigationModule, [{
        type: NgModule,
        args: [{
                declarations: [SideNavigationComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                    AnchorLinksModule,
                ],
                exports: [SideNavigationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SideNavigationModule, { declarations: function () { return [SideNavigationComponent]; }, imports: function () { return [CommonModule,
        RouterModule, AnchorLinksModule]; }, exports: function () { return [SideNavigationComponent]; } }); })();

/* Required for deleting component ref*/
class PmccModule {
}
PmccModule.ɵfac = function PmccModule_Factory(t) { return new (t || PmccModule)(); };
PmccModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PmccModule });
PmccModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [localeProvider], imports: [[
            AnchorLinksModule,
            BtnGroupModule,
            BtnMenuModule,
            BtnSplitModule,
            ButtonModule,
            CalendarModule,
            CharacterCounterModule,
            CheckboxModule,
            DataTableModule,
            DatePickerModule,
            DayofweekModule,
            DayparterModule,
            DialogModule,
            DropdownModule,
            EventModule,
            FileModule,
            FormControlModule,
            GaugeModule,
            GlobalHeaderModule,
            HierarchicalSelectorModule,
            IconModule,
            InfiniteScrollModule,
            InputModule,
            LayoutModule,
            MarkdownModule,
            MultiselectHierarchicalModule,
            MultiselectInlineModule,
            MultiselectModule,
            MultistepModule,
            NotifiersModule,
            PageNotFoundModule,
            PageTitleModule,
            PaginationModule,
            PanelModule,
            PopoverModule,
            ScrollableTableModule,
            ServicesMenuModule,
            SingleselectModule,
            SpinnerModule,
            SwitchModule,
            TableActionsModule,
            TableTreeModule,
            TableTreeMultiselectModule,
            TabsModule,
            TooltipModule,
            UtilsModule,
            MonthPickerModule,
            SelectModule,
            IntegerModule,
            AccessDeniedModule,
            AdblockerNotificationModule,
            CheckboxGroupModule,
            SelectBoxGroupModule,
            StickyFooterModule,
            TableBulkActionModule,
            TableRowActionModule,
            DrawerModule,
            SideNavigationModule,
            /* Required for adding module ref*/
        ], ButtonModule, CalendarModule, CollapsiblePanelModule, ColumnSelectorModule, CurrencyPickerModule, DataTableModule, DatePickerModule, DateRangePickerModule, FileModule, FormControlModule, IconModule, InputModule, MultiselectInlineModule, PopoverModule, ProgressBarModule, RadioButtonModule, RangeSelectorModule, ScrollableTableModule, SortableListModule, TableActionsModule, TableTreeModule, TableRichrowModule, TimePickerModule, TooltipModule, UtilsModule, MonthPickerModule, SelectModule, IntegerModule, CheckboxGroupModule, SelectBoxGroupModule, StickyFooterModule, TableBulkActionModule, TableRowActionModule, DrawerModule, SideNavigationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PmccModule, [{
        type: NgModule,
        args: [{
                declarations: [
                /* Required for deleting component ref*/
                ],
                imports: [
                    AnchorLinksModule,
                    BtnGroupModule,
                    BtnMenuModule,
                    BtnSplitModule,
                    ButtonModule,
                    CalendarModule,
                    CharacterCounterModule,
                    CheckboxModule,
                    DataTableModule,
                    DatePickerModule,
                    DayofweekModule,
                    DayparterModule,
                    DialogModule,
                    DropdownModule,
                    EventModule,
                    FileModule,
                    FormControlModule,
                    GaugeModule,
                    GlobalHeaderModule,
                    HierarchicalSelectorModule,
                    IconModule,
                    InfiniteScrollModule,
                    InputModule,
                    LayoutModule,
                    MarkdownModule,
                    MultiselectHierarchicalModule,
                    MultiselectInlineModule,
                    MultiselectModule,
                    MultistepModule,
                    NotifiersModule,
                    PageNotFoundModule,
                    PageTitleModule,
                    PaginationModule,
                    PanelModule,
                    PopoverModule,
                    ScrollableTableModule,
                    ServicesMenuModule,
                    SingleselectModule,
                    SpinnerModule,
                    SwitchModule,
                    TableActionsModule,
                    TableTreeModule,
                    TableTreeMultiselectModule,
                    TabsModule,
                    TooltipModule,
                    UtilsModule,
                    MonthPickerModule,
                    SelectModule,
                    IntegerModule,
                    AccessDeniedModule,
                    AdblockerNotificationModule,
                    CheckboxGroupModule,
                    SelectBoxGroupModule,
                    StickyFooterModule,
                    TableBulkActionModule,
                    TableRowActionModule,
                    DrawerModule,
                    SideNavigationModule,
                    /* Required for adding module ref*/
                ],
                providers: [localeProvider],
                exports: [
                    AnchorLinksComponent,
                    ApplyPipe,
                    BtnGroupComponent,
                    BtnGroupItemComponent,
                    BtnMenuComponent,
                    BtnSplitComponent,
                    ButtonModule,
                    CalendarModule,
                    CharacterCounterComponent,
                    CheckboxComponent,
                    CollapsiblePanelModule,
                    ColumnSelectorModule,
                    CurrencyPickerModule,
                    DataTableModule,
                    DatePickerModule,
                    DateRangePickerModule,
                    DayofweekComponent,
                    DayparterComponent,
                    DialogComponent,
                    DropdownComponent,
                    FileModule,
                    FormControlModule,
                    GaugeComponent,
                    GaugeHealthComponent,
                    GlobalHeaderComponent,
                    HierarchicalSelectorComponent,
                    IconModule,
                    InfiniteScrollDirective,
                    InputModule,
                    MessageBoxComponent,
                    MessageBoxTogglerComponent,
                    MiniReportGaugeComponent,
                    MultiselectComponent,
                    MultiselectHierarchicalComponent,
                    MultiselectInlineModule,
                    MultistepComponent,
                    NotificationComponent,
                    NotificationListComponent,
                    PageNotFoundComponent,
                    PageTitleComponent,
                    PaginationComponent,
                    PanelComponent,
                    PopoverModule,
                    ProgressBarModule,
                    RadioButtonModule,
                    RangeSelectorModule,
                    ScrollableTableComponent,
                    ScrollableTableModule,
                    ScrollToErrorDirective,
                    ServicesMenuInlineComponent,
                    SingleselectComponent,
                    SortableListModule,
                    SpinnerComponent,
                    SwitchComponent,
                    TabComponent,
                    TableActionsModule,
                    TableTreeModule,
                    TableTreeMultiselectComponent,
                    TableRichrowModule,
                    TabsetComponent,
                    TabsVerticalComponent,
                    TimePickerModule,
                    TooltipModule,
                    UtilsModule,
                    MonthPickerModule,
                    SelectModule,
                    IntegerModule,
                    AccessDeniedComponent,
                    AdblockerNotificationComponent,
                    CheckboxGroupComponent,
                    CheckboxGroupModule,
                    SelectBoxGroupComponent,
                    SelectBoxGroupModule,
                    StickyFooterModule,
                    TableBulkActionModule,
                    TableRowActionModule,
                    DrawerModule,
                    DrawerComponent,
                    SideNavigationComponent,
                    SideNavigationModule,
                    TableStickyColumnsDirective
                    /* Required for adding component ref*/
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PmccModule, { imports: [AnchorLinksModule, BtnGroupModule, BtnMenuModule, BtnSplitModule, ButtonModule, CalendarModule, CharacterCounterModule, CheckboxModule, DataTableModule, DatePickerModule, DayofweekModule, DayparterModule, DialogModule, DropdownModule, EventModule, FileModule, FormControlModule, GaugeModule, GlobalHeaderModule, HierarchicalSelectorModule, IconModule, InfiniteScrollModule, InputModule, LayoutModule, MarkdownModule, MultiselectHierarchicalModule, MultiselectInlineModule, MultiselectModule, MultistepModule, NotifiersModule, PageNotFoundModule, PageTitleModule, PaginationModule, PanelModule, PopoverModule, ScrollableTableModule, ServicesMenuModule, SingleselectModule, SpinnerModule, SwitchModule, TableActionsModule, TableTreeModule, TableTreeMultiselectModule, TabsModule, TooltipModule, UtilsModule, MonthPickerModule, SelectModule, IntegerModule, AccessDeniedModule, AdblockerNotificationModule, CheckboxGroupModule, SelectBoxGroupModule, StickyFooterModule, TableBulkActionModule, TableRowActionModule, DrawerModule, SideNavigationModule], exports: [AnchorLinksComponent, ApplyPipe, BtnGroupComponent, BtnGroupItemComponent, BtnMenuComponent, BtnSplitComponent, ButtonModule, CalendarModule, CharacterCounterComponent, CheckboxComponent, CollapsiblePanelModule, ColumnSelectorModule, CurrencyPickerModule, DataTableModule, DatePickerModule, DateRangePickerModule, DayofweekComponent, DayparterComponent, DialogComponent, DropdownComponent, FileModule, FormControlModule, GaugeComponent, GaugeHealthComponent, GlobalHeaderComponent, HierarchicalSelectorComponent, IconModule, InfiniteScrollDirective, InputModule, MessageBoxComponent, MessageBoxTogglerComponent, MiniReportGaugeComponent, MultiselectComponent, MultiselectHierarchicalComponent, MultiselectInlineModule, MultistepComponent, NotificationComponent, NotificationListComponent, PageNotFoundComponent, PageTitleComponent, PaginationComponent, PanelComponent, PopoverModule, ProgressBarModule, RadioButtonModule, RangeSelectorModule, ScrollableTableComponent, ScrollableTableModule, ScrollToErrorDirective, ServicesMenuInlineComponent, SingleselectComponent, SortableListModule, SpinnerComponent, SwitchComponent, TabComponent, TableActionsModule, TableTreeModule, TableTreeMultiselectComponent, TableRichrowModule, TabsetComponent, TabsVerticalComponent, TimePickerModule, TooltipModule, UtilsModule, MonthPickerModule, SelectModule, IntegerModule, AccessDeniedComponent, AdblockerNotificationComponent, CheckboxGroupComponent, CheckboxGroupModule, SelectBoxGroupComponent, SelectBoxGroupModule, StickyFooterModule, TableBulkActionModule, TableRowActionModule, DrawerModule, DrawerComponent, SideNavigationComponent, SideNavigationModule, TableStickyColumnsDirective] }); })();

/*
 * Public API Surface of pmcc
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessDeniedComponent, AccessDeniedModule, AdblockerNotificationComponent, AdblockerNotificationModule, AddonDirective, AdjacentPositionDirective, AnchorLinksComponent, AnchorLinksModule, ApplyPipe, ApprovedTimeString, BackDrop, BaseRowDefDirective, BtnGroupComponent, BtnGroupItemComponent, BtnGroupModule, BtnMenuComponent, BtnMenuModule, BtnSplitComponent, BtnSplitModule, ButtonDirective, ButtonModule, ButtonState, CalendarComponent, CalendarModule, CellDefDirective, CellOutletDirective, CharacterCounterComponent, CharacterCounterModule, CheckboxComponent, CheckboxGroupComponent, CheckboxGroupModule, CheckboxModule, CheckboxState, CloseScrollStrategy, CollapsiblePanelComponent, CollapsiblePanelContentComponent, CollapsiblePanelHeaderComponent, CollapsiblePanelModule, CollapsiblePanelTitleComponent, ColumnDefDirective, ColumnSelectorComponent, ColumnSelectorModule, CommonValidators, CurrencyPickerComponent, CurrencyPickerModule, DIALOG_DATA, DataRowOutletDirective, DataSource, DataTableComponent, DataTableModule, DatePickerComponent, DatePickerFieldComponent, DatePickerModule, DateRangePickerComponent, DateRangePickerModule, DayofweekComponent, DayofweekModule, DayparterComponent, DayparterModule, DialogCloseDirective, DialogComponent, DialogInlineComponent, DialogModule, DialogRef, DialogService, DirtyErrorStateMatcher, DomPortalOutlet, DrawerComponent, DrawerModule, DropdownComponent, DropdownModule, ErrorStateMatcher, EventModule, EventService, FileComponent, FileModule, FixedLayerComponent, FooterRowOutletDirective, FormControlComponent, FormControlModule, FormControlNativeElementDirective, GaugeComponent, GaugeHealthComponent, GaugeModule, GlobalHeaderComponent, GlobalHeaderModule, HeaderCellDefDirective, HeaderRowComponent, HeaderRowDefDirective, HeaderRowOutletDirective, HierarchicalSelectorComponent, HierarchicalSelectorModule, IconComponent, IconEffectDirective, IconModule, InfiniteScrollDirective, InfiniteScrollModule, InlineHelpDirective, InputComponent, InputDirective, InputModule, IntegerDirective, IntegerModule, LOCALE, LayoutModule, LayoutService, MarkdownModule, MarkdownService, MessageBoxComponent, MessageBoxTogglerComponent, MessageBoxTogglerState, MiniReportGaugeComponent, MonthPickerComponent, MonthPickerModule, MshDataSource, MultiselectComponent, MultiselectHierarchicalComponent, MultiselectHierarchicalItemComponent, MultiselectHierarchicalListComponent, MultiselectHierarchicalModule, MultiselectInlineComponent, MultiselectInlineModule, MultiselectModule, MultistepComponent, MultistepModule, NearPositionDirective, NotificationComponent, NotificationListComponent, NotificationService, NotifiersModule, OverlayContainer, OverlayDirective, OverlayRef, OverlayService, POSITION, PageNotFoundComponent, PageNotFoundModule, PageTitleComponent, PageTitleModule, PaginationComponent, PaginationModule, PaginationOption, PanelComponent, PanelModule, PmccModule, PmccNotification, PmccService, PopoverComponent, PopoverDismissDirective, PopoverModule, PopoverTriggerDirective, ProgressBarComponent, ProgressBarModule, RESET_ON_NAVIGATION, RadioButtonComponent, RadioButtonModule, RadioGroupComponent, RangeSelectorComponent, RangeSelectorModule, RepositionScrollStrategy, ResetOnNavigationProvider, RichrowDetailComponent, RichrowDirective, RichrowToggleDirective, RowComponent, RowDefDirective, RowToggleDirective, ScreenCenterPositionDirective, ScreenLeftPositionDirective, ScreenRightPositionDirective, ScrollStrategy, ScrollToErrorDirective, ScrollableTableComponent, ScrollableTableModule, SelectBoxComponent, SelectBoxGroupComponent, SelectBoxGroupModule, SelectComponent, SelectModule, SelectOptionComponent, ServicesMenuInlineComponent, ServicesMenuModule, SideNavigationComponent, SideNavigationModule, SingleselectComponent, SingleselectListComponent, SingleselectModule, SortDirective, SortHeaderComponent, SortableItemComponent, SortableListComponent, SortableListModule, SpinnerComponent, SpinnerModule, State, StickyFooterComponent, StickyFooterModule, SubmitErrorStateMatcher, SwitchComponent, SwitchModule, TabComponent, TableActionsComponent, TableActionsModule, TableBulkActionComponent, TableBulkActionModule, TableRichrowDirective, TableRichrowModule, TableRowActionComponent, TableRowActionModule, TableStickyColumnsDirective, TableTreeComponent, TableTreeModule, TableTreeMultiselectComponent, TableTreeMultiselectModule, TableTreeNesterComponent, TableTreeTogglerComponent, TabsModule, TabsVerticalComponent, TabsetComponent, TimePickerComponent, TimePickerModule, TooltipComponent, TooltipDirective, TooltipModule, UtilsModule, WINDOW, clamp, currencies, defaultPageSizeOptions, defaultTriggerEvent, localeFactory, localeProvider, maxShownFiles, months, rotate, skipResetOnNavigationProvider, tooltipRevealDelay, validationMessages, BTN_GROUP as ɵb, SelectedSectionHeaderComponent as ɵba, SearchComponent as ɵbb, AvailableSectionHeaderComponent as ɵbc, ButtonBarComponent as ɵbd, SelectMsTriggerModule as ɵbe, TableTreeMultiselectRowComponent as ɵbf, SELECT as ɵbh, SELECT_BOX_GROUP as ɵbj, RADIO_GROUP as ɵbl, ButtonActionsComponent as ɵbm, CurrencyPickerDropdownComponent as ɵbn, CurrencyDropdownOptionDirective as ɵbo, RangeTicksComponent as ɵbp, RangeHandleDirective as ɵbq, RichrowDetailHeightAnimatorDirective as ɵbr, TimeOptionsComponent as ɵbs, TimeOptionDirective as ɵbt, TimePipe as ɵbu, ScrollStrategies as ɵc, ScrollDispatcher as ɵd, PositionStrategyBuilderService as ɵe, PopupDirective as ɵf, SelectTriggerModule as ɵg, SelectTriggerComponent as ɵh, PARENT_DATE_PICKER as ɵj, PopoverRegistry as ɵk, DATE_RANGE_PICKER as ɵm, DialogBodyStyleService as ɵn, EscapableDirective as ɵo, PositionStrategy as ɵp, AdTagComponent as ɵq, MultiselectToolbarComponent as ɵr, SelectMsControllerDirective as ɵs, SelectMsTriggerComponent as ɵt, VIEWPORT_MARGIN as ɵu, AvailableSectionListComponent as ɵw, AvailableSectionTemplateComponent as ɵx, SelectedSectionListComponent as ɵy, SelectedSectionTemplateComponent as ɵz };

